/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(5);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__output_json__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__output_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__output_json__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var fuzzysort = __webpack_require__(10);
var lunr = __webpack_require__(11);
__webpack_require__(12)(lunr);
__webpack_require__(13)(lunr);
__webpack_require__(14)(lunr);
__webpack_require__(15)(lunr);
__webpack_require__(16)(lunr);
__webpack_require__(17)(lunr);
__webpack_require__(18)(lunr);
__webpack_require__(19)(lunr);
__webpack_require__(20)(lunr);

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',
    data: function data() {
        return {
            search: '',
            resultsActual: '',
            list: __WEBPACK_IMPORTED_MODULE_0__output_json___default.a,
            resultsCount: 0
        };
    },


    methods: {
        queryResults: function queryResults() {

            if (this.search.trim() === '') {
                return '';
            }
            //   else if(this.search.trim().length < 3){
            //     this.resultsActual = new Array();
            //     this.resultsCount = 0;
            //   }
            else {
                    var documents = this.list;

                    var idx = lunr(function () {
                        this.use(lunr.ja);
                        this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'));
                        this.ref('UUID');
                        this.field('title');
                        this.field('descFull');
                        this.metadataWhitelist = ['position'];

                        documents.forEach(function (doc) {
                            this.add(doc);
                        }, this);
                    });

                    var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
                    // var searchTerms = this.search;
                    searchTerms = this.removeStopWords(searchTerms);
                    var searchRawTerms = searchTerms;
                    // searchTerms  =  searchTerms.split(" ").join(" +");
                    // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

                    console.log(searchTerms);
                    var results = idx.search(searchTerms);

                    console.log(results);

                    results = results.map(function (res) {
                        var linkRes = documents.find(function (elem) {
                            return elem.UUID == res.ref;
                        });
                        var keywords_array = new Array();
                        var keywords_arrays = new Array();
                        var keywords_arrays_title = new Array();

                        Object.keys(res.matchData.metadata).map(function (kys) {
                            var positions_title = res.matchData.metadata[kys].title;
                            var positions_desc = res.matchData.metadata[kys].descFull;

                            if (typeof positions_title !== 'undefined') {
                                positions_title.position.forEach(function (val, i, arr) {
                                    keywords_array.push(linkRes.descFull.substring(val[0], val[0] + val[1]));
                                    keywords_arrays_title.push(val[0], val[1]);
                                });
                            }

                            if (typeof positions_desc !== 'undefined') {
                                positions_desc.position.forEach(function (val, i, arr) {
                                    keywords_array.push(linkRes.descFull.substring(val[0], val[0] + val[1]));
                                    keywords_arrays.push(val[0], val[1]);
                                });
                            }
                        });

                        res.link = linkRes.link;
                        res.desc = linkRes.desc;
                        res.title = linkRes.title;
                        res.full = linkRes.descFull;
                        res.titleArray = keywords_arrays_title;
                        res.descArray = keywords_arrays;
                        keywords_array = keywords_array.filter(function (item, index) {
                            return searchRawTerms.indexOf(item) >= 0;
                        });
                        var keywords_set = new Set(keywords_array);
                        res.keywords = [].concat(_toConsumableArray(keywords_set)).toString();
                        // res.keywords = ["ramon","joe","gudz"]
                        return res;
                    });

                    var existingPagesInResult = new Array();

                    results = results.filter(function (item, index) {

                        if (existingPagesInResult.includes(item.link)) {

                            return false;
                        } else {
                            existingPagesInResult.push(item.link);
                            return true;
                        }

                        if (res.keywords == "") {
                            return false;
                        }
                    });

                    console.log(results);
                    this.resultsActual = results;
                    this.resultsCount = results.length;
                }
        },


        clearResult: function clearResult() {
            this.search = "";
            this.resultsActual = undefined;
            this.resultsCount = 0;
            reload("cover.html", "");
        },

        removeStopWords: function removeStopWords(queryString) {
            var stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"];

            var cleanQueryString = new Array();
            queryString.split(" ").forEach(function (word) {
                if (!stopWords.includes(word)) {
                    cleanQueryString.push(word);
                }
            });

            return cleanQueryString.join(" ");
        }

    }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(7);



new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.10
 * (c) 2014-2019 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Techinically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a speical value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack becaues all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.10';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes(parentElm, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecesarry `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being pased as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anyting as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving the component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function\s*(?:[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0), __webpack_require__(1).setImmediate))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(6)))

/***/ }),
/* 6 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(2);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_870701b2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(21);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_870701b2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 8 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = [{"UUID":"8d6ea652-772c-4d93-8993-94d46d632aa8","title":"Pelajari tentang printer","link":"finding-information-about-printer-topic.html","desc":"Mencari informasi tentang printer Informasi","descFull":"Mencari informasi tentang printer Informasi dan di mana menemukannya Apa yang sedang Anda cari? Temukan di sini Instruksi penyiapan awal Lihat dokumen penyiapan yang menyertai printer. Perangkat lunak printer Driver faks atau printer Firmware printer Utilitas Kunjungi  www.lexmark.com/downloads . Panduan Pengguna  Interaktif Kunjungi  https://support.lexmark.com . Video Tutorial Buka  https://infoserve.lexmark.com/idv/ . Informasi bantuan dalam menggunakan perangkat lunak printer. Bantuan untuk sistem operasi Macintosh atau Microsoft Windows—Buka aplikasi atau program perangkat lunak printer, lalu klik  Help (Bantuan) . Klik   untuk melihat informasi berdasarkan konteks. Help (Bantuan) telah secara otomatis diinstal dengan perangkat lunak printer. Tergantung sistem operasi, perangkat lunak printer bisa berada di desktop atau folder program printer. Dokumen Dukungan obrolan langsung Dukungan Email Dukungan suara Kunjungi  https://support.lexmark.com . Pilih negara atau kawasan Anda, lalu pilih produk Anda untuk melihat tempat dukungan yang semestinya. Informasi kontak dukungan untuk negara atau kawasan Anda bisa ditemukan di situs web atau di kartu garansi cetak yang menyertai kemasan produk printer. Siapkan informasi berikut ketika Anda menghubungi dukungan pelanggan: Tempat dan tanggal pembelian Nomer seri dan jenis mesin Untuk informasi lebih lanjut, lihat  . Informasi keselamatan Informasi regulasi Informasi garansi Informasi lingkungan Informasi garansi bisa berbeda-beda menurut negara atau kawasan: Di AS —Lihat Pernyataan Garansi Terbatas termasuk dengan printer, atau kunjungi  https://support.lexmark.com . Di negara dan kawasan lain —Lihat kartu garansi cetak yang menyertai kemasan produk printer. Panduak Informasi Produk —Lihat dokumen yang menyertai kemasan produk printer atau kunjungi  https://support.lexmark.com . Informasi tentang paspor digital Lexmark. Kunjungi  https://csr.lexmark.com/digital-passport.php . mencari informasi printer"},{"UUID":"d389e484-943a-490e-9f87-a354b546324a","title":"Pelajari tentang printer","link":"finding-printer-serial-number-topic.html","desc":"Mencari nomor seri printer Buka","descFull":"Mencari nomor seri printer Buka baki. Cari nomor seri di sisi kanan printer. nomor seri printer nomor seri"},{"UUID":"493ba290-83fe-4a80-b7ef-a97a96a1b4d1","title":"Pelajari tentang printer","link":"printer-configurations-topic.html","desc":"Konfigurasi printer Pastikan Anda menempatkan","descFull":"Konfigurasi printer Pastikan Anda menempatkan printer di permukaan yang rata, kokoh, dan stabil. Model dasar Bagian-bagian model printer dasar 1 Pengumpan Dokumen Otomatis (ADF) 2 Panel kontrol 3 Port USB 4 Feeder multiguna 5 Baki 550 lembar (Standar) 6 Keranjang standar Model konfigurasi Memasang satu atau beberapa opsi di printer atau MFP Anda mungkin memerlukan basis kaster, furnitur, atau fitur lain untuk mencegah ketidakstabilan yang menyebabkan cedera. Untuk informasi lebih lanjut tentang konfigurasi yang didukung, lihat  www.lexmark.com/multifunctionprinters . Memasang satu atau beberapa opsi di printer atau MFP Anda mungkin memerlukan basis kaster, furnitur, atau fitur lain untuk mencegah ketidakstabilan yang menyebabkan cedera. Untuk informasi lebih lanjut tentang konfigurasi yang didukung, hubungi tempat di mana Anda membeli printer. Guna mengurangi risiko ketidakstabilan alat, masukkan baki secara terpisah. Biarkan baki lain tetap tertutup hingga diperlukan. Bagian-bagian model printer konfigurasi # Opsi perangkat keras Opsi perangkat keras alternatif 1  Tidak dapat dipasang dengan lis lubang stapler atau lis buklet. 2  Harus selalu dipasang dengan baki 550 lembar (opsional) dan salah satu dari 2 baki 550 lembar atau baki tandem 2000 lembar. 3  Harus selalu dipasang dengan baki 550 lembar (opsional). 4  Harus dipasang dengan baki 550 lembar (opsional) plus salah satu di bawah ini: 2 baki 550 lembar, baki tandem 2000 lembar, atau kabinet 1 Lis kawat jepret 1 Penumpuk ofset 1 Penyalur kertas Penyalur kertas dengan opsi lipatan 2 Baki 1500 lembar 2 Tidak ada 3 Baki tandem 2000 lembar 3 2 baki 550 lembar 3 Kabinet 3 4 Baki 550 lembar (opsional) Tidak ada 5 Lis buklet 4 Lis lubang dan kawat jepret 4 Beberapa opsi mungkin tidak tersedia. Untuk informasi lebih lanjut, hubungi tempat di mana Anda membeli printer tersebut. konfigurasi printer"},{"UUID":"d57b0e7e-15e3-4ce5-98c0-8c8076347406","title":"Pelajari tentang printer","link":"using-control-panel-topic.html","desc":"Menggunakan panel kontrol Bagian panel","descFull":"Menggunakan panel kontrol Bagian panel kontrol dan fungsinya Bagian panel kontrol Fungsi 1 Tombol daya Mengaktifkan atau menonaktifkan printer. Untuk menonaktifkan printer, tekan dan tahan tombol daya selama lima detik. Menyetel printer ke mode Tidur. Membangunkan printer dari mode Tidur atau Hibernasi. 2 Tampilan Melihat status bahan pakai dan pesan printer. Menyiapkan dan mengoperasikan printer. 3 Lampu indikator Memeriksa status printer. panel kontrol menggunakan menggunakan panel kontrol"},{"UUID":"2c6972df-7ca6-479f-91f3-9a639d5c9c07","title":"Pelajari tentang printer","link":"using-home-screen-topic.html","desc":"Ikon layar awal Layar awal","descFull":"Ikon layar awal Layar awal Anda bisa berbeda-beda, tergantung ada tidaknya Embedded Solutions aktif, penyiapan administratif, serta setelan kustomisasi layar awal. Ikon layar awal dan fungsinya. # Nama ikon Fungsi 1 Pengguna Tampilkan apakah pengguna masuk ke printer. 2 Informasi yang ditampilkan Tampilkan informasi khusus tentang printer, seperti alamat IP, alamat, atau waktu dan tanggal. 3 Bahan pakai Menampilkan status bahan pakai. 4 Pemberitahuan Menampilkan pesan eror atau peringatan printer kapan saja printer memerlukan intervensi untuk melanjutkan pemrosesan. Lihat Informasi lainnya pada pesan atau peringatan printer, dan cara membersihkannya. 5 Cetak Cetak foto dan dokumen 6 Salin Salin foto dan dokumen. 7 Pindai Pindai dokumen. 8 Faks Kirim pesan faks. menggunakan layar awal ikon layar awal"},{"UUID":"4ff70ee9-412b-4786-8593-af119c1c536c","title":"Pelajari tentang printer","link":"colors-of-indicator-light-topic.html","desc":"Warna lampu indikator Warna lampu","descFull":"Warna lampu indikator Warna lampu indikator dan status printer Warna lampu indikator Status printer Off (Nonaktif) Printer dalam kondisi nonaktif. Biru solid Printer dalam kondisi siap. Biru berkedip Printer sedang mencetak atau memproses data. Merah berkedip Printer memerlukan intervensi pengguna. Kuning solid Printer dalam mode Tidur. Kuning berkedip Printer dalam mode Hibernasi atau Tidur Dalam. lampu indikator status printer kondisi printer"},{"UUID":"b4748f31-9940-47ee-94be-37743b637b2e","title":"Pelajari tentang printer","link":"using-ADF-and-scanner-glass-copy-topic.html","desc":"Menggunakan pengumpan dokumen otomatis dan","descFull":"Menggunakan pengumpan dokumen otomatis dan kaca pemindai Memasukkan kertas ke baki ADF dan pada kaca pemindai Pengumpan Dokumen Otomatis (ADF) Kaca pemindai Gunakan ADF multi halaman atau dokumen dua sisi. Masukkan dokumen asli menghadap ke atas. Untuk dokumen multi halaman, pastikan Anda menyejajarkan ujung depan sebelum memasukkan. Pastikan Anda menyesuaikan pembatas ADF dengan lebar kertas yang Anda masukkan. Gunakan kaca pemindai untuk dokumen satu halaman, halaman buku, atau item-item kecil (seperti kartu pos atau foto), transparansi, kertas foto, atau media tipis (seperti kliping majalah). Taruh dokumen menghadap ke bawah di sudut dengan anak panah. menyalin menggunakan pengumpan dokumen otomatis (ADF) menyalin menggunakan kaca pemindai"},{"UUID":"0bd61baf-11eb-40e5-9259-0ef31cdb8284","title":"Pelajari tentang printer","link":"locating-security-slot-topic.html","desc":"Mencari slot keamanan Printer telah","descFull":"Mencari slot keamanan Printer telah dilengkapi dengan fitur kunci keamanan. Pasang kunci keamanan yang kompatibel dengan sebagian besar komputer laptop di lokasi yang ditunjukkan untuk mengamankan printer. slot keamanan mencari mencari slot keamanan"},{"UUID":"c5ee8b44-b0dc-47c3-8299-953ebae49c97","title":"Memilih kertas","link":"paper-guidelines-topic.html","desc":"Panduan kertas Gunakan kertas yang","descFull":"Panduan kertas Gunakan kertas yang tepat untuk mencegah kemacetan dan membantu memastikan pencetakan yang bebas gangguan. Selalu gunakan kertas baru yang tidak dalam kondisi rusak. Sebelum memasukkan kertas, cari tahu manakah sisi kertas yang akan dicetak. Informasi ini biasanya terdapat pada kemasan kertas. Jangan gunakan kertas yang telah dipotong atau digunting dengan tangan. Jangan mencampur ukuran, berat, atau jenis kertas di baki yang sama karena hal itu bisa menyebabkan kemacetan. Jangan memakai kertas berpelapis, kecuali jika kertas seperti itu memang dirancang khusus untuk pencetakan elektrofotografik. Untuk informasi lebih lanjut, lihat  Kertas dan Panduan Media Khusus . kertas memilih panduan kertas"},{"UUID":"932e34f4-c731-49bf-a319-79b93b933e5c","title":"Memilih kertas","link":"paper-guidelines-topic.html","desc":"Karakter kertas Karakter kertas di","descFull":"Karakter kertas Karakter kertas di bawah ini akan memengaruhi keandalan dan kualitas cetak. Pertimbangkan faktor-faktor berikut sebelum menggunakannya untuk pekerjaan cetak. Berat Bakin bisa mengumpan kertas dengan beragam berat. Kertas yang beratnya kurang dari 60 g/m 2  (16 lb) mungkin tidak cukup kaku untuk bisa diumpan dengan benar, sehingga bisa menyebabkan macet. Untuk informasi lebih lanjut, lihat topik “Berat kertas yang Didukung”. Keriting Keriting adalah kecenderungan kertas untuk berkerut di pinggirnya. Keriting pada kertas dalam tingkat yang parah bisa menyebabkan masalah pengumpanan kertas. Keriting ini bisa terjadi setelah kertas melewati printer, lalu terpapar dengan temperatur yang tinggi. Kertas yang tidak terbungkus dalam kondisi kering, dingin, lembap, atau panas bisa menyebabkan macet dan keriting sebelum mencetak. Kelembutan Kelembutan kertas akan secara langsung memengaruhi kualitas cetak. Jika kertas terlalu kasar, toner tidak dapat menyetu dengan baik. Jika kertas terlalu lembut, ia bisa menyebabkan masalah pada pengumpanan kertas atau kualitas cetak. Kami menyarankan Anda untuk memakai kertas 50 Sheffield point. Konten lembap Tingkat kelembapan pada kertas akan memengaruhi kualitas cetak dan kemampuan printer dalam mengumpan kertas secara benar. Simpan kertas di wadah aslinya sampai Anda akan menggunakannya. Pemaparan kertas terhadap perubahan kelembapan dapat menurunkan kinerjanya. Sebelum mencetak, simpan kertas di wadah aslinya selama 24 hingga 48 jam. Lingkungan yang di dalamnya kertas tersimpan harus sama dengan tempat menaruh printer. Biarkan kertas di wadah aslinya hingga beberapa hari jika lingkungan penyimpanan atau pengiriman berbeda dari lingkungan printer. Kertas tebal bisa memerlukan masa pengondisian yang lebih lama. Arah serat Serat adalah kesejajaran serat kertas dalam suatu lembar kertas. Serat di sini bisa berupa  serat panjang  yang membujur di sepanjang kertas, atau  grain short (serat pendek)  yang melintang selebar kertas. Untuk rekomendasi arah serat, lihat “Berat kertas yang Didukung”. Kandungan fiber Sebagian besar kertas xerografik kualitas tinggi terbuat dari 100 persen kayu pulp yang mendapat perlakuan kimiawi. Kandungan ini memberikan tingkat kestabilan yang tinggi pada kertas, sehingga masalah pengumpanan kertas bisa lebih kecil dan kualitas cetak semakin baik. Kertas yang berisi serat seperti katun akan berpengaruh negatif terhadap penanganan kertas. karakter kertas"},{"UUID":"1925af5e-2083-4f4f-8b08-a938e846de08","title":"Memilih kertas","link":"paper-guidelines-topic.html","desc":"Kertas yang tidak bisa diterima","descFull":"Kertas yang tidak bisa diterima Beberapa jenis kertas berikut tidak direkomendasikan untuk dipakai pada printer: Kertas yang mendapat perlakuan kimiawi yang digunakan untuk membuat salinan tanpa kertas karbon. Jenis ini biasa disebut dengan kertas nirkarbon, Carbonless Copy Paper (CCP/Kertas Salin Nirkarbon), atau No Carbon Required (NCR/Kertas Tanpa Karbon). Kertas pracetak kimiawi yang berpotensi mengontaminasi printer. Kertas pracetak yang dapat memengaruhi suhu fuser printer. Kertas pracetak yang memerlukan registrasi (lokasi cetak yang tepat pada halamannya), lebih dari ±2,3 mm (±0,09 inci). Misal, format Optical Character Recognition (OCR/Pengenalan Karakter Optik). Kadang kala, registrasi bisa dilakukan melalui aplikasi perangkat lunak agar sukses mencetak pada format seperti ini. Kertas berpelapis (erasable bond), kertas sintetis, kertas termal. Kertas dengan tekstur permukaan yang kasar atau berat, maupun yang tepinya kasar, atau kertas bergelombang. Kertas yang gagal memenuhi standar EN12281:2002 (Eropa). Berat kertas kurang dari 60 g/m 2  (16 lb). Dokumen atau format dengan beberapa bagian. kertas yang tidak bisa diterima"},{"UUID":"84612d20-d115-4de7-b4d8-36dfcfc6a69d","title":"Memilih kertas","link":"paper-guidelines-topic.html","desc":"Menyimpan kertas Gunakan panduan penyimpanan","descFull":"Menyimpan kertas Gunakan panduan penyimpanan kertas ini agar terhindar dari masalah kemacetan dan kualitas hasil cetak yang tidak rata: Simpan kertas di dalam kemasan aslinya di tempat yang sama dengan printer selama 24 hingga 48 jam sebelum mencetak. Tetap simpan di kemasannya jika lingkungan penyimpanan atau pengangkutan sangat berbeda dari lingkungan printer. Kertas tebal mungkin juga memerlukan waktu pengondisian yang lebih lama. Demi mendapatkan hasil terbaik, simpan kertas di tempat bersuhu 21°﻿C (70°﻿F) dan dengan kelembapan rata-rata 40%. Produsen label umumnya menyarankan agar Anda mencetak di tempat bersuhu sekitar 18–24°﻿C (65–75°﻿F) dengan kelembapan antara 40-60%. Simpan kertas di dalam karton, palet, atau laci. Bukan di lantai. Simpan setiap kemasan di tempat yang permukaannya datar. Jangan tumpuk kemasan kertas. Keluarkan kertas dari karton atau pembungkusnya hanya saat Anda akan memasukkannya ke dalam printer. Karton dan pembungkus itu membuat kertas tersebut tetap bersih, kering, dan datar. menyimpan kertas"},{"UUID":"79e366b7-1d46-49db-9ce0-62d17be1ce3c","title":"Memilih kertas","link":"paper-guidelines-topic.html","desc":"Memilih formulir preprinted dan letterhead","descFull":"Memilih formulir preprinted dan letterhead Gunakan kertas serat panjang. Hanya gunakan formulir dan letterhead yang dicetak menggunakan proses litografi offset atau cetak ukir. Jangan gunakan kertas berpermukaan kasar atau sangat bertekstur. Gunakan tinta yang tidak terpengaruh oleh resin di toner. Tinta dengan tingkat oksidasi tertentu atau berbahan dasar minyak umumnya memenuhi persyaratan ini. Namun, tidak demikian dengan tinta lateks. Cetak contoh di formulir preprinted dan letterhead yang akan digunakan sebelum membelinya dalam jumlah banyak. Tindakan ini menentukan apakah tinta di formulir preprinted atau letterhead memengaruhi kualitas cetak. Jika ragu, hubungi penyedia kertas Anda. Jika mencetak di kertas letterhead, masukkan kertas ke printer dengan orientasi yang benar. Untuk informasi lebih lanjut, baca  Panduan Kertas atau Media Khusus . Jika mencetak di kertas letterhead, masukkan kertas ke printer dengan orientasi yang benar. kertas formulir preprinted formulir preprinted memilih kertas letterhead letterhead memilih"},{"UUID":"0a2dcbd4-80be-4b58-86c2-62229d37f953","title":"Ukuran kertas yang didukung","link":"paper-guidelines-topic.html","desc":"Ukuran kertas yang didukung oleh","descFull":"Ukuran kertas yang didukung oleh konfigurasi dasar Ukuran kertas yang didukung oleh konfigurasi dasar Ukuran kertas Orientasi Baki 550 lembar (Standar) Feeder multiguna Pencetakan dua sisi* Pengumpan dokumen otomatis 1  Hanya didukung di beberapa model printer. 2  Hanya didukung jika diatur dari menu Universal Setup (Penyiapan Universal). 3  Mendukung ukuran kertas mulai dari 95 x 139,7 mm (3,74 x 5,5 inci) hingga 297 x 355,6 mm (11,69 x 14 inci). 4  Panjang maksimal dari ukuran kertas universal pada kertas banner adalah 1320.8 mm/52 inci. Masukkan hanya satu lembar kertas banner dalam satu waktu. 5  Mendukung ukuran kertas mulai dari 95 x 139,7 mm (3,74 x 5,5 inci) hingga 320 x 457,2 mm (12,6 x 18 inci). 6  Mendukung ukuran kertas mulai dari 105 x 139,7 mm (4,13 x 5,5 inci) hingga 320 x 457,2 mm (12,59 x 18 inci). 7  Mendukung ukuran kertas mulai dari 76,2 x 128 mm (3 x 5,04 inci) hingga 297 x 432 mm (11,69 x 17,01 inci). Kartu 4x6 Feed tepi pendek X ✓ X X Feed tepi panjang X X X X A6 105 x 148 mm (4,13 X 5,83 inci) Feed tepi pendek ✓ ✓ ✓ ✓ Feed tepi panjang X X X X 1/3 A4 Feed tepi pendek ✓ ✓ X ✓ Feed tepi panjang X X X X A5 148 x 210 mm (5,83 X 8,27 inci) Feed tepi pendek ✓ X ✓ ✓ Feed tepi panjang ✓ ✓ ✓ ✓ A4 210 x 297 mm (8,27 X 11,7 inci) Feed tepi pendek ✓ X ✓ ✓ Feed tepi panjang ✓ ✓ ✓ ✓ A3 297 x 420 mm (11,69 X 16,54 inci) Feed tepi pendek X ✓ ✓ 1 ✓ 1 JIS B5 182 x 257 mm (7,17 X 10,1 inci) Feed tepi pendek ✓ X ✓ ✓ Feed tepi panjang ✓ ✓ ✓ ✓ JIS B4 257 x 364 mm (10,12 X 14,33 inci) Feed tepi pendek X ✓ ✓ ✓ Statement 139,7 x 215,9 mm (5,5 X 8,5 inci) Feed tepi pendek ✓ X ✓ ✓ Feed tepi panjang ✓ ✓ ✓ ✓ Executive 184,2 x 266,7 mm (7,25 X 10,5 inci) Feed tepi pendek ✓ X ✓ ✓ Feed tepi panjang ✓ ✓ ✓ ✓ Letter 215,9 x 279,4 mm (8,5 X 11 inci) Feed tepi pendek ✓ X ✓ ✓ Feed tepi panjang ✓ ✓ ✓ ✓ Folio 215,9 x 330,2 mm (8,5 X 13 inci) Feed tepi pendek ✓ ✓ ✓ ✓ Oficio (Meksiko) 215,9 x 340,4 mm (8,5 X 13,4 inci) Feed tepi pendek ✓ ✓ ✓ ✓ Legal 215,9 x 355,6 mm (8,5 X 14 inci) Feed tepi pendek ✓ ✓ ✓ ✓ Ledger 279,4 x 431,8 mm (11 X 17 inci) Feed tepi pendek X ✓ ✓ ✓ 12x18 304,8 x 457,2 mm (12,0 X 18,0 inci) Feed tepi pendek X ✓ ✓ X SRA3 320,04 x 449,58 mm (12,6 X 17,7 inci) Feed tepi pendek X ✓ ✓ X Amplop (Choukei #3) 120 x 235 mm (4,75 X 9,25 inci) Feed tepi pendek ✓ ✓ X X Hagaki 100 x 148 mm (3,94 X 5,83 inci) Feed tepi pendek ✓ ✓ X X Amplop B5 176 x 250 mm (6,93 X 9,84 inci) Feed tepi pendek ✓ ✓ X X Amplop (Komersial #9) 98,4 x 225,4 mm (3,875 X 8,9 inci) Feed tepi pendek ✓ ✓ X X Amplop (Komersial #10) 104,8 x 241,3 mm (4,12 X 9,5 inci) Feed tepi pendek ✓ ✓ X X Amplop (Monarch 7‑3/4) 98,4 x 190,5 mm (3,875 X 7,5 inci) Feed tepi pendek ✓ ✓ X X Amplop (DL) 110 x 220 mm (4,33 X 8,66 inci) Feed tepi pendek ✓ ✓ X X Amplop (ISO C4) 229 x 324 mm (9 X 12,8 inci) Feed tepi pendek X ✓ 2 X X Amplop (ISO C5) 162 x 229 mm (6,38 X 9 inci) Feed tepi pendek ✓ ✓ X X Universal T/A ✓ 3 ✓ 4, 5 ✓ 6 ✓ 7 ukuran kertas yang didukung ukuran kertas didukung"},{"UUID":"5e27bb23-1e28-4a6f-82fc-0b0f6934ae9a","title":"Ukuran kertas yang didukung","link":"paper-guidelines-topic.html","desc":"Ukuran kertas yang didukung oleh","descFull":"Ukuran kertas yang didukung oleh baki opsional Ukuran kertas Orientasi Baki 550 lembar (opsional) 2 baki 550 lembar Baki tandem 2000 lembar Baki 1500 lembar 1  Hanya didukung jika diatur dari menu Universal Setup (Penyiapan Universal). 2  Mendukung ukuran kertas mulai dari 139,7 x 215,9 mm (5,5 x 8,5 inci) hingga 304,8 x 457,2 mm (12 x 18 inci). Kartu 4x6 Feed tepi pendek X X X X Feed tepi panjang X X X X A6 105 x 148 mm (4,13 X 5,83 inci) Feed tepi pendek ✓ ✓ X X Feed tepi panjang X X X X 1/3 A4 Feed tepi pendek X X X X Feed tepi panjang X X X X A5 148 x 210 mm (5,83 X 8,27 inci) Feed tepi pendek ✓ ✓ X X Feed tepi panjang ✓ ✓ X X A4 210 x 297 mm (8,27 X 11,7 inci) Feed tepi pendek ✓ ✓ X X Feed tepi panjang ✓ ✓ ✓ ✓ A3 297 x 420 mm (11,69 X 16,54 inci) Feed tepi pendek ✓ ✓ X X JIS B5 182 x 257 mm (7,17 X 10,1 inci) Feed tepi pendek ✓ ✓ X X Feed tepi panjang ✓ ✓ X ✓ JIS B4 257 x 364 mm (10,12 X 14,33 inci) Feed tepi pendek ✓ ✓ X X Statement 139,7 x 215,9 mm (5,5 X 8,5 inci) Feed tepi pendek ✓ ✓ X X Feed tepi panjang X X X X Executive 184,2 x 266,7 mm (7,25 X 10,5 inci) Feed tepi pendek ✓ ✓ X X Feed tepi panjang ✓ ✓ X X Letter 215,9 x 279,4 mm (8,5 X 11 inci) Feed tepi pendek ✓ ✓ X X Feed tepi panjang ✓ ✓ ✓ ✓ Folio 215,9 x 330,2 mm (8,5 X 13 inci) Feed tepi pendek ✓ ✓ X X Oficio (Meksiko) 215,9 x 340,4 mm (8,5 X 13,4 inci) Feed tepi pendek ✓ ✓ X X Legal 215,9 x 355,6 mm (8,5 X 14 inci) Feed tepi pendek ✓ ✓ X X Ledger 279,4 x 431,8 mm (11 X 17 inci) Feed tepi pendek ✓ ✓ X X 12x18 304,8 x 457,2 mm (12 X 18 inci) Feed tepi pendek ✓ ✓ X X SRA3 320,04 x 449,58 mm (12,6 X 17,7 inci) Feed tepi pendek ✓ ✓ X X Amplop (Choukei #3) 120 x 235 mm (4,75 X 9,25 inci) Feed tepi pendek X X X X Hagaki 100 x 148 mm (3,94 X 5,83 inci) Feed tepi pendek ✓ 1 ✓ 1 X X Amplop B5 176 x 250 mm (6,93 X 9,84 inci) Feed tepi pendek X X X X Amplop (Komersial #9) 98,4 x 225,4 mm (3,875 X 8,9 inci) Feed tepi pendek ✓ 1 ✓ 1 X X Amplop (Komersial #10) 104,8 x 241,3 mm (4,12 X 9,5 inci) Feed tepi pendek X X X X Amplop (Monarch 7‑3/4) 98,4 x 190,5 mm (3,875 X 7,5 inci) Feed tepi pendek ✓ ✓ X X Amplop (DL) 110 x 220 mm (4,33 X 8,66 inci) Feed tepi pendek ✓ ✓ X X Amplop (ISO C4) 229 x 324 mm (9 X 12,8 inci) Feed tepi pendek X X X X Amplop (ISO C5) 162 x 229 mm (6,38 X 9 inci) Feed tepi pendek ✓ ✓ X X Universal T/A ✓ 2 ✓ 2 ✓ ✓ ukuran kertas yang didukung ukuran kertas didukung"},{"UUID":"2418282f-4709-4635-86d1-74ce16906a63","title":"Ukuran kertas yang didukung","link":"paper-guidelines-topic.html","desc":"Ukuran kertas yang didukung oleh","descFull":"Ukuran kertas yang didukung oleh keranjang output Penyalur kertas dan salah satu dari lis buklet atau lis lubang stapler dipasang di printer. Ukuran kertas Orientasi Penyalur kertas + Lis lubang stapler Penyalur kertas + Lis buklet Keranjang standar (Keranjang atas finisher) Keranjang 1 (Lis lubang stapler, keranjang ofset) Keranjang 2 (Keranjang penyalur kertas) Keranjang standar (Keranjang atas finisher) Keranjang 1 (Lis lubang stapler, keranjang ofset) Keranjang 2 (Keranjang lis buklet) Keranjang 3 (Keranjang penyalur kertas) 1  Mendukung ukuran kertas mulai dari 90 x 148 mm (3,55 x 5,83 inci) hingga 320 x 600 mm (12,59 x 23,62 inci). 2  Mendukung ukuran kertas mulai dari 90 x 148 mm (3,55 x 5,83 inci) hingga 320 x 1260 mm (12,59 x 49,6 inci). 3  Mendukung ukuran kertas mulai dari 182 x 257 mm (7,17 x 10,12 inci) hingga 304,8 x 457,2 mm (12 x 18 inci). Kartu 4x6 Feed tepi pendek ✓ ✓ ✓ ✓ ✓ X ✓ Feed tepi panjang X X X X X X ✓ A6 105 x 148 mm (4,13 X 5,83 inci) Feed tepi pendek ✓ ✓ ✓ ✓ ✓ X ✓ Feed tepi panjang X X X X X X X 1/3 A4 Feed tepi pendek ✓ ✓ ✓ ✓ ✓ X ✓ Feed tepi panjang X X X X X X ✓ A5 148 x 210 mm (5,83 X 8,27 inci) Feed tepi pendek ✓ ✓ ✓ ✓ ✓ X ✓ Feed tepi panjang ✓ ✓ ✓ ✓ ✓ X ✓ A4 210 x 297 mm (8,27 X 11,7 inci) Feed tepi pendek ✓ ✓ ✓ ✓ ✓ ✓ ✓ Feed tepi panjang ✓ ✓ ✓ ✓ ✓ ✓ ✓ A3 297 x 420 mm (11,69 X 16,54 inci) Feed tepi pendek ✓ ✓ ✓ ✓ ✓ ✓ ✓ JIS B5 182 x 257 mm (7,17 X 10,1 inci) Feed tepi pendek ✓ ✓ ✓ ✓ ✓ ✓ ✓ Feed tepi panjang ✓ ✓ ✓ ✓ ✓ X ✓ JIS B4 257 x 364 mm (10,12 X 14,33 inci) Feed tepi pendek ✓ ✓ ✓ ✓ ✓ ✓ ✓ Statement 139,7 x 215,9 mm (5,5 X 8,5 inci) Feed tepi pendek ✓ ✓ ✓ ✓ ✓ X ✓ Feed tepi panjang ✓ ✓ ✓ ✓ ✓ X ✓ Executive 184,2 x 266,7 mm (7,25 X 10,5 inci) Feed tepi pendek ✓ ✓ ✓ ✓ ✓ X ✓ Feed tepi panjang ✓ ✓ ✓ ✓ ✓ X ✓ Letter 215,9 x 279,4 mm (8,5 X 11 inci) Feed tepi pendek ✓ ✓ ✓ ✓ ✓ ✓ ✓ Feed tepi panjang ✓ ✓ ✓ ✓ ✓ X ✓ Folio 215,9 x 330,2 mm (8,5 X 13 inci) Feed tepi pendek ✓ ✓ ✓ ✓ ✓ ✓ ✓ Oficio (Meksiko) 215,9 x 340,4 mm (8,5 X 13,4 inci) Feed tepi pendek ✓ ✓ ✓ ✓ ✓ ✓ ✓ Legal 215,9 x 355,6 mm (8,5 X 14 inci) Feed tepi pendek ✓ ✓ ✓ ✓ ✓ ✓ ✓ Ledger 279,4 x 431,8 mm (11 X 17 inci) Feed tepi pendek ✓ ✓ ✓ ✓ ✓ ✓ ✓ 12x18 304,8 x 457,2 mm (12 X 18 inci) Feed tepi pendek ✓ ✓ ✓ ✓ ✓ ✓ ✓ SRA3 320,04 x 449,58 mm (12,6 X 17,7 inci) Feed tepi pendek ✓ ✓ X ✓ ✓ X ✓ Amplop (Choukei #3) 120 x 235 mm (4,75 X 9,25 inci) Feed tepi pendek X X ✓ X X X ✓ Hagaki 100 x 148 mm (3,94 X 5,83 inci) Feed tepi pendek X X ✓ X X X ✓ Amplop B5 176 x 250 mm (6,93 X 9,84 inci) Feed tepi pendek X X ✓ X X X ✓ Amplop (Komersial #9) 98,4 x 225,4 mm (3,875 X 8,9 inci) Feed tepi pendek X X ✓ X X X ✓ Amplop (Komersial #10) 104,8 x 241,3 mm (4,12 X 9,5 inci) Feed tepi pendek X X ✓ X X X ✓ Amplop (Monarch 7‑3/4) 98,4 x 190,5 mm (3,875 X 7,5 inci) Feed tepi pendek X X ✓ X X X ✓ Amplop (DL) 110 x 220 mm (4,33 X 8,66 inci) Feed tepi pendek X X ✓ X X X ✓ Amplop (ISO C4) 229 x 324 mm (9 X 12,8 inci) Feed tepi pendek X X ✓ X X X ✓ Amplop (ISO C5) 162 x 229 mm (6,38 X 9 inci) Feed tepi pendek X X ✓ X X X ✓ Universal T/A ✓ 1 ✓ 1 ✓ 2 ✓ 1 ✓ 1 ✓ 3 ✓ 2 Penyalur kertas dengan opsi lipatan dan salah satu dari lis buklet atau lis lubang stapler dipasang di printer. Penyalur kertas dengan opsi lipatan + Lis lubang stapler Penyalur kertas dengan opsi lipatan + Lis buklet Ukuran kertas Orientasi Keranjang standar (Keranjang atas finisher) Keranjang 1 (Lis lubang stapler, keranjang ofset) Keranjang 2 (Keranjang penyalur kertas) Keranjang standar (Keranjang atas finisher) Keranjang 1 (Lis lubang stapler, keranjang ofset) Keranjang 2 (Keranjang lis buklet) Keranjang 3 (Keranjang penyalur kertas) 1  Mendukung ukuran kertas mulai dari 90 x 148 mm (3,55 x 5,83 inci) hingga 320 x 600 mm (12,59 x 23,62 inci). 2  Mendukung ukuran kertas mulai dari 90 x 148 mm (3,55 x 5,83 inci) hingga 297 x 1260 mm (11,69 x 49,6 inci). 3  Mendukung ukuran kertas mulai dari 182 x 257 mm (7,17 x 10,12 inci) hingga 304,8 x 457,2 mm (12 x 18 inci). Kartu 4x6 Feed tepi pendek ✓ ✓ ✓ ✓ ✓ X ✓ Feed tepi panjang X X X X X X X A6 105 x 148 mm (4,13 X 5,83 inci) Feed tepi pendek ✓ ✓ ✓ ✓ ✓ X ✓ Feed tepi panjang X X X X X X X 1/3 A4 Feed tepi pendek ✓ ✓ ✓ ✓ ✓ X ✓ Feed tepi panjang X X X X X X X A5 148 x 210 mm (5,83 X 8,27 inci) Feed tepi pendek ✓ ✓ ✓ ✓ ✓ X ✓ Feed tepi panjang ✓ ✓ ✓ ✓ ✓ X ✓ A4 210 x 297 mm (8,27 X 11,7 inci) Feed tepi pendek ✓ ✓ ✓ ✓ ✓ ✓ ✓ Feed tepi panjang ✓ ✓ ✓ ✓ ✓ X ✓ A3 297 x 420 mm (11,69 X 16,54 inci) Feed tepi pendek ✓ ✓ ✓ ✓ ✓ ✓ ✓ JIS B5 182 x 257 mm (7,17 X 10,1 inci) Feed tepi pendek ✓ ✓ ✓ ✓ ✓ ✓ ✓ Feed tepi panjang ✓ ✓ ✓ ✓ ✓ X ✓ JIS B4 257 x 364 mm (10,12 X 14,33 inci) Feed tepi pendek ✓ ✓ ✓ ✓ ✓ ✓ ✓ Statement 139,7 x 215,9 mm (5,5 X 8,5 inci) Feed tepi pendek ✓ ✓ ✓ ✓ ✓ X ✓ Feed tepi panjang ✓ ✓ ✓ ✓ ✓ X ✓ Executive 184,2 x 266,7 mm (7,25 X 10,5 inci) Feed tepi pendek ✓ ✓ ✓ ✓ ✓ ✓ ✓ Feed tepi panjang ✓ ✓ ✓ ✓ ✓ X ✓ Letter 215,9 x 279,4 mm (8,5 X 11 inci) Feed tepi pendek ✓ ✓ ✓ ✓ ✓ ✓ ✓ Feed tepi panjang ✓ ✓ ✓ ✓ ✓ X ✓ Folio 215,9 x 330,2 mm (8,5 X 13 inci) Feed tepi pendek ✓ ✓ ✓ ✓ ✓ ✓ ✓ Oficio (Meksiko) 215,9 x 340,4 mm (8,5 X 13,4 inci) Feed tepi pendek ✓ ✓ ✓ ✓ ✓ ✓ ✓ Legal 215,9 x 355,6 mm (8,5 X 14 inci) Feed tepi pendek ✓ ✓ ✓ ✓ ✓ ✓ ✓ Ledger 279,4 x 431,8 mm (11 X 17 inci) Feed tepi pendek ✓ ✓ ✓ ✓ ✓ ✓ ✓ 12x18 304,8 x 457,2 mm (12 X 18 inci) Feed tepi pendek ✓ ✓ X ✓ ✓ ✓ X SRA3 320,04 x 449,58 mm (12,6 X 17,7 inci) Feed tepi pendek ✓ ✓ X ✓ ✓ X X Amplop (Choukei #3) 120 x 235 mm (4,75 X 9,25 inci) Feed tepi pendek X X ✓ X X X ✓ Hagaki 100 x 148 mm (3,94 X 5,83 inci) Feed tepi pendek X X ✓ X X X ✓ Amplop B5 176 x 250 mm (6,93 X 9,84 inci) Feed tepi pendek X X ✓ X X X ✓ Amplop (Komersial #9) 98,4 x 225,4 mm (3,875 X 8,9 inci) Feed tepi pendek X X ✓ X X X ✓ Amplop (Komersial #10) 104,8 x 241,3 mm (4,12 X 9,5 inci) Feed tepi pendek X X ✓ X X X ✓ Amplop (Monarch 7‑3/4) 98,4 x 190,5 mm (3,875 X 7,5 inci) Feed tepi pendek X X ✓ X X X ✓ Amplop (DL) 110 x 220 mm (4,33 X 8,66 inci) Feed tepi pendek X X ✓ X X X ✓ Amplop (ISO C4) 229 x 324 mm (9 X 12,8 inci) Feed tepi pendek X X ✓ X X X ✓ Amplop (ISO C5) 162 x 229 mm (6,38 X 9 inci) Feed tepi pendek X X ✓ X X X ✓ Universal T/A ✓ 1 ✓ 1 ✓ 2 ✓ 1 ✓ 1 ✓ 3 ✓ 2 ukuran kertas yang didukung ukuran kertas didukung"},{"UUID":"cd060f6f-dea4-4cd9-997e-a73b18df088e","title":"Ukuran kertas yang didukung","link":"paper-guidelines-topic.html","desc":"Ukuran kertas yang didukung untuk","descFull":"Ukuran kertas yang didukung untuk lis lubang dan stapler Ukuran kertas yang didukung oleh lis stapler Ukuran kertas Orientasi Stapler Tunggal Ganda Ganda Kiri Kartu 4x6 Feed tepi pendek X X X Feed tepi panjang X X X A6 105 x 148 mm (4,13 X 5,83 inci) Feed tepi pendek X X X Feed tepi panjang X X X 1/3 A4 Feed tepi pendek X X X Feed tepi panjang X X X A5 148 x 210 mm (5,83 X 8,27 inci) Feed tepi pendek X X X Feed tepi panjang X X X A4 210 x 297 mm (8,27 X 11,7 inci) Feed tepi pendek ✓ ✓ ✓ Feed tepi panjang ✓ ✓ ✓ A3 297 x 420 mm (11,69 X 16,54 inci) Feed tepi pendek ✓ ✓ ✓ JIS B5 182 x 257 mm (7,17 X 10,1 inci) Feed tepi pendek ✓ ✓ ✓ Feed tepi panjang ✓ ✓ ✓ JIS B4 257 x 364 mm (10,12 X 14,33 inci) Feed tepi pendek ✓ ✓ ✓ Statement 139,7 x 215,9 mm (5,5 X 8,5 inci) Feed tepi pendek X X X Feed tepi panjang X X X Executive 184,2 x 266,7 mm (7,25 X 10,5 inci) Feed tepi pendek ✓ X X Feed tepi panjang ✓ ✓ ✓ Letter 215,9 x 279,4 mm (8,5 X 11 inci) Feed tepi pendek ✓ ✓ X Feed tepi panjang ✓ ✓ X Folio 215,9 x 330,2 mm (8,5 X 13 inci) Feed tepi pendek ✓ ✓ X Oficio (Meksiko) 215,9 x 340,4 mm (8,5 X 13,4 inci) Feed tepi pendek ✓ ✓ X Legal 215,9 x 355,6 mm (8,5 X 14 inci) Feed tepi pendek ✓ ✓ ✓ Ledger 279,4 x 431,8 mm (11 X 17 inci) Feed tepi pendek ✓ ✓ ✓ 12x18 304,8 x 457,2 mm (12 X 18 inci) Feed tepi pendek X X X SRA3 320,04 x 449,58 mm (12,6 X 17,7 inci) Feed tepi pendek X X X Amplop (Choukei #3) 120 x 235 mm (4,75 X 9,25 inci) Feed tepi pendek X X X Hagaki 100 x 148 mm (3,94 X 5,83 inci) Feed tepi pendek X X X Amplop B5 176 x 250 mm (6,93 X 9,84 inci) Feed tepi pendek X X X Amplop (Komersial #9) 98,4 x 225,4 mm (3,875 X 8,9 inci) Feed tepi pendek X X X Amplop (Komersial #10) 104,8 x 241,3 mm (4,12 X 9,5 inci) Feed tepi pendek X X X Amplop (Monarch 7‑3/4) 98,4 x 190,5 mm (3,875 X 7,5 inci) Feed tepi pendek X X X Amplop (DL) 110 x 220 mm (4,33 X 8,66 inci) Feed tepi pendek X X X Amplop (ISO C4) 229 x 324 mm (9 X 12,8 inci) Feed tepi pendek X X X Amplop (ISO C5) 162 x 229 mm (6,38 X 9 inci) Feed tepi pendek X X X Ukuran kertas yang didukung oleh lis lubang stapler Ukuran kertas Orientasi Stapler Lis lubang Tunggal Ganda Ganda Kiri Dua Lubang Tiga Lubang Empat Lubang Kartu 4x6 Feed tepi pendek X X X X X X Feed tepi panjang X X X X X X A6 105 x 148 mm (4,13 X 5,83 inci) Feed tepi pendek X X X X X X Feed tepi panjang X X X X X X 1/3 A4 Feed tepi pendek X X X X X X Feed tepi panjang X X X X X X A5 148 x 210 mm (5,83 X 8,27 inci) Feed tepi pendek X X X ✓ X X Feed tepi panjang X X X ✓ X X A4 210 x 297 mm (8,27 X 11,7 inci) Feed tepi pendek ✓ ✓ ✓ ✓ X X Feed tepi panjang ✓ ✓ ✓ ✓ ✓ ✓ A3 297 x 420 mm (11,69 X 16,54 inci) Feed tepi pendek ✓ ✓ ✓ ✓ ✓ ✓ JIS B5 182 x 257 mm (7,17 X 10,1 inci) Feed tepi pendek ✓ ✓ ✓ ✓ X X Feed tepi panjang ✓ ✓ ✓ ✓ ✓ ✓ JIS B4 257 x 364 mm (10,12 X 14,33 inci) Feed tepi pendek ✓ ✓ X ✓ ✓ ✓ Statement 139,7 x 215,9 mm (5,5 X 8,5 inci) Feed tepi pendek X X X ✓ X X Feed tepi panjang X X X ✓ X X Executive 184,2 x 266,7 mm (7,25 X 10,5 inci) Feed tepi pendek ✓ ✓ ✓ ✓ X X Feed tepi panjang ✓ ✓ ✓ ✓ ✓ ✓ Letter 215,9 x 279,4 mm (8,5 X 11 inci) Feed tepi pendek ✓ ✓ ✓ ✓ X X Feed tepi panjang ✓ ✓ ✓ ✓ ✓ ✓ Folio 215,9 x 330,2 mm (8,5 X 13 inci) Feed tepi pendek ✓ ✓ ✓ ✓ X X Oficio (Meksiko) 215,9 x 340,4 mm (8,5 X 13,4 inci) Feed tepi pendek ✓ ✓ ✓ ✓ X X Legal 215,9 x 355,6 mm (8,5 X 14 inci) Feed tepi pendek ✓ ✓ ✓ ✓ X X Ledger 279,4 x 431,8 mm (11 X 17 inci) Feed tepi pendek ✓ ✓ ✓ ✓ ✓ ✓ 12x18 304,8 x 457,2 mm (12 X 18 inci) Feed tepi pendek X X X X X X SRA3 320,04 x 449,58 mm (12,6 X 17,7 inci) Feed tepi pendek X X X X X X Amplop (Choukei #3) 120 x 235 mm (4,75 X 9,25 inci) Feed tepi pendek X X X X X X Hagaki 100 x 148 mm (3,94 X 5,83 inci) Feed tepi pendek X X X X X X Amplop B5 176 x 250 mm (6,93 X 9,84 inci) Feed tepi pendek X X X X X X Amplop (Komersial #9) 98,4 x 225,4 mm (3,875 X 8,9 inci) Feed tepi pendek X X X X X X Amplop (Komersial #10) 104,8 x 241,3 mm (4,12 X 9,5 inci) Feed tepi pendek X X X X X X Amplop (Monarch 7‑3/4) 98,4 x 190,5 mm (3,875 X 7,5 inci) Feed tepi pendek X X X X X X Amplop (DL) 110 x 220 mm (4,33 X 8,66 inci) Feed tepi pendek X X X X X X Amplop (ISO C4) 229 x 324 mm (9 X 12,8 inci) Feed tepi pendek X X X X X X Amplop (ISO C5) 162 x 229 mm (6,38 X 9 inci) Feed tepi pendek X X X X X X Ukuran kertas yang didukung oleh lis buklet Ukuran kertas Orientasi Stapler Lis lubang Tunggal Ganda Ganda Kiri Dua Lubang Tiga Lubang Empat Lubang Kartu 4x6 Feed tepi pendek X X X X X X Feed tepi panjang X X X X X X A6 105 x 148 mm (4,13 X 5,83 inci) Feed tepi pendek X X X X X X Feed tepi panjang X X X X X X 1/3 A4 Feed tepi pendek X X X X X X Feed tepi panjang X X X X X X A5 148 x 210 mm (5,83 X 8,27 inci) Feed tepi pendek X X X ✓ X X Feed tepi panjang X X X ✓ X X A4 210 x 297 mm (8,27 X 11,7 inci) Feed tepi pendek ✓ ✓ ✓ ✓ X X Feed tepi panjang ✓ ✓ ✓ ✓ ✓ ✓ A3 297 x 420 mm (11,69 X 16,54 inci) Feed tepi pendek ✓ ✓ ✓ ✓ ✓ ✓ JIS B5 182 x 257 mm (7,17 X 10,1 inci) Feed tepi pendek ✓ ✓ ✓ X X X Feed tepi panjang ✓ ✓ ✓ ✓ X X JIS B4 257 x 364 mm (10,12 X 14,33 inci) Feed tepi pendek ✓ ✓ X ✓ ✓ ✓ Statement 139,7 x 215,9 mm (5,5 X 8,5 inci) Feed tepi pendek X X X ✓ X X Feed tepi panjang X X X ✓ X X Executive 184,2 x 266,7 mm (7,25 X 10,5 inci) Feed tepi pendek ✓ ✓ ✓ ✓ X X Feed tepi panjang ✓ ✓ ✓ ✓ ✓ ✓ Letter 215,9 x 279,4 mm (8,5 X 11 inci) Feed tepi pendek ✓ ✓ ✓ ✓ X X Feed tepi panjang ✓ ✓ ✓ ✓ ✓ ✓ Folio 215,9 x 330,2 mm (8,5 X 13 inci) Feed tepi pendek ✓ ✓ ✓ ✓ X X Oficio (Meksiko) 215,9 x 340,4 mm (8,5 X 13,4 inci) Feed tepi pendek ✓ ✓ ✓ ✓ X X Legal 215,9 x 355,6 mm (8,5 X 14 inci) Feed tepi pendek ✓ ✓ ✓ ✓ X X Ledger 279,4 x 431,8 mm (11 X 17 inci) Feed tepi pendek ✓ ✓ ✓ ✓ ✓ ✓ 12x18 304,8 x 457,2 mm (12 X 18 inci) Feed tepi pendek X X X X X X SRA3 320,04 x 449,58 mm (12,6 X 17,7 inci) Feed tepi pendek X X X X X X Amplop (Choukei #3) 120 x 235 mm (4,75 X 9,25 inci) Feed tepi pendek X X X X X X Hagaki 100 x 148 mm (3,94 X 5,83 inci) Feed tepi pendek X X X X X X Amplop B5 176 x 250 mm (6,93 X 9,84 inci) Feed tepi pendek X X X X X X Amplop (Komersial #9) 98,4 x 225,4 mm (3,875 X 8,9 inci) Feed tepi pendek X X X X X X Amplop (Komersial #10) 104,8 x 241,3 mm (4,12 X 9,5 inci) Feed tepi pendek X X X X X X Amplop (Monarch 7‑3/4) 98,4 x 190,5 mm (3,875 X 7,5 inci) Feed tepi pendek X X X X X X Amplop (DL) 110 x 220 mm (4,33 X 8,66 inci) Feed tepi pendek X X X X X X Amplop (ISO C4) 229 x 324 mm (9 X 12,8 inci) Feed tepi pendek X X X X X X Amplop (ISO C5) 162 x 229 mm (6,38 X 9 inci) Feed tepi pendek X X X X X X ukuran kertas yang didukung ukuran kertas didukung"},{"UUID":"6b0c0fb5-dfbe-4aba-8411-051e509568cf","title":"Ukuran kertas yang didukung","link":"paper-guidelines-topic.html","desc":"Ukuran kertas yang didukung untuk","descFull":"Ukuran kertas yang didukung untuk pekerjaan lipat Ukuran kertas yang didukung oleh penyalur kertas dengan opsi lipatan. Ukuran kertas Orientasi Penyalur kertas dengan opsi lipatan Lipatan C Lipatan Z Lipatan Z separuh lembar Lipatan V Keranjang standar Keranjang standar Keranjang standar Keranjang standar Kartu 4x6 Feed tepi pendek X X X X Feed tepi panjang X X X X A6 105 x 148 mm (4,13 X 5,83 inci) Feed tepi pendek X X X X Feed tepi panjang X X X X 1/3 A4 Feed tepi pendek X X X X Feed tepi panjang X X X X A5 148 x 210 mm (5,83 X 8,27 inci) Feed tepi pendek X X X X Feed tepi panjang X X X X A4 210 x 297 mm (8,27 X 11,7 inci) Feed tepi pendek ✓ ✓ ✓ ✓ Feed tepi panjang X X X X A3 297 x 420 mm (11,69 X 16,54 inci) Feed tepi pendek ✓ ✓ ✓ ✓ JIS B5 182 x 257 mm (7,17 X 10,1 inci) Feed tepi pendek X X X X Feed tepi panjang X X X X JIS B4 257 x 364 mm (10,12 X 14,33 inci) Feed tepi pendek X X ✓ ✓ Statement 139,7 x 215,9 mm (5,5 X 8,5 inci) Feed tepi pendek X X X X Feed tepi panjang X X X X Executive 184,2 x 266,7 mm (7,25 X 10,5 inci) Feed tepi pendek X X X X Feed tepi panjang X X X X Letter 215,9 x 279,4 mm (8,5 X 11 inci) Feed tepi pendek ✓ ✓ ✓ ✓ Feed tepi panjang X X X X Folio 215,9 x 330,2 mm (8,5 X 13 inci) Feed tepi pendek X X X X Oficio (Meksiko) 215,9 x 340,4 mm (8,5 X 13,4 inci) Feed tepi pendek ✓ ✓ ✓ ✓ Legal 215,9 x 355,6 mm (8,5 X 14 inci) Feed tepi pendek ✓ ✓ ✓ ✓ Ledger 279,4 x 431,8 mm (11 X 17 inci) Feed tepi pendek ✓ ✓ ✓ ✓ 12x18 304,8 x 457,2 mm (12 X 18 inci) Feed tepi pendek X X X X SRA3 320,04 x 449,58 mm (12,6 X 17,7 inci) Feed tepi pendek X X X X Amplop (Choukei #3) 120 x 235 mm (4,75 X 9,25 inci) Feed tepi pendek X X X X Hagaki 100 x 148 mm (3,94 X 5,83 inci) Feed tepi pendek X X X X Amplop B5 176 x 250 mm (6,93 X 9,84 inci) Feed tepi pendek X X X X Amplop (Komersial #9) 98,4 x 225,4 mm (3,875 X 8,9 inci) Feed tepi pendek X X X X Amplop (Komersial #10) 104,8 x 241,3 mm (4,12 X 9,5 inci) Feed tepi pendek X X X X Amplop (Monarch 7‑3/4) 98,4 x 190,5 mm (3,875 X 7,5 inci) Feed tepi pendek X X X X Amplop (DL) 110 x 220 mm (4,33 X 8,66 inci) Feed tepi pendek X X X X Amplop (ISO C4) 229 x 324 mm (9 X 12,8 inci) Feed tepi pendek X X X X Amplop (ISO C5) 162 x 229 mm (6,38 X 9 inci) Feed tepi pendek X X X X Ukuran kertas yang didukung oleh penyalur kertas dan lis buklet. Ukuran kertas Orientasi Penyalur kertas + Lis buklet Lipatan V berganda Lipatan V Keranjang 2 Keranjang standar 1, keranjang 1, keranjang 2 Kartu 4x6 Feed tepi pendek X X Feed tepi panjang X X A6 105 x 148 mm (4,13 X 5,83 inci) Feed tepi pendek X X Feed tepi panjang X X 1/3 A4 Feed tepi pendek X X Feed tepi panjang X X A5 148 x 210 mm (5,83 X 8,27 inci) Feed tepi pendek X X Feed tepi panjang X X A4 210 x 297 mm (8,27 X 11,7 inci) Feed tepi pendek ✓ ✓ Feed tepi panjang X X A3 297 x 420 mm (11,69 X 16,54 inci) Feed tepi pendek ✓ ✓ JIS B5 182 x 257 mm (7,17 X 10,1 inci) Feed tepi pendek ✓ ✓ Feed tepi panjang X X JIS B4 257 x 364 mm (10,12 X 14,33 inci) Feed tepi pendek ✓ ✓ Statement 139,7 x 215,9 mm (5,5 X 8,5 inci) Feed tepi pendek X X Feed tepi panjang X X Executive 184,2 x 266,7 mm (7,25 X 10,5 inci) Feed tepi pendek X X Feed tepi panjang X X Letter 215,9 x 279,4 mm (8,5 X 11 inci) Feed tepi pendek ✓ ✓ Feed tepi panjang X X Folio 215,9 x 330,2 mm (8,5 X 13 inci) Feed tepi pendek ✓ ✓ Oficio (Meksiko) 215,9 x 340,4 mm (8,5 X 13,4 inci) Feed tepi pendek ✓ ✓ Legal 215,9 x 355,6 mm (8,5 X 14 inci) Feed tepi pendek ✓ ✓ Ledger 279,4 x 431,8 mm (11 X 17 inci) Feed tepi pendek ✓ ✓ 12x18 304,8 x 457,2 mm (12 X 18 inci) Feed tepi pendek ✓ ✓ SRA3 320,04 x 449,58 mm (12,6 X 17,7 inci) Feed tepi pendek ✓ ✓ Amplop (Choukei #3) 120 x 235 mm (4,75 X 9,25 inci) Feed tepi pendek X X Hagaki 100 x 148 mm (3,94 X 5,83 inci) Feed tepi pendek X X Amplop B5 176 x 250 mm (6,93 X 9,84 inci) Feed tepi pendek X X Amplop (Komersial #9) 98,4 x 225,4 mm (3,875 X 8,9 inci) Feed tepi pendek X X Amplop (Komersial #10) 104,8 x 241,3 mm (4,12 X 9,5 inci) Feed tepi pendek X X Amplop (Monarch 7‑3/4) 98,4 x 190,5 mm (3,875 X 7,5 inci) Feed tepi pendek X X Amplop (DL) 110 x 220 mm (4,33 X 8,66 inci) Feed tepi pendek X X Amplop (ISO C4) 229 x 324 mm (9 X 12,8 inci) Feed tepi pendek X X Amplop (ISO C5) 162 x 229 mm (6,38 X 9 inci) Feed tepi pendek X X Ukuran kertas yang didukung oleh penyalur kertas dengan opsi lipatan dan lis lubang stapler Ukuran kertas Orientasi Penyalur kertas dengan opsi lipatan + Lis lubang stapler Lipatan C Lipatan Z Lipatan Z separuh lembar Lipatan V Keranjang 2 Keranjang 2 Keranjang standar, keranjang 2 Keranjang standar, keranjang 2 Kartu 4x6 Feed tepi pendek X X X X Feed tepi panjang X X X X A6 105 x 148 mm (4,13 X 5,83 inci) Feed tepi pendek X X X X Feed tepi panjang X X X X 1/3 A4 Feed tepi pendek X X X X Feed tepi panjang X X X X A5 148 x 210 mm (5,83 X 8,27 inci) Feed tepi pendek X X X X Feed tepi panjang X X X X A4 210 x 297 mm (8,27 X 11,7 inci) Feed tepi pendek ✓ ✓ ✓ ✓ Feed tepi panjang X X X X A3 297 x 420 mm (11,69 X 16,54 inci) Feed tepi pendek ✓ ✓ ✓ ✓ JIS B5 182 x 257 mm (7,17 X 10,1 inci) Feed tepi pendek X X X X Feed tepi panjang X X X X JIS B4 257 x 364 mm (10,12 X 14,33 inci) Feed tepi pendek X X ✓ ✓ Statement 139,7 x 215,9 mm (5,5 X 8,5 inci) Feed tepi pendek X X X X Feed tepi panjang X X X X Executive 184,2 x 266,7 mm (7,25 X 10,5 inci) Feed tepi pendek X X X X Feed tepi panjang X X X X Letter 215,9 x 279,4 mm (8,5 X 11 inci) Feed tepi pendek ✓ ✓ ✓ ✓ Feed tepi panjang X X X X Folio 215,9 x 330,2 mm (8,5 X 13 inci) Feed tepi pendek X X X X Oficio (Meksiko) 215,9 x 340,4 mm (8,5 X 13,4 inci) Feed tepi pendek ✓ ✓ ✓ ✓ Legal 215,9 x 355,6 mm (8,5 X 14 inci) Feed tepi pendek ✓ ✓ ✓ ✓ Ledger 279,4 x 431,8 mm (11 X 17 inci) Feed tepi pendek ✓ ✓ ✓ ✓ 12x18 304,8 x 457,2 mm (12 X 18 inci) Feed tepi pendek X X X ✓ SRA3 320,04 x 449,58 mm (12,6 X 17,7 inci) Feed tepi pendek X X X ✓ Amplop (Choukei #3) 120 x 235 mm (4,75 X 9,25 inci) Feed tepi pendek X X X X Hagaki 100 x 148 mm (3,94 X 5,83 inci) Feed tepi pendek X X X X Amplop B5 176 x 250 mm (6,93 X 9,84 inci) Feed tepi pendek X X X X Amplop (Komersial #9) 98,4 x 225,4 mm (3,875 X 8,9 inci) Feed tepi pendek X X X X Amplop (Komersial #10) 104,8 x 241,3 mm (4,12 X 9,5 inci) Feed tepi pendek X X X X Amplop (Monarch 7‑3/4) 98,4 x 190,5 mm (3,875 X 7,5 inci) Feed tepi pendek X X X X Amplop (DL) 110 x 220 mm (4,33 X 8,66 inci) Feed tepi pendek X X X X Amplop (ISO C4) 229 x 324 mm (9 X 12,8 inci) Feed tepi pendek X X X X Amplop (ISO C5) 162 x 229 mm (6,38 X 9 inci) Feed tepi pendek X X X X Ukuran kertas yang didukung oleh penyalur kertas opsi lipatan dan lis buklet. Ukuran kertas Orientasi Penyalur kertas dengan opsi lipatan + Lis buklet Lipatan C Lipatan Z Lipatan Z separuh lembar Lipatan V berganda Lipatan V Keranjang 3 Keranjang 3 Keranjang standar 1, keranjang 1, keranjang 3 Keranjang 2 Keranjang standar, keranjang 1, keranjang 2, keranjang 3 Kartu 4x6 Feed tepi pendek X X X X X Feed tepi panjang X X X X X A6 105 x 148 mm (4,13 X 5,83 inci) Feed tepi pendek X X X X X Feed tepi panjang X X X X X 1/3 A4 Feed tepi pendek X X X X X Feed tepi panjang X X X X X A5 148 x 210 mm (5,83 X 8,27 inci) Feed tepi pendek X X X X X Feed tepi panjang X X X X X A4 210 x 297 mm (8,27 X 11,7 inci) Feed tepi pendek ✓ ✓ ✓ ✓ ✓ Feed tepi panjang X X X X X A3 297 x 420 mm (11,69 X 16,54 inci) Feed tepi pendek ✓ ✓ ✓ ✓ ✓ JIS B5 182 x 257 mm (7,17 X 10,1 inci) Feed tepi pendek X X X ✓ ✓ Feed tepi panjang X X X X X JIS B4 257 x 364 mm (10,12 X 14,33 inci) Feed tepi pendek X X ✓ ✓ ✓ Statement 139,7 x 215,9 mm (5,5 X 8,5 inci) Feed tepi pendek X X X X X Feed tepi panjang X X X X X Executive 184,2 x 266,7 mm (7,25 X 10,5 inci) Feed tepi pendek X X X X X Feed tepi panjang X X X X X Letter 215,9 x 279,4 mm (8,5 X 11 inci) Feed tepi pendek ✓ ✓ ✓ ✓ ✓ Feed tepi panjang X X X X X Folio 215,9 x 330,2 mm (8,5 X 13 inci) Feed tepi pendek X X X ✓ ✓ Oficio (Meksiko) 215,9 x 340,4 mm (8,5 X 13,4 inci) Feed tepi pendek ✓ ✓ ✓ ✓ ✓ Legal 215,9 x 355,6 mm (8,5 X 14 inci) Feed tepi pendek ✓ ✓ ✓ ✓ ✓ Ledger 279,4 x 431,8 mm (11 X 17 inci) Feed tepi pendek ✓ ✓ ✓ ✓ ✓ 12x18 304,8 x 457,2 mm (12 X 18 inci) Feed tepi pendek X X X X ✓ SRA3 320,04 x 449,58 mm (12,6 X 17,7 inci) Feed tepi pendek X X X X ✓ Amplop (Choukei #3) 120 x 235 mm (4,75 X 9,25 inci) Feed tepi pendek X X X X X Hagaki 100 x 148 mm (3,94 X 5,83 inci) Feed tepi pendek X X X X X Amplop B5 176 x 250 mm (6,93 X 9,84 inci) Feed tepi pendek X X X X X Amplop (Komersial #9) 98,4 x 225,4 mm (3,875 X 8,9 inci) Feed tepi pendek X X X X X Amplop (Komersial #10) 104,8 x 241,3 mm (4,12 X 9,5 inci) Feed tepi pendek X X X X X Amplop (Monarch 7‑3/4) 98,4 x 190,5 mm (3,875 X 7,5 inci) Feed tepi pendek X X X X X Amplop (DL) 110 x 220 mm (4,33 X 8,66 inci) Feed tepi pendek X X X X X Amplop (ISO C4) 229 x 324 mm (9 X 12,8 inci) Feed tepi pendek X X X X X Amplop (ISO C5) 162 x 229 mm (6,38 X 9 inci) Feed tepi pendek X X X X X ukuran kertas yang didukung ukuran kertas didukung"},{"UUID":"e2d04f2b-6ddf-49c6-b6aa-471e8958b370","title":"Ukuran kertas yang didukung","link":"paper-guidelines-topic.html","desc":"Ukuran kertas yang didukung untuk","descFull":"Ukuran kertas yang didukung untuk penumpukan ofset Ukuran kertas yang didukung oleh lis penumpuk ofset atau lis stapler Ukuran kertas Orientasi Penumpuk ofset Lis stapler 1  Mendukung ukuran kertas mulai dari 90 x 148 mm (3,55 x 5,83 inci) hingga 320 x 600 mm (12,59 x 23,62 inci). 2  Mendukung ukuran kertas mulai dari 148 x 148 mm (5,83 x 5,83 inci) hingga 297 x 431,8 mm (11,69 x 17 inci). Kartu 4x6 Feed tepi pendek X X Feed tepi panjang X X A6 105 x 148 mm (4,13 X 5,83 inci) Feed tepi pendek X X Feed tepi panjang X X 1/3 A4 Feed tepi pendek X X Feed tepi panjang X X A5 148 x 210 mm (5,83 X 8,27 inci) Feed tepi pendek ✓ ✓ Feed tepi panjang ✓ ✓ A4 210 x 297 mm (8,27 X 11,7 inci) Feed tepi pendek ✓ ✓ Feed tepi panjang ✓ ✓ A3 297 x 420 mm (11,69 X 16,54 inci) Feed tepi pendek ✓ ✓ JIS B5 182 x 257 mm (7,17 X 10,1 inci) Feed tepi pendek ✓ ✓ Feed tepi panjang ✓ ✓ JIS B4 257 x 364 mm (10,12 X 14,33 inci) Feed tepi pendek ✓ ✓ Statement 139,7 x 215,9 mm (5,5 X 8,5 inci) Feed tepi pendek ✓ X Feed tepi panjang ✓ X Executive 184,2 x 266,7 mm (7,25 X 10,5 inci) Feed tepi pendek ✓ ✓ Feed tepi panjang ✓ ✓ Letter 215,9 x 279,4 mm (8,5 X 11 inci) Feed tepi pendek ✓ ✓ Feed tepi panjang ✓ ✓ Folio 215,9 x 330,2 mm (8,5 X 13 inci) Feed tepi pendek ✓ ✓ Oficio (Meksiko) 215,9 x 340,4 mm (8,5 X 13,4 inci) Feed tepi pendek ✓ ✓ Legal 215,9 x 355,6 mm (8,5 X 14 inci) Feed tepi pendek ✓ ✓ Ledger 279,4 x 431,8 mm (11 X 17 inci) Feed tepi pendek ✓ ✓ 12x18 304,8 x 457,2 mm (12 X 18 inci) Feed tepi pendek X X SRA3 320,04 x 449,58 mm (12,6 X 17,7 inci) Feed tepi pendek X X Amplop (Choukei #3) 120 x 235 mm (4,75 X 9,25 inci) Feed tepi pendek ✓ X Hagaki 100 x 148 mm (3,94 X 5,83 inci) Feed tepi pendek ✓ X Amplop B5 176 x 250 mm (6,93 X 9,84 inci) Feed tepi pendek ✓ X Amplop (Komersial #9) 98,4 x 225,4 mm (3,875 X 8,9 inci) Feed tepi pendek ✓ X Amplop (Komersial #10) 104,8 x 241,3 mm (4,12 X 9,5 inci) Feed tepi pendek ✓ X Amplop (Monarch 7‑3/4) 98,4 x 190,5 mm (3,875 X 7,5 inci) Feed tepi pendek ✓ X Amplop (DL) 110 x 220 mm (4,33 X 8,66 inci) Feed tepi pendek ✓ X Amplop (ISO C4) 229 x 324 mm (9 X 12,8 inci) Feed tepi pendek ✓ X Amplop (ISO C5) 162 x 229 mm (6,38 X 9 inci) Feed tepi pendek ✓ X Universal T/A ✓ 1 ✓ 2 Ukuran kertas yang didukung oleh keranjang output Ukuran kertas Orientasi Penyalur kertas + Lis lubang stapler Penyalur kertas + Lis buklet Keranjang 1 Keranjang 1 1  Mendukung ukuran kertas mulai dari 139,7 x 148 mm (5,5 x 5,83 inci) hingga 304,8 x 600 mm (12 x 23,62 inci). 2  Mendukung ukuran kertas mulai dari 125 x 148 mm (4,93 x 5,83 inci) hingga 304,8 x 457,2 mm (12 x 18 inci). Kartu 4x6 Feed tepi pendek X X Feed tepi panjang X X A6 105 x 148 mm (4,13 X 5,83 inci) Feed tepi pendek X X Feed tepi panjang X X 1/3 A4 Feed tepi pendek X X Feed tepi panjang X X A5 148 x 210 mm (5,83 X 8,27 inci) Feed tepi pendek ✓ ✓ Feed tepi panjang ✓ ✓ A4 210 x 297 mm (8,27 X 11,7 inci) Feed tepi pendek ✓ ✓ Feed tepi panjang ✓ ✓ A3 297 x 420 mm (11,69 X 16,54 inci) Feed tepi pendek ✓ ✓ JIS B5 182 x 257 mm (7,17 X 10,1 inci) Feed tepi pendek ✓ ✓ Feed tepi panjang ✓ ✓ JIS B4 257 x 364 mm (10,12 X 14,33 inci) Feed tepi pendek ✓ ✓ Statement 139,7 x 215,9 mm (5,5 X 8,5 inci) Feed tepi pendek ✓ ✓ Feed tepi panjang ✓ ✓ Executive 184,2 x 266,7 mm (7,25 X 10,5 inci) Feed tepi pendek ✓ ✓ Feed tepi panjang ✓ ✓ Letter 215,9 x 279,4 mm (8,5 X 11 inci) Feed tepi pendek ✓ ✓ Feed tepi panjang ✓ ✓ Folio 215,9 x 330,2 mm (8,5 X 13 inci) Feed tepi pendek ✓ ✓ Oficio (Meksiko) 215,9 x 340,4 mm (8,5 X 13,4 inci) Feed tepi pendek ✓ ✓ Legal 215,9 x 355,6 mm (8,5 X 14 inci) Feed tepi pendek ✓ ✓ Ledger 279,4 x 431,8 mm (11 X 17 inci) Feed tepi pendek ✓ ✓ 12x18 304,8 x 457,2 mm (12 X 18 inci) Feed tepi pendek ✓ ✓ SRA3 320,04 x 449,58 mm (12,6 X 17,7 inci) Feed tepi pendek X X Amplop (Choukei #3) 120 x 235 mm (4,75 X 9,25 inci) Feed tepi pendek X X Hagaki 100 x 148 mm (3,94 X 5,83 inci) Feed tepi pendek X X Amplop B5 176 x 250 mm (6,93 X 9,84 inci) Feed tepi pendek X X Amplop (Komersial #9) 98,4 x 225,4 mm (3,875 X 8,9 inci) Feed tepi pendek X X Amplop (Komersial #10) 104,8 x 241,3 mm (4,12 X 9,5 inci) Feed tepi pendek X X Amplop (Monarch 7‑3/4) 98,4 x 190,5 mm (3,875 X 7,5 inci) Feed tepi pendek X X Amplop (DL) 110 x 220 mm (4,33 X 8,66 inci) Feed tepi pendek X X Amplop (ISO C4) 229 x 324 mm (9 X 12,8 inci) Feed tepi pendek X X Amplop (ISO C5) 162 x 229 mm (6,38 X 9 inci) Feed tepi pendek X X Universal T/A ✓ 1 ✓ 2 Ukuran kertas yang didukung oleh keranjang output (plus penyalur kertas dengan opsi lipatan) Ukuran kertas Orientasi Penyalur kertas dengan opsi lipatan + Lis lubang stapler Penyalur kertas dengan opsi lipatan + Lis buklet Keranjang 1 Keranjang 1 1  Mendukung ukuran kertas mulai dari 139,7 x 148 mm (5,5 x 5,83 inci) hingga 304,8 x 600 mm (12 x 23,62 inci). 2  Mendukung ukuran kertas mulai dari 125 x 148 mm (4,93 x 5,83 inci) hingga 304,8 x 457,2 mm (12 x 18 inci). Kartu 4x6 Feed tepi pendek X X Feed tepi panjang X X A6 105 x 148 mm (4,13 X 5,83 inci) Feed tepi pendek X X Feed tepi panjang X X 1/3 A4 Feed tepi pendek X X Feed tepi panjang X X A5 148 x 210 mm (5,83 X 8,27 inci) Feed tepi pendek ✓ ✓ Feed tepi panjang ✓ ✓ A4 210 x 297 mm (8,27 X 11,7 inci) Feed tepi pendek ✓ ✓ Feed tepi panjang ✓ ✓ A3 297 x 420 mm (11,69 X 16,54 inci) Feed tepi pendek ✓ ✓ JIS B5 182 x 257 mm (7,17 X 10,1 inci) Feed tepi pendek ✓ ✓ Feed tepi panjang ✓ ✓ JIS B4 257 x 364 mm (10,12 X 14,33 inci) Feed tepi pendek ✓ ✓ Statement 139,7 x 215,9 mm (5,5 X 8,5 inci) Feed tepi pendek ✓ ✓ Feed tepi panjang ✓ ✓ Executive 184,2 x 266,7 mm (7,25 X 10,5 inci) Feed tepi pendek ✓ ✓ Feed tepi panjang ✓ ✓ Letter 215,9 x 279,4 mm (8,5 X 11 inci) Feed tepi pendek ✓ ✓ Feed tepi panjang ✓ ✓ Folio 215,9 x 330,2 mm (8,5 X 13 inci) Feed tepi pendek ✓ ✓ Oficio (Meksiko) 215,9 x 340,4 mm (8,5 X 13,4 inci) Feed tepi pendek ✓ ✓ Legal 215,9 x 355,6 mm (8,5 X 14 inci) Feed tepi pendek ✓ ✓ Ledger 279,4 x 431,8 mm (11 X 17 inci) Feed tepi pendek ✓ ✓ 12x18 304,8 x 457,2 mm (12 X 18 inci) Feed tepi pendek ✓ ✓ SRA3 320,04 x 449,58 mm (12,6 X 17,7 inci) Feed tepi pendek X X Amplop (Choukei #3) 120 x 235 mm (4,75 X 9,25 inci) Feed tepi pendek X X Hagaki 100 x 148 mm (3,94 X 5,83 inci) Feed tepi pendek X X Amplop B5 176 x 250 mm (6,93 X 9,84 inci) Feed tepi pendek X X Amplop (Komersial #9) 98,4 x 225,4 mm (3,875 X 8,9 inci) Feed tepi pendek X X Amplop (Komersial #10) 104,8 x 241,3 mm (4,12 X 9,5 inci) Feed tepi pendek X X Amplop (Monarch 7‑3/4) 98,4 x 190,5 mm (3,875 X 7,5 inci) Feed tepi pendek X X Amplop (DL) 110 x 220 mm (4,33 X 8,66 inci) Feed tepi pendek X X Amplop (ISO C4) 229 x 324 mm (9 X 12,8 inci) Feed tepi pendek X X Amplop (ISO C5) 162 x 229 mm (6,38 X 9 inci) Feed tepi pendek X X Universal T/A ✓ 1 ✓ 2 ukuran kertas yang didukung ukuran kertas didukung"},{"UUID":"49ed61f4-543b-4653-aba8-74443bf2cef4","title":"Memilih kertas","link":"paper-guidelines-topic.html","desc":"Berat kertas yang didukung Berat","descFull":"Berat kertas yang didukung Berat kertas yang didukung Berat kertas yang didukung oleh printer Baki standar/opsional 550 lembar, 2 baki 550 lembar, baki 1500 lembar, dan baki tandem 2000 lembar Feeder multiguna Pencetakan dua sisi* Pengumpan dokumen otomatis 60-300 g/m 2 (16-80 pon bond) 60-300 g/m 2 (16-80 pon bond) 60-220 g/m 2 (16-59 pon bond) 50-150 g/m 2 (14-40 pon bond) berat kertas yang didukung berat kertas didukung"},{"UUID":"99a0e068-6199-4e14-b1b6-bc85c74977dc","title":"Memilih kertas","link":"paper-guidelines-topic.html","desc":"Jenis kertas yang didukung Jenis","descFull":"Jenis kertas yang didukung Jenis kertas yang didukung Jenis kertas yang didukung oleh konfigurasi dasar Ukuran kertas Baki 550 lembar (Standar) Feeder multiguna Pencetakan dua sisi* Pengumpan dokumen otomatis Plain paper ✓ ✓ ✓ ✓ Card stock ✓ ✓ ✓ X Daur ulang ✓ ✓ ✓ ✓ Glossy ✓ ✓ ✓ X Heavy Glossy ✓ ✓ ✓ X Label ✓ ✓ X X Label vinil ✓ ✓ X X Bond ✓ ✓ ✓ ✓ Amplop ✓ ✓ X X Amplop Kasar ✓ ✓ X X Letterhead ✓ ✓ ✓ ✓ Pracetak ✓ ✓ ✓ ✓ Kertas warna ✓ ✓ ✓ ✓ Kertas ringan ✓ ✓ ✓ ✓ Kertas berat ✓ ✓ ✓ ✓ Katun kasar ✓ ✓ ✓ X Jenis kustom ✓ ✓ ✓ ✓ Jenis kertas yang didukung oleh baki opsional Ukuran kertas Baki 550 lembar (opsional) 2 baki 550 lembar Baki tandem 2000 lembar Baki 1500 lembar Plain paper ✓ ✓ ✓ ✓ Card stock ✓ ✓ ✓ ✓ Transparansi X X X X Daur ulang ✓ ✓ ✓ ✓ Glossy ✓ ✓ ✓ ✓ Heavy Glossy ✓ ✓ ✓ ✓ Label ✓ ✓ X X Label vinil ✓ ✓ X X Bond ✓ ✓ ✓ ✓ Amplop ✓ ✓ X X Amplop Kasar ✓ ✓ X X Letterhead ✓ ✓ ✓ ✓ Pracetak ✓ ✓ ✓ ✓ Kertas warna ✓ ✓ ✓ ✓ Kertas ringan ✓ ✓ ✓ ✓ Kertas berat ✓ ✓ ✓ ✓ Katun kasar ✓ ✓ ✓ ✓ Jenis kustom ✓ ✓ ✓ ✓ Jenis kertas yang didukung oleh keranjang output Ukuran kertas Penyalur kertas + Lis lubang stapler Penyalur kertas + Lis buklet Keranjang standar (Keranjang atas finisher) Keranjang 1 (Lis lubang stapler, keranjang ofset) Keranjang 2 (Keranjang penyalur kertas) Keranjang standar (Keranjang atas finisher) Keranjang 1 (Lis lubang stapler, keranjang ofset) Keranjang 2 (Keranjang lis buklet) Keranjang 3 (Keranjang penyalur kertas) *  Panjang maksimal dari ukuran kertas universal pada kertas banner adalah 1320.8 mm/52 inci. Hanya masukkan satu lembar kertas banner pada satu pencetakan. Plain paper ✓ ✓ ✓ ✓ ✓ ✓ * ✓ Card stock ✓ ✓ ✓ ✓ ✓ X ✓ Daur ulang ✓ ✓ ✓ ✓ ✓ ✓ * ✓ Glossy ✓ ✓ ✓ ✓ ✓ ✓ * ✓ Heavy Glossy ✓ ✓ ✓ ✓ ✓ X ✓ Label ✓ ✓ ✓ ✓ ✓ X X Label vinil ✓ ✓ ✓ ✓ ✓ X X Bond ✓ ✓ ✓ ✓ ✓ ✓ * ✓ Amplop X X ✓ X X X ✓ Amplop Kasar X X ✓ X X X ✓ Letterhead ✓ ✓ ✓ ✓ ✓ ✓ * ✓ Pracetak ✓ ✓ ✓ ✓ ✓ ✓ * ✓ Kertas warna ✓ ✓ ✓ ✓ ✓ ✓ * ✓ Kertas ringan ✓ ✓ ✓ ✓ ✓ ✓ * ✓ Kertas berat ✓ ✓ ✓ ✓ ✓ X X Katun kasar ✓ ✓ ✓ ✓ ✓ X X Jenis kustom ✓ ✓ ✓ ✓ ✓ ✓ * ✓ Jenis kertas yang didukung oleh keranjang output (plus penyalur kertas dengan opsi lipatan) Ukuran kertas Penyalur kertas dengan opsi lipatan + Lis lubang stapler Penyalur kertas dengan opsi lipatan + Lis buklet Keranjang standar (Keranjang atas finisher) Keranjang 1 (Lis lubang stapler, keranjang ofset) Keranjang 2 (Keranjang penyalur kertas) Keranjang standar (Keranjang atas finisher) Keranjang 1 (Lis lubang stapler, keranjang ofset) Keranjang 2 (Keranjang lis buklet) Keranjang 3 (Keranjang penyalur kertas) *  Panjang maksimal dari ukuran kertas universal pada kertas banner adalah 1320.8 mm/52 inci. Hanya masukkan satu lembar kertas banner pada satu pencetakan. Plain paper ✓ ✓ ✓ ✓ ✓ ✓ ✓ Card stock ✓ ✓ ✓ ✓ ✓ X ✓ Daur ulang ✓ ✓ ✓ ✓ ✓ ✓ ✓ Glossy ✓ ✓ ✓ ✓ ✓ ✓ ✓ Heavy Glossy ✓ ✓ ✓ ✓ ✓ X ✓ Label ✓ ✓ ✓ ✓ ✓ X ✓ Label vinil ✓ ✓ ✓ ✓ ✓ X ✓ Bond ✓ ✓ ✓ ✓ ✓ ✓ ✓ Amplop X X ✓ X X X ✓ Amplop Kasar X X ✓ X X X ✓ Letterhead ✓ ✓ ✓ ✓ ✓ X ✓ Pracetak ✓ ✓ ✓ ✓ ✓ X ✓ Kertas warna ✓ ✓ ✓ ✓ ✓ ✓ ✓ Kertas ringan ✓ ✓ ✓ ✓ ✓ ✓ ✓ Kertas berat ✓ ✓ ✓ ✓ ✓ X X Katun kasar ✓ ✓ ✓ ✓ ✓ X X Jenis kustom ✓ ✓ ✓ ✓ ✓ ✓ * ✓ Jenis kertas yang didukung oleh penyalur kertas dengan opsi lipatan, penumpuk ofset, lis stapler Ukuran kertas Penyalur kertas dengan opsi lipatan Penumpuk ofset Lis stapler Plain paper ✓ ✓ ✓ Card stock ✓ ✓ ✓ Daur ulang ✓ ✓ ✓ Glossy ✓ ✓ ✓ Heavy Glossy ✓ ✓ ✓ Label ✓ ✓ ✓ Label vinil ✓ ✓ ✓ Bond ✓ ✓ ✓ Amplop ✓ ✓ ✓ Amplop Kasar ✓ ✓ ✓ Letterhead ✓ ✓ ✓ Pracetak ✓ ✓ ✓ Kertas warna ✓ ✓ ✓ Kertas ringan ✓ ✓ ✓ Kertas berat ✓ ✓ ✓ Katun kasar ✓ ✓ ✓ Jenis kustom ✓ ✓ ✓ Jenis kertas yang didukung oleh lis lubang stapler dan lis buklet Ukuran kertas Keranjang atas finisher (Keranjang standar) Keranjang lis stapler (Keranjang 1) Ofset Lis lubang Stapler Lipatan Ofset Lis lubang Stapler Lipatan Plain paper X ✓ X ✓ ✓ ✓ ✓ ✓ Card stock X X X X ✓ X X X Daur ulang X ✓ X ✓ ✓ ✓ ✓ ✓ Glossy X ✓ X ✓ ✓ ✓ ✓ ✓ Heavy Glossy X X X X ✓ X X X Label X X X X ✓ X X X Label vinil X X X X ✓ X X X Bond X ✓ X ✓ ✓ ✓ ✓ ✓ Letterhead X ✓ X ✓ ✓ ✓ ✓ ✓ Pracetak X ✓ X ✓ ✓ ✓ ✓ ✓ Kertas warna X ✓ X ✓ ✓ ✓ ✓ ✓ Kertas ringan X ✓ X ✓ ✓ ✓ ✓ ✓ Kertas berat X X X X ✓ X X X Katun kasar X ✓ X X ✓ ✓ X X Jenis kustom X ✓ X ✓ ✓ ✓ ✓ ✓ jenis kertas yang didukung jenis kertas didukung"},{"UUID":"344e9d4b-1791-469a-99c8-39192ca6de59","title":"Dukungan dan fitur tambahan printer","link":"supported-applications-topic.html","desc":"Aplikasi yang didukung Aplikasi dan","descFull":"Aplikasi yang didukung Aplikasi dan model printer yang didukung Aplikasi Model printer Scan Center CX833, CX961, CX962, CX963, XC8355, XC9635, XC9645, XC9655 Kustomisasi Tampilan CX833, CX961, CX962, CX963, XC8355, XC9635, XC9645, XC9655 Dukungan Pelanggan XC8355, XC9635, XC9645, XC9655 Kuota Perangkat XC8355, XC9635, XC9645, XC9655 aplikasi printer aplikasi prainstal"},{"UUID":"5c9abf96-db9b-42ad-a14a-f62d48633598","title":"Dukungan dan fitur tambahan printer","link":"supported-applications-topic.html","desc":"Flash drive dan jenis file","descFull":"Flash drive dan jenis file yang didukung Flash drive Flash drive yang mendukung USB 2.0 ke bawah. Flash drive yang mendukung sistem file NTFS (New Technology File System) atau FAT32 (File Allocation Table). Jenis file Jenis file yang didukung Dokumen Gambar PDF (versi 1.7 ke bawah) Format file Microsoft (DOC, DOCX, XLS, XLSX, PPT, PPTX) JPEG atau JPG TIFF atau TIF GIF BMP PNG PCX DCX flash drive yang didukung jenis file yang didukung"},{"UUID":"c93b80a5-71c8-4dda-bbba-70bf1122587e","title":"Dukungan dan fitur tambahan printer","link":"supported-applications-topic.html","desc":"Opsi internal yang tersedia Hard","descFull":"Opsi internal yang tersedia Hard disk Fitur berlisensi IPDS Kode Batang Lexmark  Internal solutions port (ISP) RS‑232C Serial Card MarkNet  N8230 Fiber Ethernet 100BASE-FX(LC), 1000BASE-SX(LC) Internal solutions port (ISP) opsi internal kartu firmware hard disk"},{"UUID":"7303bc14-2169-4465-b41f-b2f684b63266","title":"Menyiapkan, menginstal, dan mengatur","link":"selecting-location-printer-topic.html","desc":"Memilih lokasi printer Pastikan printer","descFull":"Memilih lokasi printer Pastikan printer memiliki ruang yang cukup untuk membuka baki, tutup, dan pintu, juga untuk memasang perangkat keras. Siapkan printer di dekat stopkontak listrik. Untuk menghindari risiko kebakaran atau tersengat listrik, sambungkan kabel daya ke stopkontak listrik yang sudah diinspeksi standar mutunya dan dihubungkan ke arde di dekat produk dan mudah dijangkau. Untuk mencegah risiko sengatan listrik, jangan menempatkan atau memakai produk ini di dekat lokasi yang basah atau berair. Pastikan aliran udara di ruangan tersebut memenuhi standar ASHRAE 62 versi terbaru, atau standar CEN Technical Committee 156. Sediakan permukaan yang rata, kokoh, dan stabil. Pastikan printer senantiasa dalam kondisi: Bersih, kering, dan bebas debu. Jauh dari kawat jepret dan penjepit kertas. Jauh dari aliran udara pendingin ruangan, penghangat ruangan, atau jendela ventilasi. Bebas dari sinar matahari langsung maupun lembap ekstrem. Perhatikan suhu ruangan yang direkomendasikan, serta hindari adanya fluktuasi suhu ruangan: Suhu yang direkomendasikan Suhu ruangan Suhu penyimpanan Beri ruangan bagi printer untuk ventilasi yang cukup: Rekomendasi ruangan di sekitar printer 1 Atas 2 Belakang 3 Sisi kanan 4 Depan 5 Sisi kiri printer memilih lokasi untuk memilih lokasi untuk printer printer pembersihan minimal memindah printer"},{"UUID":"dd8eee7e-2c7f-402a-a48e-f3def7e453c5","title":"Menyiapkan, menginstal, dan mengatur","link":"printer-ports-topic.html","desc":"Port printer Untuk mencegah risiko","descFull":"Port printer Untuk mencegah risiko sengatan listrik, jangan menyiapkan produk ini atau membuat sambungan kabel atau listrik apa pun, seperti kabel daya, faks, atau telepon ketika terjadi badai petir. Untuk menghindari risiko kebakaran atau tersengat listrik, sambungkan kabel daya ke stopkontak listrik yang sudah diinspeksi standar mutunya dan dihubungkan ke arde di dekat produk dan mudah dijangkau. Untuk mencegah risiko kebakaran atau sengatan listrik, hanya gunakan kabel daya yang disediakan bersama dengan produk ini atau produk pengganti yang disahkan oleh pembuat. Untuk mengurangi risiko kebakaran, hanya gunakan kabel telekomunikasi (RJ-11) ukuran 26 AWG atau yang lebih besar ketika menghubungkan produk ini ke jaringan telepon umum bersaklar. Untuk pengguna di Australia, kabel tersebut harus disetujui oleh Otoritas Media dan Komunikasi Australia. Untuk mencegah kehilangan data atau kerusakan printer, jangan sentuh kabel USB, adaptor jaringan nirkabel, atau printer di area yang ditunjukkan ketika mencetak. Soket dan port printer serta fungsinya Port printer Fungsi 1 Port opsi atau finisher Menyambungkan printer ke finisher atau opsi. 2 Port USB Menyambungkan keyboard atau opsi lain yang kompatibel. 3 Port LINE Hanya tersedia ketika kartu faks dipasang. Hubungkan printer ke saluran telepon aktif melalui suatu soket telepon dinding (RJ-11), filter DSL, adaptor VoIP, atau adaptor lain yang dengannya Anda bisa mengakses saluran telepon untuk mengirim dan menerima pesan. 4 Port EXT Hanya tersedia ketika kartu faks dipasang. Menghubungkan beberapa perangkat (telepon atau mesin penjawab) ke printer dan saluran telepon. Gunakan port ini jika Anda tidak memiliki saluran faks khusus bagi printer tersebut, dan jika sambungannya tidak didukung di negara atau kawasan Anda. 5 port printer USB Menghubungkan printer ke komputer. 6 Port Ethernet Menghubungkan printer ke suatu jaringan. 7 Soket kabel daya Menhubungkan printer ke stopkontak yang dibumikan. port printer Port USB Port Ethernet soket kabel daya"},{"UUID":"8fcd7282-33bb-4c82-80d5-6e29245ac837","title":"Mengatur aplikasi dan solusi","link":"setting-up-scan-center-topic.html","desc":"Menyiapkan Scan Center Dari panel","descFull":"Menyiapkan Scan Center Dari panel kontrol, pilih  Scan Center . Pilih dan buat tujuan, lalu atur setelan. Hanya destinasi yang dibuat dari Embedded Web Server yang disimpan. Untuk informasi lebih lanjut, lihat dokumen yang menyertai solusi tersebut. Pindai dokumen. Scan Center menyiapkan"},{"UUID":"a324bd60-7d36-43d2-84ac-76b7e689e01a","title":"Mengatur aplikasi dan solusi","link":"setting-up-scan-center-topic.html","desc":"Menggunakan Display Customization Menggunakan Display","descFull":"Menggunakan Display Customization Menggunakan Display Customization Pastikan setelan Screen Saver, Slideshow, dan Wallpaper diaktifkan dari Embedded Web Server. Buka  Apps (Aplikasi) Display Customization (Kustomisasi Tampilan) Configure (Atur) . Mengelola gambar slide show dan screen saver Pada bagian Gambar Slideshow dan Screen Saver, tambah, edit, atau hapus gambar. Anda bisa menambah hingga 10 gambar. Ketika diaktifkan, ikon status akan muncul di screen saver hanya ketika terdapat pemberitahuan berbasis cloud, peringatan, atau eror. Terapkan perubahan. Mengganti gambar wallpaper Dari panel kontrol, pilih  Change Wallpaper (Mengganti Wallpaper) . Pilih gambar yang akan dipakai. Terapkan perubahan. Menjalankan slide show dari flash drive Masukkan flash drive ke port USB. Dari panel kontrol, pilih  Slideshow .. Anda bisa melepas flash drive setelah slide show dimulai, tetapi gambar tidak tersimpan di printer. Jika slide show berhenti, masukkan lagi flash drive untuk melihat gambar. Kustomisasi Tampilan menggunakan menyesuaikan tampilan mengganti wallpaper menjalankan slideshow mengelola screen saver"},{"UUID":"a91072b7-686e-45b2-8e6c-fdef18bff2c6","title":"Mengatur aplikasi dan solusi","link":"setting-up-scan-center-topic.html","desc":"Mengatur penanda Membuat penanda Buka","descFull":"Mengatur penanda Membuat penanda Buka peramban web, kemudian tulis alamat IP printer di kolom alamat. Lihat alamat IP printer di layar beranda printer. Alamat IP muncul dalam empat set angka yang dipisahkan oleh titik, seperti 123.123.123.123. Jika Anda menggunakan proxy, nonaktifkan proxy tersebut untuk memuat halaman web dengan benar. Klika  Bookmarks (Penanda) Add Bookmark (Tambah Penanda) , lalu tulis nama penanda. Pilih satu jenis protokol  Address (Alamat) , dan lakukan salah satu hal berikut: Untuk HTTP dan HTTPS, tulis URL yang ingin Anda tandai. Untuk HTTPS, pastikan Anda memakai nama host, bukan alamat IP. Misal, tulis  myWebsite.com/sample.pdf  bukan  123.﻿123.123.123/sample.pdf . Pastikan nama host sesuai dengan nilai Common Name (CN) di sertifikat server. Untuk informasi tentang cara memperoleh nilai CN di sertifikat server, lihat informasi bantuan di peramban web Anda. Untuk FTP, tulis alamat FTP. Misal,  myServer/myDirectory . Masukkan nomor port FTP. Port 21 adalah port default untuk mengirim perintah. Untuk SMB, tulis alamat folder jaringan. Misal,  myServer/myShare/myFile.pdf . Tulis nama domain jaringan. Jika perlu, pilih jenis  Authentication (Otentikasi)  FTP dan SMB. Untuk membatasi akses ke penanda, masukkan PIN. Aplikasi ini mendukung beberapa jenis file berikut: PDF, JPEG, dan TIFF. Jenis file lain, seperti DOCX dan XLSX juga didukung di beberapa model printer. Klik  Save (Simpan) . Membuat folder Buka peramban web, kemudian tulis alamat IP printer di kolom alamat. Lihat alamat IP printer di layar beranda printer. Alamat IP muncul dalam empat set angka yang dipisahkan oleh titik, seperti 123.123.123.123. Jika Anda menggunakan proxy, nonaktifkan proxy tersebut untuk memuat halaman web dengan benar. Klik  Bookmarks (Penanda) Add Folder (Tambah Folder) , lalu tulis nama folder. Untuk membatasi akses terhadap folder tersebut, masukkan PIN. Klik  Save (Simpan) . penanda membuat membuat penanda"},{"UUID":"91befc32-3a1f-4bb3-ad65-e8c91d1f1b89","title":"Mengatur aplikasi dan solusi","link":"setting-up-scan-center-topic.html","desc":"Mengatur Buku Alamat Menambah kontak","descFull":"Mengatur Buku Alamat Menambah kontak Buka peramban web, kemudian tulis alamat IP printer di kolom alamat. Lihat alamat IP printer di layar beranda printer. Alamat IP muncul dalam empat set angka yang dipisahkan oleh titik, seperti 123.123.123.123. Jika Anda menggunakan proxy, nonaktifkan proxy tersebut untuk memuat halaman web dengan benar. Klik  Address Book (Buku Alamat) , lalu klik  Add Contact (Tambah Kontak) . Jika perlu, tentukan metode login untuk mengizinkan akses aplikasi. Klik  Save (Simpan) . Menambah grup Buka peramban web, kemudian tulis alamat IP printer di kolom alamat. Lihat alamat IP printer di layar beranda printer. Alamat IP muncul dalam empat set angka yang dipisahkan oleh titik, seperti 123.123.123.123. Jika Anda menggunakan proxy, nonaktifkan proxy tersebut untuk memuat halaman web dengan benar. Klik  Address Book (Buku Alamat) , lalu klik  Add Contact (Tambah Kontak) . Anda bisa menambah satu kontak atau lebih ke dalam grup. Klik  Save (Simpan) . menambah kontak menambah grup Buku Alamat"},{"UUID":"70c0e0fb-8ac7-4910-b263-40869441a049","title":"Menyiapkan dan menggunakan fitur aksesibilitas","link":"activating-voice-guidance-topic.html","desc":"Mengaktifkan Voice Guidance Dari layar","descFull":"Mengaktifkan Voice Guidance Dari layar awal Dalam satu gerakan dan dengan satu jari, usap perlahan ke kiri lalu ke atas pada tampilan sampai Anda mendengar pesan suara. Dengan dua jari, sentuh  OK . Jika sekadar gestur tidak berfungsi, gunakan sedikit tekanan. Dari keyboard Tekan dan tahan tombol  5  sampai Anda mendengar pesan suara. Tekan  Tab  untuk memindah kursor fokus ke tombol OK, lalu tekan  Enter . Jika Voice Guidance diaktifkan, selalu gunakan dua jari untuk memilih item pada tampilan. Voice Guidance (Panduan Suara) memiliki dukungan bahasa yang terbatas. Panduan Suara mengaktifkan mengaktifkan Voice Guidance"},{"UUID":"9ec8ace6-119f-47bb-89e7-4dd338b4ae73","title":"Menyiapkan dan menggunakan fitur aksesibilitas","link":"activating-voice-guidance-topic.html","desc":"Menonaktifkan Voice Guidance Dalam satu","descFull":"Menonaktifkan Voice Guidance Dalam satu gerakan dan dengan satu jari, usap perlahan ke kiri lalu ke atas pada tampilan sampai Anda mendengar pesan suara. Gunakan dua jari, lakukan hal-hal berikut: Pilih  Voice Guidance (Panduan Suara) , lalu pilih  OK . Pilih  Cancel (Batalkan) . Jika sekadar gestur tidak berfungsi, gunakan sedikit tekanan. Menekan tombol daya atau menjadikan printer dalam mode Tidur atau Hibernasi juga akan menonaktifkan Voice Guidance (Panduan Suara). Panduan Suara menonaktifkan menonaktifkan Voice Guidance"},{"UUID":"d646e7e1-bff0-4622-b502-70599001a4b5","title":"Menyiapkan dan menggunakan fitur aksesibilitas","link":"activating-voice-guidance-topic.html","desc":"Menavigasi layar dengan gestur Sebagian","descFull":"Menavigasi layar dengan gestur Sebagian besar gestur hanya tersedia ketika Voice Guidance diaktifkan. Gunakan kibor fisik untuk menulis karakter dan menyesuaikan setelan tertentu. Gestur dan fungsinya Gestur Fungsi Usap ke kiri lalu ke atas dengan satu jari Luncurkan atau mode keluar Aksesibilitas Gestur ini juga tersedia ketika printer dalam mode normal. Ketuk ganda dengan satu jari. Memilih satu opsi atau item pada layar. Ketuk ganda pada ikon beranda dengan dua jari. Menonaktifkan mode Aksesibilitas. Ketuk tiga kali dengan satu jari. Memperbesar atau memperkecil teks dan gambar. Mengaktifkan mode Magnifikasi untuk menggunakan fitur zoom. Usap ke kanan atau usap ke bawah dengan satu jari Berpindah ke item selanjutnya pada layar. Usap ke kiri atau usap ke atas dengan satu jari Berpindah ke item sebelumnya pada layar. Usap ke atas lalu ke bawah dengan satu jari Berpindah ke item pertama pada layar. Geser Mengakses bagian dari gambar yang diperbesar melebihi batas layar. Gunakan dua jari untuk menarik gambar yang diperbesar. Mengaktifkan Magnifikasi untuk menggunakan gestur geser. Usap ke atas lalu ke kanan dengan satu jari Meningkatkan volume. Gestur ini juga tersedia ketika printer dalam mode normal. Usap ke bawah lalu ke kanan dengan satu jari Menurunkan volume. Gestur ini juga tersedia ketika printer dalam mode normal. Usap ke atas lalu ke kiri dengan satu jari Keluar dari aplikasi dan kembali ke layar awal. Usap ke bawah lalu ke kiri dengan satu jari Kembali ke setelan sebelumnya. menavigasi layar menggunakan gestur gestur layar sentuh gestur layar"},{"UUID":"bffbcabd-df7d-426b-928c-08920855045d","title":"Menyiapkan dan menggunakan fitur aksesibilitas","link":"activating-voice-guidance-topic.html","desc":"Menggunakan keyboard on-screen Saat keyboard","descFull":"Menggunakan keyboard on-screen Saat keyboard on-screen muncul, lakukan satu atau beberapa hal berikut: Sentuh satu tombol untuk mengumumkan dan mengetik karakter di kolom tersebut. Tarik jari ke beberapa karakter yang berbeda untuk mengumumkan dan mengetik karakter di kolom tersebut. Sentuh satu kotak teks dengan dua jari untuk mengumumkan karakter di kolom tersebut. Sentuh  Backspace (Spasi mundur)  untuk menghapus karakter. keyboard on-screen menggunakan"},{"UUID":"ea2a28b5-e088-42ec-bf38-d1a02838f00a","title":"Menyiapkan dan menggunakan fitur aksesibilitas","link":"activating-voice-guidance-topic.html","desc":"Mengaktifkan mode Magnifikasi Dalam satu","descFull":"Mengaktifkan mode Magnifikasi Dalam satu gerakan dan dengan satu jari, usap perlahan ke kiri lalu ke atas pada tampilan sampai Anda mendengar pesan suara. Untuk model printer yang tidak memiliki speaker bawaan, gunakan headphone untuk mendengar pesan. Gunakan dua jari, lakukan hal-hal berikut: Sentuh  Magnification mode (Mode magnifikasi) . Sentuh  OK . Jika sekadar gestur tidak berfungsi, gunakan sedikit tekanan. Untuk informasi lebih lanjut tentang navigasi layar magnifikasi, lihat  . mode magnifikasi mengaktifkan mengaktifkan mode magnifikasi"},{"UUID":"459f8af1-dffe-437d-9b63-df95380ffb04","title":"Menyiapkan dan menggunakan fitur aksesibilitas","link":"activating-voice-guidance-topic.html","desc":"Menyesuaikan kecepatan bicara Voice Guidance","descFull":"Menyesuaikan kecepatan bicara Voice Guidance (Panduan Suara) Dari panel kontrol, buka  Settings (Setelan) Device (Perangkat) Accessibility (Aksesibilitas) Speech Rate (Kecepatan Bicara) . Pilih kecepatan bicara. Panduan Suara menyesuaikan kecepatan bicara menyesuaikan kecepatan bicara Panduan Suara menyesuaikan kecepatan bicara Panduan Suara"},{"UUID":"067c090d-c9e1-4dd8-882f-6ad8cb369d63","title":"Menyiapkan dan menggunakan fitur aksesibilitas","link":"activating-voice-guidance-topic.html","desc":"Menyesuaikan volume default headphone Dari","descFull":"Menyesuaikan volume default headphone Dari panel kontrol, buka  Settings (Setelan) Device (Perangkat) Accessibility (Aksesibilitas) . Sesuaikan volume headphone. Volume akan disetel ulang ke nilai default setelah pengguna keluar dari mode Aksesibilitas atau ketika printer bangun dari mode Sleep (Tidur) atau Hibernate (Hibernasi). volume headphone, menyesuaikan menyesuaikan volume headphone"},{"UUID":"d0719bac-f0a3-4ca8-8fc0-14f0beea9bee","title":"Menyiapkan dan menggunakan fitur aksesibilitas","link":"activating-voice-guidance-topic.html","desc":"Menyesuaikan volume default speaker internal","descFull":"Menyesuaikan volume default speaker internal Dari panel kontrol, usap ke kanan untuk membuka pusat kontrol. Sesuaikan volume. Apabila Mode Sunyi diaktifkan, suara pemberitahuan dinonaktifkan. Setelan ini juga akan memperlambat kinerja printer. Volume akan disetel ulang ke nilai default setelah pengguna keluar dari mode Aksesibilitas atau ketika printer bangun dari mode Tidur atau Hibernasi. volume speaker menyesuaikan menyesuaikan volume speaker"},{"UUID":"735f6180-c677-4956-8a26-ea8e3dd0ad0f","title":"Menyiapkan dan menggunakan fitur aksesibilitas","link":"activating-voice-guidance-topic.html","desc":"Mengaktifkan kata sandi atau PIN","descFull":"Mengaktifkan kata sandi atau PIN berbicara Dari panel kontrol, buka  Settings (Setelan) Device (Perangkat) Accessibility (Aksesibilitas) Speak Passwords/PINs (Kata Sandi/PIN Berbicara) . Mengaktifkan setelan. kata sandi berbicara mengaktifkan nomor identifikasi pribadi mengaktifkan"},{"UUID":"d241e326-9ec0-437f-9279-556a6c8472b3","title":"Menyiapkan printer untuk mengirim/menerima faks","link":"setting-up-printer-to-fax-group.html","desc":"Menyetel fungsi faks dengan faks","descFull":"Menyetel fungsi faks dengan faks analog Menyetel fungsi faks dengan faks analog Kartu faks harus dipasang supaya printer bisa memakai faks analog. Beberapa cara untuk menghubungkan printer dengan faks analog hanya tersedia di beberapa negara atau kawasan. Jika fungsi faks diaktifkan dan tidak disiapkan secara penuh, lampu indikator akan berkedip merah. Jika Anda tidak memiliki lingkungan TCP/IP, gunakan panel kontrol untuk menyiapkan faks. Untuk mencegah kehilangan data atau kerusakan printer, jangan sentuh kabel atau printer di area tersebut ketika sedang mengirim atau menerima faks. Menggunakan panel kontrol Dari panel kontrol, buka  Settings (Setelan) Fax (Faks) Fax Setup (Penyiapan Faks) General Fax Settings (Setelan Faks Umum) . Atur setelan. Menggunakan Embedded Web Server Buka peramban web, kemudian tulis alamat IP printer di kolom alamat. Lihat alamat IP printer di panel kontrol. Alamat IP muncul dalam empat set angka yang dipisahkan oleh titik, seperti 123.123.123.123. Jika Anda menggunakan proxy, nonaktifkan proxy tersebut untuk memuat halaman web dengan benar. Klik  Setelan Faks Penyiapan Faks Setelan Faks Umum . Atur setelan. Terapkan perubahan. faks analog menyiapkan menyiapkan faks analog"},{"UUID":"93b1a187-5739-4c1e-b1d6-1841d9bc69ec","title":"Menyiapkan printer untuk mengirim/menerima faks","link":"setting-up-printer-to-fax-group.html","desc":"Menyiapkan fungsi faks dengan etherFAX","descFull":"Menyiapkan fungsi faks dengan etherFAX Menyiapkan fungsi faks dengan etherFAX Firmware printer harus diperbarui ke versi terbaru. Informasi lebih lanjut, lihat bagian “Update firmware (Perbarui firmware)”. Paket lisensi yang tepat harus terinstal di printer Anda. Untuk informasi lebih lanjut, hubungi etherFAX. Pastikan Anda telah mendaftarkan printer Anda ke portal etherFAX. Untuk informasi lebih lanjut, kunjungi   https://www.etherfax.net/lexmark  . Diperlukan nomor seri printer untuk registrasi. Untuk informasi lebih lanjut, lihat  . Buka peramban web, kemudian tulis alamat IP printer di kolom alamat. Lihat alamat IP printer di panel kontrol. Alamat IP muncul dalam empat set angka yang dipisahkan oleh titik, seperti 123.123.123.123. Jika Anda menggunakan proxy, nonaktifkan proxy tersebut untuk memuat halaman web dengan benar. Klik  Setelan Faks Penyiapan Faks Setelan Faks Umum . Fax Setup (Penyiapan Faks)  hanya muncul apabila  Fax Mode (Mode Faks)  disetel ke posisi  Fax (Faks) . Pada kolom Fax Name (Nama Faks), tulis satu nama unik. Pada kolom Fax Number (Nomor Faks), masukkan nomor faks yang disediakan oleh etherFAX. Dari menu  Fax Transport (Transportasi Faks) , pilih  etherFAX . Menu ini hanya muncul ketika tersedia lebih dari satu transportasi faks. Jika printer hanya terinstal etherFAX, ia akan otomatis terkonfigurasi. Terapkan perubahan. etherFAX menyiapkan fungsi faks menyiapkan fungsi faks menggunakan etherFAX"},{"UUID":"e0c33ac8-064c-4720-9044-1dda9f2487ff","title":"Menyiapkan printer untuk mengirim/menerima faks","link":"setting-up-printer-to-fax-group.html","desc":"Menyiapkan fungsi faks menggunakan server","descFull":"Menyiapkan fungsi faks menggunakan server faks Dengan fitur ini, Anda bisa mengirim faks ke penyedia layanan faks yang mendukung penerimaan email. Fitur ini hanya mendukung pesan faks keluar. Untuk mendukung penerimaan faks, pastikan Anda memiliki faks berbasis perangkat, seperti faks analog, etherFAX, atau Fax over IP (FoIP), yang dikonfigurasi di printer Anda. Buka peramban web, kemudian tulis alamat IP printer di kolom alamat. Lihat alamat IP printer di panel kontrol. Alamat IP muncul dalam empat set angka yang dipisahkan oleh titik, seperti 123.123.123.123. Jika Anda menggunakan proxy, nonaktifkan proxy tersebut untuk memuat halaman web dengan benar. Klik  Settings (Setelan)  Faks  . Dari menu  Fax Mode (Mode Faks),  pilih  Fax Server (Server Faks) , lalu klik  Save (Simpan). . Klik  Fax Server Setup (Penyiapan Server Faks) . Pada kolom  To Format,  tulis  [#]@myfax.com , di mana  [#]  adalah nomor faks dan  myfax.com  adalah domain penyedia faks. Jika perlu, konfigurasi Alamat Balasan, Subjek, atau bidang Pesan. Agar printer dapat menerima pesan faks, aktifkan pengaturan penerimaan faks berbasis perangkat. Pastikan faks berbasis perangkat Anda telah dikonfigurasi. Klik  Save (Simpan) . Klik  Fax Server Email Settings (Setelan Email Server Faks) , lalu aktifkan  Use Email SMTP Server (Gunakan Server SMTP Email) . Jika setelan belum diatur, lihat  . Terapkan perubahan. server faks, menggunakan menyiapkan fungsi faks menyiapkan fungsi faks dengan server faks"},{"UUID":"7afce1f3-e9a4-41d8-a66d-7ab5bae137a4","title":"Menyiapkan printer untuk mengirim/menerima faks","link":"setting-up-printer-to-fax-group.html","desc":"Menyetel faks dengan saluran telepon","descFull":"Menyetel faks dengan saluran telepon standar. Menyetel faks dengan saluran telepon standar. Instruksi ini hanya berlaku pada printer dengan kartu faks. Untuk mencegah risiko sengatan listrik, jangan menyiapkan produk ini atau membuat sambungan kabel atau listrik apa pun, seperti kabel daya, faks, atau telepon ketika terjadi badai petir. Untuk mencegah risiko sengatan listrik, jangan menggunakan fitur faks selama badai petir. Untuk mengurangi risiko kebakaran, hanya gunakan kabel telekomunikasi (RJ-11) ukuran 26 AWG atau yang lebih besar ketika menghubungkan produk ini ke jaringan telepon umum bersaklar. Untuk pengguna di Australia, kabel tersebut harus disetujui oleh Otoritas Media dan Komunikasi Australia. Penyiapan 1: Printer tersambung ke saluran faks khusus Sambungkan ujung kabel telepon ke port line printer. Sambungkan ujung kabel lainnya ke soket telepon analog yang aktif. Anda bisa menyetel printer untuk menerima faks secara otomatis (setel  Auto Answer (Jawab Otomatis)  ke  On (Aktif) ) atau secara manual (setel  Auto Answer (Jawab Otomatis)  ke  Off (Nonaktif) ). Jika Anda ingin menerima faks secara otomatis, setel printer untuk bekerja setelah berdering selama sekian kali. Penyiapan 2: Printer berbagi saluran dengan mesin penjawab Jika Anda berlangganan dengan layanan dering khusus, pastikan Anda menyetel pola dering yang benar untuk printer. Kalau tidak, printer tidak akan menerima faks meskipun Anda telah menyetelnya untuk bisa menerima faks secara otomatis. Tersambung ke soket telepon yang sama Sambungkan ujung kabel telepon ke port line printer. Sambungkan ujung kabel lainnya ke soket telepon analog yang aktif. Sambungkan mesin penjawab dengan port telepon yang ada di printer. Tersambung ke soket telepon dinding yang berbeda Sambungkan ujung kabel telepon ke port line printer. Sambungkan ujung kabel lainnya ke soket telepon analog yang aktif. Jika hanya ada satu nomor di saluran telepon Anda, setel printer untuk menerima faks secara otomatis. Setel printer untuk mengangkat panggilan pada dering kedua setelah mesin penjawab. Misal, jika mesin penjawab mengangkat panggilan pada dering keempat, atur setelan printer  Rings to Answer (Dering untuk Menjawab)  ke  6 . menyiapkan faks menggunakan saluran telepon standar penyiapan faks menggunakan saluran telepon standar mesin penjawab menyiapkan"},{"UUID":"3096cec4-d2eb-4036-b67a-9c240fc2f102","title":"Menyiapkan printer untuk mengirim/menerima faks","link":"setting-up-printer-to-fax-group.html","desc":"Menyiapkan faks di negara atau","descFull":"Menyiapkan faks di negara atau kawasan dengan colokan dan soket telepon dinding yang berbeda Menyiapkan faks di negara atau kawasan dengan colokan dan soket telepon dinding yang berbeda Instruksi ini hanya berlaku pada printer dengan kartu faks. Untuk mencegah risiko sengatan listrik, jangan menyiapkan produk ini atau membuat sambungan kabel atau listrik apa pun, seperti kabel daya, faks, atau telepon ketika terjadi badai petir. Untuk mencegah risiko sengatan listrik, jangan menggunakan fitur faks selama badai petir. Untuk mengurangi risiko kebakaran, hanya gunakan kabel telekomunikasi (RJ-11) ukuran 26 AWG atau yang lebih besar ketika menghubungkan produk ini ke jaringan telepon umum bersaklar. Untuk pengguna di Australia, kabel tersebut harus disetujui oleh Otoritas Media dan Komunikasi Australia. Soket telepon dinding standar yang dipakai di sebagian besar negara atau kawasan adalah RJ-11. Jika soket telepon atau peralatan di tempat Anda tidak kompatibel dengan jenis sambungan ini, gunakan adaptor telepon. Kemasan printer tidak menyertakan adaptor di negara atau kawasan Anda, sehingga Anda harus membelinya secara terpisah. Hanya saja, printer telah memiliki colokan adaptor di port telepon. Jangan melepas colokan adaptor dari port telepon printer Anda jika Anda hendak membuat sambungan dengan sistem telepon kaskade atau ser. Nomor suku cadang colokan adaptor Nama suku cadang Nomor suku cadang Colokan adaptor Lexmark 40X8519 Menyambungkan printer ke soket telepon non-RJ-11 Sambungkan ujung kabel telepon ke port line printer. Sambungkan ujung kabel lainnya ke adaptor RJ-11, lalu sambungkan adaptor ke soket telepon. Jika Anda ingin menyambungkan perangkat lain dengan konektor non-RJ-11 ke soket telepon yang sama, sambungkan secara langsung ke adaptor telepon. penyiapan faks menyiapkan faks"},{"UUID":"5805c4ce-a31d-4966-a0f1-93b1ae24265d","title":"Menyiapkan printer untuk mengirim/menerima faks","link":"setting-up-printer-to-fax-group.html","desc":"Menyambungkan ke layanan dering khusus","descFull":"Menyambungkan ke layanan dering khusus Dengan layanan dering khusus, Anda bisa memiliki beberapa nomor telepon di satu saluran telepon. Masing-masing nomor telepon akan memiliki pola dering yang berbeda. Dari panel kontrol, buka  Settings (Setelan) Fax (Faks) Fax Setup (Penyiapan Faks) Fax Receive Settings (Setelan Terima Faks) Admin Controls (Kontrol Admin) Answer On (Jawab Aktif) . Pilih satu pola dering. layanan dering khusus menyambungkan ke layanan dering khusus menetapkan nada dering pada printer"},{"UUID":"f8ec90b2-345b-490c-b23b-10b0ee5a7fde","title":"Menyiapkan printer untuk mengirim/menerima faks","link":"setting-up-printer-to-fax-group.html","desc":"Menyetel waktu dan tanggal faks","descFull":"Menyetel waktu dan tanggal faks Menyetel waktu dan tanggal faks Dari panel kontrol, buka  Settings (Setelan) Device (Perangkat) Preferences (Preferensi) Date and Time (Tanggal dan Waktu) Configure (Atur) . Atur setelan. mengirim/menerima faks menyetel waktu dan tanggal tanggal dan waktu setelan faks"},{"UUID":"15150251-481d-43aa-b9d9-7adc051d7e10","title":"Menyiapkan printer untuk mengirim/menerima faks","link":"setting-up-printer-to-fax-group.html","desc":"Mengonfigurasi pergeseran waktu siang hari","descFull":"Mengonfigurasi pergeseran waktu siang hari Dari panel kontrol, buka  Settings (Setelan) Device (Perangkat) Preferences (Preferensi) Date and Time (Tanggal dan Waktu) Configure (Atur) . Pada menu  Time Zone (Zona Waktu) , pilih  (UTC+user) Custom . Pada menu  Configure (Atur) , pilih  UTC Offset . Atur setelan. mengonfigurasi pergeseran waktu siang hari pergeseran waktu siang hari mengatur"},{"UUID":"c9fc3b52-2da9-4013-9502-6940083773c7","title":"Menyiapkan printer untuk mengirim/menerima faks","link":"setting-up-printer-to-fax-group.html","desc":"Mengonfigurasi setelan speaker faks Dari","descFull":"Mengonfigurasi setelan speaker faks Dari panel kontrol, buka  Settings (Setelan) Fax (Faks) Fax Setup (Penyiapan Faks) Speaker Settings (Setelan Speaker) . Lakukan hal-hal berikut: Setel  Speaker Mode (Mode Speaker)  ke  Always On (Selalu Aktif) . Setel  Speaker Volume (Volume Speaker)  ke  High (Tinggi) . Aktifkan  Ringer Volume (Volume Dering) . mengatur setelan speaker faks speaker faks mengatur setelan"},{"UUID":"5ef476a1-a315-4d12-abea-381552f7d5f0","title":"Memasukkan kertas dan media khusus","link":"loading-trays-group.html","desc":"Menyetel ukuran dan jenis media","descFull":"Menyetel ukuran dan jenis media khusus. Menyetel ukuran dan jenis media khusus. Untuk media khusus seperti label, stok kartu, atau amplop, lakukan cara berikut: Dari panel kontrol, buka  Settings (Setelan) Paper (Kertas) Tray Configuration (Konfigurasi Baki) Paper Size/Type (Ukuran/Jenis Kertas) . Pilih satu sumber kertas, lalu setel ukuran dan jenis media khusus. menyetel ukuran kertas menyetel jenis kertas"},{"UUID":"609740b0-c49b-47c3-8101-ce4cceb657ae","title":"Memasukkan kertas dan media khusus","link":"loading-trays-group.html","desc":"Mengatur setelan kertas Universal Mengatur","descFull":"Mengatur setelan kertas Universal Mengatur setelan kertas Universal Dengan menu  Universal Setup (Penyiapan Universal),  Anda bisa menyetel lebar dan tinggi kertas yang belum ada di setelan awal printer Anda. Dari panel kontrol, buka  Settings (Setelan) Paper (Kertas) Media Configuration (Konfigurasi Media) Universal Setup (Penyiapan Universal) . Pilih  All Input Trays (Semua Baki Input) , lalu atur setelan ukuran kartu yang ingin Anda sesuaikan. menyetel ukuran kertas menyesuaikan ukuran kertas"},{"UUID":"6bb3d204-debb-482d-bd62-0e99055b1886","title":"Memasukkan kertas dan media khusus","link":"loading-trays-group.html","desc":"Memasang baki 550 lembar Guna","descFull":"Memasang baki 550 lembar Guna mengurangi risiko ketidakstabilan alat, masukkan baki secara terpisah. Biarkan baki lain tetap tertutup hingga diperlukan. Buka baki. Untuk mencegah kertas macet, jangan melepas baki ketika printer sedang sibuk. Sesuaikan pembatas dengan ukuran kertas yang Anda masukkan. Gunakan indikator di bawah baki untuk menempatkan pembatas. Kertas yang sudah dilubangi hanya didukung di baki 550 lembar (standar). Kertas A3 hanya didukung di baki 550 lembar (opsional). Fleksibelkan, angin-anginkan, serta ratakan tepi kertas sebelum memasukkan. Masukkan tumpukan kertas dengan sisi cetak menghadap ke atas. Jangan menyelipkan kertas ke baki. Pastikan pembatas sisi menempel rata pada tepi kertas. Pastikan tinggi tumpukan di bawah indikator pengisian kertas maksimum. Mengisi secara berlebih dapat menyebabkan kemacetan kertas. Masukkan baki. Jika perlu, setel ukuran dan jenis kertas agar sesuai dengan yang dimasukkan ke baki. Jika finisher dipasang, halaman-halaman tersebut akan dirotasi 180° ketika dicetak. Ketika memasukkan letterhead, lakukan salah satu di bawah ini: Tanpa finisher Dengan finisher Satu sisi, pencetakan tepi panjang Satu sisi, pencetakan tepi panjang Satu sisi, pencetakan tepi pendek Satu sisi, pencetakan tepi pendek Dua sisi, pencetakan tepi panjang Dua sisi, pencetakan tepi panjang Dua sisi, pencetakan tepi pendek Dua sisi, pencetakan tepi pendek Ketika memasukkan kertas yang sudah dilubangi, lakukan salah satu di bawah ini: Tanpa finisher opsional Dengan finisher opsional Satu sisi, pencetakan tepi panjang Satu sisi, pencetakan tepi panjang Satu sisi, pencetakan tepi pendek Satu sisi, pencetakan tepi pendek Dua sisi, pencetakan tepi panjang Dua sisi, pencetakan tepi panjang Dua sisi, pencetakan tepi pendek Dua sisi, pencetakan tepi pendek Baki 550 lembar memasukkan mengisi baki 550 lembar mengisi beberapa baki"},{"UUID":"d63a67f9-d5ab-41b9-b088-5f4be892e1df","title":"Memasukkan kertas dan media khusus","link":"loading-trays-group.html","desc":"Mengisi baki tandem 2000 lembar","descFull":"Mengisi baki tandem 2000 lembar Guna mengurangi risiko ketidakstabilan alat, masukkan baki secara terpisah. Biarkan baki lain tetap tertutup hingga diperlukan. Buka baki. Untuk mencegah kertas macet, jangan mengeluarkan baki ketika printer sedang sibuk. Fleksibelkan, angin-anginkan, serta ratakan tepi kertas sebelum memasukkan. Masukkan tumpukan kertas ke baki kanan dengan sisi cetak menghadap ke atas. Jangan menyelipkan kertas ke baki. Pastikan tinggi tumpukan di bawah indikator pengisian kertas maksimum. Mengisi secara berlebih dapat menyebabkan kemacetan kertas. Masukkan baki kanan ke dalam printer. Masukkan tumpukan kertas ke baki kiri dengan sisi cetak menghadap ke atas. Masukkan baki. Jika perlu, setel ukuran dan jenis kertas agar sesuai dengan yang dimasukkan ke baki. Jika finisher dipasang, halaman-halaman tersebut akan dirotasi 180° ketika dicetak. Ketika memasukkan kertas letterhead untuk pencetakan satu sisi, masukkan dengan sisi cetak menghadap ke atas dengan header ke arah depan baki. Ketika memasukkan kertas letterhead untuk pencetakan dua sisi, masukkan dengan sisi cetak menghadap ke bawah dengan header ke arah depan baki. Baki tandem 2000 lembar memasukkan mengisi baki tandem 2000 lembar mengisi beberapa baki"},{"UUID":"b4de17bb-6b20-45fc-ae3a-f6da96236b0b","title":"Memasukkan kertas dan media khusus","link":"loading-trays-group.html","desc":"Memasang baki 1500 lembar Guna","descFull":"Memasang baki 1500 lembar Guna mengurangi risiko ketidakstabilan alat, masukkan baki secara terpisah. Biarkan baki lain tetap tertutup hingga diperlukan. Buka pintu K. Untuk mencegah kertas macet, jangan melepas baki ketika printer sedang sibuk. Fleksibelkan, angin-anginkan, serta ratakan tepi kertas sebelum memasukkan. Masukkan tumpukan kertas dengan sisi cetak menghadap ke bawah. Jangan menyelipkan kertas ke baki. Pastikan tinggi tumpukan di bawah indikator pengisian kertas maksimum. Mengisi secara berlebih dapat menyebabkan kemacetan kertas. Tutup pintu K. Jika perlu, setel ukuran dan jenis kertas agar sesuai dengan yang dimasukkan ke baki. Ketika memasukkan kertas letterhead untuk pencetakan satu sisi, masukkan dengan sisi cetak menghadap ke bawah dan header ke arah belakang printer. Ketika memasukkan kertas letterhead untuk pencetakan dua sisi, masukkan dengan sisi cetak menghadap ke atas dengan header ke arah belakang printer. Ketika memasukkan ukuran kertas yang berbeda, pastikan Anda menyesuaikan pembatas. Lakukan hal-hal berikut: Dengan obeng minus, lepas sekrup dari pembatas kertas. Lepas pembatas kertas. Sesuaikan pembatas kertas dengan ukuran kertas yang Anda masukkan. Pasang sekrup di pembatas kertas. Baki 1500 lembar memasukkan mengisi baki"},{"UUID":"a1564a5e-c33d-41c9-a0d4-8e4a8995399b","title":"Memasukkan kertas dan media khusus","link":"loading-trays-group.html","desc":"Mengisi pengumpan serba guna Buka","descFull":"Mengisi pengumpan serba guna Buka pengumpan serba guna. Sesuaikan pembatas sisi dengan ukuran kertas yang Anda masukkan. Fleksibelkan, angin-anginkan, serta ratakan tepi kertas sebelum memasukkan. Masukkan kertas. Pastikan pembatas sisi menempel rata pada tepi kertas. Ketika memasukkan letterhead, lakukan salah satu di bawah ini: Tanpa finisher Dengan finisher Satu sisi, pencetakan tepi panjang Satu sisi, pencetakan tepi panjang Dua sisi, pencetakan tepi panjang Dua sisi, pencetakan tepi panjang Ketika memasukkan kertas yang sudah dilubangi, lakukan salah satu di bawah ini: Tanpa finisher Dengan finisher Satu sisi, pencetakan tepi panjang Satu sisi, pencetakan tepi panjang Dua sisi, pencetakan tepi panjang Dua sisi, pencetakan tepi panjang Untuk amplop Masukkan amplop dengan penutupnya menghadap atas ke arah belakang printer. Masukkan amplop Eropa dengan penutupnya menghadap atas dan menjadi bagian yang pertama masuk di feeder multiguna. Jika finisher sudah dipasang, printer akan membalik halaman 180°. memasukkan kertas di pengumpan serba guna memuat kop surat memasukkan kertas yang sudah dilubangi"},{"UUID":"b7363182-2bc1-4039-b2a6-d98b3df8de3a","title":"Memasukkan kertas dan media khusus","link":"loading-trays-group.html","desc":"Menyambung baki Buka peramban web,","descFull":"Menyambung baki Buka peramban web, kemudian tulis alamat IP printer di kolom alamat. Lihat alamat IP printer di layar beranda printer. Alamat IP muncul dalam empat set angka yang dipisahkan oleh titik, seperti 123.123.123.123. Jika Anda menggunakan proxy, nonaktifkan proxy tersebut untuk memuat halaman web dengan benar. Klik  Settings (Setelan) Paper (Kertas) Tray Configuration (Konfigurasi Baki) . Setel agar ukuran kertas dan jenis kertas pada baki yang hendak Anda sambungkan adalah sama. Pastikan Anda memasukkan kertas di baki-baki yang telah disambung dengan orientasi yang sama. Simpan setelan. Klik  Settings (Setelan) Device (Perangkat) Maintenance (Perawatan) Configuration Menu (Menu Konfigurasi) Tray Configuration (Konfigurasi Baki) . Setel  Tray Linking (Penyambungan Baki)  ke  Automatic (Otomatis) . Simpan setelan. Untuk memutus sambungan baki, pastikan tidak ada baki dengan setelan jenis dan ukuran kertas yang sama. Suhu fuser akan berbeda-beda tergantung jenis kertas yang ditentukan. Untuk menghindari masalah pencetakan, sesuaikan setelan jenis kertas di printer dengan kertas yang dimasukkan di baki. melepas sambungan baki menyambung baki penyambungan baki melepas tautan baki"},{"UUID":"1da00b96-838e-4db6-9f7a-6850f6ef7ea7","title":"Menginstal dan memperbarui perangkat lunak, driver, dan firmware","link":"installing-printer-software-topic.html","desc":"Menginstal perangkat lunak printer Driver","descFull":"Menginstal perangkat lunak printer Driver cetak disertakan dalam paket installer perangkat lunak. Untuk komputer Macintosh dengan MacOS versi 10.7 atau lebih baru, Anda tidak perlu menginstal driver untuk mencetak di printer bersertifikasi AirPrint. Jika Anda menginginkan fitur pencetakan kustom, unduh driver cetak tersebut. Dapatkan salinan paket installer perangkat lunak. Dari CD perangkat lunak yang disertakan bersama printer Anda. Buka  www.lexmark.com/downloads . Buka  www.dell.com/support/printers . Dari situs web kami atau tempat Anda membeli printer. Jalankan installer, lalu ikuti instruksi pada layar komputer. menginstal perangkat lunak printer perangkat lunak printer menginstal menginstal driver cetak driver cetak menginstal"},{"UUID":"2348a866-9838-4698-bbf2-2ebf184c89ea","title":"Menginstal dan memperbarui perangkat lunak, driver, dan firmware","link":"installing-printer-software-topic.html","desc":"Menginstal driver faks Buka ","descFull":"Menginstal driver faks Buka  www.lexmark.com/downloads , cari model printer Anda, lalu unduh paket installer yang sesuai. Kunjungi situs web kami atau tempat Anda membeli printer, lalu dapatkan paket installer yang sesuai. Buka  www.dell.com/support , kemudian unduh paket installer yang sesuai. Dari komputer Anda, klik  Properti Printer , kemudian buka tab  Konfigurasi . Jalankan installer, lalu ikuti instruksi pada layar komputer. Pilih  Faks , lalu klik  Terapkan . driver faks menginstal menginstal driver faks"},{"UUID":"511be7d7-ca22-4cf2-a1ab-b8e59943c929","title":"Menginstal dan memperbarui perangkat lunak, driver, dan firmware","link":"installing-printer-software-topic.html","desc":"Menambah printer ke komputer Sebelum","descFull":"Menambah printer ke komputer Sebelum Anda mulai, lakukan salah satu di bawah ini: Hubungkan printer dan komputer ke jaringan yang sama. Untuk informasi lebih lanjut tentang menghubungkan printer ke suatu jaringan, lihat  . Hubungkan komputer ke printer. Untuk informasi lebih lanjut, lihat  . Hubungkan printer ke komputer dengan kabel USB. Untuk informasi lebih lanjut, lihat  . Kabel USB dijual terpisah. Untuk pengguna Windows Menginstal driver printer di komputer. Untuk informasi lebih lanjut, lihat  . Buka  Printers & scanners (Printer & pemindai) , lalu klik  Add a printer or scanner (Tambah printer atau pemindai) . Sesuai dengan sambungan printer Anda, lakukan salah satu di bawah ini: Pilih printer dari daftar, kemudian klik  Add device (Tambah perangkat) . Klik  Show Wi-Fi Direct printers (Tampilkan printer Wi-Fi Direct) , pilih printer, kemudian klik  Add device (Tambah perangkat) . Klik  The printer that I want isn’t listed (Printer yang saya ingin tidak terdaftar) , kemudian dari jendela  Add Printer (Tambah Printer) , lakukan sebagai berikut: Pilih  Add a printer using an IP address or hostname (Tambah printer dengan alamat IP atau nama host) , lalu klik  Next (Selanjutnya) . Pada kolom jenis Perangkat, pilih  TCP/IP Device . Pada kolom nama host atau alamat IP, tulis alamat IP printer, lalu klik  Next (Selanjutnya) . Lihat alamat IP printer di layar beranda printer. Alamat IP muncul dalam empat set angka yang dipisahkan oleh titik, seperti 123.123.123.123. Jika Anda menggunakan proxy, nonaktifkan proxy tersebut untuk memuat halaman web dengan benar. Pilih driver printer, kemudian klik  Berikutnya . Pilih  Use the driver that is currently installed (recommended) , lalu klik  Next (Selanjutnya) . Tulis nama printer, kemudian klik  Berikutnya . Klik  Finish (Selesai) . Untuk pengguna Macintosh Buka  Printers & Scanners (Printer & Pemindai) . Klik  Add Printer, Scanner, or Fax (Tambah Printer, Pemindai, atau Faks) , lalu pilih printer. Dari menu  Add Printer (Tambah Printer),  pilih driver printer. Untuk menggunakan driver printer Macintosh, pilih salah satu antara  AirPrint  atau  Secure AirPrint . Jika Anda menginginkan fitur cetak bebas, pilih driver Lexmark Print. Untuk menginstal driver, lihat  . Jika Anda menginginkan fitur cetak bebas, pilih driver printer pembuat. Untuk menginstal driver, lihat  . Tambah printer. menambah printer ke komputer"},{"UUID":"7b1081f2-02c4-446a-b0e2-cde0b5e55174","title":"Menginstal dan memperbarui perangkat lunak, driver, dan firmware","link":"installing-printer-software-topic.html","desc":"Mengekspor file konfigurasi Buka peramban","descFull":"Mengekspor file konfigurasi Buka peramban web, kemudian tulis alamat IP printer di kolom alamat. Lihat alamat IP printer di layar beranda printer. Alamat IP muncul dalam empat set angka yang dipisahkan oleh titik, seperti 123.123.123.123. Jika Anda menggunakan proxy, nonaktifkan proxy tersebut untuk memuat halaman web dengan benar. Dari Embedded Web Server, klik  Export Configuration (Ekspor Konfigurasi) . Pilih konfigurasi yang akan diekspor. Tergantung konfigurasi yang Anda pilih, file bisa diekspor ke dalam format ZIP atau CSV. mengekspor file konfigurasi file konfigurasi mengekspor"},{"UUID":"bc721dae-d5c8-4a9d-842e-7730712e2e3c","title":"Menginstal dan memperbarui perangkat lunak, driver, dan firmware","link":"installing-printer-software-topic.html","desc":"Mengimpor file konfigurasi Buka peramban","descFull":"Mengimpor file konfigurasi Buka peramban web, kemudian tulis alamat IP printer di kolom alamat. Lihat alamat IP printer di layar beranda printer. Alamat IP muncul dalam empat set angka yang dipisahkan oleh titik, seperti 123.123.123.123. Jika Anda menggunakan proxy, nonaktifkan proxy tersebut untuk memuat halaman web dengan benar. Dari Embedded Web Server, klik  Import Configuration (Impor Konfigurasi) . Cari lokasi file tersebut disimpan. File bisa disimpan dalam format ZIP atau CSV. Klik  Import (Impor) . mengimpor file konfigurasi file konfigurasi mengimpor"},{"UUID":"ddc7e1a1-cb00-4b1b-9058-201f0ba336ef","title":"Menginstal dan memperbarui perangkat lunak, driver, dan firmware","link":"installing-printer-software-topic.html","desc":"Menambah opsi pada driver printer","descFull":"Menambah opsi pada driver printer Untuk pengguna Windows Buka folder printer. Pilih printer yang ingin Anda perbarui dan lakukan salah satu hal di bawah ini: Untuk Windows 7 atau setelahnya, pilih  Printer properties (Properti Printer) . Untuk versi sebelumnya, pilih  Properties (Properti) . Buka tab  Configuration (Konfigurasi),  lalu pilih  Update Now ‑ Ask Printer (Perbarui Sekarang - Tanya Printer) . Terapkan perubahan. Untuk pengguna Macintosh Buka  Printers & Scanners (Printer & Pemindai) . Klik  Add Printer, Scanner, or Fax (Tambah Printer, Pemindai, atau Faks) , lalu pilih printer. Pilih driver printer. Terapkan perubahan. menambah opsi perangkat keras di driver cetak driver cetak menambah opsi perangkat keras"},{"UUID":"3cd51560-172a-4604-ba65-73c2d25964dd","title":"Memperbarui firmware","link":"installing-printer-software-topic.html","desc":"Memperbarui firmware dengan panel kontrol","descFull":"Memperbarui firmware dengan panel kontrol Menggunakan pusat pemberitahuan Cara ini hanya bisa diterapkan di beberapa model printer. Dari panel kontro, buka pusat pemberitahuan, lalu pilih  Firmware update available (Pembaruan firmware tersedia) . Pilih  Install now (Instal sekarang) . Printer akan otomatis memulai ulang setelah pembaruan selesai. Menggunakan menu Setelan Dari panel kontrol, buka  Settings (Setelan) Device (Perangkat) Update Firmware (Perbarui Firmware) . Tergantung model printer Anda, pilih  Check for updates (Periksa pembaruan)  atau  Check for updates now (Periksa pembaruan sekarang) . Jika ada pembaruan, pilih  Install now (Instal sekarang) . Printer akan otomatis memulai ulang setelah pembaruan selesai. memperbarui firmware menggunakan panel kontrol firmware, memperbarui menggunakan panel kontrol"},{"UUID":"7f6fbf63-c73e-4c61-8a52-c88ad65626bb","title":"Memperbarui firmware","link":"installing-printer-software-topic.html","desc":"Memperbarui firmware dengan Embedded Web","descFull":"Memperbarui firmware dengan Embedded Web Server Sebelum mulai, pastikan bahwa: Anda sudah mendownload firmware printer yang paling baru dari  https://support.lexmark.com  dan menyimpannya di flash drive atau komputer. Untuk menggunakan firmware printer itu, ekstrak file firmware FLS dari file ZIP tersebut. Anda sudah mendownload perangkat lunak printer yang paling baru dan menyimpannya di flash drive atau komputer. Untuk informasi lebih lanjut, hubungi tempat di mana Anda membeli printer tersebut. Anda sudah mendownload perangkat lunak printer yang paling baru dan menyimpannya di flash drive atau komputer. Untuk informasi lebih lanjut, hubungi penyalur Anda. Anda tidak sedang memakai kode khusus pada printer supaya tidak kehilangan fungsionalitas. Pastikan bahwa semua printer yang mendapat pembaruan firmware dalam posisi aktif selama proses pembaruan firmware. Menonaktifkan printer selama pembaruan firmware dapat menyebabkan kerusakan parah. Jika printer tersambung ke jaringan ketika memeriksa pembaruan, Anda tidak perlu mendownload firmware terlebih dahulu. Buka peramban web, kemudian tulis alamat IP printer di kolom alamat. Lihat alamat IP printer di layar beranda printer. Alamat IP muncul dalam empat set angka yang dipisahkan oleh titik, seperti 123.123.123.123. Jika Anda menggunakan proxy, nonaktifkan proxy tersebut untuk memuat halaman web dengan benar. Klik  Device (Perangkat) . Gulir ke bawah, lalu klik  Update Firmware (Perbarui Firmware) . Tergantung model printer Anda, klik  Check for updates (Periksa pembaruan)  atau  Check for updates now (Periksa pembaruan sekarang) . Jika ada pembaruan, klik  I agree, start update (Saya setuju, mulai pembaruan) . Printer akan otomatis memulai ulang setelah pembaruan selesai. memperbarui firmware menggunakan Embedded Web Server firmware, memperbarui menggunakan Embedded Web Server"},{"UUID":"8b3a6c78-ee68-4d98-9bd2-8e2876e24423","title":"Menginstal opsi perangkat keras","link":"installing-optional-550-sheet-tray-topic.html","desc":"Memasang baki 550 lembar (opsional)","descFull":"Memasang baki 550 lembar (opsional) Untuk menghindari risiko sengatan listrik, jika Anda mengakses papan kontroler atau memasang perangkat keras atau perangkat memori opsional, ada kalanya setelah menyiapkan printer, Anda harus menonaktifkan printer terlebih dahulu, yaitu dengan melepas kabel daya dari stopkontak listrik. Jika Anda memiliki perangkat lain yang terpasang dengan printer, matikan terlebih dahulu, dan lepas kabel yang tersambung ke printer. Pekerjaan ini memerlukan obeng minus. Nonaktifkan printer. Lepas kabel daya dari stopkontak listrik, lalu dari printer. Buka kemasan baki 550 lembar (opsional) Untuk mencegah kerusakan baki, pastikan Anda menahan sisi depan dan belakang ketika mengangkatnya. Pasang pintu baki kanan. Tarik baki 550 lembar bagian dalam. Lepas pintu baki bagian atas. Lepas sekrup. Pasang pintu baki bagian bawah. Pasang sekrup. Pasang pintu baki bagian atas. Masukkan baki 550 lembar bagian dalam. Lepas pintu di bawah sisi kanan printer. Sejajarkan printer dengan baki 550 lembar, lalu turunkan ke tempatnya. Jika berat printer lebih dari 20 kg (44 lb), Anda memerlukan bantuan dua atau beberapa orang agar bisa mengangkatnya dengan aman. Tarik baki standar bagian dalam. Kencangkan baki 550 lembar ke printer. Masukkan baki standar bagian dalam. Kencangkan bagian belakang baki 550 lembar ke printer. Sambungkan ujung kabel daya printer ke printer, lalu ujung lainnya ke stopkontak listrik. Untuk menghindari risiko kebakaran atau tersengat listrik, sambungkan kabel daya ke stopkontak listrik yang sudah diinspeksi standar mutunya dan dihubungkan ke arde di dekat produk dan mudah dijangkau. Aktifkan printer. Tambahkan baki di driver cetak agar bisa menjalankan pekerjaan cetak. Untuk informasi lebih lanjut, lihat  . memasang baki 550 lembar Baki 550 lembar memasang opsi perangkat keras Baki 550 lembar"},{"UUID":"5642a999-ed37-4459-b4ee-b3a96c7b56e3","title":"Menginstal opsi perangkat keras","link":"installing-optional-550-sheet-tray-topic.html","desc":"Memasang 2 baki 550 lembar","descFull":"Memasang 2 baki 550 lembar Untuk menghindari risiko sengatan listrik, jika Anda mengakses papan kontroler atau memasang perangkat keras atau perangkat memori opsional, ada kalanya setelah menyiapkan printer, Anda harus menonaktifkan printer terlebih dahulu, yaitu dengan melepas kabel daya dari stopkontak listrik. Jika Anda memiliki perangkat lain yang terpasang dengan printer, matikan terlebih dahulu, dan lepas kabel yang tersambung ke printer. Opsi ini harus dipasang dengan baki 550 lembar (opsional). Pasang opsi di susunan paling bawah. Jika baki 550 lembar sudah dipasang, lepas baki tersebut, buka pintu sampingnya, buka pintu baki bagian bawah, lalu pasang baki di atas opsi ini. Pekerjaan ini memerlukan obeng minus. Nonaktifkan printer. Lepas kabel daya dari stopkontak listrik, lalu dari printer. Buka kemasan 2 baki 550 lembar, lalu keluarkan seluruh isi kemasan. Kunci kaster supaya 2 baki 550 lembar tidak bergerak. Sejajarkan baki 550 lembar dengan 2 baki 550 lembar, lalu turunkan ke tempatnya. Untuk mencegah kerusakan baki, pastikan Anda menahan sisi depan dan belakang ketika mengangkat baki. Tarik baki 550 lembar bagian dalam. Kencangkan baki 550 lembar ke 2 baki 550 lembar. Masukkan baki 550 lembar bagian dalam. Kencangkan bagian belakang baki 550 lembar ke 2 baki 550 lembar. Lepas pintu di bawah sisi kanan printer. Sejajarkan printer dengan baki opsional, lalu turunkan ke tempatnya. Jika berat printer lebih dari 20kg (44lb), Anda memerlukan bantuan dua atau beberapa orang agar bisa mengangkatnya dengan aman. Tarik baki standar bagian dalam. Kencangkan baki 550 lembar ke printer. Masukkan baki standar bagian dalam. Kencangkan bagian belakang baki 550 lembar ke printer. Sambungkan ujung kabel daya printer ke printer, lalu ujung lainnya ke stopkontak listrik. Untuk menghindari risiko kebakaran atau tersengat listrik, sambungkan kabel daya ke stopkontak listrik yang sudah diinspeksi standar mutunya dan dihubungkan ke arde di dekat produk dan mudah dijangkau. Aktifkan printer. Tambahkan baki di driver cetak agar bisa menjalankan pekerjaan cetak. Untuk informasi lebih lanjut, lihat  . 2 baki 550 lembar memasang opsi perangkat keras 2 baki 550 lembar memasang 2 baki 550 lembar"},{"UUID":"2fba4f43-bd21-4892-bbba-cd42fffc7999","title":"Menginstal opsi perangkat keras","link":"installing-optional-550-sheet-tray-topic.html","desc":"Memasang baki tandem 2000 lembar","descFull":"Memasang baki tandem 2000 lembar Memasang baki tandem 2000 lembar Untuk menghindari risiko sengatan listrik, jika Anda mengakses papan kontroler atau memasang perangkat keras atau perangkat memori opsional, ada kalanya setelah menyiapkan printer, Anda harus menonaktifkan printer terlebih dahulu, yaitu dengan melepas kabel daya dari stopkontak listrik. Jika Anda memiliki perangkat lain yang terpasang dengan printer, matikan terlebih dahulu, dan lepas kabel yang tersambung ke printer. Opsi ini harus dipasang dengan baki 550 lembar (opsional). Pasang opsi di susunan paling bawah. Jika baki 550 lembar sudah dipasang, lepas baki tersebut, buka pintu sampingnya, buka pintu baki bagian bawah, lalu pasang baki di atas opsi ini. Pekerjaan ini memerlukan obeng minus. Nonaktifkan printer. Lepas kabel daya dari stopkontak listrik, lalu dari printer. Buka kemasan baki tandem, lalu keluarkan seluruh isi kemasan. Kunci kaster supaya baki tandem tidak bergerak. D Sejajarkan baki 550 lembar dengan baki tandem, lalu turunkan ke tempatnya. Untuk mencegah kerusakan baki, pastikan Anda menahan sisi depan dan belakang ketika mengangkat baki. Tarik baki 550 lembar bagian dalam. Kencangkan baki 550 lembar ke baki tandem. Masukkan baki dalam. Kencangkan bagian belakang baki 550 lembar ke baki tandem. Lepas pintu di bawah sisi kanan printer. Sejajarkan printer dengan baki opsional, lalu turunkan ke tempatnya. Jika berat printer lebih dari 20kg (44lb), Anda memerlukan bantuan dua atau beberapa orang agar bisa mengangkatnya dengan aman. Tarik keluar baki standar. Kencangkan baki 550 lembar ke printer. Masukkan baki. Kencangkan bagian belakang baki 550 lembar ke printer. Sambungkan ujung kabel daya printer ke printer, lalu ujung lainnya ke stopkontak listrik. Untuk menghindari risiko kebakaran atau tersengat listrik, sambungkan kabel daya ke stopkontak listrik yang sudah diinspeksi standar mutunya dan dihubungkan ke arde di dekat produk dan mudah dijangkau. Aktifkan printer. Tambahkan baki di driver cetak agar bisa menjalankan pekerjaan cetak. Untuk informasi lebih lanjut, lihat  . Baki tandem 2000 lembar memasang opsi perangkat keras Baki tandem 2000 lembar memasang baki tandem 2000 lembar"},{"UUID":"25d61c09-c21b-492f-9ac7-cad7d4dfdc77","title":"Menginstal opsi perangkat keras","link":"installing-optional-550-sheet-tray-topic.html","desc":"Memasang kabinet Untuk menghindari risiko","descFull":"Memasang kabinet Untuk menghindari risiko sengatan listrik, jika Anda mengakses papan kontroler atau memasang perangkat keras atau perangkat memori opsional, ada kalanya setelah menyiapkan printer, Anda harus menonaktifkan printer terlebih dahulu, yaitu dengan melepas kabel daya dari stopkontak listrik. Jika Anda memiliki perangkat lain yang terpasang dengan printer, matikan terlebih dahulu, dan lepas kabel yang tersambung ke printer. Opsi ini harus dipasang dengan baki 550 lembar. Pasang opsi di susunan paling bawah. Jika baki 550 lembar sudah dipasang, lepas baki tersebut, buka pintu baki bagian bawah, lalu pasang baki di atas opsi ini. Pekerjaan ini memerlukan obeng minus. Buka kemasan, lalu pasang kabinet tersebut. Nonaktifkan printer. Lepas kabel daya dari stopkontak listrik, lalu dari printer. Kunci kaster supaya kabinet tidak bergerak. Pasang pintu samping baki 550 lembar. Sejajarkan baki dengan kabinet, lalu turunkan ke tempatnya. Untuk mencegah kerusakan baki, pastikan Anda menahan sisi depan dan belakang ketika mengangkatnya. Tarik baki dalam. Kencangkan baki ke kabinet. Masukkan baki dalam. Kencangkan bagian belakang baki ke kabinet. Lepas pintu di bawah sisi kanan printer. Sejajarkan printer dengan kabinet dan baki, lalu turunkan ke tempatnya. Jika berat printer lebih dari 20kg (44lb), Anda memerlukan bantuan dua atau beberapa orang agar bisa mengangkatnya dengan aman. Tarik baki standar bagian dalam. Kencangkan baki 550 lembar ke printer. Masukkan baki standar bagian dalam. Kencangkan bagian belakang baki 550 lembar ke printer. Sambungkan ujung kabel daya printer ke printer, lalu ujung lainnya ke stopkontak listrik. Untuk menghindari risiko kebakaran atau tersengat listrik, sambungkan kabel daya ke stopkontak listrik yang sudah diinspeksi standar mutunya dan dihubungkan ke arde di dekat produk dan mudah dijangkau. Aktifkan printer. berputar memasang opsi perangkat keras berputar memasang kabinet"},{"UUID":"c84f157d-9269-48ab-a9b2-6ea18ff2a9f5","title":"Menginstal opsi perangkat keras","link":"installing-optional-550-sheet-tray-topic.html","desc":"Memasang baki 1500 lembar Untuk","descFull":"Memasang baki 1500 lembar Untuk menghindari risiko sengatan listrik, jika Anda mengakses papan kontroler atau memasang perangkat keras atau perangkat memori opsional, ada kalanya setelah menyiapkan printer, Anda harus menonaktifkan printer terlebih dahulu, yaitu dengan melepas kabel daya dari stopkontak listrik. Jika Anda memiliki perangkat lain yang terpasang dengan printer, matikan terlebih dahulu, dan lepas kabel yang tersambung ke printer. Sebelum memasang opsi ini, pastikan baki 550 lembar dan salah satu dari baki duo 500 lembar atau baki 2000 lembar sudah dipasang. Pekerjaan ini memerlukan obeng minus. Nonaktifkan printer. Lepas kabel daya dari stopkontak listrik, lalu dari printer. Lepas pintu sambungan. Pintu jangan dibuang. Lepas pintu port. Pintu jangan dibuang. Lepas tutup sekrup dari printer. Tutup sekrup jangan dibuang. Buka kemasan baki 1500 lembar, lalu keluarkan seluruh isi kemasan. Pasang sekrup untuk braket pemasangan. Pasang braket pada printer. Gunakan braket dan sekrup yang disertakan dengan baki 1500 lembar. Pasang sisa sekrup. Pasang baki 1500 lembar. Sambungkan kabel baki dengan printer. Pasang tutup kabel baki. Geser baki 1500 lembar ke arah printer. Sambungkan ujung kabel daya printer ke printer, lalu ujung lainnya ke stopkontak listrik. Untuk menghindari risiko kebakaran atau tersengat listrik, sambungkan kabel daya ke stopkontak listrik yang sudah diinspeksi standar mutunya dan dihubungkan ke arde di dekat produk dan mudah dijangkau. Aktifkan printer. Tambahkan baki di driver cetak agar bisa menjalankan pekerjaan cetak. Untuk informasi lebih lanjut, lihat  . memasang baki 1500 lembar Baki 1500 lembar memasang opsi perangkat keras Baki 1500 lembar"},{"UUID":"be267a9f-1176-48a9-ba05-452b6374d35d","title":"Menginstal opsi perangkat keras","link":"installing-optional-550-sheet-tray-topic.html","desc":"Pada lis stapler Pada lis","descFull":"Pada lis stapler Pada lis stapler Untuk menghindari risiko sengatan listrik, jika Anda mengakses papan kontroler atau memasang perangkat keras atau perangkat memori opsional, ada kalanya setelah menyiapkan printer, Anda harus menonaktifkan printer terlebih dahulu, yaitu dengan melepas kabel daya dari stopkontak listrik. Jika Anda memiliki perangkat lain yang terpasang dengan printer, matikan terlebih dahulu, dan lepas kabel yang tersambung ke printer. Pekerjaan ini memerlukan obeng minus. Nonaktifkan printer. Lepas kabel daya dari stopkontak listrik, lalu dari printer. Buka kemasan lis buklet, lalu keluarkan seluruh isi kemasan. Pasang pembatas pengumpan. Lepas keranjang standar. Keranjang jangan dibuang. Sebelum memasang opsi, tempatkan bendera keranjang keluar dalam posisi tertutup. Apabila opsi telah dilepas, tempatkan bendera keranjang keluar dalam posisi terbuka. Lepas roller cadangan. Roller jangan dibuang. Masukkan roller pengumpan yang disertakan dengan lis stapler sampai ia berbunyi  klik . Pastikan pegas besi berada di depan roller pengumpan. Pasang pintu roller sampai berbunyi  klik . Buka pintu depan, lalu lepas pintu di bagian sisi kiri printer. Pintu dan sekrup jangan dibuang. Lepas pintu di sisi kiri belakang. Pintu dan sekrup jangan dibuang. Lepas pintu keranjang dalam. Pintu jangan dibuang. Sejajarkan, lalu masukkan pintu keranjang dalam yang disertakan dengan lis stapler. Pasang sekrup di pintu keranjang dalam. Pasang penggeser lis stapler. Masukkan lis stapler. Pasang braket untuk mengamankan finisher di printer. Gunakan sekrup yang disertakan dengan finisher. Pasang pintu belakang sebelah kiri, lalu geser lis stapler ke kiri. Pasang pintu pemotong atas bagian kiri yang disertakan dengan finisher. Masukkan kartrid pokok ke dalam finisher sampai berbunyi  klik  pada tempatnya. Tutup pintu depan, lalu geser finisher ke arah printer. Sambungkan kabel opsi dengan printer. Sambungkan ujung kabel daya printer ke printer, lalu ujung lainnya ke stopkontak listrik. Untuk menghindari risiko kebakaran atau tersengat listrik, sambungkan kabel daya ke stopkontak listrik yang sudah diinspeksi standar mutunya dan dihubungkan ke arde di dekat produk dan mudah dijangkau. Aktifkan printer. Tambahkan finisher di driver cetak agar bisa menjalankan pekerjaan cetak. Untuk informasi lebih lanjut, lihat  . memasang lis stapler lis stapler memasang opsi perangkat keras lis stapler"},{"UUID":"64a02385-d58d-4397-906c-1e312cfe23fd","title":"Menginstal opsi perangkat keras","link":"installing-optional-550-sheet-tray-topic.html","desc":"Memasang penumpuk ofset Memasang penumpuk","descFull":"Memasang penumpuk ofset Memasang penumpuk ofset Untuk menghindari risiko sengatan listrik, jika Anda mengakses papan kontroler atau memasang perangkat keras atau perangkat memori opsional, ada kalanya setelah menyiapkan printer, Anda harus menonaktifkan printer terlebih dahulu, yaitu dengan melepas kabel daya dari stopkontak listrik. Jika Anda memiliki perangkat lain yang terpasang dengan printer, matikan terlebih dahulu, dan lepas kabel yang tersambung ke printer. Nonaktifkan printer. Lepas kabel daya dari stopkontak listrik, lalu dari printer. Buka kemasan penumpuk ofset, lalu keluarkan seluruh isi kemasan. Pasang pintu belakang bagian dalam ke penumpuk ofset. Lepas keranjang standar. Keranjang jangan dibuang. Lepas pintu konektor penyalur kertas. Pintu jangan dibuang. Sebelum memasang opsi, tempatkan bendera keranjang keluar dalam posisi tertutup. Sejajarkan, lalu pasang penumpuk ofset di printer. Pastikan bagian itu terpasang dengan benar dan sejajar dengan printer. Pasang strip pelindung penumpuk ofset di printer. Tempatkan bendera keranjang keluar dalam posisi terbuka. Pasang pintu bendera keranjang sampai berbunyi  klik . Sambungkan ujung kabel daya printer ke printer, lalu ujung lainnya ke stopkontak listrik. Untuk menghindari risiko kebakaran atau tersengat listrik, sambungkan kabel daya ke stopkontak listrik yang sudah diinspeksi standar mutunya dan dihubungkan ke arde di dekat produk dan mudah dijangkau. Aktifkan printer. Tambahkan penumpuk ofset di driver cetak agar bisa menjalankan pekerjaan cetak. Untuk informasi lebih lanjut, lihat  . penumpuk ofset memasang memasang penumpuk ofset opsi perangkat keras memasang"},{"UUID":"5c5ce488-5e55-4094-8d0f-96c8360281eb","title":"Menginstal opsi perangkat keras","link":"installing-optional-550-sheet-tray-topic.html","desc":"Memasang penyalur kertas dengan opsi","descFull":"Memasang penyalur kertas dengan opsi lipatan Untuk menghindari risiko sengatan listrik, jika Anda mengakses papan kontroler atau memasang perangkat keras atau perangkat memori opsional, ada kalanya setelah menyiapkan printer, Anda harus menonaktifkan printer terlebih dahulu, yaitu dengan melepas kabel daya dari stopkontak listrik. Jika Anda memiliki perangkat lain yang terpasang dengan printer, matikan terlebih dahulu, dan lepas kabel yang tersambung ke printer. Opsi ini hanya bisa dipasang dengan lis lubang stapler atau lis buklet. Pekerjaan ini memerlukan obeng minus. Nonaktifkan printer. Lepas kabel daya dari stopkontak listrik, lalu dari printer. Buka kemasan penyalur kertas dengan opsi lipatan, lalu keluarkan seluruh isi kemasan. Lepas keranjang standar. Keranjang jangan dibuang. Sebelum memasang opsi, tempatkan bendera keranjang keluar dalam posisi tertutup. Apabila opsi telah dilepas, tempatkan bendera keranjang keluar dalam posisi terbuka. Lepas roller cadangan. Roller jangan dibuang. Masukkan roller pengumpan yang disertakan dengan opsi tersebut sampai ia berbunyi  klik . Pastikan pegas besi berada di depan roller pengumpan. Pasang pintu roller sampai berbunyi  klik . Buka pintu depan, lalu lepas pintu di bagian sisi kiri printer. Pintu dan sekrup jangan dibuang. Tutup pintu depan. Lepas pintu konektor penyalur kertas. Pintu jangan dibuang. Lepas pintu di sisi kiri belakang. Pintu dan sekrup jangan dibuang. Lepas pintu keranjang dalam. Pintu dan sekrup jangan dibuang. Sejajarkan, lalu masukkan penutup keranjang dalam yang disertakan dengan opsi tersebut. Pasang sekrup di pintu keranjang dalam. Pasang isolasi busa pada opsi. Buka pintu F, lalu kencangkan sekrupnya. Tutup pintu F. Pasang braket besi pada opsi. Masukkan opsi. Pastikan braket besi berada di depan printer. Buka pintu F, lalu gunakan obeng yang disertakan dengan opsi untuk memasang sekrup. Tutup pintu F. Pasang sekrup di dalam opsi. Pasang pintu belakang sebelah kiri. Buka pintu depan, lalu pasang pintu di bagian sisi kiri printer. Tutup pintu depan. Angkat penutup keranjang, lalu sejajarkan dan pasang keranjang opsi. Pasang sekrup di keranjang opsi. Pasang pintu penutupnya. Sambungkan kabel opsi dengan printer. Sambungkan ujung kabel daya printer ke printer, lalu ujung lainnya ke stopkontak listrik. Untuk menghindari risiko kebakaran atau tersengat listrik, sambungkan kabel daya ke stopkontak listrik yang sudah diinspeksi standar mutunya dan dihubungkan ke arde di dekat produk dan mudah dijangkau. Aktifkan printer. opsi perangkat keras penyalur kertas dengan opsi lipatan penyalur kertas dengan opsi lipatan memasang"},{"UUID":"8dddede7-a9ea-4b4e-bd43-956f4a364a6d","title":"Menginstal opsi perangkat keras","link":"installing-optional-550-sheet-tray-topic.html","desc":"Memasang lis lubang stapler dan","descFull":"Memasang lis lubang stapler dan opsi penyalur kertas Untuk menghindari risiko sengatan listrik, jika Anda mengakses papan kontroler atau memasang perangkat keras atau perangkat memori opsional, ada kalanya setelah menyiapkan printer, Anda harus menonaktifkan printer terlebih dahulu, yaitu dengan melepas kabel daya dari stopkontak listrik. Jika Anda memiliki perangkat lain yang terpasang dengan printer, matikan terlebih dahulu, dan lepas kabel yang tersambung ke printer. Pekerjaan ini memerlukan obeng minus. Nonaktifkan printer. Lepas kabel daya dari stopkontak listrik, lalu dari printer. Buka kemasan penyalur kertas yang baru. Lepas keranjang standar. Keranjang jangan dibuang. Sebelum memasang opsi, tempatkan bendera keranjang keluar dalam posisi tertutup. Apabila opsi telah dilepas, tempatkan bendera keranjang keluar dalam posisi terbuka. Lepas roller cadangan. Roller jangan dibuang. Masukkan roller pengumpan yang disertakan dengan penyalur kertas sampai ia berbunyi  klik . Pastikan pegas besi berada di depan roller pengumpan. Pasang pintunya sampai berbunyi  klik . Buka pintu depan, lalu lepas pintu di bagian sisi kiri printer. Pintu dan sekrup jangan dibuang. Tutup pintu depan. Lepas pintu konektor penyalur kertas. Pintu jangan dibuang. Buka pintunya. Pintu jangan dibuang. Pasang braket besi. Masukkan penyalur kertas. Buka gagang G, lalu pasang sekrup di depan penyalur kertas. Tutup gagang G. Pasang sekrup di belakang penyalur kertas. Buka pintu depan, lalu pasang pintu yang disertakan dengan penyalur kertas ke bagian sisi kiri printer. Tutup pintu depan. Buka kemasan lis lubang stapler. Pasang penyetabil. Lepas isolasi di sekeliling finisher. Pasang braket pada finisher. Pasang isolasi busa pada finisher. Pasang pembatas pengumpan pada finisher. Pasang keranjang pada finisher. Buka pintu finisher, lalu masukkan kotak lis lubang. Tempatkan keranjang ekstensi pada keranjang finisher. Keranjang ekstensi digunakan untuk kertas A3 atau yang lebih panjang dengan kondisi kelembapan tinggi guna membantu penumpukan kertas. Kapasitas keranjang akan dikurangi ketika keranjang ekstensi digunakan. Tutup pintu finisher. Pasang braket pada printer. Pastikan sekrup dalam posisi sejajar dengan penanda di braket pemasangan. Pasang braket besi yang disertakan dengan penyalur kertas pada printer. Buka pintu finisher, lepas sekrupnya, lalu tarik pengunci finisher. Pasang finisher pada printer. Kunci finisher pada printer, lalu pasang sekrupnya. Sambungkan kabel finisher dengan printer. Sambungkan ujung kabel daya printer ke printer, lalu ujung lainnya ke stopkontak listrik. Untuk menghindari risiko kebakaran atau tersengat listrik, sambungkan kabel daya ke stopkontak listrik yang sudah diinspeksi standar mutunya dan dihubungkan ke arde di dekat produk dan mudah dijangkau. Aktifkan printer. opsi perangkat keras penyalur kertas opsi perangkat keras lis lubang stapler penyalur kertas memasang lis lubang stapler memasang"},{"UUID":"d77f179a-31a3-4797-a746-cbcb592020a3","title":"Menginstal opsi perangkat keras","link":"installing-optional-550-sheet-tray-topic.html","desc":"Memasang lis lubang stapler dan","descFull":"Memasang lis lubang stapler dan penyalur kertas dengan opsi lipatan Untuk menghindari risiko sengatan listrik, jika Anda mengakses papan kontroler atau memasang perangkat keras atau perangkat memori opsional, ada kalanya setelah menyiapkan printer, Anda harus menonaktifkan printer terlebih dahulu, yaitu dengan melepas kabel daya dari stopkontak listrik. Jika Anda memiliki perangkat lain yang terpasang dengan printer, matikan terlebih dahulu, dan lepas kabel yang tersambung ke printer. Pekerjaan ini memerlukan obeng minus. Nonaktifkan printer. Lepas kabel daya dari stopkontak listrik, lalu dari printer. Buka kemasan penyalur kertas dengan opsi lipatan, lalu keluarkan seluruh isi kemasan. Lepas keranjang standar. Keranjang jangan dibuang. Sebelum memasang opsi, tempatkan bendera keranjang keluar dalam posisi tertutup. Apabila opsi telah dilepas, tempatkan bendera keranjang keluar dalam posisi terbuka. Lepas roller cadangan. Roller jangan dibuang. Masukkan roller pengumpan yang disertakan dengan opsi tersebut sampai ia berbunyi  klik . Pastikan pegas besi berada di depan roller pengumpan. Pasang pintunya sampai berbunyi  klik . Buka pintu depan, lalu lepas pintu di bagian sisi kiri printer. Pintu dan sekrup jangan dibuang. Tutup pintu depan. Lepas pintu konektor penyalur kertas. Pintu jangan dibuang. Lepas pintu di sisi kiri belakang. Pintu dan sekrup jangan dibuang. Lepas pintu keranjang dalam. Pintu dan sekrup jangan dibuang. Sejajarkan, lalu masukkan penutup keranjang dalam yang disertakan pada penyalur kertas dengan opsi lipatan. Pasang sekrup di pintu keranjang dalam. Pasang isolasi busa pada opsi. Buka pintu F, lalu kencangkan sekrupnya. Tutup pintu F. Pasang braket pada opsi. Masukkan opsi. Pastikan braket besi berada di depan printer. Buka pintu F, lalu gunakan obeng yang disertakan dengan opsi untuk memasang sekrup. Tutup pintu F. Pasang sekrup di dalam opsi. Pasang pintu belakang sebelah kiri. Buka kemasan lis lubang stapler. Pasang penyetabil. Lepas isolasi di sekeliling finisher. Pasang braket pada finisher. Pasang isolasi busa pada finisher. Lepas bagian kecil dari busa yang ada di sisi kanan finisher. Pasang pembatas pengumpan pada finisher. Pasang keranjang pada finisher. Buka pintu finisher, lalu masukkan kotak lis lubang. Tempatkan keranjang ekstensi pada keranjang finisher. Keranjang ekstensi digunakan untuk kertas A3 atau yang lebih panjang dengan kondisi kelembapan tinggi guna membantu penumpukan kertas. Kapasitas keranjang akan dikurangi ketika keranjang ekstensi digunakan. Tutup pintu finisher. Angkat penutup keranjang, lalu sejajarkan dan pasang penutup ke opsi. Pasang sekrup. Buka pintu depan, lalu pasang penutup potongan yang disertakan pada opsi. Pasang braket pada printer. Pastikan sekrup dalam posisi sejajar dengan penanda di braket pemasangan. Buka pintu finisher, lepas sekrupnya, lalu tarik pengunci finisher. Sambungkan kabel opsi dengan printer. Sambungkan kabel finisher dengan opsi. Pasang finisher pada printer. Kunci finisher pada printer, lalu pasang sekrupnya. Tutup pintu finisher. Sambungkan ujung kabel daya printer ke printer, lalu ujung lainnya ke stopkontak listrik. Untuk menghindari risiko kebakaran atau tersengat listrik, sambungkan kabel daya ke stopkontak listrik yang sudah diinspeksi standar mutunya dan dihubungkan ke arde di dekat produk dan mudah dijangkau. Aktifkan printer. opsi perangkat keras penyalur kertas dengan opsi lipatan opsi perangkat keras lis lubang stapler penyalur kertas dengan opsi lipatan memasang lis lubang stapler memasang"},{"UUID":"7a939566-88a5-418f-942f-84a557e6b47a","title":"Menginstal opsi perangkat keras","link":"installing-optional-550-sheet-tray-topic.html","desc":"Memasang lis buklet dan penyalur","descFull":"Memasang lis buklet dan penyalur kertas dengan opsi Untuk menghindari risiko sengatan listrik, jika Anda mengakses papan kontroler atau memasang perangkat keras atau perangkat memori opsional, ada kalanya setelah menyiapkan printer, Anda harus menonaktifkan printer terlebih dahulu, yaitu dengan melepas kabel daya dari stopkontak listrik. Jika Anda memiliki perangkat lain yang terpasang dengan printer, matikan terlebih dahulu, dan lepas kabel yang tersambung ke printer. Pekerjaan ini memerlukan obeng minus. Nonaktifkan printer. Lepas kabel daya dari stopkontak listrik, lalu dari printer. Buka kemasan penyalur kertas yang baru. Lepas keranjang standar. Keranjang jangan dibuang. Sebelum memasang opsi, tempatkan bendera keranjang keluar dalam posisi tertutup. Apabila opsi telah dilepas, tempatkan bendera keranjang keluar dalam posisi terbuka. Lepas roller cadangan. Roller jangan dibuang. Masukkan roller pengumpan yang disertakan dengan penyalur kertas sampai ia berbunyi  klik . Pastikan pegas besi berada di depan roller pengumpan. Pasang pintu roller sampai berbunyi  klik . Buka pintu depan, lalu lepas pintu di bagian sisi kiri printer. Pintu dan sekrup jangan dibuang. Tutup pintu depan. Lepas pintu konektor penyalur kertas. Pintu jangan dibuang. Buka pintunya. Pintu jangan dibuang. Pasang braket besi. Masukkan penyalur kertas. Buka gagang G, lalu pasang sekrup di depan penyalur kertas. Tutup gagang G. Pasang sekrup di belakang penyalur kertas. Buka pintu depan, lalu pasang pintu yang disertakan dengan penyalur kertas ke bagian sisi kiri printer. Tutup pintu depan. Buka kemasan lis buklet, lalu keluarkan seluruh isi kemasan. Pasang braket pada finisher. Pasang isolasi busa pada finisher. Pasang pembatas pengumpan pada finisher. Pasang keranjang atas pada finisher. Angkat penutup keranjang, lalu pasang penutup bawah pada finisher. Buka pintu finisher. Keluarkan isi kemasan dari kotak lis lubang, lalu masukkan ke dalam finisher. Tempatkan keranjang tambahan pada keranjang finisher. Keranjang ekstensi digunakan untuk kertas A3 atau yang lebih panjang dengan kondisi kelembapan tinggi guna membantu penumpukan kertas. Kapasitas keranjang akan dikurangi ketika keranjang ekstensi digunakan. Pasang keranjang di belakang finisher. Tutup pintu finisher. Pasang braket pada printer. Pastikan sekrup dalam posisi sejajar dengan penanda di braket pemasangan. Pasang braket yang disertakan dengan penyalur kertas pada printer. Buka pintu finisher, lepas sekrupnya, lalu tarik pengunci finisher. Pasang finisher pada printer. Kunci finisher pada printer, lalu pasang sekrupnya. Tutup pintu finisher. Sambungkan kabel finisher dengan printer. Sambungkan ujung kabel daya printer ke printer, lalu ujung lainnya ke stopkontak listrik. Untuk menghindari risiko kebakaran atau tersengat listrik, sambungkan kabel daya ke stopkontak listrik yang sudah diinspeksi standar mutunya dan dihubungkan ke arde di dekat produk dan mudah dijangkau. Aktifkan printer. memasang penyalur kertas memasang penyalur kertas memasang lis buklet memasang lis buklet"},{"UUID":"1f97a8b0-3b2f-4137-90ed-d3313abc1be4","title":"Menginstal opsi perangkat keras","link":"installing-optional-550-sheet-tray-topic.html","desc":"Memasang lis buklet dan penyalur","descFull":"Memasang lis buklet dan penyalur kertas dengan opsi lipatan Untuk menghindari risiko sengatan listrik, jika Anda mengakses papan kontroler atau memasang perangkat keras atau perangkat memori opsional, ada kalanya setelah menyiapkan printer, Anda harus menonaktifkan printer terlebih dahulu, yaitu dengan melepas kabel daya dari stopkontak listrik. Jika Anda memiliki perangkat lain yang terpasang dengan printer, matikan terlebih dahulu, dan lepas kabel yang tersambung ke printer. Pekerjaan ini memerlukan obeng minus. Nonaktifkan printer. Lepas kabel daya dari stopkontak listrik, lalu dari printer. Buka penyalur kertas dengan opsi lipatan. Lepas keranjang standar. Keranjang jangan dibuang. Sebelum memasang opsi, tempatkan bendera keranjang keluar dalam posisi tertutup. Apabila opsi telah dilepas, tempatkan bendera keranjang keluar dalam posisi terbuka. Lepas roller cadangan. Roller jangan dibuang. Masukkan roller pengumpan yang disertakan dengan opsi tersebut sampai ia berbunyi  klik . Pastikan pegas besi berada di depan roller pengumpan. Pasang pintu roller sampai berbunyi  klik . Buka pintu depan, lalu lepas pintu di bagian sisi kiri printer. Pintu dan sekrup jangan dibuang. Tutup pintu depan. Lepas pintu konektor penyalur kertas. Pintu jangan dibuang. Lepas pintu di sisi kiri belakang. Pintu dan sekrup jangan dibuang. Lepas pintu keranjang dalam. Pintu dan sekrup jangan dibuang. Sejajarkan, lalu masukkan penutup keranjang dalam yang disertakan dengan opsi tersebut. Pasang sekrup di pintu keranjang dalam. Pasang isolasi busa pada opsi. Buka pintu F, lalu kencangkan sekrupnya. Tutup pintu F. Pasang braket pada opsi. Masukkan opsi. Pastikan braket besi berada di depan printer. Buka pintu F, lalu gunakan obeng yang disertakan dengan opsi untuk memasang sekrup. Tutup pintu F. Pasang sekrup di dalam opsi. Pasang pintu belakang sebelah kiri. Buka kemasan lis buklet, lalu keluarkan seluruh isi kemasan. Pasang braket pada finisher. Pasang isolasi busa pada finisher. Pasang pembatas pengumpan pada finisher. Pasang keranjang atas pada finisher. Angkat penutup keranjang, lalu pasang penutup bawah pada finisher. Buka pintu finisher. Keluarkan isi kemasan dari kotak lis lubang, lalu masukkan ke dalam finisher. Tempatkan keranjang tambahan pada keranjang finisher. Keranjang ekstensi digunakan untuk kertas A3 atau yang lebih panjang dengan kondisi kelembapan tinggi guna membantu penumpukan kertas. Kapasitas keranjang akan dikurangi ketika keranjang ekstensi digunakan. Pasang keranjang di belakang finisher. Tutup pintu finisher. Angkat penutup keranjang, lalu sejajarkan dan pasang penutup ke opsi. Pasang sekrup. Buka pintu depan, lalu pasang penutup potongan yang disertakan pada opsi. Pasang braket pada printer. Pastikan sekrup dalam posisi sejajar dengan penanda di braket pemasangan. Buka pintu finisher, lepas sekrupnya, lalu tarik pengunci finisher. Sambungkan kabel opsi dengan printer. Sambungkan kabel finisher dengan opsi. Pasang finisher pada printer. Kunci finisher pada printer, lalu pasang sekrupnya. Tutup pintu finisher. Sambungkan ujung kabel daya printer ke printer, lalu ujung lainnya ke stopkontak listrik. Untuk menghindari risiko kebakaran atau tersengat listrik, sambungkan kabel daya ke stopkontak listrik yang sudah diinspeksi standar mutunya dan dihubungkan ke arde di dekat produk dan mudah dijangkau. Aktifkan printer. opsi perangkat keras penyalur kertas dengan opsi lipatan opsi perangkat keras lis buklet penyalur kertas dengan opsi lipatan memasang lis buklet memasang"},{"UUID":"245fcca5-4401-4149-9a83-ba2b852a6fdb","title":"Menginstal opsi perangkat keras","link":"installing-optional-550-sheet-tray-topic.html","desc":"Memasang rak kibor Nonaktifkan printer.","descFull":"Memasang rak kibor Nonaktifkan printer. Buka pintu B. Buka pintu depan, lalu tutup pintu B. Buka kemasan rak kibor. Masukkan kabel kibor ke dalam rak. Putar kabel di dalam rak. Lepas pintu berperekat. Sejajarkan, lalu pasang kibor di tempatnya. Sejajarkan rak, sambungkan kabel kibor ke printer, masukkan rak, lalu pasang ke printer. Aktifkan printer. opsi perangkat keras rak kibor rak kibor memasang memasang rak kibor"},{"UUID":"4492b0f0-2889-4f9b-bad8-7a82bccf7485","title":"Menginstal opsi perangkat keras","link":"installing-optional-550-sheet-tray-topic.html","desc":"Memasang kartu faks Untuk menghindari","descFull":"Memasang kartu faks Untuk menghindari risiko sengatan listrik, jika Anda mengakses papan kontroler atau memasang perangkat keras atau perangkat memori opsional, ada kalanya setelah menyiapkan printer, Anda harus menonaktifkan printer terlebih dahulu, yaitu dengan melepas kabel daya dari stopkontak listrik. Jika Anda memiliki perangkat lain yang terpasang dengan printer, matikan terlebih dahulu, dan lepas kabel yang tersambung ke printer. Pekerjaan ini memerlukan obeng minus. Nonaktifkan printer. Lepas kabel daya dari stopkontak listrik, lalu dari printer. Buka pintu akses menuju papan kontroler. Komponen elektronik papan kontroler bisa rusak dengan mudah akibat adanya sengatan listrik statis. Sentuh permukaan besi pada printer sebelum menyentuh konektor atau komponen elektronik lain pada papan kontroler. Lepas pintu port faks. Pintu dan sekrup jangan dibuang. Buka kemasan kartu faks. Sambungkan kabel faks dengan papan kontroler. Sejajarkan, lalu pasang kartu faks ke printer. Tutup pintu akses papan kontroler sampai berbunyi  klik  pada tempatnya, lalu pasang sekrupnya. Sambungkan ujung kabel daya printer ke printer, lalu ujung lainnya ke stopkontak listrik. Untuk menghindari risiko kebakaran atau tersengat listrik, sambungkan kabel daya ke stopkontak listrik yang sudah diinspeksi standar mutunya dan dihubungkan ke arde di dekat produk dan mudah dijangkau. Aktifkan printer. kartu faks memasang memasang opsi internal kartu faks"},{"UUID":"8b86a447-514c-44ce-b1fd-98b6ecf0ee27","title":"Menginstal opsi perangkat keras","link":"installing-optional-550-sheet-tray-topic.html","desc":"Memasang pembaca kartu Untuk menghindari","descFull":"Memasang pembaca kartu Untuk menghindari risiko sengatan listrik, jika Anda mengakses papan kontroler atau memasang perangkat keras atau perangkat memori opsional, ada kalanya setelah menyiapkan printer, Anda harus menonaktifkan printer terlebih dahulu, yaitu dengan melepas kabel daya dari stopkontak listrik. Jika Anda memiliki perangkat lain yang terpasang dengan printer, matikan terlebih dahulu, dan lepas kabel yang tersambung ke printer. Nonaktifkan printer. Buka pintu B. Buka tutup port USB depan. Lepas tutup port USB bawah. Jika printer Anda tidak memilikinya, lanjut ke langkah berikutnya. Lepas sampul pelindung dari pembaca kartu. Masukkan pembaca kartu. Pasang tutup port USB bawah sampai berbunyi  klik  pada tempatnya. Pasang pembatas stiker. Pasang tutup port USB depan sampai berbunyi  klik  pada tempatnya. Tutup pintu B sampai berbunyi  klik  pada tempatnya. Aktifkan printer. pembaca kartu memasang opsi internal pembaca kartu"},{"UUID":"f1b23041-3de5-4faa-9695-f17e8242e1ae","title":"Menginstal opsi perangkat keras","link":"installing-optional-550-sheet-tray-topic.html","desc":"Memasang port solusi internal Memasang","descFull":"Memasang port solusi internal Memasang port solusi internal Untuk menghindari risiko sengatan listrik, jika Anda mengakses papan kontroler atau memasang perangkat keras atau perangkat memori opsional, ada kalanya setelah menyiapkan printer, Anda harus menonaktifkan printer terlebih dahulu, yaitu dengan melepas kabel daya dari stopkontak listrik. Jika Anda memiliki perangkat lain yang terpasang dengan printer, matikan terlebih dahulu, dan lepas kabel yang tersambung ke printer. Pekerjaan ini memerlukan obeng minus. Nonaktifkan printer. Lepas kabel daya dari stopkontak listrik, lalu dari printer. Buka pintu akses menuju papan kontroler. Komponen elektronik papan kontroler bisa rusak dengan mudah akibat adanya sengatan listrik statis. Sentuh permukaan besi pada printer sebelum menyentuh konektor atau komponen elektronik lain pada papan kontroler. Buka pintu port solusi internal (ISP) Pintu dan sekrup jangan dibuang. Buka kemasan kit ISP. Isi kemasan ISP 1 ISP 2 Kabel ektensi ISP 3 Braket pemasangan 4 Sekrup Pasang braket pemasangan ke papan kontroler sampai berbunyi  klik  pada tempatnya. Pasang ISP ke braket pemasangan, lalu sambungkan kabel ektensi ISP ke konektornya di papan kontroler. Pasang ISP pada printer. Tutup pintu akses papan kontroler. Sambungkan ujung kabel daya printer ke printer, lalu ujung lainnya ke stopkontak listrik. Untuk menghindari risiko kebakaran atau tersengat listrik, sambungkan kabel daya ke stopkontak listrik yang sudah diinspeksi standar mutunya dan dihubungkan ke arde di dekat produk dan mudah dijangkau. Aktifkan printer. port solusi internal memasang memasang opsi port solusi internal"},{"UUID":"a53d5baa-40c0-47c5-8945-3c963acee461","title":"Menginstal opsi perangkat keras","link":"installing-optional-550-sheet-tray-topic.html","desc":"Mengubah pengaturan port printer setelah","descFull":"Mengubah pengaturan port printer setelah memasang port solusi internal Jika printer memiliki alamat IP statis, jangan ubah konfigurasinya. Jika komputer dikonfigurasi untuk menggunakan nama jaringan dan bukan alamat IP, jangan ubah konfigurasinya. Jika Anda menambahkan port solusi internal (ISP) nirkabel ke printer yang sebelumnya dikonfigurasi untuk koneksi Ethernet, putuskan sambungan printer dari jaringan Ethernet tersebut. Untuk pengguna Windows Buka folder printer. Dari menu pintasan printer dengan ISP baru, buka properti printer. Konfigurasikan port dari daftar. Perbarui alamat IP. Terapkan perubahan. Untuk pengguna Macintosh Dari Preferensi Sistem di menu Apple, buka daftar printer, lalu pilih  + IP . Ketikkan alamat IP pada bidang alamat. Terapkan perubahan. pengaturan port printer mengubah mengubah pengaturan port printer setelah memasang ISP"},{"UUID":"10809b15-be70-4eea-8143-2a6c240324d0","title":"Jaringan","link":"connecting-printer-to-wireless-network-topic.html","desc":"Menyambungkan printer ke jaringan Wi-Fi","descFull":"Menyambungkan printer ke jaringan Wi-Fi Sebelum mulai, pastikan bahwa: Acive Adapter (Adaptor Aktif)  telah disetel ke  Auto (Otomatis) . Dari panel kontrol, buka  Settings (Setelan) Network/Ports (Jaringan/Port) Network Overview (Tinjauan Jaringan) Active Adapter (Adaptor Aktif) . Kabel Ethernet tidak tersambung ke printer. Menggunakan panel kontrol Dari panel kontrol, buka  Settings (Setelan) Network/Ports (Jaringan/Port) Wireless (Nirkabel) Setup On Printer Panel (Penyiapan pada Panel Printer) Choose Network (Pilih Jaringan) . Pilih jaringan Wi-Fi, lalu tulis kata sandi jaringan. Jika Anda memakai printer dengan kapabilitas Wi-Fi bawaan, Anda akan mendapat perintah untuk menyetel jaringan Wi-Fi di penyiapan awal. menyambungkan printer ke Wi-Fi menyambungkan printer ke jaringan nirkabel jaringan nirkabel"},{"UUID":"adbec132-a2cb-41d5-bbd3-efa64d67f1be","title":"Jaringan","link":"connecting-printer-to-wireless-network-topic.html","desc":"Menyambungkan printer ke jaringan nirkabel","descFull":"Menyambungkan printer ke jaringan nirkabel dengan Wi‑Fi Protected Setup (WPS/Penyiapan Wi-Fi Terlindungi) Sebelum mulai, pastikan bahwa: Titik akses (router nirkabel) adalah WPS-certified atau WPS-compatible. Untuk informasi lebih lanjut, lihat dokumen yang menyertai titik akses Anda. Adaptor jaringan nirkabel telah dipasang di printer Anda. Untuk informasi lebih lanjut, lihat instruksi yang menyertai adaptor tersebut. Acive Adapter (Adaptor Aktif)  telah disetel ke  Auto (Otomatis) . Dari panel kontrol, buka  Settings (Setelan) Network/Ports (Jaringan/Port) Network Overview (Tinjauan Jaringan) Active Adapter (Adaptor Aktif) . Menggunakan metode Push Botton (Tekan Tombol) Dari panel kontrol, buka  Settings (Setelan) Network/Ports (Jaringan/Port) Wireless (Nirkabel) Wi‑Fi Protected Setup (Penyiapan Wi-Fi Terlindungi) Start Push Button Method (Mulai Metode Tekan Tombol) . Ikuti instruksi di tampilan. Menggunakan metode Personal Identification Number (PIN/Nomor Identifikasi Pribadi) Dari panel kontrol, buka  Settings (Setelan) Network/Ports (Jaringan/Port) Wireless (Nirkabel) Wi‑Fi Protected Setup (Penyiapan Wi-Fi Terlindungi) Start PIN Method (Mulai Metode PIN) . Salin delapan digit PIN WPS. Buka peramban web, kemudian tulis alamat IP di kolom alamat titik akses. Untuk mengetahui alamat IP, lihat dokumen yang menyertai titik akses Anda. Jika Anda menggunakan proxy, nonaktifkan proxy tersebut untuk memuat halaman web dengan benar. Buka setelan WPS. Untuk informasi lebih lanjut, lihat dokumen yang menyertai titik akses Anda. Masukkan delapan digit PIN, lalu simpan perubahan. Penyiapan Wi-Fi Terlindungi jaringan nirkabel jaringan nirkabel Penyiapan Wi-Fi Terlindungi menyambungkan ke jaringan nirkabel menggunakan metode PIN menyambungkan ke jaringan nirkabel menggunakan metode Push Botton"},{"UUID":"379865b9-73d1-4148-8c47-17f1906508cd","title":"Jaringan","link":"connecting-printer-to-wireless-network-topic.html","desc":"Mengatur Wi-Fi Direct Wi-Fi Direct","descFull":"Mengatur Wi-Fi Direct Wi-Fi Direct  memungkinkan perangkat Wi-Fi untuk terhubung secara langsung dengan perangkat lainnya tanpa titik akses (router nirkabel). Dari panel kontrol, buka  Settings (Setelan) Network/Ports (Jaringan/Port) Wi-Fi Direct . Atur setelan. Aktifkan Wi‑Fi Direct —Menjadikan printer bisa memancarkan jaringan Wi-Fi Direct-nya sendiri. Nama Wi‑Fi Direct —Menentukan satu nama untuk jaringan Wi-Fi Direct. Kata Sandi Wi‑Fi Direct —Menentukan kata sandi untuk menegosiasi keamanan nirkabel saat memakai koneksi peer-to-peer. Tampilkan Kata Sandi di Halaman Penyiapan —Menampilkan kata sandi pada Halaman Penyiapan Jaringan. Preferensi Jumlah Saluran —Menentukan saluran yang dikehendari untuk jaringan Wi‑Fi Direct. Alamat IP Pemilik Grup —Menentukan alamat IP pemilik grup. Tombol Terima Permintaan Otomatis —Memungkinkan printer untuk menerima permintaan sambungan secara otomatis. Menerima permintaan tekan tombol secara otomatis adalah tidak aman. Secara default, kata sandi jaringan Wi-Fi Direct tidak terlihat pada tampilan printer. Untuk menampilkan kata sandi, tekan ikon lihat kata sandi. Dari panel kontrol, buka  Settings (Setelan) Security (Keamanan) Miscellaneous (Lain-lain) Enable Password/PIN Reveal (Aktifkan Buka PIN/Kata Sandi) . Untuk mengetahui kata sandi jaringan Wi-Fi Direct tanpa menampilkannya di layar printer, cetak  Network Setup Page (Halaman Penyiapan Jaringan). . Dari panel kontrol, buka  Settings (Setelan) Reports (Laporan) Network (Jaringan) Network Setup Page (Halaman Penyiapan Jaringan) . Wi‑Fi Direct mengatur mengatur Wi-Fi Direct"},{"UUID":"36315837-d280-4664-b275-52a59f2f632f","title":"Jaringan","link":"connecting-printer-to-wireless-network-topic.html","desc":"Menghubungkan perangkat seluler ke printer","descFull":"Menghubungkan perangkat seluler ke printer Sebelum menghubungkan perangkat seluler Anda, pastikan Wi-Fi Direct sudah diatur. Untuk informasi lebih lanjut, lihat  . Dengan Wi-Fi Direct Instruksi ini hanya berlaku pada perangkat seluler yang berjalan di platform  Android . Dari perangkat seluler, buka menu  Settings (Setelan) . Aktifkan  Wi‑Fi , lalu ketuk  Wi‑Fi Direct . Pilih nama Wi-Fi Direct printer. Konfirmasi sambungan pada panel kontrol printer. Menggunakan Wi-Fi Dari perangkat seluler, buka menu  Settings (Setelan) . Klik  Wi-Fi , lalu pilih nama Wi-Fi Direct printer. String DIRECT-xy (x dan y adalah dua karakter acak) ditambahkan sebelum nama Wi-Fi Direct. Masukkan kata sandi Wi-Fi Direct. menyambungkan perangkat seluler ke printer menyambungkan ke printer dengan Wi-Fi Direct"},{"UUID":"cbebff43-b1f3-4e6c-a7c9-9e4657cdccc1","title":"Jaringan","link":"connecting-printer-to-wireless-network-topic.html","desc":"Wi-Fi Direct Menghubungkan komputer ke","descFull":"Wi-Fi Direct Menghubungkan komputer ke printer Sebelum menghubungkan komputer Anda, pastikan Wi-Fi Direct sudah dikonfigurasi. Untuk informasi lebih lanjut, lihat  . Untuk pengguna Windows Buka  Printers & scanners (Printer & pemindai) , lalu klik  Add a printer or scanner (Tambah printer atau pemindai) . Klik  Show Wi-Fi Direct printers (Tampilkan printer Wi-Fi Direct) , kemudian pilih nama Wi-Fi Direct printer. Dari tampilan printer, catat delapan digit PIN printer. Masukkan PIN tersebut di komputer. Jika driver printer belum diinstal, Windows akan men-download driver yang semestinya. Untuk pengguna Macintosh Klik ikon nirkabel, kemudian pilih nama Wi-Fi Direct printer. String DIRECT-xy (x dan y adalah dua karakter acak) ditambahkan sebelum nama Wi-Fi Direct. Tulis kata sandi Wi-Fi Direct. Kembalikan komputer Anda ke jaringan sebelumnya setelah melepas sambungan dari jaringan Wi-Fi Direct. menyambungkan komputer ke printer"},{"UUID":"7ae73b13-98d3-4e74-a349-c9aa926bbaa5","title":"Jaringan","link":"connecting-printer-to-wireless-network-topic.html","desc":"Menonaktifkan jaringan Wi-Fi Dari panel","descFull":"Menonaktifkan jaringan Wi-Fi Dari panel kontrol, buka  Settings (Setelan) Network/Ports (Jaringan/Port) Network Overview (Tinjauan Jaringan) Active Adapter (Adaptor Aktif) Standard Network (Jaringan Standar) . Pilih  Yes (Ya)  untuk memulai ulang printer. jaringan Wi-Fi, menonaktifkan menonaktifkan jaringan Wi-Fi"},{"UUID":"fac0c1c1-d495-4add-92a2-eb508aa36499","title":"Jaringan","link":"connecting-printer-to-wireless-network-topic.html","desc":"Memeriksa sambungan printer Memeriksa sambungan","descFull":"Memeriksa sambungan printer Memeriksa sambungan printer Dari panel kontrol, buka  Settings (Setelan) Reports (Laporan) Network (Jaringan) Network Setup Page (Halaman Penyiapan Jaringan) . Periksa bagian awal halaman tersebut, lalu pastikan bahwa statusnya tersambung. Jika statusnya tidak terhubung, LAN drop mungkin tidak aktif atau kabel jaringan bisa saja sedang tidak berfungsi. Hubungi administrator untuk bantuan. memeriksa koneksi jaringan sambungan printer ke jaringan memeriksa"},{"UUID":"dd8bfdac-ea1b-4182-871b-d6f868dab37c","title":"Jaringan","link":"connecting-printer-to-wireless-network-topic.html","desc":"Mengatur pencetakan dengan port serial","descFull":"Mengatur pencetakan dengan port serial (hanya Windows) Atur parameter dalam printer. Dari panel kontrol, buka menu pengaturan port. Cari menu pengaturan port serial, lalu sesuaikan pengaturan jika perlu. Terapkan perubahan. Dari komputer, buka folder printer, lalu pilih printer Anda. Buka properti printer, lalu pilih port COM dari daftar. Atur parameter port COM di Device Manager. Pencetakan dengan port serial menurunkan kecepatan cetak. Pastikan bahwa kabel serial telah terhubung ke port serial di printer Anda. mengatur pencetakan dengan port serial pencetakan dengan port serial menyiapkan"},{"UUID":"9915991e-26cd-4fca-95df-25274a51cda6","title":"Mengamankan printer","link":"erasing-printer-memory-topic.html","desc":"Menghapus memori printer Untuk menghapus","descFull":"Menghapus memori printer Untuk menghapus memori sementara atau data singgahan di printer, matikan printer. Untuk menghapus setelan jaringan, perangkat, dan memori tetap, juga setelan keamanan dan embedded solutions, lakukan hal-hal berikut: Dari panel kontrol, buka  Settings (Setelan) Device (Perangkat) Maintenance (Perawatan) Out of Service Erase (Penghapusan di Luar Layanan) . Pilih  Sanitize all information on hard disk (Hapus semua informasi di hard disk) , lalu pilih  ERASE (HAPUS) . Pilih  Start initial setup wizard (Mulai wizard penyiapan awal)  atau  Leave printer offline (Biarkan printer offline) , lalu pilih  Next (Selanjutnya) . Mulai prosesnya. Proses ini juga menghapus kunci enkripsi yang digunakan untuk melindungi data pengguna. Menghapus kunci enkripsi akan membuat data tidak bisa dikembalikan. memori tidak tetap menghapus memori tetap menghapus memori printer menghapus menghapus memori printer menghapus memori tidak tetap menghapus memori tetap"},{"UUID":"dd96b1e8-63b6-4477-81c2-2e5bfc5b636f","title":"Mengamankan printer","link":"erasing-printer-storage-drive-topic.html","desc":"Menghapus drive penyimpanan printer Menghapus","descFull":"Menghapus drive penyimpanan printer Menghapus drive penyimpanan printer Dari panel kontrol, buka  Settings (Setelan) Device (Perangkat) Maintenance (Perawatan) Out of Service Erase (Penghapusan di Luar Layanan) . Tergantung drive penyimpanan yang terinstal di printer Anda, lakukan salah satu langkah berikut: Untuk hard disk, pilih  Sanitize all information on hard disk (Hapus semua informasi di hard disk) , pilih  ERASE (HAPUS) , lalu pilih satu cara untuk menghapus data. Proses membersihkan hard disk bisa memakan waktu beberapa menit hingga lebih dari satu jam, sehingga printer tidak tersedia untuk pekerjaan lain. Untuk drive penyimpanan intelijen, pilih  Cryptographically erase all user data on ISD (Hapus semua data pengguna di ISD secara kriptografi) , lalu pilih  ERASE (HAPUS) . drive penyimpanan menghapus hard disk menghapus drive penyimpanan intelijen menghapus menghapus drive penyimpanan menghapus hard disk menghapus drive penyimpanan intelijen"},{"UUID":"38fe6a4b-cdbe-4f06-92db-c6e0bcf23627","title":"Mengamankan printer","link":"restoring-factory-default-settings-topic.html","desc":"Memulihkan ke setelan default pabrik","descFull":"Memulihkan ke setelan default pabrik Dari panel kontrol, buka  Settings (Setelan) Device (Perangkat) Restore Factory Defaults (Pulihkan ke Setelan Default) . Pilih  Restore Settings (Setelan Pemulihan) . Pilih setelan yang ingin Anda pulihkan, lalu pilih  RESTORE (PULIHKAN) . setelan default pabrik memulihkan setelan printer memulihkan ke setelan default pabrik"},{"UUID":"9e1ac6d0-d477-4595-b9c2-eb46184a8e96","title":"Mengamankan printer","link":"statement-of-volatility-topic.html","desc":"Pernyataan Volatilitas Pernyataan Volatilitas Jenis","descFull":"Pernyataan Volatilitas Pernyataan Volatilitas Jenis memori dan deskripsinya Jenis memori Deskripsi Memori tidak tetap Printer menggunakan Random Access Memory (RAM) standar sebagai buffer sementara bagi data pengguna selama menjalankan pekerjaan salin dan cetak sederhana. Memori tetap Printer bisa saja memakai dua jenis memori tetap: EEPROM dan NAND (memori flash). Keduanya akan menyimpan informasi jaringan, setelan printer, serta sistem operasi. Keduanya juga akan menyimpan setelan penanda, setelan pemindai, serta Embedded Solutions. Drive penyimpanan hard disk Beberapa printer bisa saja memiliki Hard Disk Drive. Hard disk printer ini didesain untuk fungsionalitas printer khusus. Dengan hard disk, printer bisa menyimpan data font, data format, dan data pengguna sementara saat melakukan pekerjaan cetak yang rumit. Intelligent storage drive (ISD/Drive penyimpanan intelijen) Beberapa printer bisa saja memiliki ISD. ISD menggunakan memori flash tetap guna menyimpan data pengguna seperti font, format, serta pekerjaan cetak yang rumit. Hapus konten yang terdapat di memori printer dalam beberapa kondisi berikut: Printer dinonaktifkan. ISD atau hard disk printer diganti. Printer dipindah ke departemen atau lokasi lain. Printer diservis oleh seseorang dari luar perusahaan. Printer dibawa keluar dari kantor Anda untuk diperbaiki. Printer dijual ke perusahaan lain. Untuk menghapus drive penyimpanan, patuhi kebijakan dan prosedur perusahaan Anda. pernyataan volatilitas memori tidak tetap Memori tetap drive penyimpanan hard disk drive penyimpanan intelijen menghapus memori printer mengamankan data printer"},{"UUID":"2ff8821d-f4f0-4932-8ac9-af1fd3574ce0","title":"Cetak","link":"printing-from-computer-topic.html","desc":"Mencetak dari komputer Untuk pengguna","descFull":"Mencetak dari komputer Untuk pengguna Windows Dengan dokumen terbuka, pilih  File Print (Cetak) . Pilih printer, lalu klik  Properties (Properti) ,  Preferences (Preferensi) ,  Options (Opsi) , atau  Setup (Penyiapan) . Jika perlu, sesuaikan setelan. Klik  OK , lalu klik  Print (Cetak) . Untuk pengguna Macintosh Dengan dokumen terbuka, pilih  File Print (Cetak) . Pilih printer, lalu pilih satu setelan dari  Presets (Setelan Awal) . Jika perlu, sesuaikan setelan. Klik  Print (Cetak) . mencetak dari komputer dokumen, mencetak dari komputer"},{"UUID":"d319d40d-1bb4-4316-b162-f3f69b82133c","title":"Mencetak dari perangkat seluler","link":"printing-from-mobile-device-using-lexmark-print-app-topic.html","desc":"Mencetak dari perangkat seluler dengan","descFull":"Mencetak dari perangkat seluler dengan Lexmark Print Lexmark  Print adalah solusi cetak seluler bagi perangkat seluler yang berjalan di versi  Android  6.0 atau setelahnya. Dengannya Anda bisa mengirim dokumen dan gambar ke printer yang tersambung ke jaringan dan server print management. Pastikan Anda mengunduh aplikasi Lexmark Print dari  Google Play  dan aktifkan aplikasi tersebut di perangkat seluler. Pastikan printer dan perangkat seluler tersambung ke jaringan yang sama. Dari perangkat seluler Anda, pilih dokumen dari pengelola berkas. Kirim atau bagikan dokumen tersebut ke Lexmark Print. Beberapa aplikasi pihak ketiga mungkin tidak mendukung untuk mengirim atau berbagi fitur. Untuk informasi lebih lanjut, lihat dokumen yang menyertai aplikasi tersebut. Pilih printer Jika perlu, sesuaikan setelan. Cetak dokumen. Lexmark Print menggunakan mencetak dokumen dari perangkat seluler perangkat seluler mencetak dari"},{"UUID":"1cff4d19-5b1b-46f3-a54c-7d7e43aadd3c","title":"Mencetak dari perangkat seluler","link":"printing-from-mobile-device-using-lexmark-print-app-topic.html","desc":"Mencetak dari perangkat seluler dengan","descFull":"Mencetak dari perangkat seluler dengan Mopria™ Print Service Mopria Print Service solusi pencetakan seluler yang berjalan di  Android  versi 5.0 atau sesudahnya. Dengannya Anda bisa mencetak secara langsung di printer bersertifikasi Mopria™. Pastikan Anda sudah mendownload Mopria Print Service dari  Google Play  dan mengaktifkannya di perangkat seluler Anda. Dari perangkat seluler Anda, buka aplikasi yang kompatibel atau pilih dokumen dari pengelola berkas Anda. Ketuk  Cetak . Pilih printer, kemudian sesuaikan setelan, jika perlu. Ketuk  . Mopria Print Service mencetak dari perangkat seluler perangkat seluler mencetak dari mencetak menggunakan Mopria Print Service"},{"UUID":"29e191ec-bfd0-44be-90e9-23c0c30fe4b4","title":"Mencetak dari perangkat seluler","link":"printing-from-mobile-device-using-lexmark-print-app-topic.html","desc":"Mencetak dari perangkat seluler dengan","descFull":"Mencetak dari perangkat seluler dengan AirPrint Fitur perangkat lunak AirPrint adalah solusi cetak seluler yang memungkinkan Anda mencetak secara langsung dari perangkat Apple ke printer bersertifikasi AirPrint. Pastikan perangkat Apple dan printer terhubung ke jaringan yang sama. Jika jaringan memiliki lebih dari satu hub, pastikan kedua perangkat terhubung ke subnet yang sama. Aplikasi ini hanya didukung di beberapa perangkat Apple. Dari perangkat seluler Anda, pilih dokumen dari pengelola berkas atau buka aplikasi yang kompatibel. Ketuk  Cetak . Pilih printer, kemudian sesuaikan setelan, jika perlu. Cetak dokumen. menggunakan AirPrint mencetak dari perangkat seluler perangkat seluler mencetak dari"},{"UUID":"a8469498-3cd3-4b35-9b69-f20c9989b3cd","title":"Mencetak dari perangkat seluler","link":"printing-from-mobile-device-using-lexmark-print-app-topic.html","desc":"Mencetak dari perangkat seluler menggunakan","descFull":"Mencetak dari perangkat seluler menggunakan Wi‑Fi Direct® Wi‑Fi Direct  adalah layanan pencetakan yang memungkinkan Anda mencetak ke printer dengan Wi‑Fi Direct. Pastikan bahwa perangkat seluler terhubung ke jaringan nirkabel printer. Untuk informasi lebih lanjut, lihat  . Dari perangkat seluler Anda, luncurkan aplikasi yang kompatibel atau pilih dokumen dari pengelola file Anda. Bergantung pada perangkat seluler Anda, jalankan salah satu pilihan berikut: Ketuk  Cetak . Ketuk  Cetak . Ketuk  Cetak . Pilih printer, lalu sesuaikan pengaturan jika perlu. Cetak dokumen tersebut. Wi‑Fi Direct mencetak dari perangkat seluler mencetak dari perangkat seluler perangkat seluler mencetak dari mencetak menggunakan Wi-Fi Direct"},{"UUID":"06a3a23a-dc98-475d-93d7-ea35d10b1db3","title":"Cetak","link":"printing-from-flash-drive-topic.html","desc":"Mencetak dari flash drive Masukkan","descFull":"Mencetak dari flash drive Masukkan flash drive. Untuk informasi lebih lanjut tentang flash drive yang didukung, lihat  . Jika Anda memasukkan flash drive ketika muncul pesan eror, printer akan mengabaikan flash drive tersebut. Jika Anda memasukkan flash drive ketika printer sedang memproses pekerjaan cetak lainnya, akan muncul pesan  Busy (Sibuk)  pada tampilan. Dari panel kontrol, pilih  Print (Cetak) .. Pilih  USB Drive , lalu pilih dokumen yang ingin Anda cetak. Jika perlu, atur setelannya. Cetak dokumen. Untuk mencegah kehilangan data atau kerusakan printer, jangan sentuh flash drive atau printer di area tersebut ketika sedang mencetak, membaca, atau menulis dari perangkat memori. mencetak dari flash drive flash drive, mencetak dari"},{"UUID":"f114ce59-1927-4741-a081-72ce486ba3c3","title":"Cetak","link":"configuring-confidential-jobs-topic.html","desc":"Mengonfigurasi pekerjaan rahasia Dari panel","descFull":"Mengonfigurasi pekerjaan rahasia Dari panel kontrol, buka  Settings (Setelan) Security (Keamanan) Confidential Print Setup (Penyiapan Cetak Rahasia) . Atur setelan. Item menu  Confidential Print Setup (Penyiapan Cetak Rahasia)  dan deskripsinya Setelan Deskripsi Max Invalid PIN (PIN Invalid Maks.) Menyetel batas upaya memasukkan PIN yang tidak valid. Ketika batasan itu tercapai, pekerjaan cetak untuk nama pengguna itu akan dihapus. Confidential Job Expiration (Waktu Pekerjaan Rahasia Habis) Menyetel waktu habis untuk masing-masing pekerjaan yang tertunda sebelum printer secara otomatis menghapus pekerjaan tersebut dari memori printer, hard disk atau drive penyimpanan intelijen. Pekerjaan yang tertunda bisa saja  Confidential (Rahasia) ,  Repeat (Ulang) ,  Reserve (Cadangan) , atau  Verify (Verifikasi) . Repeat Job Expiration (Waktu Pekerjaan Ulang Habis) Menyetel waktu habis untuk pekerjaan cetak yang ingin Anda ulangi. Verify Job Expiration (Waktu Verifikasi Pekerjaan Habis) Menyetel waktu habis untuk pencetakan salinan pekerjaan yang harus Anda periksa kualitasnya sebelum mencetak salinan yang tersisa. Reserve Job Expiration (Waktu Pekerjaan Cadangan Habis) Menyetel waktu habis untuk pekerjaan yang hendak Anda simpan di printer guna dipakai di lain waktu. Require All Jobs to be Held (Minta Semua Pekerjaan Ditunda) Menyetel printer untuk menunda semua pekerjaan cetak. Keep duplicate documents (Simpan dokumen duplikat) Menyetel printer untuk menyimpan semua dokumen dengan nama file yang sama. pencetakan rahasia mengatur pekerjaan tertunda mengatur menyimpan pekerjaan cetak menunda pekerjaan cetak"},{"UUID":"d9bb7917-bba1-4bd9-a82f-d7d82c20d8bf","title":"Cetak","link":"printing-confidential-and-other-held-jobs-topic.html","desc":"Mencetak dokumen rahasia dan pekerjaan","descFull":"Mencetak dokumen rahasia dan pekerjaan tertunda Untuk pengguna Windows Dengan dokumen terbuka, pilih  File Print (Cetak) . Pilih printer, lalu klik  Properties (Properti) ,  Preferences (Preferensi) ,  Options (Opsi) , atau  Setup (Penyiapan) . Klik  Print and Hold (Cetak dan Tahan) . Klik  Use Print and Hold (Gunakan Cetak dan Tahan) , lalu tentukan nama pengguna. Pilih dari salah satu jenis pekerjaan cetak berikut: Confidential print (Cetak rahasia) —Printer akan meminta nomor identifikasi pribadi sebelum mengizinkan Anda mencetak. Jika Anda memilih ini, masukkan empat digit nomor identifikasi pribadi (PIN). Verify print (Verifikasi cetak) —Printer mencetak satu salinan dan menyimpan sisa salinan yang Anda minta dari driver di memori printer. Reserve print (Simpan cetak) —Printer menyimpan pekerjaan di dalam memori sehingga Anda dapat mencetak pekerjaan itu lain waktu. Repeat print (Ulangi cetak) —Printer akan mencetak semua salinan pekerjaan yang diminta dan menyimpannya di dalam memori sehingga Anda dapat mencetak salinan tambahan di kemudian hari. Klik  OK . Klik  Print (Cetak) . Dari panel kontrol printer, jalankan pekerjaan cetak. Pilih  Print (Cetak) . Pilih  Held jobs (Pekerjaan tertunda) , lalu pilih nama pengguna Anda. Untuk mencetak dokumen rahasia, pilih  Confidential (Rahasia) , masukkan PIN, lalu pilih  OK . Pilih pekerjaan cetak, lalu pilih  Print (Cetak) . Untuk pengguna Macintosh Dengan dokumen terbuka, pilih  File Print (Cetak) . Pilih printer Dari menu drop-down  Print Job Security (Keamanan Pekerjaan Cetak),  aktifkan  Print with PIN (Cetak dengan PIN) , lalu masukkan empat digit PIN. Klik  Print (Cetak) . Dari panel kontrol printer, jalankan pekerjaan cetak. Pilih  Held jobs (Pekerjaan tertunda) , lalu pilih nama komputer. Pilih  Confidential (Rahasia) , lalu masukkan PIN. Pilih pekerjaan cetak, lalu pilih  Print (Cetak) . mencetak pekerjaan tertunda mencetak pencetakan rahasia pencetakan rahasia mencetak pekerjaan tertunda mencetak"},{"UUID":"1418e3a5-59b6-4d3d-a3c0-d9e5b8a9afbc","title":"Cetak","link":"printing-font-sample-list-topic.html","desc":"Mencetak daftar sampel font Dari","descFull":"Mencetak daftar sampel font Dari panel kontrol, buka  Settings (Setelan)  Reports (Laporan) Print (Cetak) Print Fonts (Cetak Font) . Pilih jenis font. mencetak daftar sampel font daftar sampel font mencetak"},{"UUID":"97e27b4d-739b-4ae5-91f0-c3218e34c30e","title":"Cetak","link":"printing-directory-list-topic.html","desc":"Mencetak daftar direktori Dari panel","descFull":"Mencetak daftar direktori Dari panel kontrol, buka  Settings (Setelan)  Reports (Laporan) Print (Cetak) . Pilih  Print Directory (Direktori Cetak) . mencetak daftar direktori daftar direktori mencetak"},{"UUID":"f8ea1641-b766-4600-9f82-46a02a0f438a","title":"Cetak","link":"placing-separator-sheets-in-print-jobs-topic.html","desc":"Menempatkan lembaran pemisah di pekerjaan","descFull":"Menempatkan lembaran pemisah di pekerjaan cetak Dengan dokumen terbuka, pilih  File Print (Cetak) . Pilih printer, lalu klik  Properties (Properti) ,  Preferences (Preferensi) ,  Options (Opsi) , atau  Setup (Penyiapan) . Klik  Paper/Finishing . Di menu  Separator sheets (Lembaran pemisah),  pilih satu setelan.. Klik  OK , lalu klik  Print (Cetak) . lembaran pemisah menempatkan menempatkan lembaran pemisah"},{"UUID":"7e7fe78a-dcd0-466b-b659-1036773b72bf","title":"Cetak","link":"canceling-print-job-topic.html","desc":"Membatalkan pekerjaan cetak Dari panel","descFull":"Membatalkan pekerjaan cetak Dari panel kontrol, pilih  Job Queue (Antrian Pekerjaan) . Pilih  Print (Cetak) , lalu pilih satu pekerjaan yang akan dibatalkan. Jika dokumen sudah mulai dicetak, pilih  Cancel job (Batalkan pekerjaan)  di pojok kanan bawah tampilan untuk berhenti mencetak. pekerjaan cetak membatalkan membatalkan pekerjaan cetak"},{"UUID":"3e5c541e-27b3-47a8-b447-5746d2338aea","title":"Cetak","link":"adjusting-toner-darkness-topic.html","desc":"Menyesuaikan kegelapan toner Dari panel","descFull":"Menyesuaikan kegelapan toner Dari panel kontrol, buka  Settings (Setelan) Print (Cetak) Quality (Kualitas) . Sesuaikan setelan untuk  Toner Darkness (Kegelapan Toner) . kegelapan toner menyesuaikan menyesuaikan kegelapan toner"},{"UUID":"d672950f-4964-4b34-9755-2b818574a49a","title":"Salin","link":"making-copies-topic.html","desc":"Membuat salinan Masukkan dokumen asli","descFull":"Membuat salinan Masukkan dokumen asli ke dalam baki ADF atau kaca pemindai. Supaya gambar tidak terpotong, pastikan dokumen asli dan keluaran memiliki ukuran kertas yang sama. Dari panel kontrol, pilih  Copy (Salin) , lalu tentukan jumlah salinan. Jika perlu, sesuaikan setelan salin. Salin dokumen. membuat salinan menyalin dokumen menyalin menggunakan ADF, menyalin menggunakan kaca pemindai"},{"UUID":"94863131-ca98-4be5-a6ce-8ddbe5fcf6b9","title":"Salin","link":"copying-photos-topic.html","desc":"Menyalin foto Menyalin foto Tempatkan","descFull":"Menyalin foto Menyalin foto Tempatkan foto di kaca pemindai. Dari panel kontrol, buka  Copy (Salin) More Settings (Setelan Lainnya) Content (Konten) Content Type (Jenis Konten) Photo (Foto) . Pilih  Content Source (Sumber Konten) , kemudian pilih setelan yang paling cocok dengan foto asli. Salin foto. menyalin foto foto, menyalin"},{"UUID":"991ded5b-6629-4c53-ae7e-275e24cd0bae","title":"Salin","link":"copying-on-letterhead-topic.html","desc":"Menyalin di letterhead Menyalin di","descFull":"Menyalin di letterhead Menyalin di letterhead Masukkan dokumen asli ke dalam baki ADF atau kaca pemindai. Dari panel kontrol, buka  Copy (Salin) Copy From (Salin Dari) . Pilih ukuran dokumen asli. Pilih  Copy To (Salin Ke) , lalu pilih sumber kertas yang berisi letterhead. Jika Anda memasukkan kertas letterhead ke feeder multiguna, pilih  Multipurpose Feeder (Feeder Multiguna) , pilih ukuran kertas, lalu pilih  Letterhead . Salin dokumen. menyalin pada kop surat letterhead menyalin pada"},{"UUID":"39a3d727-269e-4e89-a916-a71b335c4b3d","title":"Salin","link":"copying-on-both-sides-of-paper-topic.html","desc":"Menyalin pada dua sisi kertas","descFull":"Menyalin pada dua sisi kertas Menyalin pada dua sisi kertas Masukkan dokumen asli ke dalam baki ADF atau kaca pemindai. Dari panel kontrol, buka  Copy (Salin) More Settings (Setelan Lainnya) Sides (Sisi-sisi) . Pilih satu setelan. Salin dokumen. menyalin pada dua sisi kertas penyalinan dua sisi penyalinan dua sisi"},{"UUID":"10973a3f-822d-41bd-b597-7ecb81da7572","title":"Salin","link":"reducing-or-enlarging-copies-topic.html","desc":"Mengecilkan atau membesarkan salinan Mengecilkan","descFull":"Mengecilkan atau membesarkan salinan Mengecilkan atau membesarkan salinan Masukkan dokumen asli ke dalam baki ADF atau kaca pemindai. Dari panel kontrol, buka  Copy (Salin) More Settings (Setelan Lainnya) Scale (Skala) . Pilih satu setelan. Mengganti ukuran dokumen asli atau keluaran setelan menyetel  Scale (Skala)  akan mengembalikan nilai skala ke  Auto (Otomatis) . Salin dokumen. mengecilkan ukuran salinan membesarkan ukuran salinan ukuran salinan menyesuaikan"},{"UUID":"2c755214-4ecb-4354-a97a-7c942ee6221d","title":"Salin","link":"collating-copies-topic.html","desc":"Menyusun salinan Menyusun salinan Masukkan","descFull":"Menyusun salinan Menyusun salinan Masukkan dokumen asli ke dalam baki ADF atau kaca pemindai. Dari panel kontrol, buka  Copy (Salin) More Settings (Setelan Lainnya) Collate (Susun) On [1,2,1,2,1,2] . Salin dokumen. menyusun salinan menyortir beberapa salinan"},{"UUID":"d6ee9e99-79b8-445c-8546-5618b747636b","title":"Salin","link":"placing-separator-sheets-between-copies-topic.html","desc":"Menempatkan lembaran pemisah di antara","descFull":"Menempatkan lembaran pemisah di antara salinan Menempatkan lembaran pemisah di antara salinan Masukkan dokumen asli ke dalam baki ADF atau kaca pemindai. Dari panel kontrol, buka  Copy (Salin) More Settings (Setelan Lainnya) Separator Sheets (Lembaran Pemisah) . Aktifkan menu, lalu pilih satu setelan. Salin dokumen. lembaran pemisah menambahkan menempatkan lembaran pemisah"},{"UUID":"d9bed2cf-0145-439f-b35e-936cb7453cf2","title":"Salin","link":"copying-multiple-pages-onto-single-sheet-topic.html","desc":"Menyalin beberapa halaman di satu","descFull":"Menyalin beberapa halaman di satu lembar kertas Menyalin beberapa halaman di satu lembar kertas Masukkan dokumen asli ke dalam baki ADF atau kaca pemindai. Dari panel kontrol, buka  Copy (Salin) More Settings (Setelan Lainnya) Pages per Side (Halaman ke Sisi) . Aktifkan menu, lalu pilih satu setelan. Salin dokumen. menyalin beberapa halaman ke satu lembar menghemat kertas"},{"UUID":"cd18d3c0-f5ea-4761-bdc3-f5cf79a17a04","title":"Salin","link":"copying-cards-topic.html","desc":"Menyalin kartu Menyalin kartu Masukkan","descFull":"Menyalin kartu Menyalin kartu Masukkan satu kartu pada kaca pemindai. Dari panel kontrol, buka  Copy (Salin) Copy From (Salin Dari) ID Card (Kartu Identitas) . Salin kartu tersebut. menyalin kartu kartu, menyalin"},{"UUID":"f7a26573-4047-4ba0-bc9a-723e23145d52","title":"Salin","link":"creating-copy-shortcut-topic.html","desc":"Membuat pintasan salin Membuat pintasan","descFull":"Membuat pintasan salin Membuat pintasan salin Dari panel kontrol, pilih  Copy (Salin) .. Atur setelan, lalu pilih  . Membuat pintasan. membuat pintasan salin menambah pintasan salin"},{"UUID":"e63bed80-0235-4936-981d-d936a848036d","title":"Email","link":"configuring-smtp-settings-topic.html","desc":"Mengatur setelan SMTP Mengatur setelan","descFull":"Mengatur setelan SMTP Mengatur setelan SMTP Atur setelan Simple Mail Transfer Protocol (SMTP) untuk mengirim dokumen pindaian melalui email. Setelan bisa berbeda-beda, tergantung penyedia layanan email. Sebelum memulai, pastikan printer terhubung ke suatu jaringan dan jaringan tersebut terhubung ke Internet. Menggunakan panel kontrol Dari panel kontrol, buka  Settings (Setelan) Email Email Setup (Penyiapan Email) . Atur setelan. Menggunakan Embedded Web Server Buka peramban web, kemudian tulis alamat IP printer di kolom alamat. Lihat alamat IP printer di layar beranda printer. Alamat IP muncul dalam empat set angka yang dipisahkan oleh titik, seperti 123.123.123.123. Jika Anda menggunakan proxy, nonaktifkan proxy tersebut untuk memuat halaman web dengan benar. Klik  Settings (Setelan) Email . Pada menu  Email Setup (Penyiapan Email) , atur setelannya. Klik  Save (Simpan) . Penyedia layanan email AOL Mail Comcast Mail Gmail iCloud Mail Mail.com NetEase Mail (mail.126.com) NetEase Mail (mail.163.com) NetEase Mail (mail.yeah.net) Outlook Live atau Microsoft 365 QQ Mail Sina Mail Sohu Mail Yahoo! Mail Zoho Mail Jika Anda mendapati kesalahan saat menggunakan setelan yang disediakan, hubungi penyedia layanan. Jika penyedia layanan tidak bisa dihubungi, kontak penyedia Anda. AOL Mail Setelan untuk AOL Mail Setelan Nilai Primary SMTP Gateway (Gateway SMTP Utama) smtp.aol.com Primary SMTP Gateway Port (Port Gateway SMTP Utama) 587 Use SSL/TLS (Gunakan SSL/TLS) Required (Diperlukan) Require Trusted Certificate (Memerlukan Sertifikat Tepercaya) Disabled (Dinonaktifkan) Reply Address (Alamat Balasan) Alamat email Anda SMTP Server Authentication (Autentikasi Server SMTP) Login / Biasa Device‑Initiated E‑mail (Email Dipicu Perangkat) Gunakan Kredensial SMTP Perangkat Device UserID (ID Pengguna Perangkat) Alamat email Anda Device Password (Kata Sandi Perangkat) Kata sandi aplikasi Untuk membuat kata sandi aplikasi, buka  AOL Account Security (Keamanan Akun AOL) , masuk ke akun Anda, kemudian klik  Generate and manage app password (Buat dan kelola kata sandi aplikasi) . Comcast Mail Setelan untuk Comcast Mail Setelan Nilai Primary SMTP Gateway (Gateway SMTP Utama) smtp.comcast.net Primary SMTP Gateway Port (Port Gateway SMTP Utama) 587 Use SSL/TLS (Gunakan SSL/TLS) Required (Diperlukan) Require Trusted Certificate (Memerlukan Sertifikat Tepercaya) Disabled (Dinonaktifkan) Reply Address (Alamat Balasan) Alamat email Anda SMTP Server Authentication (Autentikasi Server SMTP) Login / Biasa Device‑Initiated E‑mail (Email Dipicu Perangkat) Gunakan Kredensial SMTP Perangkat Device UserID (ID Pengguna Perangkat) Alamat email Anda Device Password (Kata Sandi Perangkat) Kata sandi akun Pastikan bahwa setelan Third Party Access Security (Keamanan Akses Pihak Ketiga) sudah diaktifkan di akun Anda. Untuk informasi lebih lanjut, kunjungi halaman bantuan  Comcast Xfinity Connect . Gmail Pastikan verifikasi dua langkah sudah diaktifkan di akun Anda. Untuk mengaktifkan verifikasi dua langkah, kunjungi halaman  Google Account Security (Keamanan Akun Google) , masuk ke akun Anda, kemudian dari bagian  How you sign in to Google (Bagaimana Anda Masuk ke Google) , klik  2‑Step Verification (Verifikasi 2 Langkah) . Setelan SMTP untuk Google Setelan Nilai Primary SMTP Gateway (Gateway SMTP Utama) smtp.gmail.com Primary SMTP Gateway Port (Port Gateway SMTP Utama) 587 Use SSL/TLS (Gunakan SSL/TLS) Required (Diperlukan) Require Trusted Certificate (Memerlukan Sertifikat Tepercaya) Disabled (Dinonaktifkan) Reply Address (Alamat Balasan) Alamat email Anda SMTP Server Authentication (Autentikasi Server SMTP) Login / Biasa Device‑Initiated E‑mail (Email Dipicu Perangkat) Gunakan Kredensial SMTP Perangkat Device UserID (ID Pengguna Perangkat) Alamat email Anda Device Password (Kata Sandi Perangkat) Kata sandi aplikasi Untuk membuat kata sandi aplikasi, kunjungi halaman  Google Account Security (Keamanan Akun Google) , masuk ke akun Anda, kemudian dari bagian  How you sign in to Google (Bagaiman Anda masuk ke Google) , klik  2-Step Verification (Verifikasi 2 Langkah) App passwords (Kata sandi aplikasi) . “ App passwords (Kata sandi aplikasi) ” akan menunjukkan apakah verifikasi dua langkah sudah diaktifkan. iCloud Mail Pastikan verifikasi dua langkah sudah diaktifkan di akun Anda. Setelan untuk iCloud Mail Setelan Nilai Primary SMTP Gateway (Gateway SMTP Utama) smtp.mail.me.com Primary SMTP Gateway Port (Port Gateway SMTP Utama) 587 Use SSL/TLS (Gunakan SSL/TLS) Required (Diperlukan) Require Trusted Certificate (Memerlukan Sertifikat Tepercaya) Disabled (Dinonaktifkan) Reply Address (Alamat Balasan) Alamat email Anda SMTP Server Authentication (Autentikasi Server SMTP) Login / Biasa Device‑Initiated E‑mail (Email Dipicu Perangkat) Gunakan Kredensial SMTP Perangkat Device UserID (ID Pengguna Perangkat) Alamat email Anda Device Password (Kata Sandi Perangkat) Kata sandi aplikasi Kata sandi aplikasi\nUntuk membuat kata sandi aplikasi, kunjungi halaman  iCloud Accout Management (Pengelolaan Akun iCloud) , masuk ke akun Anda, kemudian dari bagian  Sign-In and Security (Masuk dan Keamanan) , klik  App-Specific Passwords (Kata Sandi Aplikasi Khusus) Generate an app-specific password (Buat kata sandi aplikasi khusus) . Mail.com Setelan untuk Mail.com Setelan Nilai Primary SMTP Gateway (Gateway SMTP Utama) smtp.mail.com Primary SMTP Gateway Port (Port Gateway SMTP Utama) 587 Use SSL/TLS (Gunakan SSL/TLS) Required (Diperlukan) Require Trusted Certificate (Memerlukan Sertifikat Tepercaya) Disabled (Dinonaktifkan) Reply Address (Alamat Balasan) Alamat email Anda SMTP Server Authentication (Autentikasi Server SMTP) Login / Biasa Device‑Initiated E‑mail (Email Dipicu Perangkat) Gunakan Kredensial SMTP Perangkat Device UserID (ID Pengguna Perangkat) Alamat email Anda Device Password (Kata Sandi Perangkat) Kata sandi akun NetEase Mail (mail.126.com) Pastikan bahwa layanan SMTP sudah diaktifkan di akun Anda. Untuk mengaktifkannya, dari halaman beranda NetEase Mail, klik  Settings (Setelan) POP3/SMTP/IMAP , kemudian aktifkan salah satu antara  layanan IMAP/SMTP  atau  layanan POP3/SMTP . Setelan untuk NetEase Mail (mail.126.com) Setelan Nilai Primary SMTP Gateway (Gateway SMTP Utama) smtp.126.com Primary SMTP Gateway Port (Port Gateway SMTP Utama) 465 Use SSL/TLS (Gunakan SSL/TLS) Required (Diperlukan) Require Trusted Certificate (Memerlukan Sertifikat Tepercaya) Disabled (Dinonaktifkan) Reply Address (Alamat Balasan) Alamat email Anda SMTP Server Authentication (Autentikasi Server SMTP) Login / Biasa Device‑Initiated E‑mail (Email Dipicu Perangkat) Gunakan Kredensial SMTP Perangkat Device UserID (ID Pengguna Perangkat) Alamat email Anda Device Password (Kata Sandi Perangkat) Kata sandi pengesahan Kata sandi pengesahan diberikan ketika  layanan IMAP/SMTP  atau  layanan POP3/SMTP  sudah diaktifkan. NetEase Mail (mail.163.com) Pastikan bahwa layanan SMTP sudah diaktifkan di akun Anda. Untuk mengaktifkannya, dari halaman beranda NetEase Mail, klik  Settings (Setelan) POP3/SMTP/IMAP , kemudian aktifkan salah satu antara  layanan IMAP/SMTP  atau  layanan POP3/SMTP . Setelan untuk NetEase Mail (mail.163.com) Setelan Nilai Primary SMTP Gateway (Gateway SMTP Utama) smtp.163.com Primary SMTP Gateway Port (Port Gateway SMTP Utama) 465 Use SSL/TLS (Gunakan SSL/TLS) Required (Diperlukan) Require Trusted Certificate (Memerlukan Sertifikat Tepercaya) Disabled (Dinonaktifkan) Reply Address (Alamat Balasan) Alamat email Anda SMTP Server Authentication (Autentikasi Server SMTP) Login / Biasa Device‑Initiated E‑mail (Email Dipicu Perangkat) Gunakan Kredensial SMTP Perangkat Device UserID (ID Pengguna Perangkat) Alamat email Anda Device Password (Kata Sandi Perangkat) Kata sandi pengesahan Kata sandi pengesahan diberikan ketika  layanan IMAP/SMTP  atau  layanan POP3/SMTP  sudah diaktifkan. NetEase Mail (mail.yeah.net) Pastikan bahwa layanan SMTP sudah diaktifkan di akun Anda. Untuk mengaktifkannya, dari halaman beranda NetEase Mail, klik  Settings (Setelan) POP3/SMTP/IMAP , kemudian aktifkan salah satu antara  layanan IMAP/SMTP  atau  layanan POP3/SMTP . Setelan untuk NetEase Mail (mail.yeah.net) Setelan Nilai Primary SMTP Gateway (Gateway SMTP Utama) smtp.yeah.net Primary SMTP Gateway Port (Port Gateway SMTP Utama) 465 Use SSL/TLS (Gunakan SSL/TLS) Required (Diperlukan) Require Trusted Certificate (Memerlukan Sertifikat Tepercaya) Disabled (Dinonaktifkan) Reply Address (Alamat Balasan) Alamat email Anda SMTP Server Authentication (Autentikasi Server SMTP) Login / Biasa Device‑Initiated E‑mail (Email Dipicu Perangkat) Gunakan Kredensial SMTP Perangkat Device UserID (ID Pengguna Perangkat) Alamat email Anda Device Password (Kata Sandi Perangkat) Kata sandi pengesahan Kata sandi pengesahan diberikan ketika  layanan IMAP/SMTP  atau  layanan POP3/SMTP  sudah diaktifkan. Outlook Live atau Microsoft 365 Setelan ini berlaku untuk domain email outlook.com dan hotmail.com, serta akun Microsoft 365. Setelan untuk Outlook Live atau Microsoft 365 Setelan Nilai Primary SMTP Gateway (Gateway SMTP Utama) smtp.office365.com Primary SMTP Gateway Port (Port Gateway SMTP Utama) 587 Use SSL/TLS (Gunakan SSL/TLS) Required (Diperlukan) Require Trusted Certificate (Memerlukan Sertifikat Tepercaya) Disabled (Dinonaktifkan) Reply Address (Alamat Balasan) Alamat email Anda SMTP Server Authentication (Autentikasi Server SMTP) Login / Biasa Device‑Initiated E‑mail (Email Dipicu Perangkat) Gunakan Kredensial SMTP Perangkat Device UserID (ID Pengguna Perangkat) Alamat email Anda Device Password (Kata Sandi Perangkat) Kata sandi aplikasi atau kata sandi akun Untuk akun dengan verifikasi dua langkah yang dinonaktifkan, gunakan kata sandi akun. Untuk akun outlook.com atau hotmail.com dengan verifikasi dua langkah yang dinonaktifkan, gunakan kata sandi akun. Untuk membuat kata sandi aplikasi, kunjungi halaman  Outlook Live Account Management (Manajemen Akun Live Outlook) , masuk ke akun Anda, kemudian klik  Create a new app password (Buat kata sandi aplikasi baru) . Opsi penyiapan lain untuk bisnis menggunakan Microsoft 365, kunjungi  Halaman bantuan Microsoft 365 . QQ Mail Pastikan bahwa layanan SMTP sudah diaktifkan di akun Anda. Untuk mengaktifkan layanan, dari halaman beranda QQ Mail, klik  Settings (Setelan) Account (Akun) . Dari bagian  Layanan POP3/IMAP/SMTP/Exchange/CardDAV/CalDAV , aktifkan salah satu antara  layanan POP3/SMTP  atau  layanan IMAP/SMTP . Setelan untuk QQ Mail Setelan Nilai Primary SMTP Gateway (Gateway SMTP Utama) smtp.qq.com Primary SMTP Gateway Port (Port Gateway SMTP Utama) 587 Use SSL/TLS (Gunakan SSL/TLS) Required (Diperlukan) Require Trusted Certificate (Memerlukan Sertifikat Tepercaya) Disabled (Dinonaktifkan) Reply Address (Alamat Balasan) Alamat email Anda SMTP Server Authentication (Autentikasi Server SMTP) Login / Biasa Device‑Initiated E‑mail (Email Dipicu Perangkat) Gunakan Kredensial SMTP Perangkat Device UserID (ID Pengguna Perangkat) Alamat email Anda Device Password (Kata Sandi Perangkat) Kode pengesahan Untuk mendapatkan kode pengesahan, dari halaman beranda QQ Mail, klik  Settings (Setelan) Account (Akun) , kemudian dari bagian  Layanan POP3/IMAP/SMTP/Exchange/CardDAV/CalDAV , klik  Generate authorization code (Buat kode pengesahan) . Sina Mail Pastikan bahwa layanan POP3/SMTP sudah diaktifkan di akun Anda. Untuk mengaktifkannya, dari halaman beranda Sina Mail, klik  Settings (Setelan) More settings (Setelan lainnya) User‑end POP/IMAP/SMTP , kemudian aktifkan  Layanan POP3/SMTP . Settings for Sina Mail Setelan Nilai Primary SMTP Gateway (Gateway SMTP Utama) smtp.sina.com Primary SMTP Gateway Port (Port Gateway SMTP Utama) 587 Use SSL/TLS (Gunakan SSL/TLS) Required (Diperlukan) Require Trusted Certificate (Memerlukan Sertifikat Tepercaya) Disabled (Dinonaktifkan) Reply Address (Alamat Balasan) Alamat email Anda SMTP Server Authentication (Autentikasi Server SMTP) Login / Biasa Device‑Initiated E‑mail (Email Dipicu Perangkat) Gunakan Kredensial SMTP Perangkat Device UserID (ID Pengguna Perangkat) Alamat email Anda Device Password (Kata Sandi Perangkat) Kode pengesahan Untuk membuat kode pengesahan, dari halaman beranda email, klik  Settings (Setelan) More settings (Setelan lainnya) User‑end POP/IMAP/SMTP , kemudian aktifkan  Authorization code status (Status kode pengesahan) . Sohu Mail Pastikan bahwa layanan SMTP sudah diaktifkan di akun Anda. Untuk mengaktifkannya, dari halaman beranda Sohu Mail, klik  Options (Opsi) Settings (Setelan) POP3/SMTP/IMAP , kemudian aktifkan salah satu antara  Layanan IMAP/SMTP  atau  Layanan POP3/SMTP . Setelan untuk Sohu Mail Setelan Nilai Primary SMTP Gateway (Gateway SMTP Utama) smtp.sohu.com Primary SMTP Gateway Port (Port Gateway SMTP Utama) 465 Use SSL/TLS (Gunakan SSL/TLS) Required (Diperlukan) Require Trusted Certificate (Memerlukan Sertifikat Tepercaya) Disabled (Dinonaktifkan) Reply Address (Alamat Balasan) Alamat email Anda SMTP Server Authentication (Autentikasi Server SMTP) Login / Biasa Device‑Initiated E‑mail (Email Dipicu Perangkat) Gunakan Kredensial SMTP Perangkat Device UserID (ID Pengguna Perangkat) Alamat email Anda Device Password (Kata Sandi Perangkat) Kata sandi independen Kata sandi independen diberikan ketika  Layanan IMAP/SMTP  atau  Layanan POP3/SMTP  sudah diaktifkan. Yahoo! Mail Setelan untuk Yahoo! Mail Setelan Nilai Primary SMTP Gateway (Gateway SMTP Utama) smtp.mail.yahoo.com Primary SMTP Gateway Port (Port Gateway SMTP Utama) 587 Use SSL/TLS (Gunakan SSL/TLS) Required (Diperlukan) Require Trusted Certificate (Memerlukan Sertifikat Tepercaya) Disabled (Dinonaktifkan) Reply Address (Alamat Balasan) Alamat email Anda SMTP Server Authentication (Autentikasi Server SMTP) Login / Biasa Device‑Initiated E‑mail (Email Dipicu Perangkat) Gunakan Kredensial SMTP Perangkat Device UserID (ID Pengguna Perangkat) Alamat email Anda Device Password (Kata Sandi Perangkat) Kata sandi aplikasi Untuk membuat kata sandi aplikasi, kunjungi halaman  Yahoo Account Security (Keamanan Akun Yahoo) , masuk ke akun Anda, kemudian dari bagian  App password (Kata Sandi Aplikasi) , klik  Generate app password (Buat kata sandi aplikasi) . Zoho Mail Setelan untuk Zoho Mail Setelan Nilai Primary SMTP Gateway (Gateway SMTP Utama) smtp.zoho.com Primary SMTP Gateway Port (Port Gateway SMTP Utama) 587 Use SSL/TLS (Gunakan SSL/TLS) Required (Diperlukan) Require Trusted Certificate (Memerlukan Sertifikat Tepercaya) Disabled (Dinonaktifkan) Reply Address (Alamat Balasan) Alamat email Anda SMTP Server Authentication (Autentikasi Server SMTP) Login / Biasa Device‑Initiated E‑mail (Email Dipicu Perangkat) Gunakan Kredensial SMTP Perangkat Device UserID (ID Pengguna Perangkat) Alamat email Anda Device Password (Kata Sandi Perangkat) Kata sandi aplikasi atau kata sandi akun Untuk akun dengan verifikasi dua langkah yang dinonaktifkan, gunakan kata sandi akun. Untuk akun dengan verifikasi dua langkah yang sudah diaktifkan, gunakan kata sandi akun. Untuk membuat kata sandi aplikasi, kunjungi halaman  Zoho Mail Account Security (Keamanan Akun Zoho Mail) , masuk ke akun Anda, kemudian dari bagian “ Application-Specific Passwords (Kata Sandi Aplikasi Spesifik) ”, klik  Generate New Password (Buat Kata Sandi Baru) . penyedia layanan email mengatur setelan server email setelan SMTP mengatur fungsi email menyiapkan setelan server email mengatur"},{"UUID":"d98d79ab-05c8-4282-84c7-ff2f055add96","title":"Email","link":"sending-email-topic.html","desc":"Mengirim email Sebelum mulai, pastikan","descFull":"Mengirim email Sebelum mulai, pastikan setelan SMTP sudah dikonfigurasi. Untuk informasi lebih lanjut, lihat  . Masukkan dokumen asli ke dalam baki ADF atau kaca pemindai. Dari panel kontrol, buka  Scan (Pindai) E-mail . Masukkan informasi yang dibutuhkan, lalu pilih  Next (Selanjutnya) . Jika perlu, atur setelannya. Pilih  Scan (Pindai) , lalu kirim email. email mengirim mengirim email"},{"UUID":"5b2a516a-278e-4d37-8e8e-f1455a1afd1a","title":"Email","link":"creating-email-shortcut-topic.html","desc":"Membuat pintasan email Menggunakan panel","descFull":"Membuat pintasan email Menggunakan panel kontrol Dari panel kontrol, buka  Scan (Pindai) E‑mail . Masukkan informasi yang dibutuhkan, lalu pilih  . Membuat pintasan. Menggunakan Embedded Web Server Buka peramban web, kemudian tulis alamat IP printer di kolom alamat. Lihat alamat IP printer di layar beranda printer. Alamat IP muncul dalam empat set angka yang dipisahkan oleh titik, seperti 123.123.123.123. Jika Anda menggunakan proxy, nonaktifkan proxy tersebut untuk memuat halaman web dengan benar. Klik  Shortcuts (Pintasan) Add Shortcut (Tambah Pintasan) . Atur setelan. Klik  Save (Simpan) . membuat pintasan email menambah pintasan email pintasan Email membuat"},{"UUID":"5c4177c8-1118-4c5b-9997-d34ab1d2e83b","title":"Faks","link":"sending-fax-topic.html","desc":"Mengirim faks Mengirim faks Menggunakan","descFull":"Mengirim faks Mengirim faks Menggunakan panel kontrol Masukkan dokumen asli ke dalam baki ADF atau kaca pemindai. Dari panel kontrol, pilih  Fax (Faks) .. Pilih  Add Recipient (Tambah Penerima)  atau  Address Book (Buku Alamat) . Jika perlu, sesuaikan setelan. Kirim faks. Menggunakan komputer Sebelum mulai, pastikan driver faks sudah diinstal. Untuk informasi lebih lanjut, lihat  . Untuk pengguna Windows Dengan dokumen terbuka, pilih  File Print (Cetak) . Pilih printer, lalu klik  Properties (Properti) ,  Preferences (Preferensi) ,  Options (Opsi) , atau  Setup (Penyiapan) . Klik  Fax (Faks) Enable fax (Aktifkan faks) Always display settings prior to fixing (Selalu tampilkan setelan sebelum mengirim faks) , lalu masukkan nomor penerima. Jika perlu, atur setelannya. Kirim faks. Untuk pengguna Macintosh Dengan dokumen terbuka, pilih  File Print (Cetak) . Pilih printer yang terdapat  ‑ Fax  setelah nama printer. Pada bidang Kepada, masukkan nomor penerima. Jika perlu, atur setelannya. Kirim faks. mengirim faks faks, mengirim"},{"UUID":"e1ec1f84-215d-4755-a335-8187a1576cc2","title":"Faks","link":"scheduling-fax-topic.html","desc":"Menjadwalkan faks Menjadwalkan faks Masukkan","descFull":"Menjadwalkan faks Menjadwalkan faks Masukkan dokumen asli ke dalam baki ADF atau kaca pemindai. Dari panel kontrol, pilih  Fax (Faks) .. Pilih  Add Recipient (Tambah Penerima)  atau  Address Book (Buku Alamat) , lalu masukkan informasi yang diperlukan. Pilih  Send Time (Waktu Kirim) , atur jam dan tanggal, lalu Pilih  Done (Selesai) . Jika perlu, atur setelan faks lainnya. Kirim faks. menjadwalkan faks faks, menjadwalkan"},{"UUID":"ec146fa9-d645-4a3e-ac1c-2c0477c9b3a3","title":"Faks","link":"creating-fax-destination-shortcut-topic.html","desc":"Membuat pintasan destinasi faks Membuat","descFull":"Membuat pintasan destinasi faks Membuat pintasan destinasi faks Dari panel kontrol, pilih  Fax (Faks) .. Pilih  Add Recipient (Tambah Penerima)  atau  Address Book (Buku Alamat) , lalu masukkan informasi yang diperlukan. Jika perlu, sesuaikan setelan. Pilih  . Membuat pintasan. membuat pintasan destinasi faks destinasi faks membuat pintasan menambah pintasan destinasi faks pintasan, membuat destinasi faks"},{"UUID":"437bbef5-8c41-4953-9c07-f9dbeb86867c","title":"Faks","link":"changing-fax-resolution-topic.html","desc":"Mengganti resolusi faks Mengganti resolusi","descFull":"Mengganti resolusi faks Mengganti resolusi faks Masukkan dokumen asli ke dalam baki ADF atau kaca pemindai. Dari panel kontrol, pilih  Fax (Faks) .. Pilih  Add Recipient (Tambah Penerima)  atau  Address Book (Buku Alamat) , lalu masukkan informasi yang diperlukan. Pilih  Resolution (Resolusi) , lalu pilih satu setelan. Kirim faks. resolusi faks mengubah mengganti resolusi faks"},{"UUID":"25b95eec-a074-4d2d-8867-395e991b0615","title":"Faks","link":"adjusting-fax-darkness-topic.html","desc":"Menyesuaikan kegelapan faks Menyesuaikan kegelapan","descFull":"Menyesuaikan kegelapan faks Menyesuaikan kegelapan faks Masukkan dokumen asli ke dalam baki ADF atau kaca pemindai. Dari panel kontrol, pilih  Fax (Faks) .. Pilih  Add Recipient (Tambah Penerima)  atau  Address Book (Buku Alamat) , lalu masukkan informasi yang diperlukan. Pilih  More Settings (Setelan Lainnya) Darkness (Kegelapan) , lalu sesuaikan setelan. Kirim faks. menyesuaikan kegelapan faks kegelapan Faks menyesuaikan"},{"UUID":"2d8b68b9-cd13-4eda-8eef-8691c6a3c8cf","title":"Faks","link":"printing-fax-log-topic.html","desc":"Mencetak log faks Mencetak log","descFull":"Mencetak log faks Mencetak log faks Dari panel kontrol, buka  Settings (Setelan) Reports (Laporan) Fax (Faks) . Pilih log faks. log faks mencetak mencetak log faks"},{"UUID":"1c51ad42-eb35-4c4d-950c-f2117ba140da","title":"Faks","link":"blocking-junk-faxes-topic.html","desc":"Memblokir faks sampah Dari panel","descFull":"Memblokir faks sampah Dari panel kontrol, buka  Settings (Setelan) Fax (Faks) Fax Setup (Penyiapan Faks) Fax Receive Settings (Setelan Terima Faks) Admin Controls (Kontrol Admin) . Aktifkan menu  Block No Name Fax (Blokir Faks Tanpa Nama) . faks sampah memblokir memblokir faks sampah"},{"UUID":"daf63f2e-f068-4ca4-8d74-4858910e9b4b","title":"Faks","link":"holding-faxes-topic.html","desc":"Holding faxes (Menunda faks) Holding","descFull":"Holding faxes (Menunda faks) Holding faxes (Menunda faks) Dari panel kontrol, buka  Settings (Setelan) Fax (Faks) Fax Setup (Penyiapan Faks) Fax Receive Settings (Setelan Terima Faks)  Holding Faxes (Menunda Faks) . Pilih satu setelan. menunda faks faks masuk menunda faks menunda"},{"UUID":"d486b5f9-d5de-4e86-ada6-a52b780ddd7b","title":"Faks","link":"forwarding-fax-topic.html","desc":"Meneruskan faks Meneruskan faks Dari","descFull":"Meneruskan faks Meneruskan faks Dari panel kontrol, buka  Settings (Setelan) Fax (Faks) Fax Setup (Penyiapan Faks) Fax Receive Settings (Setelan Terima Faks) Admin Controls (Kontrol Admin) . Pilih  Fax Forwarding (Meneruskan Faks) , lalu pilih  Print and Forward (Cetak dan Teruskan)  atau  Forward (Teruskan) . Pada menu  Forward to (Teruskan ke) , pilih destinasi dan lalu atur setelans. meneruskan faks faks meneruskan"},{"UUID":"26e3feee-6033-42c9-be52-4f2970bf76c7","title":"Pindai","link":"scanning-to-computer-topic.html","desc":"Memindai ke komputer Sebelum Anda","descFull":"Memindai ke komputer Sebelum Anda mulai, pastikan komputer dan printer terhubung ke jaringan yang sama. Untuk pengguna Windows Menggunakan Lexmark ScanBack Utility Dari komputer, buka  Lexmark ScanBack Utility , lalu klik  Create profile (Buat profil) . Untuk men-download, kunjungi  www.lexmark.com/downloads . Jika Anda ingin memakai profil pemindaian yang sudah ada, klik  Existing profile (Profil yang ada) . Klik  Setup (Penyiapan) , lalu tambah alamat IP printer. Lihat alamat IP printer di layar beranda printer. Alamat IP muncul dalam empat set angka yang dipisahkan oleh titik, seperti 123.123.123.123. Klik  OK , lalu klik  Close (Tutup) . Pilih format dan ukuran dokumen yang akan dipindai. Pilih resolusi pindai dan format berkas, kemudian klik  Next (Berikutnya) . Tulis nama profil pindai yang unik. Telusuri lokasi di mana Anda ingin menyimpan dokumen hasil pindai, lalu buat nama file. Untuk memakai kembali profil pindai tersebut, aktifkan  Create Shortcut (Buat Pintasan) , kemudian buat nama pintasan unik. Klik  Finish (Selesai) . Masukkan dokumen asli ke dalam pengumpan dokumen otomatis atau kaca pemindai. Dari panel kontrol, buka  Scan Profiles (Profil Pindai) Scan to Computer (Pindai ke Komputer) , lalu pilih satu profil pindai. Pada komputer Anda, klik  Scan Complete (Pemindaian Selesai) . Untuk pengguna Windows Menggunakan Windows Fax and Scan Pastikan bahwa printer sudah ditambahkan ke komputer. Untuk informasi lebih lanjut, lihat  . Masukkan dokumen asli ke dalam pengumpan dokumen otomatis atau kaca pemindai. Dari komputer, buka  Windows Fax and Scan (Windows Faks dan Pindai) . Klik  New Scan (Pindai Baru) , kemudian pilih sumber pemindai. Jika perlu, ubah setelan pindai. Pindai dokumen. Klik  Save as (Simpan sebagai) , tulis nama file, kemudian klik  Save (Simpan) . Untuk pengguna Macintosh Pastikan bahwa printer sudah ditambahkan ke komputer. Untuk informasi lebih lanjut, lihat  . Masukkan dokumen asli ke dalam pengumpan dokumen otomatis atau kaca pemindai. Dari komputer, lakukan salah satu di bawah ini: Buka  Image Capture (Tangkapan Gambar) . Buka  Printers & Scanners (Printer & Pemindai) , kemudian pilih printer. Klik  Scan (PIndai) Open Scanner (Buka Pemindai) . Dari jendela Pemindai, lakukan satu atau beberapa hal berikut: Pilih lokasi di mana Anda ingin menyimpan dokumen hasil pindai. Pilih ukuran dokumen asli. Untuk memindai dari ADF, pilih  Document Feeder (Pengumpan Dokumen)  dari  Scan Menu (Menu Pindai)  atau aktifkan  Use Document Feeder (Gunakan Pengumpan Dokumen) . Jika perlu, konfigurasi setelan pindai. Klik  Pindai . memindai ke komputer komputer, memindai ke Lexmark ScanBack Utility"},{"UUID":"94477cfd-6f82-47ec-b7d0-0f0f2671e404","title":"Pindai","link":"scanning-ftp-server-using-control-panel-topic.html","desc":"Memindai ke server FTP Memindai","descFull":"Memindai ke server FTP Memindai ke server FTP Sebelum mulai, pastikan printer tersambung ke server FTP. Masukkan dokumen asli ke dalam baki ADF atau kaca pemindai. Dari panel kontrol, buka  Scan (Pindai) FTP . Masukkan informasi yang dibutuhkan, lalu pilih  Next (Selanjutnya) . Jika perlu, atur setelan FTP. Pindai dokumen. Server NTP memindai ke memindai ke server FTP"},{"UUID":"a1a28608-4a4a-4139-a22b-a1f9e0b67277","title":"Pindai","link":"creating-FTP-shortcut-topic.html","desc":"Membuat pintasan FTP Membuat pintasan","descFull":"Membuat pintasan FTP Membuat pintasan FTP Dari panel kontrol, pilih  Scan (Pindai) FTP . Masukkan alamat server FTP, lalu sentuh  Membuat pintasan. membuat pintasan alamat FTP menambah pintasan alamat FTP"},{"UUID":"fc7c2650-5137-43a6-99d1-ff08ef282184","title":"Pindai","link":"scanning-to-network-folder-topic.html","desc":"Memindai ke folder jaringan Sebelum","descFull":"Memindai ke folder jaringan Sebelum mulai, pastikan bahwa folder jaringan yang ingin Anda jadikan tempat untuk menyimpan dokumen pindaian telah diatur. Masukkan dokumen asli ke dalam baki ADF atau kaca pemindai. Dari panel kontrol, buka  Scan Center Network Folder (Folder Jaringan) . Pilih folder jaringan yang ada. Untuk menambah folder jaringan, lihat  . Pindai dokumen. memindai ke folder jaringan folder jaringan memindai ke"},{"UUID":"5b38dbdf-3ad9-4259-a328-d9f202e2dc9c","title":"Pindai","link":"configuring-network-folder-destination-topic.html","desc":"Mengatur destinasi folder jaringan Mengatur","descFull":"Mengatur destinasi folder jaringan Mengatur destinasi folder jaringan Dari panel kontrol, buka  Scan Center Network Folder (Folder Jaringan) Create Network Folder (Buat Folder Jaringan) . Atur setelan yang diperlukan. Masuk ke jaringan, lalu pilih  Next (Selanjutnya) . Atur setelan folder jaringan, lalu pilih  Done (Selesai) . Untuk memindai dokumen ke folder jaringan, buka  . destinasi folder jaringan mengatur membuat folder jaringan"},{"UUID":"1ef104e8-9f55-4373-b4b7-ebd8b8265e7b","title":"Pindai","link":"creating-network-folder-shortcut-topic.html","desc":"Membuat pintasan folder jaringan Buka","descFull":"Membuat pintasan folder jaringan Buka peramban web, kemudian tulis alamat IP printer di kolom alamat. Lihat alamat IP printer di layar beranda printer. Alamat IP muncul dalam empat set angka yang dipisahkan oleh titik, seperti 123.123.123.123. Jika Anda menggunakan proxy, nonaktifkan proxy tersebut untuk memuat halaman web dengan benar. Klik  Shortcuts (Pintasan) Add Shortcut (Tambah Pintasan) . Dari menu  Shortcut Type (Jenis Pintasan),  pilih  Network Folder (Folder Jaringan) , lalu atur setelan. Terapkan perubahan. pintasan folder jaringan membuat pintasan"},{"UUID":"0ff6ac83-5f3e-4fd5-b8bd-075b3c6d6ed2","title":"Pindai","link":"scanning-to-flash-drive-topic.html","desc":"Memindai ke flash drive Memindai","descFull":"Memindai ke flash drive Memindai ke flash drive Masukkan dokumen asli ke dalam baki ADF atau kaca pemindai. Masukkan flash drive. Dari panel kontrol, pilih  Scan (Pindai) , lalu pilih  USB Drive . Pilih lokasi untuk menyimpan file, buat nama file, lalu pilih  Next (Selanjutnya) . Atur setelan pindai. Pindai dokumen. Untuk mencegah kehilangan data atau kerusakan printer, jangan sentuh flash drive atau printer di area tersebut ketika sedang mencetak, membaca, atau menulis dari perangkat memori. memindai ke flash drive flash drive memindai ke"},{"UUID":"9d335136-9578-4351-beb4-eda1d653dc63","title":"menu printer","link":"menu-map-topic.html","desc":"Peta menu 1  Hanya","descFull":"Peta menu 1  Hanya muncul jika finisher dipasang. 2  Hanya muncul jika drive penyimpanan dipasang. Device (Perangkat) Preferences (Preferensi) Eco‑Mode (Mode Eco) Remote Operator Panel (Panel Operator Jarak Jauh) Notifications (Pemberitahuan) Power Management (Manajemen Daya) Share Data with Lexmark (Berbagi Data dengan Lexmark) Accessibility (Aksesibilitas) Restore Factory Defaults (Pulihkan ke Setelan Default) Maintenance (Perawatan) Update Firmware (Perbarui Firmware) About this Printer (Tentang Printer Ini) Device (Perangkat) Preferences (Preferensi) Eco‑Mode (Mode Eco) Remote Operator Panel (Panel Operator Jarak Jauh) Notifications (Pemberitahuan) Power Management (Manajemen Daya) Accessibility (Aksesibilitas) Restore Factory Defaults (Pulihkan ke Setelan Default) Maintenance (Perawatan) Update Firmware (Perbarui Firmware) About this Printer (Tentang Printer Ini) Print (Cetak) Layout (Tata Letak) Finishing 1 Setup (Penyiapan) Quality (Kualitas) Job Accounting (Pencatatan Pekerjaan) PDF PostScript PCL Image (Gambar) Paper (Kertas) Tray Configuration (Konfigurasi Baki) Media Configuration (Konfigurasi Media) Bin Configuration (Konfigurasi Keranjang) 1 Copy (Salin) Copy Defaults (Setelan Default Salin) Fax (Faks) Fax Defaults (Setelan Default Faks) Email E‑mail Setup (Penyiapan Email) E‑mail Defaults (Setelan Default Email) Web Link Setup (Penyiapan Web Link) FTP FTP Defaults (Setelan Default FTP) USB Drive Flash Drive Scan (Pindai dari Flash Drive) Flash Drive Print (Cetak dari Flash Drive) Network/Ports (Port/Jaringan) Tinjauan Jaringan Wireless (Nirkabel) Wi‑Fi Direct Mobile Services Management (Manajemen Layanan Seluler) Ethernet TCP/IP SNMP IPSec 802.1x LPD Configuration (Konfigurasi LPD) HTTP/FTP Settings (Setelan HTTP/FTP) ThinPrint USB Restrict external network access (Batasi akses jaringan eksternal) Security (Keamanan) Login Methods (Metode Login) Schedule USB Devices (Jadwalkan Perangkat USB) Security Audit Log (Log Audit Keamanan) Login Restrictions (Pembatasan Login) Confidential Print Setup (Penyiapan Cetak Rahasia) Encryption (Enkripsi) Erase Temporary Data Files (Hapus File Data Sementara) Solutions LDAP Settings (Setelan Solutions LDAP) Miscellaneous (Lain-lain) Cloud Services (Layanan Cloud) Cloud Services Enrollment (Pendaftaran Layanan Cloud) Reports (Laporan) Menu Settings Page (Halaman Setelan Menu) Device (Perangkat) Print (Cetak) Shortcuts (Pintasan) Fax (Faks) Network (Jaringan) Troubleshooting (Pemecahan Masalah) Print Quality Test Pages (Halaman Percobaan Kualitas Cetak) Cleaning the Scanner (Membersihkan Pemindai) Forms Merge (Gabung Formulir) 2 Forms Merge (Gabung Formulir) peta menu menu printer"},{"UUID":"9bac3819-810d-4655-adc2-acd213fa5f40","title":"Perangkat","link":"preferences-topic.html","desc":"Preferences (Preferensi) Item menu Preferensi","descFull":"Preferences (Preferensi) Item menu Preferensi dan deskripsinya Item Menu Item submenu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Display Language (Bahasa Tampilan) T/A [Daftar Bahasa] Menyetel bahasa yang muncul di tampilan. Country/Region (Negara/Kawasan) T/A [Daftar negara atau kawasan] Mengidentifikasi negara atau kawasan di mana printer diatur untuk beroperasi. Run initial setup (Jalankan penyiapan awal) T/A Off (Nonaktif) * On (Aktif) Menjalankan wizard penyiapan. Keyboard Keyboard Type (Jenis Keyboard) [Daftar Bahasa] Memilih bahasa untuk menulis di keyboard. Semua nilai  Jenis Keyboard Type (Jenis Keyboard)  mungkin tidak muncul atau memerlukan perangkat keras khusus untuk muncul. Date and Time (Tanggal dan Waktu) Configure (Atur) Current Date and Time (Tanggal dan Waktu Saat Ini) Manually Set Date and Time (Menyetel Waktu dan Tanggal secara Manual) Date Format (Format Tanggal) ( BB‑HH‑TTTT *) Time Format (Format Waktu)  ( 12 jam Siang/Malam *) Time Zone (Zona Waktu) DST (GMT) Offset DST Start DST End DST Offset Atur tanggal dan waktu printer serta protokol waktu jaringan. MM‑DD‑YYYY  adalah setelan default perusahaan AS.  HH‑BB‑TTTT  adalah setelan default pabrik internasional. UTC (GMT) Offset ,  DST Start ,  DST End , dan  DST Offset  hanya muncul ketika  Time Zone  disetel ke  (UTC+user) Custom . Key ID  dan  Password  hanya muncul ketika  Enable Authentication  disetel ke  MD5 key . Network Time Protocol Enable NTP  ( Aktif *) NTP Server Enable Authentication (Aktifkan Otentikasi)  ( Tidak ada *) Key ID Password (Kata Sandi) Paper Sizes (Ukuran Kertas) T/A U.S. (AS) * Metric (Metrik) Menentukan satuan ukuran kertas. Negara atau kawasan yang dipilih dalam wizard penyiapan awal menentukan setelah ukuran kertas awal. Screen Brightness (Kecerahan Layar) T/A 20–100%  (100*) Menyesuaikan kecerahan tampilan. Flash Drive Access (Akses Flash Drive) T/A Disabled (Dinonaktifkan) Enabled (Diaktifkan) * Mengaktifkan akses ke fungsi flash drive printer. Allow Background Removal (Izinkan Penghapusan Latar) T/A Off (Nonaktif) On (Aktif) * Menentukan apakah penghapusan layar diizinkan atau tidak. Allow Custom Job scans (Izinkan Pemindaian Tugas Kustom) T/A Off (Nonaktif) On (Aktif) * Menentukan apakah setelan  Custom Job Scanning (Memindai Pekerjaan Kustom)  muncul saat menyalin, memindai, atau faks. Item menu ini hanya muncul ketika drive penyimpanan dipasang. One Page Flatbed Scanning (Pemindaian Flatbed Halam Satu) T/A Off (Nonaktif) * On (Aktif) Menyetel printer untuk memindai jenis pekerjaan apa pun yang menggunakan kaca pemindai sebagai halaman tunggal. Printer kembali ke layar awal setelah menjalankan pekerjaan pindai flatbed tunggal alih-alih menampilkan perintah. Device Sounds (Suara Perangkat) Mute All Sounds (Senyapkan Semua Suara) Off (Nonaktif) * On (Aktif) Mengatur setelan suara printer. Button Feedback (Tombol Umpan Balik) Off (Nonaktif) On (Aktif) * Volume 0–10  (5*) ADF Loaded Beep (Bip Pengisian ADF) Off (Nonaktif) On (Aktif) * Alarm Control (Kontrol Alarm) Off (Nonaktif) Single (Tunggal) * Continuous (Kontinu) Cartridge Alarm (Alarm Kartrid) Off (Nonaktif) Single (Tunggal) * Continuous (Kontinu) Speaker Mode (Mode Speaker) Always Off (Selalu Nonaktif) * Always On (Selalu Aktif) On until Connected (Aktif sampai Tersambung) Ringer Volume (Volume Dering) Off (Nonaktif) * On (Aktif) Screen Timeout (Waktu Layar Habis) T/A 5–300 seconds  (60*) Menyetel waktu diam dalam detik sebelum tampilan menunjukkan layar awal, atau sebelum printer keluar dari akun pengguna secara otomatis. menu Preferensi"},{"UUID":"5427d697-2a6c-4e25-94a0-737836ba5876","title":"Perangkat","link":"preferences-topic.html","desc":"Mode Eco Item menu Eco‑Mode","descFull":"Mode Eco Item menu Eco‑Mode (Mode Eco) dan deskripsinya Item Menu Item submenu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Print (Cetak) Sides (Sisi-sisi) 1‑Sided (2 Sisi) 2‑Sided (1 Sisi) * Menentukan apakah hendak mencetak pada satu atau dua sisi kertas. Pages per Side (Halaman ke Sisi) Off (Nonaktif) * 2 pages per side (2 halaman per sisi) 3 pages per side (2 halaman per sisi) 4 pages per side (2 halaman per sisi) 6 pages per side (2 halaman per sisi) 9 pages per side (2 halaman per sisi) 12 pages per side (2 halaman per sisi) 16 pages per side (2 halaman per sisi) Menentukan jumlah halaman yang akan dicetak pada satu sisi lembar kertas. Toner Darkness (Kegelapan Toner) 1–5  (4*) Menentukan kecerahan atau kegelapan gambar teks. Color Saver (Penyimpan Warna) Off (Nonaktif) * On (Aktif) Menyetel printer untuk mengurangi kadar toner yang ia pakai ketika mencetak grafik atau gambar. Copy (Salin) Sides (Sisi-sisi) 1 sisi ke 1 sisi * 1 sisi ke 2 sisi 2 sisi ke 1 sisi 2 sisi ke 2 sisi Menentukan pola pemindaian berdasarkan dokumen asli. Pages per Side (Halaman ke Sisi) Off (Nonaktif) * 2 Portrait pages (2 Halaman potret) 4 Portrait pages (2 Halaman potret) 2 Landscape pages (2 Halaman lanskap) 4 Landscape pages (2 Halaman lanskap) Menentukan jumlah halaman yang akan disalin pada satu sisi lembar kertas. Darkness (Kegelapan) 1–9  (5*) Menentukan kegelapan gambar teks yang dipindai. menu Mode Eco"},{"UUID":"858d2125-fb30-4ab6-bb1b-6661194fc50a","title":"Perangkat","link":"preferences-topic.html","desc":"Remote Operator Panel (Panel Operator","descFull":"Remote Operator Panel (Panel Operator Jarak Jauh) Item menu Remote Operator Panel (Panel Operator Jarak Jauh) dan deskripsinya Item Menu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. External VNC Connection (Koneksi VNC Eksternal) Don’t Allow (Jangan Izinkan) * Allow (Izinkan) Menyambungkan klien Virtual Network Computing (VNC/Komputasi Jaringan Virtual) eksternal ke panel kontrol jarak jauh. Authentication Type (Jenis Autentikasi) None (Tidak Ada) * Standard Authentication (Autentikasi Standar) Menyetel jenis autentikasi saat mengakses server klien VNC. VNC Password (Kata Sandi VNC) Setelan ditentukan pengguna. Menentukan kata sandi untuk tersambung ke server klien VNC. Item menu ini hanya muncul apabila  Authentication Type (Jenis Autentikasi)  disetel ke  Standard Authentication (Autentikasi Standar) . menu Panel Operator Jarak Jauh"},{"UUID":"0eda2764-aea8-415b-a395-bf31c91988d7","title":"Perangkat","link":"preferences-topic.html","desc":"Notifications (Pemberitahuan) Item menu Notifikasi","descFull":"Notifications (Pemberitahuan) Item menu Notifikasi dan deskripsinya Item Menu Item submenu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. ADF Loaded Beep (Bip Pengisian ADF) T/A Off (Nonaktif) On (Aktif) * Menentukan apakah printer mengeluarkan bunyi khusus jika dokumen asli telah dimasukkan ke dalam ADF. Alarm Control (Kontrol Alarm) T/A Off (Nonaktif) Single (Tunggal) * Continuous (Kontinu) Menyetel berapa kali alarm berbunyi ketika printer memerlukan intervensi pengguna. Supplies (Bahan Pakai) Show Supply Estimates (Tampilkan Estimasi Bahan Pakai) Show estimates (Tampilkan estimasi) * Do not show estimates (Jangan tampilkan estimasi) Menampilkan status estimasi bahan pakai. Cartridge Alarm (Alarm Kartrid) Off (Nonaktif) Single (Tunggal) * Continuous (Kontinu) Menyetel berapa kali alarm berbunyi ketika kartrid toner tinggal sedikit. Staple Alarm (Alarm Stapler) Off (Nonaktif) * Single (Tunggal) Continuous (Kontinu) Menyetel berapa kali alarm berbunyi ketika kartrid pokok habis. Item menu ini hanya muncul ketika lis stapler dipasang. Hole Punch Alarm (Alarm Lis Lubang) Off (Nonaktif) * Single (Tunggal) Continuous (Kontinu) Menyetel berapa kali alarm berbunyi ketika wadah lis lubang penuh atau tidak ada. Item menu ini hanya muncul ketika lis lubang stapler dipasang. E‑mail Alerts Setup (Penyiapan Pemberitahuan Email) Primary SMTP Gateway (Gateway SMTP Utama) Setelan ditentukan pengguna. Tulis alamat IP atau nama host server SMTP utama. Primary SMTP Gateway Port (Port Gateway SMTP Utama) 1–65535  (25*) Masukkan nomor port server SMTP utama. Secondary SMTP Gateway (Gateway SMTP Sekunder) Setelan ditentukan pengguna. Tulis alamat IP atau nama host server SMTP sekunder. Secondary SMTP Gateway Port (Port Gateway SMTP Sekunder) 1–65535  (25*) Memasukkan nomor port server SMTP sekunder. SMTP Timeout (Waktu SMTP Habis) 5–30 seconds  (30*) Tentukan waktu tunggu server SMTP sebelum SMTP berhenti mengirim email. Reply Address (Alamat Balasan) Setelan ditentukan pengguna. Menentukan alamat balasan pada email Always use SMTP default Reply Address (Selalu gunakan Alamat Balasan default SMTP) On (Aktif) Off (Nonaktif) * Selalu gunakan alamat balasan default di server SMTP. Use SSL/TLS (Gunakan SSL/TLS) Disabled (Dinonaktifkan) * Negotiate (Negosiasi) Required (Diperlukan) Mengirim email dengan tautan terenkripsi. Require Trusted Certificate (Memerlukan Sertifikat Tepercaya) On (Aktif) * Off (Nonaktif) Menentukan sertifikat tepercaya ketika mengakses server SMTP. Item Menu Item submenu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Email Alerts Setup (Penyiapan Pemberitahuan Email) SMTP Server Authentication (Autentikasi Server SMTP) No authentication required (Tidak diperlukan otentikasi) * Login/Plain NTLM CRAM-MD5 Digest-MD5 Kerberos 5 Menyetel jenis otentikasi untuk server SMTP. Device‑Initiated Email (Email Dipicu Perangkat) None (Tidak Ada) * Gunakan Kredensial SMTP Perangkat Menentukan apakah diperlukan kredensial untuk email dipicu perangkat. User‑Initiated Email (Email Dipicu Pengguna) None (Tidak Ada) * Gunakan Kredensial SMTP Perangkat Use Session User ID & Password (Gunakan ID Pengguna Sesi & Kata Sandi) Use Session Email Address and Password (Gunakan Alamat Email Sesi dan Kata Sandi) Prompt user (Perintah Pengguna) Menentukan apakah diperlukan kredensial untuk email dipicu pengguna. Use Active Directory Device Credentials (Gunakan Kredensial Perangkat Direktori Aktif) On (Aktif) Off (Nonaktif) * Mengaktifkan kredensial pengguna dan destinasi grup untuk tersambung ke server SMTP. Device Userid (ID Pengguna Perangkat) Setelan ditentukan pengguna. Menentukan ID pengguna untuk masuk ke server SMTP. Device Password (Kata Sandi Perangkat) Setelan ditentukan pengguna. Menentukan kata sandi untuk masuk ke server SMTP. Kerberos 5 REALM Setelan ditentukan pengguna. Menentukan realm untuk protokol otentikasi Kerberos 5. NTLM Domain Setelan ditentukan pengguna. Menentukan nama domain untuk protokol keamanan NTLM. Disable \"SMTP server not set up\" error (Nonaktifkan eror “Server SMTP belum disiapkan”) On (Aktif) Off (Nonaktif) * Menonaktifkan pesan eror tentang penyiapan server SMTP. Setup Email Lists and Alerts (Penyiapan Daftar dan Pemberitahuan Email) Setelan ditentukan pengguna. Menentukan alamat email dan mengaktifkan pemberitahuan email. Item menu ini hanya muncul di Embedded Web Server. Error Prevention (Pencegahan Eror) ADF Multifeed Sensor Off (Nonaktif) On (Aktif) * Menyetel printer untuk mendeteksi penarik ADF apabila menarik lebih dari satu lembar secara bersamaan. Auto Continue (Otomatis Lanjutkan) Off (Nonaktif) On (Aktif) * Menyetel printer untuk melanjutkan pemrosesan atau pencetakan secara otomatis setelah membersihkan beberapa kondisi tertentu. Jika disetel ke  On (Aktif) , setelan default adalah 5 detik. Auto Reboot (Otomatis Mulai Ulang) Reboot when idle (Mulai ulang ketika diam) Reboot always (Selalu mulai ulang) * Reboot never (Jangan pernah mulai ulang) Menyetel printer untuk memulai ulang apabila terjadi eror. Max Auto Reboots (Otomatis Mulai Ulang Maksimal) 1–20  (2*) Menyetel berapa kali mulai ulang otomatis yang akan dilakukan oleh printer. Auto Reboot Window (Otomatis Mulai Ulang Window) 1–525600  (720*) Menyetel berapa detik sebelum printer mulai ulang otomatis. Auto Reboot Counter (Penghitung Mulai Ulang Otomatis) Setelan ini adalah informasi hanya baca. Menampilkan berapa kali mulai ulang otomatis yang harus dilakukan oleh printer. Display Short Paper Error (Tampilkan Eror Kertas Pendek) On (Aktif) Auto‑clear (Bersihkan Otomatis) * Menyetel printer untuk menampilkan pesan ketika terjadi eror kertas pendek. Kertas pendek di sini maksudnya ukuran kertas yang dimasukkan. Page Protect (Perlindungan Halaman) Off (Nonaktif) * On (Aktif) Menyetel printer untuk memproses seluruh halaman ke dalam memori sebelum mencetak. Jam Content Recovery (Pemulihan Konten Macet) Jam Recovery (Pemulihan Kemacetan) Off (Nonaktif) On (Aktif) Auto (Otomatis) * Menyetel printer untuk mencetak ulang halaman yang macet. Scanner Jam Recovery (Pemulihan Kemacetan Pemindai) Job level (Level pekerjaan) Page level (Level halaman) * Menentukan cara memulai ulang pekerjaan pindai setelah menyelesaikan kemacetan kertas. menu Pemberitahuan"},{"UUID":"fb1d0477-174c-4604-9015-b428c770fdca","title":"Perangkat","link":"preferences-topic.html","desc":"Power Management (Manajemen Daya) Item","descFull":"Power Management (Manajemen Daya) Item menu Power Management dan deskripsinya Item Menu Item submenu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Sleep Mode Profile (Profil Mode Tidur) Print from Sleep Mode (Cetak dari Mode Tidur) Stay awake after printing (Tetap terjaga setelah mencetaka) Enter Sleep Mode after printing (Masuk Mode Tidur setelah mencetak) * Menyetel printer agar tetap bangun atau masuk  Mode Tidur  setelah mencetak. Touch to Wake from Deep Sleep (Sentuh untuk Bangun dari Tidur Dalam) Off (Nonaktif) On (Aktif) * Bangunkan printer dari  Deep Sleep Mode (Mode Tidur Dalam) . Timeouts (Waktu Habis) Sleep Mode (Mode Tidur) 1–114 menit  (15*) Setel waktu diam sebelum printer mulai beroperasi dalam  Mode Tidur . Hibernate Timeout (Waktu Hibernasi Habis) Disabled (Dinonaktifkan) 1 hour (1 jam) 2 hour (6 jam) 3 hour (6 jam) 6 hour (6 jam) 1 day (1 hari) 2 days (2 hari) 3 days (3 hari) * 1 week (1 pekan) 2 week (2 pekan) 1 month (1 bulan) Setel waktu sebelum printer nonaktif. Hibernate Timeout on Connection (Waktu Hibernasi Habis dalam Sambungan) Hibernate (Hibernasi) Do Not Hibernate (Jangan Hibernasi) * Setel  Hibernate Timeout (Waktu Hibernasi Habis)  untuk menonaktifkan printer ketika sambungan Ethernet aktif masih ada. Schedule Power Modes (Jadwalkan Mode Daya) Schedules (Jadwal) Add New Schedule (Tambah Jadwal Baru) Jadwalkan printer kapan masuk  Mode Tidur  atau mode  Hibernasi . menu Manajemen Daya"},{"UUID":"0ad6643e-04d4-4b8e-bd75-0290b9efaa8c","title":"Perangkat","link":"preferences-topic.html","desc":"Share Data with Lexmark (Berbagi","descFull":"Share Data with Lexmark (Berbagi Data dengan Lexmark) Item menu Share Data with Lexmark (Berbagi Data dengan Lexmark) dan deskripsinya Item Menu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Share Data with Lexmark (Berbagi Data dengan Lexmark) Yes (Ya) No (Tidak) * Mengirim informasi performa dan penggunaan printer ke Lexmark. Share Data Send Time (Berbagi Data Waktu Kirim) Start Time (Waktu Mulai) Stop Time (Waktu Henti) Pilih jendela waktu untuk pengumpulan dan transmisi data. Share Data Send Time  hanya muncul apabila Anda memilih  Yes (Ya)  pada  Share Data with Lexmark . menu Berbagi Data dengan Lexmark"},{"UUID":"531609d8-7f54-42d4-bdfa-56c33306c6eb","title":"Perangkat","link":"preferences-topic.html","desc":"Accessibility (Aksesibilitas) Item menu Aksesibilitas","descFull":"Accessibility (Aksesibilitas) Item menu Aksesibilitas dan deskripsinya Item Menu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Duplicate Key Strike Interval (Interval Penekanan Tombol Duplikat) 0,00–5,00  (0,00*) Menentukan interval dalam detik yang di dalamnya printer akan mengabaikan penekanan duplikat pada tombol kibor printer. Key Repeat Initial Delay (Penundaan Awal Pengulangan Tombol) 0,25–5,00  (1,00*) Menentukan waktu tunda awal dalam detik sebelum satu tombol kibor ditekan berulang. Key Repeat Rate (Kecepatan Pengulangan Tombol) 0,5–30,0  (30,0*) Mengatur jumlah penekanan per detik untuk pengulangan tombol. Prolong Screen Timeout (Perpanjang Waktu Layar Habis) Off (Nonaktif) * On (Aktif) Izinkan pengguna tetap di lokasi yang sama dan menyetel ulang pengatur waktu  Screen Timeout (Waktu Layar Habis)  ketika hampir habis, bukan malah kembali ke layar awal. Headphone Volume 1–10  (5*) Sesuaikan volume headphone. Enable Voice Guidance When Headphone is Attached (Aktifkan Panduan Suara ketika Headphone Dipasang) Off (Nonaktif) * On (Aktif) Aktifkan Panduan Suara ketika jack headphone terpasang di perangkat. Speak Passwords/PINs (PIN/Kata Sandi Berbicara) Off (Nonaktif) * On (Aktif) Menyetel printer untuk membacakan kata sandi dan nomor identifikasi pribadi (PIN). Speech Rate (Kecepatan Bicara) Very Slow (Sangat Lambat) Slow (Lambat) Normal * Fast (Cepat) Faster (Lebih Cepat) Very Fast (Sangat Cepat) Rapid (Kencang) Very Rapid (Sangat Kencang) Fastest (Paling Cepat) Menyetel kecepatan bicara Voice Guidance (Panduan Suara) menu Aksesibilitas"},{"UUID":"5c18bd63-c759-446a-b338-69e7264d6e50","title":"Perangkat","link":"preferences-topic.html","desc":"Restore Factory Defaults (Pulihkan ke","descFull":"Restore Factory Defaults (Pulihkan ke Setelan Default) Item menu Restore Factory Defaults (Pulihkan ke Setelan Default) dan deskripsinya Item Menu Setelan Deskripsi Restore Settings (Pulihkan Setelan) Restore all settings (Pulihkan semua setelan) Restore printer settings (Pulihkan setelan printer) Restore network settings (Pulihkan setelan jaringan) Restore fax settings (Pulihkan setelan faks) Restore app settings (Pulihkan setelan aplikasi) Memulihkan printer ke setelan default pabrik. menu Pulihkan ke Setelan Default"},{"UUID":"82d08903-9c60-41f3-8c07-da96429679bd","title":"Perawatan","link":"preferences-topic.html","desc":"Configuration Menu (Menu Konfigurasi) Item","descFull":"Configuration Menu (Menu Konfigurasi) Item Menu Konfigurasi dan deskripsinya Item Menu Item submenu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. USB Configuration (Konfigurasi LPD) USB PnP 1 * 2 Mengganti mode driver USB printer untuk meningkatkan kompatibilitas dengan PC. USB Scan to Local (Pindai USB ke Lokal) On (Aktif) * Off (Nonaktif) Menyetel apakah driver perangkat USB termasuk perangkat sederhana USB (antarmuka tunggal) atau perangkat Komposit USB (antarmuka ganda). USB Speed (Kecepatan USB) Full (Penuh) Auto (Otomatis) * Menyetel port USB agar berjalan dengan kecepatan penuh dan menonaktifkan kapabilitas kecepatan tinggi. Tray Configuration (Konfigurasi Baki) Size Sensing (Deteksi Ukuran) Deteksi Baki [x]  ( On/Aktif *) Menyetel baki agar otomatis mendeteksi ukuran kertas yang dimasukkan ke dalamnya. Tray Linking (Penyambungan Baki) Automatic (Otomatis) * Off (Nonaktif) Menyetel printer agar menyambungkan beberapa baki yang memiliki setelan ukuran dan jenis kertas yang sama. Show Tray Insert Message (Tampilkan Pesan Masukkan Baki) Off (Nonaktif) Only for unknown sizes (Hanya untuk ukuran yang tidak diketahui) * Always (Selalu) Menampilkan pesan yang mengizinkan pengguna mengganti setelan ukuran dan jenis kertas setelah memasukkan baki. Paper Prompts (Perintah Kertas) Auto (Otomatis) * Multipurpose Feeder (Feeder multiguna) Manual Paper (Kertas Manual) Menyetel sumber kertas yang diisi pengguna ketika muncul perintah untuk memasukkan kertas. Supaya  Multipurpose Feeder (Pengumpan Serba Guna)  muncul, pada menu  Paper (Kertas) , setel  Configure MP (Atur MP)  ke  Cassette (Kaset) . Envelope Prompts (Perintah Amplop) Auto (Otomatis) * Multipurpose Feeder (Feeder multiguna) Manual Envelope (Amplop Manual) Menyetel sumber kertas yang diisi pengguna ketika muncul perintah untuk memasukkan amplop. Supaya  Multipurpose Feeder (Pengumpan Serba Guna)  muncul, pada menu  Paper (Kertas) , setel  Configure MP (Atur MP)  ke  Cassette (Kaset) . Action for Prompts (Tindakan untuk Perintah) Prompt user (Perintah pengguna) * Continue (Lanjutkan) Use current (Gunakan saat ini) Menyetel printer untuk menyelesaikan perintah terkait perubahan kertas atau amplop. Multiple Universal Sizes (Beberapa Ukuran Universal) Off (Nonaktif) * On (Aktif) Menyetel baki agar mendukung beberapa ukuran kertas universal. Reports (Laporan) T/A Menu Settings Page (Halaman Setelan Menu) Event Log (Log Acara) Event Log Summary (Ringkasan Log Acara) Mencetak laporan tentang log acara, status, dan setelan menu printer. Supply Usage And Counters (Penghitung dan Pemakaian Bahan Pakai) Clear Supply Usage History (Bersihkan Riwayat Penggunaan Bahan Pakai) Start (Mulai) Menyetel ulang riwayat penggunaan bahan pakai ke setelan pabrik. ITM Reset (Setel Ulang ITM) Start (Mulai) Reset penghitung setelah memasang item bahan pakai atau kit perawatan baru. Reset Black Cartridge Counter (Setel Ulang Penghitung Kartrid Hitam) Start (Mulai) Reset Cyan Cartridge Counter (Setel Ulang Penghitung Kartrid Cyan) Start (Mulai) Reset Magenta Cartridge Counter (Setel Ulang Penghitung Kartrid Magenta) Start (Mulai) Reset Yellow Cartridge Counter (Setel Ulang Penghitung Kartrid Kuning) Start (Mulai) Reset Black Imaging Unit Counter (Setel Ulang Penghitung Unit Pencitraan Hitam) Start (Mulai) Reset Color Imaging Unit Counter (Setel Ulang Penghitung Unit Pencitraan Warna) Start (Mulai) Reset MPF Roller Kit Counter (Setel ulang Penghitung Kit Penarik MPF) Start (Mulai) Setel ulang Penghitung Kit Penarik 1500 Lembar Start (Mulai) Reset Roller Kit Counter (Setel Ulang Penghitung Kit Penarik) Start (Mulai) Tiered Coverage Ranges (Rentang Cakupan Berjenjang) Tiered Coverage Metrics (Metrik Cakupan Berjenjang)  ( Show/Tampilkan *) Menampilkan bagian Tiered Coverage Billing (Daftar Cakupan Berjenjang) pada laporan Statistik Perangkat. Tiered Coverage Ranges (Rentang Cakupan Berjenjang) Large Media Adjustments (Penyesuaian Media Besar) Off (Nonaktif) * On (Aktif) Mengizinkan penyesuaian ketika mencetak di kertas tebal atau besar. Printer Emulations (Emulasi Printer) PPDS Emulation (Emulasi PCL) Off (Nonaktif) * On (Aktif) Menyetel printer untuk mengenali dan menggunakan aliran data PPDS. PS Emulation (Emulasi PCL) Off (Nonaktif) On (Aktif) * Menyetel printer untuk mengenali dan menggunakan aliran data PS. Enable Formsmerge (Aktifkan Formsmerge) Off (Nonaktif) * On (Aktif) Mengaktifkan Forms Merge (Gabung Formulir). Lisensi Formsmerge harus diinstal. Memori flash pengguna harus diinstal. Enable Prescribe (Aktifkan Prescribe) Off (Nonaktif) * On (Aktif) Mengaktifkan bahasa printer PRESCRIBE. Lisensi PRESCRIBE harus diinstal. Emulator Security (Keamanan Emulator) Page Timeout (Waktu Halaman Habis)  (60*) Menyetel waktu halaman habis selama emulasi. Reset Emulator After Job (Setel Ulang Emulator setelah Pekerjaan)  ( Off/Nonaktif *) Menyetel ulang emulator setelah pekerjaan cetak. Disable Printer Message Access (Nonaktifkan Akses Pesan Printer)  ( Aktif *) Menentukan apakah emulator bisa mengakses setelan awal printer atau tidak Fax Configuration (Konfigurasi Faks) Fax Low Power Support (Dukungan Daya Rendah Faks) Disable Sleep (Nonaktifkan Mode Tidur) Permit Sleep (Izin Tidur) Auto (Otomatis) * Tentukan apakah printer mendukung fungsi faks dengan arsitektur daya rendah. Fax Storage Location (Lokasi Penyimpanan Faks) Disk * NAND Menyetel lokasi penyimpanan untuk semua faks. Item menu ini hanya muncul ketika drive penyimpanan dipasang. Print Configuration (Konfigurasi Cetak) Black Only Mode (Mode Hanya Hitam) Off (Nonaktif) * On (Aktif) Cetak pekerjaan non-salin dalam skala abu-abu. Color Trapping (Penangkapan Warna) Off (Nonaktif) 1 2 * 3 4 5 Meningkatkan hasil cetak untuk mengimbangi kesalahan pendaftaran pada printer. Font Sharpening (Penajaman Font) 0–150  (24*) Menyetel nilai ukuran titik suatu teks di bawah layar frekuensi tinggi dan menggunakannya ketika mencetak data font. Misal, jika angka yang ditunjukkan adalah 24, itu artinya semua font ukuran 24 ke bawah akan menggunakan layar frekuensi tinggi. Use Native ISD Fonts (Gunakan Font ISD Asli) On (Aktif) * Off (Nonaktif) Mengizinkan pengguna untuk memilih apakah akan memakai font gratis yang ada di drive penyimpanan intelijen (ISD). Item menu ini hanya muncul ketika ISD diinstal. Device Operations (Operasi Perangkat) Quiet Mode (Mode Sunyi) Off (Nonaktif) * On (Aktif) Menyesuaikan jumlah noise yang harus dikurangi oleh printer. Mengaktifkan setelan ini akan memperlambat kinerja printer secara keseluruhan. Enable Burst Mode (Aktifkan Mode Rentetan) On (Aktif) * Off (Nonaktif) Setel printer untuk mempercepat satu halaman dan biasanya hal itu di halaman pertama dari beberapa halaman supaya pekerjaan bisa selesai lebih cepat. Item menu ini hanya muncul di beberapa model printer. Safe Mode (Mode Aman) Off (Nonaktif) * On (Aktif) Menyetel printer agar beroperasi di mode spesial, sehingga printer akan terus menawarkan beragam fitur, meskipun printer mengalami banyak masalah. Misal, ketika disetel  On/Aktif  lalu motor dupleks tidak berfungsi, printer akan menjalankan fungsi pencetakan satu sisi meskipun pada mulanya printer disetel untuk menjalankan pencetakan dua sisi. Pencetakan dengan setelan ini hanya bisa dilakukan dari feeder multiguna. Minimum Copy Memory (Memori Salin Minimal) 20 MB 30 MB 50 MB 80 MB * 100 MB Menyetel alokasi memori minimal untuk menyimpan pekerjaan fotokopi. Clear Custom Status (Bersihkan Status Bebas) Start (Mulai) Hapus string pengguna untuk pesan bebas  Default  atau  Alternate (Alternatif) . Clear all remotely‑installed messages (Bersihkan semua pesan instal jarak jauh) Start (Mulai) Menghapus pesan yang diinstal dari jarak jauh. Automatically Display Error Screens (Otomatis Menampilkan Layar Eror) Off (Nonaktif) On (Aktif) * Menampilkan pesan eror pada layar setelah printer tetap aktif di layar awal selama waktu yang panjang. Honor orientation on fast path copy (Pakai orientasi pada salin jalur cepat) Off (Nonaktif) * On (Aktif) Mengaktifkan printer untuk menggunakan setelan orientasi di bawah menu  Copy (Salin)  ketika mengirim pekerjaan fotokopi cepat. Service Nonvolatile Memory (Memori Tetap Layanan) Encryption Status (Status Enkripsi) Menampilkan status enskripsi drive penyimpanan. Encrypt Service Nonvolatile Memory (Enkripsikan Memori Tetap Layanan) Mengaktifkan enkripsi cermin secara manual. Toner patch sensor setup (Setelan sensor patch toner) Calibration frequency preference (Preferensi frekuensi kalibrasi) Disabled (Dinonaktifkan) Fewest color adjustments (Penyesuaian warna paling sedikit) Fewer color adjustments (Penyesuaian warna lebih sedikit) Normal * Better color accuracy (Akurasi warna lebih baik) Best color accuracy (Akurasi warna terbaik) Mengatur printer agar menurunkan jumlah toner yang tepat untuk menjaga konsistensi warna. Full calibration (Kalibrasi penuh) Start (Mulai) Menjalankan kalibrasi warna penuh. Print TPS information page (Halaman informasi TPS printer) Start (Mulai) Mencetak halaman diagnostik yang berisi informasi kalibrasi sensor patch toner. App Configuration (Konfigurasi Aplikasi) LES Applications (Aplikasi LES) Off (Nonaktif) On (Aktif) * Mengaktifkan aplikasi Lexmark Embedded Solutions (LES). Scanner Configuration (Konfigurasi Pemindai) Scanner Manual Registration (Registrasi Manual Pemindai) Print Quick Test (Percobaan Cetak Cepat) Front ADF Registration (Registrasi ADF Depan) Rear ADF Registration (Registrasi ADF Belakang) Flatbed Registration (Registrasi Flatbed) Mencetak halaman target Quick Test, atau melakukan registrasi manual terhadap flatbed dan pengumpan dokumen otomatis (ADF) setelah mengganti ADF, kaca pemindai, atau papan kontroler. Ketika mencetak halaman target Quick Test, pastikan jarak margin pada halaman target adalah seragam di semua sektor target. Jika tidak, margin printer harus disetel ulang. Reset Maintenance Counter (Setel Ulang Penghitung Perawatan) Resetting ADF Maintenance Counter (Setel Ulang Penghitung Perawatan ADF)  ( Start/Mulai ) Menyetel ulang penghitung setelah mengganti kit perawatan ADF. Edge Erase (Tepi Penghapusan) Flatbed Edge Erase (Tepi Flatbed Penghapusan)  (3*) ADF Edge Erase (Tepi ADF Penghapusan)  (3*) Menyetel area non-cetak di sekitar ADF atau pekerjaan pindai flatbed dalam milimeter. ADF Deskew ADF Electronic Deskew  ( On/Aktif *) Mengurangi kemiringan dokumen yang dipindai dari ADF. Disable Scanner (Nonaktifkan Pemindai) No (Tidak) * Yes (Ya) ADF Only (Hanya ADF) Menonaktifkan pemindai ketika ia tidak bekerja dengan benar. Tiff Byte Order CPU Endianness Little Endian Big Endian Menyetel urutan bit dari output pindai TFF-format. Exact Tiff Rows Per Strip (Tentukan Baris Tiff Per Garis) On (Aktif) * Off (Nonaktif) Menyetel nilai tag Baris Per Garis dari output pindai TIFF-format. Scanner Glass Cleaning Threshold (Ambang Batas Pembersihan Kaca Pemindai) 1000–30000  (10000*) Setel angka pindai sebelum pengguna mendapat perintah untuk membersihkan kaca pemindai. menu Menu Konfigurasi"},{"UUID":"79b14846-e0c4-43f1-bb82-b320c8c53296","title":"Perawatan","link":"preferences-topic.html","desc":"Out of Service Erase (Penghapusan","descFull":"Out of Service Erase (Penghapusan di Luar Layanan) Item menu Out of Service Erase dan deskripsinya Item Menu Item submenu Setelan Deskripsi Out of Service Erase (Penghapusan di Luar Layanan) Memory Last Sanitized (Terakhir Memori Dibersihkan) Setelan ini adalah informasi hanya baca. Menampilkan kapan terakhir kali memori printer dihapus. Hard Disk Last Sanitized (Terakhir Hard Disk Dibersihkan) Setelan ini adalah informasi hanya baca. Menampilkan kapan terakhir kali hard disk dihapus. Item menu ini hanya muncul ketika hard disk sudah dipasang. ISD last erased (Terakhir ISD Dihapus) Setelan ini adalah informasi hanya baca. Menampilkan kapan terakhir kali drive penyimpanan intelijen (ISD) dihapus. Item menu ini hanya muncul ketika ISD diinstal. Sanitize all information on nonvolatile memory (Bersihkan semua informasi tentang memori tetap) Erase all printer and network settings (Hapus semua setelan jaringan dan printer) Erase all apps and app settings (Hapus semua aplikasi dan setelan aplikasi) Erase all shortcuts and shortcut settings (Hapus semua pintasan dan setelan pintasan) Bersihkan semua informasi di memori tetap Sanitize all information on hard disk (Hapus semua informasi di hard disk) Erase downloads (Erase all macros, fonts, PFOs, etc.) (Hapus unduhan [Hapus semua makro, font, PFO, dll]) Erase buffered jobs (Hapus pekerjaan singgahan) Erase Held Jobs (Hapus Pekerjaan Ditahan) Hapus semua informasi di hard disk. Item menu ini hanya muncul ketika hard disk sudah dipasang. Erase Intelligent Storage Drive (Hapus Drive Penyimpanan Intelijen) Erase (Hapus) Membersihkan semua informasi di ISD. Item menu ini hanya muncul ketika ISD diinstal. menu Penghapusan di Luar Layanan"},{"UUID":"ca0b682a-cc11-4ebc-92ce-d5685da0d320","title":"Perangkat","link":"preferences-topic.html","desc":"Update firmware (Perbarui firmware) Item","descFull":"Update firmware (Perbarui firmware) Item menu Update firmware (Perbarui firmware) dan deskripsinya Item Menu Setelan Deskripsi Current Version (Versi Saat Ini) Setelan ini adalah informasi hanya baca. Menampilkan versi firmware yang saat ini diinstal di printer. Check for updates now (Periksa pembaruan sekarang) Install now (Instal sekarang) Install later (Instal nanti) Memeriksa pembaruan firmware. Auto check for updates (Periksa otomatis pembaruan) On (Aktif) Off (Nonaktif) * Menyetel printer untuk memeriksa pembaruan firmware secara otomatis. menu Perbarui firmware"},{"UUID":"46b459ab-cf17-4c5c-875e-0f2a83d4efb4","title":"Perangkat","link":"preferences-topic.html","desc":"About this Printer (Tentang Printer","descFull":"About this Printer (Tentang Printer Ini) Item menu About this Printer (Tentang Printer Ini) dan deskripsinya Item Menu Deskripsi Asset Tag (Tanda Aset) Untuk mengetahui identitas printer. Printer’s Location (Lokasi Printer) Untuk mengetahui lokasi printer. Contact (Kontak) Untuk mengetahui informasi kontak printer. Firmware Version (Versi Firmware) Menampilkan versi firmware yang diinstal di printer. Engine (Mesin) Menampilkan nomor mesin printer. Nomor Seri Menampilkan nomor seri printer. Export Configuration File to USB (Ekspor File Konfigurasi ke USB) Mengekspor file konfigurasi ke flash drive. Export Compressed Logs to USB (Ekspor Log Kompresi ke USB) Mengekspor file log kompresi ke flash drive. Send Logs (Kirim Log) Mengirim informasi log printer ke Lexmark. menu Tentang Printer Ini"},{"UUID":"d2ac516f-6da6-49e2-acbe-8446be39abbc","title":"Cetak","link":"layout-topic.html","desc":"Layout (Tata Letak) Item menu","descFull":"Layout (Tata Letak) Item menu Layout (Tata Letak) dan deskripsinya Item Menu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Sides (Sisi-sisi) 1‑Sided (2 Sisi) 2‑Sided (1 Sisi) * Menentukan apakah hendak mencetak pada satu atau dua sisi kertas. Flip Style (Model Lipat) Long Edge (Tepi Panjang) * Short Edge (Tepi Pendek) Menentukan sisi kertas mana yang akan dijilid saat mencetak dua sisi. Blank Pages (Halaman Kosong) Print (Cetak) Do Not Print (Jangan Cetak) * Mencetak halaman kosong dalam pekerjaan cetak. Collate (Susun) Off (1,1,1,2,2,2) On (1,2,1,2,1,2) * Menjaga agar halaman pekerjaan cetak tertumpuk secara urut, khususnya saat mencetak beberapa salinan pekerjaan. Separator Sheets (Lembaran Pemisah) None (Tidak Ada) * Between Copies (Di Sela Salinan) Between Jobs (Di Sela Pekerjaan) Between Pages (Di Sela Halaman) Memasukkan lembar pemisah kosong saat mencetak. Separator Sheet Source (Sumber Lembar Pemisah) Tray (Baki)  [x] (1*) Multipurpose Feeder (Feeder multiguna) Menentukan sumber kertas untuk lembar pemisah. Pages per Side (Halaman ke Sisi) Off (Nonaktif) * 2 pages per side (2 halaman per sisi) 3 pages per side (2 halaman per sisi) 4 pages per side (2 halaman per sisi) 6 pages per side (2 halaman per sisi) 9 pages per side (2 halaman per sisi) 12 pages per side (2 halaman per sisi) 16 pages per side (2 halaman per sisi) Mencetak beberapa gambar halaman pada satu sisi lembar kertas. Pages per Side (Halaman per Sisi) Horizontal (Horisontal) * Reverse Horizontal (Horisontal Terbalik) Vertical (Vertikal) Reverse Vertical (Vertikal Terbalik) Menentukan posisi beberapa gambar halaman saat memakai menu  Pages per Side (Halaman per Sisi) . Pages per Side Orientation (Halaman per Orientasi Sisi) Auto (Otomatis) * Landscape (Lanskap) Portrait (Potret) Menentukan orientasi beberapa gambar halaman saat memakai menu  Pages per Side (Halaman per Sisi) . Pages per Side Border (Halaman per Batas Sisi) None (Tidak Ada) * Solid (Penuh) Mencetak batas di sekeliling masing-masing gambar halaman ketika memakai menu  Pages per Side (Halaman per Sisi) . Copies (Beberapa Salinan) 1–9999  (1*) Menyetel jumlah salinan dalam setiap pekerjaan cetak. Print Area (Area Cetak) Normal * Fit to page (Pas dengan halaman) Whole Page (Seluruh Halaman) Menyetel area cetak pada satu lembar kertas. menu Layout (Tata Letak)"},{"UUID":"402447c4-ae65-4cdb-a572-8b9b741a218a","title":"Cetak","link":"layout-topic.html","desc":"Finishing (Penyelesaian) Item menu Finishing","descFull":"Finishing (Penyelesaian) Item menu Finishing (Penyelesaian) dan deskripsinya Item Menu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Staple Job (Pemasangan Staple) Off (Nonaktif) * 1 staple, pojok kiri atas 2 staple, kiri 1 staple, pojok kanan atas 2 staple, atas 1 staple, pojok kiri bawah 2 staple, bawah 1 staple, pojok kanan bawah 2 staple, kanan Menentukan posisi staple untuk semua pekerjaan cetak. Item menu ini hanya muncul ketika lis stapler dipasang. Staple Test (Staple Percobaan) Start (Mulai) Menentukan apakah lis stapler berfungsi dengan baik atau tidak. Item menu ini hanya muncul ketika lis stapler dipasang. Lis Lubang Off (Nonaktif) * On (Aktif) Membuat lubang di sepanjang tepi hasil cetak. Item menu ini hanya muncul ketika lis lubang stapler dipasang. Hole Punch Mode (Mode Lis Lubang) 2 lubang 3 lubang 4 lubang Menyetel mode pelubangan untuk hasil cetak. 3 lubang  adalah setelan default perusahaan AS.  4 lubang  adalah setelan default perusahaan internasional. Item menu ini hanya muncul ketika lis lubang stapler atau lis buklet dipasang. Halaman Ofset None (Tidak Ada) * Between Copies (Di Sela Salinan) Between Jobs (Di Sela Pekerjaan) Menyusun output atau salinan dari suatu pekerjaan cetak. Between Copies (Di Sela-sela Salinan)  menyusun setiap salinan dari suatu pekerjaan cetak apabila  Collate  disetel ke  On [1,2,1,2,1,2] . Jika  Collate  disetel ke  Off [1,1,1,2,2,2] , maka setiap kumpulan hasil cetak akan disusun berdasarkan kesamaan nomor halaman. Between Jobs (Di Sela-sela Pekerjaan)  menyetel posisi ofset yang sama untuk seluruh pekerjaan cetak, terlepas dari berapa jumlah salinan yang dicetak. menu Finishing"},{"UUID":"94e16b57-ae73-4154-a4c0-ce21e596e0bb","title":"Cetak","link":"layout-topic.html","desc":"Setup (Penyiapan) Item menu Setup","descFull":"Setup (Penyiapan) Item menu Setup (Penyiapan) dan deskripsinya Item Menu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Printer Language (Bahasa Printer) PCL Emulation (Emulasi PCL) PS Emulation (Emulasi PS) Menyetel bahasa printer. Menyetel bahasa printer default tidak akan menghambat program perangkat lunak dalam mengirim pekerjaan cetak yang menggunakan bahasa printer lain. Job Waiting (Pekerjaan Menunggu) Off (Nonaktif) * On (Aktif) Menyimpan pekerjaan cetak yang memerlukan bahan pakai sehingga pekerjaan yang tidak kehabisan bahan pakai bisa terus berjalan. Item menu ini hanya muncul ketika drive penyimpanan dipasang. Job Hold Timeout (Waktu Tunda Pekerjaan Habis) 0–255  (30*) Menyetel waktu dalam detik agar printer bisa menunggu intervensi pengguna sebelum menunda pekerjaan yang sedang kehabisan sumber daya. Item menu ini hanya muncul ketika drive penyimpanan dipasang. Download Target (Target Download) RAM * Flash Disk Menentukan di mana hendak menyimpan semua sumber daya permanen yang telah didownload ke printer. Item menu ini hanya muncul ketika drive penyimpanan dipasang. Printer Usage (Penggunaan Printer) Max Speed (Kecepatan Maks) Max Yield (Hasil Maks) * Menentukan apakah perangkat keras retraksi melepaskan atau mengaktifkan unit pengembang warna selama mencetak. Jika disetel ke  Hasil Maks , perangkat keras tetap terhubung dengan unit pengembang warna ketika printer dalam keadaan siaga. Jika disetel ke  Kecepatan Maks , perangkat keras tetap terhubung dengan unit pengembang warna terlepas dari apakah pekerjaan berisi konten hitam atau warna. Low‑Speed Printer Usage (Penggunaan Printer Kecepatan Rendah) Max Yield (Hasil Maks) * Max Speed (Kecepatan Maks) Izinkan printer beralih antara hasil tinggi (hitam) dan kecepatan tinggi (warna) ketika berjalan pada kecepatan rendah. Setelan ini hanya mengubah perilaku printer ketika mesin berjalan pada kecepatan proses 25 halaman per menit. Ia tidak akan memberi pengaruh apa-apa ketika mesin berjalan pada kecepatan yang lebih tinggi. Resource Save (Simpan Sumber Daya) Off (Nonaktif) * On (Aktif) Menentukan tindakan printer terhadap sumber daya yang didownload ketika printer menerima pekerjaan yang memerlukan kapasitas memori yang lebih besar dari yang ada. Ketika disetel ke  Off (Nonaktif) , printer akan menahan sumber daya yang didownload sampai memori tersedia. Sumber daya yang berkaitan dengan bahasa printer nonaktif akan dihapus. Ketika disetel ke posisi  On (Aktif) , printer akan menyimpan semua sumber daya permanen yang didownload di semua pilihan bahasa. Ketika dibutuhkan, printer akan menampilkan pesan memori penuh, bukan menghapus sumber daya permanen. Print All Order (Cetak Semua Perintah) Alphabetical (Alfabetis) * Newest First (Terbaru Dulu) Oldest First (Terlama Dulu) Menentukan urutan ketika Anda memilih hendak mencetak semua pekerjaan rahasia dan pekerjaan yang tertunda. Automatic Deletion of Suspended Print Jobs (Penghapusan Otomatis Pekerjaan Cetak yang Ditunda) Off (Nonaktif) * On (Aktif) Menyetel printer untuk otomatis membatalkan pekerjaan cetak dalam antrean yang terganggu akibat terjadi eror seperti kertas macet dan bahan pakai tidak ada. menu Penyiapan"},{"UUID":"4f09989d-8359-4f32-830a-2bb520c7934f","title":"Cetak","link":"layout-topic.html","desc":"Quality (Kualitas) Item menu Quality","descFull":"Quality (Kualitas) Item menu Quality dan deskripsinya Item Menu Item submenu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Print Mode (Mode Cetak) T/A Black and White (Hitam Putih) Color (Warna) * Menyetel bagaimana printer menghasilkan konten berwarna. Print Resolution (Resolusi Cetak) T/A 4800 CQ * 1200 dpi Setel resolusi untuk hasil cetak. 4800 CQ  memberi output kualitas tinggi pada kecepatan maksimum. Toner Darkness (Kegelapan Toner) T/A 1 sampai 5  (4*) Menentukan kecerahan atau kegelapan gambar teks. Halftone T/A Normal * Detail Meningkatkan hasil cetak agar garisnya lebih halus dengan tepi yang lebih tajam. Color Saver (Penyimpan Warna) T/A Off (Nonaktif) * On (Aktif) Mengurangi jumlah toner yang dipakai untuk mencetak grafik dan gambar. Apabila disetel ke  On (Aktif) , setelan ini akan menimpa nilai setelan  Toner Darkness (Kegelapan Toner) . RGB Brightness (Kecerahan RGB) T/A ‑6 sampai 6  (0*) Menyesuaikan kecerahan setiap obyek di halaman yang memiliki warna merah, hijau, dan biru, serta abu-abu. Setelan ini tidak memengaruhi file yang memakai spesifikasi warna CMYK (cyan, magenta, kuning, hitam). RGB Contrast (Kontras RGB) T/A 0 sampai 5  (0*) Menyesuaikan kontras setiap obyek di halaman yang memiliki warna merah, hijau, dan biru, serta abu-abu. Setelan ini tidak memengaruhi file yang memakai spesifikasi warna CMYK (cyan, magenta, kuning, hitam). RGB Saturation (Saturasi RGB) T/A 0 sampai 5  (0*) Mempertahankan nilai hitam putih sembari menyesuaikan nilai warna dari setiap obyek di halaman. Setelan ini tidak memengaruhi file yang memakai spesifikasi warna CMYK (cyan, magenta, kuning, hitam). Advanced Imaging (Pencitraan Lanjutan) Color Balance (Keseimbangan Warna) Cyan  (0*) Magenta  (0*) Kuning  (0*) Hitam  (0*) Menyesuaikan jumlah toner yang digunakan untuk masing-masing warna. Reset Defaults (Setel Ulang ke Default) Menyetel ulang seluruh setelan warna ke nilai default. Color Correction (Koreksi Warna) Off (Nonaktif) Auto (Otomatis) * Manual Memodifikasi setelan warna yang digunakan untuk mencetak dokumen. Off (Nonaktif) —Menyetel printer untuk menerima koreksi warna dari perangkat lunak. Auto (Otomatis) —Menyetel printer untuk menerapkan beberapa profil warna pada masing-masing objek di halaman cetak. Manual —Mengizinkan konversi warna RGB atau CMYK secara bebas pada masing-masing objek di halaman cetak. Color Samples (Sampel Warna) Print Color Samples (Sampel Warna Cetak) Mencetak halaman sampel untuk masing-masing tabel konversi warna RGB dan CMYK yang digunakan di printer. Color Adjust (Penyesuaian Warna) Color Adjust (Penyesuaian Warna) Mengalibrasi printer untuk menyesuaikan variasi warna di output printer. Spot Color Replacement (Penggantian Warna Titik) Set Custom CMYK (Setel CMYK Bebas) Menentukan nilai CMYK khusus ke 20 nama titik warna. menu Kualitas"},{"UUID":"307f9eb3-83f5-4a2f-ba00-3221565f4eda","title":"Cetak","link":"layout-topic.html","desc":"Job Accounting (Pencatatan Pekerjaan) Item","descFull":"Job Accounting (Pencatatan Pekerjaan) Item menu Akuntansi Pekerjaan dan deskripsinya Item Menu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Job Accounting (Pencatatan Pekerjaan) Off (Nonaktif) * On (Aktif) Menyetel printer untuk membuat log pekerjaan cetak yang ia terima. Accounting Log Frequency (Frekuensi Pencatatan Log) Daily (Harian) Weekly (Mingguan) Monthly (Bulanan) * Menentukan seberapa sering printer membuat file log. Log Action at End of Frequency (Catat Log Tindakan di Akhir Frekuensi) None (Tidak Ada) * E‑mail Current Log (Kirim Email Log Saat Ini) E‑mail & Delete Current Log (Kirim Email & Hapus Log Saat Ini) Post Current Log (Kirim Log Saat Ini) Post & Delete Current Log (Kirim & Hapus Log Saat Ini) Menentukan bagaimana respons printer ketika ambang batas frekuensi telah habis. Nilai yang ditentukan di  Accounting Log Frequency (Frekuensi Pencatatan Log)  menentukan kapan tindakan ini dipicu. Log Near Full Level (Log Hampir Penuh) On (Aktif) * (5MB) Off (Nonaktif) Menentukan ukuran maksimal file log sebelum printer mengeksekusi  Log Action at Near Full (Log Tindakan Hampir Penuh) . Item menu ini hanya muncul ketika drive penyimpanan dipasang. Log Action at Near Full (Log Tindakan Hampir Penuh) None (Tidak Ada) * E‑mail Current Log (Kirim Email Log Saat Ini) E‑mail & Delete Current Log (Kirim Email & Hapus Log Saat Ini) E‑mail & Delete Oldest Log (Kirim Email & Hapus Log Terlama) Post Current Log (Kirim Log Saat Ini) Post & Delete Current Log (Kirim & Hapus Log Saat Ini) Post & Delete Oldest Log (Kirim & Hapus Log Terlama) Delete Current Log (Hapus Log Saat Ini) Delete Oldest Log (Hapus Log Terlama) Delete All But Current (Hapus Semua, Kecuali Saat Ini) Delete All Logs (Hapus Semua Log) Menentukan bagaimana respons printer ketika hard disk atau ISD hampir penuh. Nilai yang ditentukan di  Log Near Full Level (Log Hampir Penuh)  menentukan kapan tindakan ini dipicu. Log Action at Full (Log Tindakan Penuh) None (Tidak Ada) * E‑mail & Delete Current Log (Kirim Email & Hapus Log Saat Ini) E‑mail & Delete Oldest Log (Kirim Email & Hapus Log Terlama) Post & Delete Current Log (Kirim & Hapus Log Saat Ini) Post & Delete Oldest Log (Kirim & Hapus Log Terlama) Delete Current Log (Hapus Log Saat Ini) Delete Oldest Log (Hapus Log Terlama) Delete All But Current (Hapus Semua, Kecuali Saat Ini) Delete All Logs (Hapus Semua Log) Menentukan bagaimana respons printer ketika penggunaan drive penyimpanan mencapai batas maksimal (100MB). URL to Post Log (Log URL ke Post) Setelan ditentukan pengguna. Menentukan ke mana printer akan mengirim log pencatatan pekerjaan. E‑mail Address to Send Logs (Alamat Email untuk Mengirim Log) Setelan ditentukan pengguna. Menentukan alamat email yang ke situ printer akan mengirim log pencatatan pekerjaan. Log File Prefix (Prefiks File Log) Setelan ditentukan pengguna. Menentukan prefiks untuk file log. Nama host saat ini yang ditentukan dalam menu TCP/IP digunakan sebagai awalan file log default. menu Pencatatan Pekerjaan"},{"UUID":"4f311bb7-3b15-48c3-9fda-2831df419777","title":"Cetak","link":"layout-topic.html","desc":"PDF Item menu PDF dan","descFull":"PDF Item menu PDF dan deskripsinya Item Menu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Scale To Fit (Sesuaikan Agar Pas) Off (Nonaktif) * On (Aktif) Sesuaikan konten halaman agar sesuai dengan ukuran kertas yang dipilih. Annotations (Anotasi) Print (Cetak) Do Not Print (Jangan Cetak) * Menentukan apakah anotasi pada file PDF akan dicetak atau tidak. Print PS Error (Cetak Eror PS) Off (Nonaktif) On (Aktif) * Mengaktifkan pencetakan eror PDF. menu PDF"},{"UUID":"16c5e35f-7d22-480f-a9ed-dfbf7e38d386","title":"Cetak","link":"layout-topic.html","desc":"PostScript PostScript Item menu PostScript","descFull":"PostScript PostScript Item menu PostScript dan deskripsinya Item Menu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Print PS Error (Cetak Eror PS) Off (Nonaktif) * On (Aktif) Cetak satu halaman yang menggambarkan eror emulasi PostScript®. Ketika eror terjadi, proses pencetakan berhenti, lalu printer akan mencetak pesan eror, kemudian sisa pekerjaan cetak akan didorong keluar.  Minimum Line Width (Lebar Garis Minimal) 1–30  (2*) Menyetel lebar garis minimal. Pekerjaan yang dicetak dalam 1200 dpi akan memakai nilai tersebut secara langsung. Lock PS Startup Mode (Kunci Mode Mulai PS) Off (Nonaktif) On (Aktif) * Menonaktifkan file SysStart. Mengaktifkan file SysStart akan membuat printer atau jaringan Anda terpapar risiko keamanan. Image Smoothing (Penghalusan Gambar) Off (Nonaktif) * On (Aktif) Meningkatkan ketajaman dan kontras gambar resolusi rendaj. Setelan ini tidak berdampak pada gambar dengan resolusi 300 dpi ke atas. Font Priority (Prioritas Font) Resident * Flash/Disk Membuat urutan pencarian font. Resident —akan membuat printer mencari font yang diminta dari memori terlebih dahulu sebelum mencarinya di drive penyimpanan. Flash/Disk —akan membuat printer mencari font yang diminta dari drive penyimpanan sebelum mencarinya di memori printer. Item menu ini hanya muncul ketika drive penyimpanan dipasang. Wait Timeout (Tunggu Waktu Habis) Off (Nonaktif) On (Aktif) * Mengaktifkan printer untuk menunggu lebih banyak data sebelum membatalkan pekerjaan cetak. Jika disetel ke  On (Aktif) , setelan default pabrik adalah 40 detik. menu PostScript"},{"UUID":"647b3072-96d0-42d2-b31b-09454a56c016","title":"Cetak","link":"layout-topic.html","desc":"PCL Item menu PCL dan","descFull":"PCL Item menu PCL dan deskripsinya Item Menu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Font Source (Sumber Font) Resident * Disk Download Flash Font Card (Kartu Font) All (Semua) Pilih sumber yang berisi pilihan font default. Disk —hanya muncul jika hard disk yang berisi font telah dipasang dan dalam kondisi baik, tidak rusak, dan bisa dibaca atau bisa menyimpan informasi. Download —hanya muncul jika font yang didownload ada di memori printer. Flash —hanya muncul jika memori flash yang berisi font telah dipasang dan dalam kondisi baik, tidak rusak, dan bisa dibaca atau bisa menyimpan informasi. Font Card —hanya muncul jika kartu font yang valid telah diinstal atau drive penyimpanan intelijen telah diatur. Font Name (Nama Font) [Daftar font yang tersedia] ( Courier *) Pilih font dari sumber font yang telah ditentukan. Symbol Set (Kumpulan Simbol) [Daftar kumpulan simbol yang tersedia] ( 10U PC‑8 *) Menentukan kumpulan simbol untuk masing-masing nama font. Kumpulan simbol adalah kumpulan simbol spesial, tanda baca, karakter angka dan alfabet. Kumpulan simbol mendukung beberapa bahasa berbeda dan program tertentu, seperti simbol matematika untuk teks ilmiah. Pitch 0,08–100,00  (10,00*) Menentukan pitch untuk font dengan spasi tunggal atau tetap. Item menu ini merujuk pada jumlah karakter spasi tetap dalam suatu baris ketikan horizontal. Orientation (Orientasi) Portrait (Potret) * Landscape (Lanskap) Reverse Portrait (Potret Terbalik) Reverse Landscape (Lanskap Terbalik) Menentukan orientasi teks dan grafik pada halaman. Lines per Page (Baris per Halaman) 1–255 Menentukan jumlah baris teks untuk masing-masing halaman yang dicetak melalui arus data PCL®. Item menu ini akan mengeluarkan garis putus vertikal secara berulang setiap beberapa baris yang dipilih di antara margin default halaman. 60 adalah setelan default perusahaan AS. 64 adalah setelan default perusahaan internasional. PCL5 Minimum Line Width (Lebar Minimal Garis PCL5) 1–30  (2*) Menyetel nilai lebar minimal garis awal dari setiap pekerjaan yang dicetak dalam 1200 dpi melalui emulator yang berlaku. PCLXL Minimum Line Width (Lebar Minimal Garis PCLXL) 1–30  (2*) A4 Width (Lebar A4) 198 mm * 203 mm Menyetel lebar halaman logis pada kertas A4. Halaman logis adalah ruang pada halaman fisik di mana suatu data dicetak. Auto CR after LF (Otomatis CR setelah LF) On (Aktif) Off (Nonaktif) * Menyetel printer untuk menjalankan tugas Carriage Return (CR/Istilah lain tombol Enter) setelah perintah kontrol Line Feed (LF/Menyalin satu baris di baris baru). Carriage Return adalah mekanisme yang memerintah printer untuk memindah posisi kursor ke posisi awal di baris yang sama. Auto LF after CR (Otomatis CR setelah LF) On (Aktif) Off (Nonaktif) * Menyetel printer untuk menjalankan tugas Line Feed (LF/CR/Menyalin satu baris di baris baru) setelah perintah Carriage Return (CR/Istilah lain tombol Enter). Tray Renumber (Nomor Ulang Baki) Assign MP Feeder (Tentukan Feeder Multiguna) Assign Tray (Tentukan Baki)  [x] Assign Manual Paper (Tentukan Kertas Manual) Assign Manual Envelope (Tentukan Amplop Manual) Mengatur printer untuk bekerja dengan beberapa driver cetak atau aplikasi kustom yang menggunakan beberapa sumber penugasan berbeda guna meminta sumber kertas yang dikehendaki. Pilih dari beberapa opsi berikut: Off (Nonaktif) *—Printer menggunakan penugasan sumber kertas default. None (Tidak ada) —Sumber kertas mengabaikan perintah Select Paper Feed (Pilih Pengumpan Kertas). 0–199 —Pilih satu nilai angka untuk menetapkan nilai khusus pada suatu sumber kertas. View Factory Defaults (Lihat Setelan Default) Menampilkan setelan default untuk masing-masing sumber kertas. Restore Defaults (Pulihkan ke Default) Memulihkan nomor ulang baki ke setelan default. Print Timeout (Waktu Cetak Habis) Off (Nonaktif) On (Aktif) * (90) Menyetel printer untuk mengakhiri pekerjaan cetak setelah diam selama beberapa waktu tertentu. menu PCL"},{"UUID":"a68940aa-1d8e-4e46-9558-79f37d99812d","title":"Cetak","link":"layout-topic.html","desc":"Image (Gambar) Item menu Image","descFull":"Image (Gambar) Item menu Image (Gambar) dan deskripsinya Item Menu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Auto Fit (Otomatis Pas) On (Aktif) Off (Nonaktif) * Pilih setelan orientasi dan ukuran kertas terbaik untuk suatu gambar. Jika disetel ke  On (Aktif) , item menu ini akan dipakai sebagai setelan orientasi dan ukuran gambar. Invert (Terbalik) Off (Nonaktif) * On (Aktif) Membalikkan gambar monokrom bitonal. Item menu ini tidak berlaku untuk gambar dengan format GIF atau JPEG. Scaling (Penyesuaian) Best Fit (Paling Pas) * Anchor Top Left (Mepet Kiri Atas) Anchor Center (Pas Tengah) Fit Height/Width (Sesuai Tinggi/Lebar) Fit Height (Sesuai Tinggi) Fit Width (Sesuai Lebar) Sesuaikan gambar supaya pas dengan area cetak. Jika  Auto Fit (Otomatis Pas)  disetel ke  On (Aktif) ,  Scaling (Penyesuaian)  akan otomatis disetel ke  Best Fit (Paling Pas) . Orientation (Orientasi) Portrait (Potret) * Landscape (Lanskap) Reverse Portrait (Potret Terbalik) Reverse Landscape (Lanskap Terbalik) Menentukan orientasi teks dan grafik pada halaman. menu Gambar"},{"UUID":"a2722e88-8c46-4e31-8072-db24d923680e","title":"Kertas","link":"tray-configuration-topic.html","desc":"Tray Configuration (Konfigurasi Baki) Item","descFull":"Tray Configuration (Konfigurasi Baki) Item menu Tray Configuration dan deskripsinya Item Menu Item submenu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Default Source (Sumber Default) T/A Tray (Baki)  [x] (1*) Multipurpose Feeder (Feeder multiguna) Manual Paper (Kertas Manual) Manual Envelope (Amplop Manual) Menyetel sumber kertas default untuk semua pekerjaan cetak. Paper Size/Type (Jenis/Ukuran Kertas) Tray (Baki)  [x] Multipurpose Feeder (Feeder multiguna) Manual Paper (Kertas Manual) Manual Envelope (Amplop Manual) Size (Ukuran) Type (Jenis) Menentukan ukuran atau jenis kertas yang dimasukkan ke masing-masing sumber kertas. Substitute Size (Ukuran Pengganti) T/A Off (Nonaktif) Statement/A5 Letter/A4 11 x 17/A3 All Listed (Semua yang Terdaftar) * Menyetel printer untuk mengganti ukuran kertas yang telah ditentukan apabila ukuran yang diminta tidak dimuat di dalam sumber kertas. Off (Nonaktif) —akan meminta pengguna untuk memuat ukuran kertas yang diminta. All Listed (Semua yang Terdaftar) —memungkinkan semua penggantian yang tersedia. Configure MP (Atur MP) T/A Cassette (Kaset) * Manual First (Awal) Menentukan pola tindakan pengumpan serba guna. Cassette (Kaset) —mengatur feeder multiguna sebagai sumber kertas otomatis. Manual —menyetel feeder multiguna hanya untuk pekerjaan cetak dengan pengumpanan manual. First (Awal) —mengatur feeder multiguna sebagai sumber kertas utama. menu Konfigurasi Baki"},{"UUID":"3f9c8bbe-0e6d-4a02-ba5e-1acea1d268f9","title":"Kertas","link":"tray-configuration-topic.html","desc":"Media Configuration (Konfigurasi Media) Item","descFull":"Media Configuration (Konfigurasi Media) Item menu Media Configuration (Konfigurasi Media) dan deskripsinya Item Menu Item submenu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Units of Measure (Unit Ukuran) T/A Inches (Inci) Millimeters (Milimeter) Tentukan unit ukuran untuk kertas universal. Inches (Inci)  adalah setelan default perusahaan AS.  Millimeters (Milimeter)  adalah setelan default perusahaan internasional. Universal Setup (Penyiapan Universal) All Input Trays (Semua Baki Input) Portrait Width (Lebar Potret) Setel lebar potret kertas universal. Portrait Height (Tinggi Potret) Setel tinggi potret kertas universal. Feed Direction (Arah Pengumpanan)  ( Short Edge/Tepi Pendek *) Setel printer untuk mengambil kertas dari arah tepi pendek atau tepi panjang. Long Edge (Tepi Pendek)  hanya muncul ketika tepi terpanjang adalah lebih pendek daripada lebar maksimal yang didukung. Custom Scan Sizes (Ukuran Pindai Khusus) Scan Size Name (Nama Ukuran Pindai) Setelan ditentukan pengguna. Menentukan satu nama untuk pemindaian khusus. Width (Lebar) 1.–8,5 inci  (8,5*) 25–215,9 mm  (215,9*) Menentukan lebar dokumen asli. Height (Tinggi) 1–25 inci  (11*) 25–635 mm  (279.4*) Menentukan tinggi dokumen asli. Orientation (Orientasi) Portrait (Potret) * Landscape (Lanskap) Menentukan orientasi konten dari dokumen asli. 2 pindai tiap sisi Off (Nonaktif) * On (Aktif) Menyetel jumlah pindai default pada masing-masing sisi printer. Media Type Setup (Penyiapan Jenis Media) [Daftar jenis kertas] Tekstur Berat Orientasi Masuk Kirim ke Keranjang Tentukan tekstur, berat, dan orientasi kertas. menu Konfigurasi Media"},{"UUID":"5be3e7af-cda8-4587-ae1a-b02b4e68e94c","title":"Kertas","link":"tray-configuration-topic.html","desc":"Bin Configuration (Konfigurasi Keranjang) Item","descFull":"Bin Configuration (Konfigurasi Keranjang) Item menu Bin Configuration (Konfigurasi Keranjang) dan deskripsinya Item Menu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Keranjang Output Standard Bin (Keranjang Standar) * Bin (Keranjang)  [x] Menentukan keranjang output untuk pekerjaan cetak. Configure Bins (Atur Keranjang) Mailbox * Link (Tautkan) Link Optional (Tautkan Opsi) Type Assignment (Tulis Tugas) Atur mode operasi keranjang output. Mailbox —memungkinkan keranjang standar dan keranjang opsional untuk dipilih secara individu. Link —memungkinkan semua keranjang output ditautkan bersama seperti satu keranjang besar. Link Optional (Tautkan Opsi) —Menjadikan semua keranjang opsional seperti satu keranjang output besar. Type Assignment (Tulis Tugas) —Memberi tugas pada masing-masing jenis kertas untuk masuk keranjang tertentu. Custom Bin Names (Nama Keranjang Khusus) Keranjang Standar Bin (Keranjang)  [x] Menentukan nama keranjang. menu Konfigurasi Keranjang"},{"UUID":"c0cd0d98-148a-4ee1-a66e-bf89262f2d79","title":"Salin","link":"copy-defaults-topic.html","desc":"Copy Defaults (Setelan Default Salin)","descFull":"Copy Defaults (Setelan Default Salin) Item menu Copy Default (Setelan Default Salin) dan deskripsinya Item Menu Item submenu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Content Type (Jenis Konten) T/A Text (Teks) Text/Photo (Teks/Foto) * Photo (Foto) Graphics (Grafik) Meningkatkan output berdasarkan konten dokumen asli. Content Source (Sumber Konten) T/A Black and White Laser (Laser Hitam dan Putih) Color Laser (Laser Warna) * Inkjet Photo/Film (Foto/Film) Magazine (Majalah) Newspaper (Koran) Press (Buku Cetak) Other (Lainnya) Meningkatkan hasil output berdasarkan sumber dokumen asli. Sides (Sisi-sisi) T/A 1 sisi ke 1 sisi * 1 sisi ke 2 sisi 2 sisi ke 1 sisi 2 sisi ke 2 sisi Menentukan pola pemindaian berdasarkan dokumen asli. Separator Sheets (Lembaran Pemisah) T/A None (Tidak Ada) * Between Copies (Di Sela Salinan) Between Jobs (Di Sela Pekerjaan) Between Pages (Di Sela Halaman) Menentukan apakah hendak memasukkan lembar pemisah kosong saat mencetak. Separator Sheet Source (Sumber Lembar Pemisah) T/A Tray (Baki)  [x] (1*) Multipurpose Feeder (Feeder multiguna) Menentukan sumber kertas untuk lembar pemisah. Warna T/A Off (Nonaktif) On (Aktif) * Auto (Otomatis) Menyetel printer untuk menghasilkan output warna dari pekerjaan pindai. Pages per Side (Halaman ke Sisi) T/A Off (Nonaktif) * 2 Portrait pages (2 Halaman potret) 4 Portrait pages (2 Halaman potret) 2 Landscape pages (2 Halaman lanskap) 4 Landscape pages (2 Halaman lanskap) Menentukan jumlah gambar halaman yang akan dicetak pada satu sisi lembar kertas. Print Page Borders (Cetak Batas Halaman) T/A Off (Nonaktif) * On (Aktif) Tempatkan batas di sekeliling masing-masing gambar ketika mencetak beberapa halaman dalam satu halaman. Collate (Susun) T/A Off [1,1,1,2,2,2] On [1,2,1,2,1,2] * Mencetak beberapa salinan secara berurutan. Halaman Ofset T/A None (Tidak Ada) * Between Copies (Di Sela Salinan) Between Jobs (Di Sela Pekerjaan) Menyusun output atau salinan dari suatu pekerjaan cetak. Between Copies (Di Sela-sela Salinan) —menyusun setiap salinan dari suatu pekerjaan cetak apabila  Collate  disetel ke  On [1,2,1,2,1,2] . Jika  Collate (Susun)  disetel ke  Off/Nonaktif [1,1,1,2,2,2] , maka hasil cetakan akan ditumpuk berdasarkan kesamaan nomor halaman. Between Jobs (Di Sela-sela Pekerjaan) —menyetel posisi ofset yang sama untuk seluruh pekerjaan cetak, terlepas dari berapa jumlah salinan yang dicetak. Item menu ini hanya muncul ketika penumpuk ofset atau lis lubang stapler dipasang. Stapler T/A Off (Nonaktif) * 1 staple, pojok kiri atas 2 staple, kiri 1 staple, pojok kanan atas 2 staple, atas 1 staple, pojok kiri bawah 2 staple, bawah 1 staple, pojok kanan bawah 2 staple, kanan 4 stapler Menentukan posisi staple untuk semua pekerjaan cetak. Item menu ini hanya muncul ketika lis stapler dipasang. Lis Lubang T/A Off (Nonaktif) * 2 lubang 3 lubang 4 lubang Lis lubang pada output hasil cetakan. Item menu ini hanya muncul ketika lis lubang stapler atau lis buklet dipasang. “Copy from” Size (Ukuran “Salin dari”) [Daftar ukuran kertas] Menyetel ukuran kertas dokumen asli. Letter  adalah setelan default perusahaan AS.  A4  adalah setelan default perusahaan internasional. “Copy to” Source (Sumber “Salin ke”) T/A Tray (Baki)  [x] (1*) Multipurpose Feeder (Feeder multiguna) Auto Size Match (Otomatis Sesuaikan Ukuran) Menentukan sumber kertas untuk pekerjaan fotokopi. Temperature (Temperatur) T/A ‑4 sampai 4  (0*) Menentukan apakah ingin menghasilkan output yang lebih hangat atau lebih berwarna. Darkness (Kegelapan) T/A 1 sampai 9  (5*) Menyesuaikan kegelapan gambar yang dipindai. Number of Copies (Jumlah Salinan) T/A 1–9999  (1*) Menentukan jumlah salinan. Header/Footer T/A Left Header Middle Header Right Header Left Footer Middle Footer Right Footer Menentukan informasi header/footer pada gambar yang dipindai. Overlay (Lapisan) T/A Confidential (Rahasia) Copy (Salin) Draft (Draf) Urgent (Mendesak) Custom (Bebas) Off (Nonaktif) * Menentukan teks lapisan yang akan dicetak pada masing-masing salinan. Custom overlay (Lapisan bebas) T/A Setelan ditentukan pengguna. Tulis teks untuk pilihan  Custom (Bebas)  di menu  Overlay (Lapisan) . Advanced Imaging (Pencitraan Lanjutan) Color Balance (Keseimbangan Warna) Cyan to Red (Cyan ke Merah)  (0*) Magenta to Green (Magenta ke Hijau)  (0*) Yellow to Blue (Kuning ke Biru)  (0*) Menyesuaikan intensitas warna untuk cyan, magenta, dan kuning. Color Dropout (Dropout Warna) Color Dropout (Penurunan Warna)  ( Tidak ada *) Default Red Threshold (Ambang Batas Default Warna Merah)  (128*) Default Green Threshold (Ambang Batas Default Hijau)  (128*) Default Blue Threshold (Ambang Batas Default Warna Biru)  (128*) Menentukan warna mana yang diturunkan saat memindai, dan menyesuaikan setelan dropout untuk warna tersebut. Auto Color Detect (Deteksi Warna Otomatis) Color Sensitivity (Sensitivitas Warna)  (5*) Area Sensitivity (Sensitivitas Area)  (5*) Mengonfigurasi setelan deteksi warna otomatis. Contrast (Kontras) Best for content (Terbaik untuk konten) * 0–5 Menentukan kontras untuk gambar yang dipindai. Background Removal (Penghapusan Latar) Background Detection (Deteksi Latar)  ( Content-based/Berbasis konten *) Level  (0*) Menghapus noise warna atau gambar latar dari dokumen asli. Content-based (Berbasis konten) —menghapus warna latar dari dokumen asli. Fixed (Tetap) —menghapus noise gambar dari foto. Auto Center (Otomatis Tengah) Off (Nonaktif) * On (Aktif) Meratakan kontek di tengah halaman. Mirror Image (Gambar Kebalikan) Off (Nonaktif) * On (Aktif) Menciptakan gambar kebalikan dari dokumen asli. Negative Image (Gambar Negatif) Off (Nonaktif) * On (Aktif) Menciptakan gambar negatif dari dokumen asli. Shadow Detail (Detail Bayangan) ‑4 sampai 4  (0*) Menyesuaikan detail bayangan dokumen asli. Scan Edge to Edge (Pindai Tepi ke Tepi) Off (Nonaktif) * On (Aktif) Memindai dokumen asli dari tepi ke tepi. Sharpness (Ketajaman) 1–5  (3*) Menyesuaikan ketajaman gambar yang dipindai. Admin Controls (Kontrol Admin) Allow Color Copies (Izinkan Salinan Warna) Off (Nonaktif) On (Aktif) * Cetak salinan berwarna. Allow Priority Copies (Izinkan Salinan Prioritas) Off (Nonaktif) On (Aktif) * Menyela pekerjaan cetak untuk membuat salinan. Custom Job Scanning (Memindai Pekerjaan Kustom) Off (Nonaktif) * On (Aktif) Menyetel printer untuk memindai set pertama dari dokumen asli menggunakan setelan yang telah ditentukan, lalu memindai set kedua dengan setelan yang sama atau berbeda. Allow Save as Shortcut (Izinkan Simpan sebagai Pintasan) Off (Nonaktif) On (Aktif) * Menyimpan setelan fotokopi sebagai pintasan. Sample Copy (Salinan Sampel) Off (Nonaktif) * On (Aktif) Cetak salinan sampel untuk memeriksa kualitas sebelum mencetak salinan yang tersisa. menu Setelan Default Salin"},{"UUID":"b4719581-8444-4a1b-b961-da626dd3e2f1","title":"Setelan Default Faks","link":"fax-defaults-subgroup.html","desc":"Fax Mode (Mode Faks) Item","descFull":"Fax Mode (Mode Faks) Item menu  Fax Mode (Mode Faks)  dan deskripsi Item Menu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Fax Mode (Mode Faks) Fax (Faks) * Fax Server (Server Faks) Disabled (Dinonaktifkan) Pilih satu mode faks. menu Mode Faks"},{"UUID":"bad608b0-9b53-42da-9410-d513c9e2298a","title":"Setelan Default Faks","link":"fax-defaults-subgroup.html","desc":"Penyiapan Faks Item menu General","descFull":"Penyiapan Faks Item menu General Fax Settings (Setelan Faks Umum) dan deskripsinya Item Menu Item submenu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. General Fax Settings (Setelan Faks Umum) Fax Name (Nama Faks) Setelan ditentukan pengguna. Menentukan ID faks Anda. Fax Number (Nomor Faks) Setelan ditentukan pengguna. Menentukan nomor faks Anda. Fax ID (ID Faks) Fax Name (Nama Faks) Fax Number (Nomor Faks) * Menyetel ID faks untuk digunakan selama negosiasi faks. Aktifkan Faks Manual Off (Nonaktif) * On (Aktif) Aktifkan fungsi faks manual pada printer. Menu item ini memerlukan pemisah sambungan dan handset telepon. Gunakan sambungan telepon reguler untuk menjawab faks masuk dan untuk menghubungi nomor faks. Untuk mengaktifkan fungsi faks manual, sentuh  #  dan  0  pada keypad. Memory Use (Pemakaian Memori) All receive (Semua diterima) Mostly receive (Sebagian besar diterima) Equal (Setara) * Mostly send (Sebagian besar dikirim) All send (Semua dikirim) Menentukan jumlah memori printer internal yang dialokasikan untuk pekerjaan faks. Menu ini mencegah terjadinya kondisi buffer memori dan kegagalan faks. Cancel Faxes (Batalkan Faks) Allow (Izinkan) * Don't Allow (Tidak Diizinkan) Membatalkan faks masuk atau keluar. Fax Number Masking (Samarkan Nomor Faks) Off (Nonaktif) * From Left (Dari Kiri) From Right (Dari Kanan) Menentukan format untuk penyamaran nomor faks keluar. General Fax Settings (Setelan Faks Umum) Digits to Mask (Digit Penyamaran) 0–58  (0*) Menentukan angka digit untuk menyamarkan nomor faks keluar. Enable Line Connected Detection (Aktifkan Deteksi Sambungan Terkoneksi) Off (Nonaktif) On (Aktif) * Menentukan apakah sambungan telepon telah tersambung ke printer. Acara terdeteksi secara seketika. Aktifkan Deteksi Kesalahan Soket Line In Off (Nonaktif) On (Aktif) * Menentukan apakah sambungan telepon telah tersambung ke port yang benar pada printer. Acara terdeteksi secara seketika. Aktifkan Ekstensi pada Dukungan Penggunaan Off (Nonaktif) On (Aktif) * Menentukan apakah sambungan telepon telah dipakai oleh perangkat lain, seperti telepon lain di sambungan yang sama. Acara terdeteksi secara seketika. Optimize Fax Compatibility (Optimalkan Kompatibilitas Faks) Setelan ditentukan pengguna. Mengatur fungsionalitas faks printer untuk kompatibilitas yang optimal dengan mesin faks lain. Fax Transport (Transportasi Faks) T.38 Analog G.711 etherFAX Menyetel metode transportasi faks. Menu ini hanya muncul jika paket lisensi etherFAX atau Fax over IP (FoIP) telah diinstal pada printer. HTTPS Fax Settings (Setelan Faks HTTPS) Menu ini hanya muncul apabila  Fax Transport (Transportasi Faks)  disetel ke  etherFAX . HTTPS service URL (URL Layanan HTTPS) Setelan ditentukan pengguna. Menentukan URL layanan etherFAX. HTTPS Proxy Setelan ditentukan pengguna. Menentukan URL server proxy. HTTPS Proxy User (Pengguna HTTPS Proxy) Setelan ditentukan pengguna. Menentukan nama pengguna dan kata sandi untuk server proxy. HTTPS Proxy Password (Kata Sandi HTTPS Proxy) Fax Send Encryption (Enkripsi Faks Keluar) Disabled (Dinonaktifkan) Enabled (Diaktifkan) * Required (Diperlukan) Mengaktifkan enkripsi untuk pesan faks keluar. Fax Receive Encryption (Enkripsi Faks Masuk) Disabled (Dinonaktifkan) Enabled (Diaktifkan) * Required (Diperlukan) Mengaktifkan enkripsi untuk pesan faks masuk. HTTPS Fax Status (Status Faks HTTPS) Setelan ini adalah informasi hanya baca. Menampilkan status komunikasi etherFAX. Fax Send Settings (Setelan Kirim Faks) Resolution (Resolusi) Standard (Standar) * Fine (Halus) Super Fine (Super Halus) Ultra Fine (Ultra Halus) Menyetel resolusi gambar pindai. Semakin tinggi resolusi, semakin banyak memori dan waktu transmisi faks yang diperlukan. Original Size (Ukuran Asli) [Daftar ukuran kertas] ( Ukuran Campuran *) Tentukan ukuran dokumen asli. Orientation (Orientasi) Portrait (Potret) * Landscape (Lanskap) Menentukan orientasi dokumen asli. Sides (Sisi-sisi) Off (Nonaktif) * Short Edge (Tepi Pendek) Long Edge (Tepi Panjang) Menentukan orientasi dokumen asli ketika memindai di dua sisi dokumen. Content Type (Jenis Konten) Text (Teks) * Text/Photo (Teks/Foto) Photo (Foto) Graphics (Grafik) Meningkatkan output berdasarkan konten dokumen asli. Content Source (Sumber Konten) Black and White Laser (Laser Hitam dan Putih) Color Laser (Laser Warna) * Inkjet Photo/Film (Foto/Film) Magazine (Majalah) Newspaper (Koran) Press (Buku Cetak) Other (Lainnya) Meningkatkan hasil output berdasarkan sumber dokumen asli. Darkness (Kegelapan) 1–9  (5*) Menyesuaikan kegelapan gambar yang dipindai. Behind a PABX (Belakang PABX) On (Aktif) Off (Nonaktif) * Menyetel printer untuk menghubungi nomor faks tanpa harus menunggu pengenalan nada sambung. Private Automated Branch Exchange (PABX) adalah jaringan telepon yang memungkinkan satu nomor akses menawarkan lebih dari satu sambungan ke pemanggil luar. Dial Mode (Mode Sambung) Tone (Nada) * Pulse (Pulsa) Menentukan mode sambung untuk faks masuk atau keluar. Advanced Imaging (Pencitraan Lanjutan) Color Balance (Keseimbangan Warna) Cyan ‑ Red (Cyan - Merah)  (0*) Magenta ‑ Green (Magenta - Hijau)  (0*) Yellow ‑ Blue (Kuning - Biru)  (0*) Menyesuaikan intensitas warna selama memindai. Color Dropout (Dropout Warna) Best for Content (Terbaik untuk Konten) * 0 1 2 3 4 5 Menyetel kontras hasil output. Mirror Image (Gambar Kebalikan) Off (Nonaktif) * On (Aktif) Menciptakan gambar kebalikan dari dokumen asli. Shadow Detail (Detail Bayangan) ‑4 sampai 4  (0*) Menyesuaikan kadar detail bayangan yang terlihat pada gambar yang dipindai. Scan Edge to Edge (Pindai Tepi ke Tepi) Off (Nonaktif) On (Aktif) * Memungkinkan pemindaian dari tepi ke tepi dokumen asli. Sharpness (Ketajaman) 1–5  (3*) Menyesuaikan ketajaman gambar yang dipindai. Temperature (Temperatur) ‑4 sampai 4  (0*) Menentukan apakah ingin menghasilkan output yang lebih hangat atau lebih berwarna. Admin Controls (Kontrol Admin) Automatic Redial (Sambung Ulang Otomatis) 0–9  (5*) Menentukan berapa kali upaya sambung ulang pada printer sebelum membatalkan pengiriman faks ke tujuan tertentu. Redial Frequency (Frekuensi Sambung Ulang) 1–200  menit (3*) Meningkatkan waktu antara beberapa upaya sambung ulang guna meningkatkan peluang kesuksesan pengiriman faks. Enable ECM (Aktifkan LLDP) On (Aktif) * Off (Nonaktif) Activate Error Correction Mode (ECM/Mode Koreksi Eror) untuk pekerjaan faks. ECM akan mendeteksi dan memperbaiki kesalahan dalam proses transmisi faks yang disebabkan oleh gangguan sambungan telepon dan kekuatan sinyal yang rendah. Enable Fax Scans (Aktifkan Pindai Faks) On (Aktif) * Off (Nonaktif) Membuat faks dengan pemindai printer. Driver to Fax (Driver ke Faks) On (Aktif) * Off (Nonaktif) Memungkinkan driver printer untuk mengirim faks. Allow Save as Shortcut (Izinkan Simpan sebagai Pintasan) On (Aktif) * Off (Nonaktif) Menyimpan nomor faks sebagai pintasan printer. Max Speed (Kecepatan Maks) 33600 * 14400 9600 4800 2400 Menyetel kecepatan maksimal dalam mengirim faks. Custom Job Scanning (Memindai Pekerjaan Kustom) Off (Nonaktif) * On (Aktif) Aktifkan pekerjaan pindai kustom secara default. Scan Preview (Pratinjau Hasil Pindai) Off (Nonaktif) * On (Aktif) Tampilkan pratinjau hasil pindai di tampilan. Adjust ADF Skew (Sesuaikan Kemiringan ADF) Off (Nonaktif) On (Aktif) * Memperbaiki kemiringan pada gambar yang dipindai. Enable Color Fax Scans (Aktifkan Pindai Faks Warna) Off by Default (Nonaktif secara Default) * On by Default (Aktif secara Default) Never Use (Jangan Pernah Pakai) Always Use (Selalu Pakai) Mengaktifkan pindai warna untuk faks. Auto Convert Color Faxes to Mono Faxes (Ubah Otomatis Faks Warna ke Faks Satu Warna) On (Aktif) * Off (Nonaktif) Mengubah semua faks warna keluar menjadi hitam putih. Confirm Fax Number (Konfirmasi Nomor Faks) Off (Nonaktif) * On (Aktif) Meminta pengguna untuk mengonfirmasi nomor faks. Dial Prefix (Nomor Awal Sambungan) Setelan ditentukan pengguna. Menyetel nomor awal sambungan. Dialing Prefix Rules (Aturan Nomor Awal Sambungan) Setelan ditentukan pengguna. Menerbitkan aturan tentang nomor awal sambungan. Fax Receive Settings (Setelan Terima Faks) Fax Job Waiting (Pekerjaan Faks Menunggu) None (Tidak Ada) * Toner Toner and Supplies (Toner dan Bahan Pakai) Menghapus pekerjaan faks dari antrian cetak karena memerlukan sumber daya khusus yang tidak ada. Rings to Answer (Dering untuk Menjawab) 1–25  (3*) Menyetel jumlah dering yang diperlukan sebelum printer menjawab panggilan masuk. Auto Reduction (Pengurangan Otomatis) On (Aktif) * Off (Nonaktif) Menyesuaikan skala faks masuk agar pas dengan halaman. Paper Source (Sumber Kertas) Tray (Baki)  [x] Auto (Otomatis) * Menyetel sumber kertas untuk mencetak faks masuk. Sides (Sisi-sisi) On (Aktif) Off (Nonaktif) * Mencetak pada dua sisi kertas Separator Sheets (Lembaran Pemisah) None (Tidak Ada) * Before Job (Sebelum Pekerjaan) After Job (Setelah Pekerjaan) Menentukan apakah hendak memasukkan lembar pemisah kosong saat mencetak. Separator Sheet Source (Sumber Lembar Pemisah) Tray (Baki)  [x] (1*) Menentukan sumber kertas untuk lembar pemisah. Keranjang Output Keranjang Standar Menentukan keranjang output untuk faks masuk. Fax Footer (Footer Faks) On (Aktif) Off (Nonaktif) * Mencetak informasi transmisi di akhir masing-masing halaman faks masuk. Fax Footer Time Stamp (Keterangan Waktu Footer Faks) Receive (Menerima) * Print (Cetak) Mencetak keterangan waktu di akhir masing-masing halaman faks masuk. Holding Faxes (Menunda Faks) Held Fax Mode (Mode Faks Tertunda)(Nonaktif*)  Menunda faks masuk agar tidak langsung dicetak sampai diizinkan. Fax Holding Schedule (Jadwal Menunda Faks) Menentukan jadwal untuk menunda faks. Item menu ini hanya muncul apabila  Held Fax Mode (Mode Faks Tertunda)  disetel ke  Scheduled (Terjadwal) . Admin Controls (Kontrol Admin) Enable Fax Receive (Aktifkan Faks Masuk) On (Aktif) * Off (Nonaktif) Menyetel printer untuk menerima faks. Enable Color Fax Receive (Aktifkan Faks Masuk Warna) On (Aktif) * Off (Nonaktif) Menyetel printer untuk menerima faks warna. Enable Caller ID (Aktifkan ID Penelepon) On (Aktif) Off (Nonaktif) * Menampilkan informasi ID penelepon ketika ada panggilan masuk di tampilan printer. Block No Name Fax (Blokir Faks Tanpa Nama) On (Aktif) Off (Nonaktif) * Memblokir faks masuk yang tidak memiliki ID faks. Banned Fax List (Daftar Faks Dilarang) Add Banned Fax (Tambah Faks Dilarang) Menentukan nomor telepon yang ingin Anda blokir. Answer On (Jawab Aktif) All Rings (Semua Berdering) * Single Ring Only (Hanya Dering Sekali) Double Ring Only (Hanya Dering Dua Kali) Triple Ring Only (Hanya Dering Tiga Kali) Single or Double Rings Only (Hanya Dering Sekali atau Dua Kali) Single or Triple Rings Only (Hanya Dering Sekali atau Tiga Kali) Double or Triple Rings Only (Hanya Dering Dua Kali atau Tiga Kali) Menyetel pola dering khusus untuk faks masuk. Auto Answer (Jawab Otomatis) On (Aktif) * Off (Nonaktif) Menyetel printer untuk menerima faks secara otomatis. Kode Jawab Manual 0–9  (9*) Memasukkan kode secara manual pada tombol nomor telepon untuk mulai menerima faks. Item menu ini hanya muncul ketika printer berbagi sambungan dengan telepon. Item menu ini hanya muncul ketika Anda menyetel printer untuk menerima faks secara manual. Fax Forwarding (Meneruskan Faks) Print (Cetak) * Print and Forward (Cetak dan Teruskan) Forward (Teruskan) Menentukan apakah hendak meneruskan faks masuk. Forward To (Teruskan Ke) Destinasi 1 Destinasi 2 Menentukan ke mana hendak meneruskan faks masuk. Item ini hanya muncul ketika  Fax Forwarding (Meneruskan Faks)  disetel ke  Print and Forward (Cetak dan Teruskan)  atau  Forward (Teruskan) . Max Speed (Kecepatan Maks) 33600 * 14400 9600 4800 2400 Menyetel kecepatan maksimal dalam mengirim faks. Fax Cover Page (Halaman Sampul Faks) Fax Cover Page (Halaman Sampul Faks) Off by Default (Nonaktif secara Default) * On by Default (Aktif secara Default) Never Use (Jangan Pernah Pakai) Always Use (Selalu Pakai) Mengatur setelan untuk halaman sampul faks. Include To field (Masukkan ke Kolom) Off (Nonaktif) * On (Aktif) Include To field (Masukkan dari Kolom) Off (Nonaktif) * On (Aktif) From (Dari) Setelan ditentukan pengguna. Include To field (Kolom Sertakan Ke) Off (Nonaktif) * On (Aktif) Message (Pesan): Setelan ditentukan pengguna. Include Logo (Sertakan Logo) Off (Nonaktif) * On (Aktif) Include Footer (Sertakan Footer) [x] Off (Nonaktif) * On (Aktif) Footer [x] Setelan ditentukan pengguna. Fax Log Settings (Setelan Log Faks) Transmission Log Frequency (Frekuensi Log Transmisi) Always (Selalu) * Never (Tidak Pernah) Only for Error (Hanya saat Eror) Menentukan seberapa sering printer membuat log transmisi. Transmission Log Action (Tindakan Log Transmisi) Print (Cetak)  ( On/Aktif *) E‑mail  ( Off/Nonaktif *) Mencetak atau mengirim email log untuk transmisi faks yang berhasil maupun yang tidak. Receive Error Log (Terima Log Eror) Print Never (Jangan Pernah Cetak) * Print on Error (Cetak saat Eror) Mencetak log kegagalan menerima faks. Auto Print Logs (Cetak Log Otomatis) On (Aktif) * Off (Nonaktif) Mencetak semua aktivitas faks. Log Paper Source (Sumber Kertas Log) Tray (Baki)  [x] (1*) Menentukan sumber kertas untuk mencetak log. Logs Display (Tampilan Log) Remote Fax Name (Nama Faks Jarak Jauh) * Dialed Number (Nomor Sambungan) Mengidentifikasi pengirim dengan nomor faks atau nama faks jarak jauh. Enable Job Log (Aktifkan Log Pekerjaan) On (Aktif) * Off (Nonaktif) Melihat ringkasan semua pekerjaan faks. Enable Call Log (Aktifkan Log Panggilan) On (Aktif) * Off (Nonaktif) Melihat ringkasan riwayat panggilan faks. Log Output Bin (Keranjang Output Log) Standard Bin (Keranjang Standar) * Bin (Keranjang)  [x] Menentukan keranjang output untuk log yang dicetak. Speaker Settings (Setelan Speaker) Speaker Mode (Mode Speaker) Always Off (Selalu Nonaktif) * Always On (Selalu Aktif) On until Connected (Aktif sampai Tersambung) Menyetel mode speaker faks. Speaker Volume (Volume Speaker) Low (Rendah) * High (Tinggi) Menyesuaikan volume speaker faks. Ringer Volume (Volume Dering) Off (Nonaktif) * On (Aktif) Mengaktifkan volume dering. VoIP Settings (Setelan VoIP) VoIP Protocol (Protokol VoIP) SIP * H.323 Menyetel protokol Voice over Internet Protocol (VoIP/Suara lewat Protokol Internet). STUN Server Setelan ditentukan pengguna. Menentukan server STUN untuk melintasi firewall. Force Fax Mode (Paksa Mode Faks) Off (Nonaktif) On (Aktif) * Bertukar gateway VoIP dari analog ke T.38 di awal panggilan faks. Force Fax Mode Delay (Paksa Penundaan Mode Faks) 0–15  (7*) Menyetel waktu tunda dalam hitungan detik saat mengirim undangan  Force Fax Mode (Paksa Mode Faks)  lain. SIP Settings (Setelan PDF) Proxy Setelan ditentukan pengguna. Menentukan alamat IP sistem yang mengubah nomor telepon ke suatu alamat IP di mana suatu faks akan dikirim. Registrar Setelan ditentukan pengguna. Menentukan satu nama atau alamat IP sistem yang menangani registrasi klien Session Initiation Protocol (SIP/Protokol Inisiasi Sesi). User (Pengguna) Setelan ditentukan pengguna. Menentukan nama pengguna SIP. Password (Kata Sandi) Setelan ditentukan pengguna. Menentukan kata sandi yang hendak dipakai dalam mendaftarkan Registrar SIP. Auth ID (ID Otorisasi) Setelan ditentukan pengguna. Nama pengguna yang digunakan saat mendaftar. Jika  Auth ID (ID Otorisasi)  tidak disetel, setelan akan menggunakan nama pengguna yang terdapat di kolom User (Pengguna). Transport For Registration (Transportasi untuk Registrasi) UDP * TCP Menentukan jenis transportasi SIP untuk registrasi. Transport For Incoming Calls (Transportasi untuk Panggilan Masuk) UDP * TCP UDP And TCP (UDP dan TCP) Menyetel jenis transportasi SIP untuk registrasi. Transport For Outgoing Calls (Transportasi untuk Panggilan Keluar) UDP * TCP Menyetel jenis transportasi SIP untuk panggilan keluar. Outbound Proxy (Proxy Keluar) Setelan ditentukan pengguna. Menentukan proxy keluar untuk meneruskan semua komunikasi SIP. Contact (Kontak) Setelan ditentukan pengguna. Menentukan nama kontak untuk SIP. Realm Setelan ditentukan pengguna. Menentukan nama realm untuk SIP. Jika Realm tidak disetel, setelan akan menggunakan nama  Contact (Kontak) . SIP Registration Status (Status Registrasi SIP) Setelan ini adalah informasi hanya baca. Menampilkan status registrasi SIP. Setelan H.323 Gateway Setelan ditentukan pengguna. Menentukan alamat IP gateway H.323. Gatekeeper Setelan ditentukan pengguna. Menentukan gatekeeper H.323. User (Pengguna) Setelan ditentukan pengguna. Menentukan nama pengguna yang dipakai dengan gateway H.323. Password (Kata Sandi) Setelan ditentukan pengguna. Menentukan kata sandi untuk gateway H.323. Enable Fast Start (Aktifkan Mulai Cepat) Off (Nonaktif) * On (Aktif) Mengaktifkan Fast Start (Mulai Cepat) Disable H.245 Tunneling (Nonaktifkan H.245 Tunneling) Off (Nonaktif) * On (Aktif) Menonaktifkan H.323 Tunneling. Disable Gatekeeper Discovery (Nonaktifkan Pencarian Gatekeeper) Off (Nonaktif) On (Aktif) * Menonaktifkan pencarian gatekeeper H.323. Setelan T.38 Indicator Redundancy (Redundansi Indikator) 0–5  (3*) Menyetel berapa kali indikator faks diulang dalam komunikasi T.38. Low Speed Redundancy (Redundansi Kecepatan Rendah) 0–5  (3*) Menyetel berapa kali data kecepatan rendah diulang dalam komunikasi T.38. High Speed Redundancy (Redundansi Kecepatan Tinggi) 0–5  (1*) Menyetel berapa kali data kecepatan tinggi diulang dalam komunikasi T.38. menu Penyiapan Faks"},{"UUID":"7af8ed63-480a-4c3c-8c05-ed20a278f5f0","title":"Setelan Default Faks","link":"fax-defaults-subgroup.html","desc":"Fax Server Setup General Fax","descFull":"Fax Server Setup General Fax Settings (Setelan Faks Umum) Item menu General Fax Settings (Setelan Faks Umum) dan deskripsinya Item Menu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. To Format (Format Ke) T/A Menentukan penerima faks. Jika Anda ingin memakai nomor faks, tulis # sebelum angka. Reply Address (Alamat Balasan) T/A Menentukan alamat balasan untuk mengirim faks. Subject (Judul) T/A Menentukan pesan dan judul faks. Message (Pesan) T/A Enable analog receive (Aktifkan terima analog) Off (Nonaktif) * On (Aktif) Menyetel printer untuk menerima faks analog. Fax Server E‑mail Settings (Setelan Email Server Faks) Item menu  Fax Server E-mail Settings (Setelan Email Server Faks)  dan deskripsinya Item Menu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Use E‑mail SMTP Server (Gunakan Server SMTP Email) On (Aktif) Off (Nonaktif) * Menggunakan setelan Simple Mail Transfer Protocol (SMTP) untuk email saat menerima dan mengirim faks. Ketika disetel pada posisi  On (Aktif) , semua setelan lain dari menu  Fax Server E‑mail Settings  tidak akan muncul. Primary SMTP Gateway (Gateway SMTP Utama) T/A Tulis alamat IP atau nama host server SMTP utama. Primary SMTP Gateway Port (Port Gateway SMTP Utama) 1–65535 (25*) Masukkan nomor port server SMTP utama. Secondary SMTP Gateway (Gateway SMTP Sekunder) T/A Tulis alamat IP atau nama host server SMTP sekunder/cadangan. Secondary SMTP Gateway Port (Port Gateway SMTP Sekunder) 1–65535 (25*) Masukkan nomor port server SMTP sekunder/cadangan Anda. SMTP Timeout (Waktu SMTP Habis) 5–30 (30*) Menyetel waktu sebelum printer nonaktif apabila server SMTP tidak merespons. Reply Address (Alamat Balasan) T/A Menentukan alamat balasan untuk mengirim faks. Use SSL/TLS (Gunakan SSL/TLS) Disabled (Dinonaktifkan) * Negotiate (Negosiasi) Required (Diperlukan) Menentukan apakah hendak mengirim faks dengan tautan terenkripsi. Require Trusted Certificate (Memerlukan Sertifikat Tepercaya) Off (Nonaktif) On (Aktif) * Menentukan sertifikat tepercaya ketika mengakses server SMTP. SMTP Server Authentication (Autentikasi Server SMTP) No authentication required (Tidak diperlukan otentikasi) * Login / Biasa NTLM CRAM‑MD5 Digest‑MD5 Kerberos 5 Menyetel jenis otentikasi untuk server SMTP. Device‑Initiated E‑mail (Email Dipicu Perangkat) None (Tidak Ada) * Gunakan Kredensial SMTP Perangkat Menentukan apakah diperlukan kredensial untuk email dipicu perangkat. User‑Initiated E‑mail (Email Dipicu Pengguna) None (Tidak Ada) * Gunakan Kredensial SMTP Perangkat Use Session User ID and Password (Gunakan ID Pengguna Sesi dan Kata Sandi) Use Session E‑mail address and Password (Gunakan alamat Email Sesi dan Kata Sandi) Prompt user (Perintah Pengguna) Menentukan apakah diperlukan kredensial untuk email dipicu pengguna. Use Active Directory Device Credentials (Gunakan Kredensial Perangkat Direktori Aktif) Off (Nonaktif) * On (Aktif) Mengaktifkan kredensial pengguna dan destinasi grup untuk tersambung ke server SMTP. Device Userid (ID Pengguna Perangkat) T/A Menentukan ID pengguna dan kata sandi untuk tersambung ke server SMTP. Device Password (Kata Sandi Perangkat) T/A Kerberos 5 REALM T/A Menentukan realm untuk protokol otentikasi Kerberos 5. NTLM Domain T/A Menentukan nama domain untuk protokol keamanan NTLM. Disable \"SMTP server not set up\" error (Nonaktifkan eror “Server SMTP belum disiapkan”) Off (Nonaktif) * On (Aktif) Menyembunyikan pesan eror “Server SMTP belum disiapkan”. Fax Server Scan Settings (Setelan Pindai Server Faks) Item menu  Fax Server Scan Settings (Setelan Pindai Server Faks)  dan deskripsinya Item Menu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Image Format (Format Gambar) TIFF (.tif) PDF (.pdf) * XPS (.xps) TXT (.txt) RTF (.rtf) DOCX (.docx) XLSX (.xlsx) CSV (.csv) Menentukan format file untuk gambar yang dipindai. Content Type (Jenis Konten) Text (Teks) * Text/Photo (Teks/Foto) Photo (Foto) Graphics (Grafik) Meningkatkan output berdasarkan konten dokumen asli. Content Source (Sumber Konten) Black and White Laser (Laser Hitam dan Putih) Color Laser (Laser Warna) * Inkjet Photo/Film (Foto/Film) Magazine (Majalah) Newspaper (Koran) Press (Buku Cetak) Other (Lainnya) Meningkatkan hasil output berdasarkan sumber dokumen asli. Fax Resolution (Resolusi Faks) Standard (Standar) * Fine (Halus) Super Fine (Super Halus) Ultra Fine (Ultra Halus) Menyetel resolusi faks. Sides (Sisi-sisi) Off (Nonaktif) * Short Edge (Tepi Pendek) Long Edge (Tepi Panjang) Menentukan orientasi dokumen asli ketika memindai di dua sisi dokumen. Darkness (Kegelapan) 1–9 (5*) Menyetel kegelapan output. Orientation (Orientasi) Portrait (Potret) * Landscape (Lanskap) Menentukan orientasi teks dan grafik pada halaman. Original Size (Ukuran Asli) [Daftar ukuran kertas] Menyetel ukuran kertas dokumen asli. Mixed Sizes (Ukuran Campuran)  adalah setelan default perusahaan AS.  A4  adalah setelan default perusahaan internasional. Setelan ini bisa bervariasi, tergantung model printer Anda. Use Multi‑Page TIFF (Gunakan TIFF Multi Halaman) Off (Nonaktif) On (Aktif) * Pilih antara file TIFF halaman tunggal dan ganda. menu Penyiapan Server Faks"},{"UUID":"fe0e852e-7255-4a7f-8a83-3f5c355eb728","title":"Email","link":"email-setup-topic.html","desc":"Email Setup (Penyiapan Email) Item","descFull":"Email Setup (Penyiapan Email) Item menu Penyiapan Email dan deskripsinya Item Menu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Primary SMTP Gateway (Gateway SMTP Utama) Setelan ditentukan pengguna. Tulis alamat IP atau nama host server SMTP utama untuk mengirim email. Primary SMTP Gateway Port (Port Gateway SMTP Utama) 1–65535 (25*) Masukkan nomor port server SMTP utama. Secondary SMTP Gateway (Gateway SMTP Sekunder) Setelan ditentukan pengguna. Tulis alamat IP atau nama host server SMTP sekunder/cadangan. Secondary SMTP Gateway Port (Port Gateway SMTP Sekunder) 1–65535  (25*) Masukkan nomor port server SMTP sekunder/cadangan Anda. SMTP Timeout (Waktu SMTP Habis) 5–30 seconds  (30*) Menyetel waktu sebelum printer nonaktif apabila server SMTP tidak merespons. Reply Address (Alamat Balasan) Setelan ditentukan pengguna. Menentukan alamat balasan pada email Always use SMTP default Reply Address (Selalu gunakan Alamat Balasan default SMTP) On (Aktif) Off (Nonaktif) * Selalu gunakan alamat balasan default di server SMTP. Use SSL/TLS (Gunakan SSL/TLS) Disabled (Dinonaktifkan) * Negotiate (Negosiasi) Required (Diperlukan) Menentukan apakah hendak mengirim email dengan tautan terenkripsi. Require Trusted Certificate (Memerlukan Sertifikat Tepercaya) Off (Nonaktif) On (Aktif) * Menentukan sertifikat tepercaya ketika mengakses server SMTP. SMTP Server Authentication (Autentikasi Server SMTP) No authentication required (Tidak diperlukan otentikasi) * Login / Biasa NTLM CRAM‑MD5 Digest‑MD5 Kerberos 5 Menyetel jenis otentikasi untuk server SMTP. Device‑Initiated Email (Email Dipicu Perangkat) None (Tidak Ada) * None (Tidak Ada) * Gunakan Kredensial SMTP Perangkat Menentukan apakah diperlukan kredensial untuk email dipicu perangkat. User‑Initiated Email (Email Dipicu Pengguna) None (Tidak Ada) * Gunakan Kredensial SMTP Perangkat Use Session User ID and Password (Gunakan ID Pengguna Sesi dan Kata Sandi) Use Session Email Address and Password (Gunakan Alamat Email Sesi dan Kata Sandi) Prompt user (Perintah Pengguna) Menentukan apakah diperlukan kredensial untuk email dipicu pengguna. Use Active Directory Device Credentials (Gunakan Kredensial Perangkat Direktori Aktif) Off (Nonaktif) * On (Aktif) Menentukan apakah diperlukan kredensial untuk email dipicu pengguna. Device Userid (ID Pengguna Perangkat) Setelan ditentukan pengguna. Menentukan ID pengguna dan kata sandi untuk tersambung ke server SMTP. Device Password (Kata Sandi Perangkat) Setelan ditentukan pengguna. Kerberos 5 REALM Setelan ditentukan pengguna. Menentukan realm untuk protokol otentikasi Kerberos 5. NTLM Domain Setelan ditentukan pengguna. Menentukan nama domain untuk protokol keamanan NTLM. Disable \"SMTP server not set up\" error (Nonaktifkan eror “Server SMTP belum disiapkan”) Off (Nonaktif) * On (Aktif) Menyembunyikan pesan eror “Server SMTP belum disiapkan”. menu Penyiapan Email"},{"UUID":"bd9272e2-b95f-49ac-afce-f2639d1a87df","title":"Email","link":"email-setup-topic.html","desc":"Setelan Default Email Item menu","descFull":"Setelan Default Email Item menu Email Default (Setelan Default Email) dan deskripsinya Item Menu Item submenu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Subject (Judul): T/A Setelan ditentukan pengguna. Menentukan pesan dan judul email. Message (Pesan): T/A Setelan ditentukan pengguna. File Name (Nama File) T/A Setelan ditentukan pengguna. Menentukan nama file untuk dokumen yang dipindai. Format T/A JPEG (.jpg) PDF (.pdf) * TIFF (.tif) XPS (.xps) TXT (.txt) RTF (.rtf) DOCX (.docx) CSV (.csv) Menentukan format file untuk dokumen yang dipindai. Item menu bisa bervariasi, tergantung model printer Anda. Global OCR Settings (Setelan OCR Global) Recognized Languages (Bahasa yang Dikenal) [Daftar Bahasa] Mengatur setelan untuk pengenalan karakter optik (OCR). Menu ini hanya muncul jika Anda telah membeli dan menginstal solusi OCR. Auto Rotate (Rotasi Otomatis) Off (Nonaktif) * On (Aktif) Despeckle (Bintik) Off (Nonaktif) * On (Aktif) Auto Contrast Enhance (Peningkatan Kontras Otomatis) Off (Nonaktif) * On (Aktif) PDF Settings (Setelan PDF) PDF Version (Versi PDF) 1,3 1,4 1,5 * 1,6 1,7 Mengatur setelan PDF untuk gambar yang dipindai. Archival Version (Versi Arsip)  dan  Archival (PDF/A) ([PDF/A] Arsip)  hanya didukung jika  PDF Version (Versi PDF)  disetel pada 1.4 atau 1.7. Highly Compressed (Kompresi Tinggi)  hanya muncul apabila drive penyimpanan telah dipasang. Secure (Aman)  hanya didukung ketika  PDF Version  disetel ke 1.4 atau lebih. Archival (PDF/A) Off (Nonaktif) * On (Aktif) Archival Version A‑1a * A‑1b A‑2u Highly Compressed (Kompresi Tinggi) Off (Nonaktif) * On (Aktif) Secure (Aman) Off (Nonaktif) * On (Aktif) Searchable (Bisa Dicari) Off (Nonaktif) * On (Aktif) Bagi Tugas Berdasarkan Halaman 0 * Content Type (Jenis Konten) T/A Text (Teks) Text/Photo (Teks/Foto) * Photo (Foto) Graphics (Grafik) Tentukan konten dokumen asli. Content Source (Sumber Konten) T/A Black and White Laser (Laser Hitam dan Putih)  * Color Laser (Laser Warna) * Inkjet Photo/Film (Foto/Film) Magazine (Majalah) Newspaper (Koran) Press (Buku Cetak) Other (Lainnya) Menentukan sumber dokumen asli. Warna T/A Black and White (Hitam Putih) Gray (Abu-abu) Color (Warna) * Auto (Otomatis) Menentukan penangkapan gambar dokumen asli. Resolution (Resolusi) T/A 75 dpi 150 dpi 200 dpi 300 dpi 400 dpi 600 dpi Menyetel resolusi gambar pindai. Darkness (Kegelapan) T/A 1–9  (5*) Menyesuaikan kegelapan gambar yang dipindai. Orientation (Orientasi) T/A Portrait (Potret) * Landscape (Lanskap) Menentukan orientasi dokumen asli. Original Size (Ukuran Asli) T/A Mixed Sizes (Ukuran Campuran) * Menyetel ukuran kertas dokumen asli. Sides (Sisi-sisi) T/A Off (Nonaktif) * Short Edge (Tepi Pendek) Long Edge (Tepi Panjang) Menentukan orientasi dokumen asli ketika memindai di dua sisi dokumen. Advanced Imaging (Pencitraan Lanjutan) Item Menu Item submenu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Color Balance (Keseimbangan Warna) Cyan Magenta Kuning ‑4–4  (0*) ‑4–4  (0*) ‑4–4  (0*) Menyesuaikan intensitas warna untuk cyan, magenta, dan kuning. Color Dropout (Dropout Warna) Color Dropout (Dropout Warna) None (Tidak Ada) * Merah Hijau Biru Menentukan warna mana yang diturunkan saat memindai, dan menyesuaikan setelan dropout untuk warna tersebut. Default Red Threshold (Ambang Batas Default Warna Merah) 0–255  (128*) Default Green Threshold (Ambang Batas Default Warna Hijau) 0–255  (128*) Default Blue Threshold (Ambang Batas Default Warna Biru) 0–255  (128*) Auto Color Detect (Deteksi Warna Otomatis) Color Sensitivity (Sensitivitas Warna) 1–9  (5*) Mengonfigurasi setelan deteksi warna otomatis. Area Sensitivity (Sensitivitas Area) 1–9  (5*) E‑mail Bit Depth (Kedalaman Bit Email) 1 bit * 8 bit * Resolusi Pindai Minimal 75 dpi 150 dpi 200 dpi 300 dpi JPEG Quality (Kualitas JPEG) T/A Best for content (Terbaik untuk konten) * 5–95 Menyetel kualitas JPEG gambar yang dipindai. Contrast (Kontras) T/A Best for content (Terbaik untuk konten) * 0–5 Menentukan kontras untuk gambar yang dipindai. Background Removal (Penghapusan Latar) Deteksi Latar Belakang Berbasis Konten * Tetap Level  ‑4 sampai 4  (0*) Menghapus noise warna atau gambar latar dari dokumen asli. Mirror Image (Gambar Kebalikan) T/A Off (Nonaktif) * On (Aktif) Menciptakan gambar kebalikan dari dokumen asli. Negative Image (Gambar Negatif) T/A Off (Nonaktif) * On (Aktif) Menciptakan gambar negatif dari dokumen asli. Shadow Detail (Detail Bayangan) T/A ‑4 sampai 4  (0*) Menyesuaikan detail bayangan pada gambar yang dipindai. Scan Edge to Edge (Pindai Tepi ke Tepi) T/A Off (Nonaktif) * On (Aktif) Memindai dokumen asli dari tepi ke tepi. Sharpness (Ketajaman) T/A 1–5  (3*) Menyesuaikan ketajaman gambar yang dipindai. Temperature (Temperatur) T/A ‑4 sampai 4  (0*) Menghasilkan output yang lebih biru atau merah daripada dokumen asli. Blank Pages (Halaman Kosong) Penghapusan Halaman Kosong Jangan Hapus * Hapus Menghapus halaman kosong dari dokumen asli. Blank Page Sensitivity (Sensitivitas Halaman Kosong) 1–9  (5*) Menyetel sensitivitas pindai kaitannya dengan halaman kosong pada dokumen asli. Admin Controls (Kontrol Admin) Item Menu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Max Email Size (Ukuran Email Maksimal) 0–65535  (0*) Menyetel ukuran file yang diizinkan untuk masing-masing email. Size Error Message (Pesan Eror Ukuran) Setelan ditentukan pengguna. Menentukan pesan eror yang dikirim printer ketika email melebihi ukuran yang diizinkan. Anda bisa menulis hingga 1024 karakter. Limit Destinations (Batasi Tujuan) Setelan ditentukan pengguna. Membatasi pengiriman email hanya ke daftar nama domain yang telah ditentukan. Gunakan koma untuk memisahkan masing-masing domain. Send Me a Copy (Kirim Salinan Ke Saya) Never appears (Jangan pernah muncul) * On by Default (Aktif secara Default) Off by Default (Nonaktif secara Default) Always On (Selalu Aktif) Mengirim salinan email kepada Anda. Allow self emails only (Izinkan mengirim email ke alamat sendiri) Off (Nonaktif) * On (Aktif) Menyetel printer untuk mengirim email ke diri Anda sendiri. Use cc:/bcc (Gunakan cc/bcc): Off (Nonaktif) * On (Aktif) Mengaktifkan fitur Carbon Copy (CC) dan Blind Carbon Copy (BCC) pada email. Use Multi‑Page TIFF (Gunakan TIFF Multi Halaman) Off (Nonaktif) * On (Aktif) Mengaktifkan pemindaian beberapa gambar TIFF dalam satu file TIFF. TIFF Compression (Kompresi TIFF) JPEG LZW * Menentukan jenis kompresi file TIFF. Text Default (Setelan Default Teks) 5–95  (75*) Menyetel kualitas teks pada konten yang sedang dipindai. Text/Photo Default (Setelan Default Teks/Foto) 5–95  (75*) Menyetel kualitas teks dan foto pada konten yang sedang dipindai. Photo Default (Setelan Default Foto) 5–95  (50*) Menyetel kualitas foto pada konten yang sedang dipindai. Adjust ADF Skew (Sesuaikan Kemiringan ADF) Off (Nonaktif) * On (Aktif) Menyetel printer untuk menyesuaikan gambar miring dari dokumen yang dipindai dari ADF. Transmission Log (Log Transmisi) Print log (Cetak log) * Do Not Print Log (Jangan Cetak Log) Print Only For Error (Hanya Cetak Jika Eror) Mencetak log transmisi untuk pemindaian email Log Paper Source (Sumber Kertas Log) Tray (Baki)  [x] (1*) Multipurpose Feeder (Feeder multiguna) Menentukan sumber kertas untuk mencetak log. Custom Job Scanning (Memindai Pekerjaan Kustom) Off (Nonaktif) * On (Aktif) Menyetel printer untuk memindai set pertama dari dokumen asli menggunakan setelan yang telah ditentukan, lalu memindai set kedua dengan setelan yang sama atau berbeda. Item menu ini hanya muncul ketika drive penyimpanan dipasang. Scan Preview (Pratinjau Hasil Pindai) Off (Nonaktif) On (Aktif) * Menampilkan pratinjau hasil pindai dari dokumen asli. Item menu ini hanya muncul ketika drive penyimpanan dipasang. Allow Save as Shortcut (Izinkan Simpan sebagai Pintasan) Off (Nonaktif) On (Aktif) * Menyimpan alamat email sebagai pintasan. E‑mail Images Sent As (Gambar Email Dikirim Sebagai) Attachment (Lampiran) * Web Link Menentukan cara mengirim gambar yang disertakan di dalam email Reset E-mail Information After Sending (Setel Ulang Informasi Email setelah Mengirim) Off (Nonaktif) On (Aktif) * Menyetel ulang kolom Ke, Judul, Pesan, dan Nama File ke nilai default setelah mengirim email. menu Setelan Default Email"},{"UUID":"a13645ab-0354-451c-bfd5-d826cebd0979","title":"Email","link":"email-setup-topic.html","desc":"Web Link Setup (Penyiapan Web","descFull":"Web Link Setup (Penyiapan Web Link) Item menu Web Link Setup (Penyiapan Web Link) dan deskripsinya Item Menu Setelan Deskripsi Server Setelan ditentukan pengguna. Menentukan kredensial server yang menyimpan gambar yang terdapat di dalam email. Login (Masuk) Setelan ditentukan pengguna. Password (Kata Sandi) Setelan ditentukan pengguna. Path (Jalur) Setelan ditentukan pengguna. File Name (Nama File) Setelan ditentukan pengguna. Web Link Setelan ditentukan pengguna. menu Penyiapan Web Link"},{"UUID":"9082f672-6c6d-457b-bd72-c16558ae0498","title":"FTP","link":"ftp-defaults-topic.html","desc":"FTP Defaults (Setelan Default FTP)","descFull":"FTP Defaults (Setelan Default FTP) Item menu FTP Default (Setelan Default FTP) dan deskripsinya Item Menu Item submenu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Format T/A JPEG (.jpg) PDF (.pdf) * TIFF (.tif) XPS (.xps) TXT (.txt) RTF (.rtf) DOCX (.docx) CSV (.csv) Menentukan format file untuk gambar yang dipindai. Global OCR Settings (Setelan OCR Global) Recognized Languages (Bahasa yang Dikenal) [Daftar Bahasa] Mengatur setelan untuk pengenalan karakter optik (OCR). Menu ini hanya muncul jika Anda telah membeli dan menginstal solusi OCR. Auto Rotate (Rotasi Otomatis) Off (Nonaktif) * On (Aktif) Despeckle (Bintik) Off (Nonaktif) * On (Aktif) Auto Contrast Enhance (Peningkatan Kontras Otomatis) Off (Nonaktif) * On (Aktif) PDF Settings (Setelan PDF) PDF Version (Versi PDF) 1,3 1,4 1,5 * 1,6 1,7 Mengatur setelan PDF untuk gambar yang dipindai. Archival Version (Versi Arsip)  dan  Archival (PDF/A) ([PDF/A] Arsip)  hanya didukung jika  PDF Version (Versi PDF)  disetel pada 1.4 atau 1.7. Highly Compressed (Kompresi Tinggi)  hanya muncul apabila drive penyimpanan telah dipasang. Secure (Aman)  hanya didukung ketika  PDF Version  disetel ke 1.4 atau lebih. Archival (PDF/A) Off (Nonaktif) * On (Aktif) Archival Version A‑1a * A‑1b A‑2u Highly Compressed (Kompresi Tinggi) Off (Nonaktif) * On (Aktif) Secure (Aman) Off (Nonaktif) * On (Aktif) Searchable (Bisa Dicari) Off (Nonaktif) * On (Aktif) Bagi Tugas Berdasarkan Halaman 0 * Content Type (Jenis Konten) T/A Text (Teks) Text/Photo (Teks/Foto) * Graphics (Grafik) Photo (Foto) Meningkatkan output berdasarkan jenis konten dokumen asli. Content Source (Sumber Konten) T/A Black and White Laser (Laser Hitam dan Putih) Color Laser (Laser Warna) * Inkjet Photo/Film (Foto/Film) Magazine (Majalah) Newspaper (Koran) Press (Buku Cetak) Other (Lainnya) Meningkatkan output berdasarkan sumber konten dokumen asli. Warna T/A Black and White (Hitam Putih) Gray (Abu-abu) Color (Warna) * Auto (Otomatis) Menyetel printer untuk menangkap konten file berwarna atau hitam putih. Resolution (Resolusi) T/A 75 dpi 150 dpi 200 dpi 300 dpi 400 dpi 600 dpi Menyetel resolusi gambar pindai. Darkness (Kegelapan) T/A 1–9  (5*) Menyesuaikan kegelapan gambar yang dipindai. Orientation (Orientasi) T/A Portrait (Potret) * Landscape (Lanskap) Menentukan orientasi dokumen asli. Original Size (Ukuran Asli) T/A Mixed Sizes (Ukuran Campuran) * Menyetel ukuran kertas dokumen asli. Sides (Sisi-sisi) T/A Off (Nonaktif) * Long Edge (Tepi Panjang) Short Edge (Tepi Pendek) Menentukan orientasi ketika memindai di dua sisi dokumen. File Name (Nama File) T/A Setelan ditentukan pengguna. Menentukan nama file untuk gambar yang dipindai. Advanced Imaging (Pencitraan Lanjutan) Item Menu Item submenu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Color Balance (Keseimbangan Warna) Cyan Magenta Kuning ‑4–4  (0*) ‑4–4  (0*) ‑4–4  (0*) Menyesuaikan intensitas warna untuk cyan, magenta, dan kuning. Color Dropout (Dropout Warna) Color Dropout (Dropout Warna) None (Tidak Ada) * Merah Hijau Biru Menentukan warna mana yang diturunkan saat memindai, dan menyesuaikan setelan dropout untuk warna tersebut. Default Red Threshold (Ambang Batas Default Warna Merah) 0–255  (128*) Default Green Threshold (Ambang Batas Default Warna Hijau) 0–255  (128*) Default Blue Threshold (Ambang Batas Default Warna Biru) 0–255  (128*) Auto Color Detect (Deteksi Warna Otomatis) Color Sensitivity (Sensitivitas Warna) 1–9  (5*) Mengonfigurasi setelan deteksi warna otomatis. Area Sensitivity (Sensitivitas Area) 1–9  (5*) E‑mail Bit Depth (Kedalaman Bit Email) 1 bit * 8 bit * Resolusi Pindai Minimal 75 dpi 150 dpi 200 dpi 300 dpi JPEG Quality (Kualitas JPEG) T/A Best for content (Terbaik untuk konten) * 5–95 Menyetel kualitas JPEG gambar yang dipindai. Contrast (Kontras) T/A Best for content (Terbaik untuk konten) * 0–5 Menentukan kontras untuk gambar yang dipindai. Background Removal (Penghapusan Latar) Deteksi Latar Belakang Berbasis Konten * Tetap Level  ‑4 sampai 4  (0*) Menghapus noise warna atau gambar latar dari dokumen asli. Mirror Image (Gambar Kebalikan) T/A Off (Nonaktif) * On (Aktif) Menciptakan gambar kebalikan dari dokumen asli. Negative Image (Gambar Negatif) T/A Off (Nonaktif) * On (Aktif) Menciptakan gambar negatif dari dokumen asli. Shadow Detail (Detail Bayangan) T/A ‑4 sampai 4  (0*) Menyesuaikan detail bayangan pada gambar yang dipindai. Scan Edge to Edge (Pindai Tepi ke Tepi) T/A Off (Nonaktif) * On (Aktif) Memindai dokumen asli dari tepi ke tepi. Sharpness (Ketajaman) T/A 1–5  (3*) Menyesuaikan ketajaman gambar yang dipindai. Temperature (Temperatur) T/A ‑4 sampai 4  (0*) Menghasilkan output yang lebih biru atau merah daripada dokumen asli. Blank Pages (Halaman Kosong) Penghapusan Halaman Kosong Jangan Hapus * Hapus Menghapus halaman kosong dari dokumen asli. Blank Page Sensitivity (Sensitivitas Halaman Kosong) 1–9  (5*) Menyetel sensitivitas pindai kaitannya dengan halaman kosong pada dokumen asli. Admin Controls (Kontrol Admin) Item Menu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Text Default (Setelan Default Teks) 5–95  (75*) Menyetel kualitas teks pada gambar yang dipindai. Text/Photo Default (Setelan Default Teks/Foto) 5–95  (75*) Menyetel kualitas teks dan foto pada gambar yang dipindai. Photo Default (Setelan Default Foto) 5–95  (50*) Menyetel kualitas foto pada gambar yang dipindai. Use Multi‑Page TIFF (Gunakan TIFF Multi Halaman) On (Aktif) * Off (Nonaktif) Mengaktifkan pemindaian beberapa gambar TIFF dalam satu file TIFF. TIFF Compression (Kompresi TIFF) LZW * JPEG Menentukan jenis kompresi file TIFF. Transmission Log (Log Transmisi) Print log (Cetak log) * Do Not Print Log (Jangan Cetak Log) Print Only For Error (Hanya Cetak Jika Eror) Mencetak log transmisi untuk pemindaian FTP Log Paper Source (Sumber Kertas Log) Tray (Baki)  [x] (1*) Multipurpose Feeder (Feeder multiguna) Menentukan sumber kertas untuk mencetak log FTP. Custom Job Scanning (Memindai Pekerjaan Kustom) Off (Nonaktif) * On (Aktif) Menyetel printer untuk memindai set pertama dari dokumen asli menggunakan setelan yang telah ditentukan, lalu memindai set kedua dengan setelan yang sama atau berbeda. Item menu ini hanya muncul ketika drive penyimpanan dipasang. Scan Preview (Pratinjau Hasil Pindai) Off (Nonaktif) On (Aktif) * Menampilkan pratinjau dokumen asli. Item menu ini hanya muncul ketika drive penyimpanan dipasang. Allow Save as Shortcut (Izinkan Simpan sebagai Pintasan) Off (Nonaktif) On (Aktif) * Menyimpan alamat FTP sebagai pintasan. menu Setelan Default FTP"},{"UUID":"01878905-f231-4261-961a-cc413253b90b","title":"USB Drive","link":"flash-drive-scan-topic.html","desc":"Flash Drive Scan (Pindai dari","descFull":"Flash Drive Scan (Pindai dari Flash Drive) Item menu Flash Drive Scan (Pindai dari Flash Drive) dan deskripsinya Item Menu Item submenu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Format T/A JPEG (.jpg) PDF (.pdf) * TIFF (.tif) XPS (.xps) TXT (.txt) RTF (.rtf) * DOCX (.doc) XLSX (.xlsx) CSV (.csv) Menentukan format file untuk gambar yang dipindai. TXT (.txt) ,  RTF (.rtf) ,  DOCX (.docx) ,  XLSX (.xlsx) , dan  CSV (.csv)  hanya muncul jika Anda membeli dan menginstal solusi Optical Character Recognition (OCR/Pengenalan Karakter Optik). Global OCR Settings (Setelan OCR Global) Recognized Languages (Bahasa yang Dikenal) [Daftar Bahasa] Mengatur setelan OCR. Menu ini hanya muncul jika Anda telah membeli dan menginstal solusi OCR. Auto Rotate (Rotasi Otomatis) Off (Nonaktif) * On (Aktif) Despeckle (Bintik) Off (Nonaktif) * On (Aktif) Auto Contrast Enhance (Peningkatan Kontras Otomatis) Off (Nonaktif) * On (Aktif) PDF Settings (Setelan PDF) PDF Version (Versi PDF) 1,3 1,4 1,5 * 1,6 1,7 Mengatur setelan PDF untuk gambar yang dipindai. Archival (PDF/A)  dan  Archival Version —hanya didukung jika  Versi PDF  disetel pada 1.4 atau 1.7. Highly Compressed (Kompresi Tinggi) —hanya muncul apabila hard disk telah dipasang. Secure (Aman) —hanya didukung ketika  Versi PDF  disetel pada 1.4 atau lebih. Archival (PDF/A) Off (Nonaktif) * On (Aktif) Archival Version A‑1a * A‑1b A‑2u Highly Compressed (Kompresi Tinggi) Off (Nonaktif) * On (Aktif) Secure (Aman) Off (Nonaktif) * On (Aktif) Searchable (Bisa Dicari) Off (Nonaktif) * On (Aktif) Content Type (Jenis Konten) T/A Text (Teks) Text/Photo (Teks/Foto) * Photo (Foto) Graphics (Grafik) Meningkatkan output berdasarkan jenis konten dokumen asli. Content Source (Sumber Konten) T/A Black and White Laser (Laser Hitam dan Putih) Color Laser (Laser Warna) * Inkjet Photo/Film (Foto/Film) Magazine (Majalah) Newspaper (Koran) Press (Buku Cetak) Other (Lainnya) Meningkatkan output berdasarkan sumber konten dokumen asli. Warna T/A Black and White (Hitam Putih) Gray (Abu-abu) Color (Warna) * Auto (Otomatis) Menyetel printer untuk menangkap konten file berwarna atau hitam putih. Resolution (Resolusi) T/A 75 dpi 150 dpi 200 dpi 300 dpi 400 dpi 600 dpi Menyetel resolusi gambar pindai. Darkness (Kegelapan) T/A 1–9  (5*) Menyesuaikan kegelapan gambar yang dipindai. Orientation (Orientasi) T/A Portrait (Potret) * Landscape (Lanskap) Menentukan orientasi dokumen asli. Original Size (Ukuran Asli) T/A Mixed Sizes (Ukuran Campuran) * Menyetel ukuran kertas dokumen asli. Sides (Sisi-sisi) T/A Off (Nonaktif) * Short Edge (Tepi pendek) Long Edge (Tepi Panjang) Menentukan orientasi dokumen asli ketika memindai di dua sisi dokumen. File Name (Nama File) T/A Setelan ditentukan pengguna. Menentukan nama file untuk gambar yang dipindai. Advanced Imaging (Pencitraan Lanjutan) Color Balance (Keseimbangan Warna) Cyan  (0*) Magenta  (0*) Kuning  (0*) Menyesuaikan intensitas warna untuk cyan, magenta, dan kuning. Color Dropout (Dropout Warna) Color Dropout (Penurunan Warna)  ( Tidak ada *) Default Red Threshold (Ambang Batas Default Warna Merah)  (128*) Default Green Threshold (Ambang Batas Default Hijau)  (128*) Default Blue Threshold (Ambang Batas Default Warna Biru)  (128*) Menentukan warna mana yang diturunkan saat memindai, dan menyesuaikan setelan dropout untuk warna tersebut. Auto Color Detect (Deteksi Warna Otomatis) Color Sensitivity (Sensitivitas Warna)  (5*) Area Sensitivity (Sensitivitas Area)  (5*) Scan Bit Depth (Kedalaman Bit Pindai)  (1 bit*) Minimum Scan Resolution (Resolusi Pindai Minimal)  (300 dpi*) Mengonfigurasi setelan deteksi warna otomatis. JPEG Quality (Kualitas JPEG) Best for content (Terbaik untuk konten) * 5–95 Menyetel kualitas JPEG gambar yang dipindai. Contrast (Kontras) Best for content (Terbaik untuk konten) * 0–5 Menentukan kontras untuk gambar yang dipindai. Background Removal (Penghapusan Latar) Background Detection (Deteksi Latar)  ( Content-based/Berbasis konten *) Level  (0*) Menghapus noise warna atau gambar latar dari dokumen asli. Mirror Image (Gambar Kebalikan) Off (Nonaktif) * On (Aktif) Menciptakan gambar kebalikan dari dokumen asli. Item Menu Item submenu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Advanced Imaging (Pencitraan Lanjutan) Negative Image (Gambar Negatif) Off (Nonaktif) * On (Aktif) Menciptakan gambar negatif dari dokumen asli. Shadow Detail (Detail Bayangan) ‑4 sampai 4  (0*) Menyesuaikan detail bayangan pada gambar yang dipindai. Scan Edge to Edge (Pindai Tepi ke Tepi) Off (Nonaktif) * On (Aktif) Memindai dokumen asli dari tepi ke tepi. Sharpness (Ketajaman) 1–5  (3*) Menyesuaikan ketajaman gambar yang dipindai. Temperature (Temperatur) ‑4 sampai 4  (0*) Menghasilkan output yang lebih biru atau merah daripada dokumen asli. Blank Pages (Halaman Kosong) Blank Page Removal (Penghapusan Halaman Kosong)  ( Do Not Remove/Jangan Hapus *) Blank Page Sensitivity (Sensitivitas Halaman Kosong)  (5*) Menyetel sensitivitas pindai kaitannya dengan halaman kosong pada dokumen asli. Admin Controls (Kontrol Admin) Text Default (Setelan Default Teks) 5–95  (75*) Menyetel kualitas teks pada gambar yang dipindai. Text/Photo Default (Setelan Default Teks/Foto) 5–95  (75*) Menyetel kualitas teks dan foto pada gambar yang dipindai. Photo Default (Setelan Default Foto) 5–95  (50*) Menyetel kualitas foto pada gambar yang dipindai. Use Multi‑Page TIFF (Gunakan TIFF Multi Halaman) Off (Nonaktif) On (Aktif) * Mengaktifkan pemindaian beberapa gambar TIFF dalam satu file TIFF. TIFF Compression (Kompresi TIFF) JPEG LZW * Menentukan jenis kompresi file TIFF. Custom Job Scanning (Memindai Pekerjaan Kustom) Off (Nonaktif) * On (Aktif) Menyetel printer untuk memindai set pertama dari dokumen asli menggunakan setelan yang telah ditentukan, lalu memindai set kedua dengan setelan yang sama atau berbeda. Item menu ini hanya muncul ketika drive penyimpanan dipasang. Scan Preview (Pratinjau Hasil Pindai) Off (Nonaktif) * On (Aktif) Menampilkan pratinjau hasil pindai dari dokumen asli. Item menu ini hanya muncul ketika drive penyimpanan dipasang. Adjust ADF Skew (Sesuaikan Kemiringan ADF) Off (Nonaktif) On (Aktif) * Menyetel printer untuk menyesuaikan gambar miring dari dokumen yang dipindai dari pengumpan dokumen otomatis. menu Pindai dari Flash Drive"},{"UUID":"1b25bd4b-2928-402e-8441-e3c86580a5dc","title":"USB Drive","link":"flash-drive-scan-topic.html","desc":"Flash Drive Print (Cetak dari","descFull":"Flash Drive Print (Cetak dari Flash Drive) Item menu Flash Drive Print (Cetak dari Flash Drive) dan deskripsinya Item Menu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Number of Copies (Jumlah Salinan) 1–9999  (1*) Menyetel jumlah salinan dalam suatu pekerjaan cetak. Paper Source (Sumber Kertas) Tray (Baki)  [x] (1*) Multipurpose Feeder (Feeder multiguna) Manual Paper (Kertas Manual) Manual Envelope (Amplop Manual) Menyetel sumber kertas untuk pekerjaan cetak. Warna Off (Nonaktif) On (Aktif) * Mencetak dari flash drive dengan tinta warna. Collate (Susun) Off [1,1,1,2,2,2] On [1,2,1,2,1,2] * Menjaga agar halaman pekerjaan cetak tertumpuk secara urut, khususnya saat mencetak beberapa salinan pekerjaan. Sides (Sisi-sisi) 1‑Sided (1 Sisi) * 2‑Sided (2 Sisi) Menentukan apakah hendak mencetak pada satu atau dua sisi kertas. Stapler Off (Nonaktif) * 1 staple, pojok kiri atas 2 staple, kiri 1 staple, pojok kanan atas 2 staple, atas 1 staple, pojok kiri bawah 2 staple, bawah 1 staple, pojok kanan bawah 2 staple, kanan Menentukan posisi staple untuk semua pekerjaan cetak. Item menu ini hanya muncul ketika lis stapler dipasang. Lis Lubang Off (Nonaktif) * 2 lubang 3 lubang 4 lubang Menyetel mode pelubangan untuk semua pekerjaan cetak. Item menu ini hanya muncul ketika lis lubang stapler atau lis buklet dipasang. Halaman Ofset None (Tidak Ada) * Between Copies (Di Sela Salinan) Between Jobs (Di Sela Pekerjaan) Menyusun output atau salinan dari suatu pekerjaan cetak. Between Copies (Di Sela-sela Salinan) —menyusun setiap salinan dari suatu pekerjaan cetak apabila  Collate  disetel ke  On [1,2,1,2,1,2] . Jika  Collate —disetel ke  Off [1,1,1,2,2,2] , maka setiap kumpulan hasil cetak akan disusun berdasarkan kesamaan nomor halaman. Between Jobs (Di Sela-sela Pekerjaan) —menyetel posisi ofset yang sama untuk seluruh pekerjaan cetak, terlepas dari berapa jumlah salinan yang dicetak. Flip Style (Model Lipat) Long Edge (Tepi Panjang) * Short Edge (Tepi Pendek) Menentukan sisi kertas mana yang akan dijilid saat mencetak dua sisi. Pages per Side (Halaman ke Sisi) Off (Nonaktif) * 2 pages per side (2 halaman per sisi) 3 pages per side (2 halaman per sisi) 4 pages per side (2 halaman per sisi) 6 pages per side (2 halaman per sisi) 9 pages per side (2 halaman per sisi) 12 pages per side (2 halaman per sisi) 16 pages per side (2 halaman per sisi) Mencetak beberapa gambar halaman pada satu sisi lembar kertas. Pages per Side (Halaman per Sisi) Horizontal (Horisontal) * Reverse Horizontal (Horisontal Terbalik) Reverse Vertical (Vertikal Terbalik) Vertical (Vertikal) Menentukan posisi beberapa gambar halaman saat memakai menu  Pages per Side (Halaman per Sisi) . Pages per Side Orientation (Halaman per Orientasi Sisi) Auto (Otomatis) * Landscape (Lanskap) Portrait (Potret) Menentukan orientasi beberapa gambar halaman saat memakai menu  Pages per Side (Halaman per Sisi) . Pages per Side Border (Halaman per Batas Sisi) None (Tidak Ada) * Solid (Penuh) Mencetak batas di sekeliling masing-masing gambar halaman ketika memakai menu  Pages per Side (Halaman per Sisi) . Separator Sheets (Lembaran Pemisah) Off (Nonaktif) * Between Copies (Di Sela Salinan) Between Jobs (Di Sela Pekerjaan) Between Pages (Di Sela Halaman) Memasukkan lembar pemisah kosong saat mencetak. Separator Sheet Source (Sumber Lembar Pemisah) Tray (Baki)  [x] (1*) Multipurpose Feeder (Feeder multiguna) Menentukan sumber kertas untuk lembar pemisah. Blank Pages (Halaman Kosong) Do Not Print (Jangan Cetak) * Print (Cetak) Mencetak halaman kosong dalam pekerjaan cetak. menu Cetak dari Flash Drive"},{"UUID":"ef601129-c50c-4b39-8c53-dd3d9e4ec051","title":"Port/Jaringan","link":"network-overview-topic.html","desc":"Tinjauan Jaringan Item menu Network","descFull":"Tinjauan Jaringan Item menu Network Overview (Tinjauan Jaringan) dan deskripsinya Item Menu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Active Adapter (Adaptor Aktif) Auto (Otomatis) * Standard Network (Jaringan Standar) Wireless (Nirkabel) Menentukan jenis koneksi jaringan. Wireless (Nirkabel)  hanya tersedia di printer yang tersambung ke jaringan nirkabel. Network Status (Status Jaringan) Setelan ini adalah informasi hanya baca. Menampilkan status konektivitas jaringan printer. Display Network Status on Printer (Tampilkan Status Jaringan di Printer) Off (Nonaktif) On (Aktif) * Menampilkan status jaringan di printer. Speed, Duplex (Kecepatan, Dupleks) Setelan ini adalah informasi hanya baca. Menampilkan kecepatan kartu jaringan aktif saat ini. IPv4 Setelan ini adalah informasi hanya baca. Menampilkan alamat IPv4. All IPv6 Addresses (Semua Alamat IPv6) Setelan ini adalah informasi hanya baca. Menampilkan semua alamat IPv6. Reset Print Server (Setel Ulang Server Cetak) Start (Mulai) Menyetel ulang semua koneksi jaringan aktif ke printer. Setelan ini akan menghapus semua setelan konfigurasi jaringan. Network Job Timeout (Waktu Pekerjaan Jaringan Habis) Off (Nonaktif) On (Aktif) * (90 detik) Menyetel waktu sebelum printer membatalkan pekerjaan cetak jaringan. Banner Page (Halaman Banner) Off (Nonaktif) On (Aktif) * Mencetak halaman banner. Scan to PC Port Range (Pindai ke Rentang Port PC) Setelan ditentukan pengguna. Menentukan rentang port yang valid bagi printer yang ada di belakang firewall blocking port. Enable Network Connections (Aktifkan Koneksi Jaringan) Off (Nonaktif) On (Aktif) * Mengaktifkan printer untuk tersambung ke jaringan. Enable LLDP (Aktifkan LLDP) Off (Nonaktif) * On (Aktif) Menampilkan status jaringan di layar printer. menu Tinjauan Jaringan"},{"UUID":"fc111c84-98fb-4c1b-8170-ae599169545f","title":"Port/Jaringan","link":"network-overview-topic.html","desc":"Wireless (Nirkabel) Menu ini hanya","descFull":"Wireless (Nirkabel) Menu ini hanya tersedia di beberapa printer yang tersambung ke jaringan Wi-Fi atau printer yang memiliki adaptor jaringan nirkabel. Item menu Wireless (Nirkabel) dan deskripsinya Item Menu Item submenu Setelan Deskripsi Setup On Printer Panel (Penyiapan pada Panel Printer) Choose Network (Pilih Jaringan) [Daftar jaringan nirkabel yang tersedia] Menentukan jaringan nirkabel yang akan disambungkan ke printer. Add Wi‑Fi Network (Tambah Jaringan Wi-Fi) Network Name (Nama Jaringan) Network Mode (Mode Jaringan)  ( Infrastructure/Infrastruktur *) Wireless Security Mode (Mode Keamanan Nirkabel)  ( Disabled/Dinonaktifkan *) Masukkan nama dan jenis jaringan secara manual. Wi‑Fi Protected Setup (Penyiapan Wi-Fi Terlindungi) T/A Start Push Button Method (Mulai Metode Tombol Tekan) Start PIN Method (Mulai Metode PIN) Membuat jaringan Wi-Fi dan mengaktifkan keamanan jaringan. Start Push Button Method (Mulai Metode Tekan Tombol)  akan menyambungkan printer ke jaringan Wi‑Fi ketika tombol di printer dan akses poin (router nirkabel) ditekan dalam waktu tertentu. Start PIN Method (Mulai Metode PIN)  menyambungkan printer ke jaringan Wi-Fi ketika PIN di printer dimasukkan ke setelan titik akses nirkabel. Network Mode (Mode Jaringan) T/A BSS Type (Jenis BSS) Infrastructure (Infrastruktur) Menentukan mode jaringan. Compatibility (Kompatibilitas) T/A 802.11b/g/n (2.4GHz) * 802.11a/b/g/n/ac (2.4GHz/5GHz) 802.11a/n/ac (5GHz) Menentukan standar jaringan Wi-Fi. 802.11a/b/g/n/ac (2.4GHz/5GHz)  dan  802.11a/n/ac (5GHz)  hanya muncul ketika opsi Wi-Fi dipasang. Wireless Security Mode (Mode Keamanan Nirkabel) T/A Disabled (Dinonaktifkan) * WPA2/WPA-Personal WPA2-Personal WPA3/WPA-Personal WPA3-Personal 802.1x - RADIUS Menyetel mode keamanan untuk menyambungkan printer ke perangkat Wi-Fi. WPA2/WPA Personal T/A AES Mengaktifkan keamanan Wi-Fi melalui Wi-Fi Protected Access (WPA/Akses Wi-Fi terlindungi). Item menu ini hanya muncul ketika  Wireless Security Mode (Mode Keamanan Nirkabel)  disetel ke posisi  WPA2/WPA-Personal . Set PSK T/A Setelan ditentukan pengguna. Menyetel kata sandi untuk keamanan koneksi Wi‑Fi. WPA2-Personal T/A AES Mengaktifkan keamanan Wi-Fi melalui WPA2. Item menu ini hanya muncul ketika  Wireless Security Mode (Mode Keamanan Nirkabel)  disetel ke posisi  WPA2-Personal . 802.1x Encryption Mode T/A WPA+ WPA2 * Mengaktifkan keamanan Wi-Fi melalui standar 802.1x. Item menu ini hanya muncul ketika  Wireless Security Mode (Mode Keamanan Nirkabel)  disetel ke posisi  802.1x - RADIUS . 802.1x - RADIUS  hanya dapat diatur dari Embedded Web Server. IPv4 Enable DHCP (Aktifkan LLDP) On (Aktif) * Off (Nonaktif) Mengaktifkan dan mengatur setelan IPv4 pada printer. Set Static IP Address (Setel Alamat IP Statis) IP Address (Alamat IP) Netmask Gateway IPv6 Enable IPv6 (Aktifkan IPv6) On (Aktif) * Off (Nonaktif) Mengaktifkan dan mengatur setelan IPv6 pada printer. Enable DHCPv6 (Aktifkan IPv6) On (Aktif) Off (Nonaktif) * Stateless Address Autoconfiguration (Autokonfigurasi Alamat Tanpa Status) On (Aktif) * Off (Nonaktif) DNS Server Address (Alamat Server DNS) Setelan ditentukan pengguna. Manually Assigned IPv6 Address (Alamat IPv6 Ditentukan Manual) Setelan ditentukan pengguna. Manually Assigned IPv6 Router (Router IPv6 Ditentukan Manual) Setelan ditentukan pengguna. Address Prefix (Awal Alamat) Setelan ditentukan pengguna. All IPv6 Addresses (Semua Alamat IPv6) Setelan ditentukan pengguna. All IPv6 Router Addresses (Semua Alamat Router IPv6) Setelan ditentukan pengguna. Network Address (Alamat Jaringan) T/A UAA LAA Melihat alamat jaringan. PCL SmartSwitch T/A Off (Nonaktif) On (Aktif) * Menyetel printer agar otomatis berpindah ke emulasi PCL saat pekerjaan cetak memerlukannya, terlepas dari apa pun bahasa default printer. Jika  PCL SmartSwitch dinonaktifkan , printer tidak akan memeriksa data yang masuk dan akan menggunakan bahasa default printer yang ditentukan dalam menu  Setup (Penyiapan) . PS SmartSwitch T/A Off (Nonaktif) On (Aktif) * Menyetel printer untuk otomatis berpindah ke emulasi PS saat pekerjaan cetak memerlukannya, terlepas dari apa pun bahasa default printer. Jika  PS SmartSwitch dinonaktifkan , printer tidak akan memeriksa data yang masuk dan akan menggunakan bahasa default printer yang ditentukan dalam menu  Setup (Penyiapan) . Job Buffering (Tugas Sementara) T/A On (Aktif) Off (Nonaktif) * Menyimpan sementara pekerjaan cetak di drive penyimpanan sebelum mencetak. Item menu ini hanya muncul ketika drive penyimpanan dipasang. Mac Binary PS T/A Auto (Otomatis) * On (Aktif) Off (Nonaktif) Menyetel printer untuk memproses pekerjaan cetak emulasi Macintosh Binary PostScript. On (Aktif)  akan memproses pekerjaan cetak emulasi PostScript biner mentah. Off (Nonaktif)  akan memfilter pekerjaan cetak dengan protokol standar. menu Nirkabel"},{"UUID":"d5db1522-2a1a-4ec0-b5af-7d5eb11a9c58","title":"Port/Jaringan","link":"network-overview-topic.html","desc":"Wi‑Fi Direct Item menu Wi-Fi","descFull":"Wi‑Fi Direct Item menu Wi-Fi Direct dan deskripsinya Item Menu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Enable Wi-Fi Direct (Aktifkan Wi-Fi Direct) On (Aktif) Off (Nonaktif) * Menyetel printer untuk tersambung secara langsung ke perangkat Wi-Fi. Wi‑Fi Direct Name (Nama Wi-Fi Direct) Setelan ditentukan pengguna. Menentukan nama jaringan Wi-Fi Direct. Wi‑Fi Direct Password (Kata Sandi Wi-Fi Direct) Setelan ditentukan pengguna. Menyetel kata sandi untuk mengotentikasi dan memvalidasi pengguna di sambungan Wi-Fi. Show Password on Setup Page (Tampilkan Kata Sandi di Halaman Penyiapan) Off (Nonaktif) On (Aktif) * Menampilkan  Wi-Fi Direct Password (Kata Sandi Wi-Fi Direct)  di  Network Setup Page (Halaman Penyiapan Jaringan) . Preferred Channel Number (Preferensi Jumlah Saluran) 1–11 Auto (Otomatis) * Menyetel preferensi saluran jaringan Wi-Fi. Group Owner IP Address (Alamat IP Pemilik Grup) Setelan ditentukan pengguna. Menentukan alamat IP pemilik grup. Auto‑Accept Push Button Requests (Permintaan Tombol Tekan Terima Otomatis) Off (Nonaktif) * On (Aktif) Menerima permintaan sambungan ke jaringan secara otomatis. Menerima klien secara otomatis tidak aman. menu Wi‑Fi Direct"},{"UUID":"7bc401d9-88f8-41c5-a5e2-98d8c9ee424d","title":"Port/Jaringan","link":"network-overview-topic.html","desc":"Mobile Services Management (Manajemen Layanan","descFull":"Mobile Services Management (Manajemen Layanan Seluler) Item menu Mobile Services Management (Manajemen Layanan Seluler) dan deskripsinya Item Menu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Enable IPP Print (Aktifkan Pencetakan IPP) On (Aktif) * Off (Nonaktif) Mengaktifkan printer jaringan untuk mencetak pekerjaan dengan Internet Printing Protocol (IPP/Protokol Cetak Internet) Enable IPP Faks (Aktifkan Faks IPP) On (Aktif) * Off (Nonaktif) Mengaktifkan printer USB untuk mengirim pekerjaan faks dengan IPP. Enable IPP Over USB (Aktifkan IPP lewat USB) On (Aktif) * Off (Nonaktif) Mengaktifkan printer USB untuk mencetak pekerjaan dengan IPP. IPP biasanya didesain untuk printer jaringan. Enable Scan (Aktifkan Pindai) On (Aktif) * Off (Nonaktif) Mengaktifkan printer jaringan untuk mencetak pekerjaan dengan protokol eSCL. Enable Mopria Discovery (Aktifkan Mopria Discovery) On (Aktif) * Off (Nonaktif) Mengaktifkan perangkat seluler untuk menemukan printer bersertifikat Mopria™. menu Manajemen Layanan Seluler"},{"UUID":"bbe758f2-a519-4cfd-8288-fda7ac846a81","title":"Port/Jaringan","link":"network-overview-topic.html","desc":"Ethernet Item menu Ethernet dan","descFull":"Ethernet Item menu Ethernet dan deskripsinya Item Menu Item submenu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Network Speed (Kecepatan Jaringan) T/A Setelan ini adalah informasi hanya baca. Menampilkan kecepatan adaptor jaringan aktif. IPv4 Enable DHCP (Aktifkan LLDP) On (Aktif) * Off (Nonaktif) Mengatur setelan IPv4. Setelan ditentukan pengguna. Set Static IP Address (Setel Alamat IP Statis) IP Address (Alamat IP) Netmask Gateway IPv6 Enable IPv6 (Aktifkan IPv6) On (Aktif) * Off (Nonaktif) Mengatur setelan IPv6. Enable DHCPv6 (Aktifkan IPv6) Off (Nonaktif) * On (Aktif) Stateless Address Autoconfiguration (Autokonfigurasi Alamat Tanpa Status) On (Aktif) * Off (Nonaktif) DNS Server Address (Alamat Server DNS) Setelan ditentukan pengguna. Manually Assigned IPv6 Address (Alamat IPv6 Ditentukan Manual) Setelan ditentukan pengguna. Manually Assigned IPv6 Router (Router IPv6 Ditentukan Manual) Setelan ditentukan pengguna. Address Prefix (Awal Alamat) (64*) 0–128  (64*) All IPv6 Addresses (Semua Alamat IPv6) Setelan ini adalah informasi hanya baca. All IPv6 Router Addresses (Semua Alamat Router IPv6) Setelan ini adalah informasi hanya baca. Network Address (Alamat Jaringan) T/A UAA LAA Menentukan alamat jaringan. PCL SmartSwitch T/A Off (Nonaktif) On (Aktif) * Menyetel printer agar otomatis berpindah ke emulasi PCL saat pekerjaan cetak memerlukannya, terlepas dari apa pun bahasa default printer. Jika setelan ini dinonaktifkan, printer tidak akan memeriksa data masuk dan akan menggunakan bahasa default printer yang ditentukan dalam menu  Setup (Penyiapan) . PS SmartSwitch T/A Off (Nonaktif) On (Aktif) * Menyetel printer untuk otomatis berpindah ke emulasi PostScript saat pekerjaan cetak memerlukannya, terlepas dari apa pun bahasa default printer. Jika setelan ini dinonaktifkan, printer tidak akan memeriksa data masuk dan akan menggunakan bahasa default printer yang ditentukan dalam menu  Setup (Penyiapan) . Job Buffering (Tugas Sementara) T/A Off (Nonaktif) * On (Aktif) Menyimpan sementara pekerjaan di drive penyimpanan sebelum mencetak. Item menu ini hanya muncul ketika drive penyimpanan dipasang. Mac Binary PS T/A Auto (Otomatis) * Off (Nonaktif) On (Aktif) Menyetel printer untuk memproses pekerjaan cetak emulasi Macintosh Binary PostScript. Auto (Otomatis)  akan memproses pekerjaan cetak dari komputer yang berjalan dengan sistem operasi Windows atau Macintosh. Off (Nonaktif)  akan memfilter pekerjaan emulasi PostScript dengan protokol standar. Energy Efficient Ethernet (Ethernet Hemat Energi) T/A On (Aktif) Off (Nonaktif) Auto (Otomatis) * Mengurangi konsumsi daya ketika printer tidak menerima data dari jaringan Ethernet. menu Ethernet"},{"UUID":"ef0ce347-6933-40c7-855d-e907fbb47b25","title":"Port/Jaringan","link":"network-overview-topic.html","desc":"TCP/IP Menu ini hanya muncul","descFull":"TCP/IP Menu ini hanya muncul di printer jaringan atau printer yang tersambung ke server cetak. Item menu TCP/IP dan deskripsinya Item Menu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Set Hostname (Setel Nama Host) Setelan ditentukan pengguna. Menyetel nama host TCP/IP saat ini. Domain Name (Nama Domain) Setelan ditentukan pengguna. Menyetel nama domain. Allow DHCP/BOOTP to update NTP server (Izinkan DHCP/BOOTP untuk memperbarui server NTP) On (Aktif) * Off (Nonaktif) Mengizinkan klien Dynamic Host Configuration Protocol (DHCP) dan BOOTstrap Protocol (BOOTP) untuk memperbarui setelan NTP printer. Zero Configuration Name (Nama Konfigurasi Nol) Setelan ditentukan pengguna. Menentukan nama layanan untuk jaringan konfigurasi nol. Enable Auto IP (Aktifkan IP Otomatis) Off (Nonaktif) On (Aktif) * Menentukan alamat IP secara otomatis. DNS Server Address (Alamat Server DNS) Setelan ditentukan pengguna. Menentukan alamat server Domain Name System (DNS/Sistem Nama Domain). Backup DNS Server Address (Alamat Server DNS Cadangan) Setelan ditentukan pengguna. Menentukan alamat server DNS cadangan. Backup DNS Server Address 2 (Alamat Server DNS Cadangan 3) Backup DNS Server Address 3 (Alamat Server DNS Cadangan 3) Domain Search Order (Pesan Pencarian Domain) Setelan ditentukan pengguna. Menentukan daftar nama domain untuk menempatkan printer dan sumber dayanya yang berada di beberapa domain berbeda di jaringan. Enable DDNS (Aktifkan LLDP) Off (Nonaktif) * On (Aktif) Perbarui setelan Dynamic DNS (DDNS). DDNS TTL Setelan ditentukan pengguna. Menentukan setelan DDNS saat ini. Default TTL (TTL Default) DDNS Refresh Time (Waktu Penyegaran DDNS) Enable mDNS (Aktifkan mDNS) Off (Nonaktif) On (Aktif) * Memperbarui setelan DNS multicast. WINS Server Address (Alamat Server DNS) Setelan ditentukan pengguna. Menentukan alamat server untuk Layanan Nama Internet Windows (WINS). Enable BOOTP (Aktifkan LLDP) Off (Nonaktif) * On (Aktif) Izinkan BOOTP untuk menentukan alamat IP. Restricted Server List (Daftar Server yang Dilarang) Setelan ditentukan pengguna. Menentukan alamat IP yang diizinkan untuk berkomunikasi dengan printer melalui TCP/IP. Gunakan koma untuk memisahkan masing-masing alamat IP. Anda bisa menambah hingga 50 alamat IP. Restricted Server List Options (Opsi Daftar Server yang Dibatasi) Block All Ports (Blokir Semua Port) * Block Printing Only (Hanya Blokir Mencetak) Block Printing and HTTP Only (Hanya Blokir HTTP dan Mencetak) Menentukan opsi akses untuk alamat IP yang tidak terdaftar. MTU 256–1500 Ethernet  (1500*) Menentukan parameter Maximum Transmission Unit (MTU/Unit Transmisi Maksimal) untuk koneksi TCP. Raw Print Port (Port Cetak Mentah) 1–65535  (9100*) Menentukan nomor port mentah untuk printer yang tersambung ke suatu jaringan. Outbound Traffic Maximum Speed (Kecepatan Maksimal Lalu Lintas Keluar) Off (Nonaktif) * On (Aktif) Menentukan laju transfer maksimal printer. Jika diaktifkan, opsi untuk setelan ini adalah 100-1000000 kb/detik. TLS Support (Dukungan TLS) Enable TLSv1.0  ( Off/Nonaktif *) Enable TLSv1.1 (Aktifkan TLSv1.1) ( Off/Nonaktif *) Enable TLSv1.2 (Aktifkan TLSv1.2)  ( Aktif *) Mengaktifkan protokol Transport Layer Security (TLS). SSL Cipher List Setelan ditentukan pengguna. Menentukan algoritma cipher yang hendak dipakai untuk sambungan SSL atau TLS. TLSv1.3 SSL Cipher List menu TCP/IP"},{"UUID":"0c2223a7-1843-4e4c-9e5d-7d771f235538","title":"Port/Jaringan","link":"network-overview-topic.html","desc":"SNMP Menu ini hanya muncul","descFull":"SNMP Menu ini hanya muncul di printer jaringan atau printer yang tersambung ke server cetak. Item menu SNMP dan deskripsinya Item Menu Item submenu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. SNMP Versi 1 dan 2c Enabled (Diaktifkan) Off (Nonaktif) On (Aktif) * Mengatur Simple Network Management Protocol (SNMP/Protokol Manajemen Jaringan Sederhana) versi 1 dan 2c untuk menginstal aplikasi dan driver printer. Allow SNMP Set (Izinkan Kumpulan SNMP) Off (Nonaktif) On (Aktif) * Enable PPM MIB (Aktifkan PPM MIB) Off (Nonaktif) On (Aktif) * SNMP Community (Komunitas SNMP) Setelan ditentukan pengguna. SNMP Version 3 (SNMP Versi 3) Enabled (Diaktifkan) Off (Nonaktif) On (Aktif) * Mengaktifkan SNMP versi 3 untuk menginstal dan memperbarui keamanan printer. Context Name (Nama Konteks) Setelan ditentukan pengguna. Masukkan nama konteks. Set Read/Write Credentials (Setel Kredensial Baca/Tulis) Username (Nama Pengguna) Authentication Password (Kata Sandi Autentikasi) Privacy Password (Kata Sandi Privasi) Memasukkan kredensial baca dan tulis untuk SNMP versi 3. Set Read‑only Credentials (Setel Kredensial Hanya Baca) Username (Nama Pengguna) Authentication Password (Kata Sandi Autentikasi) Privacy Password (Kata Sandi Privasi) Memasukkan kredensial hanya baca untuk SNMP versi 3. Authentication Hash (Hash Autentikasi) MD5 SHA1 * Menyetel hash autentikasi yang berlaku. Minimum Authentication Level (Level Autentikasi Minimum) No Authentication, No Privacy (Tanpa Autentikasi, Tanpa Privasi) Authentication, No Privacy (Autentikasi, Tanpa Privasi) Authentication, Privacy (Autentikasi, Privasi) * Menyetel level autentikasi minimum yang berlaku. Privacy Algorithm (Algoritma Privasi) DES AES‑128 * Menyetel algoritma privasi yang berlaku. menu SNMP"},{"UUID":"b95f8c50-ca3b-48ca-bead-80a89fa471ec","title":"Port/Jaringan","link":"network-overview-topic.html","desc":"IPSec Menu ini hanya muncul","descFull":"IPSec Menu ini hanya muncul di printer jaringan atau printer yang tersambung ke server cetak. Item menu IPSec dan deskripsinya Item Menu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Enable IPSec (Aktifkan IPSec) Off (Nonaktif) * On (Aktif) Mengaktifkan Internet Protocol Security (IPSec/Keamanan Protokol Internet) Base Configuration (Konfigurasi Dasar) Default * Compatibility (Kompatibilitas) Secure (Aman) Menyetel konfigurasi dasar IPSec. Item menu ini hanya muncul jika  Enable IPSec (Aktifkan IPSec)  disetel ke  On (Aktif) . DH (Diffie‑Hellman) Group Proposal modp2048 (14) * modp3072 (15) modp4096 (16) modp6144 (17) Menyetel konfigurasi dasar IPSec. Item menu ini hanya muncul jika  Base Configuration (Konfigurasi Dasar)  disetel ke  On (Aktif) . Proposed Encryption Method (Metode Enkripsi yang Diminta) 3DES AES * Menyetel suatu metode enkripsi. Item menu ini hanya muncul jika  Base Configuration (Konfigurasi Dasar)  disetel ke  On (Aktif) . Proposed Authentication Method (Metode Autentikasi yang Diminta) SHA1 SHA256 * SHA512 Menyetel suatu metode autentikasi. Item menu ini hanya muncul jika  Base Configuration (Konfigurasi Dasar)  disetel ke  On (Aktif) . IKE SA Lifetime (Jam) 1 2 4 8 24 * Menentukan masa kedaluwarsa IKE SA. Item menu ini hanya muncul jika  Base Configuration (Konfigurasi Dasar)  disetel ke  Secure (Aman) . IPSec SA Lifetime (Jam) 1 2 4 8 24 * Menentukan masa kedaluwarsa IPSec SA. Item menu ini hanya muncul jika  Base Configuration (Konfigurasi Dasar)  disetel ke  Secure (Aman) . IPSec Device Certificate (Sertifikat Perangkat IPSec) default * Menentukan sertifikat IPSec. Item menu ini hanya muncul jika  Enable IPSec (Aktifkan IPSec)  disetel ke  On (Aktif) . Pre‑Shared Key Authenticated Connections Host  [x] Mengatur sambungan terautentikasi printer. Item menu ini hanya muncul jika  Enable IPSec (Aktifkan IPSec)  disetel ke  On (Aktif) . Certificate Authenticated Connections Host  [x]  Address[/subnet] menu IPSec"},{"UUID":"a1f823c2-a0af-4d0a-97b9-92fc0779fbc2","title":"Port/Jaringan","link":"network-overview-topic.html","desc":"802.1x 802.1x Menu ini hanya","descFull":"802.1x 802.1x Menu ini hanya muncul di printer jaringan atau printer yang tersambung ke server cetak. Item menu 802.1x dan deskripsinya Item Menu Item submenu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Active (Aktif) T/A Off (Nonaktif) * On (Aktif) Memungkinkan printer bergabung ke jaringan yang memerlukan otentikasi sebelum mengizinkan akses. 802.1x Authentication (Otentikasi 802.1x) Device Login Name (Nama Login Perangkat) Setelan ditentukan pengguna. Menentukan nama login yang unik. Device Login Password (Kata Sandi Login Perangkat) Setelan ditentukan pengguna. Menentukan kata sandi unik. Validate Server Certificate (Validasi Sertifikat Server) On (Aktif) * Off (Nonaktif) Mengaktifkan opsi ini akan meminta Anda untuk melakukan versifikasi sertifikat keamanan di server autentikasi. Enable Event Logging (Mengaktifkan Log Acara) On (Aktif) Off (Nonaktif) * Mengaktifkan printer untuk mencatat log sambungan. 802.1x Device Certificate (Sertifikat Perangkat 802.1x) default * Memilih sertifikat digital yang ingin Anda pakai. Jika hanya satu sertifikat yang diinstal, maka  default  adalah satu-satunya opsi. Authentication Mechanism (Mekansme Autentikasi) EAP ‑ MD5 On (Aktif) * Off (Nonaktif) Mengaktifkan kerangka kerja Extensible Authentication Protocol (EAP ‑ MD5). EAP - MSCHAPv2 On (Aktif) * Off (Nonaktif) Mengaktifkan metode autentikasi EAP Microsoft Challenge Handshake Authentication Protocol (MSCHAP) versi 2. LEAP On (Aktif) * Off (Nonaktif) Mengaktifkan Lightweight Extensible Authentication Protocol (LEAP), yang merupakan versi modifikasi dari MSCHAP. PEAP On (Aktif) * Off (Nonaktif) Mengaktifkan Protokol Autentikasi Ekstensi Terproteksi (PEAP), yang memberi lebih banyak autentikasi aman untuk 802.11 WLAN. PEAP mendukung kontrol akses port 802.1x. EAP - TLS On (Aktif) * Off (Nonaktif) Mengaktifkan EAP Transport Layer Security (TLS), protokok yang di dalamnya klien dan server saling melakukan autentikasi dengan memakai sertifikat digital. EAP - TTLS On (Aktif) * Off (Nonaktif) Mengaktifkan EAP tunneled Transport Layer Security (TLS), sebuah protokol yang hampir sama dengan EAP_TLS, hanya saja, server harus memiliki sertifikat untuk melakukan autentikasi sendiri kepada klien terlebih dahulu. TTLS Authentication Method (Metode Autentikasi TTLS) CHAP MSCHAP MSCHAPv2 * PAP Memilih cara EAP TTLS mana yang ingin Anda pakai. menu 802.1x"},{"UUID":"4c6f5769-7b3a-4a8b-adfa-736e1062ae35","title":"Port/Jaringan","link":"network-overview-topic.html","desc":"LPD Configuration (Konfigurasi LPD) Menu","descFull":"LPD Configuration (Konfigurasi LPD) Menu ini hanya muncul di printer jaringan atau printer yang tersambung ke server cetak. Item menu LPD Configuration dan deskripsinya Item Menu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. LPD Timeout (Waktu SMTP Habis) 0–65535 seconds  (90*) Menyetel nilai batas waktu untuk menghentikan server Line Printer Daemon (LPD) supaya tidak menunggu tanpa batas waktu untuk pekerjaan cetak yang macet atau tidak valid. LPD Banner Page (Halaman Banner LPD) Off (Nonaktif) * On (Aktif) Mencetak halaman banner untuk semua pekerjaan cetak LPD. Halaman banner adalah halaman pertama dari suatu pekerjaan cetak yang berfungsi sebagai pemisah antar pekerjaan cetak untuk mengidentifikasi dari mana permintaan pekerjaan cetak itu berasal. LPD Trailer Page (Halaman Cuplikan LPD) Off (Nonaktif) * On (Aktif) Mencetak halaman cuplikan untuk semua pekerjaan cetak LPD. Halaman cuplikan adalah halaman terakhir dari suatu pekerjaan cetak. LPD Carriage Return Conversion (Konversi Tombol Enter LPD) Off (Nonaktif) * On (Aktif) Mengaktifkan konversi tombol Enter LPD. Carriage Return adalah mekanisme yang memerintah printer untuk memindah posisi kursor ke posisi awal di baris yang sama. menu Konfigurasi LPD"},{"UUID":"ee0f4f30-a1fc-4083-81ff-e16e341a831d","title":"Port/Jaringan","link":"network-overview-topic.html","desc":"HTTP/FTP Settings (Setelan HTTP/FTP) Item","descFull":"HTTP/FTP Settings (Setelan HTTP/FTP) Item menu HTTP/FTP Settings (Setelan HTTP/FTP) dan deskripsinya Item Menu Item submenu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Proxy HTPP Proxy IP Address (Alamat IP Proxy HTPP) Setelan ditentukan pengguna. Mengonfigurasi setelan server HTTP. HTTP Default IP Port (Port IP Default HTTP) Setelan ditentukan pengguna. Mengatur alamat port IP default HTTP. Port default dari pabrik untuk HTTP adalah 80. FTP Proxy IP Address (Alamat IP Proxy HTPP) Setelan ditentukan pengguna. Konfigurasi pengaturan FTP. FTP Default IP Port (Port IP Default HTTP) Setelan ditentukan pengguna. Mengatur alamat port IP default FTP. Port default dari pabrik untuk HTTP adalah 21. Authentication (Otentikasi) None (Tidak Ada) Auto (Otomatis) * Basic (Dasar) Digest NTLM Menentukan kredensial autentikasi. Username (Nama Pengguna) Setelan ditentukan pengguna. Menentukan nama pengguna unik. Password (Kata Sandi) Setelan ditentukan pengguna. Menentukan kata sandi unik. Local Domains (Domain Lokal) Setelan ditentukan pengguna. Menentukan nama domain untuk server HTTP dan FTP. Other Settings (Setelan Lainnya) Enable HTTP Server (Aktifkan Server HTTP) On (Aktif) * Off (Nonaktif) Mengakses Embedded Web Server untuk mengamati dan mengelola printer. Enable HTPPS (Aktifkan LLDP) On (Aktif) * Off (Nonaktif) Aktifkan Hypertext Transfer Protocol Secure (HTTPS) untuk mengenkripsi data yang berasal dari, dan menuju ke, server cetak. Force HTTPS Connections (Paksa Koneksi HTTPS) On (Aktif) Off (Nonaktif) * Paksa printer untuk menggunakan koneksi HTTPS. Enable FTP/TFTP (Aktifkan FTP/TFTP) On (Aktif) * Off (Nonaktif) Mengirim file dengan FTP/TFTP. HTTPS Device Certificate (Sertifikat Perangkat HTTPS) default * Melihat apakah ada sertifikat perangkat HTTP yang digunakan pada printer. Timeout for HTTP/FTP Requests (Waktu Permintaan HTTP/FTP Habis) 1–299 seconds  (30*) Menentukan lama waktu sebelum koneksi server berhenti. Retries for HTTP/FTP Requests (Ulangi Permintaan HTTP/FTP) 1–299 seconds  (3*) Menyetel banyaknya upaya percobaan ulang untuk menyambungkan server HTTP/FTP. menu Setelan HTTP/FTP"},{"UUID":"94e69ae3-a0f3-4f6a-9629-46cb5dcebfdd","title":"Port/Jaringan","link":"network-overview-topic.html","desc":"ThinPrint Item menu ThinPrint dan","descFull":"ThinPrint Item menu ThinPrint dan deskripsinya Item Menu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Enable ThinPrint (Aktifkan ThinPrint) Off (Nonaktif) * On (Aktif) Cetak dengan ThinPrint. Port Number (Nomor Port) 4000–4999  (4000*) Setel nomor port untuk server ThinPrint. Bandwidth (bit/det) 100–1000000  (0*) Setel kecepatan transmisi data di lingkungan ThinPrint. Ukuran Paket (kbytes) 0–64000  (0*) Setel ukuran paket untuk transmisi data. menu ThinPrint"},{"UUID":"c63cc5ad-ce99-4d51-bd74-1cb0eeac06fb","title":"Port/Jaringan","link":"network-overview-topic.html","desc":"USB Item menu USB dan","descFull":"USB Item menu USB dan deskripsinya Item Menu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. PCL SmartSwitch Off (Nonaktif) On (Aktif) * Menyetel printer untuk otomatis berpindah ke emulasi PCL saat menerima pekerjaan cetak dari port USB, terlepas dari apa pun bahasa default printer. Jika setelan ini dinonaktifkan, printer tidak akan memeriksa data masuk dan akan menggunakan bahasa default printer yang ditentukan dalam menu  Setup (Penyiapan) . PS SmartSwitch Off (Nonaktif) On (Aktif) * Menyetel printer untuk otomatis berpindah ke emulasi PostScript saat menerima pekerjaan cetak dari port USB, terlepas dari apa pun bahasa default printer. Jika setelan ini dinonaktifkan, printer tidak akan memeriksa data masuk dan akan menggunakan bahasa default printer yang ditentukan dalam menu  Setup (Penyiapan) . Job Buffering (Tugas Sementara) Off (Nonaktif) * On (Aktif) Menyimpan sementara pekerjaan di drive penyimpanan sebelum mencetak. Item menu ini hanya muncul ketika drive penyimpanan dipasang. Mac Binary PS Auto (Otomatis) * On (Aktif) Off (Nonaktif) Menyetel printer untuk memproses pekerjaan cetak emulasi Macintosh Binary PostScript. Auto (Otomatis)  akan memproses pekerjaan cetak dari komputer yang berjalan dengan sistem operasi Windows atau Macintosh. Off (Nonaktif)  akan memfilter pekerjaan emulasi PostScript dengan protokol standar. Enable USB Port (Aktifkan Port USB) Off (Nonaktif) On (Aktif) * Mengaktifkan port drive USB depan dan belakang. menu USB"},{"UUID":"0c430ad9-e669-453d-a797-86562d6e3c02","title":"Port/Jaringan","link":"network-overview-topic.html","desc":"Restrict external network access (Batasi","descFull":"Restrict external network access (Batasi akses jaringan eksternal) Item Restrict external network access (Batasi akses jaringan eksternal) dan deskripsinya Item Menu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Restrict external network access (Batasi akses jaringan eksternal) Off (Nonaktif) * On (Aktif) Membatasi akses ke situs jaringan. External network address (Alamat jaringan eksternal) Setelan ditentukan pengguna. Menentukan alamat jaringan dengan akses terbatas. Email address for notification (Alamat email untuk pemberitahuan) Setelan ditentukan pengguna. Menentukan alamat email yang akan mendapat pemberitahuan jika ada yang login. Ping frequency (Frekuensi ping) 1–300  (10*) Tentukan interval kueri jaringan dalam hitungan detik. Subject (Judul) Setelan ditentukan pengguna. Menentukan judul dan pesan dari email pemberitahuan. Message (Pesan) menu Batasi akses jaringan eksternal"},{"UUID":"14100fad-d159-4a8f-92cd-bdb49786b77a","title":"Metode Login","link":"login-methods-subgroup.html","desc":"Manage Permissions (Kelola Izin) Item","descFull":"Manage Permissions (Kelola Izin) Item menu Manage Permissions (Kelola Izin) dan deskripsinya Item Menu Setelan Deskripsi Function Access (Akses Fungsi) Access Address Book in Apps (Akses Buku Alamat di Aplikasi) Modify Address Book (Modifikasi Buku Alamat) Manage Shortcuts (Kelola Pintasan) Create Profiles (Buat Profil) Manage Bookmarks (Kelola Penanda) Flash Drive Print (Cetak dari Flash Drive) Flash Drive Color Printing (Pencetakan Warna dari Flash Drive) Flash Drive Scan (Pindai dari Flash Drive) Copy Function (Fungsi Salin) Copy Color Printing (Pencetakan Warna dari Fungsi Salin) Color Dropout (Dropout Warna) E‑mail Function (Fungsi Email) Fax Function (Fungsi Faks) FTP Function (Fungsi FTP) Release Held Faxes (Lepas Faks Tertunda) Held Jobs Access (Akses Pekerjaan Tertunda) Use Profiles (Profil Penggunaan) Cancel Jobs at the Device (Batalkan Pekerjaan di Perangkat) Change Language (Ganti Bahasa) Internet Printing Protocol (IPP/Protokol Cetak Internet) Initiate Scans Remotely (Mulai Pindai Jarak Jauh) B/W Print (Cetak Hitam Putih) Color Print (Pencetakan Warna) Network Folder ‑ Scan (Folder Jaringan - Pindai) Hard Disk ‑ Print (Cetak) Hard Disk ‑ Color Print (Pencetakan Warna) Hard Disk ‑ Scan (Pindai) Menentukan fungsi printer yang bisa diakses oleh pengguna. Beberapa item menu hanya muncul ketika drive penyimpanan dipasang. Administrative Menus (Menu Administratif) Security Menu (Menu Keamanan) Network/Ports Menu (Menu Port/Jaringan) Paper Menu (Menu Kertas) Reports Menu (Menu Laporan) Function Configuration Menus (Menu Konfigurasi Fungsi) Supplies Menu (Menu Bahan Pakai) Option Card Menu (Menu Kartu Opsi) SE Menu (Menu SE) Device Menu (Menu Perangkat) Menentukan menu printer yang bisa diakses oleh pengguna. Device Management (Manajemen Perangkat) Remote Management (Manajemen Jarak Jauh) Firmware Updates (Pembaruan Firmware) Apps Configuration (Konfigurasi Apl) Operator Panel Lock (Kunci Panel Operator) Embedded Web Server Access (Akses Embedded Web Server) Import / Export All Settings (Impor/Ekspor Semua Setelan) Out of Service Erase (Penghapusan di Luar Layanan) Cloud Services Enrollment (Pendaftaran Layanan Cloud) Menentukan fungsi  Device Management (Manajemen Perangkat)  yang bisa diakses oleh pengguna. Apps (Aplikasi) New Apps (Aplikasi Baru) Slideshow Change Wallpaper (Mengganti Wallpaper) Screen Saver Card Copy Scan Center Scan Center Custom (Kustomisasi Scan Center)  [x] Mengendalikan akses ke aplikasi printer. menu Mengelola Izin"},{"UUID":"f62e121e-a3f9-4e6a-bcf1-df73e5e9465d","title":"Metode Login","link":"login-methods-subgroup.html","desc":"Local Accounts (Akun Lokal) Item","descFull":"Local Accounts (Akun Lokal) Item menu Local Accounts (Akun Lokal) dan deskripsinya Item Menu Item submenu Setelan Deskripsi Manage Groups/Permissions (Kelola Grup/Izin) Add Group (Tambah Grup) Setelan ditentukan pengguna. Menentukan grup yang memiliki akses terhadap fungsi, menu administratif, opsi manajemen, dan aplikasi printer. All Users (Semua Pengguna) Import Access Controls (Impor Kontrol Akses) Mengimpor kontrol akses dari akun yang terdaftar di printer. Add User (Tambah Pengguna) Username/Password (Nama Pengguna/Kata Sandi) Username (Nama Pengguna) Password (Kata Sandi) PIN * Setelan ditentukan pengguna. Tambah pengguna dan tentukan metode login ke printer. menu Akun Lokal"},{"UUID":"198b903e-2fbf-4c03-b43e-f2efbd7b67d1","title":"Metode Login","link":"login-methods-subgroup.html","desc":"Default Login Methods (Metode Login","descFull":"Default Login Methods (Metode Login Default) Menu ini hanya muncul apabila menu  Local Accounts (Akun Lokal)  telah diatur. Item menu Default Login Methods (Metode Login Default) dan deskripsinya Item Menu Setelan Deskripsi Control Panel (Panel Kontrol) Username/Password (Nama Pengguna/Kata Sandi) Username (Nama Pengguna) Password (Kata Sandi) PIN * Menentukan metode login default untuk mengakses panel kontrol. Browser (Peramban) Username/Password (Nama Pengguna/Kata Sandi) Username (Nama Pengguna) Password (Kata Sandi) PIN * Menentukan metode login default untuk mengakses peramban. menu Metode Login Default"},{"UUID":"bb683fa2-72ee-43de-9636-ef9c2acddf0a","title":"Keamanan","link":"login-methods-subgroup.html","desc":"Schedule USB Devices (Jadwalkan Perangkat","descFull":"Schedule USB Devices (Jadwalkan Perangkat USB) Item menu Schedule USB Devices (Jadwalkan Perangkat USB) dan deskripsi Item Menu Item submenu Setelan Deskripsi Schedules (Jadwal) Add New Schedule (Tambah Jadwal Baru) Save Schedule (Simpan Jadwal) Action (Tindakan) Day(s) (Hari) Time (Waktu) Jadwalkan akses ke port USB Depan. menu Jadwalkan Perangkat USB"},{"UUID":"9fcd7ae2-dd38-41a3-bc70-a618b51fcdfc","title":"Keamanan","link":"login-methods-subgroup.html","desc":"Security Audit Log (Log Audit","descFull":"Security Audit Log (Log Audit Keamanan) Item menu Security Audit Log (Log Audit Keamanan) dan deskripsinya Item Menu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Enable Audit (Aktifkan Audit) Off (Nonaktif) * On (Aktif) Menyetel printer untuk menyimpan acara di dalam log audit keamanan dan log sistem jarak jauh. Enable Remote Syslog (Aktifkan Syslog Jarak Jauh) Off (Nonaktif) * On (Aktif) Menyetel printer untuk mengirim log audit ke server jarak jauh. Remote Syslog Server (Server Syslog Jarak Jauh) Setelan ditentukan pengguna. Menentukan server syslog jarak jauh. Remote Syslog Port (Port Syslog Jarak Jauh) 1–65535  (514*) Menentukan port yang akan dilalui untuk mengirim log acara ke server jarak jauh. Remote Syslog Method (Metode Syslog Jarak Jauh) Normal UDP * Stunnel Mengidentifikasi protokol yang akan dipakai printer untuk mentransmisikan log acara ke server jarak jauh. Remote Syslog Facility (Fasilitas Syslog Jarak Jauh) 0 ‑ Kernel Messages 1 ‑ User‑Level Messages 2 ‑ Mail System 3 ‑ System Daemons 4 ‑ Security/Authorization Messages * 5 ‑ Messages Generated Internally by Syslogs 6 ‑ Line Printer Subsystem 7 ‑ Network News Subsystem 8 ‑ UUCP Subsystem 9 ‑ Clock Daemon 10 ‑ Security/Authorization Messages 11 ‑ FTP Daemon 12 ‑ NTP Subsystem 13 ‑ Log Audit 14 ‑ Log Alert 15 ‑ Clock Daemon 16 ‑ Local Use 0 (local0) 17‑ Local Use 1 (local1) 18 ‑ Local Use 2 (local2) 19 ‑ Local Use 3 (local3) 20 ‑ Local Use 4 (local4) 21 ‑ Local Use 5 (local5) 22 ‑ Local Use 6 (local6) 23 ‑ Local Use 7 (local7) Menentukan nilai fasilitas yang akan digunakan printer untuk mengirim log acara ke server syslog jarak jauh. Severity of Events to Log (Keparahan Acara ke Log) 0 ‑ Emergency (Darurat) 1 ‑ Alert (Peringatan Keras) 2 ‑ Critical (Kritis) 3 ‑ Error (Eror) 4 ‑ Warning (Peringatan Ringan) * 5 ‑ Notice (Pemberitahuan) 6 ‑ Informational (Informasional) 7 ‑ Debug Menentukan nilai keparahan dari tiap-tiap acara. Remote Syslog Non‑Logged Events (Acara yang tidak Dicatat di Syslog Jarak Jauh) Off (Nonaktif) * On (Aktif) Menyetel printer untuk mengirim acara yang bisa dipakai. Admin’s Email Address (Alamat Email Admin) Setelan ditentukan pengguna. Menentukan alamat email admin printer yang akan diberi tahu tentang log acara tertentu. Email Log Cleared Alert (Kirim Email Pemberitahuan Log Dibersihkan) Off (Nonaktif) * On (Aktif) Menyetel printer untuk mengirim email kepada admin setiap ada log yang dihapus. Email Log Wrapped Alert (Kirim Email Pemberitahuan Log Penuh) Off (Nonaktif) * On (Aktif) Menyetel printer untuk mengirim email kepada admin apabila entri log sudah penuh. Log Full Behavior (Log Seluruh Perilaku) r Wrap Over Oldest Entries (Timpa Entri Lama) * Email Log Then Delete All Entries (Kirim Email Log Lalu Hapus Semua Entri) Menentukan bagaimana printer akan mengatasi masalah penyimpanan log ketika memori penyimpanan log penuh. Email % Full Alert (Kirim Email % Pemberitahuan Penuh) Off (Nonaktif) * On (Aktif) Menyetel printer untuk mengirim email kepada admin apabila memori penyimpanan log penuh. % Full Alert Level (Pemberitahuan Persentase Penuh) 1–99  (90*) Menentukan apakah ruang yang dipakai log sama atau lebih dari nilai pemberitahuan penuh. Email Log Exported Alert (Kirim Email Pemberitahuan Ekspor Log) Off (Nonaktif) * On (Aktif) Mengirim email pemberitahuan kepada admin ketika log diekspor. Email Log Settings Changed Alert (Kirim Email Pemberitahuan Log Setelan yang Diubah) Off (Nonaktif) * On (Aktif) Menyetel printer untuk mengirim email kepada admin ketika nilai di menu  Enable Audit (Aktifkan Audit)  diubah. Log Line Endings (Baris Akhir Log) LF (\\n) * CR (\\r) CRLF (\\r\\n) Menentukan bagaimana printer akan menangani baris terakhir dari suatu file log, tergantung pada sistem operasi yang mengurai dan melihat file tersebut. Digitally Sign Exports (Ekspor Tanda Tangan Digital) Off (Nonaktif) * On (Aktif) Menyetel printer untuk menandatangani ekspor log keamanan secara otomatis. Clear Log (Bersihkan Log) Setelan ditentukan pengguna. Menghapus semua log audit. Export Log (Ekspor Log) Syslog (RFC 5424) Syslog (RFC 3164) CSV Mengekspor log dari printer atau flash drive. menu Log Audit Keamanan"},{"UUID":"cf773806-b416-4b08-8786-b1967e3ac30d","title":"Keamanan","link":"login-methods-subgroup.html","desc":"Login Restrictions (Pembatasan Login) Item","descFull":"Login Restrictions (Pembatasan Login) Item menu Login Restrictions (Pembatasan Login) dan deskripsinya Item Menu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Login failures (Gagal login) 1–10  (3*) Menentukan jumlah gagal login sebelum pengguna terkunci. Failure time frame (Rentang waktu gagal) 1–60 menit  (5*) Menentukan rentang waktu gagal login sebelum pengguna terkunci. Lockout time (Waktu terkunci) 1–60 menit  (5*) Menentukan berapa lama seseorang tidak boleh login. Web Login Timeout (Waktu Login Web Habis) 1–120 menit  (10*) Menentukan berapa lama antarmuka jarak jauh, halaman web misalnya, boleh terus diam sebelum pengguna dikeluarkan secara otomatis. menu Pembatasan Login"},{"UUID":"5348ed83-29dd-4bb0-9ff8-997c47db9356","title":"Keamanan","link":"login-methods-subgroup.html","desc":"Confidential Print Setup (Penyiapan Cetak","descFull":"Confidential Print Setup (Penyiapan Cetak Rahasia) Item menu Confidential Print Setup (Penyiapan Cetak Rahasia) dan deskripsinya Item Menu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Max Invalid PIN (PIN Invalid Maks.) 2–10 Menyetel batas upaya memasukkan PIN yang tidak valid. Ketika batasan itu tercapai, pekerjaan cetak untuk nama pengguna itu akan dihapus. Confidential Job Expiration (Waktu Pekerjaan Rahasia Habis) Off (Nonaktif) * 1 Hour (1 Jam) 4 Hours (4 Jam) 24 Hours (4 Jam) 72 Hours (4 Jam) 1 Week (1 Pekan) Menyetel waktu kedaluwarsa untuk setiap jenis pekerjaan tertunda sebelum printer otomatis menghapusnya dari memori. Jenis-jenis pekerjaan tertunda di antaranya  Confidential (Rahasia) ,  Repeat (Berulang) ,  Reserve (Simpan) , dan  Verify (Verifikasi) . Jika setelan waktu kedaluwarsa diubah ketika pekerjaan cetak rahasia berada di memori atau hard disk printer, waktu kedaluwarsa untuk pekerjaan cetak tersebut tidak akan berubah ke nilai default yang baru. Jika printer dinonaktifkan, semua pekerjaan rahasia yang tertunda di memori printer akan dihapus. Repeat Job Expiration (Waktu Pekerjaan Ulang Habis) Off (Nonaktif) * 1 Hour (1 Jam) 4 Hours (4 Jam) 24 Hours (4 Jam) 72 Hours (4 Jam) 1 Week (1 Pekan) Menyetel waktu habis untuk pekerjaan cetak yang ingin Anda ulangi. Verify Job Expiration (Waktu Verifikasi Pekerjaan Habis) Off (Nonaktif) * 1 Hour (1 Jam) 4 Hours (4 Jam) 24 Hours (4 Jam) 72 Hours (4 Jam) 1 Week (1 Pekan) Menyetel waktu habis untuk pencetakan salinan pekerjaan yang harus Anda periksa kualitasnya sebelum mencetak salinan yang tersisa. Reserve Job Expiration (Waktu Pekerjaan Cadangan Habis) Off (Nonaktif) * 1 Hour (1 Jam) 4 Hours (4 Jam) 24 Hours (4 Jam) 72 Hours (4 Jam) 1 Week (1 Pekan) Menyetel waktu habis untuk pekerjaan yang hendak Anda simpan di printer guna dipakai di lain waktu. Require All Jobs to be Held (Minta Semua Pekerjaan Ditunda) Off (Nonaktif) * On (Aktif) Menyetel printer untuk menunda semua pekerjaan cetak. Keep duplicate documents (Simpan dokumen duplikat) Off (Nonaktif) * On (Aktif) Menyetel printer untuk menyimpan semua dokumen dengan nama file yang sama. menu Confidential Print Setup (Penyiapan Cetak Rahasia)"},{"UUID":"edbbf5a6-40e5-404b-b03a-66089efa966a","title":"Keamanan","link":"login-methods-subgroup.html","desc":"Encryption (Enkripsi) Item menu Encryption","descFull":"Encryption (Enkripsi) Item menu Encryption (Enkripsi) dan deskripsinya Item Menu Setelan Deskripsi Internal Storage (Penyimpanan Internal) Setelan ini adalah informasi hanya baca. Menampilkan status enskripsi penyimpanan internal. Hard Disk Setelan ini adalah informasi hanya baca. Menampilkan status enskripsi hard disk. Item menu ini hanya muncul ketika hard disk sudah dipasang. Intelligent Storage Drive (Drive Penyimpanan Intelijen) Setelan ini adalah informasi hanya baca. Menampilkan status enskripsi drive penyimpanan intelijen (ISD). Item menu ini hanya muncul ketika ISD diinstal. menu Enkripsi"},{"UUID":"a5bca4af-6433-4728-a1ff-006f2590dbf0","title":"Keamanan","link":"login-methods-subgroup.html","desc":"Erase Temporary Data Files (Hapus","descFull":"Erase Temporary Data Files (Hapus File Data Sementara) Item menu Erase Temporary Data Files (Hapus File Data Sementara) dan deskripsinya Item Menu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Stored in onboard memory (Tersimpan di memori sepapan) Off (Nonaktif) * On (Aktif) Menyetel printer untuk menghapus semua data pekerjaan dari memori printer setelah selesai. Stored on hard disk (Tersimpan di hard disk) 1 Pass Erase * 3 Pass Erase 7 Pass Erase Menentukan cara yang dipakai printer untuk menghapus semua data pekerjaan dari hard disk setelah selesai. Item menu ini hanya muncul ketika hard disk printer dipasang. menu Hapus File Data Sementara"},{"UUID":"d8c34606-d94b-4406-b32d-9291026125e3","title":"Keamanan","link":"login-methods-subgroup.html","desc":"Solutions LDAP Settings (Setelan Solutions","descFull":"Solutions LDAP Settings (Setelan Solutions LDAP) Item menu Solutions LDAP Settings (Setelan Solutions LDAP) dan deskripsinya Item Menu Setelan Deskripsi Follow LDAP Referrals (Ikuti Referensi LDAP) Off (Nonaktif) * On (Aktif) Cari akun pengguna yang pernah masuk di beberapa server dalam domain tersebut. LDAP Certificate Verification (Verifikasi Sertifikat LDAP) Yes (Ya) No (Tidak) * Aktifkan verifikasi sertifikat LDAP. menu Solutions LDAP Settings (Setelan Solutions LDAP)"},{"UUID":"f4f5c4ab-9dda-4799-b303-10210ea0c359","title":"Keamanan","link":"login-methods-subgroup.html","desc":"Miscellaneous (Lain-lain) Item menu Miscellaneous","descFull":"Miscellaneous (Lain-lain) Item menu Miscellaneous (Lain-lain) dan deskripsinya Item Menu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Protected Features (Fitur Terlindungi) Show (Tampilkan) * Hide (Sembunyikan) Menampilkan semua fitur yang dilindungi oleh Function Access Control (FAC/Kendali Akses Fungsi), apa pun jenis izin keamanan yang dimiliki pengguna. Hide (Sembunyikan)  menampilkan fitur yang dilindungi FAC yang bisa diakses oleh pengguna. Print Permission (Izin Cetak) Off (Nonaktif) * On (Aktif) Meminta pengguna untuk login sebelum mencetak. Default Print Permission Login (Login Default Izin Cetak) Username/Password (Nama Pengguna/Kata Sandi) * Username (Nama Pengguna) Menyetel login default untuk  Print Permission (Izin Cetak) . Security Reset Jumper (Jumper untuk Setel Ulang Keamanan) Enable “Guest” access (Aktifkan akses Tamu) * No Effect (Tanpa Efek) Menentukan akses pengguna ke printer. Enable “Guest” access (Aktifkan akses Tamu)  memberi izin kepada semua orang untuk mengakses seluruh aspek printer. No Effect (Tidak Berpengaruh)  dapat membuat akses ke printer tidak mungkin dilakukan bila informasi keamanan yang diperlukan tidak tersedia. Use Intelligent Storage Drive for User Data (Gunakan Drive Penyimpanan Intelijen untuk Data Pengguna) Off (Nonaktif) On (Aktif) * Mengaktifkan drive penyimpanan intelijen untuk menyimpan data pengguna. Item menu ini dinonaktifkan ketika hard disk sudah dipasang. Minimum Password Length (Panjang Minimal Kata Sandi) 0–32  (0*) Menentukan panjang minimal kata sandi yang digunakan untuk akun internal seperti  Password (Kata Sandi)  dan akun  Username/Password (Nama Pengguna/Kata Sandi) . Enable Password/PIN Reveal (Aktifkan Buka PIN/Kata Sandi) Off (Nonaktif) On (Aktif) * Menampilkan kata sandi atau nomor identifikasi pribadi (PIN). Allow Encryption of Service Nonvolatile Memory (Izinkan Enkripsi Memori Tetap Layanan) Off (Nonaktif) * On (Aktif) Mengaktifkan enkripsi memori tetap layanan di perangkat Anda. Setelan ini tersedia jika  Encrypt Service Nonvolatile Memory (Enkripsi Memori Tetap Layanan)  dinonaktifkan. menu Lain-lain"},{"UUID":"56b078e8-6955-4bc6-951b-5ac7d157c649","title":"Layanan Cloud","link":"cloud-services-enrollment-topic.html","desc":"Cloud Services Enrollment (Pendaftaran Layanan","descFull":"Cloud Services Enrollment (Pendaftaran Layanan Cloud) Item menu Cloud Services Enrollment dan deskripsinya Item Menu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. View More Information (Lihat Informasi Lainnya) Setelan ini adalah informasi hanya baca. Lihat informasi tambahan tentang penggunaan Lexmark Cloud Services. Aktifkan komunikasi dengan Lexmark Cloud Services Off (Nonaktif) * On (Aktif) Mengaktifkan komunikasi antara printer dengan Lexmark Cloud Services View Current Status (Lihat Status Sekarang) Setelan ini adalah informasi hanya baca. Melihat status koneksi antara printer dengan Lexmark Cloud Services. menu Pendaftaran Layanan Cloud"},{"UUID":"396a55c8-7117-4153-b086-20b562934c82","title":"Laporan","link":"menu-settings-page-topic.html","desc":"Halaman Pengaturan Menu Item menu","descFull":"Halaman Pengaturan Menu Item menu  Halaman Pengaturan Menu  dan deskripsinya Item menu Deskripsi Halaman Pengaturan Menu Mencetak laporan berisi menu printer. menu Halaman Pengaturan Menu"},{"UUID":"1c7c1ac9-ea23-4416-9678-701115aef160","title":"Laporan","link":"menu-settings-page-topic.html","desc":"Device (Perangkat) Item menu Device","descFull":"Device (Perangkat) Item menu Device (Perangkat) dan deskripsinya Item Menu Deskripsi Device Information (Informasi Perangkat) Mencetak laporan yang berisi informasi tentang printer. Device Statistics (Statistik Perangkat) Mencetak laporan tentang status bahan pakai, penghitung kertas, informasi pekerjaan, dan yang lainnya. Profiles List (Daftar Profil) Mencetak daftar profil yang tersimpan di printer. Asset Report (Laporan Aset) Mencetak alat diagnosis untuk masalah printer. Agar konten tidak terpotong, cetak laporan tersebut pada kertas ukuran Letter atau A4. menu Perangkat"},{"UUID":"51919e0a-5dac-4acc-a4a6-a62411a915ba","title":"Laporan","link":"menu-settings-page-topic.html","desc":"Print (Cetak) Item menu Print","descFull":"Print (Cetak) Item menu Print dan deskripsinya Item Menu Setelan Deskripsi Print Fonts (Font Cetak) PCL Fonts (Font PCL) PS Fonts (Font PCL) Mencetak sampel dan informasi tentang font yang tersedia di masing-masing bahasa printer. Print Demo (Demo Cetak) Demo Page (Halaman Demo) Mencetak alat diagnosis untuk masalah printer. Agar konten tidak terpotong, cetak laporan tersebut pada kertas ukuran Letter atau A4. Item menu ini hanya muncul ketika printer sudah memiliki halaman demo. Print Directory (Direktori Cetak) Setelan ditentukan pengguna. Mencetak laporan yang menampilkan sumber daya yang tersimpan di flash drive atau hard disk printer. menu Cetak"},{"UUID":"8c72b656-dfbe-4bc9-b5b1-260c4af3c729","title":"Laporan","link":"menu-settings-page-topic.html","desc":"Shortcuts (Pintasan) Item menu Shortcuts","descFull":"Shortcuts (Pintasan) Item menu Shortcuts (Pintasan) dan deskripsinya Item Menu Deskripsi All Shortcuts (Semua Pintasan) Mencetak laporan yang berisi daftar pintasan yang tersimpan di printer. Fax Shortcuts (Pintasan Faks)  hanya muncul apabila  Faks  dipasang. Fax Shortcuts (Pintasan Faks) Copy Shortcuts (Pintasan Salin) Email Shortcuts (Pintasan Email) FTP Shortcuts (Pintasan FTP) Network Folder Shortcuts (Pintasan Folder Jaringan) menu Pintasan"},{"UUID":"640741d7-e1a6-441d-8a94-424179b11363","title":"Laporan","link":"menu-settings-page-topic.html","desc":"Fax (Faks) Menu ini muncul","descFull":"Fax (Faks) Menu ini muncul hanya jika Faks sudah diatur, dan  Enable Job Log (Aktifkan Log Pekerjaan)  disetel ke  On (Aktif) . Item menu Fax (Faks) dan deskripsinya Item Menu Deskripsi Fax Job Log (Log Pekerjaan Faks) Mencetak laporan tentang 200 pekerjaan faks terakhir yang berhasil. Fax Call Log (Log Panggilan Faks) Mencetak laporan tentang 100 panggilan keluar, panggilan masuk, dan panggilan yang diblokir. menu Faks"},{"UUID":"a2662df0-6314-4fbe-986f-e6851887a235","title":"Laporan","link":"menu-settings-page-topic.html","desc":"Network (Jaringan) Item menu Network","descFull":"Network (Jaringan) Item menu Network (Jaringan) dan deskripsinya Item Menu Deskripsi Network Setup Page (Halaman Penyiapan Jaringan) Mencetak satu halaman yang menampilkan setelan jaringan dan nirkabel yang sudah diatur di printer. Item menu ini hanya muncul di printer jaringan atau printer yang tersambung dengan server cetak. Wi‑Fi Direct Connected Clients Menampilkan daftar perangkat yang tersambung ke printer melalui Wi-Fi Direct. Item menu ini hanya muncul jika  Enable Wi-Fi Direct (Aktifkan Wi‑ Fi Direct)  disetel ke  On (Aktif) . menu Jaringan"},{"UUID":"85168c50-efc1-44ac-b90e-4b8857fff0ac","title":"menu printer","link":"troubleshooting-menu-topic.html","desc":"Troubleshooting (Pemecahan Masalah) Item menu","descFull":"Troubleshooting (Pemecahan Masalah) Item menu Troubleshooting (Pemecahan Masalah) dan deskripsinya Item Menu Deskripsi Print Quality Test Pages (Halaman Percobaan Kualitas Cetak) Mencetak halaman sampel untuk mengidentifikasi dan memperbaiki cacat pada kualitas cetak. Cleaning the Scanner (Membersihkan Pemindai) Instruksi cetak tentang cara membersihkan pemindai. menu Pemecahan Masalah Halaman Percobaan Kualitas Cetak Membersihkan Pemindai"},{"UUID":"fbb39b2c-1548-41bb-af1a-54a07cbd1e82","title":"menu printer","link":"forms-merge-topic.html","desc":"Forms Merge (Gabung Formulir) Item","descFull":"Forms Merge (Gabung Formulir) Item menu ini hanya muncul ketika drive penyimpanan dipasang. Item menu Forms Merge (Gabung Formulir) dan deskripsinya Item Menu Item submenu Setelan Deskripsi Tanda bintang (*) di samping nilai adalah setelan default pabrik. Merge Mode (Mode Gabung) T/A Print (Cetak) * Data Capture (Tangkap Data) Disabled (Dinonaktifkan) Menentukan mode operasi dari Forms Merge (Gabung Formulir). Data Capture Target (Target Tangkap Data) T/A Flash * Menyetel destinasi target di mana data yang ditangkap akan diteruskan. Menu ini hanya muncul ketika  Merge Mode (Mode Gabung)  disetel ke  Data Capture (Tangkap Data) . Print Port and Filter Settings (Setelan Filter dan Port Cetak) Network Port (Port Jaringan) On (Aktif) * Off (Nonaktif) Mengaktifkan Forms Merge (Gabung Formulir) untuk memproses semua data yang dikirim ke port jaringan. Network Filter (Filter Jaringan) Disabled (Dinonaktifkan) * NULL OFIS OFIS+NULL OFIS+AS400 AS400 PCL ZPL ZPLF Menentukan filter jaringan untuk semua data yang dikirim ke printer. Port USB On (Aktif) * Off (Nonaktif) Mengaktifkan Forms Merge (Gabung Formulir) untuk memproses semua data yang dikirim ke port USB. USB Filter Disabled (Dinonaktifkan) * NULL OFIS OFIS+NULL OFIS+AS400 AS400 PCL ZPL ZPLF Menentukan filter USB untuk semua data yang dikirim ke printer. Local Port Timeout (Waktu Port Lokal Habis) 1–100  (10*) Menentukan nilai waktu habis untuk pekerjaan Forms Merge (Gabung Formulir) yang dikirim ke port lokal. Miscellaneous (Lain-lain) Print All Forms (Print Semua Formulir) Start (Mulai) Mencetak semua set formulir yang tersimpan di drive penyimpanan intelijen atau hard disk printer. Error Page Print (Eror Cetak Halaman) On (Aktif) * Off (Nonaktif) Mengaktifkan pencetakan halaman eror ketika terjadi eror dalam pekerjaan Forms Merge (Gabung Formulir). menu Gabung Formulir"},{"UUID":"d71fb0e4-e124-4fbf-89eb-e2fc7c913b0f","title":"menu printer","link":"printing-menu-settings-page-topic.html","desc":"Mencetak  Menu Settings Page","descFull":"Mencetak  Menu Settings Page (Halaman Setelan Menu) Dari panel kontrol, buka  Settings (Setelan) Reports (Laporan) . Pilih  Menu Settings Page (Halaman Setelan Menu) . mencetak Halaman Setelan Menu Halaman Setelan Menu mencetak menu printer"},{"UUID":"7eabad90-dcb7-4bbd-94e0-9a3999743765","title":"Opsi lis printer","link":"using-staple-finisher-topic.html","desc":"Menggunakan lis stapler Men-staple dengan","descFull":"Menggunakan lis stapler Men-staple dengan driver printer Untuk pengguna Windows Dengan dokumen terbuka, pilih  File Print (Cetak) . Pilih printer, lalu klik  Properties (Properti) ,  Preferences (Preferensi) ,  Options (Opsi) , atau  Setup (Penyiapan) . Klik  Paper/Finishing (Kertas/Penjilidan) , lalu atur setelan  Kertas . Di menu  Staple,  pilih satu setelan. Klik  OK , lalu klik  Print (Cetak) . Untuk pengguna Macintosh Dengan dokumen terbuka, pilih  File Print (Cetak) . Pilih printer Dari menu  Finishing Options (Opsi Penjilidan),  pilih  Apply Finishings (Terapkan Penjilidan) Printer Options (Opsi Printer) . Klik  Staple , lalu pilih satu setelan. Klik  Print (Cetak) . Men-staple dengan panel kontrol Dari panel kontrol, pilih  Print (Cetak) , lalu pilih sumber pekerjaan cetak. Pilih dokumen. Pilih  More Settings (Setelan Lainnya) , lalu pilih  Finishing Options (Opsi Penjilidan) . Pilih  Staple , lalu pilih satu setelan. Cetak dokumen. lis stapler menggunakan menjilid lembar cetakan menjilid salinan dokumen"},{"UUID":"68fe84b4-cb5c-4a8e-9c8a-6fe8612bfb76","title":"Opsi lis printer","link":"using-staple-hole-punch-finisher-topic.html","desc":"Menggunakan lis lubang stapler Menggunakan","descFull":"Menggunakan lis lubang stapler Menggunakan lis lubang stapler Melubangi atau men-staple kertas dengan driver printer Untuk pengguna Windows Dengan dokumen terbuka, pilih  File Print (Cetak) . Pilih printer, lalu klik  Properties (Properti) ,  Preferences (Preferensi) ,  Options (Opsi) , atau  Setup (Penyiapan) . Klik  Paper/Finishing (Kertas/Penjilidan) , lalu atur setelan  Kertas . Tergantung metode penyelesaian yang Anda inginkan, pilih satu setelan untuk  Staple (Lis Stapler)  atau  Hole punch (Lis Lubang) . Anda bisa memilih satu setelan untuk keduanya, jika Anda ingin memasang lis lubang stapler pada hasil cetak. Klik  OK , lalu klik  Print (Cetak) . Untuk pengguna Macintosh Dengan dokumen terbuka, pilih  File Print (Cetak) . Pilih printer Dari menu  Finishing Options (Opsi Penjilidan),  pilih  Apply Finishings (Terapkan Penjilidan) Printer Options (Opsi Printer) . Klik  Staple  atau  Punch , lalu pilih satu setelan. Klik  Print (Cetak) . Melubangi atau men-staple kertas dengan panel kontrol Dari panel kontrol, pilih  Print (Cetak) , lalu pilih sumber pekerjaan cetak. Pilih dokumen. Pilih  More Settings (Setelan Lainnya) , lalu pilih  Finishing Options (Opsi Penjilidan) . Tergantung metode penyelesaian yang Anda inginkan, pilih satu setelan untuk  Staple (Lis Stapler)  atau  Hole punch (Lis Lubang) . Anda bisa memilih satu setelan untuk keduanya, jika Anda ingin memasang lis lubang stapler pada hasil cetak. Cetak dokumen. menjilid lembar cetakan lis lubang di lembar cetakan lis lubang stapler menggunakan"},{"UUID":"e16d4f7c-6de6-49d8-984e-0479bbdbd9df","title":"Opsi lis printer","link":"using-offset-stacker-topic.html","desc":"Menggunakan penumpuk ofset Penumpukan ofset","descFull":"Menggunakan penumpuk ofset Penumpukan ofset dengan driver printer Untuk pengguna Windows Dengan dokumen terbuka, pilih  File Print (Cetak) . Pilih printer, lalu klik  Properties (Properti) ,  Preferences (Preferensi) ,  Options (Opsi) , atau  Setup (Penyiapan) . Klik  Paper/Finishing (Kertas/Penjilidan) , lalu atur setelan  Kertas . Di menu  Offset,  pilih satu setelan.. Klik  OK , lalu klik  Print (Cetak) . Untuk pengguna Macintosh Dengan dokumen terbuka, pilih  File Print (Cetak) . Pilih printer Dari menu  Finishing Options (Opsi Penjilidan),  pilih  Apply Finishings (Terapkan Penjilidan) Printer Options (Opsi Printer) . Klik  Offset , lalu pilih satu setelan. Klik  Print (Cetak) . Penumpukan ofset dengan panel kontrol Masukkan dokumen asli ke dalam baki ADF atau kaca pemindai. Supaya gambar tidak terpotong, pastikan dokumen asli dan keluaran memiliki ukuran kertas yang sama. Dari panel kontrol, pilih  Copy (Salin) , lalu tentukan jumlah salinan. Pilih  More Settings (Setelan Lainnya) , lalu pilih  Offset Pages (Halaman Ofset) . Aktifkan menu, lalu pilih satu setelan. Cetak dokumen. penumpuk ofset menggunakan penumpukan ofset"},{"UUID":"84301019-5394-4651-baf5-17ba5e8567b8","title":"Opsi lis printer","link":"using-booklet-finisher-topic.html","desc":"Menggunakan lis buklet Sebelum membuat","descFull":"Menggunakan lis buklet Sebelum membuat buklet, masukkan kertas dengan tepi pendek ke arah sisi kanan baki. Membuat buklet dengan driver printer Untuk pengguna Windows Dengan dokumen terbuka, pilih  File Print (Cetak) . Pilih printer, lalu klik  Properties (Properti) ,  Preferences (Preferensi) ,  Options (Opsi) , atau  Setup (Penyiapan) . Pilih  Booklet (Buklet) . Klik tab  Paper/Finishing , lalu atur setelan kertas. Di menu  Fold (Lipatan) , pilih satu setelan.. Klik  OK , lalu klik  Print (Cetak) . Untuk pengguna Macintosh Dengan dokumen terbuka, pilih  File Print (Cetak) . Pilih printer Dari menu  Finishing Options (Opsi Penjilidan),  pilih  Apply Finishings (Terapkan Penjilidan) Printer Options (Opsi Printer) . Pilih  Booklet (Buklet) , lalu pilih setelan  Fold (Lipatan) . Klik  OK . Membuat buklet dengan panel kontrol Masukkan dokumen asli ke dalam baki ADF atau kaca pemindai. Supaya gambar tidak terpotong, pastikan dokumen asli dan keluaran memiliki ukuran kertas yang sama. Dari panel kontrol, pilih  Copy (Salin) , lalu atur setelannya. Pilih  More Settings (Setelan Lainnya) , lalu pilih  Create Booklet (Buat Buklet) . Aktifkan  Booklet Finishing , lalu pilih satu setelan. Salin dokumen. membuat buklet membuat buklet lis buklet menggunakan"},{"UUID":"b3c573b1-f439-49d6-90de-5f4753813711","title":"Opsi lis printer","link":"using-hptfu-topic.html","desc":"Menggunakan penyalur kertas dengan opsi","descFull":"Menggunakan penyalur kertas dengan opsi lipatan Melipat kertas dengan driver printer Untuk pengguna Windows Dengan dokumen terbuka, pilih  File Print (Cetak) . Pilih printer, lalu klik  Properties (Properti) ,  Preferences (Preferensi) ,  Options (Opsi) , atau  Setup (Penyiapan) . Klik  Paper/Finishing (Kertas/Penjilidan) , lalu atur setelan kertas. Di menu  Fold (Lipatan) , pilih satu setelan.. Klik  OK , lalu klik  Print (Cetak) . Untuk pengguna Macintosh Dengan dokumen terbuka, pilih  File Print (Cetak) . Pilih printer Dari menu  Finishing Options (Opsi Penjilidan),  pilih  Apply Finishings (Terapkan Penjilidan) Printer Options (Opsi Printer) . Klik  Fold (Lipat) , lalu pilih satu setelan. Klik  Print (Cetak) . Melipat kertas dengan panel kontrol Masukkan dokumen asli ke dalam baki ADF atau kaca pemindai. Supaya gambar tidak terpotong, pastikan dokumen asli dan keluaran memiliki ukuran kertas yang sama. Dari panel kontrol, pilih  Copy (Salin) , lalu tentukan jumlah salinan. Pilih  More Settings (Setelan Lainnya) , lalu pilih  Finishing Options (Opsi Penjilidan) . Pilih  Fold (Lipat) , lalu pilih satu setelan. Salin dokumen. penyalur kertas dengan opsi lipatan menggunakan melipat salinan cetak melipat dokumen yang disalin"},{"UUID":"ef22e813-3626-4668-90e7-510bf1076d0c","title":"Merawat printer","link":"checking-supplies-status-topic.html","desc":"Memeriksa status bahan pakai dan","descFull":"Memeriksa status bahan pakai dan suku cadang Memeriksa status bahan pakai dan suku cadang Dari pojok kanan atas panel kontrol, pilih  . Melihat status bahan pakai dan suku cadang printer. Anda juga bisa memilih   untuk memeriksa pemberitahuan yang memerlukan intervensi pengguna. memeriksa, status bahan pakai status bahan pakai memeriksa status suku cadang printer memeriksa"},{"UUID":"124bf462-bbb4-49af-9e1c-fd83a8b8a83c","title":"Merawat printer","link":"configuring-supply-notifications-topic.html","desc":"Mengatur notifikasi bahan pakai Mengatur","descFull":"Mengatur notifikasi bahan pakai Mengatur notifikasi bahan pakai Buka peramban web, kemudian tulis alamat IP printer di kolom alamat. Lihat alamat IP printer di layar beranda printer. Alamat IP muncul dalam empat set angka yang dipisahkan oleh titik, seperti 123.123.123.123. Jika Anda menggunakan proxy, nonaktifkan proxy tersebut untuk memuat halaman web dengan benar. Klik  Settings (Setelan) Device (Perangkat) Notifications (Pemberitahuan) . Klik  Custom Supply Notifications (Pemberitahuan Bahan Pakai Khusus) . Pilih pemberitahuan untuk masing-masing item bahan pakai. Terapkan perubahan. notifikasi bahan pakai mengatur mengatur notifikasi bahan pakai"},{"UUID":"67224be8-f3c3-468a-b35f-136e27be397b","title":"Merawat printer","link":"setting-up-email-alert-topic.html","desc":"Menyiapkan peringatan email Menyiapkan peringatan","descFull":"Menyiapkan peringatan email Menyiapkan peringatan email Buka peramban web, kemudian tulis alamat IP printer di kolom alamat. Lihat alamat IP printer di layar beranda printer. Alamat IP muncul dalam empat set angka yang dipisahkan oleh titik, seperti 123.123.123.123. Jika Anda menggunakan proxy, nonaktifkan proxy tersebut untuk memuat halaman web dengan benar. Klik  Settings (Setelan) Device (Perangkat) Notifications (Pemberitahuan) . Klik  Email Alert Setup (Penyiapan Pemberitahuan Email) , lalu atur setelan. Untuk informasi lebih lanjut tentang setelan SMTP, hubungi penyedia email Anda. Terapkan perubahan. Klik  Setup E-mail Lists and Alerts (Siapkan Pemberitahuan dan Daftar Email) , lalu atur setelan. Terapkan perubahan. peringatan email menyiapkan menyiapkan peringatan email"},{"UUID":"221f98ea-c8f5-4adb-b239-6ac99cf3cbcd","title":"Merawat printer","link":"generating-reports-and-logs-topic.html","desc":"Membuat laporan dan log Membuat","descFull":"Membuat laporan dan log Membuat laporan dan log Dari panel kontrol, buka  Settings (Setelan) Reports (Laporan) . Pilih laporan atau log yang ingin Anda cetak. Menu Settings Page (Halaman Setelan Menu) —Menampilkan preferensi, setelan, dan konfigurasi printer saat ini. Device (Perangkat) Device Information (Informasi Perangkat) —Menampilkan faks, solusi yang diinstal, serta nomor seri printer. Device Statistics (Statistik Perangkat) —Menampilkan informasi pekerjaan cetak, total lembar cetakan, serta status bahan pakai. Profiles List (Daftar Profil) —Menampilkan daftar profil atau pintasan yang disimpan di printer. Asset Report (Laporan Aset) —Menampilkan laporan tentang informasi aset printer, seperti nama model dan nomor seri. Print (Cetak) Print Fonts (Font Cetak) —Menampilkan font yang tersedia di masing-masing bahasa printer. Print Demo (Demo Cetak) —Menampilkan file demo yang tersedia di dalam firmware, opsi flash, dan opsi disk. Print Directory (Direktori Cetak) —Menampilkan sumber daya yang tersimpan di flash drive, hard disk, atau drive penyimpanan intelijen (ISD). Laporan hanya muncul ketika flash drive, hard disk printer, atau ISD dipasang. Shortcuts (Pintasan) All Shortcuts (Semua Pintasan) —Menampilkan daftar semua pintasan yang disimpan di printer. Fax Shortcuts (Pintasan Faks) —Menampilkan daftar pintasan faks yang tersimpan di printer. Copy Shortcuts (Pintasan Salin) —Menampilkan daftar pintasan salin yang tersimpan di printer. E‑mail Shortcuts (Pintasan Email) —Menampilkan daftar pintasan email yang tersimpan di printer. FTP Shortcuts (Pintasan FTP) —Menampilkan daftar pintasan FTP yang tersimpan di printer. Network Folder Shortcuts (Pintasan Folder Jaringan) —Menampilkan daftar pintasan folder jaringan yang tersimpan di printer. Fax (Faks) Fax Job Log (Log Pekerjaan Faks) —Daftar 200 pekerjaan faks terakhir yang berhasil. Laporan muncul hanya jika  Enable Job Log (Aktifkan Log Pekerjaan)  diaktifkan. Fax Call Log (Log Panggilan Faks) —Menampilkan sumber daya yang tersimpan di flash drive atau drive penyimpanan. Laporan hanya muncul ketika flash drive atau drive penyimpanan dipasang. Network (Jaringan) Network Setup Page (Halaman Penyiapan Jaringan) —Menampilkan setelan nirkabel dan jaringan yang sudah diatur di printer. Laporan ini hanya muncul di printer jaringan atau printer yang tersambung ke server cetak. Wi-Fi Direct Connected Clients (Klien Tersambung Wi-Fi Direct) —Menampilkan daftar perangkat yang tersambung ke printer melalui Wi-Fi Direct. Laporan ini hanya muncul jika  Enable Wi-Fi Direct (Aktifkan Wi-Fi Direct)  disetel ke  On (Aktif) . laporan printer log cetak melihat laporan dan log pembacaan meter, melihat lembar cetakan, melihat"},{"UUID":"4cf158a8-e49f-4b60-9fbf-1e8dad22ee98","title":"Memesan bahan pakai dan suku cadang","link":"ordering-parts-and-supplies-group.html","desc":"Untuk memesan persediaan di AS,","descFull":"Untuk memesan persediaan di AS, hubungi Lexmark di nomor 1-800-539-6275 guna memperoleh informasi tentang dealer peralatan resmi Lexmark di area Anda. Untuk negara atau wilayah lain, kunjungi  www.lexmark.com  atau hubungi tempat Anda membeli printer. Untuk memesan persediaan, hubungi tempat Anda membeli printer ini. Seluruh perkiraan masa pakai persediaan printer menggunakan asumsi bahwa pencetakan menggunakan kertas biasa berukuran letter atau A4. Jika performanya tidak dijaga atau komponen dan persediaan tidak rutin diganti, printer Anda bisa rusak. komponen dan persediaan asli"},{"UUID":"62a0d6fa-a5e9-4a0d-ae18-bb02060ff447","title":"Memesan bahan pakai dan suku cadang","link":"ordering-parts-and-supplies-group.html","desc":"Menggunakan komponen dan persediaan asli","descFull":"Menggunakan komponen dan persediaan asli Lexmark Printer Lexmark Anda dirancang agar berfungsi optimal jika menggunakan komponen dan persediaan Lexmark asli. Penggunaan persediaan atau komponen pihak ketiga dapat memengaruhi kinerja, keandalan, atau masa pakai printer dan komponen pencitraan. Ini juga dapat memengaruhi cakupan garansi. Kerusakan akibat penggunaan komponen atau persediaan pihak ketiga mungkin tidak tercakup dalam garansi. Semua indikator kegunaan dirancang agar dapat berfungsi dengan komponen dan persediaan Lexmark. Hasil yang tidak terduga dapat muncul jika Anda menggunakan komponen atau persediaan pihak ketiga. Penggunaan komponen pencitraan melebihi harapan masa pakainya dapat merusak printer Lexmark Anda atau komponen yang terkait. Persediaan dan komponen tanpa ketentuan perjanjian Program Pengembalian dapat direset dan diproduksi ulang. Namun, garansi pabrik tidak mencakup kerusakan apa pun yang disebabkan oleh persediaan atau suku cadang palsu. Mereset penghitung di persediaan atau komponen tanpa proses produksi ulang yang tepat dapat merusak printer Anda. Setelah mereset penghitung persediaan atau komponen, printer Anda mungkin menampilkan kesalahan yang mengindikasikan adanya item yang direset. menggunakan komponen dan persediaan asli Lexmark komponen dan persediaan asli Lexmark"},{"UUID":"c8023ade-1f4c-4bae-aa8c-a613fbc2b4c7","title":"Memesan bahan pakai dan suku cadang","link":"ordering-parts-and-supplies-group.html","desc":"Memesan kartrid toner Memesan kartrid","descFull":"Memesan kartrid toner Memesan kartrid toner Estimasi hasil kartrid didasarkan pada standar ISO/IEC 19798. Cakupan cetak yang sangat rendah selama waktu yang sangat lama dapat memengaruhi secara negatif terhadap hasil sebenarnya. Untuk memesan kartrid toner, hubungi tempat di mana Anda membeli printer. Program Pengembalian Kartrid Toner Lexmark CX833, CX961, CX962, CX963 Item Amerika Serikat, Kanada, Australia, dan Selandia Baru Uni Eropa, Wilayah Ekonomi Eropa, Islandia, Liechtenstein, Norwegia, dan Swiss Asia Pasifik lainnya Amerika Latin, Puerto Riko, dan Meksiko Eropa lainnya, Timur Tengah, Afrika, Eropa Timur dan Tengah, Persemakmuran Negara-negara Merdeka Untuk informasi lebih lanjut tentang negara di tiap-tiap kawasan, buka  www.lexmark.com/regions Cyan 77L10C0 77L20C0 77L30C0 77L40C0 77L50C0 Magenta 77L10M0 77L20M0 77L30M0 77L40M0 77L50M0 Kuning 77L10Y0 77L20Y0 77L30Y0 77L40Y0 77L50Y0 Hitam 77L10K0 77L20K0 77L30K0 77L40K0 77L50K0 Program pengembalian katrid toner hasil tinggi Lexmark CX833 Item Amerika Serikat, Kanada, Australia, dan Selandia Baru Uni Eropa, Wilayah Ekonomi Eropa, Islandia, Liechtenstein, Norwegia, dan Swiss Asia Pasifik lainnya Amerika Latin, Puerto Riko, dan Meksiko Eropa lainnya, Timur Tengah, Afrika, Eropa Timur dan Tengah, Persemakmuran Negara-negara Merdeka Untuk informasi lebih lanjut tentang negara di tiap-tiap kawasan, buka  www.lexmark.com/regions Cyan 79L10K0 79L20K0 79L30K0 79L40K0 79L50K0 Magenta 79L1HM0 79L2HM0 79L3HM0 79L4HM0 79L5HM0 Kuning 79L1HY0 79L2HY0 79L3HY0 79L4HY0 79L5HY0 Hitam 79L1HK0 79L2HK0 79L3HK0 79L4HK0 79L5HK0 Lexmark CX961, CX962, CX963 Item Amerika Serikat, Kanada, Australia, dan Selandia Baru Uni Eropa, Wilayah Ekonomi Eropa, Islandia, Liechtenstein, Norwegia, dan Swiss Asia Pasifik lainnya Amerika Latin, Puerto Riko, dan Meksiko Eropa lainnya, Timur Tengah, Afrika, Eropa Timur dan Tengah, Persemakmuran Negara-negara Merdeka Untuk informasi lebih lanjut tentang negara di tiap-tiap kawasan, buka  www.lexmark.com/regions Cyan 77L10K0 77L20K0 77L30K0 77L40K0 77L50K0 Magenta 77L1HM0 77L2HM0 77L3HM0 77L4HM0 77L5HM0 Kuning 77L1HY0 77L2HY0 77L3HY0 77L4HY0 77L5HY0 Hitam 77L1HK0 77L2HK0 77L3HK0 77L4HK0 77L5HK0 Lexmark XC8355 Item Amerika Serikat, Kanada, Australia, Selandia Baru Eropa lainnya, Timur Tengah, Afrika Untuk informasi lebih lanjut tentang negara di tiap-tiap kawasan, buka  www.lexmark.com/regions Cyan 24B7574 24B7582 Magenta 24B7575 24B7583 Kuning 24B7576 24B7584 Hitam 24B7577 24B7585 Lexmark XC9635, XC9645, XC9655 Item Amerika Serikat, Kanada, Australia, dan Selandia Baru Eropa lainnya, Timur Tengah, Afrika Untuk informasi lebih lanjut tentang negara di tiap-tiap kawasan, buka  www.lexmark.com/regions Cyan 24B7570 24B7578 Magenta 24B7571 24B7579 Kuning 24B7572 24B7580 Hitam 24B7573 24B7581 Katrid toner reguler hasil tinggi Lexmark CX833 Item Seluruh Dunia Untuk informasi lebih lanjut tentang negara di tiap-tiap kawasan, buka  www.lexmark.com/regions Cyan 77L0H20 Magenta 77L0H30 Kuning 77L0H40 Hitam 77L0H10 Lexmark CX961, CX962, CX963 Item Seluruh Dunia Untuk informasi lebih lanjut tentang negara di tiap-tiap kawasan, buka  www.lexmark.com/regions Cyan 79L0H20 Magenta 79L0H30 Kuning 79L0H40 Hitam 79L0H10 memesan bahan pakai kartrid toner kartrid toner memesan"},{"UUID":"c8249be8-e1ff-4b04-98f9-de512ac2d260","title":"Memesan bahan pakai dan suku cadang","link":"ordering-parts-and-supplies-group.html","desc":"Memesan unit pencitraan hitam Memesan","descFull":"Memesan unit pencitraan hitam Memesan unit pencitraan hitam Untuk memesan unit pencitraan hitam, hubungi tempat di mana membeli printer. Unit pencitraan hitam dan nomor suku cadangnya Item Nomor suku cadang Program pengembalian unit pencitraan hitam 77L0ZK0 Unit pencitraan hitam 77L0Z10 unit pencitraan hitam memesan memesan bahan pakai unit pencitraan hitam"},{"UUID":"9703e8da-4a03-4d1d-8f9d-303fe7f7ce29","title":"Memesan bahan pakai dan suku cadang","link":"ordering-parts-and-supplies-group.html","desc":"Memesan kit pencitraan warna Untuk","descFull":"Memesan kit pencitraan warna Untuk memesan kit pencitraan warna, hubungi tempat di mana Anda membeli printer. Item Nomor suku cadang Program pengembalian kit pencitraan warna 77L0ZV0 Kit pencitraan warna reguler 77L0Z50 kit pencitraan warna memesan memesan bahan pakai kit pencitraan warna"},{"UUID":"0a9584eb-0534-4c3a-8fff-881b96f962d7","title":"Memesan bahan pakai dan suku cadang","link":"ordering-parts-and-supplies-group.html","desc":"Memesan botol limbah toner Memesan","descFull":"Memesan botol limbah toner Memesan botol limbah toner Untuk memesan botol limbah toner, hubungi tempat di mana Anda membeli printer. Nomor botol limbah toner Item Nomor suku cadang Botol limbah toner 77L0W00 memesan bahan pakai botol limbah toner botol limbah toner memesan"},{"UUID":"5251798d-1a40-4a39-ad34-f8637aefd860","title":"Memesan bahan pakai dan suku cadang","link":"ordering-parts-and-supplies-group.html","desc":"Memesan kartrid pokok Untuk memesan","descFull":"Memesan kartrid pokok Untuk memesan kartrid pokok, hubungi tempat di mana Anda membeli printer. Kartrid pokok dan nomor suku cadang Item Nomor suku cadang 1  Hanya tersedia untuk pembuat buklet. 2  Hanya tersedia untuk lis buklet, lis stapler, dan lis lubang stapler. Kartrid pokok (4 paket) 1 20L7500 Kartrid pokok (3 paket) 2 25A0013 kartrid pokok memesan memesan bahan pakai kartrid pokok"},{"UUID":"55bc073e-5ecb-4be2-8b75-aad4f11da141","title":"Memesan bahan pakai dan suku cadang","link":"ordering-parts-and-supplies-group.html","desc":"Memesan kit perawatan Memesan kit","descFull":"Memesan kit perawatan Memesan kit perawatan Untuk memesan kit perawatan, hubungi tempat di mana Anda membeli printer. Cocokkan kit perawatan dengan voltase printer. Penggunaan jenis kertas tertentu bisa menyebabkan penggantian kit perawatan jadi lebih sering. Termasuk dalam kit perawatan adalah fuser dan roda penarik. Suku cadang ini mungkin harus dibeli dan diganti secara terpisah, jika diperlukan. Kit perawatan dan nomor suku cadang yang direkomendasikan Item Nomor suku cadang Penggantian kit perawatan hanya boleh dilakukan oleh teknisi servis yang sah. Hubungi penyedia layanan Anda. 100 V Program pengembalian kit perawatan fuser, Tipe 02 41X5654 110-120 V Program pengembalian kit perawatan fuser, Tipe 00 41X5655 220-240 V Program pengembalian kit perawatan fuser, Tipe 01 41X5656 100 V Program pengembalian kit perawatan fuser, Tipe 12 41X6053 110-120 V Program pengembalian kit perawatan fuser, Tipe 10 41X6051 220-240 V Program pengembalian kit perawatan fuser, Tipe 11 41X6052 memesan bahan pakai kit perawatan fuser kit perawatan fuser memesan"},{"UUID":"861c53f1-c050-452e-b45f-8826928e9d2e","title":"Mengganti bahan pakai dan suku cadang","link":"replacing-toner-cartridge-topic.html","desc":"Mengganti kartrid toner Mengganti kartrid","descFull":"Mengganti kartrid toner Mengganti kartrid toner Buka pintu depan. Lepas kartrid toner yang lama. Buka kemasan kartrid toner yang baru. Masukkan kartrid toner baru sampai berbunyi  klik . Tutup pintu. kartrid toner mengganti mengganti bahan pakai kartrid toner"},{"UUID":"f75cf9ab-a6e8-4b66-a9af-66ffa8cd5e49","title":"Mengganti bahan pakai dan suku cadang","link":"replacing-toner-cartridge-topic.html","desc":"Mengganti unit pencitraan hitam Buka","descFull":"Mengganti unit pencitraan hitam Buka pintu depan. Lepas kartrid toner. Lepas botol limbah toner. Supaya toner tidak tumpah, pasang botol dalam posisi tegak. Lepas kit pencitraan. Jangan sampai kit pencitraan terpapar cahaya secara langsung. Kualitas cetak akan menurun jika lama terpapar cahaya. Jangan sentuh gendang fotokonduktor. Tindakan tersebut bisa memengaruhi kualitas pekerjaan cetak di masa mendatang. Taruh kit pencitraan di permukaan yang datar dan bersih, serta dalam posisi tegak, supaya tidak menggores atau merusak gendang fotokonduktor. Buka unit pencitraan hitam yang lama. Lepas unit pencitraan hitam yang lama. Buka kemasan unit pencitraan hitam yang baru. Masukkan unit pencitraan hitam yang baru. Kunci unit pencitraan hitam yang baru pada tempatnya. Masukkan kit pencitraan sampai benar-benar pas. Masukkan botol limbah toner sampai berbunyi  klik  pada tempatnya. Tarik perlahan pengusap printhead, lalu bersihkan lensa printhead. Untuk informasi lebih lanjut tentang membersihkan lensa printhead, lihat  . Masukkan kartrid toner. Tutup pintu. unit pencitraan hitam mengganti mengganti bahan pakai unit pencitraan hitam"},{"UUID":"71faa302-1f9b-49d2-92ab-a515a91839ab","title":"Mengganti bahan pakai dan suku cadang","link":"replacing-toner-cartridge-topic.html","desc":"Mengganti kit pencitraan warna Buka","descFull":"Mengganti kit pencitraan warna Buka pintu depan. Lepas kartrid toner. Lepas botol limbah toner. Supaya toner tidak tumpah, pasang botol dalam posisi tegak. Lepas kit pencitraan lama. Taruh kit pencitraan di permukaan yang datar dan bersih, serta dalam posisi tegak, supaya tidak menggores atau merusak gendang fotokonduktor. Buka unit pencitraan hitam. Lepas unit pencitraan hitam. Unit pencitraan hitam itu jangan dibuang. Ia akan dipasang di kit pencitraan yang baru. Buka kit pencitraan baru. Kit pencitraan biasanya berisi wadah pencitraan dan unit pengembang cyan, magenta, dan kuning. Jangan sampai kit pencitraan terpapar cahaya secara langsung. Kualitas cetak akan menurun jika lama terpapar cahaya. Jangan sentuh gendang fotokonduktor. Tindakan tersebut bisa memengaruhi kualitas pekerjaan cetak di masa mendatang. Masukkan unit pencitraan hitam ke dalam kit pencitraan yang baru. Kunci unit pencitraan hitam pada tempatnya. Masukkan kit pencitraan baru sampai benar-benar pas. Masukkan botol limbah toner sampai berbunyi  klik  pada tempatnya. Tarik perlahan pengusap printhead, lalu bersihkan lensa printhead. Untuk informasi lebih lanjut tentang membersihkan lensa printhead, lihat  . Masukkan kartrid toner. Tutup pintu. kit pencitraan warna mengganti mengganti bahan pakai kit pencitraan warna"},{"UUID":"dcf62ced-f015-4c78-9581-d75aef2b0561","title":"Mengganti bahan pakai dan suku cadang","link":"replacing-toner-cartridge-topic.html","desc":"Mengganti botol limbah toner Mengganti","descFull":"Mengganti botol limbah toner Mengganti botol limbah toner Buka pintu depan. Lepas botol limbah toner yang lama. Supaya toner tidak tumpah, pasang botol dalam posisi tegak. Buka kemasan botol limbah toner yang baru. Masukkan botol limbah toner yang baru sampai berbunyi  klik,  lalu tutup pintunya. mengganti bahan pakai botol limbah toner botol limbah toner mengganti"},{"UUID":"433a5aac-74b9-4e84-9545-7d289e2695a8","title":"Mengganti bahan pakai dan suku cadang","link":"replacing-toner-cartridge-topic.html","desc":"Mengganti fuser Mengganti fuser Nonaktifkan","descFull":"Mengganti fuser Mengganti fuser Nonaktifkan printer. Lepas kabel daya dari stopkontak listrik, lalu dari printer. Buka pintu B. Bagian dalam printer mungkin panas. Untuk mengurangi risiko cedera akibat komponen panas, biarkan permukaan berubah dingin sebelum menyentuhnya. Buka kunci, lalu lepas fuser yang lama. Buka kemasan fuser yang baru. Masukkan fuser yang baru sampai berbunyi  klik,  lalu kunci. Tutup pintu B. Sambungkan ujung kabel daya printer ke printer, lalu ujung lainnya ke stopkontak listrik. Untuk menghindari risiko kebakaran atau tersengat listrik, sambungkan kabel daya ke stopkontak listrik yang sudah diinspeksi standar mutunya dan dihubungkan ke arde di dekat produk dan mudah dijangkau. Aktifkan printer. fuser mengganti mengganti bagian fuser"},{"UUID":"ce9f54ee-3bcf-458c-8dff-23aa61083d71","title":"Mengganti bahan pakai dan suku cadang","link":"replacing-toner-cartridge-topic.html","desc":"Mengganti baki dalam Mengganti baki","descFull":"Mengganti baki dalam Mengganti baki dalam Tarik baki dalam yang lama. Buka kemasan baki dalam yang baru. Masukkan baki dalam yang baru. baki dimasukkan mengganti mengganti bagian baki dimasukkan"},{"UUID":"1ce17595-081b-4655-ad69-018f641ba875","title":"Mengganti bahan pakai dan suku cadang","link":"replacing-toner-cartridge-topic.html","desc":"Mengganti pembatas ukuran di baki","descFull":"Mengganti pembatas ukuran di baki 550 lembar (opsional) Mengganti pembatas ukuran di baki 550 lembar (opsional) Tarik keluar baki. Lepas pembatas ukuran yang lama. Buka kemasan pembatas ukuran yang baru. Masukkan pembatas ukuran yang baru sampai berbunyi  klik  pada tempatnya. Masukkan baki. pembatas ukuran mengganti mengganti bagian pembatas ukuran"},{"UUID":"6e3a7fad-df93-4912-9265-55c34d081b0b","title":"Mengganti bahan pakai dan suku cadang","link":"replacing-toner-cartridge-topic.html","desc":"Mengganti pintu baki 550 lembar","descFull":"Mengganti pintu baki 550 lembar (opsional) Mengganti pintu baki 550 lembar (opsional) Lepas pintu baki yang lama. Buka kemasan pintu baki yang baru. Masukkan pintu baki yang baru sampai berbunyi klik pada tempatnya. mengganti bagian pintu baki pintu baki mengganti Pintu baki 550 lembar"},{"UUID":"fc23c405-f034-49b3-9df8-46f1cf09212b","title":"Mengganti bahan pakai dan suku cadang","link":"replacing-toner-cartridge-topic.html","desc":"Mengganti ekstensi keranjang atas pada","descFull":"Mengganti ekstensi keranjang atas pada lis buklet Lepas ekstensi keranjang atas yang lama. Buka kemasan ekstensi keranjang atas yang baru. Masukkan ekstensi keranjang atas yang lama. mengganti bagian ekstensi keranjang atas lis buklet ekstensi keranjang atas lis buklet mengganti"},{"UUID":"921ba622-7891-44f9-bf31-9884d3094c31","title":"Mengganti bahan pakai dan suku cadang","link":"replacing-toner-cartridge-topic.html","desc":"Mengganti kotak lis lubang Tergantung","descFull":"Mengganti kotak lis lubang Tergantung jenis finisher yang dipasang, tampilan kotak lis lubang bisa berbeda-beda. Buka pintu finisher. Keluarkan kotak lis lubang yang lama. Buka kemasan kotak lis lubang yang baru. Masukkan kotak lis lubang yang baru. Tutup pintu finisher. mengganti bagian kotak lis lubang kotak lis lubang mengganti"},{"UUID":"ab102c0e-f24f-4b8e-8ceb-4c5270c3cce9","title":"Mengganti bahan pakai dan suku cadang","link":"replacing-toner-cartridge-topic.html","desc":"Mengganti keranjang standar Mengganti keranjang","descFull":"Mengganti keranjang standar Mengganti keranjang standar Lepas keranjang standar yang lama. Buka kemasan keranjang standar yang baru. Pasang keranjang standar yang baru. mengganti bagian keranjang standar keranjang standar mengganti"},{"UUID":"500ecf12-939f-43a1-8664-9be95f53a27a","title":"Mengganti bahan pakai dan suku cadang","link":"replacing-toner-cartridge-topic.html","desc":"Mengganti pintu kipas Lepas pintu","descFull":"Mengganti pintu kipas Lepas pintu kipas yang lama. Buka kemasan pintu kipas yang baru. Masukkan pintu kipas yang baru sampai berbunyi  klik  pada tempatnya. mengganti bagian pintu kipas pintu kipas mengganti"},{"UUID":"83227995-81ea-4048-beb3-6b266c7a6380","title":"Mengganti bahan pakai dan suku cadang","link":"replacing-toner-cartridge-topic.html","desc":"Mengganti pintu sebelah kanan Buka","descFull":"Mengganti pintu sebelah kanan Buka pintu sebelah kanan. Buka kemasan pintu kipas yang baru. Masukkan pintu kipas yang baru sampai berbunyi  klik  pada tempatnya. mengganti bagian pintu kanan pintu kanan mengganti"},{"UUID":"475ab245-1fe4-479b-90c1-05033e7bb69c","title":"Mengganti bahan pakai dan suku cadang","link":"replacing-toner-cartridge-topic.html","desc":"Mengganti alat pembersih kaca Buka","descFull":"Mengganti alat pembersih kaca Buka pintu pemindai. Lepas alat pembersih kaca yang lama. Buka kemasan pembersih kaca yang baru. Masukkan pembersih kaca yang baru. Tutup pintu pemindai. mengganti bagian alat pembersih kaca alat pembersih kaca mengganti"},{"UUID":"767f4a0f-1a30-480e-ba09-d1cd1821269b","title":"Mengganti bahan pakai dan suku cadang","link":"replacing-toner-cartridge-topic.html","desc":"Mengganti pintu konektor penyalur kertas","descFull":"Mengganti pintu konektor penyalur kertas Mengganti pintu konektor penyalur kertas Lepas keranjang standar. Lepas pintu konektor penyalur kertas yang lama. Buka kemasan pintu konektor yang baru. Pasang pintu konektor yang baru sampai berbunyi  klik  pada tempatnya. Pasang keranjang standar. mengganti bagian pintu konektor penyalur kertas pintu konektor penyalur kertas mengganti"},{"UUID":"7c2ea568-ea7d-4923-8bc1-fa189e4300fc","title":"Mengganti unit kartrid pokok","link":"replacing-toner-cartridge-topic.html","desc":"Mengganti kartrid pokok pada lis","descFull":"Mengganti kartrid pokok pada lis stapler Pegang gagang F, lalu geser lis stapler ke kiri. Lepas wadah kartrid pokok Lepas kartrid pokok yang kosong. Masukkan kartrid pokok yang baru sampai berbunyi  klik  pada tempatnya. Masukkan wadah kartrid pokok sampai berbunyi  klik  pada tempatnya. Geser lis stapler ke kanan. mengganti bahan pakai kartrid pokok kartrid pokok mengganti"},{"UUID":"862236c5-60b3-4d5a-98f3-a33185018eaf","title":"Mengganti unit kartrid pokok","link":"replacing-toner-cartridge-topic.html","desc":"Mengganti kartrid pokok pada lis","descFull":"Mengganti kartrid pokok pada lis lubang stapler Buka pintu H. Tarik gagang hijau, lalu lepas wadah kartrid pokok yang lama. Lepas kartrid pokok yang kosong. Buka kartrid pokok yang baru. Masukkan kartrid pokok yang baru sampai berbunyi  klik  pada tempatnya. Masukkan wadah kartrid pokok sampai berbunyi  klik  pada tempatnya. Tutup pintu H. mengganti bahan pakai kartrid pokok kartrid pokok mengganti"},{"UUID":"3fac519b-09f3-41bd-a55d-f00d5e331ae2","title":"Mengganti unit kartrid pokok","link":"replacing-toner-cartridge-topic.html","desc":"Mengganti kartrid pokok pada lis","descFull":"Mengganti kartrid pokok pada lis buklet Buka pintu H. Tarik gagang hijau, lalu lepas wadah kartrid pokok yang lama. Lepas kartrid pokok yang kosong. Buka kartrid pokok yang baru. Masukkan kartrid pokok yang baru sampai berbunyi  klik  pada tempatnya. Masukkan wadah kartrid pokok sampai berbunyi  klik  pada tempatnya. Tutup pintu H. mengganti bahan pakai kartrid pokok kartrid pokok mengganti"},{"UUID":"b5378a45-c393-4b16-a0ea-f2dc5595fe8e","title":"Mengganti unit kartrid pokok","link":"replacing-toner-cartridge-topic.html","desc":"Mengganti wadah kartrid pokok pada","descFull":"Mengganti wadah kartrid pokok pada lis buklet Buka pintu finisher. Tarik lis buklet, lalu lepas wadah kartrid pokok yang lama. Buka kemasan wadah kartrid pokok yang baru. Masukkan wadah kartrid pokok yang baru. Masukkan lis buklet, lalu tutup pintu finisher. mengganti bagian penopang kartrid pokok penopang kartrid pokok mengganti"},{"UUID":"fd84345e-a3fe-410b-b5d2-451a01dad4e5","title":"Mengganti bahan pakai dan suku cadang","link":"replacing-toner-cartridge-topic.html","desc":"Menyetel ulang penghitung pemakaian bahan","descFull":"Menyetel ulang penghitung pemakaian bahan pakai Menyetel ulang penghitung pemakaian bahan pakai Dari panel kontrol, buka  Settings (Setelan) Device (Perangkat) Maintenance (Perawatan) Configuration Menu (Menu Konfigurasi) Supply Usage And Counters (Penghitung dan Pemakaian Bahan Pakai) . Pilih penghitung yang ingin Anda setel ulang. Suku cadang dan bahan pakai yang tidak memiliki perjanjian Program Pengembalian bisa disetel ulang dan diproduksi ulang. Meski demikian, garansi produsen tidak berlaku untuk kerusakan yang disebabkan oleh penggunaan suku cadang atau bahan pakai yang tidak asli. Menyetel ulang penghitung pada suku cadang dan bahan pakai tanpa pembuatan ulang yang semestinya bisa merusak printer. Setelah menyetel ulang penghitung suku cadang atau bahan pakai, printer Anda bisa saja menampilkan eror yang menunjukkan keberadaan item setel ulang. Suku cadang dan bahan pakai yang tidak memiliki perjanjian Program Pengembalian bisa disetel ulang dan diproduksi ulang. Meski demikian, garansi produsen tidak berlaku untuk kerusakan yang disebabkan oleh penggunaan suku cadang atau bahan pakai yang tidak asli. Menyetel ulang penghitung pada suku cadang dan bahan pakai tanpa pembuatan ulang yang semestinya bisa merusak printer. Setelah menyetel ulang penghitung suku cadang atau bahan pakai, printer Anda bisa saja menampilkan eror yang menunjukkan keberadaan item setel ulang. penghitung pemakaian bahan pakai menyetel ulang menyetel ulang penghitung pemakaian bahan pakai"},{"UUID":"2ce1299c-a6ef-42f6-a3b6-711a4b9920dc","title":"Membersihkan bagian printer","link":"cleaning-printer-topic.html","desc":"Membersihkan printer Membersihkan printer Untuk","descFull":"Membersihkan printer Membersihkan printer Untuk menghindari risiko sengatan listrik ketika membersihkan bagian luar printer, cabut kabel daya dari stopkontak dan lepaskan semua kabel dari printer sebelum melanjutkan. Jalankan tugas ini setia beberapa bulan sekali. Kerusakan pada printer akibat kesalahan dalam proses pemindahan tidak tercakup dalam garansi. Nonaktifkan printer, lalu lepas kabel daya dari stopkontak listrik. Keluarkan kertas dari keranjang standar dan feeder multiguna. Dengan memakai sikat lembut atau penyedot debu, bersihkan debu, serat, dan potongan kertas di sekitar printer. Dengan memakai kain bekas yang lembut tanpa serat, usap bagian luar printer. Jangan memakai pembersih atau deterjen rumahan karena dapat merusak cat printer. Pastikan seluruh area printer dalam kondisi kering dan bersih. Sambungkan kabel daya ke stopkontak listrik, lalu aktifkan printer. Untuk menghindari risiko kebakaran atau tersengat listrik, sambungkan kabel daya ke stopkontak listrik yang sudah diinspeksi standar mutunya dan dihubungkan ke arde di dekat produk dan mudah dijangkau. membersihkan printer printer, membersihkan"},{"UUID":"df2050e9-8eab-4308-b700-e1f39984954b","title":"Membersihkan bagian printer","link":"cleaning-printer-topic.html","desc":"Membersihkan layar sentuh Membersihkan layar","descFull":"Membersihkan layar sentuh Membersihkan layar sentuh Untuk menghindari risiko sengatan listrik ketika membersihkan bagian luar printer, cabut kabel daya dari stopkontak dan lepaskan semua kabel dari printer sebelum melanjutkan. Nonaktifkan printer, lalu lepas kabel daya dari stopkontak listrik. Dengan memakai kain bekas yang lembut tanpa serat, usap area layar sentuh. Jangan memakai pembersih atau deterjen rumahan karena dapat merusak layar sentuh. Pastikan layar sentuh dalam kondisi kering setelah dibersihkan. Sambungkan kabel daya ke stopkontak listrik, lalu aktifkan printer. Untuk menghindari risiko kebakaran atau tersengat listrik, sambungkan kabel daya ke stopkontak listrik yang sudah diinspeksi standar mutunya dan dihubungkan ke arde di dekat produk dan mudah dijangkau. layar sentuh, membersihkan membersihkan layar sentuh"},{"UUID":"5b9992ff-de31-4e58-8184-d5742cbe6e42","title":"Membersihkan bagian printer","link":"cleaning-printer-topic.html","desc":"Membersihkan pemindai Buka pintu pemindai.","descFull":"Membersihkan pemindai Buka pintu pemindai. Lepas alat pembersih kaca. Buka pintu A1. Dengan memakai alat, usap kaca ADF. Tutup pintu A1. Dengan memakai kain bekas yang lembut tanpa serat, usap area-area berikut: Bantalan kaca ADF Bantalan kaca pemindai Kaca pemindai Dengan memakai alat, usap kaca ADF. Kembalikan alat ke tempatnya. Tutup pintu pemindai. pemindai membersihkan kualitas cetak membersihkan pemindai membersihkan pemindai"},{"UUID":"02fc791e-3764-4d65-a5e3-190e2b5bff57","title":"Membersihkan bagian printer","link":"cleaning-printer-topic.html","desc":"Membersihkan lensa printhead Buka pintu","descFull":"Membersihkan lensa printhead Buka pintu depan. Lepas kartrid toner. Perlahan tarik pengusap sampai berhenti. Pengusap tidak terlepas dari printer. Dorong kembali pengusap ke dalam printhead sampai berhenti. Ulangi  langkah 3  dan  langkah 4  sebanyak tiga kali untuk masing-masing printhead. Masukkan kartrid toner. Tutup pintu depan. lensa printhead membersihkan membersihkan lensa printhead"},{"UUID":"eda89572-6de1-42a1-afd4-4cb41112c0ec","title":"Membersihkan bagian printer","link":"cleaning-printer-topic.html","desc":"Mengosongkan kotak lis lubang Tergantung","descFull":"Mengosongkan kotak lis lubang Tergantung jenis finisher yang dipasang, tampilan kotak lis lubang bisa berbeda-beda. Buka pintu finisher. Keluarkan, lalu kosongkan kotak lis lubang. Masukkan kotak lis lubang. Tutup pintu finisher. kotak lis lubang mengosongkan mengosongkan kotak lis lubang"},{"UUID":"499c85fd-0d79-4ed0-8dda-72b9e2874f26","title":"Menghemat energi dan kertas","link":"configuring-power-save-mode-settings-topic.html","desc":"Mengatur setelan mode hemat daya","descFull":"Mengatur setelan mode hemat daya Mengatur setelan mode hemat daya Mode tidur Dari panel kontrol, buka  Settings (Setelan) Device (Perangkat) Power Management (Manajemen Daya) Timeouts (Waktu Habis) Sleep Mode (Mode Tidur) . Tentukan lama printer tetap diam sebelum memasuki  Sleep Mode (Mode Tidur) . mode hibernasi Dari panel kontrol, buka  Settings (Setelan) Device (Perangkat) Power Management (Manajemen Daya) Timeouts (Waktu Habis) Hibernate Timeout (Waktu Hibernasi Habis) . Tentukan lama printer tetap diam sebelum memasuki mode hibernasi. Agar  Hibernate Timeout (Waktu Hibernasi Habis)  berfungsi, setel  Hibernate Timeout on Connection (Waktu Hibernasi Habis dalam Sambungan)  ke  Hibernate (Hibernasi) . Embedded Web Server dinonaktifkan ketika printer dalam mode hibernasi. Mode tidur mengatur mode hibernasi mengatur mode hemat daya mengatur"},{"UUID":"04c695b0-5762-40d7-bda9-99ab2de2ddf9","title":"Menghemat energi dan kertas","link":"configuring-power-save-mode-settings-topic.html","desc":"Menyesuaikan kecerahan tampilan Menyesuaikan kecerahan","descFull":"Menyesuaikan kecerahan tampilan Menyesuaikan kecerahan tampilan Dari panel kontrol, buka  Settings (Setelan) Device (Perangkat) Preferences (Preferensi) . Pada menu  Screen Brightness (Kecerahan Layar) , sesuaikan setelan. kecerahan tampilan menyesuaikan menyesuaikan kecerahan"},{"UUID":"2fe46ebc-cfd4-4917-b3a4-1a993b6f6ff2","title":"Menghemat energi dan kertas","link":"configuring-power-save-mode-settings-topic.html","desc":"Menghemat bahan pakai Mencetak pada","descFull":"Menghemat bahan pakai Mencetak pada dua sisi kertas Pencetakan dua sisi adalah setelan default printer. Cetak beberapa halaman pada satu lembar kertas. Gunakan fitur pratinjau untuk melihat penampakan dokumen sebelum dicetak. Cetak satu salinan dokumen untuk memeriksa akurasi konten dan format. menghemat bahan pakai bahan pakai, mengawetkan"},{"UUID":"207fb7dc-85d9-42c4-aa3e-c92d02b3b768","title":"Merawat printer","link":"moving-printer-topic.html","desc":"Memindah printer ke lokasi lain","descFull":"Memindah printer ke lokasi lain Memindah printer ke lokasi lain Jika berat printer lebih dari 20 kg (44 lb), Anda memerlukan bantuan dua atau beberapa orang agar bisa mengangkatnya dengan aman. Untuk mencegah risiko kebakaran atau sengatan listrik, hanya gunakan kabel daya yang disediakan bersama dengan produk ini atau produk pengganti yang disahkan oleh pembuat. Ketika memindah printer, ikuti panduan berikut guna menghindari cedera personal atau kerusakan pada printer. Pastikan semua pintu dan baki tertutup. Nonaktifkan printer, lalu lepas kabel daya dari stopkontak listrik. Putus semua sambungan colokan dan kabel dari printer. Jika printer memiliki penyangga terpisah untuk baki opsional atau opsi output, lepas penyangga tersebut sebelum memindah printer. Jikas printer memiliki basis kaster, gulung dengan hati-hati ke lokasi baru. Harap selalu waspada jika melewati ambang pintu dan retakan pada lantai. Jika printer tidak memiliki basis kaster, tetapi diatur dengan baki opsional serta opsi output, lepas opsi output dan angkat printer tanpa baki. Jangan coba-coba mengangkat printer dan opsi lain secara bersamaan. Selalu gunakan pegangan tangan yang tersedia pada printer untuk mengangkatnya. Jika hendak memakai troli untuk memindah printer, pastikan troli memiliki permukaan yang bisa menopang seluruh kaki-kaki printer. Jika hendak memakai troli untuk memindah opsi perangkat keras, pastikan troli memiliki permukaan yang bisa menopang ukuran opsi tersebut. Jaga agar printer senantiasa dalam posisi berdiri. Hindari melakukan gerakan yang cepat dan tiba-tiba. Pastikan jari Anda tidak di bawah printer ketika Anda meletakkannya. Pastikan terdapat cukup ruang kosong di sekeliling printer. Kerusakan pada printer akibat kesalahan dalam proses pemindahan tidak tercakup dalam garansi. memindah printer"},{"UUID":"881ea795-b4a1-4679-8598-9eb68e49121c","title":"Menyelesaikan masalah","link":"print-quality-problems-topic.html","desc":"Masalah kualitas cetak Temukan gambar","descFull":"Masalah kualitas cetak Temukan gambar yang mewakili masalah kualitas cetak yang Anda alami, lalu klik tautan di bawah ini untuk membaca langkah pemecahan masalah."},{"UUID":"e77644a7-1571-4958-8201-0e2aec297be8","title":"Menyelesaikan masalah","link":"printer-error-codes-topic.html","desc":"Kode eror printer Kode eror","descFull":"Kode eror printer Kode eror dan cara mengatasinya Kode eror Pesan eror Solusi 2.01 Bahan pakai diperlukan. Pilih  Cancel Job (Batalkan Pekerjaan)  dan pesan bahan pakai yang diperlukan. Untuk informasi lebih lanjut, lihat  . 3.01 Keranjang output standar penuh. Keluarkan kertas dari keranjang, lalu pilih  Continue (Lanjutkan) . 3.02, 3.03, 3.04 Keluarkan kertas dari keranjang [x]. Keluarkan kertas dari keranjang, lalu pilih  Continue (Lanjutkan) . 7.13, 7.23, 7.33,7.43 Masukkan baki [x]. Masukkan baki yang ditunjuk. 8.01 Tutup pintu depan. Pastikan pintu depan selalu tertutup, kecuali ketika perawatan. 8.02, 8.03, 8.04, 8.05, 8.08, 8.10, 8.11 Tutup pintu [x]. Pastikan pintu yang ditunjuk selalu tertutup, kecuali ketika perawatan. 8.06 Pasang kembali baki 1500 lembar. Pastikan baki sudah terpasang dengan benar di printer. 8.07 Pasang kembali lis stapler. Pastikan lis stapler terpasang dengan benar di printer. 8.08 Tutup pintu penyalur kertas F. Pastikan pintu selalu tertutup, kecuali ketika perawatan. 8.09 Tutup pintu penyalur kertas G. 9 Printer harus dimulai ulang. Pekerjaan terakhir mungkin tidak selesai. Pilih  Continue (Lanjutkan)  untuk membersihkan pesan dan melanjutkan mencetak. 11.11, 11.21, 11.31, 11.41, 11.51, 11.81, 11.91 Masukkan <source/> dengan <type/> <size/>. Isi baki yang ditunjukkan dengan kertas. Untuk informasi lebih lanjut, lihat  . 11.12, 11.22, 11.32, 11.42, 11.82, 11.92 Masukkan <source/> dengan <type/> <size/> <orientation/>. 12.11, 12.21, 12.31, 12.41, 12.51, 12.91 Ubah <source/> ke <type/> <size/>.  Tarik baki yang ditunjuk, keluarkan kertas, lalu masukkan jenis dan ukuran kertas yang benar. Untuk informasi lebih lanjut, lihat  . 12.12, 12.22, 12.32, 12.4212.92 Ubah <source/> ke <type/> <size/> <orientation/>. 31.00 Kotak lis lubang tidak ada atau penuh. Buka pintu H. Keluarkan kotak lis lubang. Jika kotak lis lubang penuh, kosongkan. Masukkan kotak lis lubang. Tutup pintu H. 31.35, 31.35A, 31.35B Pasang kembali botol limbah toner yang tidak ada atau tidak responsif. Buka pintu depan. Lepas botol limbah toner. Supaya toner tidak tumpah, pasang botol dalam posisi tegak. Masukkan botol limbah toner. Tutup pintu depan. 31.40z, 31.41z, 31.42z, 31.43z Pasang kembali kartrid toner [warna] yang tidak ada atau tidak responsif. Buka pintu depan. Lepas kartrid. Masukkan kartrid. Tutup pintu depan. 31.60z Pasang kembali unit pencitraan hitam yang tidak ada atau tidak responsif. Buka pintu depan. Lepas kartrid toner. Lepas botol limbah toner. Supaya toner tidak tumpah, pasang botol dalam posisi tegak. Lepas kit pencitraan. Jangan sampai kit pencitraan terpapar cahaya secara langsung. Kualitas cetak akan menurun jika lama terpapar cahaya. Jangan sentuh gendang fotokonduktor. Tindakan tersebut bisa memengaruhi kualitas pekerjaan cetak di masa mendatang. Buka kunci, lalu lepas unit pencitraan hitam. Masukkan unit pencitraan hitam, lalu kunci pada tempatnya. Masukkan kit pencitraan sampai benar-benar pas. Masukkan botol limbah toner. Masukkan kartrid toner. Tutup pintu depan. 31.64z Pasang kembali kit pencitraan warna yang tidak ada, lepas, atau tidak responsif. Buka pintu depan. Lepas kartrid toner. Lepas botol limbah toner. Supaya toner tidak tumpah, pasang botol dalam posisi tegak. Lepas kit pencitraan. Jangan sampai kit pencitraan terpapar cahaya secara langsung. Kualitas cetak akan menurun jika lama terpapar cahaya. Jangan sentuh gendang fotokonduktor. Tindakan tersebut bisa memengaruhi kualitas pekerjaan cetak di masa mendatang. Masukkan kit pencitraan sampai benar-benar pas. Masukkan botol limbah toner. Masukkan kartrid toner. Tutup pintu depan. 31.80z Pasang kembali fuser yang tidak ada atau tidak responsif. Buka pintu B. Bagian dalam printer mungkin panas. Untuk mengurangi risiko cedera akibat komponen panas, biarkan permukaan berubah dingin sebelum menyentuhnya. Buka kunci, lalu lepas fuser tersebut. Masukkan fuser, lalu kunci pada tempatnya. Tutup pintu B. 32.40z, 32.41z, 32.42z, 32.43z Ganti kartrid toner [warna] yang tidak didukung. Untuk informasi lebih lanjut, lihat  . 32.60z Ganti unit pencitraan hitam yang tidak didukung Untuk informasi lebih lanjut, lihat  . 32.65z Ganti kit pencitraan warna yang tidak didukung. Untuk informasi lebih lanjut, lihat  . 33.40z, 33.41z, 33.42z, 33.43z Kartrid [warna] reguler isi ulang Untuk informasi lebih lanjut, lihat  . 33.60z Unit pencitraan hitam tidak asli, lihat Panduan Pengguna. Untuk informasi lebih lanjut, lihat  . 33.64z Kit pencitraan warna tidak asli, lihat Panduan Pengguna. 34.00 Kertas terlalu pendek. Sesuaikan ukuran kertas dengan kertas yang ada di baki. Dari panel kontrol, buka  Settings (Pengaturan) Paper (Kertas) Tray (Baki) Configuration (Konfigurasi) Paper Size/Type (Jenis/Ukuran Kertas) . 34.10, 34.20, 34.30, 34.40, 34.50 Periksa [sumber], sesuaikan pembatas dan orientasi. Tarik baki yang ditunjuk, lalu pastikan bahwa kertas telah dimasukkan dengan benar. Untuk informasi lebih lanjut, lihat  . 34.90 Periksa feeder multiguna, sesuaikan pembatas dan orientasi. Pastikan bahwa kertas telah dimasukkan dengan benar. Untuk informasi lebih lanjut, lihat  . 37.1 Memori tidak cukup untuk menyusun pekerjaan. Lakukan salah satu di bawah ini: Pilih  Continue (Lanjutkan)  untuk mencetak bagian pekerjaan yang tersimpan dan mulai menyusun sisa pekerjaan cetak. Batalkan pekerjaan cetak ini. 37.3 Memori tidak cukup, beberapa pekerjaan yang tertunda telah dihapus. Pilih  Continue (Lanjutkan)  untuk membersihkan pesan dan melanjutkan mencetak. 38.1 Memori penuh. Coba satu atau dua cara berikut: Pilih  Continue (Lanjutkan)  untuk membersihkan pesan dan melanjutkan mencetak. Batalkan pekerjaan cetak ini. Pasang memori printer yang lebih besar. Kurangi jumlah halaman di pekerjaan cetak. 39.1 Halaman rumit, beberapa data mungkin tidak tercetak. Coba satu atau dua cara berikut: Pilih  Continue (Lanjutkan)  untuk membersihkan pesan dan melanjutkan mencetak. Batalkan pekerjaan cetak ini. Pasang memori printer yang lebih besar. Kurangi kerumitan dan ukuran pekerjaan cetak sebelum mengirimnya kembali ke printer. Kurangi jumlah halaman di pekerjaan cetak. Kurangi jumlah dan ukuran font yang diunduh. Hapus font atau makro yang tidak perlu dari pekerjaan cetak. Kurangi jumlah grafik di pekerjaan cetak. 42.yyC, 42.yyK, 42.yyM, 42.yyY Ganti kartrid toner [warna] dan kawasan printer yang tidak cocok. Untuk informasi lebih lanjut, lihat  . 43.40Y, 43.41Y, 43.42Y, 43.43Y Pasang kembali kartrid toner [warna]. Buka pintu depan. Lepas kartrid. Masukkan kartrid. Tutup pintu depan. 43.40Z, 43.41Z, 43.42Z, 43.43Z Ganti kartrid toner [warna]. Untuk informasi lebih lanjut, lihat  . 50 Kesalahan font PPDS. Instal font PPDS seperti yang ditunjukkan pada pekerjaan cetak, lalu pilih  Continue (Lanjutkan)  supaya printer mencari font pengganti. 51 Flash rusak terdeteksi. Coba satu atau dua cara berikut: Ganti memori flash. Pilih  Continue (Lanjutkan)  untuk membersihkan pesan dan melanjutkan mencetak. Batalkan pekerjaan cetak ini. 52 Tidak cukup ruang di memori flash untuk sumber daya. Coba satu atau dua cara berikut: Pilih  Continue (Lanjutkan)  untuk membersihkan pesan dan melanjutkan mencetak. Hapus font, makro, dan data lain yang tersimpan di memori flash. Pasang drive penyimpanan. Font dan makro yang telah diunduh dan sebelumnya tidak disimpan di memori flash akan terhapus. 58.4 Konfigurasi opsi output tidak benar. Nonaktifkan printer, lalu pasang keranjang atau finisher yang benar. 61 Lepas disk yang rusak. Ganti drive penyimpanan yang rusak. 62 Disk penuh. Coba satu atau dua cara berikut: Pilih  Continue (Lanjutkan)  untuk membersihkan pesan dan melanjutkan mencetak. Hapus font, makro, dan data lain yang tersimpan di drive. Pasang drive penyimpanan. 63 Format disk tersebut. Format akan menghapus semua informasi dari drive penyimpanan. Untuk memformat disk, lakukan hal-hal berikut: Dari panel kontrol, buka  Settings (Setelan) Device (Perangkat) Maintenance (Perawatan) Out of Service Erase (Penghapusan di Luar Layanan) . Pilih  Sanitize all information on hard disk (Hapus semua informasi di hard disk) , lalu pilih  ERASE (HAPUS) . 71.01 Nama Terminal Faks tidak disiapkan. Hubungi administrator sistem. Untuk informasi lebih lanjut, lihat  . 71.02 Nomor Terminal Faks tidak disiapkan. Hubungi administrator sistem. 71.03 Tidak ada sambungan telepon analog ke modem, faks dinonaktifkan. Periksa koneksi dan sambungan sinyal. Untuk informasi lebih lanjut, lihat  . 71.04 Telepon analog tersambung ke port yang salah. Cabut sambungan telepon, lalu sambungkan ke port LINE. 71.06 Tidak dapat tersambung ke Server Faks HTTPS. Koneksi ke Server Faks HTTPS terputus. Periksa koneksi internet printer. 71.07 Printer tidak terdaftar di Server Faks HTTPS. Pastikan printer telah ditambah ke daftar perangkat portal Server Faks HTTPS. Hubungi administrator sistem. 71.11 Partisi faks. Partisi faks tidak berfungsi. Hubungi administrator sistem. 71.12 Memori penuh, tidak dapat mencetak faks. Pilih  Print All (Cetak Semua)  untuk mencetak sebanyak mungkin faks yang tersimpan. 71.13 Memori penuh. Tidak dapat mengirim faks. Lakukan salah satu di bawah ini: Lanjutkan dan coba kirim faks sekali lagi. Pindai dokumen asli satu halaman saat itu juga, hubungi nomor faks dan kirim dokumen tersebut melalui faks. 71.4 Waktu di printer tidak benar. Atur waktu printer. Dari panel kontrol, buka  Settings (Setelan) Device (Perangkat) Preferences (Preferensi) Date and Time (Tanggal dan Waktu) Configure (Atur) . 72.01 Server email SMTP belum disiapkan. Hubungi administrator sistem. Lakukan salah satu di bawah ini: Siapkan fungsi email. Untuk informasi lebih lanjut, lihat  . Nonaktifkan pesan eror. Untuk informasi lebih lanjut, lihat  . 72.02 Server web link belum disiapkan. Hubungi administrator sistem. Hubungi administrator sistem Anda. 72.04 Server faks To Format belum disiapkan. Hubungi administrator sistem. Lakukan salah satu di bawah ini: Atur  To Format . Dari panel kontrol, buka  Settings (Setelan) Fax (Faks) Fax Server Setup (Penyiapan Server Faks) General Fax Settings (Setelan Faks Umum) . Hubungi administrator sistem Anda. 75.01 Secure Element terdeteksi. Lakukan salah satu langkah berikut: Gunakan Secure Element yang diinstal. Printer menghapus semua sertifikat yang ada, dan bisa juga menghapus serta memformat ulang drive penyimpanan. Nonaktifkan printer, lalu lepas Secure Element. 75.02 Secure Element tidak dikenali. 75.03 Kesalahan komunikasi dengan Secure Element. Lakukan salah satu langkah berikut: Hentikan pemakaian Secure Element. Printer menghapus semua sertifikat yang ada, dan bisa juga menghapus serta memformat ulang drive penyimpanan. Nonaktifkan printer, lepas, lalu instal Secure Element. 75.11 Pembaruan Secure Element gagal. Lakukan salah satu langkah berikut: Coba perbarui sekali lagi. Batalkan pembaruan. Printer menghapus semua sertifikat yang ada berikut seluruh isi drive penyimpanan. 75.12 Pembaruan Secure Element tidak selesai. Lakukan salah satu langkah berikut: Mulai ulang printer. Tunggu selama 10 detik hingga pembaruan selesai. Batalkan pembaruan. Printer menghapus semua sertifikat yang ada berikut seluruh isi drive penyimpanan. 80.01, 80.09 Kit perawatan hampir habis. Pilih  Continue (Lanjutkan)  untuk membersihkan pesan. 80.11, 80.19 Kit perawatan tinggal sedikit. 80.21, 80.29 Kit perawatan sangat sedikit. 80.31 Ganti kit perawatan untuk melanjutkan mencetak. Untuk informasi lebih lanjut, lihat  . 80.31 Ganti kit perawatan, masa pakai yang disarankan terlampaui. 81.11 Kit penarik baki 1500 lembar tinggal sedikit. Pilih  Continue (Lanjutkan)  untuk membersihkan pesan. 81.31 Ganti kit penarik baki 1500 lembar, masa pakai yang disarankan terlampaui . Untuk informasi lebih lanjut, hubungi  dukungan pelanggan . 82.00, 82.02, 82.09 Botol limbah toner hampir penuh. Untuk informasi lebih lanjut, lihat  . 82.3, 82.32, 82.33, 82.39 Ganti botol limbah toner. 83.1y Modul transfer tinggal sedikit. Pilih  Continue (Lanjutkan)  untuk membersihkan pesan. 83.3y Ganti modul transfer, masa pakai yang disarankan terlampaui. Untuk informasi lebih lanjut, hubungi  dukungan pelanggan . 83.4y Ganti modul transfer. 83.20 Kartrid pokok tinggal sedikit. Pilih  Continue (Lanjutkan)  untuk membersihkan pesan. 83.20 Staple S2 bagian dalam tinggal sedikit. 83.20 Staple S2 bagian luar tinggal sedikit. 83.30 Kartrid pokok kosong atau tidak ada. Lakukan salah satu di bawah ini: Lepas, lalu masukkan kartrid pokok. Ganti kartrid pokok. Untuk informasi lebih lanjut, lihat   atau  . 83.30 Kartrid pokok S1 bagian dalam kosong atau tidak ada. Lakukan salah satu di bawah ini: Lepas, lalu masukkan kartrid pokok. Ganti kartrid pokok. Untuk informasi lebih lanjut, lihat  . 83.30 Kartrid pokok S2 bagian dalam tidak ada atau kosong. Lakukan salah satu di bawah ini: Lepas, lalu masukkan kartrid pokok. Ganti kartrid pokok. Untuk informasi lebih lanjut, lihat  . 83.30 Kartrid pokok S2 bagian luar tidak ada atau kosong. 84.01K, 84.03K, 84.09K Unit pencitraan hitam hampir habis. Pilih  Continue (Lanjutkan)  untuk membersihkan pesan. 84.11K, 84.13K, 84.19K Unit pencitraan hitam tinggal sedikit. 84.21C, 84.03C, 84.09C Unit pencitraan hitam sangat sedikit. 84.01C, 84.03C, 84.09C Kit pencitraan warna mendekati sedikit. 84.11C, 84.13C, 84.19C Kit pencitraan warna tinggal sedikit. 84.21C, 84.23C, 84.29C Kit pencitraan warna sangat sedikit. 84.31, 84.33 Ganti unit pencitraan hitam, masa pakai yang disarankan terlampaui. Untuk informasi lebih lanjut, lihat  . 84.31, 84.33 Ganti kit pencitraan warna, masa pakai yang disarankan terlampaui. Untuk informasi lebih lanjut, lihat  . 84.41, 84.43, 84.48 Ganti unit pencitraan hitam untuk melanjutkan mencetak. Untuk informasi lebih lanjut, lihat  . 84.41, 84.43, 84.48 Ganti kit pencitraan warna untuk melanjutkan mencetak. Untuk informasi lebih lanjut, lihat  . 86.23 Perawatan pemindai diperlukan dengan segera. Pilih  Continue (Lanjutkan)  untuk membersihkan pesan. 86.33 Ganti kit ADF, masa pakai yang disarankan terlampaui. Untuk informasi lebih lanjut, hubungi  dukungan pelanggan . 88.00[x], 88.07[x], 88.08[x], 88.09[x] Kartrid toner [warna] mendekati sedikit. Pilih  Continue (Lanjutkan)  untuk membersihkan pesan. 88.10[x], 88.17[x], 88.18[x], 88.19[x] Kartrid toner [warna] tinggal sedikit. 88.20[x], 88.27[x], 88.28[x], 88.29[x] Kartrid toner [warna] sangat sedikit. 88.30[x], 88.37[x], 88.38[x] Ganti kartrid toner [warna], perkiraan sisa halaman <NUM/>. Untuk informasi lebih lanjut, lihat  . 88.30[x], 88.37[x], 88.38[x] Ganti kartrid toner [warna]. 88.40[x], 88.47[x], 88.48[x] Ganti kartrid toner [warna], sisa halaman 0. 88.40[x], 88.47[x], 88.48[x] Ganti kartrid toner [warna]. 200.03, 200.05, 200.12, 200.13, 200.14, 200.15, 200.22, 200.23, 200.24, 200.25, 200.26, 200.32, 200.33, 200.34, 200.35, 200.36, 200.42, 200.43, 200.44, 200.45, 200.46, 200.52, 200.53, 200.54, 200.55, 200.56, 200.91, 201.91, 202.02, 202.03, 202.04, 202.05, 202.12, 202.13, 202.14, 202.15, 202.22, 202.23, 202.24, 202.25, 202.32, 202.33, 202.34, 202.35, 202.42, 202.43, 202.44, 202.45, 202.52, 202.53, 202.54, 202.55, 202.91, 202.93, 202.95, 231.03, 231.05, 231.13, 231.15, 231.23, 231.25, 231.33, 231.35, 231.43, 231.45, 231.53, 231.55, 231.91, 232.03, 232.05, 232.13, 232.15, 232.23, 232.25, 232.33, 232.35, 232.43, 232.45, 232.53, 232.55, 232.93, 232.94, 232.95, 240.05, 240.25, 240.35, 240.45, 240.55, 240.91, 240.95, 241.12, 241.14, 241.15, 241.91 Kertas macet di [LOCATION/]. Untuk informasi lebih lanjut, lihat  . 240.06 Kertas macet di [LOCATION/]. Untuk informasi lebih lanjut, lihat  . 241.16, 241.82, 241.83, 241.84, 661.13, 661.84 Kesalahan memasukkan kertas di [LOCATION/]. Buka baki 1. Lepas, lalu sesuaikan kembali tumpukan kertas. Jika perlu, sesuaikan pembatas kertas. Isi ulang baki 1. Tutup baki 1. 242.23, 242.25, 242.35, 242.45, 242.55, 242.91 Kertas macet di [LOCATION/]. Untuk informasi lebih lanjut, lihat  . 242.33, 242.43, 243.33, 243.35, 243.36, 243.43, 243.35, 243.45, 243.45, 243.55, 243.91, 244.43, 244.45, 244.91 Kertas macet di [LOCATION/]. Untuk informasi lebih lanjut, lihat: 243.43, 243.53, 244.43, 244.45, 244.46, 244.91, 245.53, 245.56, 245.55, 245.91, 602.59, 664.43, 665.53 Kertas macet di [LOCATION/]. Untuk informasi lebih lanjut, lihat  . 28X.13K, 28X.93K, 28X.15K, 28X.95K, 281.16K, 281.96K, 680.20K, 680.40K Ganti semua dokumen asli ketika memulai kembali pekerjaan. Lakukan salah satu di bawah ini: Mulai ulang pekerjaan. Batalkan pekerjaan. 28X.13Q, 28X.93Q, 28X.15Q, 28X.95Q, 281.16Q, 281.96Q, 680.20Q Ganti dokumen asli yang macet ketika melanjutkan pekerjaan. Lakukan salah satu di bawah ini: Pindai dari kaca pemindai. Pindai dari pengumpan dokumen otomatis. Selesaikan pekerjaan tanpa memindai lebih lanjut. Batalkan pekerjaan. 280.06 Masukkan kembali dokumen asli ke dalam ADF dan mulai kembali pekerjaan. 280.06, 280.11, 280.13, 280.15, 280.91, 280.93, 280.95, 281.11, 281.15, 281.16, 281.91, 281.95, 281.96, 282.11, 282.13, 282.15, 282.91, 282.93, 282.95, 283.11, 283.13, 283.91, 283.15, 283.93, 284.11, 284.13, 284.15, 284.91, 284.93, 284.95, 295.01 Pemindai macet. Untuk informasi lebih lanjut, lihat  . 291.06 Tutup pintu alas datar dan masukkan dokumen asli saat memulai kembali pekerjaan. Lakukan salah satu di bawah ini: Pindai dari kaca pemindai. Pindai dari pengumpan dokumen otomatis. Selesaikan pekerjaan tanpa memindai lebih lanjut. Batalkan pekerjaan. 400.11, 400.13, 400.15, 401.11, 401.13, 401.15, 404.19, 438.11, 438.21, 444.66, 450.21, 450.23, 450.25, 450.98, 450.99, 451.21, 451.23, 451.25, 452.66, 453.21, 453.23, 454.21, 454.23, 454.25, 457.21, 457.23, 457.25, 460.66, 461.66, 464.66, 465.66, 466.66, 467.66, 468.66, 469.66, 472.66, 477.66, 480.66, 483.66, 486.29, 504.11, 504.15, 505.11, 505.15, 514.19, 698.29 Kertas macet di [LOCATION/]. Untuk informasi lebih lanjut, lihat  . 400.11, 400.13, 400.15, 401.11, 401.13, 401.15, 404.19, 438.11, 438.21, 442.66, 444.66, 445.66, 450.21, 450.23, 450.25, 451.21, 451.23, 451.25, 451.98, 451.99, 452.66, 453.21, 453.23, 453.25, 454.21, 454.23, 454.25, 457.21, 457.23, 457.25, 459.66, 460.66, 461.66, 462.66, 463.66, 464.66, 465.66, 466.66, 467.66, 468.66, 469.66, 470.66, 472.66, 473.66, 476.66, 477.66, 480.66, 483.66, 486.29, 490.66, 491.21, 491.25, 491.66, 493.21, 494.21, 492.66, 494.66, 495.66, 496.66, 497.66, 504.11, 504.15, 505.11, 505.15, 514.19, 698.29 Kertas macet di [LOCATION/]. Untuk informasi lebih lanjut, lihat  . 420.11, 420.13, 420.15, 420.99, 421.56, 422.56, 423.56, 424.56, 425.13, 425.15, 425.11, 426.11, 426.15, 428.56A, 428.56B, 431.56, 435.56, 438.11, 439.19, 461.56, 698.19 Kertas macet di [LOCATION/]. Untuk informasi lebih lanjut, lihat  . 438.11, 500.11, 500.13, 500.15, 500.99, 502.11, 502.13, 502.15, 504.11, 504.13, 504.15, 505.13, 506.11, 506.13, 506.15, 507.11, 507.13, 507.15, 508.56, 509.56, 510.56, 511.56, 512.56, 513.56, 514.19, 698.19, 698.29 Kertas macet di [LOCATION/]. Untuk informasi lebih lanjut, lihat  . 602.29, 662.23 Kesalahan memasukkan kertas di baki 2. Untuk informasi lebih lanjut, lihat  . 602.39, 663.33 Kesalahan memasukkan kertas di baki 3. Untuk informasi lebih lanjut, lihat: 602.49, 664.43 Kesalahan memasukkan kertas di baki 4. Untuk informasi lebih lanjut, lihat  . kode eror printer kode eror pesan printer pesan eror"},{"UUID":"b84a1765-7e2a-4385-a20f-380fc94d0da7","title":"Kualitas cetak rendah","link":"solving-printing-problems.html","desc":"Halaman putih atau kosong Sebelum","descFull":"Halaman putih atau kosong Sebelum menyelesaikan masalah tersebut, cetak Halaman Percobaan Kualitas Cetak. Dari panel kontrol, buka  Settings (Setelan) Troubleshooting (Pemecahan Masalah) Print Quality Test Pages (Cetak Halaman Percobaan Kualitas) . Gunakan baki 1 untuk mencetak halaman sampel dan pastikan bahwa kertas sudah dimasukkan dengan orientasi potret. Coba satu atau dua cara berikut: Pastikan semua bahan kemasan sudah dilepas dari kit pencitraan, unit pencitraan, dan kartrid toner. Periksa apakah printer masih memakai kartrid toner Lexmark yang asli dan didukung. Periksa apakah printer masih memakai kartrid toner yang asli dan didukung. Jika kartrid tidak didukung, pasang kartrid yang didukung. Pastikan kit pencitraan dan unit pencitraan hitam telah dipasang dengan benar. Lepas kit pencitraan, lalu lepas unit pencitraan hitam. Jangan sampai kit pencitraan dan unit pencitraan hitam terpapar cahaya secara langsung selama lebih dari 10 menit. Kualitas cetak akan menurun jika lama terpapar cahaya. Jangan menyentuh membran fotokonduktor di bawah kit pencitraan dan unit pencitraan hitam. Tindakan tersebut bisa memengaruhi kualitas pekerjaan cetak di masa mendatang. Masukkan unit pencitraan hitam, lalu masukkan kit pencitraan. Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah kualitas cetak halaman putih masalah kualitas cetak halaman kosong halaman kosong halaman putih"},{"UUID":"8cc96e14-7c48-4542-8fbf-8aab01f6c1f5","title":"Kualitas cetak rendah","link":"solving-printing-problems.html","desc":"Hasil cetak gelap Sebelum menyelesaikan","descFull":"Hasil cetak gelap Sebelum menyelesaikan masalah tersebut, cetak Halaman Percobaan Kualitas Cetak. Dari panel kontrol, buka  Settings (Setelan) Troubleshooting (Pemecahan Masalah) Print Quality Test Pages (Cetak Halaman Percobaan Kualitas) . Gunakan baki 1 untuk mencetak halaman sampel dan pastikan bahwa kertas sudah dimasukkan dengan orientasi potret. Coba satu atau dua cara berikut: Dari panel kontrol, buka  Settings (Setelan) Print (Cetak) Quality (Kualitas) Advanced Imaging (Pencitraan Lanjutan) , lalu pilih  Color Adjust (Penyesuaian Warna) . Tergantung sistem operasi Anda, kurangi kegelapan toner dari Printing Preferences (Preferensi Cetak) atau Print dialog (dialog Cetak). Anda juga bisa mengubah setelan pada panel kontrol printer. Buka  Settings (Setelan) Print (Cetak) Quality (Kualitas) Toner Darkness (Kegelapan Toner) . Tergantung sistem operasi Anda, tentukan jenis kertas dari Printing Preferences (Preferensi Mencetak) atau Print Dialog (Dialog Cetak). Pastikan setelan sesuai dengan kertas yang dimasukkan ke baki. Anda juga bisa mengubah setelan pada panel kontrol printer. Buka  Settings (Setelan) Paper (Kertas) Tray Configuration (Konfigurasi Baki) Paper Size/Type (Ukuran/Jenis Kertas) . Pastikan kertas tidak memiliki tekstur atau permukaan yang kasar. Masukkan kertas dari kemasan baru. Kertas menyerap minyak karena tingkat kelembapan yang tinggi. Simpan kertas di wadah aslinya sampai Anda benar-benar akan menggunakannya. Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah kualitas cetak hasil cetak gelap hasil cetak gelap"},{"UUID":"6ce7619e-9426-426f-813c-9c03927e3f69","title":"Kualitas cetak rendah","link":"solving-printing-problems.html","desc":"Gambar hantu Sebelum menyelesaikan masalah","descFull":"Gambar hantu Sebelum menyelesaikan masalah tersebut, cetak Halaman Percobaan Kualitas Cetak. Dari panel kontrol, buka  Settings (Setelan) Troubleshooting (Pemecahan Masalah) Print Quality Test Pages (Cetak Halaman Percobaan Kualitas) . Gunakan baki 1 untuk mencetak halaman sampel dan pastikan bahwa kertas sudah dimasukkan dengan orientasi potret. Coba satu atau dua cara berikut: Masukkan baki dengan berat dan jenis kertas yang benar. Tergantung sistem operasi Anda, tentukan jenis kertas dari Printing Preferences (Preferensi Mencetak) atau Print Dialog (Dialog Cetak). Pastikan setelan sesuai dengan kertas yang dimasukkan ke baki. Anda juga bisa mengubah setelan pada panel kontrol printer. Buka  Settings (Setelan) Paper (Kertas) Tray Configuration (Konfigurasi Baki) Paper Size/Type (Ukuran/Jenis Kertas) . Dari panel kontrol, buka  Settings (Setelan) Print (Cetak) Quality (Kualitas) Advanced Imaging (Pencitraan Lanjutan) , lalu pilih  Color Adjust (Penyesuaian Warna) . Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah kualitas cetak gambar hantu gambar hantu"},{"UUID":"ade8ff38-2ec1-421f-9515-77082a103347","title":"Kualitas cetak rendah","link":"solving-printing-problems.html","desc":"Latar warna atau abu-abu Sebelum","descFull":"Latar warna atau abu-abu Sebelum menyelesaikan masalah tersebut, cetak Halaman Percobaan Kualitas Cetak. Dari panel kontrol, buka  Settings (Setelan) Troubleshooting (Pemecahan Masalah) Print Quality Test Pages (Cetak Halaman Percobaan Kualitas) . Gunakan baki 1 untuk mencetak halaman sampel dan pastikan bahwa kertas sudah dimasukkan dengan orientasi potret. Coba satu atau dua cara berikut: Tergantung sistem operasi Anda, naikkan kegelapan toner dari Printing Preferences (Preferensi Cetak) atau Print dialog (Dialog Cetak). Anda juga bisa mengubah setelan pada panel kontrol printer. Buka  Settings (Setelan) Print (Cetak) Quality (Kualitas) Toner Darkness (Kegelapan Toner) . Dari panel kontrol, buka  Settings (Setelan) Print (Cetak) Quality (Kualitas) Advanced Imaging (Pencitraan Lanjutan) , lalu pilih  Color Adjust (Penyesuaian Warna) . Pastikan kit pencitraan dan unit pencitraan hitam telah dipasang dengan benar. Lepas kit pencitraan, lalu lepas unit pencitraan hitam. Jangan sampai kit pencitraan dan unit pencitraan hitam terpapar cahaya secara langsung selama lebih dari 10 menit. Kualitas cetak akan menurun jika lama terpapar cahaya. Jangan menyentuh membran fotokonduktor di bawah kit pencitraan dan unit pencitraan hitam. Tindakan tersebut bisa memengaruhi kualitas pekerjaan cetak di masa mendatang. Masukkan unit pencitraan hitam, lalu masukkan kit pencitraan. Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah kualitas cetak latar warna atau abu-abu latar abu-abu pada hasil cetak latar belakang berwarna pada hasil cetak"},{"UUID":"5e23f827-9358-4ba6-93c0-5bdfb32725b3","title":"Kualitas cetak rendah","link":"solving-printing-problems.html","desc":"Margin tidak benar Coba satu","descFull":"Margin tidak benar Coba satu atau dua cara berikut: Sesuaikan pembatas kertas pada baki ke posisi yang benar untuk kertas yang dimasukkan. Tergantung sistem operasi Anda, tentukan ukuran kertas dari Printing Preferences (Preferensi Mencetak) atau Print Dialog (Dialog Cetak). Pastikan setelan sesuai dengan kertas yang dimasukkan. Anda juga bisa mengubah setelan pada panel kontrol printer. Buka  Settings (Setelan) Paper (Kertas) Tray Configuration (Konfigurasi Baki) Paper Size/Type (Ukuran/Jenis Kertas) . Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah kualitas cetak margin tidak benar margin tidak benar"},{"UUID":"0de1be27-fb19-494d-9aa8-3992bd018f32","title":"Kualitas cetak rendah","link":"solving-printing-problems.html","desc":"Hasil cetak tipis Sebelum menyelesaikan","descFull":"Hasil cetak tipis Sebelum menyelesaikan masalah tersebut, cetak Halaman Percobaan Kualitas Cetak. Dari panel kontrol, buka  Settings (Setelan) Troubleshooting (Pemecahan Masalah) Print Quality Test Pages (Cetak Halaman Percobaan Kualitas) . Gunakan baki 1 untuk mencetak halaman sampel dan pastikan bahwa kertas sudah dimasukkan dengan orientasi potret. Coba satu atau dua cara berikut: Pastikan semua bahan kemasan sudah dilepas dari kit pencitraan, unit pencitraan, dan kartrid toner. Dari panel kontrol, buka  Settings (Setelan) Print (Cetak) Quality (Kualitas) Advanced Imaging (Pencitraan Lanjutan) , lalu pilih  Color Adjust (Penyesuaian Warna) . Tergantung sistem operasi Anda, naikkan kegelapan toner dari Printing Preferences (Preferensi Cetak) atau Print dialog (Dialog Cetak). Anda juga bisa mengubah setelan pada panel kontrol printer. Buka  Settings (Setelan) Print (Cetak) Quality (Kualitas) Toner Darkness (Kegelapan Toner) . Dari panel kontrol, buka  Settings (Setelan) Print (Cetak) Quality (Kualitas) , lalu nonaktifkan  Color Saver (Penyimpan Warna) . Tergantung sistem operasi Anda, tentukan jenis kertas dari Printing Preferences (Preferensi Mencetak) atau Print Dialog (Dialog Cetak). Pastikan setelan sesuai dengan kertas yang dimasukkan. Anda juga bisa mengubah setelan pada panel kontrol printer. Buka  Settings (Setelan) Paper (Kertas) Tray Configuration (Konfigurasi Baki) Paper Size/Type (Ukuran/Jenis Kertas) . Pastikan kertas tidak memiliki tekstur atau permukaan yang kasar. Masukkan kertas dari kemasan baru. Kertas menyerap minyak karena tingkat kelembapan yang tinggi. Simpan kertas di wadah aslinya sampai Anda benar-benar akan menggunakannya. Pastikan kit pencitraan dan unit pencitraan hitam telah dipasang dengan benar. Lepas kit pencitraan, lalu lepas unit pencitraan hitam. Jangan sampai kit pencitraan dan unit pencitraan hitam terpapar cahaya secara langsung selama lebih dari 10 menit. Kualitas cetak akan menurun jika lama terpapar cahaya. Jangan menyentuh membran fotokonduktor di bawah kit pencitraan dan unit pencitraan hitam. Tindakan tersebut bisa memengaruhi kualitas pekerjaan cetak di masa mendatang. Masukkan unit pencitraan hitam, lalu masukkan kit pencitraan. Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah kualitas cetak hasil cetak tipis hasil cetak tipis"},{"UUID":"e7f89e53-f2a5-4cba-a81b-604a4e5c6264","title":"Kualitas cetak rendah","link":"solving-printing-problems.html","desc":"Warna hilang Sebelum menyelesaikan masalah","descFull":"Warna hilang Sebelum menyelesaikan masalah tersebut, cetak Halaman Percobaan Kualitas Cetak. Dari panel kontrol, buka  Settings (Setelan) Troubleshooting (Pemecahan Masalah) Print Quality Test Pages (Cetak Halaman Percobaan Kualitas) . Gunakan baki 1 untuk mencetak halaman sampel dan pastikan bahwa kertas sudah dimasukkan dengan orientasi potret. Coba satu atau dua cara berikut: Pastikan semua bahan kemasan sudah dilepas dari kit pencitraan, unit pencitraan, dan kartrid toner. Lepas unit pengembang dari warna yang hilang. Lepas kit pencitraan. Jangan sampai kit pencitraan dan unit pencitraan hitam terpapar cahaya secara langsung selama lebih dari 10 menit. Kualitas cetak akan menurun jika lama terpapar cahaya. Jangan menyentuh membran fotokonduktor di bawah kit pencitraan dan unit pencitraan hitam. Tindakan tersebut bisa memengaruhi kualitas pekerjaan cetak di masa mendatang. Lepas, lalu masukkan unit pengembang dari warna yang hilang. Masukkan kit pencitraan. Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah kualitas cetak warna hilang warna hilang"},{"UUID":"6518f68d-22fa-4da0-97ca-a7f9a1dbc3f0","title":"Kualitas cetak rendah","link":"solving-printing-problems.html","desc":"Hasil cetak bintik-bintik Hasil cetak","descFull":"Hasil cetak bintik-bintik Hasil cetak bintik-bintik Sebelum menyelesaikan masalah tersebut, cetak Halaman Percobaan Kualitas Cetak. Dari panel kontrol, buka  Settings (Setelan) Troubleshooting (Pemecahan Masalah) Print Quality Test Pages (Cetak Halaman Percobaan Kualitas) . Gunakan baki 1 untuk mencetak halaman sampel dan pastikan bahwa kertas sudah dimasukkan dengan orientasi potret. Coba satu atau dua cara berikut: Periksa apakah terdapat kebocoran toner. Pastikan setelan ukuran dan jenis kertas sesuai dengan kertas yang dimasukkan. Dari panel kontrol, buka  Settings (Setelan) Paper (Kertas) Tray Configuration (Konfigurasi Baki) Paper Size/Type (Ukuran/Jenis Kertas) . Pastikan kertas tidak memiliki tekstur atau permukaan yang kasar. Tergantung sistem operasi Anda, tentukan jenis dan ukuran kertas dari Printing Preferences (Preferensi Mencetak) atau Print Dialog (Dialog Cetak). Pastikan setelan sesuai dengan kertas yang dimasukkan ke baki. Masukkan kertas dari kemasan baru. Kertas menyerap minyak karena tingkat kelembapan yang tinggi. Simpan kertas di wadah aslinya sampai Anda benar-benar akan menggunakannya. Pastikan kit pencitraan dan unit pencitraan hitam telah dipasang dengan benar. Lepas kit pencitraan, lalu lepas unit pencitraan hitam. Jangan sampai kit pencitraan dan unit pencitraan hitam terpapar cahaya secara langsung selama lebih dari 10 menit. Kualitas cetak akan menurun jika lama terpapar cahaya. Jangan menyentuh membran fotokonduktor di bawah kit pencitraan dan unit pencitraan hitam. Tindakan tersebut bisa memengaruhi kualitas pekerjaan cetak di masa mendatang. Masukkan unit pencitraan hitam, lalu masukkan kit pencitraan. Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah kualitas cetak hasil cetak bintik-bintik hasil cetak bintik-bintik bercak pada halaman cetak"},{"UUID":"23a56dbb-00fe-4312-a88c-78c2379e0011","title":"Kualitas cetak rendah","link":"solving-printing-problems.html","desc":"Hasil cetak bengkok atau miring","descFull":"Hasil cetak bengkok atau miring Sebelum menyelesaikan masalah tersebut, cetak Halaman Percobaan Kualitas Cetak. Dari panel kontrol, buka  Settings (Setelan) Troubleshooting (Pemecahan Masalah) Print Quality Test Pages (Cetak Halaman Percobaan Kualitas) . Gunakan baki 1 untuk mencetak halaman sampel dan pastikan bahwa kertas sudah dimasukkan dengan orientasi potret. Coba satu atau dua cara berikut: Masukkan kertas dari kemasan baru. Buka baki, lalu keluarkan kertas tersebut. Masukkan kertas dari kemasan baru. Kertas menyerap minyak karena tingkat kelembapan yang tinggi. Simpan kertas di wadah aslinya sampai Anda benar-benar akan menggunakannya. Sesuaikan pembatas kertas pada baki ke posisi yang benar untuk kertas yang dimasukkan. Pastikan Anda mencetak pada kertas yang didukung. Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah kualitas cetak hasil cetak miring masalah kualitas cetak hasil cetak bengkok hasil cetak bengkok hasil cetak miring"},{"UUID":"0edc6362-a5ac-49be-87cd-cfad8bc7141b","title":"Kualitas cetak rendah","link":"solving-printing-problems.html","desc":"Seluruh halaman terblok warna atau","descFull":"Seluruh halaman terblok warna atau hitam Sebelum menyelesaikan masalah tersebut, cetak Halaman Percobaan Kualitas Cetak. Dari panel kontrol, buka  Settings (Setelan) Troubleshooting (Pemecahan Masalah) Print Quality Test Pages (Cetak Halaman Percobaan Kualitas) . Gunakan baki 1 untuk mencetak halaman sampel dan pastikan bahwa kertas sudah dimasukkan dengan orientasi potret. Lepas kit pencitraan, lalu lepas unit pencitraan hitam. Jangan sampai kit pencitraan dan unit pencitraan hitam terpapar cahaya secara langsung selama lebih dari 10 menit. Kualitas cetak akan menurun jika lama terpapar cahaya. Jangan menyentuh membran fotokonduktor di bawah kit pencitraan dan unit pencitraan hitam. Tindakan tersebut bisa memengaruhi kualitas pekerjaan cetak di masa mendatang. Masukkan unit pencitraan hitam, lalu masukkan kit pencitraan. Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah kualitas cetak seluruh halaman terblok warna atau hitam warna pekat gambar hitam"},{"UUID":"be662ad2-047b-4cfe-b476-ddc25cbe2865","title":"Kualitas cetak rendah","link":"solving-printing-problems.html","desc":"Gambar atau teks terpotong Sebelum","descFull":"Gambar atau teks terpotong Sebelum menyelesaikan masalah tersebut, cetak Halaman Percobaan Kualitas Cetak. Dari panel kontrol, buka  Settings (Setelan) Troubleshooting (Pemecahan Masalah) Print Quality Test Pages (Cetak Halaman Percobaan Kualitas) . Gunakan baki 1 untuk mencetak halaman sampel dan pastikan bahwa kertas sudah dimasukkan dengan orientasi potret. Coba satu atau dua cara berikut: Pastikan semua bahan kemasan sudah dilepas dari kit pencitraan, unit pencitraan, dan kartrid toner. Sesuaikan pembatas kertas pada baki ke posisi yang benar untuk kertas yang dimasukkan. Tergantung sistem operasi Anda, tentukan ukuran kertas dari Printing Preferences (Preferensi Mencetak) atau Print Dialog (Dialog Cetak). Pastikan setelan sesuai dengan kertas yang dimasukkan ke baki. Anda juga bisa mengubah setelan pada panel kontrol printer. Buka  Settings (Setelan) Paper (Kertas) Tray Configuration (Konfigurasi Baki) Paper Size/Type (Ukuran/Jenis Kertas) . Pastikan kit pencitraan dan unit pencitraan hitam telah dipasang dengan benar. Lepas kit pencitraan, lalu lepas unit pencitraan hitam. Jangan sampai kit pencitraan dan unit pencitraan hitam terpapar cahaya secara langsung selama lebih dari 10 menit. Kualitas cetak akan menurun jika lama terpapar cahaya. Jangan menyentuh membran fotokonduktor di bawah kit pencitraan dan unit pencitraan hitam. Tindakan tersebut bisa memengaruhi kualitas pekerjaan cetak di masa mendatang. Masukkan unit pencitraan hitam, lalu masukkan kit pencitraan. Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah kualitas cetak gambar atau teks terpotong teks terpotong pada hasil cetak gambar terpotong pada hasil cetak"},{"UUID":"cb90f61e-eddc-44a1-85bb-4b6a8b1d67ef","title":"Kualitas cetak rendah","link":"solving-printing-problems.html","desc":"Toner menggores Sebelum menyelesaikan masalah","descFull":"Toner menggores Sebelum menyelesaikan masalah tersebut, cetak Halaman Percobaan Kualitas Cetak. Dari panel kontrol, buka  Settings (Setelan) Troubleshooting (Pemecahan Masalah) Print Quality Test Pages (Cetak Halaman Percobaan Kualitas) . Gunakan baki 1 untuk mencetak halaman sampel dan pastikan bahwa kertas sudah dimasukkan dengan orientasi potret. Lakukan salah satu di bawah ini: Pastikan kabel daya printer telah dipasang dengan benar ke stopkontak listrik yang sudah diinspeksi standar mutunya dan dihubungkan ke arde. Tergantung sistem operasi Anda, tentukan jenis kertas dari Printing Preferences (Preferensi Mencetak) atau Print Dialog (Dialog Cetak). Pastikan setelan sesuai dengan kertas yang dimasukkan. Atur jenis kertas dari panel kontrol. Buka  Settings (Setelan) Paper (Kertas) Tray Configuration (Konfigurasi Baki) Paper Size/Type (Ukuran/Jenis Kertas) . Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah kualitas cetak toner menggores toner menggores"},{"UUID":"2502b2c4-e5a4-4a2d-9670-06b8d9662f1c","title":"Kualitas cetak rendah","link":"solving-printing-problems.html","desc":"Kerapatan cetak tidak sama Sebelum","descFull":"Kerapatan cetak tidak sama Sebelum menyelesaikan masalah tersebut, cetak Halaman Percobaan Kualitas Cetak. Dari panel kontrol, buka  Settings (Setelan) Troubleshooting (Pemecahan Masalah) Print Quality Test Pages (Cetak Halaman Percobaan Kualitas) . Gunakan baki 1 untuk mencetak halaman sampel dan pastikan bahwa kertas sudah dimasukkan dengan orientasi potret. Coba satu atau dua cara berikut: Buka pintu B, lalu pastikan roller penarik kedua telah dikunci pada tempatnya. Pastikan kit pencitraan dan unit pencitraan hitam telah dipasang dengan benar. Lepas kit pencitraan, lalu lepas unit pencitraan hitam. Jangan sampai kit pencitraan dan unit pencitraan hitam terpapar cahaya secara langsung selama lebih dari 10 menit. Kualitas cetak akan menurun jika lama terpapar cahaya. Jangan menyentuh membran fotokonduktor di bawah kit pencitraan dan unit pencitraan hitam. Tindakan tersebut bisa memengaruhi kualitas pekerjaan cetak di masa mendatang. Masukkan unit pencitraan hitam, lalu masukkan kit pencitraan. Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah kualitas cetak kerapatan cetak tidak sama kerapatan cetak tidak sama"},{"UUID":"83a0cb7b-538d-47a2-aead-771caa545811","title":"Kualitas cetak rendah","link":"solving-printing-problems.html","desc":"Garis hitam horizontal Sebelum menyelesaikan","descFull":"Garis hitam horizontal Sebelum menyelesaikan masalah tersebut, cetak Halaman Percobaan Kualitas Cetak. Dari panel kontrol, buka  Settings (Setelan) Troubleshooting (Pemecahan Masalah) Print Quality Test Pages (Cetak Halaman Percobaan Kualitas) . Gunakan baki 1 untuk mencetak halaman sampel dan pastikan bahwa kertas sudah dimasukkan dengan orientasi potret. Jika garis-garis gelap horizontal tetap muncul di hasil cetak, lihat  . Coba satu atau dua cara berikut: Tergantung sistem operasi Anda, tentukan jenis kertas dari Printing Preferences (Preferensi Mencetak) atau Print Dialog (Dialog Cetak). Pastikan setelan sesuai dengan kertas yang dimasukkan. Anda juga bisa mengubah setelan pada panel kontrol printer. Buka  Settings (Setelan) Paper (Kertas) Tray Configuration (Konfigurasi Baki) Paper Size/Type (Ukuran/Jenis Kertas) . Pastikan kertas tidak memiliki tekstur atau permukaan yang kasar. Masukkan kertas dari kemasan baru. Kertas menyerap minyak karena tingkat kelembapan yang tinggi. Simpan kertas di wadah aslinya sampai Anda benar-benar akan menggunakannya. Pastikan kit pencitraan dan unit pencitraan hitam telah dipasang dengan benar. Lepas kit pencitraan, lalu lepas unit pencitraan hitam. Jangan sampai kit pencitraan dan unit pencitraan hitam terpapar cahaya secara langsung selama lebih dari 10 menit. Kualitas cetak akan menurun jika lama terpapar cahaya. Jangan menyentuh membran fotokonduktor di bawah kit pencitraan dan unit pencitraan hitam. Tindakan tersebut bisa memengaruhi kualitas pekerjaan cetak di masa mendatang. Masukkan unit pencitraan hitam, lalu masukkan kit pencitraan. Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah kualitas cetak garis hitam horizontal garis hitam horizontal"},{"UUID":"1a2bc98c-bbda-4cd2-9ff6-e59752c92ee2","title":"Kualitas cetak rendah","link":"solving-printing-problems.html","desc":"Garis hitam vertikal Sebelum menyelesaikan","descFull":"Garis hitam vertikal Sebelum menyelesaikan masalah tersebut, cetak Halaman Percobaan Kualitas Cetak. Dari panel kontrol, buka  Settings (Setelan) Troubleshooting (Pemecahan Masalah) Print Quality Test Pages (Cetak Halaman Percobaan Kualitas) . Gunakan baki 1 untuk mencetak halaman sampel dan pastikan bahwa kertas sudah dimasukkan dengan orientasi potret. Coba satu atau dua cara berikut: Tergantung sistem operasi Anda, tentukan jenis kertas dari Printing Preferences (Preferensi Mencetak) atau Print Dialog (Dialog Cetak). Pastikan setelan sesuai dengan kertas yang dimasukkan ke baki. Anda juga bisa mengubah setelan pada panel kontrol printer. Buka  Settings (Setelan) Paper (Kertas) Tray Configuration (Konfigurasi Baki) Paper Size/Type (Ukuran/Jenis Kertas) . Pastikan kertas tidak memiliki tekstur atau permukaan yang kasar. Masukkan kertas dari kemasan baru. Kertas menyerap minyak karena tingkat kelembapan yang tinggi. Simpan kertas di wadah aslinya sampai Anda benar-benar akan menggunakannya. Pastikan kit pencitraan dan unit pencitraan hitam telah dipasang dengan benar. Lepas kit pencitraan, lalu lepas unit pencitraan hitam. Jangan sampai kit pencitraan dan unit pencitraan hitam terpapar cahaya secara langsung selama lebih dari 10 menit. Kualitas cetak akan menurun jika lama terpapar cahaya. Jangan menyentuh membran fotokonduktor di bawah kit pencitraan dan unit pencitraan hitam. Tindakan tersebut bisa memengaruhi kualitas pekerjaan cetak di masa mendatang. Masukkan unit pencitraan hitam, lalu masukkan kit pencitraan. Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah kualitas cetak garis hitam vertikal pada hasil cetak garis gelap vertikal pada hasil cetak"},{"UUID":"875e2e60-2f4b-4486-badb-fc8bd520e358","title":"Kualitas cetak rendah","link":"solving-printing-problems.html","desc":"Garis putih horizontal Sebelum menyelesaikan","descFull":"Garis putih horizontal Sebelum menyelesaikan masalah tersebut, cetak Halaman Percobaan Kualitas Cetak. Dari panel kontrol, buka  Settings (Setelan) Troubleshooting (Pemecahan Masalah) Print Quality Test Pages (Cetak Halaman Percobaan Kualitas) . Gunakan baki 1 untuk mencetak halaman sampel dan pastikan bahwa kertas sudah dimasukkan dengan orientasi potret. Jika garis-garis putih horizontal tetap muncul di hasil cetak, lihat  . Coba satu atau dua cara berikut: Tergantung sistem operasi Anda, tentukan jenis kertas dari Printing Preferences (Preferensi Mencetak) atau Print Dialog (Dialog Cetak). Pastikan setelan sesuai dengan kertas yang dimasukkan ke baki. Anda juga bisa mengubah setelan pada panel kontrol printer. Buka  Settings (Setelan) Paper (Kertas) Tray Configuration (Konfigurasi Baki) Paper Size/Type (Ukuran/Jenis Kertas) . Masukkan jenis kertas yang direkomendasikan ke sumber kertas yang telah ditentukan. Pastikan kit pencitraan dan unit pencitraan hitam telah dipasang dengan benar. Lepas kit pencitraan, lalu lepas unit pencitraan hitam. Jangan sampai fotokonduktor terpapar cahaya secara langsung. Kualitas cetak akan menurun jika lama terpapar cahaya. Jangan sentuh gendang fotokonduktor. Tindakan tersebut bisa memengaruhi kualitas pekerjaan cetak di masa mendatang. Masukkan unit pencitraan hitam, lalu masukkan kit pencitraan. Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah kualitas cetak garis putih horizontal garis putih horizontal"},{"UUID":"6aa4f338-2fe4-4aa5-981a-b3c2407184d6","title":"Kualitas cetak rendah","link":"solving-printing-problems.html","desc":"Garis putih vertikal Sebelum menyelesaikan","descFull":"Garis putih vertikal Sebelum menyelesaikan masalah tersebut, cetak Halaman Percobaan Kualitas Cetak. Dari panel kontrol, buka  Settings (Setelan) Troubleshooting (Pemecahan Masalah) Print Quality Test Pages (Cetak Halaman Percobaan Kualitas) . Gunakan baki 1 untuk mencetak halaman sampel dan pastikan bahwa kertas sudah dimasukkan dengan orientasi potret. Coba satu atau dua cara berikut: Tergantung sistem operasi Anda, tentukan jenis kertas dari Printing Preferences (Preferensi Mencetak) atau Print Dialog (Dialog Cetak). Pastikan setelan sesuai dengan kertas yang dimasukkan ke baki. Anda juga bisa mengubah setelan pada panel kontrol printer. Buka  Settings (Setelan) Paper (Kertas) Tray Configuration (Konfigurasi Baki) Paper Size/Type (Ukuran/Jenis Kertas) . Periksa apakah Anda menggunakan jenis kertas yang direkomendasikan. Pastikan Anda mengisi sumber kertas dengan jenis kertas yang disarankan. Pastikan kit pencitraan dan unit pencitraan hitam telah dipasang dengan benar. Lepas kit pencitraan, lalu lepas unit pencitraan hitam. Jangan sampai kit pencitraan dan unit pencitraan hitam terpapar cahaya secara langsung selama lebih dari 10 menit. Kualitas cetak akan menurun jika lama terpapar cahaya. Jangan menyentuh membran fotokonduktor di bawah kit pencitraan dan unit pencitraan hitam. Tindakan tersebut bisa memengaruhi kualitas pekerjaan cetak di masa mendatang. Masukkan unit pencitraan hitam, lalu masukkan kit pencitraan. Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah kualitas cetak garis putih vertikal garis putih vertikal"},{"UUID":"a5b12ce4-a76c-4374-819d-33c43d4efd7d","title":"Kualitas cetak rendah","link":"solving-printing-problems.html","desc":"Kerusakan cetak yang berulang Sebelum","descFull":"Kerusakan cetak yang berulang Sebelum menyelesaikan masalah tersebut, cetak Halaman Percobaan Kualitas Cetak. Dari panel kontrol, buka  Settings (Setelan) Troubleshooting (Pemecahan Masalah) Print Quality Test Pages (Cetak Halaman Percobaan Kualitas) . Gunakan baki 1 untuk mencetak halaman sampel dan pastikan bahwa kertas sudah dimasukkan dengan orientasi potret. Tentukan berapa warna yang mengalami cacat. Ukur jarak antar cacat yang berulang pada halaman warna yang terkena dampak. Dengan memakai Pengukur Cacat Perawatan, ukur jarak antar cacat yang berulang pada halaman warna yang terdampak. Ganti item bahan pakai atau suku cadang berdasarkan hasil pengukuran pada halaman warna yang terkena dampak. Kit pencitraan warna atau kit pencitraan hitam 94,5 mm (3,72 inci) 19,9 mm (1,18 inci) 23,2 mm (0,19 inci) Unit pengembang 43,6 mm (1,72 inci) 45,0 mm (1,77 inci) Fuser 95 mm (3,74 inci) 110 mm (4,33 inci) Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah kualitas cetak kerusakan cetak berulang kerusakan cetak berulang"},{"UUID":"3e0ec31b-0f81-4e06-9a0b-1885250fd093","title":"Masalah mencetak","link":"solving-printing-problems.html","desc":"Pekerjaan cetak tidak mencetak Coba","descFull":"Pekerjaan cetak tidak mencetak Coba satu atau dua cara berikut: Dari dokumen yang sedang Anda coba cetak, buka dialog Preferensi Cetak, lalu periksa apakah Anda telah memilih printer yang benar. Periksa apakah printer aktif, lalu selesaikan pesan eror yang muncul pada tampilan. Periksa apakah port bekerja dan apakah kabel telah tersambung dengan aman ke komputer dan printer. Untuk informasi lebih lanjut, lihat dokumen yang menyertai printer tersebut. Nonaktifkan printer, tunggu sekitar 10 detik, lalu aktifkan printer. Lepas, lalu pasang kembali driver cetak. Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah mencetak pekerjaan cetak tidak mencetak pekerjaan cetak tidak dicetak pekerjaan cetak tidak mencetak"},{"UUID":"23b0d7d8-3c01-4248-91fb-40e7825521c1","title":"Masalah mencetak","link":"solving-printing-problems.html","desc":"Dokumen rahasia dan dokumen tertunda","descFull":"Dokumen rahasia dan dokumen tertunda tidak dicetak Coba satu atau dua cara berikut: Dari panel kontrol, periksa apakah dokumen muncul di daftar  Held Jobs (Pekerjaan Tertunda) . Jika dokumen tidak terdaftar, cetak dokumen dengan opsi Print and Hold (Cetak dan Tahan). Selesaikan masalah format atau data yang tidak benar pada pekerjaan cetak. Hapus pekerjaan cetak, lalu kirim sekali lagi. Untuk file PDF, buat satu file baru, lalu cetak dokumen tersebut. Jika Anda mencetak dari internet, bisa saja printer sedang membaca sekian banyak judul pekerjaan karena terjadi duplikasi. Bagi pengguna Windows, pastikan pilih  Keep duplicate documents (Simpan dokumen duplikat)  pada dialog Printing Preferences (Preferensi Cetak). Bagi pengguna Macintosh, beri nama yang berbeda untuk masing-masing pekerjaan. Hapus pekerjaan yang tertunda guna membebaskan memori printer. Pasang memori printer yang lebih besar. Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah kualitas cetak dokumen rahasia dan dokumen tertunda tidak dicetak dokumen rahasia tidak dicetak dokumen tertunda tidak dicetak"},{"UUID":"323b8b77-b48d-4076-a134-c5ad148bb7df","title":"Masalah mencetak","link":"solving-printing-problems.html","desc":"Pekerjaan cetak dari baki atau","descFull":"Pekerjaan cetak dari baki atau kertas yang keliru Coba satu atau dua cara berikut: Pastikan Anda mencetak pada kertas yang benar. Tergantung sistem operasi Anda, tentukan jenis dan ukuran kertas dari Printing Preferences (Preferensi Mencetak) atau Print Dialog (Dialog Cetak). Pastikan setelan sesuai dengan kertas yang dimasukkan. Anda juga bisa mengubah setelan pada panel kontrol printer. Buka  Settings (Setelan) Paper (Kertas) Tray Configuration (Konfigurasi Baki) Paper Size/Type (Ukuran/Jenis Kertas) . Periksa apakah baki sudah tersambung. Untuk informasi lebih lanjut, lihat  . Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah mencetak pekerjaan cetak dari baki yang salah masalah mencetak pekerjaan cetak pada kertas yang salah pekerjaan cetak dari baki yang salah pekerjaan cetak pada kertas yang salah"},{"UUID":"9bbdc83d-f07b-4237-a95f-6d1c2f16df6d","title":"Masalah mencetak","link":"solving-printing-problems.html","desc":"Pencetakan lambat Coba satu atau","descFull":"Pencetakan lambat Coba satu atau dua cara berikut: Pasitkan kabel printer tersambung dengan aman ke printer, komputer, server cetak, opsi, dan perangkat lainnya. Pastikan bahwa printer tidak dalam  Quiet Mode (Mode Sunyi) . Dari panel kontrol, buka  Settings (Setelan) Device (Perangkat) Maintenance (Perawatan) Configuration Menu (Menu Konfigurasi) Device Operations (Operasi Perangkat) Quiet Mode (Mode Sunyi) . Menentukan resolusi dokumen yang ingin Anda cetak. Tergantung sistem operasi Anda, akses Printing Preferences (Preferensi Cetak) atau Print dialog (Dialog Cetak). Setel resolusi pada  4800 CQ . Anda juga bisa mengubah setelan pada panel kontrol. Buka  Settings (Setelan) Print (Cetak) Quality (Kualitas) Print Resolution (Resolusi Cetak) . Tergantung sistem operasi Anda, tentukan jenis kertas dari Printing Preferences (Preferensi Mencetak) atau Print Dialog (Dialog Cetak). Anda juga bisa mengubah setelan pada panel kontrol. Buka  Settings (Setelan) Paper (Kertas) Tray Configuration (Konfigurasi Baki) Paper Size/Type (Ukuran/Jenis Kertas) . Kertas berat akan dicetak lebih lambat. Kertas dengan ukuran yang lebih ramping dari letter, A4, dan legal cenderung dicetak lebih lambat. Pastikan setelan printer untuk tekstur dan berat sudah sesuai dengan kertas yang dimasukkan. Dari panel kontrol, buka  Settings (Setelan) Paper (Kertas) Media Configuration (Konfigurasi Media) Media Types (Jenis Media) . Kertas kasar bertekstur dan kertas berat cenderung dicetak lebih lama. Hapus pekerjaan yang tertunda. Pastikan bahwa printer tidak sedang kelebihan panas. Izinkan printer menurunkan suhunya setelah melakukan pekerjaan cetak yang lama. Amati temperatur ruangan yang disarankan untuk printer. Untuk informasi lebih lanjut, lihat  . Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah mencetak pencetakan lambat pencetakan lambat"},{"UUID":"133f7af5-8093-4ebb-829e-dea32293c070","title":"Menyelesaikan masalah","link":"trb-printer-not-responding-topic.html","desc":"Printer tidak merespons Coba satu","descFull":"Printer tidak merespons Coba satu atau dua cara berikut: Pastikan kabel daya telah terhubung ke stopkontak listrik. Untuk menghindari risiko kebakaran atau tersengat listrik, sambungkan kabel daya ke stopkontak listrik yang sudah diinspeksi standar mutunya dan dihubungkan ke arde di dekat produk dan mudah dijangkau. Pastikan stopkontak listrik tidak dimatikan oleh saklar atau pemutus arus. Periksa apakah printer aktif. Pastikan printer tidak berada dalam Mode Tidur atau Hibernasi. Pastikan kabel yang menghubungkan printer dan komputer tersambung ke port yang benar. Matikan printer, pasang perangkat keras pelengkap, lalu hidupkan printer. Untuk informasi lebih lanjut, lihat dokumentasi yang disertakan dengan pelengkap tersebut. Instal driver cetak yang benar. Nonaktifkan printer, tunggu sekitar 10 detik, lalu aktifkan printer. Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah mencetak printer tidak merespons printer tidak merespons"},{"UUID":"9dc7e0e3-8c3c-43b3-9d5d-99fe25070a20","title":"Menyelesaikan masalah","link":"trb-unable-to-read-flash-drive-topic.html","desc":"Tidak bisa membaca dari flash","descFull":"Tidak bisa membaca dari flash drive Coba satu atau dua cara berikut: Pastikan printer tidak sedang sibuk memproses beberapa pekerjaan. Pastikan flash drive sudah dimasukkan ke port USB depan. Flash drive tidak bekerja jika dimasukkan ke port USB belakang. Pastikan bahwa flash drive benar-benar didukung. Untuk informasi lebih lanjut, lihat  . Lepas, lalu masukkan flash drive. Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . tidak bisa membaca dari flash drive masalah mencetak tidak bisa membaca dari flash drive"},{"UUID":"f0c4d832-d372-4b47-8773-5d4fbc1e89dc","title":"Menyelesaikan masalah","link":"enabling-usb-port-topic.html","desc":"Mengaktifkan port USB Dari panel","descFull":"Mengaktifkan port USB Dari panel kontrol, buka  Settings (Setelan) Network/Ports (Jaringan/Port) USB . Pilih  Enable USB Port (Aktifkan Port USB) . Port USB mengaktifkan Mengaktifkan port USB menyiapkan port USB"},{"UUID":"3cfcd393-6cc7-43d7-a458-a780f5870cf9","title":"Mengatasi kertas macet","link":"clearing-jams.html","desc":"Menghindari kemacetan Masukkan kertas dengan","descFull":"Menghindari kemacetan Masukkan kertas dengan benar Pastikan kertas pada posisi rata pada baki. Cara memasukkan kertas yang benar dan salah Kertas dimasukkan dengan cara yang benar Kertas dimasukkan dengan cara yang salah Jangan masukkan atau melepas baki saat printer sedang mencetak. Jangan masukkan terlalu banyak kertas. Pastikan tinggi tumpukan di bawah indikator pengisian kertas maksimum. Jangan geser kertas ke dalam baki. Masukkan kertas seperti yang ditunjukkan pada gambar. Pastikan pembatas kertas diposisikan dengan benar dan tidak menekan kertas atau amplop. Dorong baki dengan kuat ke dalam printer setelah memasukkan kertas. Menggunakan kertas yang disarankan Gunakan hanya kertas yang disarankan atau media khusus. Jangan masukkan kertas yang berkerut, berkerut, lembap, bengkok, atau tertekuk-tekuk. Lenturkan, kipas, dan sejajarkan tepi kertas sebelum memuat. Jangan gunakan kertas yang telah terpotong atau disobek dengan tangan. Jangan campur ukuran, berat, atau jenis kertas di baki yang sama. Pastikan ukuran dan jenis kertas diatur dengan benar di komputer atau panel kontrol printer. Simpan kertas sesuai rekomendasi produsen. kertas macet menghindari macet, kertas menghindari menghindari kertas macet"},{"UUID":"ee069578-7170-4f18-963b-79cde68247df","title":"Mengatasi kertas macet","link":"clearing-jams.html","desc":"Mengidentifikasi lokasi kemacetan Apabila ","descFull":"Mengidentifikasi lokasi kemacetan Apabila  Bantuan Kemacetan  disetel pada posisi  Aktif , printer akan mendorong beberapa halaman kosong atau halaman dengan hasil cetak parsial setelah halaman yang macet dibersihkan. Periksa hasil cetak, apakah terdapat halaman kosong. Apabila  Pemulihan Kemacetan  disetel pada posisi  Aktif  atau  Auto , printer akan mencetak ulang halaman yang macet. Lokasi kemacetan Lokasi kemacetan 1 Pintu B 2 Feeder multiguna 3 Baki standar 4 Keranjang standar 5 Pengumpan dokumen otomatis 6 Lis stapler 7 Baki 550 lembar (opsional) 8 2 baki 550 lembar 9 Baki 1500 lembar 10 Lis lubang stapler 11 Penyalur kertas dengan opsi lipatan 12 Baki tandem 2000 lembar 13 Lis buklet kertas macet mencari lokasi kemacetan mengidentifikasi"},{"UUID":"a959ac36-d91e-4fa4-9b2e-ca7800d8e2ae","title":"Mengatasi kertas macet","link":"clearing-jams.html","desc":"Kertas macet di keranjang standar","descFull":"Kertas macet di keranjang standar Kertas macet di keranjang standar Tarik keluar baki standar. Keluarkan kertas yang macet. Pastikan semua sobekan kertas dikeluarkan. Masukkan baki. mengatasi kertas macet di baki standar mengeluarkan kertas macet di baki standar kertas macet di baki standar"},{"UUID":"779a3c4b-5a84-4213-90dc-479d68d8e4ba","title":"Mengatasi kertas macet","link":"clearing-jams.html","desc":"Kertas macet di baki 550","descFull":"Kertas macet di baki 550 lembar (opsional) Buka pintu D. Keluarkan kertas yang macet. Pastikan semua sobekan kertas dikeluarkan. Tutup pintu. Tarik keluar baki 550 lembar (opsional) Keluarkan kertas yang macet. Pastikan semua sobekan kertas dikeluarkan. Masukkan baki. mengatasi kertas macet di baki 550 lembar mengeluarkan kertas macet di baki 550 lembar kertas macet di baki 550 lembar"},{"UUID":"e213b9ad-820a-4256-bb46-8aa0bc639889","title":"Mengatasi kertas macet","link":"clearing-jams.html","desc":"Kemacetan kertas di pengumpan dokumen","descFull":"Kemacetan kertas di pengumpan dokumen otomatis Kemacetan kertas di pintu A Buka pintu A. Keluarkan kertas yang macet. Pastikan semua sobekan kertas dikeluarkan. Tutup pintu A. Kertas macet di pintu A1. Buka pintu pemindai. Tekan kait hijau untuk membuka pintu A1. Putar kenop hijau di dekat pintu A1 ke kanan, lalu keluarkan kertas yang macet. Pastikan semua sobekan kertas dikeluarkan. Tutup pintu A1, lalu tutup pintu pemindai. Kertas macet di keranjang pengumpan dokumen otomatis. Keluarkan kertas dari keranjang pengumpan dokumen otomatis. Keluarkan kertas yang macet. Pastikan semua sobekan kertas dikeluarkan. mengatasi kertas macet di pengumpan dokumen otomatis kertas macet di pengumpan dokumen otomatis mengeluarkan kertas macet di pengumpan dokumen otomatis"},{"UUID":"bb41350f-2d50-4324-8b74-76cf27a24a0c","title":"Mengatasi kertas macet","link":"clearing-jams.html","desc":"Kemacetan kertas di pengumpan serba","descFull":"Kemacetan kertas di pengumpan serba guna Keluarkan kertas dari feeder multiguna. Keluarkan kertas yang macet. Pastikan semua sobekan kertas dikeluarkan. mengatasi kertas macet di pengumpan serba guna mengeluarkan kertas macet di pengumpan serba guna kertas macet di pengumpan serba guna"},{"UUID":"4cee0992-dec2-4822-bcef-5551ffdba79e","title":"Mengatasi kertas macet","link":"clearing-jams.html","desc":"Kertas macet di baki duo","descFull":"Kertas macet di baki duo 550 lembar Buka pintu E. Keluarkan kertas macet di pintu E. Pastikan semua sobekan kertas dikeluarkan. Tutup pintu E. Tarik keluar baki 3. Keluarkan kertas yang macet. Pastikan semua sobekan kertas dikeluarkan. Masukkan baki 3. Ulangi  langkah 4  hingga  langkah 6  untuk baki 4. mengatasi kertas macet 2 baki 550 lembar mengeluarkan kertas macet 2 baki 550 lembar kertas macet 2 baki 550 lembar"},{"UUID":"894beabf-eedc-4f56-9345-1019f1a23615","title":"Mengatasi kertas macet","link":"clearing-jams.html","desc":"Kertas macet di baki tandem","descFull":"Kertas macet di baki tandem 2000 lembar Buka pintu E. Keluarkan kertas macet di pintu E. Pastikan semua sobekan kertas dikeluarkan. Tutup pintu E. mengatasi kertas macet di baki tandem 2000 lembar mengeluarkan kertas macet di baki tandem 2000 lembar kertas macet di baki 2000 lembar"},{"UUID":"7322e1f1-3a54-449d-8319-cbbe1d895559","title":"Mengatasi kertas macet","link":"clearing-jams.html","desc":"Kertas macet di baki 1500","descFull":"Kertas macet di baki 1500 lembar Buka pintu K. Keluarkan kertas yang macet. Pastikan semua sobekan kertas dikeluarkan. Tutup pintu K. Pegang gagang J, lalu geser baki ke kanan. Keluarkan kertas yang macet. Pastikan semua sobekan kertas dikeluarkan. Kembalikan baki ke tempatnya. mengatasi kertas macet di baki tandem 1500 lembar mengeluarkan kertas macet di baki tandem 1500 lembar kertas macet di baki tandem 1500 lembar"},{"UUID":"dc1cd6ee-214d-4542-861b-0f9ba1df4634","title":"Mengatasi kertas macet","link":"clearing-jams.html","desc":"Kertas macet di pintu B","descFull":"Kertas macet di pintu B Buka pintu B. Bagian dalam printer mungkin panas. Untuk mengurangi risiko cedera akibat komponen panas, biarkan permukaan berubah dingin sebelum menyentuhnya. Untuk mencegah kerusakan akibat arus elektrostatis, sentuh rangka besi printer yang terbuka sebelum mengakses atau menyentuh area interior printer. Keluarkan kertas macet di lokasi-lokasi berikut: Pastikan semua sobekan kertas dikeluarkan. Di atas fuser Di dalam fuser Di bawah fuser Di bawah roller keluar keranjang standar Di unit dupleks Tutup pintu B. kertas macet di pintu B kertas macet di fuser kertas macet di unit dupleks mengatasi kertas macet di fuser mengatasi kertas macet di unit dupleks mengeluarkan kertas macet di fuser mengeluarkan kertas macet di unit dupleks"},{"UUID":"6acaea86-5914-4fd1-ade3-7d93bcfb7fb5","title":"Mengatasi kertas macet","link":"clearing-jams.html","desc":"Kertas macet di keranjang standar","descFull":"Kertas macet di keranjang standar Keluarkan kertas dari keranjang standar Keluarkan kertas yang macet. Pastikan semua sobekan kertas dikeluarkan. mengatasi kertas macet keranjang standar s mengeluarkan kertas macet di keranjang standar kertas macet di keranjang standar"},{"UUID":"4b750459-377b-46f8-9609-b87101c44336","title":"Mengatasi kertas macet","link":"clearing-jams.html","desc":"Kertas macet di lis stapler","descFull":"Kertas macet di lis stapler Keluarkan kertas macet di keranjang lis stapler. Pastikan semua sobekan kertas dikeluarkan. Pegang gagang F, lalu geser lis stapler ke kiri. Buka pintu R1, lalu putar kenop R2 searah jarum jam. Keluarkan kertas yang macet. Pastikan semua sobekan kertas dikeluarkan. Tutup pintu R1. Keluarkan kertas macet roller keluar keranjang standar. Pastikan semua sobekan kertas dikeluarkan. Kembalikan lis stapler ke tempatnya. mengatasi kertas macet di lis stapler mengeluarkan kertas macet di lis stapler kertas macet di lis stapler"},{"UUID":"61f35519-19e3-4176-8f8d-2c8a36b0d721","title":"Mengatasi kertas macet","link":"clearing-jams.html","desc":"Kertas macet di penyalur kertas","descFull":"Kertas macet di penyalur kertas dengan opsi lipatan Keluarkan kertas yang macet. Pastikan semua sobekan kertas dikeluarkan. Buka pintu F. Angkat gagang N4. Angkat gagang N5. Keluarkan kertas yang macet. Pastikan semua sobekan kertas dikeluarkan. Tutup gagang N5, lalu tutup gagang N4. Tekan gagang N1. Putar kenop N2 berlawanan arah jarum jam. Keluarkan kertas yang macet. Supaya printer tidak rusak, lepas semua aksesori tangan sebelum mengeluarkan kertas yang macet. Pastikan semua sobekan kertas dikeluarkan. Kembalikan posisi gagang N1. Tutup pintu F. mengatasi kertas macet di penyalur kertas dengan opsi lipatan mengeluarkan kertas macet di penyalur kertas dengan opsi lipatan kertas macet di penyalur kertas dengan opsi lipatan"},{"UUID":"77a6cc8b-e84d-49f4-9425-54a02899ad4d","title":"Mengatasi kertas macet","link":"clearing-jams.html","desc":"Kertas macet pada lis lubang","descFull":"Kertas macet pada lis lubang stapler Jika printer telah diatur dengan penyalur kertas, lakukan hal-hal di bawah ini: Keluarkan kertas macet di keranjang 1. Pastikan semua sobekan kertas dikeluarkan. Jangan mengeluarkan halaman cetak yang ada di pengumpul staple agar tidak ada halaman yang hilang. Keluarkan kertas macet di keranjang standar finisher. Pastikan semua sobekan kertas dikeluarkan. Keluarkan kertas macet di keranjang 2. Pastikan semua sobekan kertas dikeluarkan. Buka pintu penyalur kertas, lalu keluarkan kertas yang macet. Pastikan semua sobekan kertas dikeluarkan. Tutup pintu penyalur kertas G. Buka pintu I, buka pintu R1, lalu keluarkan kertas yang macet. Pastikan semua sobekan kertas dikeluarkan. Tutup pintu R1, lalu tutup pintu I. Buka pintu penyalur kertas F. Buka pintu H. Angkat gagang R4. Putar kenop R3 berlawanan arah jarum jam, lalu keluarkan kertas yang macet di keranjang 1. Pastikan semua sobekan kertas dikeluarkan. Putar kenop R2 berlawanan arah jarum jam, lalu keluarkan kertas yang macet di pintu penyalur kertas F. Pastikan semua sobekan kertas dikeluarkan. Tutup pintu penyalur kertas F. Putar balik gagang R4 ke posisinya semula. Tutup pintu H. Jika printer telah diatur dengan penyalur kertas plus opsi lipatan, lakukan hal-hal di bawah ini: Keluarkan kertas macet di keranjang 1. Pastikan semua sobekan kertas dikeluarkan. Jangan mengeluarkan halaman cetak yang ada di pengumpul staple agar tidak ada halaman yang hilang. Keluarkan kertas macet di keranjang standar finisher. Pastikan semua sobekan kertas dikeluarkan. Keluarkan kertas macet di keranjang 2. Pastikan semua sobekan kertas dikeluarkan. Buka pintu F. Buka pintu N4. Buka pintu N5. Buka pintu H. Angkat gagang R4. Putar kenop R3 berlawanan arah jarum jam, lalu keluarkan kertas yang macet di keranjang 1. Pastikan semua sobekan kertas dikeluarkan. Putar gagang R2 berlawanan arah jarum jam, lalu keluarkan kertas yang macet di antara pintu N4 dan N5. Pastikan semua sobekan kertas dikeluarkan. Buka pintu B. Bagian dalam printer mungkin panas. Untuk mengurangi risiko cedera akibat komponen panas, biarkan permukaan berubah dingin sebelum menyentuhnya. Untuk mencegah kerusakan akibat arus elektrostatis, sentuh rangka besi printer yang terbuka sebelum mengakses atau menyentuh area interior printer. Keluarkan kertas macet di bawah roller keluar keranjang standar. Pastikan semua sobekan kertas dikeluarkan. Tutup pintu B. Tekan gagang N1. Putar kenop N2 berlawanan arah jarum jam. Keluarkan kertas yang macet. Supaya printer tidak rusak, lepas semua aksesori tangan sebelum mengeluarkan kertas yang macet. Pastikan semua sobekan kertas dikeluarkan. Kembalikan posisi gagang N1. Tutup gagang N5, lalu tutup gagang N4. Tutup pintu F. Putar balik gagang R4 ke posisinya semula. Tutup pintu H. mengatasi kertas macet di lis lubang stapler mengeluarkan kertas macet di lis lubang stapler kertas macet di lis lubang stapler"},{"UUID":"edda6a80-90aa-425d-805d-de328f61162d","title":"Mengatasi kertas macet","link":"clearing-jams.html","desc":"Kertas macet di lis buklet","descFull":"Kertas macet di lis buklet Jika printer telah diatur dengan penyalur kertas, lakukan hal-hal di bawah ini: Keluarkan kertas macet di keranjang standar finisher. Pastikan semua sobekan kertas dikeluarkan. Keluarkan kertas macet di keranjang 1. Pastikan semua sobekan kertas dikeluarkan. Keluarkan kertas macet di keranjang 1. Pastikan semua sobekan kertas dikeluarkan. Jangan mengeluarkan halaman cetak yang ada di pengumpul staple agar tidak ada halaman yang hilang. Keluarkan kertas macet di keranjang 3. Pastikan semua sobekan kertas dikeluarkan. Buka pintu penyalur kertas, lalu keluarkan kertas yang macet. Pastikan semua sobekan kertas dikeluarkan. Tutup pintu penyalur kertas G. Buka pintu penyalur kertas F. Buka pintu H. Geser gagang R3 ke kanan, lalu keluarkan kertas yang macet. Pastikan semua sobekan kertas dikeluarkan. Geser gagang R1 ke kiri, putar kenop R2 berlawanan arah jarum jam, lalu keluarkan kertas yang macet. Pastikan semua sobekan kertas dikeluarkan. Putar kenop R5 berlawanan arah jarum jam, lalu keluarkan kertas yang macet dari keranjang standar finisher. Pastikan semua sobekan kertas dikeluarkan. Angkat gagang R4, putar kenop R2 berlawanan arah jarum jam, lalu keluarkan kertas yang macet. Pastikan semua sobekan kertas dikeluarkan. Tutup pintu penyalur kertas F. Putar balik gagang R1, R3, dan R4 ke posisinya semula. Tutup pintu H. Jika printer telah diatur dengan penyalur kertas plus opsi lipatan, lakukan hal-hal di bawah ini: Keluarkan kertas macet di keranjang standar finisher. Pastikan semua sobekan kertas dikeluarkan. Keluarkan kertas macet di keranjang 1. Pastikan semua sobekan kertas dikeluarkan. Keluarkan kertas macet di keranjang 1. Pastikan semua sobekan kertas dikeluarkan. Jangan mengeluarkan halaman cetak yang ada di pengumpul staple agar tidak ada halaman yang hilang. Keluarkan kertas macet di keranjang 3. Pastikan semua sobekan kertas dikeluarkan. Buka pintu F. Buka pintu H. Buka pintu N4. Buka pintu N5. Angkat gagang R4. Putar kenop R2 searah jarum jam, lalu keluarkan kertas yang macet di gagang R4. Pastikan semua sobekan kertas dikeluarkan. Geser gagang R1 ke kiri, putar kenop R2 berlawanan arah jarum jam, lalu keluarkan kertas yang macet di antara pintu N4 dan N5. Pastikan semua sobekan kertas dikeluarkan. Buka pintu B. Bagian dalam printer mungkin panas. Untuk mengurangi risiko cedera akibat komponen panas, biarkan permukaan berubah dingin sebelum menyentuhnya. Untuk mencegah kerusakan akibat arus elektrostatis, sentuh rangka besi printer yang terbuka sebelum mengakses atau menyentuh area interior printer. Keluarkan kertas macet di bawah roller keluar keranjang standar. Pastikan semua sobekan kertas dikeluarkan. Tutup pintu B. Tekan gagang N1. Putar kenop N2 berlawanan arah jarum jam. Keluarkan kertas yang macet. Supaya printer tidak rusak, lepas semua aksesori tangan sebelum mengeluarkan kertas yang macet. Pastikan semua sobekan kertas dikeluarkan. Kembalikan posisi gagang N1. Tutup pintu N5 lalu tutup pintu N4. Tutup pintu F. Putar balik gagang R1 dan R4 ke posisinya semula. Tutup pintu H. Kertas macet di lis buklet Keluarkan kertas macet di keranjang 2. Pastikan semua sobekan kertas dikeluarkan. Buka pintu H. Putar kenop R6, R11, dan R10 searah jarum jam. Tarik lis buklet. Keluarkan kertas yang macet. Pastikan semua sobekan kertas dikeluarkan. Putar kenop R9 berlawanan arah jarum jam sampai berhenti. Buka pintu R8. Keluarkan kertas yang macet. Pastikan semua sobekan kertas dikeluarkan. Tutup pintu R8. Kembalikan lis buklet ke tempatnya. Tutup pintu H. mengatasi kertas macet di lis buklet mengeluarkan kertas macet di lis buklet kertas macet di lis buklet"},{"UUID":"4c25bda6-8cee-4643-b7d1-b3571fbeb9d7","title":"Masalah koneksi jaringan","link":"trb-cannot-open-embedded-web-server-topic.html","desc":"Tidak dapat membuka Embedded Web","descFull":"Tidak dapat membuka Embedded Web Server Tidak dapat membuka Embedded Web Server Coba satu atau dua cara berikut: Pastikan bahwa printer tidak sedang aktif. Pastikan bahwa alamat IP printer sudah benar. Lihat alamat IP di panel kontrol. Alamat IP muncul dalam empat set angka yang dipisahkan oleh titik, seperti 123.123.123.123. Pastikan Anda menginstal peramban yang didukung. Internet Explorer versi 11 atau terbaru Microsoft Edge Safari versi 6 atau terbaru Google Chrome  versi 32 atau terbaru Mozilla Firefox versi 24 atau terbaru Periksa apakah koneksi jaringan berfungsi. Jika koneksi tidak berfungsi, hubungi admin Anda. Pastikan sambungan kabel ke printer dan server cetak dalam kondisi aman. Untuk informasi lebih lanjut, lihat dokumen yang menyertai server cetak. Periksa apakah server proxy web dinonaktifkan. Jika koneksi tidak dinonaktifkan, hubungi admin Anda. Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . tidak dapat membuka Embedded Web Server pemecahan masalah tidak dapat membuka Embedded Web Server"},{"UUID":"8c79d19c-35aa-45a8-971b-5975befec369","title":"Masalah koneksi jaringan","link":"trb-cannot-open-embedded-web-server-topic.html","desc":"Tidak dapat menyambungkan printer ke","descFull":"Tidak dapat menyambungkan printer ke jaringan Wi-Fi Tidak dapat menyambungkan printer ke jaringan Wi-Fi Coba satu atau dua cara berikut: Dari panel kontrol, buka  Settings (Setelan) Network/Ports (Jaringan/Port) Network Overview (Tinjauan Jaringan) Active Adapter (Adaptor Aktif) , lalu pilih  Auto (Otomatis) . Pastikan bahwa komputer tersambung ke jaringan Wi-Fi yang benar. Untuk informasi lebih lanjut, lihat  . Beberapa ruter ada yang membagikan nama Wi-Fi default. Pastikan Anda memasukkan kata sandi jaringan yang benar. Catat spasi, angka, juga kapitalisasi dalam kata sandi tersebut. Pastikan mode keamanan nirkabel yang benar telah dipilih. Dari panel kontrol, buka  Settings (Setelan) Network/Ports (Jaringan/Port) Wireless (Nirkabel) Wireless Security Mode (Mode Keamanan Nirkabel) . Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . tidak dapat menyambungkan printer ke Wi-Fi pemecahan masalah tidak dapat menyambungkan printer ke Wi-Fi"},{"UUID":"b54806d9-0492-4b54-8d6b-6863c81da6c9","title":"Masalah opsi perangkat keras","link":"trb-cannot-detect-internal-option-topic.html","desc":"Tidak dapat mendeteksi opsi internal","descFull":"Tidak dapat mendeteksi opsi internal Tidak dapat mendeteksi opsi internal Coba satu atau dua cara berikut: Nonaktifkan printer, tunggu sekitar 10 detik, lalu aktifkan printer. Cetak  Menu Settings Page (Halaman Setelan Menu) , lalu periksa apakah opsi internal sudah terlihat di daftar Fitur yang Diinstal. Dari panel kontrol, buka  Settings (Setelan) Reports (Laporan) Menu Settings Page (Halaman Setelan Menu) . Periksa apakan opsi internal telah dipasang dengan benar ke papan kontroler. Nonaktifkan printer, lalu lepas kabel daya dari stopkontak listrik. Pastikan opsi internal terpasang ke konektor yang benar pada papan kontroler. Sambungkan kabel daya ke stopkontak listrik, lalu aktifkan printer. Untuk menghindari risiko kebakaran atau tersengat listrik, sambungkan kabel daya ke stopkontak listrik yang sudah diinspeksi standar mutunya dan dihubungkan ke arde di dekat produk dan mudah dijangkau. Periksa apakah opsi internal tersedia di driver printer. Jika perlu, tambah opsi internal secara manual ke dalam driver cetak agar tersedia untuk berbagai pekerjaan cetak. Untuk informasi lebih lanjut, lihat  . Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah opsi perangkat keras tidak dapat mendeteksi opsi internal opsi internal tidak terdeteksi tidak dapat mendeteksi opsi internal"},{"UUID":"0abb87cc-d9e1-4c1e-9bc6-0604d64da011","title":"Masalah opsi perangkat keras","link":"trb-cannot-detect-internal-option-topic.html","desc":"Port solusi internal tidak berfungsi","descFull":"Port solusi internal tidak berfungsi dengan baik Port solusi internal tidak berfungsi dengan baik Coba satu atau dua cara berikut: Cetak  Menu Settings Page (Halaman Setelan Menu) , lalu periksa apakah port solusi internal (ISP) muncul di daftar fitur yang diinstal. Dari panel kontrol, buka  Settings (Setelan) Reports (Laporan) Menu Settings Page (Halaman Setelan Menu) . Lepas, lalu pasang kembali ISP. Untuk informasi lebih lanjut, lihat  . Periksa kabel dan sambungan ISP. Gunakan kabel yang benar, lalu pastikan bahwa ia telah terhubung dengan benar ke ISP. Periksa apakah kabel antarmuka solusi ISP telah tersambung dengan benar ke slot yang semestinya di papan kontroler. Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . pemecahan masalah port solusi internal masalah opsi printer port solusi internal port solusi internal tidak berfungsi dengan baik"},{"UUID":"d09a377d-34b1-4056-9ba5-2a6e133996fb","title":"Masalah opsi perangkat keras","link":"trb-cannot-detect-internal-option-topic.html","desc":"Kartu antarmuka seri/paralel tidak berjalan","descFull":"Kartu antarmuka seri/paralel tidak berjalan dengan benar Kartu antarmuka seri/paralel tidak berjalan dengan benar Coba satu atau dua cara berikut: Cetak  Menu Settings Page (Halaman Setelan Menu) , lalu periksa apakah kartu antarmuka seri/paralel muncul di daftar fitur yang diinstal. Dari panel kontrol, buka  Settings (Setelan) Reports (Laporan) Menu Settings Page (Halaman Setelan Menu) . Lepas dan pasang kembali kartu antarmuka seri/paralel. Untuk informasi lebih lanjut, lihat  . Periksa sambungan antara kabel dengan kartu antarmuka seri/paralel. Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah opsi printer kartu antarmuka paralel masalah opsi printer kartu antarmuka seri pemecahan masalah kartu antarmuka paralel pemecahan masalah kartu antarmuka seri"},{"UUID":"16929381-5b4a-4dfd-8966-080d2de25afb","title":"Masalah opsi perangkat keras","link":"trb-cannot-detect-internal-option-topic.html","desc":"Flash rusak terdeteksi Flash rusak","descFull":"Flash rusak terdeteksi Flash rusak terdeteksi Coba satu atau dua cara berikut: Ganti memori flash yang rusak. Pilih  Continue (Lanjutkan)  untuk mengabaikan pesan dan melanjutkan mencetak. Batalkan pekerjaan cetak ini. pesan printer flash rusak terdeteksi memori flash rusak pemecahan masalah memori flash rusak"},{"UUID":"51ebcf06-6368-429e-8eb8-3a288de8ee6c","title":"Masalah opsi perangkat keras","link":"trb-cannot-detect-internal-option-topic.html","desc":"Tidak cukup ruang di memori","descFull":"Tidak cukup ruang di memori flash untuk sumber daya Tidak cukup ruang di memori flash untuk sumber daya Coba satu atau dua cara berikut: Pilih  Continue (Lanjutkan)  untuk membersihkan pesan dan melanjutkan mencetak. Hapus font, makro, dan data lain yang tersimpan di memori flash. Pasang drive penyimpanan. Font dan makro yang telah diunduh dan sebelumnya tidak disimpan di memori flash akan terhapus. pesan printer Tidak cukup ruang di memori flash untuk sumber daya Tidak cukup ruang di memori flash untuk sumber daya"},{"UUID":"82df8254-4903-440f-a1ee-5c3345904a8b","title":"Masalah dengan bahan pakai","link":"message-replace-cartridge-printer-region-mismatch-topic.html","desc":"Mengganti kawasan printer dan kartrid","descFull":"Mengganti kawasan printer dan kartrid yang tidak cocok Untuk membetulkan masalah ini, beli kartrid dengan kawasan yang benar, yang sesuai dengan kawasan printer, atau beli kartrid yang berlaku di seluruh dunia. Angka pertama setelah 42 di pesan tersebut menunjukkan kawasan printer. Angka kedua setelah 42 di pesan tersebut menunjukkan kawasan kartrid. Instal kartrid toner yang benar. Kawasan kartrid toner dan printer Kawasan Kode angka Seluruh dunia atau kawasan tak terdefinisi 0 Amerika Utara (Amerika Serikat, Kanada) 1 Wilayah Ekonomi Eropa, Eropa Barat, Negara-negara Nordik, Swiss 2 Asia Pasifik 3 Amerika Latin 4 Eropa lainnya, Timur Tengah, Afrika 5 Australia, Selandia Baru 6 Kawasan tidak valid 9 Untuk mencari setelan kawasan printer dan kartrid toner, cetak  Print Quality Test Pages (Halaman Percobaan Kualitas Cetak) . Dari panel kontrol, buka  Settings (Setelan) Troubleshooting (Pemecahan Masalah) Print Quality Test Pages (Cetak Halaman Percobaan Kualitas) . pesan printer Mengganti kawasan printer dan kartrid yang tidak cocok Mengganti kawasan printer dan kartrid yang tidak cocok kartrid, kawasan printer tidak cocok"},{"UUID":"967036ac-5d66-4a62-8eff-873f97db6cf1","title":"Masalah dengan bahan pakai","link":"message-replace-cartridge-printer-region-mismatch-topic.html","desc":"Kartrid [warna] reguler isi ulang","descFull":"Kartrid [warna] reguler isi ulang Printer mendeteksi bahwa kartrid reguler Lexmark telah diisi ulang dengan toner tidak asli yang bukan buatan Lexmark. Printer mendeteksi bahwa kartrid telah diisi ulang dengan toner tidak asli yang bukan buatan produsen printer Anda. Pilih  OK  untuk melanjutkan. Semua indikator masa pakai komponen printer dirancang untuk berfungsi dengan bahan pakai dan suku cadang Lexmark. Printer akan memberikan hasil yang tidak terduga saat menggunakan bahan pakai atau komponen yang diproduksi oleh selain Lexmark. Semua indikator masa pakai komponen printer dirancang untuk berfungsi dengan bahan pakai dan suku cadang produsen. Printer akan memberikan hasil yang tidak terduga saat menggunakan bahan pakai atau komponen yang diproduksi oleh selain produsen printer Anda. Untuk informasi lebih lanjut, baca pernyataan garansi terbatas untuk printer Anda. pesan printer kartrid reguler isi ulang toner tidak asli bahan pakai pihak ketiga"},{"UUID":"41de618d-a1c0-4f85-81d7-885d5de048ac","title":"Masalah dengan bahan pakai","link":"message-replace-cartridge-printer-region-mismatch-topic.html","desc":"Non‑Lexmark supply (Bahan pakai non-Lexmark)","descFull":"Non‑Lexmark supply (Bahan pakai non-Lexmark) Non‑Dell supply (Bahan pakai non-Dell) Non‑Printer Manufacturer supply (Bahan pakai Produsen non-Printer) Printer mendeteksi suku cadang atau bahan pakai non-Lexmark yang terpasang di printer. Printer mendeteksi suku cadang atau bahan pakai non-Dell yang terpasang di printer. Printer mendeteksi suku cadang atau bahan pakai tidak dikenal yang terpasang di printer. Printer Lexmark Anda didesain untuk berfungsi paling baik dengan suku cadang dan bahan pakai asli Lexmark. Menggunakan suku cadang atau bahan pakai pihak ketiga akan memengaruhi performa, keandalan, masa pakai printer, maupun komponen pencitraannya. Printer Dell Anda didesain untuk berfungsi paling baik dengan suku cadang dan bahan pakai asli Dell. Menggunakan suku cadang atau bahan pakai pihak ketiga akan memengaruhi performa, keandalan, masa pakai printer, maupun komponen pencitraannya. Printer Anda dirancang untuk berfungsi paling baik dengan suku cadang dan bahan pakai asli yang diproduksi oleh produsen printer. Menggunakan suku cadang atau bahan pakai pihak ketiga akan memengaruhi performa, keandalan, masa pakai printer, maupun komponen pencitraannya. Semua indikator masa pakai dirancang untuk berfungsi dengan suku cadang dan bahan pakai Lexmark dan bisa saja menyuguhkan hasil yang tidak terduga jika yang dipakai adalah suku cadang atau bahan pakai pihak ketiga. Penggunaan komponen pencitraan yang melebihi masa pakainya akan menyebabkan kerusakan pada printer Lexmark atau komponen terkait. Semua indikator masa pakai dirancang untuk berfungsi dengan suku cadang dan bahan pakai Dell dan bisa saja menyuguhkan hasil yang tidak terduga jika yang dipakai adalah suku cadang atau bahan pakai pihak ketiga. Penggunaan komponen pencitraan yang melebihi masa pakainya dapat menyebabkan kerusakan pada printer Dell atau komponen terkait. Semua indikator masa pakai dirancang untuk berfungsi dengan suku cadang dan bahan pakai dari produsen printer dan bisa saja menyuguhkan hasil yang tidak terduga jika yang dipakai adalah suku cadang atau bahan pakai pihak ketiga. Penggunaan komponen pencitraan yang melebihi masa pakainya dapat menyebabkan kerusakan pada printer atau komponen terkait. Penggunaan suku cadang atau bahan pakai pihak ketiga dapat memengaruhi cakupan garansi. Kerusakan yang disebabkan akibat penggunaan suku cadang atau bahan pakai pihak ketiga tidak akan dicakup dalam garansi. Untuk menerima sebagian atau seluruh risiko ini, serta untuk melanjutkan penggunaan suku cadang dan bahan pakai tidak asli pada printer Anda, sentuh dan tahan pesan eror pada tampilan dengan dua jari selama 15 detik. Ketika kotak dialog konfirmasi muncul, sentuh  Continue (Lanjutkan) . Jika Anda tidak ingin menerima risiko ini semua, lepas suku cadang atau bahan pakai pihak ketiga dari printer Anda dan gunakan suku cadang atau bahan pakai asli Lexmark. Untuk informasi lebih lanjut, lihat  . Jika Anda tidak ingin menerima risiko ini semua, lepas suku cadang atau bahan pakai pihak ketiga dari printer Anda dan gunakan suku cadang atau bahan pakai asli Dell. Jika Anda tidak ingin menerima risiko ini semua, lepas suku cadang atau bahan pakai pihak ketiga dari printer Anda dan gunakan suku cadang atau bahan pakai asli dari produsen printer. Jika printer tidak mencetak setelah pesan eror dibersihkan, setel ulang penghitung pemakaian bahan pakai. Dari panel kontrol, buka  Settings (Setelan) Device (Perangkat) Maintenance (Perawatan) Configuration Menu (Menu Konfigurasi) Supply Usage And Counters (Penghitung dan Pemakaian Bahan Pakai) . Pilih suku cadang atau bahan pakai yang ingin Anda setel ulang, lalu pilih  Start (Mulai) . Baca pesan peringatan, lalu pilih  Continue (Lanjutkan) . Dengan dua jari, sentuh tampilan selama 15 detik untuk membersihkan pesan. Jika Anda tidak bisa menyetel ulang penghitung pemakaian bahan pakai, kembalikan bahan pakai ke tempat Anda membeli. pesan printer Bahan pakai non-Lexmark Bahan pakai non-Lexmark pesan printer Bahan pakai non-Dell Bahan pakai non-Dell pesan printer Bahan pakai Produsen non-Printer Bahan pakai Produsen non-Printer menyetel ulang penghitung pemakaian bahan pakai penghitung pemakaian bahan pakai menyetel ulang menyetel ulang penghitung pemakaian bahan pakai"},{"UUID":"4272297a-162f-470f-bc7b-f2455b131da7","title":"Masalah pengumpanan kertas","link":"trb-paper-curl-topic.html","desc":"Kertas keriting Coba satu atau","descFull":"Kertas keriting Coba satu atau dua cara berikut: Sesuaikan pembatas kertas pada baki ke posisi yang benar untuk kertas yang dimasukkan. Tergantung sistem operasi Anda, tentukan jenis kertas dari Printing Preferences (Preferensi Mencetak) atau Print Dialog (Dialog Cetak). Pastikan setelan sesuai dengan kertas yang dimasukkan. Anda juga bisa mengubah setelan pada panel kontrol printer. Buka  Settings (Setelan) Paper (Kertas) Tray Configuration (Konfigurasi Baki) Paper Size/Type (Ukuran/Jenis Kertas) . Keluarkan kertas, balik, lalu masukkan lagi. Masukkan kertas dari kemasan baru. Kertas menyerap minyak karena tingkat kelembapan yang tinggi. Simpan kertas di wadah aslinya sampai Anda benar-benar akan menggunakannya. Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah kualitas cetak kertas keriting kertas keriting"},{"UUID":"3cc0f203-c2b3-49ab-b171-0d43a4b737dd","title":"Masalah pengumpanan kertas","link":"trb-paper-curl-topic.html","desc":"Tutup amplop lengket saat mencetak","descFull":"Tutup amplop lengket saat mencetak Coba satu atau dua cara berikut: Gunakan amplop yang telah disimpan di tempat yang kering. Mencetak amplop dengan kandungan lembap yang tinggi bisa membuat tutup amplop lengket. Pastikan jenis kertas disetel ke  Envelope (Amplop) . Dari panel kontrol, buka  Settings (Setelan) Paper (Kertas) Tray Configuration (Konfigurasi Baki) Paper Size/Type (Ukuran/Jenis Kertas) . Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah pengumpanan kertas tutup amplop lengket saat mencetak tutup amplop lengket saat mencetak"},{"UUID":"22a457ad-486a-4a21-bd12-ee15b0bbb7ac","title":"Masalah pengumpanan kertas","link":"trb-paper-curl-topic.html","desc":"Pencetakan susun tidak berfungsi Coba","descFull":"Pencetakan susun tidak berfungsi Coba satu atau dua cara berikut: Dari panel kontrol, buka  Settings (Setelan) Print (Cetak) Layout (Tata Letak) Collate (Susun) , lalu pilih  On [1,2,1,2,1,2] . Dari dokumen yang Anda cetak, buka dialog Preferensi Cetak, lalu pilih  Collate (Susun) . Kurangi jumlah halaman yang akan dicetak. Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah pengumpanan kertas pencetakan susun tidak berfungsi pencetakan susun tidak berfungsi"},{"UUID":"18b1f6d0-4d31-4b0f-81df-a33ab0200dbd","title":"Masalah pengumpanan kertas","link":"trb-paper-curl-topic.html","desc":"Sambungan baki tidak berfungsi Coba","descFull":"Sambungan baki tidak berfungsi Coba satu atau dua cara berikut: Pastikan bahwa baki yang disambung berisi kertas dengan ukuran, jenis, dan orientasi yang sama. Pastikan bahwa pembatas kertas berada di tempat yang benar. Setel ukuran dan jenis kertas agar sesuai dengan yang dimasukkan ke baki. Dari panel kontrol, buka  Settings (Setelan) Paper (Kertas) Tray Configuration (Konfigurasi Baki) Paper Size/Type (Ukuran/Jenis Kertas) . Pastikan bahwa  Sambungan Baki  telah disetel ke  Automatic (Otomatis) . Untuk informasi lebih lanjut, lihat  . Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah pengumpanan kertas sambungan baki tidak berfungsi sambungan baki tidak berfungsi"},{"UUID":"24e68ad0-d3be-4fbf-a82f-f2495e305dc1","title":"Masalah pengumpanan kertas","link":"trb-paper-curl-topic.html","desc":"Kertas sering macet Coba satu","descFull":"Kertas sering macet Coba satu atau dua cara berikut: Periksa apakah kertas dimasukkan dengan benar. Pastikan bahwa pembatas kertas berada di tempat yang benar. Pastikan tinggi tumpukan di bawah indikator pengisian kertas maksimum. Pastikan mencetak pada kertas dengan jenis dan ukuran yang disarankan. Setel ukuran dan jenis kertas yang benar. Dari panel kontrol, buka  Settings (Setelan) Paper (Kertas) Tray Configuration (Konfigurasi Baki) Paper Size/Type (Ukuran/Jenis Kertas) . Masukkan kertas dari kemasan baru. Kertas menyerap minyak karena tingkat kelembapan yang tinggi. Simpan kertas di wadah aslinya sampai Anda benar-benar akan menggunakannya. Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah pengumpanan kertas kertas sering macet kertas sering macet"},{"UUID":"abfe4a8c-b70f-4f4b-a6d0-b71c6a5e4172","title":"Masalah pengumpanan kertas","link":"trb-paper-curl-topic.html","desc":"Halaman yang macet tidak dicetak","descFull":"Halaman yang macet tidak dicetak ulang Dari panel kontrol, buka  Settings (Setelan) Device (Perangkat) Notifications (Notifikasi) Jam Content Recovery (Pemulihan Konten Macet) . Pada menu  Jam Recovery (Pemulihan Kemacetan),  pilih  On (Aktif)  atau  Auto (Otomatis) . Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah mencetak halaman yang macet tidak dicetak ulang halaman yang macet tidak dicetak ulang"},{"UUID":"1bf83b18-cd7b-417b-b189-d2f11a7b456b","title":"Mengirim masalah via email","link":"disabling-smtp-server-not-setup-error-topic.html","desc":"Menonaktifkan pesan eror “SMTP server","descFull":"Menonaktifkan pesan eror “SMTP server not set up” (Server SMTP belum disiapkan) Dari panel kontrol, buka  Settings (Setelan) Email Email Setup (Penyiapan Email) . Setel pesan eror  Disable “SMTP server not set up”  ke  On . Agar eror tersebut tidak terjadi lagi, lakukan satu atau beberapa hal berikut: Perbarui firmware printer. Informasi lebih lanjut, lihat bagian “Update firmware (Perbarui firmware)”. Atur setelan SMTP email. Untuk informasi lebih lanjut, lihat  . eror server SMTP belum disiapkan menonaktifkan pemecahan masalah eror server SMTP belum disiapkan menonaktifkan eror server SMTP belum disiapkan"},{"UUID":"3eed6a89-004c-426b-ae19-9160419cc789","title":"Mengirim masalah via email","link":"disabling-smtp-server-not-setup-error-topic.html","desc":"Tidak dapat mengirim email Coba","descFull":"Tidak dapat mengirim email Coba salah satu cara berikut: Pastikan setelan SMTP email telah diatur dengan benar. Untuk informasi lebih lanjut, lihat  . Pastikan printer terhubung ke suatu jaringan dan jaringan tersebut terhubung ke Internet. Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah email tidak dapat mengirim email tidak dapat mengirim email"},{"UUID":"5d8ab7b4-179f-4b64-81fb-efd4e06f0caf","title":"masalah faks","link":"trb-caller-id-not-shown-topic.html","desc":"ID penelepon tidak ditampilkan ID","descFull":"ID penelepon tidak ditampilkan ID penelepon tidak ditampilkan Instruksi ini hanya berlaku pada printer dengan kartu faks. Dari panel kontrol, buka  Settings (Setelan) Fax (Faks) Fax Setup (Penyiapan Faks) Fax Receive Settings (Setelan Terima Faks) Admin Controls (Kontrol Admin) . Setelah  Enable Caller ID (Aktifkan ID Penelepon)  ke  On (Aktif) . Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah faks ID penelepon tidak ditampilkan ID penelepon tidak ditampilkan"},{"UUID":"f84b92b0-c74a-4b8d-a058-16ab1cb831c2","title":"masalah faks","link":"trb-caller-id-not-shown-topic.html","desc":"Tidak dapat mengirim atau menerima","descFull":"Tidak dapat mengirim atau menerima faks dengan faks analog Tidak dapat mengirim atau menerima faks dengan faks analog Coba satu atau dua cara berikut : Selesaikan pesan eror yang muncul pada tampilan. Pastikan sambungan kabel untuk telepon, handset, atau mesin penjawab dalam kondisi aman. Periksa nada sambung. Hubungi nomor faks untuk memeriksa apakah ia berfungsi dengan baik. Jika Anda menggunakan fitur On Hook Dial, tingkatkan volumi untuk memeriksa apakah Anda mendengar nada sambung. Periksa soket telepon dinding. Sambungkan telepon analog ke soket dinding secara langsung. Dengarkan nada sambung. Jika Anda tidak mendengar nada sambung, gunakan kabel telepon yang berbeda. Jika Anda masih tidak bisa mendengar nada sambung, sambungkan telepon analog ke soket dinding yang berbeda. Jika Anda mendengar nada sambung, hubungkan printer ke soket dinding. Periksa apakah printer tersambung ke layanan telepon analog atau ke konektor digital yang benar. Jika Anda menggunakan layanan telepon Integrated Services for Digital Network (ISDN/Layanan Terpadu untuk Jaringan Digital), sambungkan ke port telepon analog adaptor terminal ISDN. Untuk informasi lebih lanjut, hubungi penyalur ISDN Anda. Jika Anda menggunakan DSL, sambungkan router atau filter DSL yang mendukung penggunaan analog. Untuk informasi lebih lanjut, hubungi penyalur DSL Anda. Jika Anda menggunakan layanan telepon PBX, pastikan Anda menyambungkannya ke koneksi analog di PBX. Jika tidak ada, pertimbangkan memasang sambungan telepon analog untuk mesin faks. Untuk sementara waktu, putus sambungan dengan peralatan lain, atau nonaktifkan layanan telepon. Putus sambungan dengan peralatan lain (seperti mesin penjawab, komputer, modem, atau pemisah sambungan telepon) antara printer dengan sambungan telepon. Nonaktifkan panggilan tunggu dan pesan suara. Untuk informasi lebih lanjut, hubungi perusahaan telepon Anda. Pindai dokumen asli pada satu halaman satu kali. Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah faks tidak dapat mengirim atau menerima faks dengan faks analog tidak dapat mengirim atau menerima faks dengan faks analog"},{"UUID":"c358ca44-0cd4-4be9-8e8f-b648aa4661a2","title":"masalah faks","link":"trb-caller-id-not-shown-topic.html","desc":"Bisa menerima tetapi tidak bisa","descFull":"Bisa menerima tetapi tidak bisa mengirim faks dengan faks analog Bisa menerima tetapi tidak bisa mengirim faks dengan faks analog Coba satu atau dua cara berikut: Masukkan dokumen asli ke dalam baki ADF atau kaca pemindai. Siapkan nomor pintasan dengan benar. Periksa apakah nomor pintasan disetel sebagai nomor telepon yang hendak Anda hubungi. Hubungi nomor telepon secara manual. Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah faks tidak bisa mengirim faks dengan faks analog tidak bisa mengirim faks dengan faks analog"},{"UUID":"707ae31b-5f83-413d-bc4c-23f8397c4b04","title":"masalah faks","link":"trb-caller-id-not-shown-topic.html","desc":"Bisa mengirim tetapi tidak bisa","descFull":"Bisa mengirim tetapi tidak bisa menerima faks dengan faks analog Bisa mengirim tetapi tidak bisa menerima faks dengan faks analog Coba satu atau dua cara berikut: Pastikan sumber kertas tidak kosong. Periksa setelan jumlah dering penundaan. Dari panel kontrol, buka  Settings (Setelan) Fax (Faks) Fax Setup (Penyiapan Faks) Fax Receive Settings (Setelan Terima Faks) Rings to Answer (Dering untuk Menjawab) . Jika printer mencetak halaman kosong, lihat  . Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah faks bisa mengirim tetapi tidak bisa menerima faks dengan faks analog tidak bisa menerima faks dengan faks analog"},{"UUID":"d4fc9413-f1cf-402b-9692-833f237d5de2","title":"masalah faks","link":"trb-caller-id-not-shown-topic.html","desc":"Tidak dapat menyiapkan etherFAX Tidak","descFull":"Tidak dapat menyiapkan etherFAX Tidak dapat menyiapkan etherFAX Coba satu atau dua cara berikut : Periksa sambungan printer. Dari panel kontrol, buka  Settings (Setelan) Reports (Laporan) Network (Jaringan) Network Setup Page (Halaman Penyiapan Jaringan) . Memeriksa status jaringan pada halaman cetak. Pastikan printer terhubung ke suatu jaringan dan jaringan tersebut terhubung ke Internet. Pastikan etherFAX disiapkan dengan benar. Untuk informasi lebih lanjut, lihat  . Jika masalah ini tetap ada, kunjungi  https://www.etherfax.net/lexmark . masalah faks tidak dapat menyiapkan etherFAX tidak dapat menyiapkan etherFAX"},{"UUID":"240a5e81-b586-4b13-b380-9fdf708a8828","title":"masalah faks","link":"trb-caller-id-not-shown-topic.html","desc":"Tidak dapat mengirim atau menerima","descFull":"Tidak dapat mengirim atau menerima faks dengan etherFAX Tidak dapat mengirim atau menerima faks dengan etherFAX Coba satu atau dua cara berikut : Pastikan printer terhubung ke suatu jaringan dan jaringan tersebut terhubung ke Internet. Pastikan etherFAX disiapkan dengan benar. Untuk informasi lebih lanjut, lihat  . Pecah dokumen besar ke dalam beberapa file ukuran kecil. Jika masalah ini tetap ada, kunjungi  https://www.etherfax.net/lexmark . masalah faks tidak dapat mengirim atau menerima faks dengan etherFAX tidak dapat mengirim atau menerima faks dengan etherFAX"},{"UUID":"457511be-0659-4f6d-9739-bf90b4b855de","title":"masalah faks","link":"trb-caller-id-not-shown-topic.html","desc":"Kualitas cetak faks rendah Kualitas","descFull":"Kualitas cetak faks rendah Kualitas cetak faks rendah Coba satu atau dua cara berikut: Memperbaiki masalah kualitas cetak. Cetak  Test Quality Pages (Halaman Percobaan Kualitas) . Dari panel kontrol, buka  Settings (Setelan) Troubleshooting (Pemecahan Masalah) Print Quality Test Pages (Cetak Halaman Percobaan Kualitas) . Perbaiki masalah pada kualitas cetak. Untuk informasi lebih lanjut, lihat  . Jika Anda memakai faks analog, kurangi kecepatan transmisi faks masuk. Dari panel kontrol, buka  Settings (Setelan) Fax (Faks) Fax Setup (Penyiapan Faks) Fax Receive Settings (Setelan Terima Faks) Admin Controls (Kontrol Admin) . Pada menu  Max Speed (Kecepatan Maks.) , pilih kecepatan transmisi yang lebih rendah. Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah faks kualitas cetak rendah kualitas cetak faks rendah"},{"UUID":"807852f5-a961-44ee-ac12-806a32e68aa3","title":"masalah faks","link":"trb-caller-id-not-shown-topic.html","desc":"Halaman sampul faks tidak terdapat","descFull":"Halaman sampul faks tidak terdapat informasi Halaman sampul faks tidak terdapat informasi Nonaktifkan printer, tunggu sekitar 10 detik, lalu aktifkan printer. Kirim atau terima faks. Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah faks tidak ada informasi pada halaman sampul faks tidak ada informasi pada halaman sampul faks"},{"UUID":"698f2cad-bc2e-4aae-ad14-c8f02e56e362","title":"masalah faks","link":"trb-caller-id-not-shown-topic.html","desc":"Tidak bisa mengirim faks halaman","descFull":"Tidak bisa mengirim faks halaman sampul dari komputer Tidak bisa mengirim faks halaman sampul dari komputer Coba satu atau dua cara berikut : Pastikan bahwa driver printer telah diperbarui. Untuk informasi lebih lanjut, buka  www.lexmark.com/downloads . Pastikan bahwa driver printer telah diperbarui. Untuk informasi lebih lanjut, hubungi tempat di mana Anda membeli printer tersebut. Pastikan driver printer telah diperbarui, lalu kirim faks. Untuk informasi lebih lanjut, hubungi  penyalur Anda . Bersihkan setelan  Always display settings prior to faxing (Selalu tampilkan setelan sebelum mengirim faks) . Dari dokumen yang akan Anda kirim lewat faks, buka dialog  Print (Cetak) . Pilih printer, kemudian klik  Properties (Properti) ,  Preferences (Preferensi) ,  Options (Opsi) , atau  Setup (Penyiapan) . Klik  Fax (Faks) , lalu bersihkan setelan  Always display settings prior to faxing (Selalu tampilkan setelan sebelum mengirim faks) . Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah faks tidak dapat mengirim halaman sampul faks dari komputer tidak dapat mengirim halaman sampul faks dari komputer"},{"UUID":"503ee2bd-7a44-4f24-9a2e-20ef99d53f77","title":"Masalah memindai","link":"trb-cannot-scan-to-computer-topic.html","desc":"Tidak dapat memindai ke komputer","descFull":"Tidak dapat memindai ke komputer Coba satu atau dua cara berikut: Lakukan satu pekerjaan fotokopi. Apabila suatu pekerjaan gagal, nonaktifkan printer, tunggu sekitar 10 detik, lalu aktifkan printer. Periksa sambungan printer. Cetak  Network Setup Page (Halaman Penyiapan Jaringan) . Dari panel kontrol, buka  Settings (Setelan) Reports (Laporan) Network (Jaringan) , lalu pilih  Network Setup Page (Halaman Penyiapan Jaringan) . Periksa bagian awal halaman tersebut, lalu pastikan bahwa statusnya tersambung. Pastikan printer dan komputer terhubung ke jaringan yang sama. Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah memindai tidak dapat memindai ke komputer tidak dapat memindai ke komputer"},{"UUID":"5737ae18-a6d4-440d-b629-bfa7b96c59dd","title":"Masalah memindai","link":"trb-cannot-scan-to-computer-topic.html","desc":"Tidak dapat menindai ke folder","descFull":"Tidak dapat menindai ke folder jaringan Coba satu atau dua cara berikut: Buat pintasan folder jaringan, lalu pindai dokumen dengan pintasan tersebut. Untuk informasi lebih lanjut, lihat  . Pastikan format dan jalur folder jaringan benar. Misal,  // server_hostname /foldername/path , di mana  server_hostname  adalah domain kualifikasi penuh (FQDN) atau alamat IP. Pastikan bahwa Anda memiliki izin akses ke folder jaringan tersebut. Perbarui pintasan folder jaringan. Buka peramban web, kemudian tulis alamat IP printer di kolom alamat. Lihat alamat IP printer di layar beranda printer. Alamat IP muncul dalam empat set angka yang dipisahkan oleh titik, seperti 123.123.123.123. Jika Anda menggunakan proxy, nonaktifkan proxy tersebut untuk memuat halaman web dengan benar. Klik  Pintasan , kemudian pilih satu pintasan. Jika Anda memiliki beberapa jenis pintasan, pilih  Network Folder (Folder Jaringan) . Pada kolom Share Path, tulis jalur folder jaringan. Misal,  \\\\server_hostname\\foldername\\path . Selalu gunakan garis miring maju ketika menulis Share Path. Dari menu  Authentication (Otentikasi) , pilih metode otentikasi Anda. Jika  Authentication (Otentikasi)  disetel ke “ Use assigned username and password (Gunakan nama pengguna dan kata sandi yang ditentukan) ,” maka pada kolom Username and Password (Nama Pengguna dan Kata Sandi), tulis kredensial Anda. Klik  Save (Simpan) . Pastikan printer dan folder jaringan terhubung ke jaringan yang sama. Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . tidak dapat memindai ke folder jaringan masalah memindai tidak dapat memindai ke folder jaringan"},{"UUID":"175b6c21-753e-4919-8ee5-2737646906c0","title":"Masalah memindai","link":"trb-cannot-scan-to-computer-topic.html","desc":"Salinan dokumen atau foto terpotong","descFull":"Salinan dokumen atau foto terpotong Coba satu atau dua cara berikut: Pastikan bahwa dokumen atau foto dimasukkan dengan menghadap ke bawah di pojok kiri atas kaca pemindai. Sesuaikan setelan ukuran kertas dengan kertas yang ada di baki. Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah menyalin salinan dokumen terpotong masalah menyalin salinan foto terpotong salinan dokumen atau foto terpotong masalah memindai salinan dokumen terpotong masalah memindai salinan foto terpotong"},{"UUID":"a9f5913c-1c11-4776-aaa9-82e98608b37b","title":"Masalah memindai","link":"trb-cannot-scan-to-computer-topic.html","desc":"Kualitas salin rendah Coba satu","descFull":"Kualitas salin rendah Coba satu atau dua cara berikut: Bersihkan kaca pemindai dan kaca ADF dengan kain bekas yang lembut tanpa serat. Jika printer Anda memiliki kaca ADF kedua di dalam ADF, bersihkan pula kaca tersebut. Untuk informasi lebih lanjut, lihat  . Pastikan bahwa dokumen atau foto dimasukkan dengan menghadap ke bawah di pojok kiri atas kaca pemindai. Periksa kualitas foto atau dokumen asli dan sesuaikan setelan kualitas pindai. Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah menyalin kualitas salin rendah kualitas salin rendah masalah memindai kualitas salin rendah kualitas pindai rendah"},{"UUID":"95e6b0dd-fa4e-426b-b75e-2911c10d32f1","title":"Masalah memindai","link":"trb-cannot-scan-to-computer-topic.html","desc":"Garis-garis gelap vertikal saat memindai","descFull":"Garis-garis gelap vertikal saat memindai dari ADF Angkat pintu pemindai, lalu lepas alat pembersih kaca. Usap kaca ADF di samping kaca pemindai. Buka pintu A1, lalu bersihkan kaca ADF. Kembalikan alat ke tempatnya. Tutup pintu pemindai. Untuk informasi lebih lanjut tentang membersihkan pemindai, lihat  . Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah memindai Garis-garis gelap vertikal pada keluaran saat memindai dari ADF. Garis-garis gelap vertikal pada keluaran saat memindai dari ADF. masalah kualitas pindai"},{"UUID":"3ae20471-ad1c-4602-bb4b-550bac18e607","title":"Masalah memindai","link":"trb-cannot-scan-to-computer-topic.html","desc":"Gambar atau teks bergerigi saat","descFull":"Gambar atau teks bergerigi saat memindai dari ADF. Gambar atau teks bergerigi saat memindai dari ADF. Masukkan 50 lembar kertas biasa yang bersih ke dalam ADF. Kertas biasa bisa membantu membersihkan atau menghilangkan debu dan lapisan lain dari roller pengumpan ADF. Dari panel kontrol, usap ke kanan ke pusat kontrol, lalu pilih  Masukkan dokumen asli ke dalam ADF. Pindai dokumen. Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah memindai gambar bergerigi masalah memindai teks bergerigi pemecahan masalah gambar bergerigi dari pemindaian ADF pemecahan masalah teks bergerigi dari pemindaian ADF gambar bergerigi dari pemindaian ADF teks bergerigi dari pemindaian ADF"},{"UUID":"eb8e1774-8707-4f93-9107-c434fa321e97","title":"Masalah memindai","link":"trb-cannot-scan-to-computer-topic.html","desc":"Pekerjaan pindai tidak berhasil Pekerjaan","descFull":"Pekerjaan pindai tidak berhasil Pekerjaan pindai tidak berhasil Coba satu atau dua cara berikut: Pastikan bahwa kabel USB atau Ethernet tersambung dengan aman ke komputer dan printer. Periksa file yang ingin Anda pindai, dan pastikan bahwa: Nama file belum dipakai di folder destinasi. Foto atau dokumen yang ingin Anda pindai tidak terbuka di aplikasi lain. Pastikan bahwa kotak centang  Keterangan waktu Append  atau  Timpa file lama  telah dipilih pada setelan konfigurasi destinasi. Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah memindai pekerjaan pindai tidak berhasil pekerjaan pindai tidak berhasil pemecahan masalah pekerjaan pindai tidak berhasil"},{"UUID":"ef81e359-b8d7-4c14-b4e0-e42d869e7622","title":"Masalah memindai","link":"trb-cannot-scan-to-computer-topic.html","desc":"Pemindai tidak bisa ditutup Pemindai","descFull":"Pemindai tidak bisa ditutup Pemindai tidak bisa ditutup Lepas penghalang yang membuat pemindai tidak bisa ditutup. Tutup pemindai. Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah memindai pemindai tidak bisa ditutup pemindai tidak bisa ditutup"},{"UUID":"c609dec1-d2d2-4b5f-9c47-aadb2a8df973","title":"Masalah memindai","link":"trb-cannot-scan-to-computer-topic.html","desc":"Memindai terlalu lama atau membuat","descFull":"Memindai terlalu lama atau membuat komputer berhenti Memindai terlalu lama atau membuat komputer berhenti Tutup semua aplikasi yang mengganggu pemindaian. Pindai dokumen sekali lagi. Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah memindai memindai terlalu lama masalah memindai memindai membuat komputer berhenti pemindaian terlalu lama atau membuat komputer berhenti"},{"UUID":"c14d46d3-28dc-4594-be79-43c78ed87df6","title":"Masalah memindai","link":"trb-cannot-scan-to-computer-topic.html","desc":"Pemindai tidak merespons Pemindai tidak","descFull":"Pemindai tidak merespons Pemindai tidak merespons Coba satu atau dua cara berikut: Periksa apakah kabel daya tersambung dengan benar ke printer dan stopkontak listrik. Untuk menghindari risiko kebakaran atau tersengat listrik, sambungkan kabel daya ke stopkontak listrik yang sudah diinspeksi standar mutunya dan dihubungkan ke arde di dekat produk dan mudah dijangkau. Periksa apakah printer aktif, lalu selesaikan pesan eror yang muncul pada tampilan. Nonaktifkan printer, tunggu sekitar 10 detik, lalu aktifkan printer. Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah menyalin pemindai tidak merespons masalah memindai pemindai tidak merespons pemindai tidak merespons"},{"UUID":"c63527fa-6581-4153-b6dc-a2ea961d949d","title":"Masalah memindai","link":"trb-cannot-scan-to-computer-topic.html","desc":"Menyesuaikan registrasi pemindai Menyesuaikan registrasi","descFull":"Menyesuaikan registrasi pemindai Menyesuaikan registrasi pemindai Dari panel kontrol, buka  Settings (Setelan) Device (Perangkat) Maintenance (Perawatan) Configuration Menu (Menu Konfigurasi) Scanner Configuration (Konfigurasi Pemindai) Scanner Manual Registration (Registrasi Manual Pemindai) . Pada menu  Print Quick Test (Cetak Percobaan Cepat) , pilih  Start (Mulai) . Taruh halaman percobaan di kaca pemindai, lalu pilih  Flatbed Registration (Registrasi Flatbed) . Pada menu  Copy Quick Test (Salin Percobaan Cepat) , pilih  Start (Mulai) . Bandingkan halaman percobaan dengan dokumen asli. Jika margin halaman percobaan berbeda dari dokumen asli, atur setelan  Horizontal Adjust (Penyesuaian Horizontal)  dan  Top Margin (Margin Atas) . Ulangi   dan   sampai margin halaman  Copy Quick Test (Salin Percobaan Cepat)  sama/hampir sama dengan dokumen asli. menyesuaikan registrasi pemindai"},{"UUID":"36f06ddc-a96f-49f3-84c1-d6319298633a","title":"Masalah memindai","link":"trb-cannot-scan-to-computer-topic.html","desc":"Menyesuaikan registrasi ADF Dari panel","descFull":"Menyesuaikan registrasi ADF Dari panel kontrol, buka  Settings (Setelan) Device (Perangkat) Maintenance (Perawatan) Configuration Menu (Menu Konfigurasi) Scanner Configuration (Konfigurasi Pemindai) Scanner Manual Registration (Registrasi Manual Pemindai) . Pada menu  Print Quick Test (Cetak Percobaan Cepat) , pilih  Start (Mulai) . Tempatkan halaman tes di baki ADF. Pilih  Front ADF Registration (Registrasi ADF Depan)  atau  Rear ADF Registration (Registrasi ADF Belakang) . Untuk meratakan  Registrasi ADF Depan , tempatkan halaman tes menghadap ke atas, dengan tepi pendek masuk terlebih dahulu ke dalam ADF. Untuk meratakan  Registrasi ADF Belakang , tempatkan halaman tes menghadap ke bawah, dengan tepi pendek masuk terlebih dahulu ke dalam ADF. Pada menu  Copy Quick Test (Salin Percobaan Cepat) , pilih  Start (Mulai) . Bandingkan halaman percobaan dengan dokumen asli. Jika margin halaman tes berbeda dari dokumen asli, atur setelan  Horizontal Adjust (Penyesuaian Horizontal)  dan  Top Margin (Margin Atas) . Ulangi   dan   sampai margin halaman  Copy Quick Test (Salin Percobaan Cepat)  sama/hampir sama dengan dokumen asli. registrasi ADF menyesuaikan menyesuaikan registrasi ADF"},{"UUID":"a4fbe022-ae46-4f32-9465-b83dc455c067","title":"Masalah kualitas warna","link":"modifying-colors-in-printed-output-topic.html","desc":"Memodifikasi warna di hasil cetak.","descFull":"Memodifikasi warna di hasil cetak. Dari panel kontrol, buka  Settings (Setelan) Print (Cetak) Quality (Kualitas) Advanced Imaging (Pencitraan Lanjutan) Color Correction (Koreksi Warna) . Di menu  Color Correction (Koreksi Warna),  pilih  Manual . Di menu  Color Correction Content (Konten Koreksi Warna),  pilih setelan konversi warna yang semestinya. Warna manual, menu, jenis objek, dan tabel konversi warna Jenis objek Tabel konversi warna Gambar RGB Teks RGB Grafik RGB Vivid —Menghasilkan warna yang lebih terang, lebih tersaturasi, dan bisa diterapkan di semua format warna berikutnya. sRGB Display —Menghasilkan output yang mendekati sama dengan apa yang terlihat di monitor komputer. Penggunaan toner hitam akan lebih maksimal pada pencetakan hasil foto. Display‑True Black —Menghasilkan output yang mendekati sama dengan apa yang terlihat di monitor komputer. Setelan ini hanya menggunakan toner hitam untuk membuat semua level abu-abu netral. sRGB Vivid —Meningkatkan saturasi warna untuk koreksi warna pada  sRGB Display . Penggunaan toner hitam akan lebih maksimal pada pencetakan grafik bisnis. Off (Nonaktif) Gambar CMYK Teks CMYK Grafik CMYK US CMYK —Menerapkan koreksi warna hingga mendekati output warna Specifications for Web Offset Publishing (SWOP). Euro CMYK —Menerapkan koreksi warna hingga mendekati output warna Euroscale. Vivid CMYK —Meningkatkan saturasi warna dari setelan koreksi  US CMYK . Off (Nonaktif) memodifikasi output warna koreksi warna manual koreksi warna"},{"UUID":"45b2c736-438c-4906-9356-25748e50ae0f","title":"Masalah kualitas warna","link":"modifying-colors-in-printed-output-topic.html","desc":"Tanya-Jawab Umum Pencetakan Warna Apa","descFull":"Tanya-Jawab Umum Pencetakan Warna Apa yang dimaksud dengan RGB? RGB adalah metode deskripsi warna dengan menunjukkan kadar warna merah, hijau, atau biru, yang dipakai untuk menghasilkan suatu warna tertentu. Cahaya merah, hijau, dan biru bisa ditambahkan dengan berbagai macam kadar tertentu untuk menghasilkan begitu banyak warna. Layar komputer, pemindai, serta kamera digital menggunakan metode ini untuk menampilkan warna. Apa yang dimaksud dengan CMYK? CMYK adalah metode deskripsi warna dengan menunjukkan kadar warna cyan, magenta, kuning, dan hitam, yang dipakai untuk mereproduksi satu warna tertentu. Tinta atau toner CMYK bisa dicetak dengan berbagai macam kadar tertentu untuk menghasilkan begitu banyak warna. Mesin cetak, printer inkjet, dan printer laser warna mampu menciptakan warna dengan cara seperti ini. Bagaimana suatu warna ditentukan dalam dokumen yang akan dicetak? Program perangkat lunak digunakan untuk menentukan dan mengubah warna dalam suatu dokumen menggunakan kombinasi warna RGB atau CMYK. Untuk informasi lebih lanjut, lihat topik Bantuan program perangkat lunak. Bagaimana printer tahu warna apa yang akan dicetak? Ketika mencetak dokumen, informasi yang menjelaskan jenis dan warna setiap objek akan dikirim ke printer. Informasi tersebut lalu diteruskan melalui tabel konversi warna. Warna diterjemahkan ke dalam kadar yang tepat pada toner CMYK, yang digunakan untuk memproduksi warna sesuai keinginan Anda. Informasi objek akan menentukan penerapan tabel konversi warna tersebut. Misal, printer bisa menerapkan satu jenis tabel konversi warna pada suatu teks, sembari menerapkan tabel konversi warna lainnya pada suatu foto. Apa yang dimaksud dengan koreksi warna manual? Apabila koreksi warna manual diaktifkan, printer akan memakai tabel konversi warna yang dipilih pengguna untuk memproses objek. Setelan koreksi warna manual dibuat khusus untuk jenis objek yang dicetak (teks, grafik, atau gambar). Ia juga dibuat khusus untuk menentukan warna objek dalam program perangkat lunak (kombinasi RGB atau CMYK). Untuk menerapkan berbagai tabel konversi warna secara manual, buka  . Apabila program tidak menentukan warna dalam kombinasi RGB atau CMYK, koreksi warna manual menjadi tidak berguna. Ia juga tidak akan efektif apabila program atau sistem operasi komputer tidak mengendalikan penyesuaian warna. Di banyak situasi, Koreksi Warna lebih banyak disetel menjadi Otomatis guna menghasilkan warna dokumen yang diinginkan. Bagaimana saya menyesuaikan suatu warna (seperti logo perusahaan)? Pada menu  Quality (Kualitas) , di sana terdapat sembilan kumpulan  Sampel Warna . Kumpulan tersebut juga tersedia dari halaman  Sampel Warna  Embedded Web Server. Apa pun kumpulan sampel warna yang dipilih, ia akan menghasilkan cetakan multi halaman yang terdiri dari ratusan kotak berwarna. Setiap kotak berisi satu kombinasi CMYK atau RGB, tergantung tabel yang dipilih. Warna yang diamati pada setiap kotak diperoleh dengan kombinasi CMYK atau RGB yang diberi label pada kotak tersebut. Dengan memeriksa kumpulan  Sampel Warna , Anda dapat mengidentifikasi kotak dengan warna yang paling dekat dengan warna sedang yang dicocokkan Kombinasi warna pada label kotak dapat digunakan untuk mengubah warna objek dalam program perangkat lunak. Untuk informasi lebih lanjut, lihat topik Bantuan program perangkat lunak. Koreksi warna manual diperlukan untuk menggunakan tabel konversi warna yang dipilih pada objek tertentu. Memilih  Sampel Warna  yang hendak dipakai untuk pencocokan warna sangat dipengaruhi oleh: Setelan  Koreksi Warna  yang sedang digunakan ( Otomatis ,  Nonaktif , atau  Manual ). Jenis objek yang sedang dicetak (teks, grafis, atau gambar). Bagaimana warna objek ditentukan dalam program perangkat lunak (kombinasi RGB atau CMYK). Jika program perangkat lunak tidak menentukan warna dalam kombinasi RGB atau CMYK, maka halaman  Sampel Warna  menjadi tidak berguna. Beberapa program perangkat lunak menyesuaikan kombinasi RGB atau CMYK di program tersebut melalui manajemen warna. Dalam situasi seperti ini, warna pada hasil cetak bisa saja tidak sama dengan apa yang terdapat di halaman  Sampel Warna . masalah kualitas warna Tanya-Jawab Umum Pencetakan Warna pencetakan warna koreksi warna sampel warna"},{"UUID":"b80f3db9-d288-4a9c-8267-f5e5207ab684","title":"Masalah kualitas warna","link":"modifying-colors-in-printed-output-topic.html","desc":"Muncul lapisan warna pada hasil","descFull":"Muncul lapisan warna pada hasil cetak Muncul lapisan warna pada hasil cetak Coba satu atau dua cara berikut: Dari panel kontrol, buka  Settings (Setelan) Print (Cetak) Quality (Kualitas) Advanced Imaging (Pencitraan Lanjutan) , lalu pilih  Color Adjust (Penyesuaian Warna) . Dari panel kontrol, buka  Settings (Setelan) Print (Cetak) Quality (Kualitas) Advanced Imaging (Pencitraan Lanjutan) , pilih  Color Balance (Keseimbangan Warna)  dan sesuaikan setelan. Jika masalah ini tetap ada, hubungi  dukungan pelanggan . Jika masalah ini tetap ada, hubungi  penyalur Anda. . masalah kualitas warna muncul lapisan warna pada hasil cetak muncul lapisan warna pada hasil cetak pemecahan masalah muncul lapisan warna pada hasil cetak"},{"UUID":"ee373b7c-6a04-4637-be04-43da6542dd6b","title":"Menyelesaikan masalah","link":"trb-contacting-customer-support-topic.html","desc":"Menghubungi dukungan pelanggan Menghubungi dukungan","descFull":"Menghubungi dukungan pelanggan Menghubungi dukungan pelanggan Sebelum menghubungi dukungan pelanggan, pastikan Anda memiliki informasi berikut: Masalah printer Pesan eror Jenis model printer dan nomor seri Buka  https://support.lexmark.com  untuk menerima dukungan melalui email atau obrolan, atau telusuri pustaka manual, dokumen dukungan, driver, dan unduhan lainnya. Dukungan teknis via telepon juga tersedia. Untuk wilayah AS atau Kanada, hubungi 1-800-539-6275. Untuk wilayah atau negara lain, buka  direktori kontak dukungan internasional . Kunjungi tempat di mana Anda membeli printer. menghubungi dukungan pelanggan dukungan pelanggan"},{"UUID":"59d6dc8f-94b5-4c6a-936d-4ab3ea55ac67","title":"Menyelesaikan masalah","link":"troubleshooting-chapter.html","desc":"Menghubungi penyalur Anda Sebelum menghubungi","descFull":"Menghubungi penyalur Anda Sebelum menghubungi penyalur Anda, pastikan Anda memiliki informasi berikut: Masalah printer Pesan eror Jenis model printer dan nomor seri menghubungi penyalur Anda penyalur printer"},{"UUID":"11b44b2c-47fa-4219-aedc-b0273f7b2c99","title":"Menyelesaikan masalah","link":"troubleshooting-chapter.html","desc":"Menghubungi bagian dukungan teknis Saat","descFull":"Menghubungi bagian dukungan teknis Saat menghubungi dukungan teknis, jelaskan masalahnya, pesan pada layar printer, dan langkah yang telah Anda jalankan ketika menanganinya. Lihat label di sisi dalam penutup depan atas atau di bagian belakang printer, lalu catat informasi berikut: Model printer Nomor tag layanan atau kode layanan ekspres Untuk informasi lebih lanjut, kunjungi  www.dell.com/support . pemecahan masalah menghubungi bagian dukungan teknis menghubungi bagian dukungan teknis"},{"UUID":"ebca3f0f-84b6-445b-8923-8033f8bcb201","title":"Membuang dan mendaur ulang","link":"recycling-lexmark-products-topic.html","desc":"Mendaur ulang produk Lexmark Mendaur","descFull":"Mendaur ulang produk Lexmark Mendaur ulang produk Lexmark Kunjungi  www.lexmark.com/recycle . Pilih negara atau kawasan Anda. Pilih satu program daur ulang. mendaur ulang produk"},{"UUID":"4fb7586f-390e-45d0-bf59-ad7ad20ccdca","title":"Membuang dan mendaur ulang","link":"recycling-lexmark-packaging-topic.html","desc":"Mendaur ulang kemasan Lexmark Mendaur","descFull":"Mendaur ulang kemasan Lexmark Mendaur ulang kemasan Lexmark Lexmark terus berupaya meminimalkan pengemasan. Lebih sedikit kemasan membantu memastikan bahwa Lexmark diangkut dengan cara yang paling efisien, peka lingkungan, dan lebih sedikit kemasan yang harus dibuang. Efisiensi ini menghasilkan lebih sedikit emisi rumah kaca, hemat energi, dan efisien sumber daya alam. Lexmark juga menawarkan daur ulang komponen kemasan di beberapa negara atau wilayah. Untuk informasi lebih lanjut, buka  www.lexmark.com/recycle . Karton Lexmark dapat didaur ulang 100% jika terdapat fasilitas daur ulang. Beberapa fasilitas bisa jadi tidak ada di daerah Anda. Busa yang digunakan dalam kemasan Lexmark dapat didaur ulang jika terdapat fasilitas daur ulang busa. Beberapa fasilitas bisa jadi tidak ada di daerah Anda. Jika Anda mengembalikan kartrid ke Lexmark, Anda bisa memakai kembali kotak tempat kartrid tersebut. Lexmark akan mendaur ulang kotak tersebut. mendaur ulang produk bahan kemasan"}]

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
WHAT: SublimeText-like Fuzzy Search

USAGE:
  fuzzysort.single('fs', 'Fuzzy Search') // {score: -16}
  fuzzysort.single('test', 'test') // {score: 0}
  fuzzysort.single('doesnt exist', 'target') // null

  fuzzysort.go('mr', ['Monitor.cpp', 'MeshRenderer.cpp'])
  // [{score: -18, target: "MeshRenderer.cpp"}, {score: -6009, target: "Monitor.cpp"}]

  fuzzysort.highlight(fuzzysort.single('fs', 'Fuzzy Search'), '<b>', '</b>')
  // <b>F</b>uzzy <b>S</b>earch
*/

// UMD (Universal Module Definition) for fuzzysort
;(function(root, UMD) {
  if(true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (UMD),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else if(typeof module === 'object' && module.exports) module.exports = UMD()
  else root.fuzzysort = UMD()
})(this, function UMD() { function fuzzysortNew(instanceOptions) {

  var fuzzysort = {

    single: function(search, target, options) {
      if(!search) return null
      if(!isObj(search)) search = fuzzysort.getPreparedSearch(search)

      if(!target) return null
      if(!isObj(target)) target = fuzzysort.getPrepared(target)

      var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
        : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
        : true
      var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
      return algorithm(search, target, search[0])
      // var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
      // var result = algorithm(search, target, search[0])
      // if(result === null) return null
      // if(result.score < threshold) return null
      // return result
    },

    go: function(search, targets, options) {
      if(!search) return noResults
      search = fuzzysort.prepareSearch(search)
      var searchLowerCode = search[0]

      var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
      var limit = options && options.limit || instanceOptions && instanceOptions.limit || 9007199254740991
      var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
        : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
        : true
      var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
      var resultsLen = 0; var limitedCount = 0
      var targetsLen = targets.length

      // This code is copy/pasted 3 times for performance reasons [options.keys, options.key, no keys]

      // options.keys
      if(options && options.keys) {
        var scoreFn = options.scoreFn || defaultScoreFn
        var keys = options.keys
        var keysLen = keys.length
        for(var i = targetsLen - 1; i >= 0; --i) { var obj = targets[i]
          var objResults = new Array(keysLen)
          for (var keyI = keysLen - 1; keyI >= 0; --keyI) {
            var key = keys[keyI]
            var target = getValue(obj, key)
            if(!target) { objResults[keyI] = null; continue }
            if(!isObj(target)) target = fuzzysort.getPrepared(target)

            objResults[keyI] = algorithm(search, target, searchLowerCode)
          }
          objResults.obj = obj // before scoreFn so scoreFn can use it
          var score = scoreFn(objResults)
          if(score === null) continue
          if(score < threshold) continue
          objResults.score = score
          if(resultsLen < limit) { q.add(objResults); ++resultsLen }
          else {
            ++limitedCount
            if(score > q.peek().score) q.replaceTop(objResults)
          }
        }

      // options.key
      } else if(options && options.key) {
        var key = options.key
        for(var i = targetsLen - 1; i >= 0; --i) { var obj = targets[i]
          var target = getValue(obj, key)
          if(!target) continue
          if(!isObj(target)) target = fuzzysort.getPrepared(target)

          var result = algorithm(search, target, searchLowerCode)
          if(result === null) continue
          if(result.score < threshold) continue

          // have to clone result so duplicate targets from different obj can each reference the correct obj
          result = {target:result.target, _targetLowerCodes:null, _nextBeginningIndexes:null, score:result.score, indexes:result.indexes, obj:obj} // hidden

          if(resultsLen < limit) { q.add(result); ++resultsLen }
          else {
            ++limitedCount
            if(result.score > q.peek().score) q.replaceTop(result)
          }
        }

      // no keys
      } else {
        for(var i = targetsLen - 1; i >= 0; --i) { var target = targets[i]
          if(!target) continue
          if(!isObj(target)) target = fuzzysort.getPrepared(target)

          var result = algorithm(search, target, searchLowerCode)
          if(result === null) continue
          if(result.score < threshold) continue
          if(resultsLen < limit) { q.add(result); ++resultsLen }
          else {
            ++limitedCount
            if(result.score > q.peek().score) q.replaceTop(result)
          }
        }
      }

      if(resultsLen === 0) return noResults
      var results = new Array(resultsLen)
      for(var i = resultsLen - 1; i >= 0; --i) results[i] = q.poll()
      results.total = resultsLen + limitedCount
      return results
    },

    goAsync: function(search, targets, options) {
      var canceled = false
      var p = new Promise(function(resolve, reject) {
        if(!search) return resolve(noResults)
        search = fuzzysort.prepareSearch(search)
        var searchLowerCode = search[0]

        var q = fastpriorityqueue()
        var iCurrent = targets.length - 1
        var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
        var limit = options && options.limit || instanceOptions && instanceOptions.limit || 9007199254740991
        var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
          : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
          : true
        var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
        var resultsLen = 0; var limitedCount = 0
        function step() {
          if(canceled) return reject('canceled')

          var startMs = Date.now()

          // This code is copy/pasted 3 times for performance reasons [options.keys, options.key, no keys]

          // options.keys
          if(options && options.keys) {
            var scoreFn = options.scoreFn || defaultScoreFn
            var keys = options.keys
            var keysLen = keys.length
            for(; iCurrent >= 0; --iCurrent) { var obj = targets[iCurrent]
              var objResults = new Array(keysLen)
              for (var keyI = keysLen - 1; keyI >= 0; --keyI) {
                var key = keys[keyI]
                var target = getValue(obj, key)
                if(!target) { objResults[keyI] = null; continue }
                if(!isObj(target)) target = fuzzysort.getPrepared(target)

                objResults[keyI] = algorithm(search, target, searchLowerCode)
              }
              objResults.obj = obj // before scoreFn so scoreFn can use it
              var score = scoreFn(objResults)
              if(score === null) continue
              if(score < threshold) continue
              objResults.score = score
              if(resultsLen < limit) { q.add(objResults); ++resultsLen }
              else {
                ++limitedCount
                if(score > q.peek().score) q.replaceTop(objResults)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }

          // options.key
          } else if(options && options.key) {
            var key = options.key
            for(; iCurrent >= 0; --iCurrent) { var obj = targets[iCurrent]
              var target = getValue(obj, key)
              if(!target) continue
              if(!isObj(target)) target = fuzzysort.getPrepared(target)

              var result = algorithm(search, target, searchLowerCode)
              if(result === null) continue
              if(result.score < threshold) continue

              // have to clone result so duplicate targets from different obj can each reference the correct obj
              result = {target:result.target, _targetLowerCodes:null, _nextBeginningIndexes:null, score:result.score, indexes:result.indexes, obj:obj} // hidden

              if(resultsLen < limit) { q.add(result); ++resultsLen }
              else {
                ++limitedCount
                if(result.score > q.peek().score) q.replaceTop(result)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }

          // no keys
          } else {
            for(; iCurrent >= 0; --iCurrent) { var target = targets[iCurrent]
              if(!target) continue
              if(!isObj(target)) target = fuzzysort.getPrepared(target)

              var result = algorithm(search, target, searchLowerCode)
              if(result === null) continue
              if(result.score < threshold) continue
              if(resultsLen < limit) { q.add(result); ++resultsLen }
              else {
                ++limitedCount
                if(result.score > q.peek().score) q.replaceTop(result)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }
          }

          if(resultsLen === 0) return resolve(noResults)
          var results = new Array(resultsLen)
          for(var i = resultsLen - 1; i >= 0; --i) results[i] = q.poll()
          results.total = resultsLen + limitedCount
          resolve(results)
        }

        isNode?setImmediate(step):step()
      })
      p.cancel = function() { canceled = true }
      return p
    },

    highlight: function(result, hOpen, hClose) {
      if(result === null) return null
      if(hOpen === undefined) hOpen = '<b>'
      if(hClose === undefined) hClose = '</b>'
      var highlighted = ''
      var matchesIndex = 0
      var opened = false
      var target = result.target
      var targetLen = target.length
      var matchesBest = result.indexes
      for(var i = 0; i < targetLen; ++i) { var char = target[i]
        if(matchesBest[matchesIndex] === i) {
          ++matchesIndex
          if(!opened) { opened = true
            highlighted += hOpen
          }

          if(matchesIndex === matchesBest.length) {
            highlighted += char + hClose + target.substr(i+1)
            break
          }
        } else {
          if(opened) { opened = false
            highlighted += hClose
          }
        }
        highlighted += char
      }

      return highlighted
    },

    prepare: function(target) {
      if(!target) return
      return {target:target, _targetLowerCodes:fuzzysort.prepareLowerCodes(target), _nextBeginningIndexes:null, score:null, indexes:null, obj:null} // hidden
    },
    prepareSlow: function(target) {
      if(!target) return
      return {target:target, _targetLowerCodes:fuzzysort.prepareLowerCodes(target), _nextBeginningIndexes:fuzzysort.prepareNextBeginningIndexes(target), score:null, indexes:null, obj:null} // hidden
    },
    prepareSearch: function(search) {
      if(!search) return
      return fuzzysort.prepareLowerCodes(search)
    },



    // Below this point is only internal code
    // Below this point is only internal code
    // Below this point is only internal code
    // Below this point is only internal code



    getPrepared: function(target) {
      if(target.length > 999) return fuzzysort.prepare(target) // don't cache huge targets
      var targetPrepared = preparedCache.get(target)
      if(targetPrepared !== undefined) return targetPrepared
      targetPrepared = fuzzysort.prepare(target)
      preparedCache.set(target, targetPrepared)
      return targetPrepared
    },
    getPreparedSearch: function(search) {
      if(search.length > 999) return fuzzysort.prepareSearch(search) // don't cache huge searches
      var searchPrepared = preparedSearchCache.get(search)
      if(searchPrepared !== undefined) return searchPrepared
      searchPrepared = fuzzysort.prepareSearch(search)
      preparedSearchCache.set(search, searchPrepared)
      return searchPrepared
    },

    algorithm: function(searchLowerCodes, prepared, searchLowerCode) {
      var targetLowerCodes = prepared._targetLowerCodes
      var searchLen = searchLowerCodes.length
      var targetLen = targetLowerCodes.length
      var searchI = 0 // where we at
      var targetI = 0 // where you at
      var typoSimpleI = 0
      var matchesSimpleLen = 0

      // very basic fuzzy match; to remove non-matching targets ASAP!
      // walk through target. find sequential matches.
      // if all chars aren't found then exit
      for(;;) {
        var isMatch = searchLowerCode === targetLowerCodes[targetI]
        if(isMatch) {
          matchesSimple[matchesSimpleLen++] = targetI
          ++searchI; if(searchI === searchLen) break
          searchLowerCode = searchLowerCodes[typoSimpleI===0?searchI : (typoSimpleI===searchI?searchI+1 : (typoSimpleI===searchI-1?searchI-1 : searchI))]
        }

        ++targetI; if(targetI >= targetLen) { // Failed to find searchI
          // Check for typo or exit
          // we go as far as possible before trying to transpose
          // then we transpose backwards until we reach the beginning
          for(;;) {
            if(searchI <= 1) return null // not allowed to transpose first char
            if(typoSimpleI === 0) { // we haven't tried to transpose yet
              --searchI
              var searchLowerCodeNew = searchLowerCodes[searchI]
              if(searchLowerCode === searchLowerCodeNew) continue // doesn't make sense to transpose a repeat char
              typoSimpleI = searchI
            } else {
              if(typoSimpleI === 1) return null // reached the end of the line for transposing
              --typoSimpleI
              searchI = typoSimpleI
              searchLowerCode = searchLowerCodes[searchI + 1]
              var searchLowerCodeNew = searchLowerCodes[searchI]
              if(searchLowerCode === searchLowerCodeNew) continue // doesn't make sense to transpose a repeat char
            }
            matchesSimpleLen = searchI
            targetI = matchesSimple[matchesSimpleLen - 1] + 1
            break
          }
        }
      }

      var searchI = 0
      var typoStrictI = 0
      var successStrict = false
      var matchesStrictLen = 0

      var nextBeginningIndexes = prepared._nextBeginningIndexes
      if(nextBeginningIndexes === null) nextBeginningIndexes = prepared._nextBeginningIndexes = fuzzysort.prepareNextBeginningIndexes(prepared.target)
      var firstPossibleI = targetI = matchesSimple[0]===0 ? 0 : nextBeginningIndexes[matchesSimple[0]-1]

      // Our target string successfully matched all characters in sequence!
      // Let's try a more advanced and strict test to improve the score
      // only count it as a match if it's consecutive or a beginning character!
      if(targetI !== targetLen) for(;;) {
        if(targetI >= targetLen) {
          // We failed to find a good spot for this search char, go back to the previous search char and force it forward
          if(searchI <= 0) { // We failed to push chars forward for a better match
            // transpose, starting from the beginning
            ++typoStrictI; if(typoStrictI > searchLen-2) break
            if(searchLowerCodes[typoStrictI] === searchLowerCodes[typoStrictI+1]) continue // doesn't make sense to transpose a repeat char
            targetI = firstPossibleI
            continue
          }

          --searchI
          var lastMatch = matchesStrict[--matchesStrictLen]
          targetI = nextBeginningIndexes[lastMatch]

        } else {
          var isMatch = searchLowerCodes[typoStrictI===0?searchI : (typoStrictI===searchI?searchI+1 : (typoStrictI===searchI-1?searchI-1 : searchI))] === targetLowerCodes[targetI]
          if(isMatch) {
            matchesStrict[matchesStrictLen++] = targetI
            ++searchI; if(searchI === searchLen) { successStrict = true; break }
            ++targetI
          } else {
            targetI = nextBeginningIndexes[targetI]
          }
        }
      }

      { // tally up the score & keep track of matches for highlighting later
        if(successStrict) { var matchesBest = matchesStrict; var matchesBestLen = matchesStrictLen }
        else { var matchesBest = matchesSimple; var matchesBestLen = matchesSimpleLen }
        var score = 0
        var lastTargetI = -1
        for(var i = 0; i < searchLen; ++i) { var targetI = matchesBest[i]
          // score only goes down if they're not consecutive
          if(lastTargetI !== targetI - 1) score -= targetI
          lastTargetI = targetI
        }
        if(!successStrict) {
          score *= 1000
          if(typoSimpleI !== 0) score += -20/*typoPenalty*/
        } else {
          if(typoStrictI !== 0) score += -20/*typoPenalty*/
        }
        score -= targetLen - searchLen
        prepared.score = score
        prepared.indexes = new Array(matchesBestLen); for(var i = matchesBestLen - 1; i >= 0; --i) prepared.indexes[i] = matchesBest[i]

        return prepared
      }
    },

    algorithmNoTypo: function(searchLowerCodes, prepared, searchLowerCode) {
      var targetLowerCodes = prepared._targetLowerCodes
      var searchLen = searchLowerCodes.length
      var targetLen = targetLowerCodes.length
      var searchI = 0 // where we at
      var targetI = 0 // where you at
      var matchesSimpleLen = 0

      // very basic fuzzy match; to remove non-matching targets ASAP!
      // walk through target. find sequential matches.
      // if all chars aren't found then exit
      for(;;) {
        var isMatch = searchLowerCode === targetLowerCodes[targetI]
        if(isMatch) {
          matchesSimple[matchesSimpleLen++] = targetI
          ++searchI; if(searchI === searchLen) break
          searchLowerCode = searchLowerCodes[searchI]
        }
        ++targetI; if(targetI >= targetLen) return null // Failed to find searchI
      }

      var searchI = 0
      var successStrict = false
      var matchesStrictLen = 0

      var nextBeginningIndexes = prepared._nextBeginningIndexes
      if(nextBeginningIndexes === null) nextBeginningIndexes = prepared._nextBeginningIndexes = fuzzysort.prepareNextBeginningIndexes(prepared.target)
      var firstPossibleI = targetI = matchesSimple[0]===0 ? 0 : nextBeginningIndexes[matchesSimple[0]-1]

      // Our target string successfully matched all characters in sequence!
      // Let's try a more advanced and strict test to improve the score
      // only count it as a match if it's consecutive or a beginning character!
      if(targetI !== targetLen) for(;;) {
        if(targetI >= targetLen) {
          // We failed to find a good spot for this search char, go back to the previous search char and force it forward
          if(searchI <= 0) break // We failed to push chars forward for a better match

          --searchI
          var lastMatch = matchesStrict[--matchesStrictLen]
          targetI = nextBeginningIndexes[lastMatch]

        } else {
          var isMatch = searchLowerCodes[searchI] === targetLowerCodes[targetI]
          if(isMatch) {
            matchesStrict[matchesStrictLen++] = targetI
            ++searchI; if(searchI === searchLen) { successStrict = true; break }
            ++targetI
          } else {
            targetI = nextBeginningIndexes[targetI]
          }
        }
      }

      { // tally up the score & keep track of matches for highlighting later
        if(successStrict) { var matchesBest = matchesStrict; var matchesBestLen = matchesStrictLen }
        else { var matchesBest = matchesSimple; var matchesBestLen = matchesSimpleLen }
        var score = 0
        var lastTargetI = -1
        for(var i = 0; i < searchLen; ++i) { var targetI = matchesBest[i]
          // score only goes down if they're not consecutive
          if(lastTargetI !== targetI - 1) score -= targetI
          lastTargetI = targetI
        }
        if(!successStrict) score *= 1000
        score -= targetLen - searchLen
        prepared.score = score
        prepared.indexes = new Array(matchesBestLen); for(var i = matchesBestLen - 1; i >= 0; --i) prepared.indexes[i] = matchesBest[i]

        return prepared
      }
    },

    prepareLowerCodes: function(str) {
      var strLen = str.length
      var lowerCodes = [] // new Array(strLen)    sparse array is too slow
      var lower = str.toLowerCase()
      for(var i = 0; i < strLen; ++i) lowerCodes[i] = lower.charCodeAt(i)
      return lowerCodes
    },
    prepareBeginningIndexes: function(target) {
      var targetLen = target.length
      var beginningIndexes = []; var beginningIndexesLen = 0
      var wasUpper = false
      var wasAlphanum = false
      for(var i = 0; i < targetLen; ++i) {
        var targetCode = target.charCodeAt(i)
        var isUpper = targetCode>=65&&targetCode<=90
        var isAlphanum = isUpper || targetCode>=97&&targetCode<=122 || targetCode>=48&&targetCode<=57
        var isBeginning = isUpper && !wasUpper || !wasAlphanum || !isAlphanum
        wasUpper = isUpper
        wasAlphanum = isAlphanum
        if(isBeginning) beginningIndexes[beginningIndexesLen++] = i
      }
      return beginningIndexes
    },
    prepareNextBeginningIndexes: function(target) {
      var targetLen = target.length
      var beginningIndexes = fuzzysort.prepareBeginningIndexes(target)
      var nextBeginningIndexes = [] // new Array(targetLen)     sparse array is too slow
      var lastIsBeginning = beginningIndexes[0]
      var lastIsBeginningI = 0
      for(var i = 0; i < targetLen; ++i) {
        if(lastIsBeginning > i) {
          nextBeginningIndexes[i] = lastIsBeginning
        } else {
          lastIsBeginning = beginningIndexes[++lastIsBeginningI]
          nextBeginningIndexes[i] = lastIsBeginning===undefined ? targetLen : lastIsBeginning
        }
      }
      return nextBeginningIndexes
    },

    cleanup: cleanup,
    new: fuzzysortNew,
  }
  return fuzzysort
} // fuzzysortNew

// This stuff is outside fuzzysortNew, because it's shared with instances of fuzzysort.new()
var isNode = "function" !== 'undefined' && typeof window === 'undefined'
// var MAX_INT = Number.MAX_SAFE_INTEGER
// var MIN_INT = Number.MIN_VALUE
var preparedCache = new Map()
var preparedSearchCache = new Map()
var noResults = []; noResults.total = 0
var matchesSimple = []; var matchesStrict = []
function cleanup() { preparedCache.clear(); preparedSearchCache.clear(); matchesSimple = []; matchesStrict = [] }
function defaultScoreFn(a) {
  var max = -9007199254740991
  for (var i = a.length - 1; i >= 0; --i) {
    var result = a[i]; if(result === null) continue
    var score = result.score
    if(score > max) max = score
  }
  if(max === -9007199254740991) return null
  return max
}

// prop = 'key'              2.5ms optimized for this case, seems to be about as fast as direct obj[prop]
// prop = 'key1.key2'        10ms
// prop = ['key1', 'key2']   27ms
function getValue(obj, prop) {
  var tmp = obj[prop]; if(tmp !== undefined) return tmp
  var segs = prop
  if(!Array.isArray(prop)) segs = prop.split('.')
  var len = segs.length
  var i = -1
  while (obj && (++i < len)) obj = obj[segs[i]]
  return obj
}

function isObj(x) { return typeof x === 'object' } // faster as a function

// Hacked version of https://github.com/lemire/FastPriorityQueue.js
var fastpriorityqueue=function(){var r=[],o=0,e={};function n(){for(var e=0,n=r[e],c=1;c<o;){var f=c+1;e=c,f<o&&r[f].score<r[c].score&&(e=f),r[e-1>>1]=r[e],c=1+(e<<1)}for(var a=e-1>>1;e>0&&n.score<r[a].score;a=(e=a)-1>>1)r[e]=r[a];r[e]=n}return e.add=function(e){var n=o;r[o++]=e;for(var c=n-1>>1;n>0&&e.score<r[c].score;c=(n=c)-1>>1)r[n]=r[c];r[n]=e},e.poll=function(){if(0!==o){var e=r[0];return r[0]=r[--o],n(),e}},e.peek=function(e){if(0!==o)return r[0]},e.replaceTop=function(o){r[0]=o,n()},e};
var q = fastpriorityqueue() // reuse this, except for async, it needs to make its own

return fuzzysortNew()
}) // UMD

// TODO: (performance) wasm version!?

// TODO: (performance) layout memory in an optimal way to go fast by avoiding cache misses

// TODO: (performance) preparedCache is a memory leak

// TODO: (like sublime) backslash === forwardslash

// TODO: (performance) i have no idea how well optizmied the allowing typos algorithm is

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).setImmediate))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * lunr - http://lunrjs.com - A bit like Solr, but much smaller and not as bright - 2.3.8
 * Copyright (C) 2019 Oliver Nightingale
 * @license MIT
 */

;(function(){

/**
 * A convenience function for configuring and constructing
 * a new lunr Index.
 *
 * A lunr.Builder instance is created and the pipeline setup
 * with a trimmer, stop word filter and stemmer.
 *
 * This builder object is yielded to the configuration function
 * that is passed as a parameter, allowing the list of fields
 * and other builder parameters to be customised.
 *
 * All documents _must_ be added within the passed config function.
 *
 * @example
 * var idx = lunr(function () {
 *   this.field('title')
 *   this.field('body')
 *   this.ref('id')
 *
 *   documents.forEach(function (doc) {
 *     this.add(doc)
 *   }, this)
 * })
 *
 * @see {@link lunr.Builder}
 * @see {@link lunr.Pipeline}
 * @see {@link lunr.trimmer}
 * @see {@link lunr.stopWordFilter}
 * @see {@link lunr.stemmer}
 * @namespace {function} lunr
 */
var lunr = function (config) {
  var builder = new lunr.Builder

  builder.pipeline.add(
    lunr.trimmer,
    lunr.stopWordFilter,
    lunr.stemmer
  )

  builder.searchPipeline.add(
    lunr.stemmer
  )

  config.call(builder, builder)
  return builder.build()
}

lunr.version = "2.3.8"
/*!
 * lunr.utils
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A namespace containing utils for the rest of the lunr library
 * @namespace lunr.utils
 */
lunr.utils = {}

/**
 * Print a warning message to the console.
 *
 * @param {String} message The message to be printed.
 * @memberOf lunr.utils
 * @function
 */
lunr.utils.warn = (function (global) {
  /* eslint-disable no-console */
  return function (message) {
    if (global.console && console.warn) {
      console.warn(message)
    }
  }
  /* eslint-enable no-console */
})(this)

/**
 * Convert an object to a string.
 *
 * In the case of `null` and `undefined` the function returns
 * the empty string, in all other cases the result of calling
 * `toString` on the passed object is returned.
 *
 * @param {Any} obj The object to convert to a string.
 * @return {String} string representation of the passed object.
 * @memberOf lunr.utils
 */
lunr.utils.asString = function (obj) {
  if (obj === void 0 || obj === null) {
    return ""
  } else {
    return obj.toString()
  }
}

/**
 * Clones an object.
 *
 * Will create a copy of an existing object such that any mutations
 * on the copy cannot affect the original.
 *
 * Only shallow objects are supported, passing a nested object to this
 * function will cause a TypeError.
 *
 * Objects with primitives, and arrays of primitives are supported.
 *
 * @param {Object} obj The object to clone.
 * @return {Object} a clone of the passed object.
 * @throws {TypeError} when a nested object is passed.
 * @memberOf Utils
 */
lunr.utils.clone = function (obj) {
  if (obj === null || obj === undefined) {
    return obj
  }

  var clone = Object.create(null),
      keys = Object.keys(obj)

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i],
        val = obj[key]

    if (Array.isArray(val)) {
      clone[key] = val.slice()
      continue
    }

    if (typeof val === 'string' ||
        typeof val === 'number' ||
        typeof val === 'boolean') {
      clone[key] = val
      continue
    }

    throw new TypeError("clone is not deep and does not support nested objects")
  }

  return clone
}
lunr.FieldRef = function (docRef, fieldName, stringValue) {
  this.docRef = docRef
  this.fieldName = fieldName
  this._stringValue = stringValue
}

lunr.FieldRef.joiner = "/"

lunr.FieldRef.fromString = function (s) {
  var n = s.indexOf(lunr.FieldRef.joiner)

  if (n === -1) {
    throw "malformed field ref string"
  }

  var fieldRef = s.slice(0, n),
      docRef = s.slice(n + 1)

  return new lunr.FieldRef (docRef, fieldRef, s)
}

lunr.FieldRef.prototype.toString = function () {
  if (this._stringValue == undefined) {
    this._stringValue = this.fieldName + lunr.FieldRef.joiner + this.docRef
  }

  return this._stringValue
}
/*!
 * lunr.Set
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A lunr set.
 *
 * @constructor
 */
lunr.Set = function (elements) {
  this.elements = Object.create(null)

  if (elements) {
    this.length = elements.length

    for (var i = 0; i < this.length; i++) {
      this.elements[elements[i]] = true
    }
  } else {
    this.length = 0
  }
}

/**
 * A complete set that contains all elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.complete = {
  intersect: function (other) {
    return other
  },

  union: function (other) {
    return other
  },

  contains: function () {
    return true
  }
}

/**
 * An empty set that contains no elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.empty = {
  intersect: function () {
    return this
  },

  union: function (other) {
    return other
  },

  contains: function () {
    return false
  }
}

/**
 * Returns true if this set contains the specified object.
 *
 * @param {object} object - Object whose presence in this set is to be tested.
 * @returns {boolean} - True if this set contains the specified object.
 */
lunr.Set.prototype.contains = function (object) {
  return !!this.elements[object]
}

/**
 * Returns a new set containing only the elements that are present in both
 * this set and the specified set.
 *
 * @param {lunr.Set} other - set to intersect with this set.
 * @returns {lunr.Set} a new set that is the intersection of this and the specified set.
 */

lunr.Set.prototype.intersect = function (other) {
  var a, b, elements, intersection = []

  if (other === lunr.Set.complete) {
    return this
  }

  if (other === lunr.Set.empty) {
    return other
  }

  if (this.length < other.length) {
    a = this
    b = other
  } else {
    a = other
    b = this
  }

  elements = Object.keys(a.elements)

  for (var i = 0; i < elements.length; i++) {
    var element = elements[i]
    if (element in b.elements) {
      intersection.push(element)
    }
  }

  return new lunr.Set (intersection)
}

/**
 * Returns a new set combining the elements of this and the specified set.
 *
 * @param {lunr.Set} other - set to union with this set.
 * @return {lunr.Set} a new set that is the union of this and the specified set.
 */

lunr.Set.prototype.union = function (other) {
  if (other === lunr.Set.complete) {
    return lunr.Set.complete
  }

  if (other === lunr.Set.empty) {
    return this
  }

  return new lunr.Set(Object.keys(this.elements).concat(Object.keys(other.elements)))
}
/**
 * A function to calculate the inverse document frequency for
 * a posting. This is shared between the builder and the index
 *
 * @private
 * @param {object} posting - The posting for a given term
 * @param {number} documentCount - The total number of documents.
 */
lunr.idf = function (posting, documentCount) {
  var documentsWithTerm = 0

  for (var fieldName in posting) {
    if (fieldName == '_index') continue // Ignore the term index, its not a field
    documentsWithTerm += Object.keys(posting[fieldName]).length
  }

  var x = (documentCount - documentsWithTerm + 0.5) / (documentsWithTerm + 0.5)

  return Math.log(1 + Math.abs(x))
}

/**
 * A token wraps a string representation of a token
 * as it is passed through the text processing pipeline.
 *
 * @constructor
 * @param {string} [str=''] - The string token being wrapped.
 * @param {object} [metadata={}] - Metadata associated with this token.
 */
lunr.Token = function (str, metadata) {
  this.str = str || ""
  this.metadata = metadata || {}
}

/**
 * Returns the token string that is being wrapped by this object.
 *
 * @returns {string}
 */
lunr.Token.prototype.toString = function () {
  return this.str
}

/**
 * A token update function is used when updating or optionally
 * when cloning a token.
 *
 * @callback lunr.Token~updateFunction
 * @param {string} str - The string representation of the token.
 * @param {Object} metadata - All metadata associated with this token.
 */

/**
 * Applies the given function to the wrapped string token.
 *
 * @example
 * token.update(function (str, metadata) {
 *   return str.toUpperCase()
 * })
 *
 * @param {lunr.Token~updateFunction} fn - A function to apply to the token string.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.update = function (fn) {
  this.str = fn(this.str, this.metadata)
  return this
}

/**
 * Creates a clone of this token. Optionally a function can be
 * applied to the cloned token.
 *
 * @param {lunr.Token~updateFunction} [fn] - An optional function to apply to the cloned token.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.clone = function (fn) {
  fn = fn || function (s) { return s }
  return new lunr.Token (fn(this.str, this.metadata), this.metadata)
}
/*!
 * lunr.tokenizer
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A function for splitting a string into tokens ready to be inserted into
 * the search index. Uses `lunr.tokenizer.separator` to split strings, change
 * the value of this property to change how strings are split into tokens.
 *
 * This tokenizer will convert its parameter to a string by calling `toString` and
 * then will split this string on the character in `lunr.tokenizer.separator`.
 * Arrays will have their elements converted to strings and wrapped in a lunr.Token.
 *
 * Optional metadata can be passed to the tokenizer, this metadata will be cloned and
 * added as metadata to every token that is created from the object to be tokenized.
 *
 * @static
 * @param {?(string|object|object[])} obj - The object to convert into tokens
 * @param {?object} metadata - Optional metadata to associate with every token
 * @returns {lunr.Token[]}
 * @see {@link lunr.Pipeline}
 */
lunr.tokenizer = function (obj, metadata) {
  if (obj == null || obj == undefined) {
    return []
  }

  if (Array.isArray(obj)) {
    return obj.map(function (t) {
      return new lunr.Token(
        lunr.utils.asString(t).toLowerCase(),
        lunr.utils.clone(metadata)
      )
    })
  }

  var str = obj.toString().toLowerCase(),
      len = str.length,
      tokens = []

  for (var sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
    var char = str.charAt(sliceEnd),
        sliceLength = sliceEnd - sliceStart

    if ((char.match(lunr.tokenizer.separator) || sliceEnd == len)) {

      if (sliceLength > 0) {
        var tokenMetadata = lunr.utils.clone(metadata) || {}
        tokenMetadata["position"] = [sliceStart, sliceLength]
        tokenMetadata["index"] = tokens.length

        tokens.push(
          new lunr.Token (
            str.slice(sliceStart, sliceEnd),
            tokenMetadata
          )
        )
      }

      sliceStart = sliceEnd + 1
    }

  }

  return tokens
}

/**
 * The separator used to split a string into tokens. Override this property to change the behaviour of
 * `lunr.tokenizer` behaviour when tokenizing strings. By default this splits on whitespace and hyphens.
 *
 * @static
 * @see lunr.tokenizer
 */
lunr.tokenizer.separator = /[\s\-]+/
/*!
 * lunr.Pipeline
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.Pipelines maintain an ordered list of functions to be applied to all
 * tokens in documents entering the search index and queries being ran against
 * the index.
 *
 * An instance of lunr.Index created with the lunr shortcut will contain a
 * pipeline with a stop word filter and an English language stemmer. Extra
 * functions can be added before or after either of these functions or these
 * default functions can be removed.
 *
 * When run the pipeline will call each function in turn, passing a token, the
 * index of that token in the original list of all tokens and finally a list of
 * all the original tokens.
 *
 * The output of functions in the pipeline will be passed to the next function
 * in the pipeline. To exclude a token from entering the index the function
 * should return undefined, the rest of the pipeline will not be called with
 * this token.
 *
 * For serialisation of pipelines to work, all functions used in an instance of
 * a pipeline should be registered with lunr.Pipeline. Registered functions can
 * then be loaded. If trying to load a serialised pipeline that uses functions
 * that are not registered an error will be thrown.
 *
 * If not planning on serialising the pipeline then registering pipeline functions
 * is not necessary.
 *
 * @constructor
 */
lunr.Pipeline = function () {
  this._stack = []
}

lunr.Pipeline.registeredFunctions = Object.create(null)

/**
 * A pipeline function maps lunr.Token to lunr.Token. A lunr.Token contains the token
 * string as well as all known metadata. A pipeline function can mutate the token string
 * or mutate (or add) metadata for a given token.
 *
 * A pipeline function can indicate that the passed token should be discarded by returning
 * null, undefined or an empty string. This token will not be passed to any downstream pipeline
 * functions and will not be added to the index.
 *
 * Multiple tokens can be returned by returning an array of tokens. Each token will be passed
 * to any downstream pipeline functions and all will returned tokens will be added to the index.
 *
 * Any number of pipeline functions may be chained together using a lunr.Pipeline.
 *
 * @interface lunr.PipelineFunction
 * @param {lunr.Token} token - A token from the document being processed.
 * @param {number} i - The index of this token in the complete list of tokens for this document/field.
 * @param {lunr.Token[]} tokens - All tokens for this document/field.
 * @returns {(?lunr.Token|lunr.Token[])}
 */

/**
 * Register a function with the pipeline.
 *
 * Functions that are used in the pipeline should be registered if the pipeline
 * needs to be serialised, or a serialised pipeline needs to be loaded.
 *
 * Registering a function does not add it to a pipeline, functions must still be
 * added to instances of the pipeline for them to be used when running a pipeline.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @param {String} label - The label to register this function with
 */
lunr.Pipeline.registerFunction = function (fn, label) {
  if (label in this.registeredFunctions) {
    lunr.utils.warn('Overwriting existing registered function: ' + label)
  }

  fn.label = label
  lunr.Pipeline.registeredFunctions[fn.label] = fn
}

/**
 * Warns if the function is not registered as a Pipeline function.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @private
 */
lunr.Pipeline.warnIfFunctionNotRegistered = function (fn) {
  var isRegistered = fn.label && (fn.label in this.registeredFunctions)

  if (!isRegistered) {
    lunr.utils.warn('Function is not registered with pipeline. This may cause problems when serialising the index.\n', fn)
  }
}

/**
 * Loads a previously serialised pipeline.
 *
 * All functions to be loaded must already be registered with lunr.Pipeline.
 * If any function from the serialised data has not been registered then an
 * error will be thrown.
 *
 * @param {Object} serialised - The serialised pipeline to load.
 * @returns {lunr.Pipeline}
 */
lunr.Pipeline.load = function (serialised) {
  var pipeline = new lunr.Pipeline

  serialised.forEach(function (fnName) {
    var fn = lunr.Pipeline.registeredFunctions[fnName]

    if (fn) {
      pipeline.add(fn)
    } else {
      throw new Error('Cannot load unregistered function: ' + fnName)
    }
  })

  return pipeline
}

/**
 * Adds new functions to the end of the pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction[]} functions - Any number of functions to add to the pipeline.
 */
lunr.Pipeline.prototype.add = function () {
  var fns = Array.prototype.slice.call(arguments)

  fns.forEach(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)
    this._stack.push(fn)
  }, this)
}

/**
 * Adds a single function after a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.after = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  pos = pos + 1
  this._stack.splice(pos, 0, newFn)
}

/**
 * Adds a single function before a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.before = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  this._stack.splice(pos, 0, newFn)
}

/**
 * Removes a function from the pipeline.
 *
 * @param {lunr.PipelineFunction} fn The function to remove from the pipeline.
 */
lunr.Pipeline.prototype.remove = function (fn) {
  var pos = this._stack.indexOf(fn)
  if (pos == -1) {
    return
  }

  this._stack.splice(pos, 1)
}

/**
 * Runs the current list of functions that make up the pipeline against the
 * passed tokens.
 *
 * @param {Array} tokens The tokens to run through the pipeline.
 * @returns {Array}
 */
lunr.Pipeline.prototype.run = function (tokens) {
  var stackLength = this._stack.length

  for (var i = 0; i < stackLength; i++) {
    var fn = this._stack[i]
    var memo = []

    for (var j = 0; j < tokens.length; j++) {
      var result = fn(tokens[j], j, tokens)

      if (result === null || result === void 0 || result === '') continue

      if (Array.isArray(result)) {
        for (var k = 0; k < result.length; k++) {
          memo.push(result[k])
        }
      } else {
        memo.push(result)
      }
    }

    tokens = memo
  }

  return tokens
}

/**
 * Convenience method for passing a string through a pipeline and getting
 * strings out. This method takes care of wrapping the passed string in a
 * token and mapping the resulting tokens back to strings.
 *
 * @param {string} str - The string to pass through the pipeline.
 * @param {?object} metadata - Optional metadata to associate with the token
 * passed to the pipeline.
 * @returns {string[]}
 */
lunr.Pipeline.prototype.runString = function (str, metadata) {
  var token = new lunr.Token (str, metadata)

  return this.run([token]).map(function (t) {
    return t.toString()
  })
}

/**
 * Resets the pipeline by removing any existing processors.
 *
 */
lunr.Pipeline.prototype.reset = function () {
  this._stack = []
}

/**
 * Returns a representation of the pipeline ready for serialisation.
 *
 * Logs a warning if the function has not been registered.
 *
 * @returns {Array}
 */
lunr.Pipeline.prototype.toJSON = function () {
  return this._stack.map(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)

    return fn.label
  })
}
/*!
 * lunr.Vector
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A vector is used to construct the vector space of documents and queries. These
 * vectors support operations to determine the similarity between two documents or
 * a document and a query.
 *
 * Normally no parameters are required for initializing a vector, but in the case of
 * loading a previously dumped vector the raw elements can be provided to the constructor.
 *
 * For performance reasons vectors are implemented with a flat array, where an elements
 * index is immediately followed by its value. E.g. [index, value, index, value]. This
 * allows the underlying array to be as sparse as possible and still offer decent
 * performance when being used for vector calculations.
 *
 * @constructor
 * @param {Number[]} [elements] - The flat list of element index and element value pairs.
 */
lunr.Vector = function (elements) {
  this._magnitude = 0
  this.elements = elements || []
}


/**
 * Calculates the position within the vector to insert a given index.
 *
 * This is used internally by insert and upsert. If there are duplicate indexes then
 * the position is returned as if the value for that index were to be updated, but it
 * is the callers responsibility to check whether there is a duplicate at that index
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @returns {Number}
 */
lunr.Vector.prototype.positionForIndex = function (index) {
  // For an empty vector the tuple can be inserted at the beginning
  if (this.elements.length == 0) {
    return 0
  }

  var start = 0,
      end = this.elements.length / 2,
      sliceLength = end - start,
      pivotPoint = Math.floor(sliceLength / 2),
      pivotIndex = this.elements[pivotPoint * 2]

  while (sliceLength > 1) {
    if (pivotIndex < index) {
      start = pivotPoint
    }

    if (pivotIndex > index) {
      end = pivotPoint
    }

    if (pivotIndex == index) {
      break
    }

    sliceLength = end - start
    pivotPoint = start + Math.floor(sliceLength / 2)
    pivotIndex = this.elements[pivotPoint * 2]
  }

  if (pivotIndex == index) {
    return pivotPoint * 2
  }

  if (pivotIndex > index) {
    return pivotPoint * 2
  }

  if (pivotIndex < index) {
    return (pivotPoint + 1) * 2
  }
}

/**
 * Inserts an element at an index within the vector.
 *
 * Does not allow duplicates, will throw an error if there is already an entry
 * for this index.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 */
lunr.Vector.prototype.insert = function (insertIdx, val) {
  this.upsert(insertIdx, val, function () {
    throw "duplicate index"
  })
}

/**
 * Inserts or updates an existing index within the vector.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 * @param {function} fn - A function that is called for updates, the existing value and the
 * requested value are passed as arguments
 */
lunr.Vector.prototype.upsert = function (insertIdx, val, fn) {
  this._magnitude = 0
  var position = this.positionForIndex(insertIdx)

  if (this.elements[position] == insertIdx) {
    this.elements[position + 1] = fn(this.elements[position + 1], val)
  } else {
    this.elements.splice(position, 0, insertIdx, val)
  }
}

/**
 * Calculates the magnitude of this vector.
 *
 * @returns {Number}
 */
lunr.Vector.prototype.magnitude = function () {
  if (this._magnitude) return this._magnitude

  var sumOfSquares = 0,
      elementsLength = this.elements.length

  for (var i = 1; i < elementsLength; i += 2) {
    var val = this.elements[i]
    sumOfSquares += val * val
  }

  return this._magnitude = Math.sqrt(sumOfSquares)
}

/**
 * Calculates the dot product of this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The vector to compute the dot product with.
 * @returns {Number}
 */
lunr.Vector.prototype.dot = function (otherVector) {
  var dotProduct = 0,
      a = this.elements, b = otherVector.elements,
      aLen = a.length, bLen = b.length,
      aVal = 0, bVal = 0,
      i = 0, j = 0

  while (i < aLen && j < bLen) {
    aVal = a[i], bVal = b[j]
    if (aVal < bVal) {
      i += 2
    } else if (aVal > bVal) {
      j += 2
    } else if (aVal == bVal) {
      dotProduct += a[i + 1] * b[j + 1]
      i += 2
      j += 2
    }
  }

  return dotProduct
}

/**
 * Calculates the similarity between this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The other vector to calculate the
 * similarity with.
 * @returns {Number}
 */
lunr.Vector.prototype.similarity = function (otherVector) {
  return this.dot(otherVector) / this.magnitude() || 0
}

/**
 * Converts the vector to an array of the elements within the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toArray = function () {
  var output = new Array (this.elements.length / 2)

  for (var i = 1, j = 0; i < this.elements.length; i += 2, j++) {
    output[j] = this.elements[i]
  }

  return output
}

/**
 * A JSON serializable representation of the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toJSON = function () {
  return this.elements
}
/* eslint-disable */
/*!
 * lunr.stemmer
 * Copyright (C) 2019 Oliver Nightingale
 * Includes code from - http://tartarus.org/~martin/PorterStemmer/js.txt
 */

/**
 * lunr.stemmer is an english language stemmer, this is a JavaScript
 * implementation of the PorterStemmer taken from http://tartarus.org/~martin
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token - The string to stem
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 * @function
 */
lunr.stemmer = (function(){
  var step2list = {
      "ational" : "ate",
      "tional" : "tion",
      "enci" : "ence",
      "anci" : "ance",
      "izer" : "ize",
      "bli" : "ble",
      "alli" : "al",
      "entli" : "ent",
      "eli" : "e",
      "ousli" : "ous",
      "ization" : "ize",
      "ation" : "ate",
      "ator" : "ate",
      "alism" : "al",
      "iveness" : "ive",
      "fulness" : "ful",
      "ousness" : "ous",
      "aliti" : "al",
      "iviti" : "ive",
      "biliti" : "ble",
      "logi" : "log"
    },

    step3list = {
      "icate" : "ic",
      "ative" : "",
      "alize" : "al",
      "iciti" : "ic",
      "ical" : "ic",
      "ful" : "",
      "ness" : ""
    },

    c = "[^aeiou]",          // consonant
    v = "[aeiouy]",          // vowel
    C = c + "[^aeiouy]*",    // consonant sequence
    V = v + "[aeiou]*",      // vowel sequence

    mgr0 = "^(" + C + ")?" + V + C,               // [C]VC... is m>0
    meq1 = "^(" + C + ")?" + V + C + "(" + V + ")?$",  // [C]VC[V] is m=1
    mgr1 = "^(" + C + ")?" + V + C + V + C,       // [C]VCVC... is m>1
    s_v = "^(" + C + ")?" + v;                   // vowel in stem

  var re_mgr0 = new RegExp(mgr0);
  var re_mgr1 = new RegExp(mgr1);
  var re_meq1 = new RegExp(meq1);
  var re_s_v = new RegExp(s_v);

  var re_1a = /^(.+?)(ss|i)es$/;
  var re2_1a = /^(.+?)([^s])s$/;
  var re_1b = /^(.+?)eed$/;
  var re2_1b = /^(.+?)(ed|ing)$/;
  var re_1b_2 = /.$/;
  var re2_1b_2 = /(at|bl|iz)$/;
  var re3_1b_2 = new RegExp("([^aeiouylsz])\\1$");
  var re4_1b_2 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var re_1c = /^(.+?[^aeiou])y$/;
  var re_2 = /^(.+?)(ational|tional|enci|anci|izer|bli|alli|entli|eli|ousli|ization|ation|ator|alism|iveness|fulness|ousness|aliti|iviti|biliti|logi)$/;

  var re_3 = /^(.+?)(icate|ative|alize|iciti|ical|ful|ness)$/;

  var re_4 = /^(.+?)(al|ance|ence|er|ic|able|ible|ant|ement|ment|ent|ou|ism|ate|iti|ous|ive|ize)$/;
  var re2_4 = /^(.+?)(s|t)(ion)$/;

  var re_5 = /^(.+?)e$/;
  var re_5_1 = /ll$/;
  var re3_5 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var porterStemmer = function porterStemmer(w) {
    var stem,
      suffix,
      firstch,
      re,
      re2,
      re3,
      re4;

    if (w.length < 3) { return w; }

    firstch = w.substr(0,1);
    if (firstch == "y") {
      w = firstch.toUpperCase() + w.substr(1);
    }

    // Step 1a
    re = re_1a
    re2 = re2_1a;

    if (re.test(w)) { w = w.replace(re,"$1$2"); }
    else if (re2.test(w)) { w = w.replace(re2,"$1$2"); }

    // Step 1b
    re = re_1b;
    re2 = re2_1b;
    if (re.test(w)) {
      var fp = re.exec(w);
      re = re_mgr0;
      if (re.test(fp[1])) {
        re = re_1b_2;
        w = w.replace(re,"");
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1];
      re2 = re_s_v;
      if (re2.test(stem)) {
        w = stem;
        re2 = re2_1b_2;
        re3 = re3_1b_2;
        re4 = re4_1b_2;
        if (re2.test(w)) { w = w + "e"; }
        else if (re3.test(w)) { re = re_1b_2; w = w.replace(re,""); }
        else if (re4.test(w)) { w = w + "e"; }
      }
    }

    // Step 1c - replace suffix y or Y by i if preceded by a non-vowel which is not the first letter of the word (so cry -> cri, by -> by, say -> say)
    re = re_1c;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      w = stem + "i";
    }

    // Step 2
    re = re_2;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step2list[suffix];
      }
    }

    // Step 3
    re = re_3;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step3list[suffix];
      }
    }

    // Step 4
    re = re_4;
    re2 = re2_4;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      if (re.test(stem)) {
        w = stem;
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1] + fp[2];
      re2 = re_mgr1;
      if (re2.test(stem)) {
        w = stem;
      }
    }

    // Step 5
    re = re_5;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      re2 = re_meq1;
      re3 = re3_5;
      if (re.test(stem) || (re2.test(stem) && !(re3.test(stem)))) {
        w = stem;
      }
    }

    re = re_5_1;
    re2 = re_mgr1;
    if (re.test(w) && re2.test(w)) {
      re = re_1b_2;
      w = w.replace(re,"");
    }

    // and turn initial Y back to y

    if (firstch == "y") {
      w = firstch.toLowerCase() + w.substr(1);
    }

    return w;
  };

  return function (token) {
    return token.update(porterStemmer);
  }
})();

lunr.Pipeline.registerFunction(lunr.stemmer, 'stemmer')
/*!
 * lunr.stopWordFilter
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.generateStopWordFilter builds a stopWordFilter function from the provided
 * list of stop words.
 *
 * The built in lunr.stopWordFilter is built using this generator and can be used
 * to generate custom stopWordFilters for applications or non English languages.
 *
 * @function
 * @param {Array} token The token to pass through the filter
 * @returns {lunr.PipelineFunction}
 * @see lunr.Pipeline
 * @see lunr.stopWordFilter
 */
lunr.generateStopWordFilter = function (stopWords) {
  var words = stopWords.reduce(function (memo, stopWord) {
    memo[stopWord] = stopWord
    return memo
  }, {})

  return function (token) {
    if (token && words[token.toString()] !== token.toString()) return token
  }
}

/**
 * lunr.stopWordFilter is an English language stop word list filter, any words
 * contained in the list will not be passed through the filter.
 *
 * This is intended to be used in the Pipeline. If the token does not pass the
 * filter then undefined will be returned.
 *
 * @function
 * @implements {lunr.PipelineFunction}
 * @params {lunr.Token} token - A token to check for being a stop word.
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 */
lunr.stopWordFilter = lunr.generateStopWordFilter([
  'a',
  'able',
  'about',
  'across',
  'after',
  'all',
  'almost',
  'also',
  'am',
  'among',
  'an',
  'and',
  'any',
  'are',
  'as',
  'at',
  'be',
  'because',
  'been',
  'but',
  'by',
  'can',
  'cannot',
  'could',
  'dear',
  'did',
  'do',
  'does',
  'either',
  'else',
  'ever',
  'every',
  'for',
  'from',
  'get',
  'got',
  'had',
  'has',
  'have',
  'he',
  'her',
  'hers',
  'him',
  'his',
  'how',
  'however',
  'i',
  'if',
  'in',
  'into',
  'is',
  'it',
  'its',
  'just',
  'least',
  'let',
  'like',
  'likely',
  'may',
  'me',
  'might',
  'most',
  'must',
  'my',
  'neither',
  'no',
  'nor',
  'not',
  'of',
  'off',
  'often',
  'on',
  'only',
  'or',
  'other',
  'our',
  'own',
  'rather',
  'said',
  'say',
  'says',
  'she',
  'should',
  'since',
  'so',
  'some',
  'than',
  'that',
  'the',
  'their',
  'them',
  'then',
  'there',
  'these',
  'they',
  'this',
  'tis',
  'to',
  'too',
  'twas',
  'us',
  'wants',
  'was',
  'we',
  'were',
  'what',
  'when',
  'where',
  'which',
  'while',
  'who',
  'whom',
  'why',
  'will',
  'with',
  'would',
  'yet',
  'you',
  'your'
])

lunr.Pipeline.registerFunction(lunr.stopWordFilter, 'stopWordFilter')
/*!
 * lunr.trimmer
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.trimmer is a pipeline function for trimming non word
 * characters from the beginning and end of tokens before they
 * enter the index.
 *
 * This implementation may not work correctly for non latin
 * characters and should either be removed or adapted for use
 * with languages with non-latin characters.
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token The token to pass through the filter
 * @returns {lunr.Token}
 * @see lunr.Pipeline
 */
lunr.trimmer = function (token) {
  return token.update(function (s) {
    return s.replace(/^\W+/, '').replace(/\W+$/, '')
  })
}

lunr.Pipeline.registerFunction(lunr.trimmer, 'trimmer')
/*!
 * lunr.TokenSet
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A token set is used to store the unique list of all tokens
 * within an index. Token sets are also used to represent an
 * incoming query to the index, this query token set and index
 * token set are then intersected to find which tokens to look
 * up in the inverted index.
 *
 * A token set can hold multiple tokens, as in the case of the
 * index token set, or it can hold a single token as in the
 * case of a simple query token set.
 *
 * Additionally token sets are used to perform wildcard matching.
 * Leading, contained and trailing wildcards are supported, and
 * from this edit distance matching can also be provided.
 *
 * Token sets are implemented as a minimal finite state automata,
 * where both common prefixes and suffixes are shared between tokens.
 * This helps to reduce the space used for storing the token set.
 *
 * @constructor
 */
lunr.TokenSet = function () {
  this.final = false
  this.edges = {}
  this.id = lunr.TokenSet._nextId
  lunr.TokenSet._nextId += 1
}

/**
 * Keeps track of the next, auto increment, identifier to assign
 * to a new tokenSet.
 *
 * TokenSets require a unique identifier to be correctly minimised.
 *
 * @private
 */
lunr.TokenSet._nextId = 1

/**
 * Creates a TokenSet instance from the given sorted array of words.
 *
 * @param {String[]} arr - A sorted array of strings to create the set from.
 * @returns {lunr.TokenSet}
 * @throws Will throw an error if the input array is not sorted.
 */
lunr.TokenSet.fromArray = function (arr) {
  var builder = new lunr.TokenSet.Builder

  for (var i = 0, len = arr.length; i < len; i++) {
    builder.insert(arr[i])
  }

  builder.finish()
  return builder.root
}

/**
 * Creates a token set from a query clause.
 *
 * @private
 * @param {Object} clause - A single clause from lunr.Query.
 * @param {string} clause.term - The query clause term.
 * @param {number} [clause.editDistance] - The optional edit distance for the term.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromClause = function (clause) {
  if ('editDistance' in clause) {
    return lunr.TokenSet.fromFuzzyString(clause.term, clause.editDistance)
  } else {
    return lunr.TokenSet.fromString(clause.term)
  }
}

/**
 * Creates a token set representing a single string with a specified
 * edit distance.
 *
 * Insertions, deletions, substitutions and transpositions are each
 * treated as an edit distance of 1.
 *
 * Increasing the allowed edit distance will have a dramatic impact
 * on the performance of both creating and intersecting these TokenSets.
 * It is advised to keep the edit distance less than 3.
 *
 * @param {string} str - The string to create the token set from.
 * @param {number} editDistance - The allowed edit distance to match.
 * @returns {lunr.Vector}
 */
lunr.TokenSet.fromFuzzyString = function (str, editDistance) {
  var root = new lunr.TokenSet

  var stack = [{
    node: root,
    editsRemaining: editDistance,
    str: str
  }]

  while (stack.length) {
    var frame = stack.pop()

    // no edit
    if (frame.str.length > 0) {
      var char = frame.str.charAt(0),
          noEditNode

      if (char in frame.node.edges) {
        noEditNode = frame.node.edges[char]
      } else {
        noEditNode = new lunr.TokenSet
        frame.node.edges[char] = noEditNode
      }

      if (frame.str.length == 1) {
        noEditNode.final = true
      }

      stack.push({
        node: noEditNode,
        editsRemaining: frame.editsRemaining,
        str: frame.str.slice(1)
      })
    }

    if (frame.editsRemaining == 0) {
      continue
    }

    // insertion
    if ("*" in frame.node.edges) {
      var insertionNode = frame.node.edges["*"]
    } else {
      var insertionNode = new lunr.TokenSet
      frame.node.edges["*"] = insertionNode
    }

    if (frame.str.length == 0) {
      insertionNode.final = true
    }

    stack.push({
      node: insertionNode,
      editsRemaining: frame.editsRemaining - 1,
      str: frame.str
    })

    // deletion
    // can only do a deletion if we have enough edits remaining
    // and if there are characters left to delete in the string
    if (frame.str.length > 1) {
      stack.push({
        node: frame.node,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // deletion
    // just removing the last character from the str
    if (frame.str.length == 1) {
      frame.node.final = true
    }

    // substitution
    // can only do a substitution if we have enough edits remaining
    // and if there are characters left to substitute
    if (frame.str.length >= 1) {
      if ("*" in frame.node.edges) {
        var substitutionNode = frame.node.edges["*"]
      } else {
        var substitutionNode = new lunr.TokenSet
        frame.node.edges["*"] = substitutionNode
      }

      if (frame.str.length == 1) {
        substitutionNode.final = true
      }

      stack.push({
        node: substitutionNode,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // transposition
    // can only do a transposition if there are edits remaining
    // and there are enough characters to transpose
    if (frame.str.length > 1) {
      var charA = frame.str.charAt(0),
          charB = frame.str.charAt(1),
          transposeNode

      if (charB in frame.node.edges) {
        transposeNode = frame.node.edges[charB]
      } else {
        transposeNode = new lunr.TokenSet
        frame.node.edges[charB] = transposeNode
      }

      if (frame.str.length == 1) {
        transposeNode.final = true
      }

      stack.push({
        node: transposeNode,
        editsRemaining: frame.editsRemaining - 1,
        str: charA + frame.str.slice(2)
      })
    }
  }

  return root
}

/**
 * Creates a TokenSet from a string.
 *
 * The string may contain one or more wildcard characters (*)
 * that will allow wildcard matching when intersecting with
 * another TokenSet.
 *
 * @param {string} str - The string to create a TokenSet from.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromString = function (str) {
  var node = new lunr.TokenSet,
      root = node

  /*
   * Iterates through all characters within the passed string
   * appending a node for each character.
   *
   * When a wildcard character is found then a self
   * referencing edge is introduced to continually match
   * any number of any characters.
   */
  for (var i = 0, len = str.length; i < len; i++) {
    var char = str[i],
        final = (i == len - 1)

    if (char == "*") {
      node.edges[char] = node
      node.final = final

    } else {
      var next = new lunr.TokenSet
      next.final = final

      node.edges[char] = next
      node = next
    }
  }

  return root
}

/**
 * Converts this TokenSet into an array of strings
 * contained within the TokenSet.
 *
 * This is not intended to be used on a TokenSet that
 * contains wildcards, in these cases the results are
 * undefined and are likely to cause an infinite loop.
 *
 * @returns {string[]}
 */
lunr.TokenSet.prototype.toArray = function () {
  var words = []

  var stack = [{
    prefix: "",
    node: this
  }]

  while (stack.length) {
    var frame = stack.pop(),
        edges = Object.keys(frame.node.edges),
        len = edges.length

    if (frame.node.final) {
      /* In Safari, at this point the prefix is sometimes corrupted, see:
       * https://github.com/olivernn/lunr.js/issues/279 Calling any
       * String.prototype method forces Safari to "cast" this string to what
       * it's supposed to be, fixing the bug. */
      frame.prefix.charAt(0)
      words.push(frame.prefix)
    }

    for (var i = 0; i < len; i++) {
      var edge = edges[i]

      stack.push({
        prefix: frame.prefix.concat(edge),
        node: frame.node.edges[edge]
      })
    }
  }

  return words
}

/**
 * Generates a string representation of a TokenSet.
 *
 * This is intended to allow TokenSets to be used as keys
 * in objects, largely to aid the construction and minimisation
 * of a TokenSet. As such it is not designed to be a human
 * friendly representation of the TokenSet.
 *
 * @returns {string}
 */
lunr.TokenSet.prototype.toString = function () {
  // NOTE: Using Object.keys here as this.edges is very likely
  // to enter 'hash-mode' with many keys being added
  //
  // avoiding a for-in loop here as it leads to the function
  // being de-optimised (at least in V8). From some simple
  // benchmarks the performance is comparable, but allowing
  // V8 to optimize may mean easy performance wins in the future.

  if (this._str) {
    return this._str
  }

  var str = this.final ? '1' : '0',
      labels = Object.keys(this.edges).sort(),
      len = labels.length

  for (var i = 0; i < len; i++) {
    var label = labels[i],
        node = this.edges[label]

    str = str + label + node.id
  }

  return str
}

/**
 * Returns a new TokenSet that is the intersection of
 * this TokenSet and the passed TokenSet.
 *
 * This intersection will take into account any wildcards
 * contained within the TokenSet.
 *
 * @param {lunr.TokenSet} b - An other TokenSet to intersect with.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.prototype.intersect = function (b) {
  var output = new lunr.TokenSet,
      frame = undefined

  var stack = [{
    qNode: b,
    output: output,
    node: this
  }]

  while (stack.length) {
    frame = stack.pop()

    // NOTE: As with the #toString method, we are using
    // Object.keys and a for loop instead of a for-in loop
    // as both of these objects enter 'hash' mode, causing
    // the function to be de-optimised in V8
    var qEdges = Object.keys(frame.qNode.edges),
        qLen = qEdges.length,
        nEdges = Object.keys(frame.node.edges),
        nLen = nEdges.length

    for (var q = 0; q < qLen; q++) {
      var qEdge = qEdges[q]

      for (var n = 0; n < nLen; n++) {
        var nEdge = nEdges[n]

        if (nEdge == qEdge || qEdge == '*') {
          var node = frame.node.edges[nEdge],
              qNode = frame.qNode.edges[qEdge],
              final = node.final && qNode.final,
              next = undefined

          if (nEdge in frame.output.edges) {
            // an edge already exists for this character
            // no need to create a new node, just set the finality
            // bit unless this node is already final
            next = frame.output.edges[nEdge]
            next.final = next.final || final

          } else {
            // no edge exists yet, must create one
            // set the finality bit and insert it
            // into the output
            next = new lunr.TokenSet
            next.final = final
            frame.output.edges[nEdge] = next
          }

          stack.push({
            qNode: qNode,
            output: next,
            node: node
          })
        }
      }
    }
  }

  return output
}
lunr.TokenSet.Builder = function () {
  this.previousWord = ""
  this.root = new lunr.TokenSet
  this.uncheckedNodes = []
  this.minimizedNodes = {}
}

lunr.TokenSet.Builder.prototype.insert = function (word) {
  var node,
      commonPrefix = 0

  if (word < this.previousWord) {
    throw new Error ("Out of order word insertion")
  }

  for (var i = 0; i < word.length && i < this.previousWord.length; i++) {
    if (word[i] != this.previousWord[i]) break
    commonPrefix++
  }

  this.minimize(commonPrefix)

  if (this.uncheckedNodes.length == 0) {
    node = this.root
  } else {
    node = this.uncheckedNodes[this.uncheckedNodes.length - 1].child
  }

  for (var i = commonPrefix; i < word.length; i++) {
    var nextNode = new lunr.TokenSet,
        char = word[i]

    node.edges[char] = nextNode

    this.uncheckedNodes.push({
      parent: node,
      char: char,
      child: nextNode
    })

    node = nextNode
  }

  node.final = true
  this.previousWord = word
}

lunr.TokenSet.Builder.prototype.finish = function () {
  this.minimize(0)
}

lunr.TokenSet.Builder.prototype.minimize = function (downTo) {
  for (var i = this.uncheckedNodes.length - 1; i >= downTo; i--) {
    var node = this.uncheckedNodes[i],
        childKey = node.child.toString()

    if (childKey in this.minimizedNodes) {
      node.parent.edges[node.char] = this.minimizedNodes[childKey]
    } else {
      // Cache the key for this node since
      // we know it can't change anymore
      node.child._str = childKey

      this.minimizedNodes[childKey] = node.child
    }

    this.uncheckedNodes.pop()
  }
}
/*!
 * lunr.Index
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * An index contains the built index of all documents and provides a query interface
 * to the index.
 *
 * Usually instances of lunr.Index will not be created using this constructor, instead
 * lunr.Builder should be used to construct new indexes, or lunr.Index.load should be
 * used to load previously built and serialized indexes.
 *
 * @constructor
 * @param {Object} attrs - The attributes of the built search index.
 * @param {Object} attrs.invertedIndex - An index of term/field to document reference.
 * @param {Object<string, lunr.Vector>} attrs.fieldVectors - Field vectors
 * @param {lunr.TokenSet} attrs.tokenSet - An set of all corpus tokens.
 * @param {string[]} attrs.fields - The names of indexed document fields.
 * @param {lunr.Pipeline} attrs.pipeline - The pipeline to use for search terms.
 */
lunr.Index = function (attrs) {
  this.invertedIndex = attrs.invertedIndex
  this.fieldVectors = attrs.fieldVectors
  this.tokenSet = attrs.tokenSet
  this.fields = attrs.fields
  this.pipeline = attrs.pipeline
}

/**
 * A result contains details of a document matching a search query.
 * @typedef {Object} lunr.Index~Result
 * @property {string} ref - The reference of the document this result represents.
 * @property {number} score - A number between 0 and 1 representing how similar this document is to the query.
 * @property {lunr.MatchData} matchData - Contains metadata about this match including which term(s) caused the match.
 */

/**
 * Although lunr provides the ability to create queries using lunr.Query, it also provides a simple
 * query language which itself is parsed into an instance of lunr.Query.
 *
 * For programmatically building queries it is advised to directly use lunr.Query, the query language
 * is best used for human entered text rather than program generated text.
 *
 * At its simplest queries can just be a single term, e.g. `hello`, multiple terms are also supported
 * and will be combined with OR, e.g `hello world` will match documents that contain either 'hello'
 * or 'world', though those that contain both will rank higher in the results.
 *
 * Wildcards can be included in terms to match one or more unspecified characters, these wildcards can
 * be inserted anywhere within the term, and more than one wildcard can exist in a single term. Adding
 * wildcards will increase the number of documents that will be found but can also have a negative
 * impact on query performance, especially with wildcards at the beginning of a term.
 *
 * Terms can be restricted to specific fields, e.g. `title:hello`, only documents with the term
 * hello in the title field will match this query. Using a field not present in the index will lead
 * to an error being thrown.
 *
 * Modifiers can also be added to terms, lunr supports edit distance and boost modifiers on terms. A term
 * boost will make documents matching that term score higher, e.g. `foo^5`. Edit distance is also supported
 * to provide fuzzy matching, e.g. 'hello~2' will match documents with hello with an edit distance of 2.
 * Avoid large values for edit distance to improve query performance.
 *
 * Each term also supports a presence modifier. By default a term's presence in document is optional, however
 * this can be changed to either required or prohibited. For a term's presence to be required in a document the
 * term should be prefixed with a '+', e.g. `+foo bar` is a search for documents that must contain 'foo' and
 * optionally contain 'bar'. Conversely a leading '-' sets the terms presence to prohibited, i.e. it must not
 * appear in a document, e.g. `-foo bar` is a search for documents that do not contain 'foo' but may contain 'bar'.
 *
 * To escape special characters the backslash character '\' can be used, this allows searches to include
 * characters that would normally be considered modifiers, e.g. `foo\~2` will search for a term "foo~2" instead
 * of attempting to apply a boost of 2 to the search term "foo".
 *
 * @typedef {string} lunr.Index~QueryString
 * @example <caption>Simple single term query</caption>
 * hello
 * @example <caption>Multiple term query</caption>
 * hello world
 * @example <caption>term scoped to a field</caption>
 * title:hello
 * @example <caption>term with a boost of 10</caption>
 * hello^10
 * @example <caption>term with an edit distance of 2</caption>
 * hello~2
 * @example <caption>terms with presence modifiers</caption>
 * -foo +bar baz
 */

/**
 * Performs a search against the index using lunr query syntax.
 *
 * Results will be returned sorted by their score, the most relevant results
 * will be returned first.  For details on how the score is calculated, please see
 * the {@link https://lunrjs.com/guides/searching.html#scoring|guide}.
 *
 * For more programmatic querying use lunr.Index#query.
 *
 * @param {lunr.Index~QueryString} queryString - A string containing a lunr query.
 * @throws {lunr.QueryParseError} If the passed query string cannot be parsed.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.search = function (queryString) {
  return this.query(function (query) {
    var parser = new lunr.QueryParser(queryString, query)
    parser.parse()
  })
}

/**
 * A query builder callback provides a query object to be used to express
 * the query to perform on the index.
 *
 * @callback lunr.Index~queryBuilder
 * @param {lunr.Query} query - The query object to build up.
 * @this lunr.Query
 */

/**
 * Performs a query against the index using the yielded lunr.Query object.
 *
 * If performing programmatic queries against the index, this method is preferred
 * over lunr.Index#search so as to avoid the additional query parsing overhead.
 *
 * A query object is yielded to the supplied function which should be used to
 * express the query to be run against the index.
 *
 * Note that although this function takes a callback parameter it is _not_ an
 * asynchronous operation, the callback is just yielded a query object to be
 * customized.
 *
 * @param {lunr.Index~queryBuilder} fn - A function that is used to build the query.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.query = function (fn) {
  // for each query clause
  // * process terms
  // * expand terms from token set
  // * find matching documents and metadata
  // * get document vectors
  // * score documents

  var query = new lunr.Query(this.fields),
      matchingFields = Object.create(null),
      queryVectors = Object.create(null),
      termFieldCache = Object.create(null),
      requiredMatches = Object.create(null),
      prohibitedMatches = Object.create(null)

  /*
   * To support field level boosts a query vector is created per
   * field. An empty vector is eagerly created to support negated
   * queries.
   */
  for (var i = 0; i < this.fields.length; i++) {
    queryVectors[this.fields[i]] = new lunr.Vector
  }

  fn.call(query, query)

  for (var i = 0; i < query.clauses.length; i++) {
    /*
     * Unless the pipeline has been disabled for this term, which is
     * the case for terms with wildcards, we need to pass the clause
     * term through the search pipeline. A pipeline returns an array
     * of processed terms. Pipeline functions may expand the passed
     * term, which means we may end up performing multiple index lookups
     * for a single query term.
     */
    var clause = query.clauses[i],
        terms = null,
        clauseMatches = lunr.Set.complete

    if (clause.usePipeline) {
      terms = this.pipeline.runString(clause.term, {
        fields: clause.fields
      })
    } else {
      terms = [clause.term]
    }

    for (var m = 0; m < terms.length; m++) {
      var term = terms[m]

      /*
       * Each term returned from the pipeline needs to use the same query
       * clause object, e.g. the same boost and or edit distance. The
       * simplest way to do this is to re-use the clause object but mutate
       * its term property.
       */
      clause.term = term

      /*
       * From the term in the clause we create a token set which will then
       * be used to intersect the indexes token set to get a list of terms
       * to lookup in the inverted index
       */
      var termTokenSet = lunr.TokenSet.fromClause(clause),
          expandedTerms = this.tokenSet.intersect(termTokenSet).toArray()

      /*
       * If a term marked as required does not exist in the tokenSet it is
       * impossible for the search to return any matches. We set all the field
       * scoped required matches set to empty and stop examining any further
       * clauses.
       */
      if (expandedTerms.length === 0 && clause.presence === lunr.Query.presence.REQUIRED) {
        for (var k = 0; k < clause.fields.length; k++) {
          var field = clause.fields[k]
          requiredMatches[field] = lunr.Set.empty
        }

        break
      }

      for (var j = 0; j < expandedTerms.length; j++) {
        /*
         * For each term get the posting and termIndex, this is required for
         * building the query vector.
         */
        var expandedTerm = expandedTerms[j],
            posting = this.invertedIndex[expandedTerm],
            termIndex = posting._index

        for (var k = 0; k < clause.fields.length; k++) {
          /*
           * For each field that this query term is scoped by (by default
           * all fields are in scope) we need to get all the document refs
           * that have this term in that field.
           *
           * The posting is the entry in the invertedIndex for the matching
           * term from above.
           */
          var field = clause.fields[k],
              fieldPosting = posting[field],
              matchingDocumentRefs = Object.keys(fieldPosting),
              termField = expandedTerm + "/" + field,
              matchingDocumentsSet = new lunr.Set(matchingDocumentRefs)

          /*
           * if the presence of this term is required ensure that the matching
           * documents are added to the set of required matches for this clause.
           *
           */
          if (clause.presence == lunr.Query.presence.REQUIRED) {
            clauseMatches = clauseMatches.union(matchingDocumentsSet)

            if (requiredMatches[field] === undefined) {
              requiredMatches[field] = lunr.Set.complete
            }
          }

          /*
           * if the presence of this term is prohibited ensure that the matching
           * documents are added to the set of prohibited matches for this field,
           * creating that set if it does not yet exist.
           */
          if (clause.presence == lunr.Query.presence.PROHIBITED) {
            if (prohibitedMatches[field] === undefined) {
              prohibitedMatches[field] = lunr.Set.empty
            }

            prohibitedMatches[field] = prohibitedMatches[field].union(matchingDocumentsSet)

            /*
             * Prohibited matches should not be part of the query vector used for
             * similarity scoring and no metadata should be extracted so we continue
             * to the next field
             */
            continue
          }

          /*
           * The query field vector is populated using the termIndex found for
           * the term and a unit value with the appropriate boost applied.
           * Using upsert because there could already be an entry in the vector
           * for the term we are working with. In that case we just add the scores
           * together.
           */
          queryVectors[field].upsert(termIndex, clause.boost, function (a, b) { return a + b })

          /**
           * If we've already seen this term, field combo then we've already collected
           * the matching documents and metadata, no need to go through all that again
           */
          if (termFieldCache[termField]) {
            continue
          }

          for (var l = 0; l < matchingDocumentRefs.length; l++) {
            /*
             * All metadata for this term/field/document triple
             * are then extracted and collected into an instance
             * of lunr.MatchData ready to be returned in the query
             * results
             */
            var matchingDocumentRef = matchingDocumentRefs[l],
                matchingFieldRef = new lunr.FieldRef (matchingDocumentRef, field),
                metadata = fieldPosting[matchingDocumentRef],
                fieldMatch

            if ((fieldMatch = matchingFields[matchingFieldRef]) === undefined) {
              matchingFields[matchingFieldRef] = new lunr.MatchData (expandedTerm, field, metadata)
            } else {
              fieldMatch.add(expandedTerm, field, metadata)
            }

          }

          termFieldCache[termField] = true
        }
      }
    }

    /**
     * If the presence was required we need to update the requiredMatches field sets.
     * We do this after all fields for the term have collected their matches because
     * the clause terms presence is required in _any_ of the fields not _all_ of the
     * fields.
     */
    if (clause.presence === lunr.Query.presence.REQUIRED) {
      for (var k = 0; k < clause.fields.length; k++) {
        var field = clause.fields[k]
        requiredMatches[field] = requiredMatches[field].intersect(clauseMatches)
      }
    }
  }

  /**
   * Need to combine the field scoped required and prohibited
   * matching documents into a global set of required and prohibited
   * matches
   */
  var allRequiredMatches = lunr.Set.complete,
      allProhibitedMatches = lunr.Set.empty

  for (var i = 0; i < this.fields.length; i++) {
    var field = this.fields[i]

    if (requiredMatches[field]) {
      allRequiredMatches = allRequiredMatches.intersect(requiredMatches[field])
    }

    if (prohibitedMatches[field]) {
      allProhibitedMatches = allProhibitedMatches.union(prohibitedMatches[field])
    }
  }

  var matchingFieldRefs = Object.keys(matchingFields),
      results = [],
      matches = Object.create(null)

  /*
   * If the query is negated (contains only prohibited terms)
   * we need to get _all_ fieldRefs currently existing in the
   * index. This is only done when we know that the query is
   * entirely prohibited terms to avoid any cost of getting all
   * fieldRefs unnecessarily.
   *
   * Additionally, blank MatchData must be created to correctly
   * populate the results.
   */
  if (query.isNegated()) {
    matchingFieldRefs = Object.keys(this.fieldVectors)

    for (var i = 0; i < matchingFieldRefs.length; i++) {
      var matchingFieldRef = matchingFieldRefs[i]
      var fieldRef = lunr.FieldRef.fromString(matchingFieldRef)
      matchingFields[matchingFieldRef] = new lunr.MatchData
    }
  }

  for (var i = 0; i < matchingFieldRefs.length; i++) {
    /*
     * Currently we have document fields that match the query, but we
     * need to return documents. The matchData and scores are combined
     * from multiple fields belonging to the same document.
     *
     * Scores are calculated by field, using the query vectors created
     * above, and combined into a final document score using addition.
     */
    var fieldRef = lunr.FieldRef.fromString(matchingFieldRefs[i]),
        docRef = fieldRef.docRef

    if (!allRequiredMatches.contains(docRef)) {
      continue
    }

    if (allProhibitedMatches.contains(docRef)) {
      continue
    }

    var fieldVector = this.fieldVectors[fieldRef],
        score = queryVectors[fieldRef.fieldName].similarity(fieldVector),
        docMatch

    if ((docMatch = matches[docRef]) !== undefined) {
      docMatch.score += score
      docMatch.matchData.combine(matchingFields[fieldRef])
    } else {
      var match = {
        ref: docRef,
        score: score,
        matchData: matchingFields[fieldRef]
      }
      matches[docRef] = match
      results.push(match)
    }
  }

  /*
   * Sort the results objects by score, highest first.
   */
  return results.sort(function (a, b) {
    return b.score - a.score
  })
}

/**
 * Prepares the index for JSON serialization.
 *
 * The schema for this JSON blob will be described in a
 * separate JSON schema file.
 *
 * @returns {Object}
 */
lunr.Index.prototype.toJSON = function () {
  var invertedIndex = Object.keys(this.invertedIndex)
    .sort()
    .map(function (term) {
      return [term, this.invertedIndex[term]]
    }, this)

  var fieldVectors = Object.keys(this.fieldVectors)
    .map(function (ref) {
      return [ref, this.fieldVectors[ref].toJSON()]
    }, this)

  return {
    version: lunr.version,
    fields: this.fields,
    fieldVectors: fieldVectors,
    invertedIndex: invertedIndex,
    pipeline: this.pipeline.toJSON()
  }
}

/**
 * Loads a previously serialized lunr.Index
 *
 * @param {Object} serializedIndex - A previously serialized lunr.Index
 * @returns {lunr.Index}
 */
lunr.Index.load = function (serializedIndex) {
  var attrs = {},
      fieldVectors = {},
      serializedVectors = serializedIndex.fieldVectors,
      invertedIndex = Object.create(null),
      serializedInvertedIndex = serializedIndex.invertedIndex,
      tokenSetBuilder = new lunr.TokenSet.Builder,
      pipeline = lunr.Pipeline.load(serializedIndex.pipeline)

  if (serializedIndex.version != lunr.version) {
    lunr.utils.warn("Version mismatch when loading serialised index. Current version of lunr '" + lunr.version + "' does not match serialized index '" + serializedIndex.version + "'")
  }

  for (var i = 0; i < serializedVectors.length; i++) {
    var tuple = serializedVectors[i],
        ref = tuple[0],
        elements = tuple[1]

    fieldVectors[ref] = new lunr.Vector(elements)
  }

  for (var i = 0; i < serializedInvertedIndex.length; i++) {
    var tuple = serializedInvertedIndex[i],
        term = tuple[0],
        posting = tuple[1]

    tokenSetBuilder.insert(term)
    invertedIndex[term] = posting
  }

  tokenSetBuilder.finish()

  attrs.fields = serializedIndex.fields

  attrs.fieldVectors = fieldVectors
  attrs.invertedIndex = invertedIndex
  attrs.tokenSet = tokenSetBuilder.root
  attrs.pipeline = pipeline

  return new lunr.Index(attrs)
}
/*!
 * lunr.Builder
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.Builder performs indexing on a set of documents and
 * returns instances of lunr.Index ready for querying.
 *
 * All configuration of the index is done via the builder, the
 * fields to index, the document reference, the text processing
 * pipeline and document scoring parameters are all set on the
 * builder before indexing.
 *
 * @constructor
 * @property {string} _ref - Internal reference to the document reference field.
 * @property {string[]} _fields - Internal reference to the document fields to index.
 * @property {object} invertedIndex - The inverted index maps terms to document fields.
 * @property {object} documentTermFrequencies - Keeps track of document term frequencies.
 * @property {object} documentLengths - Keeps track of the length of documents added to the index.
 * @property {lunr.tokenizer} tokenizer - Function for splitting strings into tokens for indexing.
 * @property {lunr.Pipeline} pipeline - The pipeline performs text processing on tokens before indexing.
 * @property {lunr.Pipeline} searchPipeline - A pipeline for processing search terms before querying the index.
 * @property {number} documentCount - Keeps track of the total number of documents indexed.
 * @property {number} _b - A parameter to control field length normalization, setting this to 0 disabled normalization, 1 fully normalizes field lengths, the default value is 0.75.
 * @property {number} _k1 - A parameter to control how quickly an increase in term frequency results in term frequency saturation, the default value is 1.2.
 * @property {number} termIndex - A counter incremented for each unique term, used to identify a terms position in the vector space.
 * @property {array} metadataWhitelist - A list of metadata keys that have been whitelisted for entry in the index.
 */
lunr.Builder = function () {
  this._ref = "id"
  this._fields = Object.create(null)
  this._documents = Object.create(null)
  this.invertedIndex = Object.create(null)
  this.fieldTermFrequencies = {}
  this.fieldLengths = {}
  this.tokenizer = lunr.tokenizer
  this.pipeline = new lunr.Pipeline
  this.searchPipeline = new lunr.Pipeline
  this.documentCount = 0
  this._b = 0.75
  this._k1 = 1.2
  this.termIndex = 0
  this.metadataWhitelist = []
}

/**
 * Sets the document field used as the document reference. Every document must have this field.
 * The type of this field in the document should be a string, if it is not a string it will be
 * coerced into a string by calling toString.
 *
 * The default ref is 'id'.
 *
 * The ref should _not_ be changed during indexing, it should be set before any documents are
 * added to the index. Changing it during indexing can lead to inconsistent results.
 *
 * @param {string} ref - The name of the reference field in the document.
 */
lunr.Builder.prototype.ref = function (ref) {
  this._ref = ref
}

/**
 * A function that is used to extract a field from a document.
 *
 * Lunr expects a field to be at the top level of a document, if however the field
 * is deeply nested within a document an extractor function can be used to extract
 * the right field for indexing.
 *
 * @callback fieldExtractor
 * @param {object} doc - The document being added to the index.
 * @returns {?(string|object|object[])} obj - The object that will be indexed for this field.
 * @example <caption>Extracting a nested field</caption>
 * function (doc) { return doc.nested.field }
 */

/**
 * Adds a field to the list of document fields that will be indexed. Every document being
 * indexed should have this field. Null values for this field in indexed documents will
 * not cause errors but will limit the chance of that document being retrieved by searches.
 *
 * All fields should be added before adding documents to the index. Adding fields after
 * a document has been indexed will have no effect on already indexed documents.
 *
 * Fields can be boosted at build time. This allows terms within that field to have more
 * importance when ranking search results. Use a field boost to specify that matches within
 * one field are more important than other fields.
 *
 * @param {string} fieldName - The name of a field to index in all documents.
 * @param {object} attributes - Optional attributes associated with this field.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this field.
 * @param {fieldExtractor} [attributes.extractor] - Function to extract a field from a document.
 * @throws {RangeError} fieldName cannot contain unsupported characters '/'
 */
lunr.Builder.prototype.field = function (fieldName, attributes) {
  if (/\//.test(fieldName)) {
    throw new RangeError ("Field '" + fieldName + "' contains illegal character '/'")
  }

  this._fields[fieldName] = attributes || {}
}

/**
 * A parameter to tune the amount of field length normalisation that is applied when
 * calculating relevance scores. A value of 0 will completely disable any normalisation
 * and a value of 1 will fully normalise field lengths. The default is 0.75. Values of b
 * will be clamped to the range 0 - 1.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.b = function (number) {
  if (number < 0) {
    this._b = 0
  } else if (number > 1) {
    this._b = 1
  } else {
    this._b = number
  }
}

/**
 * A parameter that controls the speed at which a rise in term frequency results in term
 * frequency saturation. The default value is 1.2. Setting this to a higher value will give
 * slower saturation levels, a lower value will result in quicker saturation.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.k1 = function (number) {
  this._k1 = number
}

/**
 * Adds a document to the index.
 *
 * Before adding fields to the index the index should have been fully setup, with the document
 * ref and all fields to index already having been specified.
 *
 * The document must have a field name as specified by the ref (by default this is 'id') and
 * it should have all fields defined for indexing, though null or undefined values will not
 * cause errors.
 *
 * Entire documents can be boosted at build time. Applying a boost to a document indicates that
 * this document should rank higher in search results than other documents.
 *
 * @param {object} doc - The document to add to the index.
 * @param {object} attributes - Optional attributes associated with this document.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this document.
 */
lunr.Builder.prototype.add = function (doc, attributes) {
  var docRef = doc[this._ref],
      fields = Object.keys(this._fields)

  this._documents[docRef] = attributes || {}
  this.documentCount += 1

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i],
        extractor = this._fields[fieldName].extractor,
        field = extractor ? extractor(doc) : doc[fieldName],
        tokens = this.tokenizer(field, {
          fields: [fieldName]
        }),
        terms = this.pipeline.run(tokens),
        fieldRef = new lunr.FieldRef (docRef, fieldName),
        fieldTerms = Object.create(null)

    this.fieldTermFrequencies[fieldRef] = fieldTerms
    this.fieldLengths[fieldRef] = 0

    // store the length of this field for this document
    this.fieldLengths[fieldRef] += terms.length

    // calculate term frequencies for this field
    for (var j = 0; j < terms.length; j++) {
      var term = terms[j]

      if (fieldTerms[term] == undefined) {
        fieldTerms[term] = 0
      }

      fieldTerms[term] += 1

      // add to inverted index
      // create an initial posting if one doesn't exist
      if (this.invertedIndex[term] == undefined) {
        var posting = Object.create(null)
        posting["_index"] = this.termIndex
        this.termIndex += 1

        for (var k = 0; k < fields.length; k++) {
          posting[fields[k]] = Object.create(null)
        }

        this.invertedIndex[term] = posting
      }

      // add an entry for this term/fieldName/docRef to the invertedIndex
      if (this.invertedIndex[term][fieldName][docRef] == undefined) {
        this.invertedIndex[term][fieldName][docRef] = Object.create(null)
      }

      // store all whitelisted metadata about this token in the
      // inverted index
      for (var l = 0; l < this.metadataWhitelist.length; l++) {
        var metadataKey = this.metadataWhitelist[l],
            metadata = term.metadata[metadataKey]

        if (this.invertedIndex[term][fieldName][docRef][metadataKey] == undefined) {
          this.invertedIndex[term][fieldName][docRef][metadataKey] = []
        }

        this.invertedIndex[term][fieldName][docRef][metadataKey].push(metadata)
      }
    }

  }
}

/**
 * Calculates the average document length for this index
 *
 * @private
 */
lunr.Builder.prototype.calculateAverageFieldLengths = function () {

  var fieldRefs = Object.keys(this.fieldLengths),
      numberOfFields = fieldRefs.length,
      accumulator = {},
      documentsWithField = {}

  for (var i = 0; i < numberOfFields; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        field = fieldRef.fieldName

    documentsWithField[field] || (documentsWithField[field] = 0)
    documentsWithField[field] += 1

    accumulator[field] || (accumulator[field] = 0)
    accumulator[field] += this.fieldLengths[fieldRef]
  }

  var fields = Object.keys(this._fields)

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i]
    accumulator[fieldName] = accumulator[fieldName] / documentsWithField[fieldName]
  }

  this.averageFieldLength = accumulator
}

/**
 * Builds a vector space model of every document using lunr.Vector
 *
 * @private
 */
lunr.Builder.prototype.createFieldVectors = function () {
  var fieldVectors = {},
      fieldRefs = Object.keys(this.fieldTermFrequencies),
      fieldRefsLength = fieldRefs.length,
      termIdfCache = Object.create(null)

  for (var i = 0; i < fieldRefsLength; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        fieldName = fieldRef.fieldName,
        fieldLength = this.fieldLengths[fieldRef],
        fieldVector = new lunr.Vector,
        termFrequencies = this.fieldTermFrequencies[fieldRef],
        terms = Object.keys(termFrequencies),
        termsLength = terms.length


    var fieldBoost = this._fields[fieldName].boost || 1,
        docBoost = this._documents[fieldRef.docRef].boost || 1

    for (var j = 0; j < termsLength; j++) {
      var term = terms[j],
          tf = termFrequencies[term],
          termIndex = this.invertedIndex[term]._index,
          idf, score, scoreWithPrecision

      if (termIdfCache[term] === undefined) {
        idf = lunr.idf(this.invertedIndex[term], this.documentCount)
        termIdfCache[term] = idf
      } else {
        idf = termIdfCache[term]
      }

      score = idf * ((this._k1 + 1) * tf) / (this._k1 * (1 - this._b + this._b * (fieldLength / this.averageFieldLength[fieldName])) + tf)
      score *= fieldBoost
      score *= docBoost
      scoreWithPrecision = Math.round(score * 1000) / 1000
      // Converts 1.23456789 to 1.234.
      // Reducing the precision so that the vectors take up less
      // space when serialised. Doing it now so that they behave
      // the same before and after serialisation. Also, this is
      // the fastest approach to reducing a number's precision in
      // JavaScript.

      fieldVector.insert(termIndex, scoreWithPrecision)
    }

    fieldVectors[fieldRef] = fieldVector
  }

  this.fieldVectors = fieldVectors
}

/**
 * Creates a token set of all tokens in the index using lunr.TokenSet
 *
 * @private
 */
lunr.Builder.prototype.createTokenSet = function () {
  this.tokenSet = lunr.TokenSet.fromArray(
    Object.keys(this.invertedIndex).sort()
  )
}

/**
 * Builds the index, creating an instance of lunr.Index.
 *
 * This completes the indexing process and should only be called
 * once all documents have been added to the index.
 *
 * @returns {lunr.Index}
 */
lunr.Builder.prototype.build = function () {
  this.calculateAverageFieldLengths()
  this.createFieldVectors()
  this.createTokenSet()

  return new lunr.Index({
    invertedIndex: this.invertedIndex,
    fieldVectors: this.fieldVectors,
    tokenSet: this.tokenSet,
    fields: Object.keys(this._fields),
    pipeline: this.searchPipeline
  })
}

/**
 * Applies a plugin to the index builder.
 *
 * A plugin is a function that is called with the index builder as its context.
 * Plugins can be used to customise or extend the behaviour of the index
 * in some way. A plugin is just a function, that encapsulated the custom
 * behaviour that should be applied when building the index.
 *
 * The plugin function will be called with the index builder as its argument, additional
 * arguments can also be passed when calling use. The function will be called
 * with the index builder as its context.
 *
 * @param {Function} plugin The plugin to apply.
 */
lunr.Builder.prototype.use = function (fn) {
  var args = Array.prototype.slice.call(arguments, 1)
  args.unshift(this)
  fn.apply(this, args)
}
/**
 * Contains and collects metadata about a matching document.
 * A single instance of lunr.MatchData is returned as part of every
 * lunr.Index~Result.
 *
 * @constructor
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 * @property {object} metadata - A cloned collection of metadata associated with this document.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData = function (term, field, metadata) {
  var clonedMetadata = Object.create(null),
      metadataKeys = Object.keys(metadata || {})

  // Cloning the metadata to prevent the original
  // being mutated during match data combination.
  // Metadata is kept in an array within the inverted
  // index so cloning the data can be done with
  // Array#slice
  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]
    clonedMetadata[key] = metadata[key].slice()
  }

  this.metadata = Object.create(null)

  if (term !== undefined) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = clonedMetadata
  }
}

/**
 * An instance of lunr.MatchData will be created for every term that matches a
 * document. However only one instance is required in a lunr.Index~Result. This
 * method combines metadata from another instance of lunr.MatchData with this
 * objects metadata.
 *
 * @param {lunr.MatchData} otherMatchData - Another instance of match data to merge with this one.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData.prototype.combine = function (otherMatchData) {
  var terms = Object.keys(otherMatchData.metadata)

  for (var i = 0; i < terms.length; i++) {
    var term = terms[i],
        fields = Object.keys(otherMatchData.metadata[term])

    if (this.metadata[term] == undefined) {
      this.metadata[term] = Object.create(null)
    }

    for (var j = 0; j < fields.length; j++) {
      var field = fields[j],
          keys = Object.keys(otherMatchData.metadata[term][field])

      if (this.metadata[term][field] == undefined) {
        this.metadata[term][field] = Object.create(null)
      }

      for (var k = 0; k < keys.length; k++) {
        var key = keys[k]

        if (this.metadata[term][field][key] == undefined) {
          this.metadata[term][field][key] = otherMatchData.metadata[term][field][key]
        } else {
          this.metadata[term][field][key] = this.metadata[term][field][key].concat(otherMatchData.metadata[term][field][key])
        }

      }
    }
  }
}

/**
 * Add metadata for a term/field pair to this instance of match data.
 *
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 */
lunr.MatchData.prototype.add = function (term, field, metadata) {
  if (!(term in this.metadata)) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = metadata
    return
  }

  if (!(field in this.metadata[term])) {
    this.metadata[term][field] = metadata
    return
  }

  var metadataKeys = Object.keys(metadata)

  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]

    if (key in this.metadata[term][field]) {
      this.metadata[term][field][key] = this.metadata[term][field][key].concat(metadata[key])
    } else {
      this.metadata[term][field][key] = metadata[key]
    }
  }
}
/**
 * A lunr.Query provides a programmatic way of defining queries to be performed
 * against a {@link lunr.Index}.
 *
 * Prefer constructing a lunr.Query using the {@link lunr.Index#query} method
 * so the query object is pre-initialized with the right index fields.
 *
 * @constructor
 * @property {lunr.Query~Clause[]} clauses - An array of query clauses.
 * @property {string[]} allFields - An array of all available fields in a lunr.Index.
 */
lunr.Query = function (allFields) {
  this.clauses = []
  this.allFields = allFields
}

/**
 * Constants for indicating what kind of automatic wildcard insertion will be used when constructing a query clause.
 *
 * This allows wildcards to be added to the beginning and end of a term without having to manually do any string
 * concatenation.
 *
 * The wildcard constants can be bitwise combined to select both leading and trailing wildcards.
 *
 * @constant
 * @default
 * @property {number} wildcard.NONE - The term will have no wildcards inserted, this is the default behaviour
 * @property {number} wildcard.LEADING - Prepend the term with a wildcard, unless a leading wildcard already exists
 * @property {number} wildcard.TRAILING - Append a wildcard to the term, unless a trailing wildcard already exists
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with trailing wildcard</caption>
 * query.term('foo', { wildcard: lunr.Query.wildcard.TRAILING })
 * @example <caption>query term with leading and trailing wildcard</caption>
 * query.term('foo', {
 *   wildcard: lunr.Query.wildcard.LEADING | lunr.Query.wildcard.TRAILING
 * })
 */

lunr.Query.wildcard = new String ("*")
lunr.Query.wildcard.NONE = 0
lunr.Query.wildcard.LEADING = 1
lunr.Query.wildcard.TRAILING = 2

/**
 * Constants for indicating what kind of presence a term must have in matching documents.
 *
 * @constant
 * @enum {number}
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with required presence</caption>
 * query.term('foo', { presence: lunr.Query.presence.REQUIRED })
 */
lunr.Query.presence = {
  /**
   * Term's presence in a document is optional, this is the default value.
   */
  OPTIONAL: 1,

  /**
   * Term's presence in a document is required, documents that do not contain
   * this term will not be returned.
   */
  REQUIRED: 2,

  /**
   * Term's presence in a document is prohibited, documents that do contain
   * this term will not be returned.
   */
  PROHIBITED: 3
}

/**
 * A single clause in a {@link lunr.Query} contains a term and details on how to
 * match that term against a {@link lunr.Index}.
 *
 * @typedef {Object} lunr.Query~Clause
 * @property {string[]} fields - The fields in an index this clause should be matched against.
 * @property {number} [boost=1] - Any boost that should be applied when matching this clause.
 * @property {number} [editDistance] - Whether the term should have fuzzy matching applied, and how fuzzy the match should be.
 * @property {boolean} [usePipeline] - Whether the term should be passed through the search pipeline.
 * @property {number} [wildcard=lunr.Query.wildcard.NONE] - Whether the term should have wildcards appended or prepended.
 * @property {number} [presence=lunr.Query.presence.OPTIONAL] - The terms presence in any matching documents.
 */

/**
 * Adds a {@link lunr.Query~Clause} to this query.
 *
 * Unless the clause contains the fields to be matched all fields will be matched. In addition
 * a default boost of 1 is applied to the clause.
 *
 * @param {lunr.Query~Clause} clause - The clause to add to this query.
 * @see lunr.Query~Clause
 * @returns {lunr.Query}
 */
lunr.Query.prototype.clause = function (clause) {
  if (!('fields' in clause)) {
    clause.fields = this.allFields
  }

  if (!('boost' in clause)) {
    clause.boost = 1
  }

  if (!('usePipeline' in clause)) {
    clause.usePipeline = true
  }

  if (!('wildcard' in clause)) {
    clause.wildcard = lunr.Query.wildcard.NONE
  }

  if ((clause.wildcard & lunr.Query.wildcard.LEADING) && (clause.term.charAt(0) != lunr.Query.wildcard)) {
    clause.term = "*" + clause.term
  }

  if ((clause.wildcard & lunr.Query.wildcard.TRAILING) && (clause.term.slice(-1) != lunr.Query.wildcard)) {
    clause.term = "" + clause.term + "*"
  }

  if (!('presence' in clause)) {
    clause.presence = lunr.Query.presence.OPTIONAL
  }

  this.clauses.push(clause)

  return this
}

/**
 * A negated query is one in which every clause has a presence of
 * prohibited. These queries require some special processing to return
 * the expected results.
 *
 * @returns boolean
 */
lunr.Query.prototype.isNegated = function () {
  for (var i = 0; i < this.clauses.length; i++) {
    if (this.clauses[i].presence != lunr.Query.presence.PROHIBITED) {
      return false
    }
  }

  return true
}

/**
 * Adds a term to the current query, under the covers this will create a {@link lunr.Query~Clause}
 * to the list of clauses that make up this query.
 *
 * The term is used as is, i.e. no tokenization will be performed by this method. Instead conversion
 * to a token or token-like string should be done before calling this method.
 *
 * The term will be converted to a string by calling `toString`. Multiple terms can be passed as an
 * array, each term in the array will share the same options.
 *
 * @param {object|object[]} term - The term(s) to add to the query.
 * @param {object} [options] - Any additional properties to add to the query clause.
 * @returns {lunr.Query}
 * @see lunr.Query#clause
 * @see lunr.Query~Clause
 * @example <caption>adding a single term to a query</caption>
 * query.term("foo")
 * @example <caption>adding a single term to a query and specifying search fields, term boost and automatic trailing wildcard</caption>
 * query.term("foo", {
 *   fields: ["title"],
 *   boost: 10,
 *   wildcard: lunr.Query.wildcard.TRAILING
 * })
 * @example <caption>using lunr.tokenizer to convert a string to tokens before using them as terms</caption>
 * query.term(lunr.tokenizer("foo bar"))
 */
lunr.Query.prototype.term = function (term, options) {
  if (Array.isArray(term)) {
    term.forEach(function (t) { this.term(t, lunr.utils.clone(options)) }, this)
    return this
  }

  var clause = options || {}
  clause.term = term.toString()

  this.clause(clause)

  return this
}
lunr.QueryParseError = function (message, start, end) {
  this.name = "QueryParseError"
  this.message = message
  this.start = start
  this.end = end
}

lunr.QueryParseError.prototype = new Error
lunr.QueryLexer = function (str) {
  this.lexemes = []
  this.str = str
  this.length = str.length
  this.pos = 0
  this.start = 0
  this.escapeCharPositions = []
}

lunr.QueryLexer.prototype.run = function () {
  var state = lunr.QueryLexer.lexText

  while (state) {
    state = state(this)
  }
}

lunr.QueryLexer.prototype.sliceString = function () {
  var subSlices = [],
      sliceStart = this.start,
      sliceEnd = this.pos

  for (var i = 0; i < this.escapeCharPositions.length; i++) {
    sliceEnd = this.escapeCharPositions[i]
    subSlices.push(this.str.slice(sliceStart, sliceEnd))
    sliceStart = sliceEnd + 1
  }

  subSlices.push(this.str.slice(sliceStart, this.pos))
  this.escapeCharPositions.length = 0

  return subSlices.join('')
}

lunr.QueryLexer.prototype.emit = function (type) {
  this.lexemes.push({
    type: type,
    str: this.sliceString(),
    start: this.start,
    end: this.pos
  })

  this.start = this.pos
}

lunr.QueryLexer.prototype.escapeCharacter = function () {
  this.escapeCharPositions.push(this.pos - 1)
  this.pos += 1
}

lunr.QueryLexer.prototype.next = function () {
  if (this.pos >= this.length) {
    return lunr.QueryLexer.EOS
  }

  var char = this.str.charAt(this.pos)
  this.pos += 1
  return char
}

lunr.QueryLexer.prototype.width = function () {
  return this.pos - this.start
}

lunr.QueryLexer.prototype.ignore = function () {
  if (this.start == this.pos) {
    this.pos += 1
  }

  this.start = this.pos
}

lunr.QueryLexer.prototype.backup = function () {
  this.pos -= 1
}

lunr.QueryLexer.prototype.acceptDigitRun = function () {
  var char, charCode

  do {
    char = this.next()
    charCode = char.charCodeAt(0)
  } while (charCode > 47 && charCode < 58)

  if (char != lunr.QueryLexer.EOS) {
    this.backup()
  }
}

lunr.QueryLexer.prototype.more = function () {
  return this.pos < this.length
}

lunr.QueryLexer.EOS = 'EOS'
lunr.QueryLexer.FIELD = 'FIELD'
lunr.QueryLexer.TERM = 'TERM'
lunr.QueryLexer.EDIT_DISTANCE = 'EDIT_DISTANCE'
lunr.QueryLexer.BOOST = 'BOOST'
lunr.QueryLexer.PRESENCE = 'PRESENCE'

lunr.QueryLexer.lexField = function (lexer) {
  lexer.backup()
  lexer.emit(lunr.QueryLexer.FIELD)
  lexer.ignore()
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexTerm = function (lexer) {
  if (lexer.width() > 1) {
    lexer.backup()
    lexer.emit(lunr.QueryLexer.TERM)
  }

  lexer.ignore()

  if (lexer.more()) {
    return lunr.QueryLexer.lexText
  }
}

lunr.QueryLexer.lexEditDistance = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.EDIT_DISTANCE)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexBoost = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.BOOST)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexEOS = function (lexer) {
  if (lexer.width() > 0) {
    lexer.emit(lunr.QueryLexer.TERM)
  }
}

// This matches the separator used when tokenising fields
// within a document. These should match otherwise it is
// not possible to search for some tokens within a document.
//
// It is possible for the user to change the separator on the
// tokenizer so it _might_ clash with any other of the special
// characters already used within the search string, e.g. :.
//
// This means that it is possible to change the separator in
// such a way that makes some words unsearchable using a search
// string.
lunr.QueryLexer.termSeparator = lunr.tokenizer.separator

lunr.QueryLexer.lexText = function (lexer) {
  while (true) {
    var char = lexer.next()

    if (char == lunr.QueryLexer.EOS) {
      return lunr.QueryLexer.lexEOS
    }

    // Escape character is '\'
    if (char.charCodeAt(0) == 92) {
      lexer.escapeCharacter()
      continue
    }

    if (char == ":") {
      return lunr.QueryLexer.lexField
    }

    if (char == "~") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexEditDistance
    }

    if (char == "^") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexBoost
    }

    // "+" indicates term presence is required
    // checking for length to ensure that only
    // leading "+" are considered
    if (char == "+" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    // "-" indicates term presence is prohibited
    // checking for length to ensure that only
    // leading "-" are considered
    if (char == "-" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    if (char.match(lunr.QueryLexer.termSeparator)) {
      return lunr.QueryLexer.lexTerm
    }
  }
}

lunr.QueryParser = function (str, query) {
  this.lexer = new lunr.QueryLexer (str)
  this.query = query
  this.currentClause = {}
  this.lexemeIdx = 0
}

lunr.QueryParser.prototype.parse = function () {
  this.lexer.run()
  this.lexemes = this.lexer.lexemes

  var state = lunr.QueryParser.parseClause

  while (state) {
    state = state(this)
  }

  return this.query
}

lunr.QueryParser.prototype.peekLexeme = function () {
  return this.lexemes[this.lexemeIdx]
}

lunr.QueryParser.prototype.consumeLexeme = function () {
  var lexeme = this.peekLexeme()
  this.lexemeIdx += 1
  return lexeme
}

lunr.QueryParser.prototype.nextClause = function () {
  var completedClause = this.currentClause
  this.query.clause(completedClause)
  this.currentClause = {}
}

lunr.QueryParser.parseClause = function (parser) {
  var lexeme = parser.peekLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.type) {
    case lunr.QueryLexer.PRESENCE:
      return lunr.QueryParser.parsePresence
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expected either a field or a term, found " + lexeme.type

      if (lexeme.str.length >= 1) {
        errorMessage += " with value '" + lexeme.str + "'"
      }

      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }
}

lunr.QueryParser.parsePresence = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.str) {
    case "-":
      parser.currentClause.presence = lunr.Query.presence.PROHIBITED
      break
    case "+":
      parser.currentClause.presence = lunr.Query.presence.REQUIRED
      break
    default:
      var errorMessage = "unrecognised presence operator'" + lexeme.str + "'"
      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term or field, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term or field, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseField = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  if (parser.query.allFields.indexOf(lexeme.str) == -1) {
    var possibleFields = parser.query.allFields.map(function (f) { return "'" + f + "'" }).join(', '),
        errorMessage = "unrecognised field '" + lexeme.str + "', possible fields: " + possibleFields

    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.fields = [lexeme.str]

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseTerm = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  parser.currentClause.term = lexeme.str.toLowerCase()

  if (lexeme.str.indexOf("*") != -1) {
    parser.currentClause.usePipeline = false
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseEditDistance = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var editDistance = parseInt(lexeme.str, 10)

  if (isNaN(editDistance)) {
    var errorMessage = "edit distance must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.editDistance = editDistance

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseBoost = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var boost = parseInt(lexeme.str, 10)

  if (isNaN(boost)) {
    var errorMessage = "boost must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.boost = boost

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

  /**
   * export the module via AMD, CommonJS or as a browser global
   * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
   */
  ;(function (root, factory) {
    if (true) {
      // AMD. Register as an anonymous module.
      !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
      /**
       * Node. Does not work with strict CommonJS, but
       * only CommonJS-like enviroments that support module.exports,
       * like Node.
       */
      module.exports = factory()
    } else {
      // Browser globals (root is window)
      root.lunr = factory()
    }
  }(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return lunr
  }))
})();


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return function(lunr) {
        /* provides utilities for the included stemmers */
        lunr.stemmerSupport = {
            Among: function(s, substring_i, result, method) {
                this.toCharArray = function(s) {
                    var sLength = s.length, charArr = new Array(sLength);
                    for (var i = 0; i < sLength; i++)
                        charArr[i] = s.charCodeAt(i);
                    return charArr;
                };

                if ((!s && s != "") || (!substring_i && (substring_i != 0)) || !result)
                    throw ("Bad Among initialisation: s:" + s + ", substring_i: "
                        + substring_i + ", result: " + result);
                this.s_size = s.length;
                this.s = this.toCharArray(s);
                this.substring_i = substring_i;
                this.result = result;
                this.method = method;
            },
            SnowballProgram: function() {
                var current;
                return {
                    bra : 0,
                    ket : 0,
                    limit : 0,
                    cursor : 0,
                    limit_backward : 0,
                    setCurrent : function(word) {
                        current = word;
                        this.cursor = 0;
                        this.limit = word.length;
                        this.limit_backward = 0;
                        this.bra = this.cursor;
                        this.ket = this.limit;
                    },
                    getCurrent : function() {
                        var result = current;
                        current = null;
                        return result;
                    },
                    in_grouping : function(s, min, max) {
                        if (this.cursor < this.limit) {
                            var ch = current.charCodeAt(this.cursor);
                            if (ch <= max && ch >= min) {
                                ch -= min;
                                if (s[ch >> 3] & (0X1 << (ch & 0X7))) {
                                    this.cursor++;
                                    return true;
                                }
                            }
                        }
                        return false;
                    },
                    in_grouping_b : function(s, min, max) {
                        if (this.cursor > this.limit_backward) {
                            var ch = current.charCodeAt(this.cursor - 1);
                            if (ch <= max && ch >= min) {
                                ch -= min;
                                if (s[ch >> 3] & (0X1 << (ch & 0X7))) {
                                    this.cursor--;
                                    return true;
                                }
                            }
                        }
                        return false;
                    },
                    out_grouping : function(s, min, max) {
                        if (this.cursor < this.limit) {
                            var ch = current.charCodeAt(this.cursor);
                            if (ch > max || ch < min) {
                                this.cursor++;
                                return true;
                            }
                            ch -= min;
                            if (!(s[ch >> 3] & (0X1 << (ch & 0X7)))) {
                                this.cursor++;
                                return true;
                            }
                        }
                        return false;
                    },
                    out_grouping_b : function(s, min, max) {
                        if (this.cursor > this.limit_backward) {
                            var ch = current.charCodeAt(this.cursor - 1);
                            if (ch > max || ch < min) {
                                this.cursor--;
                                return true;
                            }
                            ch -= min;
                            if (!(s[ch >> 3] & (0X1 << (ch & 0X7)))) {
                                this.cursor--;
                                return true;
                            }
                        }
                        return false;
                    },
                    eq_s : function(s_size, s) {
                        if (this.limit - this.cursor < s_size)
                            return false;
                        for (var i = 0; i < s_size; i++)
                            if (current.charCodeAt(this.cursor + i) != s.charCodeAt(i))
                                return false;
                        this.cursor += s_size;
                        return true;
                    },
                    eq_s_b : function(s_size, s) {
                        if (this.cursor - this.limit_backward < s_size)
                            return false;
                        for (var i = 0; i < s_size; i++)
                            if (current.charCodeAt(this.cursor - s_size + i) != s
                                .charCodeAt(i))
                                return false;
                        this.cursor -= s_size;
                        return true;
                    },
                    find_among : function(v, v_size) {
                        var i = 0, j = v_size, c = this.cursor, l = this.limit, common_i = 0, common_j = 0, first_key_inspected = false;
                        while (true) {
                            var k = i + ((j - i) >> 1), diff = 0, common = common_i < common_j
                                ? common_i
                                : common_j, w = v[k];
                            for (var i2 = common; i2 < w.s_size; i2++) {
                                if (c + common == l) {
                                    diff = -1;
                                    break;
                                }
                                diff = current.charCodeAt(c + common) - w.s[i2];
                                if (diff)
                                    break;
                                common++;
                            }
                            if (diff < 0) {
                                j = k;
                                common_j = common;
                            } else {
                                i = k;
                                common_i = common;
                            }
                            if (j - i <= 1) {
                                if (i > 0 || j == i || first_key_inspected)
                                    break;
                                first_key_inspected = true;
                            }
                        }
                        while (true) {
                            var w = v[i];
                            if (common_i >= w.s_size) {
                                this.cursor = c + w.s_size;
                                if (!w.method)
                                    return w.result;
                                var res = w.method();
                                this.cursor = c + w.s_size;
                                if (res)
                                    return w.result;
                            }
                            i = w.substring_i;
                            if (i < 0)
                                return 0;
                        }
                    },
                    find_among_b : function(v, v_size) {
                        var i = 0, j = v_size, c = this.cursor, lb = this.limit_backward, common_i = 0, common_j = 0, first_key_inspected = false;
                        while (true) {
                            var k = i + ((j - i) >> 1), diff = 0, common = common_i < common_j
                                ? common_i
                                : common_j, w = v[k];
                            for (var i2 = w.s_size - 1 - common; i2 >= 0; i2--) {
                                if (c - common == lb) {
                                    diff = -1;
                                    break;
                                }
                                diff = current.charCodeAt(c - 1 - common) - w.s[i2];
                                if (diff)
                                    break;
                                common++;
                            }
                            if (diff < 0) {
                                j = k;
                                common_j = common;
                            } else {
                                i = k;
                                common_i = common;
                            }
                            if (j - i <= 1) {
                                if (i > 0 || j == i || first_key_inspected)
                                    break;
                                first_key_inspected = true;
                            }
                        }
                        while (true) {
                            var w = v[i];
                            if (common_i >= w.s_size) {
                                this.cursor = c - w.s_size;
                                if (!w.method)
                                    return w.result;
                                var res = w.method();
                                this.cursor = c - w.s_size;
                                if (res)
                                    return w.result;
                            }
                            i = w.substring_i;
                            if (i < 0)
                                return 0;
                        }
                    },
                    replace_s : function(c_bra, c_ket, s) {
                        var adjustment = s.length - (c_ket - c_bra), left = current
                            .substring(0, c_bra), right = current.substring(c_ket);
                        current = left + s + right;
                        this.limit += adjustment;
                        if (this.cursor >= c_ket)
                            this.cursor += adjustment;
                        else if (this.cursor > c_bra)
                            this.cursor = c_bra;
                        return adjustment;
                    },
                    slice_check : function() {
                        if (this.bra < 0 || this.bra > this.ket || this.ket > this.limit
                            || this.limit > current.length)
                            throw ("faulty slice operation");
                    },
                    slice_from : function(s) {
                        this.slice_check();
                        this.replace_s(this.bra, this.ket, s);
                    },
                    slice_del : function() {
                        this.slice_from("");
                    },
                    insert : function(c_bra, c_ket, s) {
                        var adjustment = this.replace_s(c_bra, c_ket, s);
                        if (c_bra <= this.bra)
                            this.bra += adjustment;
                        if (c_bra <= this.ket)
                            this.ket += adjustment;
                    },
                    slice_to : function() {
                        this.slice_check();
                        return current.substring(this.bra, this.ket);
                    },
                    eq_v_b : function(s) {
                        return this.eq_s_b(s.length, s);
                    }
                };
            }
        };

        lunr.trimmerSupport = {
            generateTrimmer: function(wordCharacters) {
                var startRegex = new RegExp("^[^" + wordCharacters + "]+")
                var endRegex = new RegExp("[^" + wordCharacters + "]+$")

                return function(token) {
                    // for lunr version 2
                    if (typeof token.update === "function") {
                        return token.update(function (s) {
                            return s
                                .replace(startRegex, '')
                                .replace(endRegex, '');
                        })
                    } else { // for lunr version 1
                        return token
                            .replace(startRegex, '')
                            .replace(endRegex, '');
                    }
                };
            }
        }
    }
}));


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return function(lunr) {
        /* Set up the pipeline for indexing content in multiple languages. The
           corresponding lunr.{lang} files must be loaded before calling this
           function; English ('en') is built in.

           Returns: a lunr plugin for use in your indexer.

           Known drawback: every word will be stemmed with stemmers for every
           language. This could mean that sometimes words that have the same
           stemming root will not be stemmed as such.
           */
        lunr.multiLanguage = function(/* lang1, lang2, ... */) {
            var languages = Array.prototype.slice.call(arguments);
            var nameSuffix = languages.join('-');
            var wordCharacters = "";
            var pipeline = [];
            var searchPipeline = [];
            for (var i = 0; i < languages.length; ++i) {
                if (languages[i] == 'en') {
                    wordCharacters += '\\w';
                    pipeline.unshift(lunr.stopWordFilter);
                    pipeline.push(lunr.stemmer);
                    searchPipeline.push(lunr.stemmer);
                } else {
                    wordCharacters += lunr[languages[i]].wordCharacters;
                    if (lunr[languages[i]].stopWordFilter) {
                        pipeline.unshift(lunr[languages[i]].stopWordFilter);
                    }
                    if (lunr[languages[i]].stemmer) {
                        pipeline.push(lunr[languages[i]].stemmer);
                        searchPipeline.push(lunr[languages[i]].stemmer);
                    }
                }
            };
            var multiTrimmer = lunr.trimmerSupport.generateTrimmer(wordCharacters);
            lunr.Pipeline.registerFunction(multiTrimmer, 'lunr-multi-trimmer-' + nameSuffix);
            pipeline.unshift(multiTrimmer);

            return function() {
                this.pipeline.reset();

                this.pipeline.add.apply(this.pipeline, pipeline);

                // for lunr version 2
                // this is necessary so that every searched word is also stemmed before
                // in lunr <= 1 this is not needed, as it is done using the normal pipeline
                if (this.searchPipeline) {
                    this.searchPipeline.reset();
                    this.searchPipeline.add.apply(this.searchPipeline, searchPipeline);
                }
            };
        }
    }
}));


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */

    return function(lunr) {
        // TinySegmenter 0.1 -- Super compact Japanese tokenizer in Javascript
        // (c) 2008 Taku Kudo <taku@chasen.org>
        // TinySegmenter is freely distributable under the terms of a new BSD licence.
        // For details, see http://chasen.org/~taku/software/TinySegmenter/LICENCE.txt

        function TinySegmenter() {
          var patterns = {
            "[一二三四五六七八九十百千万億兆]":"M",
            "[一-龠々〆ヵヶ]":"H",
            "[ぁ-ん]":"I",
            "[ァ-ヴーｱ-ﾝﾞｰ]":"K",
            "[a-zA-Zａ-ｚＡ-Ｚ]":"A",
            "[0-9０-９]":"N"
          }
          this.chartype_ = [];
          for (var i in patterns) {
            var regexp = new RegExp(i);
            this.chartype_.push([regexp, patterns[i]]);
          }

          this.BIAS__ = -332
          this.BC1__ = {"HH":6,"II":2461,"KH":406,"OH":-1378};
          this.BC2__ = {"AA":-3267,"AI":2744,"AN":-878,"HH":-4070,"HM":-1711,"HN":4012,"HO":3761,"IA":1327,"IH":-1184,"II":-1332,"IK":1721,"IO":5492,"KI":3831,"KK":-8741,"MH":-3132,"MK":3334,"OO":-2920};
          this.BC3__ = {"HH":996,"HI":626,"HK":-721,"HN":-1307,"HO":-836,"IH":-301,"KK":2762,"MK":1079,"MM":4034,"OA":-1652,"OH":266};
          this.BP1__ = {"BB":295,"OB":304,"OO":-125,"UB":352};
          this.BP2__ = {"BO":60,"OO":-1762};
          this.BQ1__ = {"BHH":1150,"BHM":1521,"BII":-1158,"BIM":886,"BMH":1208,"BNH":449,"BOH":-91,"BOO":-2597,"OHI":451,"OIH":-296,"OKA":1851,"OKH":-1020,"OKK":904,"OOO":2965};
          this.BQ2__ = {"BHH":118,"BHI":-1159,"BHM":466,"BIH":-919,"BKK":-1720,"BKO":864,"OHH":-1139,"OHM":-181,"OIH":153,"UHI":-1146};
          this.BQ3__ = {"BHH":-792,"BHI":2664,"BII":-299,"BKI":419,"BMH":937,"BMM":8335,"BNN":998,"BOH":775,"OHH":2174,"OHM":439,"OII":280,"OKH":1798,"OKI":-793,"OKO":-2242,"OMH":-2402,"OOO":11699};
          this.BQ4__ = {"BHH":-3895,"BIH":3761,"BII":-4654,"BIK":1348,"BKK":-1806,"BMI":-3385,"BOO":-12396,"OAH":926,"OHH":266,"OHK":-2036,"ONN":-973};
          this.BW1__ = {",と":660,",同":727,"B1あ":1404,"B1同":542,"、と":660,"、同":727,"」と":1682,"あっ":1505,"いう":1743,"いっ":-2055,"いる":672,"うし":-4817,"うん":665,"から":3472,"がら":600,"こう":-790,"こと":2083,"こん":-1262,"さら":-4143,"さん":4573,"した":2641,"して":1104,"すで":-3399,"そこ":1977,"それ":-871,"たち":1122,"ため":601,"った":3463,"つい":-802,"てい":805,"てき":1249,"でき":1127,"です":3445,"では":844,"とい":-4915,"とみ":1922,"どこ":3887,"ない":5713,"なっ":3015,"など":7379,"なん":-1113,"にし":2468,"には":1498,"にも":1671,"に対":-912,"の一":-501,"の中":741,"ませ":2448,"まで":1711,"まま":2600,"まる":-2155,"やむ":-1947,"よっ":-2565,"れた":2369,"れで":-913,"をし":1860,"を見":731,"亡く":-1886,"京都":2558,"取り":-2784,"大き":-2604,"大阪":1497,"平方":-2314,"引き":-1336,"日本":-195,"本当":-2423,"毎日":-2113,"目指":-724,"Ｂ１あ":1404,"Ｂ１同":542,"｣と":1682};
          this.BW2__ = {"..":-11822,"11":-669,"――":-5730,"−−":-13175,"いう":-1609,"うか":2490,"かし":-1350,"かも":-602,"から":-7194,"かれ":4612,"がい":853,"がら":-3198,"きた":1941,"くな":-1597,"こと":-8392,"この":-4193,"させ":4533,"され":13168,"さん":-3977,"しい":-1819,"しか":-545,"した":5078,"して":972,"しな":939,"その":-3744,"たい":-1253,"たた":-662,"ただ":-3857,"たち":-786,"たと":1224,"たは":-939,"った":4589,"って":1647,"っと":-2094,"てい":6144,"てき":3640,"てく":2551,"ては":-3110,"ても":-3065,"でい":2666,"でき":-1528,"でし":-3828,"です":-4761,"でも":-4203,"とい":1890,"とこ":-1746,"とと":-2279,"との":720,"とみ":5168,"とも":-3941,"ない":-2488,"なが":-1313,"など":-6509,"なの":2614,"なん":3099,"にお":-1615,"にし":2748,"にな":2454,"によ":-7236,"に対":-14943,"に従":-4688,"に関":-11388,"のか":2093,"ので":-7059,"のに":-6041,"のの":-6125,"はい":1073,"はが":-1033,"はず":-2532,"ばれ":1813,"まし":-1316,"まで":-6621,"まれ":5409,"めて":-3153,"もい":2230,"もの":-10713,"らか":-944,"らし":-1611,"らに":-1897,"りし":651,"りま":1620,"れた":4270,"れて":849,"れば":4114,"ろう":6067,"われ":7901,"を通":-11877,"んだ":728,"んな":-4115,"一人":602,"一方":-1375,"一日":970,"一部":-1051,"上が":-4479,"会社":-1116,"出て":2163,"分の":-7758,"同党":970,"同日":-913,"大阪":-2471,"委員":-1250,"少な":-1050,"年度":-8669,"年間":-1626,"府県":-2363,"手権":-1982,"新聞":-4066,"日新":-722,"日本":-7068,"日米":3372,"曜日":-601,"朝鮮":-2355,"本人":-2697,"東京":-1543,"然と":-1384,"社会":-1276,"立て":-990,"第に":-1612,"米国":-4268,"１１":-669};
          this.BW3__ = {"あた":-2194,"あり":719,"ある":3846,"い.":-1185,"い。":-1185,"いい":5308,"いえ":2079,"いく":3029,"いた":2056,"いっ":1883,"いる":5600,"いわ":1527,"うち":1117,"うと":4798,"えと":1454,"か.":2857,"か。":2857,"かけ":-743,"かっ":-4098,"かに":-669,"から":6520,"かり":-2670,"が,":1816,"が、":1816,"がき":-4855,"がけ":-1127,"がっ":-913,"がら":-4977,"がり":-2064,"きた":1645,"けど":1374,"こと":7397,"この":1542,"ころ":-2757,"さい":-714,"さを":976,"し,":1557,"し、":1557,"しい":-3714,"した":3562,"して":1449,"しな":2608,"しま":1200,"す.":-1310,"す。":-1310,"する":6521,"ず,":3426,"ず、":3426,"ずに":841,"そう":428,"た.":8875,"た。":8875,"たい":-594,"たの":812,"たり":-1183,"たる":-853,"だ.":4098,"だ。":4098,"だっ":1004,"った":-4748,"って":300,"てい":6240,"てお":855,"ても":302,"です":1437,"でに":-1482,"では":2295,"とう":-1387,"とし":2266,"との":541,"とも":-3543,"どう":4664,"ない":1796,"なく":-903,"など":2135,"に,":-1021,"に、":-1021,"にし":1771,"にな":1906,"には":2644,"の,":-724,"の、":-724,"の子":-1000,"は,":1337,"は、":1337,"べき":2181,"まし":1113,"ます":6943,"まっ":-1549,"まで":6154,"まれ":-793,"らし":1479,"られ":6820,"るる":3818,"れ,":854,"れ、":854,"れた":1850,"れて":1375,"れば":-3246,"れる":1091,"われ":-605,"んだ":606,"んで":798,"カ月":990,"会議":860,"入り":1232,"大会":2217,"始め":1681,"市":965,"新聞":-5055,"日,":974,"日、":974,"社会":2024,"ｶ月":990};
          this.TC1__ = {"AAA":1093,"HHH":1029,"HHM":580,"HII":998,"HOH":-390,"HOM":-331,"IHI":1169,"IOH":-142,"IOI":-1015,"IOM":467,"MMH":187,"OOI":-1832};
          this.TC2__ = {"HHO":2088,"HII":-1023,"HMM":-1154,"IHI":-1965,"KKH":703,"OII":-2649};
          this.TC3__ = {"AAA":-294,"HHH":346,"HHI":-341,"HII":-1088,"HIK":731,"HOH":-1486,"IHH":128,"IHI":-3041,"IHO":-1935,"IIH":-825,"IIM":-1035,"IOI":-542,"KHH":-1216,"KKA":491,"KKH":-1217,"KOK":-1009,"MHH":-2694,"MHM":-457,"MHO":123,"MMH":-471,"NNH":-1689,"NNO":662,"OHO":-3393};
          this.TC4__ = {"HHH":-203,"HHI":1344,"HHK":365,"HHM":-122,"HHN":182,"HHO":669,"HIH":804,"HII":679,"HOH":446,"IHH":695,"IHO":-2324,"IIH":321,"III":1497,"IIO":656,"IOO":54,"KAK":4845,"KKA":3386,"KKK":3065,"MHH":-405,"MHI":201,"MMH":-241,"MMM":661,"MOM":841};
          this.TQ1__ = {"BHHH":-227,"BHHI":316,"BHIH":-132,"BIHH":60,"BIII":1595,"BNHH":-744,"BOHH":225,"BOOO":-908,"OAKK":482,"OHHH":281,"OHIH":249,"OIHI":200,"OIIH":-68};
          this.TQ2__ = {"BIHH":-1401,"BIII":-1033,"BKAK":-543,"BOOO":-5591};
          this.TQ3__ = {"BHHH":478,"BHHM":-1073,"BHIH":222,"BHII":-504,"BIIH":-116,"BIII":-105,"BMHI":-863,"BMHM":-464,"BOMH":620,"OHHH":346,"OHHI":1729,"OHII":997,"OHMH":481,"OIHH":623,"OIIH":1344,"OKAK":2792,"OKHH":587,"OKKA":679,"OOHH":110,"OOII":-685};
          this.TQ4__ = {"BHHH":-721,"BHHM":-3604,"BHII":-966,"BIIH":-607,"BIII":-2181,"OAAA":-2763,"OAKK":180,"OHHH":-294,"OHHI":2446,"OHHO":480,"OHIH":-1573,"OIHH":1935,"OIHI":-493,"OIIH":626,"OIII":-4007,"OKAK":-8156};
          this.TW1__ = {"につい":-4681,"東京都":2026};
          this.TW2__ = {"ある程":-2049,"いった":-1256,"ころが":-2434,"しょう":3873,"その後":-4430,"だって":-1049,"ていた":1833,"として":-4657,"ともに":-4517,"もので":1882,"一気に":-792,"初めて":-1512,"同時に":-8097,"大きな":-1255,"対して":-2721,"社会党":-3216};
          this.TW3__ = {"いただ":-1734,"してい":1314,"として":-4314,"につい":-5483,"にとっ":-5989,"に当た":-6247,"ので,":-727,"ので、":-727,"のもの":-600,"れから":-3752,"十二月":-2287};
          this.TW4__ = {"いう.":8576,"いう。":8576,"からな":-2348,"してい":2958,"たが,":1516,"たが、":1516,"ている":1538,"という":1349,"ました":5543,"ません":1097,"ようと":-4258,"よると":5865};
          this.UC1__ = {"A":484,"K":93,"M":645,"O":-505};
          this.UC2__ = {"A":819,"H":1059,"I":409,"M":3987,"N":5775,"O":646};
          this.UC3__ = {"A":-1370,"I":2311};
          this.UC4__ = {"A":-2643,"H":1809,"I":-1032,"K":-3450,"M":3565,"N":3876,"O":6646};
          this.UC5__ = {"H":313,"I":-1238,"K":-799,"M":539,"O":-831};
          this.UC6__ = {"H":-506,"I":-253,"K":87,"M":247,"O":-387};
          this.UP1__ = {"O":-214};
          this.UP2__ = {"B":69,"O":935};
          this.UP3__ = {"B":189};
          this.UQ1__ = {"BH":21,"BI":-12,"BK":-99,"BN":142,"BO":-56,"OH":-95,"OI":477,"OK":410,"OO":-2422};
          this.UQ2__ = {"BH":216,"BI":113,"OK":1759};
          this.UQ3__ = {"BA":-479,"BH":42,"BI":1913,"BK":-7198,"BM":3160,"BN":6427,"BO":14761,"OI":-827,"ON":-3212};
          this.UW1__ = {",":156,"、":156,"「":-463,"あ":-941,"う":-127,"が":-553,"き":121,"こ":505,"で":-201,"と":-547,"ど":-123,"に":-789,"の":-185,"は":-847,"も":-466,"や":-470,"よ":182,"ら":-292,"り":208,"れ":169,"を":-446,"ん":-137,"・":-135,"主":-402,"京":-268,"区":-912,"午":871,"国":-460,"大":561,"委":729,"市":-411,"日":-141,"理":361,"生":-408,"県":-386,"都":-718,"｢":-463,"･":-135};
          this.UW2__ = {",":-829,"、":-829,"〇":892,"「":-645,"」":3145,"あ":-538,"い":505,"う":134,"お":-502,"か":1454,"が":-856,"く":-412,"こ":1141,"さ":878,"ざ":540,"し":1529,"す":-675,"せ":300,"そ":-1011,"た":188,"だ":1837,"つ":-949,"て":-291,"で":-268,"と":-981,"ど":1273,"な":1063,"に":-1764,"の":130,"は":-409,"ひ":-1273,"べ":1261,"ま":600,"も":-1263,"や":-402,"よ":1639,"り":-579,"る":-694,"れ":571,"を":-2516,"ん":2095,"ア":-587,"カ":306,"キ":568,"ッ":831,"三":-758,"不":-2150,"世":-302,"中":-968,"主":-861,"事":492,"人":-123,"会":978,"保":362,"入":548,"初":-3025,"副":-1566,"北":-3414,"区":-422,"大":-1769,"天":-865,"太":-483,"子":-1519,"学":760,"実":1023,"小":-2009,"市":-813,"年":-1060,"強":1067,"手":-1519,"揺":-1033,"政":1522,"文":-1355,"新":-1682,"日":-1815,"明":-1462,"最":-630,"朝":-1843,"本":-1650,"東":-931,"果":-665,"次":-2378,"民":-180,"気":-1740,"理":752,"発":529,"目":-1584,"相":-242,"県":-1165,"立":-763,"第":810,"米":509,"自":-1353,"行":838,"西":-744,"見":-3874,"調":1010,"議":1198,"込":3041,"開":1758,"間":-1257,"｢":-645,"｣":3145,"ｯ":831,"ｱ":-587,"ｶ":306,"ｷ":568};
          this.UW3__ = {",":4889,"1":-800,"−":-1723,"、":4889,"々":-2311,"〇":5827,"」":2670,"〓":-3573,"あ":-2696,"い":1006,"う":2342,"え":1983,"お":-4864,"か":-1163,"が":3271,"く":1004,"け":388,"げ":401,"こ":-3552,"ご":-3116,"さ":-1058,"し":-395,"す":584,"せ":3685,"そ":-5228,"た":842,"ち":-521,"っ":-1444,"つ":-1081,"て":6167,"で":2318,"と":1691,"ど":-899,"な":-2788,"に":2745,"の":4056,"は":4555,"ひ":-2171,"ふ":-1798,"へ":1199,"ほ":-5516,"ま":-4384,"み":-120,"め":1205,"も":2323,"や":-788,"よ":-202,"ら":727,"り":649,"る":5905,"れ":2773,"わ":-1207,"を":6620,"ん":-518,"ア":551,"グ":1319,"ス":874,"ッ":-1350,"ト":521,"ム":1109,"ル":1591,"ロ":2201,"ン":278,"・":-3794,"一":-1619,"下":-1759,"世":-2087,"両":3815,"中":653,"主":-758,"予":-1193,"二":974,"人":2742,"今":792,"他":1889,"以":-1368,"低":811,"何":4265,"作":-361,"保":-2439,"元":4858,"党":3593,"全":1574,"公":-3030,"六":755,"共":-1880,"円":5807,"再":3095,"分":457,"初":2475,"別":1129,"前":2286,"副":4437,"力":365,"動":-949,"務":-1872,"化":1327,"北":-1038,"区":4646,"千":-2309,"午":-783,"協":-1006,"口":483,"右":1233,"各":3588,"合":-241,"同":3906,"和":-837,"員":4513,"国":642,"型":1389,"場":1219,"外":-241,"妻":2016,"学":-1356,"安":-423,"実":-1008,"家":1078,"小":-513,"少":-3102,"州":1155,"市":3197,"平":-1804,"年":2416,"広":-1030,"府":1605,"度":1452,"建":-2352,"当":-3885,"得":1905,"思":-1291,"性":1822,"戸":-488,"指":-3973,"政":-2013,"教":-1479,"数":3222,"文":-1489,"新":1764,"日":2099,"旧":5792,"昨":-661,"時":-1248,"曜":-951,"最":-937,"月":4125,"期":360,"李":3094,"村":364,"東":-805,"核":5156,"森":2438,"業":484,"氏":2613,"民":-1694,"決":-1073,"法":1868,"海":-495,"無":979,"物":461,"特":-3850,"生":-273,"用":914,"町":1215,"的":7313,"直":-1835,"省":792,"県":6293,"知":-1528,"私":4231,"税":401,"立":-960,"第":1201,"米":7767,"系":3066,"約":3663,"級":1384,"統":-4229,"総":1163,"線":1255,"者":6457,"能":725,"自":-2869,"英":785,"見":1044,"調":-562,"財":-733,"費":1777,"車":1835,"軍":1375,"込":-1504,"通":-1136,"選":-681,"郎":1026,"郡":4404,"部":1200,"金":2163,"長":421,"開":-1432,"間":1302,"関":-1282,"雨":2009,"電":-1045,"非":2066,"駅":1620,"１":-800,"｣":2670,"･":-3794,"ｯ":-1350,"ｱ":551,"ｸﾞ":1319,"ｽ":874,"ﾄ":521,"ﾑ":1109,"ﾙ":1591,"ﾛ":2201,"ﾝ":278};
          this.UW4__ = {",":3930,".":3508,"―":-4841,"、":3930,"。":3508,"〇":4999,"「":1895,"」":3798,"〓":-5156,"あ":4752,"い":-3435,"う":-640,"え":-2514,"お":2405,"か":530,"が":6006,"き":-4482,"ぎ":-3821,"く":-3788,"け":-4376,"げ":-4734,"こ":2255,"ご":1979,"さ":2864,"し":-843,"じ":-2506,"す":-731,"ず":1251,"せ":181,"そ":4091,"た":5034,"だ":5408,"ち":-3654,"っ":-5882,"つ":-1659,"て":3994,"で":7410,"と":4547,"な":5433,"に":6499,"ぬ":1853,"ね":1413,"の":7396,"は":8578,"ば":1940,"ひ":4249,"び":-4134,"ふ":1345,"へ":6665,"べ":-744,"ほ":1464,"ま":1051,"み":-2082,"む":-882,"め":-5046,"も":4169,"ゃ":-2666,"や":2795,"ょ":-1544,"よ":3351,"ら":-2922,"り":-9726,"る":-14896,"れ":-2613,"ろ":-4570,"わ":-1783,"を":13150,"ん":-2352,"カ":2145,"コ":1789,"セ":1287,"ッ":-724,"ト":-403,"メ":-1635,"ラ":-881,"リ":-541,"ル":-856,"ン":-3637,"・":-4371,"ー":-11870,"一":-2069,"中":2210,"予":782,"事":-190,"井":-1768,"人":1036,"以":544,"会":950,"体":-1286,"作":530,"側":4292,"先":601,"党":-2006,"共":-1212,"内":584,"円":788,"初":1347,"前":1623,"副":3879,"力":-302,"動":-740,"務":-2715,"化":776,"区":4517,"協":1013,"参":1555,"合":-1834,"和":-681,"員":-910,"器":-851,"回":1500,"国":-619,"園":-1200,"地":866,"場":-1410,"塁":-2094,"士":-1413,"多":1067,"大":571,"子":-4802,"学":-1397,"定":-1057,"寺":-809,"小":1910,"屋":-1328,"山":-1500,"島":-2056,"川":-2667,"市":2771,"年":374,"庁":-4556,"後":456,"性":553,"感":916,"所":-1566,"支":856,"改":787,"政":2182,"教":704,"文":522,"方":-856,"日":1798,"時":1829,"最":845,"月":-9066,"木":-485,"来":-442,"校":-360,"業":-1043,"氏":5388,"民":-2716,"気":-910,"沢":-939,"済":-543,"物":-735,"率":672,"球":-1267,"生":-1286,"産":-1101,"田":-2900,"町":1826,"的":2586,"目":922,"省":-3485,"県":2997,"空":-867,"立":-2112,"第":788,"米":2937,"系":786,"約":2171,"経":1146,"統":-1169,"総":940,"線":-994,"署":749,"者":2145,"能":-730,"般":-852,"行":-792,"規":792,"警":-1184,"議":-244,"谷":-1000,"賞":730,"車":-1481,"軍":1158,"輪":-1433,"込":-3370,"近":929,"道":-1291,"選":2596,"郎":-4866,"都":1192,"野":-1100,"銀":-2213,"長":357,"間":-2344,"院":-2297,"際":-2604,"電":-878,"領":-1659,"題":-792,"館":-1984,"首":1749,"高":2120,"｢":1895,"｣":3798,"･":-4371,"ｯ":-724,"ｰ":-11870,"ｶ":2145,"ｺ":1789,"ｾ":1287,"ﾄ":-403,"ﾒ":-1635,"ﾗ":-881,"ﾘ":-541,"ﾙ":-856,"ﾝ":-3637};
          this.UW5__ = {",":465,".":-299,"1":-514,"E2":-32768,"]":-2762,"、":465,"。":-299,"「":363,"あ":1655,"い":331,"う":-503,"え":1199,"お":527,"か":647,"が":-421,"き":1624,"ぎ":1971,"く":312,"げ":-983,"さ":-1537,"し":-1371,"す":-852,"だ":-1186,"ち":1093,"っ":52,"つ":921,"て":-18,"で":-850,"と":-127,"ど":1682,"な":-787,"に":-1224,"の":-635,"は":-578,"べ":1001,"み":502,"め":865,"ゃ":3350,"ょ":854,"り":-208,"る":429,"れ":504,"わ":419,"を":-1264,"ん":327,"イ":241,"ル":451,"ン":-343,"中":-871,"京":722,"会":-1153,"党":-654,"務":3519,"区":-901,"告":848,"員":2104,"大":-1296,"学":-548,"定":1785,"嵐":-1304,"市":-2991,"席":921,"年":1763,"思":872,"所":-814,"挙":1618,"新":-1682,"日":218,"月":-4353,"査":932,"格":1356,"機":-1508,"氏":-1347,"田":240,"町":-3912,"的":-3149,"相":1319,"省":-1052,"県":-4003,"研":-997,"社":-278,"空":-813,"統":1955,"者":-2233,"表":663,"語":-1073,"議":1219,"選":-1018,"郎":-368,"長":786,"間":1191,"題":2368,"館":-689,"１":-514,"Ｅ２":-32768,"｢":363,"ｲ":241,"ﾙ":451,"ﾝ":-343};
          this.UW6__ = {",":227,".":808,"1":-270,"E1":306,"、":227,"。":808,"あ":-307,"う":189,"か":241,"が":-73,"く":-121,"こ":-200,"じ":1782,"す":383,"た":-428,"っ":573,"て":-1014,"で":101,"と":-105,"な":-253,"に":-149,"の":-417,"は":-236,"も":-206,"り":187,"る":-135,"を":195,"ル":-673,"ン":-496,"一":-277,"中":201,"件":-800,"会":624,"前":302,"区":1792,"員":-1212,"委":798,"学":-960,"市":887,"広":-695,"後":535,"業":-697,"相":753,"社":-507,"福":974,"空":-822,"者":1811,"連":463,"郎":1082,"１":-270,"Ｅ１":306,"ﾙ":-673,"ﾝ":-496};
          
          return this;
        }
        TinySegmenter.prototype.ctype_ = function(str) {
          for (var i in this.chartype_) {
            if (str.match(this.chartype_[i][0])) {
              return this.chartype_[i][1];
            }
          }
          return "O";
        }

        TinySegmenter.prototype.ts_ = function(v) {
          if (v) { return v; }
          return 0;
        }

        TinySegmenter.prototype.segment = function(input) {
          if (input == null || input == undefined || input == "") {
            return [];
          }
          var result = [];
          var seg = ["B3","B2","B1"];
          var ctype = ["O","O","O"];
          var o = input.split("");
          for (i = 0; i < o.length; ++i) {
            seg.push(o[i]);
            ctype.push(this.ctype_(o[i]))
          }
          seg.push("E1");
          seg.push("E2");
          seg.push("E3");
          ctype.push("O");
          ctype.push("O");
          ctype.push("O");
          var word = seg[3];
          var p1 = "U";
          var p2 = "U";
          var p3 = "U";
          for (var i = 4; i < seg.length - 3; ++i) {
            var score = this.BIAS__;
            var w1 = seg[i-3];
            var w2 = seg[i-2];
            var w3 = seg[i-1];
            var w4 = seg[i];
            var w5 = seg[i+1];
            var w6 = seg[i+2];
            var c1 = ctype[i-3];
            var c2 = ctype[i-2];
            var c3 = ctype[i-1];
            var c4 = ctype[i];
            var c5 = ctype[i+1];
            var c6 = ctype[i+2];
            score += this.ts_(this.UP1__[p1]);
            score += this.ts_(this.UP2__[p2]);
            score += this.ts_(this.UP3__[p3]);
            score += this.ts_(this.BP1__[p1 + p2]);
            score += this.ts_(this.BP2__[p2 + p3]);
            score += this.ts_(this.UW1__[w1]);
            score += this.ts_(this.UW2__[w2]);
            score += this.ts_(this.UW3__[w3]);
            score += this.ts_(this.UW4__[w4]);
            score += this.ts_(this.UW5__[w5]);
            score += this.ts_(this.UW6__[w6]);
            score += this.ts_(this.BW1__[w2 + w3]);
            score += this.ts_(this.BW2__[w3 + w4]);
            score += this.ts_(this.BW3__[w4 + w5]);
            score += this.ts_(this.TW1__[w1 + w2 + w3]);
            score += this.ts_(this.TW2__[w2 + w3 + w4]);
            score += this.ts_(this.TW3__[w3 + w4 + w5]);
            score += this.ts_(this.TW4__[w4 + w5 + w6]);
            score += this.ts_(this.UC1__[c1]);
            score += this.ts_(this.UC2__[c2]);
            score += this.ts_(this.UC3__[c3]);
            score += this.ts_(this.UC4__[c4]);
            score += this.ts_(this.UC5__[c5]);
            score += this.ts_(this.UC6__[c6]);
            score += this.ts_(this.BC1__[c2 + c3]);
            score += this.ts_(this.BC2__[c3 + c4]);
            score += this.ts_(this.BC3__[c4 + c5]);
            score += this.ts_(this.TC1__[c1 + c2 + c3]);
            score += this.ts_(this.TC2__[c2 + c3 + c4]);
            score += this.ts_(this.TC3__[c3 + c4 + c5]);
            score += this.ts_(this.TC4__[c4 + c5 + c6]);
        //  score += this.ts_(this.TC5__[c4 + c5 + c6]);    
            score += this.ts_(this.UQ1__[p1 + c1]);
            score += this.ts_(this.UQ2__[p2 + c2]);
            score += this.ts_(this.UQ3__[p3 + c3]);
            score += this.ts_(this.BQ1__[p2 + c2 + c3]);
            score += this.ts_(this.BQ2__[p2 + c3 + c4]);
            score += this.ts_(this.BQ3__[p3 + c2 + c3]);
            score += this.ts_(this.BQ4__[p3 + c3 + c4]);
            score += this.ts_(this.TQ1__[p2 + c1 + c2 + c3]);
            score += this.ts_(this.TQ2__[p2 + c2 + c3 + c4]);
            score += this.ts_(this.TQ3__[p3 + c1 + c2 + c3]);
            score += this.ts_(this.TQ4__[p3 + c2 + c3 + c4]);
            var p = "O";
            if (score > 0) {
              result.push(word);
              word = "";
              p = "B";
            }
            p1 = p2;
            p2 = p3;
            p3 = p;
            word += seg[i];
          }
          result.push(word);

          return result;
        }

        lunr.TinySegmenter = TinySegmenter;
    };

}));

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `German` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.de = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.de.trimmer,
        lunr.de.stopWordFilter,
        lunr.de.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.de.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.de.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.de.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.de.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.de.trimmer, 'trimmer-de');

    /* lunr stemmer function */
    lunr.de.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function GermanStemmer() {
          var a_0 = [new Among("", -1, 6), new Among("U", 0, 2),
              new Among("Y", 0, 1), new Among("\u00E4", 0, 3),
              new Among("\u00F6", 0, 4), new Among("\u00FC", 0, 5)
            ],
            a_1 = [
              new Among("e", -1, 2), new Among("em", -1, 1),
              new Among("en", -1, 2), new Among("ern", -1, 1),
              new Among("er", -1, 1), new Among("s", -1, 3),
              new Among("es", 5, 2)
            ],
            a_2 = [new Among("en", -1, 1),
              new Among("er", -1, 1), new Among("st", -1, 2),
              new Among("est", 2, 1)
            ],
            a_3 = [new Among("ig", -1, 1),
              new Among("lich", -1, 1)
            ],
            a_4 = [new Among("end", -1, 1),
              new Among("ig", -1, 2), new Among("ung", -1, 1),
              new Among("lich", -1, 3), new Among("isch", -1, 2),
              new Among("ik", -1, 2), new Among("heit", -1, 3),
              new Among("keit", -1, 4)
            ],
            g_v = [17, 65, 16, 1, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 8, 0, 32, 8
            ],
            g_s_ending = [117, 30, 5],
            g_st_ending = [
              117, 30, 4
            ],
            I_x, I_p2, I_p1, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 252)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function r_prelude() {
            var v_1 = sbp.cursor,
              v_2, v_3, v_4, v_5;
            while (true) {
              v_2 = sbp.cursor;
              sbp.bra = v_2;
              if (sbp.eq_s(1, "\u00DF")) {
                sbp.ket = sbp.cursor;
                sbp.slice_from("ss");
              } else {
                if (v_2 >= sbp.limit)
                  break;
                sbp.cursor = v_2 + 1;
              }
            }
            sbp.cursor = v_1;
            while (true) {
              v_3 = sbp.cursor;
              while (true) {
                v_4 = sbp.cursor;
                if (sbp.in_grouping(g_v, 97, 252)) {
                  v_5 = sbp.cursor;
                  sbp.bra = v_5;
                  if (habr1("u", "U", v_4))
                    break;
                  sbp.cursor = v_5;
                  if (habr1("y", "Y", v_4))
                    break;
                }
                if (v_4 >= sbp.limit) {
                  sbp.cursor = v_3;
                  return;
                }
                sbp.cursor = v_4 + 1;
              }
            }
          }

          function habr2() {
            while (!sbp.in_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            return false;
          }

          function r_mark_regions() {
            I_p1 = sbp.limit;
            I_p2 = I_p1;
            var c = sbp.cursor + 3;
            if (0 <= c && c <= sbp.limit) {
              I_x = c;
              if (!habr2()) {
                I_p1 = sbp.cursor;
                if (I_p1 < I_x)
                  I_p1 = I_x;
                if (!habr2())
                  I_p2 = sbp.cursor;
              }
            }
          }

          function r_postlude() {
            var among_var, v_1;
            while (true) {
              v_1 = sbp.cursor;
              sbp.bra = v_1;
              among_var = sbp.find_among(a_0, 6);
              if (!among_var)
                return;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("y");
                  break;
                case 2:
                case 5:
                  sbp.slice_from("u");
                  break;
                case 3:
                  sbp.slice_from("a");
                  break;
                case 4:
                  sbp.slice_from("o");
                  break;
                case 6:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var, v_1 = sbp.limit - sbp.cursor,
              v_2, v_3, v_4;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_1, 7);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R1()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(1, "s")) {
                      sbp.bra = sbp.cursor;
                      if (sbp.eq_s_b(3, "nis"))
                        sbp.slice_del();
                    }
                    break;
                  case 3:
                    if (sbp.in_grouping_b(g_s_ending, 98, 116))
                      sbp.slice_del();
                    break;
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_2, 4);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R1()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    if (sbp.in_grouping_b(g_st_ending, 98, 116)) {
                      var c = sbp.cursor - 3;
                      if (sbp.limit_backward <= c && c <= sbp.limit) {
                        sbp.cursor = c;
                        sbp.slice_del();
                      }
                    }
                    break;
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_4, 8);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R2()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(2, "ig")) {
                      sbp.bra = sbp.cursor;
                      v_2 = sbp.limit - sbp.cursor;
                      if (!sbp.eq_s_b(1, "e")) {
                        sbp.cursor = sbp.limit - v_2;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                    break;
                  case 2:
                    v_3 = sbp.limit - sbp.cursor;
                    if (!sbp.eq_s_b(1, "e")) {
                      sbp.cursor = sbp.limit - v_3;
                      sbp.slice_del();
                    }
                    break;
                  case 3:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    v_4 = sbp.limit - sbp.cursor;
                    if (!sbp.eq_s_b(2, "er")) {
                      sbp.cursor = sbp.limit - v_4;
                      if (!sbp.eq_s_b(2, "en"))
                        break;
                    }
                    sbp.bra = sbp.cursor;
                    if (r_R1())
                      sbp.slice_del();
                    break;
                  case 4:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    among_var = sbp.find_among_b(a_3, 2);
                    if (among_var) {
                      sbp.bra = sbp.cursor;
                      if (r_R2() && among_var == 1)
                        sbp.slice_del();
                    }
                    break;
                }
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_standard_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.de.stemmer, 'stemmer-de');

    lunr.de.stopWordFilter = lunr.generateStopWordFilter('aber alle allem allen aller alles als also am an ander andere anderem anderen anderer anderes anderm andern anderr anders auch auf aus bei bin bis bist da damit dann das dasselbe dazu daß dein deine deinem deinen deiner deines dem demselben den denn denselben der derer derselbe derselben des desselben dessen dich die dies diese dieselbe dieselben diesem diesen dieser dieses dir doch dort du durch ein eine einem einen einer eines einig einige einigem einigen einiger einiges einmal er es etwas euch euer eure eurem euren eurer eures für gegen gewesen hab habe haben hat hatte hatten hier hin hinter ich ihm ihn ihnen ihr ihre ihrem ihren ihrer ihres im in indem ins ist jede jedem jeden jeder jedes jene jenem jenen jener jenes jetzt kann kein keine keinem keinen keiner keines können könnte machen man manche manchem manchen mancher manches mein meine meinem meinen meiner meines mich mir mit muss musste nach nicht nichts noch nun nur ob oder ohne sehr sein seine seinem seinen seiner seines selbst sich sie sind so solche solchem solchen solcher solches soll sollte sondern sonst um und uns unse unsem unsen unser unses unter viel vom von vor war waren warst was weg weil weiter welche welchem welchen welcher welches wenn werde werden wie wieder will wir wird wirst wo wollen wollte während würde würden zu zum zur zwar zwischen über'.split(' '));

    lunr.Pipeline.registerFunction(lunr.de.stopWordFilter, 'stopWordFilter-de');
  };
}))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Spanish` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.es = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.es.trimmer,
        lunr.es.stopWordFilter,
        lunr.es.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.es.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.es.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.es.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.es.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.es.trimmer, 'trimmer-es');

    /* lunr stemmer function */
    lunr.es.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function SpanishStemmer() {
          var a_0 = [new Among("", -1, 6), new Among("\u00E1", 0, 1),
              new Among("\u00E9", 0, 2), new Among("\u00ED", 0, 3),
              new Among("\u00F3", 0, 4), new Among("\u00FA", 0, 5)
            ],
            a_1 = [
              new Among("la", -1, -1), new Among("sela", 0, -1),
              new Among("le", -1, -1), new Among("me", -1, -1),
              new Among("se", -1, -1), new Among("lo", -1, -1),
              new Among("selo", 5, -1), new Among("las", -1, -1),
              new Among("selas", 7, -1), new Among("les", -1, -1),
              new Among("los", -1, -1), new Among("selos", 10, -1),
              new Among("nos", -1, -1)
            ],
            a_2 = [new Among("ando", -1, 6),
              new Among("iendo", -1, 6), new Among("yendo", -1, 7),
              new Among("\u00E1ndo", -1, 2), new Among("i\u00E9ndo", -1, 1),
              new Among("ar", -1, 6), new Among("er", -1, 6),
              new Among("ir", -1, 6), new Among("\u00E1r", -1, 3),
              new Among("\u00E9r", -1, 4), new Among("\u00EDr", -1, 5)
            ],
            a_3 = [
              new Among("ic", -1, -1), new Among("ad", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_4 = [
              new Among("able", -1, 1), new Among("ible", -1, 1),
              new Among("ante", -1, 1)
            ],
            a_5 = [new Among("ic", -1, 1),
              new Among("abil", -1, 1), new Among("iv", -1, 1)
            ],
            a_6 = [
              new Among("ica", -1, 1), new Among("ancia", -1, 2),
              new Among("encia", -1, 5), new Among("adora", -1, 2),
              new Among("osa", -1, 1), new Among("ista", -1, 1),
              new Among("iva", -1, 9), new Among("anza", -1, 1),
              new Among("log\u00EDa", -1, 3), new Among("idad", -1, 8),
              new Among("able", -1, 1), new Among("ible", -1, 1),
              new Among("ante", -1, 2), new Among("mente", -1, 7),
              new Among("amente", 13, 6), new Among("aci\u00F3n", -1, 2),
              new Among("uci\u00F3n", -1, 4), new Among("ico", -1, 1),
              new Among("ismo", -1, 1), new Among("oso", -1, 1),
              new Among("amiento", -1, 1), new Among("imiento", -1, 1),
              new Among("ivo", -1, 9), new Among("ador", -1, 2),
              new Among("icas", -1, 1), new Among("ancias", -1, 2),
              new Among("encias", -1, 5), new Among("adoras", -1, 2),
              new Among("osas", -1, 1), new Among("istas", -1, 1),
              new Among("ivas", -1, 9), new Among("anzas", -1, 1),
              new Among("log\u00EDas", -1, 3), new Among("idades", -1, 8),
              new Among("ables", -1, 1), new Among("ibles", -1, 1),
              new Among("aciones", -1, 2), new Among("uciones", -1, 4),
              new Among("adores", -1, 2), new Among("antes", -1, 2),
              new Among("icos", -1, 1), new Among("ismos", -1, 1),
              new Among("osos", -1, 1), new Among("amientos", -1, 1),
              new Among("imientos", -1, 1), new Among("ivos", -1, 9)
            ],
            a_7 = [
              new Among("ya", -1, 1), new Among("ye", -1, 1),
              new Among("yan", -1, 1), new Among("yen", -1, 1),
              new Among("yeron", -1, 1), new Among("yendo", -1, 1),
              new Among("yo", -1, 1), new Among("yas", -1, 1),
              new Among("yes", -1, 1), new Among("yais", -1, 1),
              new Among("yamos", -1, 1), new Among("y\u00F3", -1, 1)
            ],
            a_8 = [
              new Among("aba", -1, 2), new Among("ada", -1, 2),
              new Among("ida", -1, 2), new Among("ara", -1, 2),
              new Among("iera", -1, 2), new Among("\u00EDa", -1, 2),
              new Among("ar\u00EDa", 5, 2), new Among("er\u00EDa", 5, 2),
              new Among("ir\u00EDa", 5, 2), new Among("ad", -1, 2),
              new Among("ed", -1, 2), new Among("id", -1, 2),
              new Among("ase", -1, 2), new Among("iese", -1, 2),
              new Among("aste", -1, 2), new Among("iste", -1, 2),
              new Among("an", -1, 2), new Among("aban", 16, 2),
              new Among("aran", 16, 2), new Among("ieran", 16, 2),
              new Among("\u00EDan", 16, 2), new Among("ar\u00EDan", 20, 2),
              new Among("er\u00EDan", 20, 2), new Among("ir\u00EDan", 20, 2),
              new Among("en", -1, 1), new Among("asen", 24, 2),
              new Among("iesen", 24, 2), new Among("aron", -1, 2),
              new Among("ieron", -1, 2), new Among("ar\u00E1n", -1, 2),
              new Among("er\u00E1n", -1, 2), new Among("ir\u00E1n", -1, 2),
              new Among("ado", -1, 2), new Among("ido", -1, 2),
              new Among("ando", -1, 2), new Among("iendo", -1, 2),
              new Among("ar", -1, 2), new Among("er", -1, 2),
              new Among("ir", -1, 2), new Among("as", -1, 2),
              new Among("abas", 39, 2), new Among("adas", 39, 2),
              new Among("idas", 39, 2), new Among("aras", 39, 2),
              new Among("ieras", 39, 2), new Among("\u00EDas", 39, 2),
              new Among("ar\u00EDas", 45, 2), new Among("er\u00EDas", 45, 2),
              new Among("ir\u00EDas", 45, 2), new Among("es", -1, 1),
              new Among("ases", 49, 2), new Among("ieses", 49, 2),
              new Among("abais", -1, 2), new Among("arais", -1, 2),
              new Among("ierais", -1, 2), new Among("\u00EDais", -1, 2),
              new Among("ar\u00EDais", 55, 2), new Among("er\u00EDais", 55, 2),
              new Among("ir\u00EDais", 55, 2), new Among("aseis", -1, 2),
              new Among("ieseis", -1, 2), new Among("asteis", -1, 2),
              new Among("isteis", -1, 2), new Among("\u00E1is", -1, 2),
              new Among("\u00E9is", -1, 1), new Among("ar\u00E9is", 64, 2),
              new Among("er\u00E9is", 64, 2), new Among("ir\u00E9is", 64, 2),
              new Among("ados", -1, 2), new Among("idos", -1, 2),
              new Among("amos", -1, 2), new Among("\u00E1bamos", 70, 2),
              new Among("\u00E1ramos", 70, 2), new Among("i\u00E9ramos", 70, 2),
              new Among("\u00EDamos", 70, 2), new Among("ar\u00EDamos", 74, 2),
              new Among("er\u00EDamos", 74, 2), new Among("ir\u00EDamos", 74, 2),
              new Among("emos", -1, 1), new Among("aremos", 78, 2),
              new Among("eremos", 78, 2), new Among("iremos", 78, 2),
              new Among("\u00E1semos", 78, 2), new Among("i\u00E9semos", 78, 2),
              new Among("imos", -1, 2), new Among("ar\u00E1s", -1, 2),
              new Among("er\u00E1s", -1, 2), new Among("ir\u00E1s", -1, 2),
              new Among("\u00EDs", -1, 2), new Among("ar\u00E1", -1, 2),
              new Among("er\u00E1", -1, 2), new Among("ir\u00E1", -1, 2),
              new Among("ar\u00E9", -1, 2), new Among("er\u00E9", -1, 2),
              new Among("ir\u00E9", -1, 2), new Among("i\u00F3", -1, 2)
            ],
            a_9 = [
              new Among("a", -1, 1), new Among("e", -1, 2),
              new Among("o", -1, 1), new Among("os", -1, 1),
              new Among("\u00E1", -1, 1), new Among("\u00E9", -1, 2),
              new Among("\u00ED", -1, 1), new Among("\u00F3", -1, 1)
            ],
            g_v = [17,
              65, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 17, 4, 10
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1() {
            if (sbp.out_grouping(g_v, 97, 252)) {
              while (!sbp.in_grouping(g_v, 97, 252)) {
                if (sbp.cursor >= sbp.limit)
                  return true;
                sbp.cursor++;
              }
              return false;
            }
            return true;
          }

          function habr2() {
            if (sbp.in_grouping(g_v, 97, 252)) {
              var v_1 = sbp.cursor;
              if (habr1()) {
                sbp.cursor = v_1;
                if (!sbp.in_grouping(g_v, 97, 252))
                  return true;
                while (!sbp.out_grouping(g_v, 97, 252)) {
                  if (sbp.cursor >= sbp.limit)
                    return true;
                  sbp.cursor++;
                }
              }
              return false;
            }
            return true;
          }

          function habr3() {
            var v_1 = sbp.cursor,
              v_2;
            if (habr2()) {
              sbp.cursor = v_1;
              if (!sbp.out_grouping(g_v, 97, 252))
                return;
              v_2 = sbp.cursor;
              if (habr1()) {
                sbp.cursor = v_2;
                if (!sbp.in_grouping(g_v, 97, 252) || sbp.cursor >= sbp.limit)
                  return;
                sbp.cursor++;
              }
            }
            I_pV = sbp.cursor;
          }

          function habr4() {
            while (!sbp.in_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr3();
            sbp.cursor = v_1;
            if (habr4()) {
              I_p1 = sbp.cursor;
              if (habr4())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 6);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("a");
                    continue;
                  case 2:
                    sbp.slice_from("e");
                    continue;
                  case 3:
                    sbp.slice_from("i");
                    continue;
                  case 4:
                    sbp.slice_from("o");
                    continue;
                  case 5:
                    sbp.slice_from("u");
                    continue;
                  case 6:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_attached_pronoun() {
            var among_var;
            sbp.ket = sbp.cursor;
            if (sbp.find_among_b(a_1, 13)) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among_b(a_2, 11);
              if (among_var && r_RV())
                switch (among_var) {
                  case 1:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("iendo");
                    break;
                  case 2:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ando");
                    break;
                  case 3:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ar");
                    break;
                  case 4:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("er");
                    break;
                  case 5:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ir");
                    break;
                  case 6:
                    sbp.slice_del();
                    break;
                  case 7:
                    if (sbp.eq_s_b(1, "u"))
                      sbp.slice_del();
                    break;
                }
            }
          }

          function habr5(a, n) {
            if (!r_R2())
              return true;
            sbp.slice_del();
            sbp.ket = sbp.cursor;
            var among_var = sbp.find_among_b(a, n);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (among_var == 1 && r_R2())
                sbp.slice_del();
            }
            return false;
          }

          function habr6(c1) {
            if (!r_R2())
              return true;
            sbp.slice_del();
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(2, c1)) {
              sbp.bra = sbp.cursor;
              if (r_R2())
                sbp.slice_del();
            }
            return false;
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 46);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  break;
                case 2:
                  if (habr6("ic"))
                    return false;
                  break;
                case 3:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("log");
                  break;
                case 4:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("u");
                  break;
                case 5:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("ente");
                  break;
                case 6:
                  if (!r_R1())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_3, 4);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    if (r_R2()) {
                      sbp.slice_del();
                      if (among_var == 1) {
                        sbp.ket = sbp.cursor;
                        if (sbp.eq_s_b(2, "at")) {
                          sbp.bra = sbp.cursor;
                          if (r_R2())
                            sbp.slice_del();
                        }
                      }
                    }
                  }
                  break;
                case 7:
                  if (habr5(a_4, 3))
                    return false;
                  break;
                case 8:
                  if (habr5(a_5, 3))
                    return false;
                  break;
                case 9:
                  if (habr6("at"))
                    return false;
                  break;
              }
              return true;
            }
            return false;
          }

          function r_y_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 12);
              sbp.limit_backward = v_1;
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1) {
                  if (!sbp.eq_s_b(1, "u"))
                    return false;
                  sbp.slice_del();
                }
                return true;
              }
            }
            return false;
          }

          function r_verb_suffix() {
            var among_var, v_1, v_2, v_3;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_8, 96);
              sbp.limit_backward = v_1;
              if (among_var) {
                sbp.bra = sbp.cursor;
                switch (among_var) {
                  case 1:
                    v_2 = sbp.limit - sbp.cursor;
                    if (sbp.eq_s_b(1, "u")) {
                      v_3 = sbp.limit - sbp.cursor;
                      if (sbp.eq_s_b(1, "g"))
                        sbp.cursor = sbp.limit - v_3;
                      else
                        sbp.cursor = sbp.limit - v_2;
                    } else
                      sbp.cursor = sbp.limit - v_2;
                    sbp.bra = sbp.cursor;
                  case 2:
                    sbp.slice_del();
                    break;
                }
              }
            }
          }

          function r_residual_suffix() {
            var among_var, v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_9, 8);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (r_RV())
                    sbp.slice_del();
                  break;
                case 2:
                  if (r_RV()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(1, "u")) {
                      sbp.bra = sbp.cursor;
                      v_1 = sbp.limit - sbp.cursor;
                      if (sbp.eq_s_b(1, "g")) {
                        sbp.cursor = sbp.limit - v_1;
                        if (r_RV())
                          sbp.slice_del();
                      }
                    }
                  }
                  break;
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_attached_pronoun();
            sbp.cursor = sbp.limit;
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_y_verb_suffix()) {
                sbp.cursor = sbp.limit;
                r_verb_suffix();
              }
            }
            sbp.cursor = sbp.limit;
            r_residual_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.es.stemmer, 'stemmer-es');

    lunr.es.stopWordFilter = lunr.generateStopWordFilter('a al algo algunas algunos ante antes como con contra cual cuando de del desde donde durante e el ella ellas ellos en entre era erais eran eras eres es esa esas ese eso esos esta estaba estabais estaban estabas estad estada estadas estado estados estamos estando estar estaremos estará estarán estarás estaré estaréis estaría estaríais estaríamos estarían estarías estas este estemos esto estos estoy estuve estuviera estuvierais estuvieran estuvieras estuvieron estuviese estuvieseis estuviesen estuvieses estuvimos estuviste estuvisteis estuviéramos estuviésemos estuvo está estábamos estáis están estás esté estéis estén estés fue fuera fuerais fueran fueras fueron fuese fueseis fuesen fueses fui fuimos fuiste fuisteis fuéramos fuésemos ha habida habidas habido habidos habiendo habremos habrá habrán habrás habré habréis habría habríais habríamos habrían habrías habéis había habíais habíamos habían habías han has hasta hay haya hayamos hayan hayas hayáis he hemos hube hubiera hubierais hubieran hubieras hubieron hubiese hubieseis hubiesen hubieses hubimos hubiste hubisteis hubiéramos hubiésemos hubo la las le les lo los me mi mis mucho muchos muy más mí mía mías mío míos nada ni no nos nosotras nosotros nuestra nuestras nuestro nuestros o os otra otras otro otros para pero poco por porque que quien quienes qué se sea seamos sean seas seremos será serán serás seré seréis sería seríais seríamos serían serías seáis sido siendo sin sobre sois somos son soy su sus suya suyas suyo suyos sí también tanto te tendremos tendrá tendrán tendrás tendré tendréis tendría tendríais tendríamos tendrían tendrías tened tenemos tenga tengamos tengan tengas tengo tengáis tenida tenidas tenido tenidos teniendo tenéis tenía teníais teníamos tenían tenías ti tiene tienen tienes todo todos tu tus tuve tuviera tuvierais tuvieran tuvieras tuvieron tuviese tuvieseis tuviesen tuvieses tuvimos tuviste tuvisteis tuviéramos tuviésemos tuvo tuya tuyas tuyo tuyos tú un una uno unos vosotras vosotros vuestra vuestras vuestro vuestros y ya yo él éramos'.split(' '));

    lunr.Pipeline.registerFunction(lunr.es.stopWordFilter, 'stopWordFilter-es');
  };
}))

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `French` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.fr = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.fr.trimmer,
        lunr.fr.stopWordFilter,
        lunr.fr.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.fr.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.fr.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.fr.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.fr.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.fr.trimmer, 'trimmer-fr');

    /* lunr stemmer function */
    lunr.fr.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function FrenchStemmer() {
          var a_0 = [new Among("col", -1, -1), new Among("par", -1, -1),
              new Among("tap", -1, -1)
            ],
            a_1 = [new Among("", -1, 4),
              new Among("I", 0, 1), new Among("U", 0, 2), new Among("Y", 0, 3)
            ],
            a_2 = [
              new Among("iqU", -1, 3), new Among("abl", -1, 3),
              new Among("I\u00E8r", -1, 4), new Among("i\u00E8r", -1, 4),
              new Among("eus", -1, 2), new Among("iv", -1, 1)
            ],
            a_3 = [
              new Among("ic", -1, 2), new Among("abil", -1, 1),
              new Among("iv", -1, 3)
            ],
            a_4 = [new Among("iqUe", -1, 1),
              new Among("atrice", -1, 2), new Among("ance", -1, 1),
              new Among("ence", -1, 5), new Among("logie", -1, 3),
              new Among("able", -1, 1), new Among("isme", -1, 1),
              new Among("euse", -1, 11), new Among("iste", -1, 1),
              new Among("ive", -1, 8), new Among("if", -1, 8),
              new Among("usion", -1, 4), new Among("ation", -1, 2),
              new Among("ution", -1, 4), new Among("ateur", -1, 2),
              new Among("iqUes", -1, 1), new Among("atrices", -1, 2),
              new Among("ances", -1, 1), new Among("ences", -1, 5),
              new Among("logies", -1, 3), new Among("ables", -1, 1),
              new Among("ismes", -1, 1), new Among("euses", -1, 11),
              new Among("istes", -1, 1), new Among("ives", -1, 8),
              new Among("ifs", -1, 8), new Among("usions", -1, 4),
              new Among("ations", -1, 2), new Among("utions", -1, 4),
              new Among("ateurs", -1, 2), new Among("ments", -1, 15),
              new Among("ements", 30, 6), new Among("issements", 31, 12),
              new Among("it\u00E9s", -1, 7), new Among("ment", -1, 15),
              new Among("ement", 34, 6), new Among("issement", 35, 12),
              new Among("amment", 34, 13), new Among("emment", 34, 14),
              new Among("aux", -1, 10), new Among("eaux", 39, 9),
              new Among("eux", -1, 1), new Among("it\u00E9", -1, 7)
            ],
            a_5 = [
              new Among("ira", -1, 1), new Among("ie", -1, 1),
              new Among("isse", -1, 1), new Among("issante", -1, 1),
              new Among("i", -1, 1), new Among("irai", 4, 1),
              new Among("ir", -1, 1), new Among("iras", -1, 1),
              new Among("ies", -1, 1), new Among("\u00EEmes", -1, 1),
              new Among("isses", -1, 1), new Among("issantes", -1, 1),
              new Among("\u00EEtes", -1, 1), new Among("is", -1, 1),
              new Among("irais", 13, 1), new Among("issais", 13, 1),
              new Among("irions", -1, 1), new Among("issions", -1, 1),
              new Among("irons", -1, 1), new Among("issons", -1, 1),
              new Among("issants", -1, 1), new Among("it", -1, 1),
              new Among("irait", 21, 1), new Among("issait", 21, 1),
              new Among("issant", -1, 1), new Among("iraIent", -1, 1),
              new Among("issaIent", -1, 1), new Among("irent", -1, 1),
              new Among("issent", -1, 1), new Among("iront", -1, 1),
              new Among("\u00EEt", -1, 1), new Among("iriez", -1, 1),
              new Among("issiez", -1, 1), new Among("irez", -1, 1),
              new Among("issez", -1, 1)
            ],
            a_6 = [new Among("a", -1, 3),
              new Among("era", 0, 2), new Among("asse", -1, 3),
              new Among("ante", -1, 3), new Among("\u00E9e", -1, 2),
              new Among("ai", -1, 3), new Among("erai", 5, 2),
              new Among("er", -1, 2), new Among("as", -1, 3),
              new Among("eras", 8, 2), new Among("\u00E2mes", -1, 3),
              new Among("asses", -1, 3), new Among("antes", -1, 3),
              new Among("\u00E2tes", -1, 3), new Among("\u00E9es", -1, 2),
              new Among("ais", -1, 3), new Among("erais", 15, 2),
              new Among("ions", -1, 1), new Among("erions", 17, 2),
              new Among("assions", 17, 3), new Among("erons", -1, 2),
              new Among("ants", -1, 3), new Among("\u00E9s", -1, 2),
              new Among("ait", -1, 3), new Among("erait", 23, 2),
              new Among("ant", -1, 3), new Among("aIent", -1, 3),
              new Among("eraIent", 26, 2), new Among("\u00E8rent", -1, 2),
              new Among("assent", -1, 3), new Among("eront", -1, 2),
              new Among("\u00E2t", -1, 3), new Among("ez", -1, 2),
              new Among("iez", 32, 2), new Among("eriez", 33, 2),
              new Among("assiez", 33, 3), new Among("erez", 32, 2),
              new Among("\u00E9", -1, 2)
            ],
            a_7 = [new Among("e", -1, 3),
              new Among("I\u00E8re", 0, 2), new Among("i\u00E8re", 0, 2),
              new Among("ion", -1, 1), new Among("Ier", -1, 2),
              new Among("ier", -1, 2), new Among("\u00EB", -1, 4)
            ],
            a_8 = [
              new Among("ell", -1, -1), new Among("eill", -1, -1),
              new Among("enn", -1, -1), new Among("onn", -1, -1),
              new Among("ett", -1, -1)
            ],
            g_v = [17, 65, 16, 1, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 128, 130, 103, 8, 5
            ],
            g_keep_with_s = [1, 65, 20, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 128
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 251)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function habr2(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              sbp.slice_from(c2);
              sbp.cursor = v_1;
              return true;
            }
            return false;
          }

          function r_prelude() {
            var v_1, v_2;
            while (true) {
              v_1 = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 251)) {
                sbp.bra = sbp.cursor;
                v_2 = sbp.cursor;
                if (habr1("u", "U", v_1))
                  continue;
                sbp.cursor = v_2;
                if (habr1("i", "I", v_1))
                  continue;
                sbp.cursor = v_2;
                if (habr2("y", "Y", v_1))
                  continue;
              }
              sbp.cursor = v_1;
              sbp.bra = v_1;
              if (!habr1("y", "Y", v_1)) {
                sbp.cursor = v_1;
                if (sbp.eq_s(1, "q")) {
                  sbp.bra = sbp.cursor;
                  if (habr2("u", "U", v_1))
                    continue;
                }
                sbp.cursor = v_1;
                if (v_1 >= sbp.limit)
                  return;
                sbp.cursor++;
              }
            }
          }

          function habr3() {
            while (!sbp.in_grouping(g_v, 97, 251)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 251)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            return false;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            if (sbp.in_grouping(g_v, 97, 251) && sbp.in_grouping(g_v, 97, 251) &&
              sbp.cursor < sbp.limit)
              sbp.cursor++;
            else {
              sbp.cursor = v_1;
              if (!sbp.find_among(a_0, 3)) {
                sbp.cursor = v_1;
                do {
                  if (sbp.cursor >= sbp.limit) {
                    sbp.cursor = I_pV;
                    break;
                  }
                  sbp.cursor++;
                } while (!sbp.in_grouping(g_v, 97, 251));
              }
            }
            I_pV = sbp.cursor;
            sbp.cursor = v_1;
            if (!habr3()) {
              I_p1 = sbp.cursor;
              if (!habr3())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var, v_1;
            while (true) {
              v_1 = sbp.cursor;
              sbp.bra = v_1;
              among_var = sbp.find_among(a_1, 4);
              if (!among_var)
                break;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("i");
                  break;
                case 2:
                  sbp.slice_from("u");
                  break;
                case 3:
                  sbp.slice_from("y");
                  break;
                case 4:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var, v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_4, 43);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  break;
                case 2:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  if (sbp.eq_s_b(2, "ic")) {
                    sbp.bra = sbp.cursor;
                    if (!r_R2())
                      sbp.slice_from("iqU");
                    else
                      sbp.slice_del();
                  }
                  break;
                case 3:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("log");
                  break;
                case 4:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("u");
                  break;
                case 5:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("ent");
                  break;
                case 6:
                  if (!r_RV())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_2, 6);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    switch (among_var) {
                      case 1:
                        if (r_R2()) {
                          sbp.slice_del();
                          sbp.ket = sbp.cursor;
                          if (sbp.eq_s_b(2, "at")) {
                            sbp.bra = sbp.cursor;
                            if (r_R2())
                              sbp.slice_del();
                          }
                        }
                        break;
                      case 2:
                        if (r_R2())
                          sbp.slice_del();
                        else if (r_R1())
                          sbp.slice_from("eux");
                        break;
                      case 3:
                        if (r_R2())
                          sbp.slice_del();
                        break;
                      case 4:
                        if (r_RV())
                          sbp.slice_from("i");
                        break;
                    }
                  }
                  break;
                case 7:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_3, 3);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    switch (among_var) {
                      case 1:
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("abl");
                        break;
                      case 2:
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("iqU");
                        break;
                      case 3:
                        if (r_R2())
                          sbp.slice_del();
                        break;
                    }
                  }
                  break;
                case 8:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  if (sbp.eq_s_b(2, "at")) {
                    sbp.bra = sbp.cursor;
                    if (r_R2()) {
                      sbp.slice_del();
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "ic")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("iqU");
                        break;
                      }
                    }
                  }
                  break;
                case 9:
                  sbp.slice_from("eau");
                  break;
                case 10:
                  if (!r_R1())
                    return false;
                  sbp.slice_from("al");
                  break;
                case 11:
                  if (r_R2())
                    sbp.slice_del();
                  else if (!r_R1())
                    return false;
                  else
                    sbp.slice_from("eux");
                  break;
                case 12:
                  if (!r_R1() || !sbp.out_grouping_b(g_v, 97, 251))
                    return false;
                  sbp.slice_del();
                  break;
                case 13:
                  if (r_RV())
                    sbp.slice_from("ant");
                  return false;
                case 14:
                  if (r_RV())
                    sbp.slice_from("ent");
                  return false;
                case 15:
                  v_1 = sbp.limit - sbp.cursor;
                  if (sbp.in_grouping_b(g_v, 97, 251) && r_RV()) {
                    sbp.cursor = sbp.limit - v_1;
                    sbp.slice_del();
                  }
                  return false;
              }
              return true;
            }
            return false;
          }

          function r_i_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor < I_pV)
              return false;
            v_1 = sbp.limit_backward;
            sbp.limit_backward = I_pV;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_5, 35);
            if (!among_var) {
              sbp.limit_backward = v_1;
              return false;
            }
            sbp.bra = sbp.cursor;
            if (among_var == 1) {
              if (!sbp.out_grouping_b(g_v, 97, 251)) {
                sbp.limit_backward = v_1;
                return false;
              }
              sbp.slice_del();
            }
            sbp.limit_backward = v_1;
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_2, v_3;
            if (sbp.cursor < I_pV)
              return false;
            v_2 = sbp.limit_backward;
            sbp.limit_backward = I_pV;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 38);
            if (!among_var) {
              sbp.limit_backward = v_2;
              return false;
            }
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2()) {
                  sbp.limit_backward = v_2;
                  return false;
                }
                sbp.slice_del();
                break;
              case 2:
                sbp.slice_del();
                break;
              case 3:
                sbp.slice_del();
                v_3 = sbp.limit - sbp.cursor;
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(1, "e")) {
                  sbp.bra = sbp.cursor;
                  sbp.slice_del();
                } else
                  sbp.cursor = sbp.limit - v_3;
                break;
            }
            sbp.limit_backward = v_2;
            return true;
          }

          function r_residual_suffix() {
            var among_var, v_1 = sbp.limit - sbp.cursor,
              v_2, v_4, v_5;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "s")) {
              sbp.bra = sbp.cursor;
              v_2 = sbp.limit - sbp.cursor;
              if (sbp.out_grouping_b(g_keep_with_s, 97, 232)) {
                sbp.cursor = sbp.limit - v_2;
                sbp.slice_del();
              } else
                sbp.cursor = sbp.limit - v_1;
            } else
              sbp.cursor = sbp.limit - v_1;
            if (sbp.cursor >= I_pV) {
              v_4 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 7);
              if (among_var) {
                sbp.bra = sbp.cursor;
                switch (among_var) {
                  case 1:
                    if (r_R2()) {
                      v_5 = sbp.limit - sbp.cursor;
                      if (!sbp.eq_s_b(1, "s")) {
                        sbp.cursor = sbp.limit - v_5;
                        if (!sbp.eq_s_b(1, "t"))
                          break;
                      }
                      sbp.slice_del();
                    }
                    break;
                  case 2:
                    sbp.slice_from("i");
                    break;
                  case 3:
                    sbp.slice_del();
                    break;
                  case 4:
                    if (sbp.eq_s_b(2, "gu"))
                      sbp.slice_del();
                    break;
                }
              }
              sbp.limit_backward = v_4;
            }
          }

          function r_un_double() {
            var v_1 = sbp.limit - sbp.cursor;
            if (sbp.find_among_b(a_8, 5)) {
              sbp.cursor = sbp.limit - v_1;
              sbp.ket = sbp.cursor;
              if (sbp.cursor > sbp.limit_backward) {
                sbp.cursor--;
                sbp.bra = sbp.cursor;
                sbp.slice_del();
              }
            }
          }

          function r_un_accent() {
            var v_1, v_2 = 1;
            while (sbp.out_grouping_b(g_v, 97, 251))
              v_2--;
            if (v_2 <= 0) {
              sbp.ket = sbp.cursor;
              v_1 = sbp.limit - sbp.cursor;
              if (!sbp.eq_s_b(1, "\u00E9")) {
                sbp.cursor = sbp.limit - v_1;
                if (!sbp.eq_s_b(1, "\u00E8"))
                  return;
              }
              sbp.bra = sbp.cursor;
              sbp.slice_from("e");
            }
          }

          function habr5() {
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_i_verb_suffix()) {
                sbp.cursor = sbp.limit;
                if (!r_verb_suffix()) {
                  sbp.cursor = sbp.limit;
                  r_residual_suffix();
                  return;
                }
              }
            }
            sbp.cursor = sbp.limit;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "Y")) {
              sbp.bra = sbp.cursor;
              sbp.slice_from("i");
            } else {
              sbp.cursor = sbp.limit;
              if (sbp.eq_s_b(1, "\u00E7")) {
                sbp.bra = sbp.cursor;
                sbp.slice_from("c");
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            habr5();
            sbp.cursor = sbp.limit;
            r_un_double();
            sbp.cursor = sbp.limit;
            r_un_accent();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.fr.stemmer, 'stemmer-fr');

    lunr.fr.stopWordFilter = lunr.generateStopWordFilter('ai aie aient aies ait as au aura aurai auraient aurais aurait auras aurez auriez aurions aurons auront aux avaient avais avait avec avez aviez avions avons ayant ayez ayons c ce ceci celà ces cet cette d dans de des du elle en es est et eu eue eues eurent eus eusse eussent eusses eussiez eussions eut eux eûmes eût eûtes furent fus fusse fussent fusses fussiez fussions fut fûmes fût fûtes ici il ils j je l la le les leur leurs lui m ma mais me mes moi mon même n ne nos notre nous on ont ou par pas pour qu que quel quelle quelles quels qui s sa sans se sera serai seraient serais serait seras serez seriez serions serons seront ses soi soient sois soit sommes son sont soyez soyons suis sur t ta te tes toi ton tu un une vos votre vous y à étaient étais était étant étiez étions été étée étées étés êtes'.split(' '));

    lunr.Pipeline.registerFunction(lunr.fr.stopWordFilter, 'stopWordFilter-fr');
  };
}))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Italian` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.it = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.it.trimmer,
        lunr.it.stopWordFilter,
        lunr.it.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.it.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.it.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.it.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.it.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.it.trimmer, 'trimmer-it');

    /* lunr stemmer function */
    lunr.it.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function ItalianStemmer() {
          var a_0 = [new Among("", -1, 7), new Among("qu", 0, 6),
              new Among("\u00E1", 0, 1), new Among("\u00E9", 0, 2),
              new Among("\u00ED", 0, 3), new Among("\u00F3", 0, 4),
              new Among("\u00FA", 0, 5)
            ],
            a_1 = [new Among("", -1, 3),
              new Among("I", 0, 1), new Among("U", 0, 2)
            ],
            a_2 = [
              new Among("la", -1, -1), new Among("cela", 0, -1),
              new Among("gliela", 0, -1), new Among("mela", 0, -1),
              new Among("tela", 0, -1), new Among("vela", 0, -1),
              new Among("le", -1, -1), new Among("cele", 6, -1),
              new Among("gliele", 6, -1), new Among("mele", 6, -1),
              new Among("tele", 6, -1), new Among("vele", 6, -1),
              new Among("ne", -1, -1), new Among("cene", 12, -1),
              new Among("gliene", 12, -1), new Among("mene", 12, -1),
              new Among("sene", 12, -1), new Among("tene", 12, -1),
              new Among("vene", 12, -1), new Among("ci", -1, -1),
              new Among("li", -1, -1), new Among("celi", 20, -1),
              new Among("glieli", 20, -1), new Among("meli", 20, -1),
              new Among("teli", 20, -1), new Among("veli", 20, -1),
              new Among("gli", 20, -1), new Among("mi", -1, -1),
              new Among("si", -1, -1), new Among("ti", -1, -1),
              new Among("vi", -1, -1), new Among("lo", -1, -1),
              new Among("celo", 31, -1), new Among("glielo", 31, -1),
              new Among("melo", 31, -1), new Among("telo", 31, -1),
              new Among("velo", 31, -1)
            ],
            a_3 = [new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("ar", -1, 2),
              new Among("er", -1, 2), new Among("ir", -1, 2)
            ],
            a_4 = [
              new Among("ic", -1, -1), new Among("abil", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_5 = [
              new Among("ic", -1, 1), new Among("abil", -1, 1),
              new Among("iv", -1, 1)
            ],
            a_6 = [new Among("ica", -1, 1),
              new Among("logia", -1, 3), new Among("osa", -1, 1),
              new Among("ista", -1, 1), new Among("iva", -1, 9),
              new Among("anza", -1, 1), new Among("enza", -1, 5),
              new Among("ice", -1, 1), new Among("atrice", 7, 1),
              new Among("iche", -1, 1), new Among("logie", -1, 3),
              new Among("abile", -1, 1), new Among("ibile", -1, 1),
              new Among("usione", -1, 4), new Among("azione", -1, 2),
              new Among("uzione", -1, 4), new Among("atore", -1, 2),
              new Among("ose", -1, 1), new Among("ante", -1, 1),
              new Among("mente", -1, 1), new Among("amente", 19, 7),
              new Among("iste", -1, 1), new Among("ive", -1, 9),
              new Among("anze", -1, 1), new Among("enze", -1, 5),
              new Among("ici", -1, 1), new Among("atrici", 25, 1),
              new Among("ichi", -1, 1), new Among("abili", -1, 1),
              new Among("ibili", -1, 1), new Among("ismi", -1, 1),
              new Among("usioni", -1, 4), new Among("azioni", -1, 2),
              new Among("uzioni", -1, 4), new Among("atori", -1, 2),
              new Among("osi", -1, 1), new Among("anti", -1, 1),
              new Among("amenti", -1, 6), new Among("imenti", -1, 6),
              new Among("isti", -1, 1), new Among("ivi", -1, 9),
              new Among("ico", -1, 1), new Among("ismo", -1, 1),
              new Among("oso", -1, 1), new Among("amento", -1, 6),
              new Among("imento", -1, 6), new Among("ivo", -1, 9),
              new Among("it\u00E0", -1, 8), new Among("ist\u00E0", -1, 1),
              new Among("ist\u00E8", -1, 1), new Among("ist\u00EC", -1, 1)
            ],
            a_7 = [
              new Among("isca", -1, 1), new Among("enda", -1, 1),
              new Among("ata", -1, 1), new Among("ita", -1, 1),
              new Among("uta", -1, 1), new Among("ava", -1, 1),
              new Among("eva", -1, 1), new Among("iva", -1, 1),
              new Among("erebbe", -1, 1), new Among("irebbe", -1, 1),
              new Among("isce", -1, 1), new Among("ende", -1, 1),
              new Among("are", -1, 1), new Among("ere", -1, 1),
              new Among("ire", -1, 1), new Among("asse", -1, 1),
              new Among("ate", -1, 1), new Among("avate", 16, 1),
              new Among("evate", 16, 1), new Among("ivate", 16, 1),
              new Among("ete", -1, 1), new Among("erete", 20, 1),
              new Among("irete", 20, 1), new Among("ite", -1, 1),
              new Among("ereste", -1, 1), new Among("ireste", -1, 1),
              new Among("ute", -1, 1), new Among("erai", -1, 1),
              new Among("irai", -1, 1), new Among("isci", -1, 1),
              new Among("endi", -1, 1), new Among("erei", -1, 1),
              new Among("irei", -1, 1), new Among("assi", -1, 1),
              new Among("ati", -1, 1), new Among("iti", -1, 1),
              new Among("eresti", -1, 1), new Among("iresti", -1, 1),
              new Among("uti", -1, 1), new Among("avi", -1, 1),
              new Among("evi", -1, 1), new Among("ivi", -1, 1),
              new Among("isco", -1, 1), new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("Yamo", -1, 1),
              new Among("iamo", -1, 1), new Among("avamo", -1, 1),
              new Among("evamo", -1, 1), new Among("ivamo", -1, 1),
              new Among("eremo", -1, 1), new Among("iremo", -1, 1),
              new Among("assimo", -1, 1), new Among("ammo", -1, 1),
              new Among("emmo", -1, 1), new Among("eremmo", 54, 1),
              new Among("iremmo", 54, 1), new Among("immo", -1, 1),
              new Among("ano", -1, 1), new Among("iscano", 58, 1),
              new Among("avano", 58, 1), new Among("evano", 58, 1),
              new Among("ivano", 58, 1), new Among("eranno", -1, 1),
              new Among("iranno", -1, 1), new Among("ono", -1, 1),
              new Among("iscono", 65, 1), new Among("arono", 65, 1),
              new Among("erono", 65, 1), new Among("irono", 65, 1),
              new Among("erebbero", -1, 1), new Among("irebbero", -1, 1),
              new Among("assero", -1, 1), new Among("essero", -1, 1),
              new Among("issero", -1, 1), new Among("ato", -1, 1),
              new Among("ito", -1, 1), new Among("uto", -1, 1),
              new Among("avo", -1, 1), new Among("evo", -1, 1),
              new Among("ivo", -1, 1), new Among("ar", -1, 1),
              new Among("ir", -1, 1), new Among("er\u00E0", -1, 1),
              new Among("ir\u00E0", -1, 1), new Among("er\u00F2", -1, 1),
              new Among("ir\u00F2", -1, 1)
            ],
            g_v = [17, 65, 16, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 128, 128, 8, 2, 1
            ],
            g_AEIO = [17, 65, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 128, 128, 8, 2
            ],
            g_CG = [17],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 249)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function r_prelude() {
            var among_var, v_1 = sbp.cursor,
              v_2, v_3, v_4;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 7);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("\u00E0");
                    continue;
                  case 2:
                    sbp.slice_from("\u00E8");
                    continue;
                  case 3:
                    sbp.slice_from("\u00EC");
                    continue;
                  case 4:
                    sbp.slice_from("\u00F2");
                    continue;
                  case 5:
                    sbp.slice_from("\u00F9");
                    continue;
                  case 6:
                    sbp.slice_from("qU");
                    continue;
                  case 7:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
            sbp.cursor = v_1;
            while (true) {
              v_2 = sbp.cursor;
              while (true) {
                v_3 = sbp.cursor;
                if (sbp.in_grouping(g_v, 97, 249)) {
                  sbp.bra = sbp.cursor;
                  v_4 = sbp.cursor;
                  if (habr1("u", "U", v_3))
                    break;
                  sbp.cursor = v_4;
                  if (habr1("i", "I", v_3))
                    break;
                }
                sbp.cursor = v_3;
                if (sbp.cursor >= sbp.limit) {
                  sbp.cursor = v_2;
                  return;
                }
                sbp.cursor++;
              }
            }
          }

          function habr2(v_1) {
            sbp.cursor = v_1;
            if (!sbp.in_grouping(g_v, 97, 249))
              return false;
            while (!sbp.out_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function habr3() {
            if (sbp.in_grouping(g_v, 97, 249)) {
              var v_1 = sbp.cursor;
              if (sbp.out_grouping(g_v, 97, 249)) {
                while (!sbp.in_grouping(g_v, 97, 249)) {
                  if (sbp.cursor >= sbp.limit)
                    return habr2(v_1);
                  sbp.cursor++;
                }
                return true;
              }
              return habr2(v_1);
            }
            return false;
          }

          function habr4() {
            var v_1 = sbp.cursor,
              v_2;
            if (!habr3()) {
              sbp.cursor = v_1;
              if (!sbp.out_grouping(g_v, 97, 249))
                return;
              v_2 = sbp.cursor;
              if (sbp.out_grouping(g_v, 97, 249)) {
                while (!sbp.in_grouping(g_v, 97, 249)) {
                  if (sbp.cursor >= sbp.limit) {
                    sbp.cursor = v_2;
                    if (sbp.in_grouping(g_v, 97, 249) &&
                      sbp.cursor < sbp.limit)
                      sbp.cursor++;
                    return;
                  }
                  sbp.cursor++;
                }
                I_pV = sbp.cursor;
                return;
              }
              sbp.cursor = v_2;
              if (!sbp.in_grouping(g_v, 97, 249) || sbp.cursor >= sbp.limit)
                return;
              sbp.cursor++;
            }
            I_pV = sbp.cursor;
          }

          function habr5() {
            while (!sbp.in_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr4();
            sbp.cursor = v_1;
            if (habr5()) {
              I_p1 = sbp.cursor;
              if (habr5())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_1, 3);
              if (!among_var)
                break;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("i");
                  break;
                case 2:
                  sbp.slice_from("u");
                  break;
                case 3:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_attached_pronoun() {
            var among_var;
            sbp.ket = sbp.cursor;
            if (sbp.find_among_b(a_2, 37)) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among_b(a_3, 5);
              if (among_var && r_RV()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    sbp.slice_from("e");
                    break;
                }
              }
            }
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 51);
            if (!among_var)
              return false;
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                break;
              case 2:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "ic")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2())
                    sbp.slice_del();
                }
                break;
              case 3:
                if (!r_R2())
                  return false;
                sbp.slice_from("log");
                break;
              case 4:
                if (!r_R2())
                  return false;
                sbp.slice_from("u");
                break;
              case 5:
                if (!r_R2())
                  return false;
                sbp.slice_from("ente");
                break;
              case 6:
                if (!r_RV())
                  return false;
                sbp.slice_del();
                break;
              case 7:
                if (!r_R1())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_4, 4);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    if (among_var == 1) {
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "at")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                  }
                }
                break;
              case 8:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_5, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 9:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "at")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(2, "ic")) {
                      sbp.bra = sbp.cursor;
                      if (r_R2())
                        sbp.slice_del();
                    }
                  }
                }
                break;
            }
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 87);
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1)
                  sbp.slice_del();
              }
              sbp.limit_backward = v_1;
            }
          }

          function habr6() {
            var v_1 = sbp.limit - sbp.cursor;
            sbp.ket = sbp.cursor;
            if (sbp.in_grouping_b(g_AEIO, 97, 242)) {
              sbp.bra = sbp.cursor;
              if (r_RV()) {
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(1, "i")) {
                  sbp.bra = sbp.cursor;
                  if (r_RV()) {
                    sbp.slice_del();
                    return;
                  }
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
          }

          function r_vowel_suffix() {
            habr6();
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "h")) {
              sbp.bra = sbp.cursor;
              if (sbp.in_grouping_b(g_CG, 99, 103))
                if (r_RV())
                  sbp.slice_del();
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_attached_pronoun();
            sbp.cursor = sbp.limit;
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              r_verb_suffix();
            }
            sbp.cursor = sbp.limit;
            r_vowel_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.it.stemmer, 'stemmer-it');

    lunr.it.stopWordFilter = lunr.generateStopWordFilter('a abbia abbiamo abbiano abbiate ad agl agli ai al all alla alle allo anche avemmo avendo avesse avessero avessi avessimo aveste avesti avete aveva avevamo avevano avevate avevi avevo avrai avranno avrebbe avrebbero avrei avremmo avremo avreste avresti avrete avrà avrò avuta avute avuti avuto c che chi ci coi col come con contro cui da dagl dagli dai dal dall dalla dalle dallo degl degli dei del dell della delle dello di dov dove e ebbe ebbero ebbi ed era erano eravamo eravate eri ero essendo faccia facciamo facciano facciate faccio facemmo facendo facesse facessero facessi facessimo faceste facesti faceva facevamo facevano facevate facevi facevo fai fanno farai faranno farebbe farebbero farei faremmo faremo fareste faresti farete farà farò fece fecero feci fosse fossero fossi fossimo foste fosti fu fui fummo furono gli ha hai hanno ho i il in io l la le lei li lo loro lui ma mi mia mie miei mio ne negl negli nei nel nell nella nelle nello noi non nostra nostre nostri nostro o per perché più quale quanta quante quanti quanto quella quelle quelli quello questa queste questi questo sarai saranno sarebbe sarebbero sarei saremmo saremo sareste saresti sarete sarà sarò se sei si sia siamo siano siate siete sono sta stai stando stanno starai staranno starebbe starebbero starei staremmo staremo stareste staresti starete starà starò stava stavamo stavano stavate stavi stavo stemmo stesse stessero stessi stessimo steste stesti stette stettero stetti stia stiamo stiano stiate sto su sua sue sugl sugli sui sul sull sulla sulle sullo suo suoi ti tra tu tua tue tuo tuoi tutti tutto un una uno vi voi vostra vostre vostri vostro è'.split(' '));

    lunr.Pipeline.registerFunction(lunr.it.stopWordFilter, 'stopWordFilter-it');
  };
}))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Japanese` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Chad Liu
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /*
    Japanese tokenization is trickier, since it does not
    take into account spaces.
    Since the tokenization function is represented different
    internally for each of the Lunr versions, this had to be done
    in order to try to try to pick the best way of doing this based
    on the Lunr version
     */
    var isLunr2 = lunr.version[0] == "2";

    /* register specific locale function */
    lunr.ja = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.ja.trimmer,
        lunr.ja.stopWordFilter,
        lunr.ja.stemmer
      );

      // change the tokenizer for japanese one
      if (isLunr2) { // for lunr version 2.0.0
        this.tokenizer = lunr.ja.tokenizer;
      } else {
        if (lunr.tokenizer) { // for lunr version 0.6.0
          lunr.tokenizer = lunr.ja.tokenizer;
        }
        if (this.tokenizerFn) { // for lunr version 0.7.0 -> 1.0.0
          this.tokenizerFn = lunr.ja.tokenizer;
        }
      }
    };
    var segmenter = new lunr.TinySegmenter(); // インスタンス生成

    lunr.ja.tokenizer = function(obj) {
      var i;
      var str;
      var len;
      var segs;
      var tokens;
      var char;
      var sliceLength;
      var sliceStart;
      var sliceEnd;
      var segStart;

      if (!arguments.length || obj == null || obj == undefined)
        return [];

      if (Array.isArray(obj)) {
        return obj.map(
          function(t) {
            return isLunr2 ? new lunr.Token(t.toLowerCase()) : t.toLowerCase();
          }
        );
      }

      str = obj.toString().toLowerCase().replace(/^\s+/, '');
      for (i = str.length - 1; i >= 0; i--) {
        if (/\S/.test(str.charAt(i))) {
          str = str.substring(0, i + 1);
          break;
        }
      }

      tokens = [];
      len = str.length;
      for (sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
        char = str.charAt(sliceEnd);
        sliceLength = sliceEnd - sliceStart;

        if ((char.match(/\s/) || sliceEnd == len)) {
          if (sliceLength > 0) {
            segs = segmenter.segment(str.slice(sliceStart, sliceEnd)).filter(
              function(token) {
                return !!token;
              }
            );

            segStart = sliceStart;
            for (i = 0; i < segs.length; i++) {
              if (isLunr2) {
                tokens.push(
                  new lunr.Token(
                    segs[i], {
                      position: [segStart, segs[i].length],
                      index: tokens.length
                    }
                  )
                );
              } else {
                tokens.push(segs[i]);
              }
              segStart += segs[i].length;
            }
          }

          sliceStart = sliceEnd + 1;
        }
      }

      return tokens;
    }

    /* lunr stemmer function */
    lunr.ja.stemmer = (function() {

      /* TODO japanese stemmer  */
      return function(word) {
        return word;
      }
    })();
    lunr.Pipeline.registerFunction(lunr.ja.stemmer, 'stemmer-ja');

    /* lunr trimmer function */
    lunr.ja.wordCharacters = "一二三四五六七八九十百千万億兆一-龠々〆ヵヶぁ-んァ-ヴーｱ-ﾝﾞa-zA-Zａ-ｚＡ-Ｚ0-9０-９";
    lunr.ja.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.ja.wordCharacters);
    lunr.Pipeline.registerFunction(lunr.ja.trimmer, 'trimmer-ja');

    /* lunr stop word filter. see http://www.ranks.nl/stopwords/japanese */
    lunr.ja.stopWordFilter = lunr.generateStopWordFilter(
      'これ それ あれ この その あの ここ そこ あそこ こちら どこ だれ なに なん 何 私 貴方 貴方方 我々 私達 あの人 あのかた 彼女 彼 です あります おります います は が の に を で え から まで より も どの と し それで しかし'.split(' '));
    lunr.Pipeline.registerFunction(lunr.ja.stopWordFilter, 'stopWordFilter-ja');

    // alias ja => jp for backward-compatibility.
    // jp is the country code, while ja is the language code
    // a new lunr.ja.js has been created, but in order to
    // keep the backward compatibility, we'll leave the lunr.jp.js
    // here for a while, and just make it use the new lunr.ja.js
    lunr.jp = lunr.ja;
    lunr.Pipeline.registerFunction(lunr.jp.stemmer, 'stemmer-jp');
    lunr.Pipeline.registerFunction(lunr.jp.trimmer, 'trimmer-jp');
    lunr.Pipeline.registerFunction(lunr.jp.stopWordFilter, 'stopWordFilter-jp');
  };
}))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Portuguese` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.pt = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.pt.trimmer,
        lunr.pt.stopWordFilter,
        lunr.pt.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.pt.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.pt.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.pt.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.pt.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.pt.trimmer, 'trimmer-pt');

    /* lunr stemmer function */
    lunr.pt.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function PortugueseStemmer() {
          var a_0 = [new Among("", -1, 3), new Among("\u00E3", 0, 1),
              new Among("\u00F5", 0, 2)
            ],
            a_1 = [new Among("", -1, 3),
              new Among("a~", 0, 1), new Among("o~", 0, 2)
            ],
            a_2 = [
              new Among("ic", -1, -1), new Among("ad", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_3 = [
              new Among("ante", -1, 1), new Among("avel", -1, 1),
              new Among("\u00EDvel", -1, 1)
            ],
            a_4 = [new Among("ic", -1, 1),
              new Among("abil", -1, 1), new Among("iv", -1, 1)
            ],
            a_5 = [
              new Among("ica", -1, 1), new Among("\u00E2ncia", -1, 1),
              new Among("\u00EAncia", -1, 4), new Among("ira", -1, 9),
              new Among("adora", -1, 1), new Among("osa", -1, 1),
              new Among("ista", -1, 1), new Among("iva", -1, 8),
              new Among("eza", -1, 1), new Among("log\u00EDa", -1, 2),
              new Among("idade", -1, 7), new Among("ante", -1, 1),
              new Among("mente", -1, 6), new Among("amente", 12, 5),
              new Among("\u00E1vel", -1, 1), new Among("\u00EDvel", -1, 1),
              new Among("uci\u00F3n", -1, 3), new Among("ico", -1, 1),
              new Among("ismo", -1, 1), new Among("oso", -1, 1),
              new Among("amento", -1, 1), new Among("imento", -1, 1),
              new Among("ivo", -1, 8), new Among("a\u00E7a~o", -1, 1),
              new Among("ador", -1, 1), new Among("icas", -1, 1),
              new Among("\u00EAncias", -1, 4), new Among("iras", -1, 9),
              new Among("adoras", -1, 1), new Among("osas", -1, 1),
              new Among("istas", -1, 1), new Among("ivas", -1, 8),
              new Among("ezas", -1, 1), new Among("log\u00EDas", -1, 2),
              new Among("idades", -1, 7), new Among("uciones", -1, 3),
              new Among("adores", -1, 1), new Among("antes", -1, 1),
              new Among("a\u00E7o~es", -1, 1), new Among("icos", -1, 1),
              new Among("ismos", -1, 1), new Among("osos", -1, 1),
              new Among("amentos", -1, 1), new Among("imentos", -1, 1),
              new Among("ivos", -1, 8)
            ],
            a_6 = [new Among("ada", -1, 1),
              new Among("ida", -1, 1), new Among("ia", -1, 1),
              new Among("aria", 2, 1), new Among("eria", 2, 1),
              new Among("iria", 2, 1), new Among("ara", -1, 1),
              new Among("era", -1, 1), new Among("ira", -1, 1),
              new Among("ava", -1, 1), new Among("asse", -1, 1),
              new Among("esse", -1, 1), new Among("isse", -1, 1),
              new Among("aste", -1, 1), new Among("este", -1, 1),
              new Among("iste", -1, 1), new Among("ei", -1, 1),
              new Among("arei", 16, 1), new Among("erei", 16, 1),
              new Among("irei", 16, 1), new Among("am", -1, 1),
              new Among("iam", 20, 1), new Among("ariam", 21, 1),
              new Among("eriam", 21, 1), new Among("iriam", 21, 1),
              new Among("aram", 20, 1), new Among("eram", 20, 1),
              new Among("iram", 20, 1), new Among("avam", 20, 1),
              new Among("em", -1, 1), new Among("arem", 29, 1),
              new Among("erem", 29, 1), new Among("irem", 29, 1),
              new Among("assem", 29, 1), new Among("essem", 29, 1),
              new Among("issem", 29, 1), new Among("ado", -1, 1),
              new Among("ido", -1, 1), new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("indo", -1, 1),
              new Among("ara~o", -1, 1), new Among("era~o", -1, 1),
              new Among("ira~o", -1, 1), new Among("ar", -1, 1),
              new Among("er", -1, 1), new Among("ir", -1, 1),
              new Among("as", -1, 1), new Among("adas", 47, 1),
              new Among("idas", 47, 1), new Among("ias", 47, 1),
              new Among("arias", 50, 1), new Among("erias", 50, 1),
              new Among("irias", 50, 1), new Among("aras", 47, 1),
              new Among("eras", 47, 1), new Among("iras", 47, 1),
              new Among("avas", 47, 1), new Among("es", -1, 1),
              new Among("ardes", 58, 1), new Among("erdes", 58, 1),
              new Among("irdes", 58, 1), new Among("ares", 58, 1),
              new Among("eres", 58, 1), new Among("ires", 58, 1),
              new Among("asses", 58, 1), new Among("esses", 58, 1),
              new Among("isses", 58, 1), new Among("astes", 58, 1),
              new Among("estes", 58, 1), new Among("istes", 58, 1),
              new Among("is", -1, 1), new Among("ais", 71, 1),
              new Among("eis", 71, 1), new Among("areis", 73, 1),
              new Among("ereis", 73, 1), new Among("ireis", 73, 1),
              new Among("\u00E1reis", 73, 1), new Among("\u00E9reis", 73, 1),
              new Among("\u00EDreis", 73, 1), new Among("\u00E1sseis", 73, 1),
              new Among("\u00E9sseis", 73, 1), new Among("\u00EDsseis", 73, 1),
              new Among("\u00E1veis", 73, 1), new Among("\u00EDeis", 73, 1),
              new Among("ar\u00EDeis", 84, 1), new Among("er\u00EDeis", 84, 1),
              new Among("ir\u00EDeis", 84, 1), new Among("ados", -1, 1),
              new Among("idos", -1, 1), new Among("amos", -1, 1),
              new Among("\u00E1ramos", 90, 1), new Among("\u00E9ramos", 90, 1),
              new Among("\u00EDramos", 90, 1), new Among("\u00E1vamos", 90, 1),
              new Among("\u00EDamos", 90, 1), new Among("ar\u00EDamos", 95, 1),
              new Among("er\u00EDamos", 95, 1), new Among("ir\u00EDamos", 95, 1),
              new Among("emos", -1, 1), new Among("aremos", 99, 1),
              new Among("eremos", 99, 1), new Among("iremos", 99, 1),
              new Among("\u00E1ssemos", 99, 1), new Among("\u00EAssemos", 99, 1),
              new Among("\u00EDssemos", 99, 1), new Among("imos", -1, 1),
              new Among("armos", -1, 1), new Among("ermos", -1, 1),
              new Among("irmos", -1, 1), new Among("\u00E1mos", -1, 1),
              new Among("ar\u00E1s", -1, 1), new Among("er\u00E1s", -1, 1),
              new Among("ir\u00E1s", -1, 1), new Among("eu", -1, 1),
              new Among("iu", -1, 1), new Among("ou", -1, 1),
              new Among("ar\u00E1", -1, 1), new Among("er\u00E1", -1, 1),
              new Among("ir\u00E1", -1, 1)
            ],
            a_7 = [new Among("a", -1, 1),
              new Among("i", -1, 1), new Among("o", -1, 1),
              new Among("os", -1, 1), new Among("\u00E1", -1, 1),
              new Among("\u00ED", -1, 1), new Among("\u00F3", -1, 1)
            ],
            a_8 = [
              new Among("e", -1, 1), new Among("\u00E7", -1, 2),
              new Among("\u00E9", -1, 1), new Among("\u00EA", -1, 1)
            ],
            g_v = [17,
              65, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 19, 12, 2
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function r_prelude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 3);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("a~");
                    continue;
                  case 2:
                    sbp.slice_from("o~");
                    continue;
                  case 3:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function habr2() {
            if (sbp.out_grouping(g_v, 97, 250)) {
              while (!sbp.in_grouping(g_v, 97, 250)) {
                if (sbp.cursor >= sbp.limit)
                  return true;
                sbp.cursor++;
              }
              return false;
            }
            return true;
          }

          function habr3() {
            if (sbp.in_grouping(g_v, 97, 250)) {
              while (!sbp.out_grouping(g_v, 97, 250)) {
                if (sbp.cursor >= sbp.limit)
                  return false;
                sbp.cursor++;
              }
            }
            I_pV = sbp.cursor;
            return true;
          }

          function habr4() {
            var v_1 = sbp.cursor,
              v_2, v_3;
            if (sbp.in_grouping(g_v, 97, 250)) {
              v_2 = sbp.cursor;
              if (habr2()) {
                sbp.cursor = v_2;
                if (habr3())
                  return;
              } else
                I_pV = sbp.cursor;
            }
            sbp.cursor = v_1;
            if (sbp.out_grouping(g_v, 97, 250)) {
              v_3 = sbp.cursor;
              if (habr2()) {
                sbp.cursor = v_3;
                if (!sbp.in_grouping(g_v, 97, 250) || sbp.cursor >= sbp.limit)
                  return;
                sbp.cursor++;
              }
              I_pV = sbp.cursor;
            }
          }

          function habr5() {
            while (!sbp.in_grouping(g_v, 97, 250)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 250)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr4();
            sbp.cursor = v_1;
            if (habr5()) {
              I_p1 = sbp.cursor;
              if (habr5())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_1, 3);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("\u00E3");
                    continue;
                  case 2:
                    sbp.slice_from("\u00F5");
                    continue;
                  case 3:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_5, 45);
            if (!among_var)
              return false;
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                break;
              case 2:
                if (!r_R2())
                  return false;
                sbp.slice_from("log");
                break;
              case 3:
                if (!r_R2())
                  return false;
                sbp.slice_from("u");
                break;
              case 4:
                if (!r_R2())
                  return false;
                sbp.slice_from("ente");
                break;
              case 5:
                if (!r_R1())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_2, 4);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    if (among_var == 1) {
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "at")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                  }
                }
                break;
              case 6:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_3, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 7:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_4, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 8:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "at")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2())
                    sbp.slice_del();
                }
                break;
              case 9:
                if (!r_RV() || !sbp.eq_s_b(1, "e"))
                  return false;
                sbp.slice_from("ir");
                break;
            }
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_6, 120);
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1)
                  sbp.slice_del();
                sbp.limit_backward = v_1;
                return true;
              }
              sbp.limit_backward = v_1;
            }
            return false;
          }

          function r_residual_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_7, 7);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (among_var == 1)
                if (r_RV())
                  sbp.slice_del();
            }
          }

          function habr6(c1, c2) {
            if (sbp.eq_s_b(1, c1)) {
              sbp.bra = sbp.cursor;
              var v_1 = sbp.limit - sbp.cursor;
              if (sbp.eq_s_b(1, c2)) {
                sbp.cursor = sbp.limit - v_1;
                if (r_RV())
                  sbp.slice_del();
                return false;
              }
            }
            return true;
          }

          function r_residual_form() {
            var among_var, v_1, v_2, v_3;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_8, 4);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (r_RV()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    v_1 = sbp.limit - sbp.cursor;
                    if (habr6("u", "g"))
                      habr6("i", "c")
                  }
                  break;
                case 2:
                  sbp.slice_from("c");
                  break;
              }
            }
          }

          function habr1() {
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_verb_suffix()) {
                sbp.cursor = sbp.limit;
                r_residual_suffix();
                return;
              }
            }
            sbp.cursor = sbp.limit;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "i")) {
              sbp.bra = sbp.cursor;
              if (sbp.eq_s_b(1, "c")) {
                sbp.cursor = sbp.limit;
                if (r_RV())
                  sbp.slice_del();
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            habr1();
            sbp.cursor = sbp.limit;
            r_residual_form();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.pt.stemmer, 'stemmer-pt');

    lunr.pt.stopWordFilter = lunr.generateStopWordFilter('a ao aos aquela aquelas aquele aqueles aquilo as até com como da das de dela delas dele deles depois do dos e ela elas ele eles em entre era eram essa essas esse esses esta estamos estas estava estavam este esteja estejam estejamos estes esteve estive estivemos estiver estivera estiveram estiverem estivermos estivesse estivessem estivéramos estivéssemos estou está estávamos estão eu foi fomos for fora foram forem formos fosse fossem fui fôramos fôssemos haja hajam hajamos havemos hei houve houvemos houver houvera houveram houverei houverem houveremos houveria houveriam houvermos houverá houverão houveríamos houvesse houvessem houvéramos houvéssemos há hão isso isto já lhe lhes mais mas me mesmo meu meus minha minhas muito na nas nem no nos nossa nossas nosso nossos num numa não nós o os ou para pela pelas pelo pelos por qual quando que quem se seja sejam sejamos sem serei seremos seria seriam será serão seríamos seu seus somos sou sua suas são só também te tem temos tenha tenham tenhamos tenho terei teremos teria teriam terá terão teríamos teu teus teve tinha tinham tive tivemos tiver tivera tiveram tiverem tivermos tivesse tivessem tivéramos tivéssemos tu tua tuas tém tínhamos um uma você vocês vos à às éramos'.split(' '));

    lunr.Pipeline.registerFunction(lunr.pt.stopWordFilter, 'stopWordFilter-pt');
  };
}))

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"form__field"},[_c('div',{staticClass:"cell"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"ids_topicSearch",attrs:{"id":"ctl00_ids_contentPlaceHolder_ids_topicSearch","name":"ctl00$ids_contentPlaceHolder$ids_topicSearch","placeholder":"Search Contents","type":"text"},domProps:{"value":(_vm.search)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.queryResults($event)},"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),(_vm.search)?_c('div',{staticClass:"search_button"},[_c('button',{staticClass:"close-icon",on:{"click":_vm.clearResult}},[_vm._v("\n    ×\n   ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"search_button"},[_c('button',{on:{"click":_vm.queryResults}},[_c('i',{staticClass:"fa fa-search"})])])]),_vm._v(" "),_c('div',{staticClass:"col-1 l-pad-top",attrs:{"id":"results"}},[_c('div',[_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-bottom":"10px"}},[(_vm.resultsCount != 0)?_c('strong',[_vm._v("\n     ("+_vm._s(_vm.resultsCount)+") Results Found\n    ")]):(_vm.resultsActual)?_c('strong',[_vm._v("\n     No Results Found\n    ")]):_vm._e()])]),_vm._v(" "),_vm._l((_vm.resultsActual),function(result){return _c('div',[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":result.link,"keywords":result.keywords,"onclick":"reload(this.href, this.getAttribute('keywords'))"}},[_vm._v("\n     "+_vm._s(result.title)+"\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-3-style"},[_vm._v("\n    "+_vm._s(result.desc)+"\n   ")])])})],2),_vm._v(" "),(!_vm.resultsActual)?_c('div',{staticClass:"side-toc"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_vm._m(13),_vm._v(" "),_vm._m(14),_vm._v(" "),_vm._m(15),_vm._v(" "),_vm._m(16),_vm._v(" "),_vm._m(17),_vm._v(" "),_vm._m(18),_vm._v(" "),_vm._m(19),_vm._v(" "),_vm._m(20),_vm._v(" "),_vm._m(21),_vm._v(" "),_vm._m(22),_vm._v(" "),_vm._m(23),_vm._v(" "),_vm._m(24),_vm._v(" "),_vm._m(25),_vm._v(" "),_vm._m(26),_vm._v(" "),_vm._m(27),_vm._v(" "),_vm._m(28),_vm._v(" "),_vm._m(29),_vm._v(" "),_vm._m(30)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"cover.html","title":"CX833, CX961, CX962, CX963, XC8355, XC9635, XC9645, XC9655 MFPs"}},[_vm._v("\n    CX833, CX961, CX962, CX963, XC8355, XC9635, XC9645, XC9655 MFPs\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"safety.html#safety_ba","title":"Informasi keselamatan"}},[_vm._v("\n    Informasi keselamatan\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e18"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":".html#d0e23","title":"Konvensi"}},[_vm._v("\n     Konvensi\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"safety-cable-topic.html#d0e43","title":"Pernyataan produk"}},[_vm._v("\n     Pernyataan produk\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"learning-about-printer-chapter.html#learning-about-printer-chapter_ba","title":"Pelajari tentang printer"}},[_vm._v("\n    Pelajari tentang printer\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e221"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"finding-information-about-printer-topic.html#finding-information-about-printer_ba","title":"Mencari informasi tentang printer"}},[_vm._v("\n     Mencari informasi tentang printer\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"finding-printer-serial-number-topic.html#finding-printer-serial-number_ba","title":"Mencari nomor seri printer"}},[_vm._v("\n     Mencari nomor seri printer\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printer-configurations-topic.html#printer-configurations_ba","title":"Konfigurasi printer"}},[_vm._v("\n     Konfigurasi printer\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-control-panel-topic.html#using-control-panel_ba","title":"Menggunakan panel kontrol"}},[_vm._v("\n     Menggunakan panel kontrol\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-home-screen-topic.html#using-home-screen_ba","title":"Ikon layar awal"}},[_vm._v("\n     Ikon layar awal\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"colors-of-indicator-light-topic.html#colors-of-indicator-light_ba","title":"Warna lampu indikator"}},[_vm._v("\n     Warna lampu indikator\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-ADF-and-scanner-glass-copy-topic.html#using-ADF-and-scanner-glass-copy_ba","title":"Menggunakan pengumpan dokumen otomatis dan kaca pemindai"}},[_vm._v("\n     Menggunakan pengumpan dokumen otomatis dan kaca pemindai\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"locating-security-slot-topic.html#locating-security-slot_ba","title":"Mencari slot keamanan"}},[_vm._v("\n     Mencari slot keamanan\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"paper-guidelines-topic.html#d0e769","title":"Memilih kertas"}},[_vm._v("\n     Memilih kertas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"supported-applications-topic.html#d0e10635","title":"Dukungan dan fitur tambahan printer"}},[_vm._v("\n     Dukungan dan fitur tambahan printer\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_ba","title":"Menyiapkan, menginstal, dan mengatur"}},[_vm._v("\n    Menyiapkan, menginstal, dan mengatur\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e10762"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"selecting-location-printer-topic.html#selecting-location-printer_ba","title":"Memilih lokasi printer"}},[_vm._v("\n     Memilih lokasi printer\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printer-ports-topic.html#printer-ports_ba","title":"Port printer"}},[_vm._v("\n     Port printer\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-scan-center-topic.html#d0e10961","title":"Mengatur aplikasi dan solusi"}},[_vm._v("\n     Mengatur aplikasi dan solusi\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"activating-voice-guidance-topic.html#d0e11138","title":"Menyiapkan dan menggunakan fitur aksesibilitas"}},[_vm._v("\n     Menyiapkan dan menggunakan fitur aksesibilitas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-printer-to-fax-group.html#d0e11443","title":"Menyiapkan printer untuk mengirim/menerima faks"}},[_vm._v("\n     Menyiapkan printer untuk mengirim/menerima faks\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"loading-trays-group.html#loading-trays-group_ba","title":"Memasukkan kertas dan media khusus"}},[_vm._v("\n     Memasukkan kertas dan media khusus\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"installing-printer-software-topic.html#d0e12239","title":"Menginstal dan memperbarui perangkat lunak, driver, dan firmware"}},[_vm._v("\n     Menginstal dan memperbarui perangkat lunak, driver, dan firmware\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"installing-optional-550-sheet-tray-topic.html#d0e12565","title":"Menginstal opsi perangkat keras"}},[_vm._v("\n     Menginstal opsi perangkat keras\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"connecting-printer-to-wireless-network-topic.html#d0e14096","title":"Jaringan"}},[_vm._v("\n     Jaringan\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"securing-the-printer.html#securing-the-printer_ba","title":"Mengamankan printer"}},[_vm._v("\n    Mengamankan printer\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e14448"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"erasing-printer-memory-topic.html#erasing-printer-memory_ba","title":"Menghapus memori printer"}},[_vm._v("\n     Menghapus memori printer\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"erasing-printer-storage-drive-topic.html#erasing-printer-storage-drive_ba","title":"Menghapus drive penyimpanan printer"}},[_vm._v("\n     Menghapus drive penyimpanan printer\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"restoring-factory-default-settings-topic.html#restoring-factory-default-settings_ba","title":"Memulihkan ke setelan default pabrik"}},[_vm._v("\n     Memulihkan ke setelan default pabrik\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"statement-of-volatility-topic.html#statement-of-volatility_ba","title":"Pernyataan Volatilitas"}},[_vm._v("\n     Pernyataan Volatilitas\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"printing-chapter.html#printing-chapter_ba","title":"Cetak"}},[_vm._v("\n    Cetak\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e14640"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-from-computer-topic.html#printing-from-computer_ba","title":"Mencetak dari komputer"}},[_vm._v("\n     Mencetak dari komputer\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-from-mobile-device-using-lexmark-print-app-topic.html#d0e14691","title":"Mencetak dari perangkat seluler"}},[_vm._v("\n     Mencetak dari perangkat seluler\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-from-flash-drive-topic.html#printing-from-flash-drive_ba","title":"Mencetak dari flash drive"}},[_vm._v("\n     Mencetak dari flash drive\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-confidential-jobs-topic.html#configuring-confidential-jobs_ba","title":"Mengonfigurasi pekerjaan rahasia"}},[_vm._v("\n     Mengonfigurasi pekerjaan rahasia\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_ba","title":"Mencetak dokumen rahasia dan pekerjaan tertunda"}},[_vm._v("\n     Mencetak dokumen rahasia dan pekerjaan tertunda\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-font-sample-list-topic.html#printing-font-sample-list_ba","title":"Mencetak daftar sampel font"}},[_vm._v("\n     Mencetak daftar sampel font\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-directory-list-topic.html#printing-directory-list_ba","title":"Mencetak daftar direktori"}},[_vm._v("\n     Mencetak daftar direktori\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"placing-separator-sheets-in-print-jobs-topic.html#placing-separator-sheets-in-print-jobs_ba","title":"Menempatkan lembaran pemisah di pekerjaan cetak"}},[_vm._v("\n     Menempatkan lembaran pemisah di pekerjaan cetak\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"canceling-print-job-topic.html#canceling-print-job_ba","title":"Membatalkan pekerjaan cetak"}},[_vm._v("\n     Membatalkan pekerjaan cetak\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"adjusting-toner-darkness-topic.html#adjusting-toner-darkness_ba","title":"Menyesuaikan kegelapan toner"}},[_vm._v("\n     Menyesuaikan kegelapan toner\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"copying.html#copying_ba","title":"Salin"}},[_vm._v("\n    Salin\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e15186"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"making-copies-topic.html#making-copies_ba","title":"Membuat salinan"}},[_vm._v("\n     Membuat salinan\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-photos-topic.html#copying-photos_ba","title":"Menyalin foto"}},[_vm._v("\n     Menyalin foto\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-on-letterhead-topic.html#copying-on-letterhead_ba","title":"Menyalin di letterhead"}},[_vm._v("\n     Menyalin di letterhead\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-on-both-sides-of-paper-topic.html#copying-on-both-sides-of-paper_ba","title":"Menyalin pada dua sisi kertas"}},[_vm._v("\n     Menyalin pada dua sisi kertas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"reducing-or-enlarging-copies-topic.html#reducing-or-enlarging-copies_ba","title":"Mengecilkan atau membesarkan salinan"}},[_vm._v("\n     Mengecilkan atau membesarkan salinan\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"collating-copies-topic.html#collating-copies_ba","title":"Menyusun salinan"}},[_vm._v("\n     Menyusun salinan\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"placing-separator-sheets-between-copies-topic.html#placing-separator-sheets-between-copies_ba","title":"Menempatkan lembaran pemisah di antara salinan"}},[_vm._v("\n     Menempatkan lembaran pemisah di antara salinan\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-multiple-pages-onto-single-sheet-topic.html#copying-multiple-pages-onto-single-sheet_ba","title":"Menyalin beberapa halaman di satu lembar kertas"}},[_vm._v("\n     Menyalin beberapa halaman di satu lembar kertas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-cards-topic.html#copying-cards_ba","title":"Menyalin kartu"}},[_vm._v("\n     Menyalin kartu\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-copy-shortcut-topic.html#creating-copy-shortcut_ba","title":"Membuat pintasan salin"}},[_vm._v("\n     Membuat pintasan salin\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"E-mailing.html#E-mailing_ba","title":"Email"}},[_vm._v("\n    Email\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e15459"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-smtp-settings-topic.html#configuring-smtp-settings_ba","title":"Mengatur setelan SMTP"}},[_vm._v("\n     Mengatur setelan SMTP\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"sending-email-topic.html#sending-email_ba","title":"Mengirim email"}},[_vm._v("\n     Mengirim email\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-email-shortcut-topic.html#creating-email-shortcut-using-control-panel_ba","title":"Membuat pintasan email"}},[_vm._v("\n     Membuat pintasan email\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"Faxing.html#Faxing_ba","title":"Faks"}},[_vm._v("\n    Faks\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e16908"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"sending-fax-topic.html#sending-fax_ba","title":"Mengirim faks"}},[_vm._v("\n     Mengirim faks\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scheduling-fax-topic.html#scheduling-fax_ba","title":"Menjadwalkan faks"}},[_vm._v("\n     Menjadwalkan faks\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-fax-destination-shortcut-topic.html#creating-fax-destination-shortcut_ba","title":"Membuat pintasan destinasi faks"}},[_vm._v("\n     Membuat pintasan destinasi faks\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"changing-fax-resolution-topic.html#changing-fax-resolution_ba","title":"Mengganti resolusi faks"}},[_vm._v("\n     Mengganti resolusi faks\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"adjusting-fax-darkness-topic.html#adjusting-fax-darkness_ba","title":"Menyesuaikan kegelapan faks"}},[_vm._v("\n     Menyesuaikan kegelapan faks\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-fax-log-topic.html#printing-fax-log_ba","title":"Mencetak log faks"}},[_vm._v("\n     Mencetak log faks\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"blocking-junk-faxes-topic.html#blocking-junk-faxes_ba","title":"Memblokir faks sampah"}},[_vm._v("\n     Memblokir faks sampah\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"holding-faxes-topic.html#holding-faxes_ba","title":"Holding faxes (Menunda faks)"}},[_vm._v("\n     Holding faxes (Menunda faks)\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"forwarding-fax-topic.html#forwarding-fax_ba","title":"Meneruskan faks"}},[_vm._v("\n     Meneruskan faks\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"FTP.html#FTP_ba","title":"Pindai"}},[_vm._v("\n    Pindai\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e17204"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-to-computer-topic.html#scanning-to-computer_ba","title":"Memindai ke komputer"}},[_vm._v("\n     Memindai ke komputer\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-ftp-server-using-control-panel-topic.html#scanning-ftp-server-using-control-panel_ba","title":"Memindai ke server FTP"}},[_vm._v("\n     Memindai ke server FTP\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-FTP-shortcut-topic.html#creating-FTP-shortcut_ba","title":"Membuat pintasan FTP"}},[_vm._v("\n     Membuat pintasan FTP\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-to-network-folder-topic.html#scanning-to-network-folder_ba","title":"Memindai ke folder jaringan"}},[_vm._v("\n     Memindai ke folder jaringan\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-network-folder-destination-topic.html#configuring-network-folder-destination_ba","title":"Mengatur destinasi folder jaringan"}},[_vm._v("\n     Mengatur destinasi folder jaringan\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-network-folder-shortcut-topic.html#creating-network-folder-shortcut_ba","title":"Membuat pintasan folder jaringan"}},[_vm._v("\n     Membuat pintasan folder jaringan\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-to-flash-drive-topic.html#scanning-to-flash-drive_ba","title":"Memindai ke flash drive"}},[_vm._v("\n     Memindai ke flash drive\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"printer-menus-chapter.html#printer-menus-chapter_ba","title":"menu printer"}},[_vm._v("\n    menu printer\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e17493"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"menu-map-topic.html#menu-map_ba","title":"Peta menu"}},[_vm._v("\n     Peta menu\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"preferences-topic.html#d0e17807","title":"Perangkat"}},[_vm._v("\n     Perangkat\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"layout-topic.html#d0e20041","title":"Cetak"}},[_vm._v("\n     Cetak\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"tray-configuration-topic.html#d0e21323","title":"Kertas"}},[_vm._v("\n     Kertas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copy-defaults-topic.html#d0e21655","title":"Salin"}},[_vm._v("\n     Salin\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"fax-defaults-subgroup.html#d0e22214","title":"Faks"}},[_vm._v("\n     Faks\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"email-setup-topic.html#d0e24081","title":"Email"}},[_vm._v("\n     Email\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"ftp-defaults-topic.html#d0e25178","title":"FTP"}},[_vm._v("\n     FTP\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"flash-drive-scan-topic.html#d0e25884","title":"USB Drive"}},[_vm._v("\n     USB Drive\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"network-overview-topic.html#d0e26730","title":"Port/Jaringan"}},[_vm._v("\n     Port/Jaringan\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"login-methods-subgroup.html#d0e28881","title":"Keamanan"}},[_vm._v("\n     Keamanan\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"cloud-services-enrollment-topic.html#d0e29978","title":"Layanan Cloud"}},[_vm._v("\n     Layanan Cloud\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"menu-settings-page-topic.html#d0e30035","title":"Laporan"}},[_vm._v("\n     Laporan\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"troubleshooting-menu-topic.html#troubleshooting-menu_ba","title":"Troubleshooting (Pemecahan Masalah)"}},[_c('strong',[_vm._v("\n      Troubleshooting (Pemecahan Masalah)\n     ")])])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"forms-merge-topic.html#forms-merge_ba","title":"Forms Merge (Gabung Formulir)"}},[_c('strong',[_vm._v("\n      Forms Merge (Gabung Formulir)\n     ")])])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-menu-settings-page-topic.html#printing-menu-settings-page_ba","title":"Mencetak Menu Settings Page (Halaman Setelan Menu)"}},[_vm._v("\n     Mencetak\n     "),_c('strong',[_vm._v("\n      Menu Settings Page (Halaman Setelan Menu)\n     ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"using-printer-finisher-options-chapter.html#using-printer-finisher-options-chapter_ba","title":"Opsi lis printer"}},[_vm._v("\n    Opsi lis printer\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e30518"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-staple-finisher-topic.html#using-staple-finisher_ba","title":"Menggunakan lis stapler"}},[_vm._v("\n     Menggunakan lis stapler\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-staple-hole-punch-finisher-topic.html#using-staple-hole-punch-finisher_ba","title":"Menggunakan lis lubang stapler"}},[_vm._v("\n     Menggunakan lis lubang stapler\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-offset-stacker-topic.html#using-offset-stacker_ba","title":"Menggunakan penumpuk ofset"}},[_vm._v("\n     Menggunakan penumpuk ofset\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-booklet-finisher-topic.html#using-booklet-finisher_ba","title":"Menggunakan lis buklet"}},[_vm._v("\n     Menggunakan lis buklet\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-hptfu-topic.html#using-hptfu_ba","title":"Menggunakan penyalur kertas dengan opsi lipatan"}},[_vm._v("\n     Menggunakan penyalur kertas dengan opsi lipatan\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"maintain-printer-chapter.html#maintain-printer-chapter_ba","title":"Merawat printer"}},[_vm._v("\n    Merawat printer\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e30928"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"checking-supplies-status-topic.html#checking-supplies-status_ba","title":"Memeriksa status bahan pakai dan suku cadang"}},[_vm._v("\n     Memeriksa status bahan pakai dan suku cadang\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-supply-notifications-topic.html#configuring-supply-notifications_ba","title":"Mengatur notifikasi bahan pakai"}},[_vm._v("\n     Mengatur notifikasi bahan pakai\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-email-alert-topic.html#setting-up-email-alert_ba","title":"Menyiapkan peringatan email"}},[_vm._v("\n     Menyiapkan peringatan email\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"generating-reports-and-logs-topic.html#generating-reports-and-logs_ba","title":"Membuat laporan dan log"}},[_vm._v("\n     Membuat laporan dan log\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"ordering-parts-and-supplies-group.html#ordering-parts-and-supplies-group_ba","title":"Memesan bahan pakai dan suku cadang"}},[_vm._v("\n     Memesan bahan pakai dan suku cadang\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"replacing-toner-cartridge-topic.html#d0e31783","title":"Mengganti bahan pakai dan suku cadang"}},[_vm._v("\n     Mengganti bahan pakai dan suku cadang\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"cleaning-printer-topic.html#d0e32407","title":"Membersihkan bagian printer"}},[_vm._v("\n     Membersihkan bagian printer\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-power-save-mode-settings-topic.html#d0e32571","title":"Menghemat energi dan kertas"}},[_vm._v("\n     Menghemat energi dan kertas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"moving-printer-topic.html#moving-printer_ba","title":"Memindah printer ke lokasi lain"}},[_vm._v("\n     Memindah printer ke lokasi lain\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"troubleshooting-chapter.html#troubleshooting-chapter_ba","title":"Menyelesaikan masalah"}},[_vm._v("\n    Menyelesaikan masalah\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e32709"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"print-quality-problems-topic.html#print-quality-problems_ba","title":"Masalah kualitas cetak"}},[_vm._v("\n     Masalah kualitas cetak\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printer-error-codes-topic.html#printer-error-codes_ba","title":"Kode eror printer"}},[_vm._v("\n     Kode eror printer\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"solving-printing-problems.html#solving-printing-problems_ba","title":"Masalah mencetak"}},[_vm._v("\n     Masalah mencetak\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-printer-not-responding-topic.html#trb-printer-not-responding_ba","title":"Printer tidak merespons"}},[_vm._v("\n     Printer tidak merespons\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_ba","title":"Tidak bisa membaca dari flash drive"}},[_vm._v("\n     Tidak bisa membaca dari flash drive\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"enabling-usb-port-topic.html#enabling-usb-port_ba","title":"Mengaktifkan port USB"}},[_vm._v("\n     Mengaktifkan port USB\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"clearing-jams.html#clearing-jams_ba","title":"Mengatasi kertas macet"}},[_vm._v("\n     Mengatasi kertas macet\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-cannot-open-embedded-web-server-topic.html#d0e36133","title":"Masalah koneksi jaringan"}},[_vm._v("\n     Masalah koneksi jaringan\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-cannot-detect-internal-option-topic.html#d0e36226","title":"Masalah opsi perangkat keras"}},[_vm._v("\n     Masalah opsi perangkat keras\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"message-replace-cartridge-printer-region-mismatch-topic.html#d0e36399","title":"Masalah dengan bahan pakai"}},[_vm._v("\n     Masalah dengan bahan pakai\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-paper-curl-topic.html#d0e36547","title":"Masalah pengumpanan kertas"}},[_vm._v("\n     Masalah pengumpanan kertas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"disabling-smtp-server-not-setup-error-topic.html#d0e36741","title":"Mengirim masalah via email"}},[_vm._v("\n     Mengirim masalah via email\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-caller-id-not-shown-topic.html#d0e36796","title":"masalah faks"}},[_vm._v("\n     masalah faks\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-cannot-scan-to-computer-topic.html#d0e37118","title":"Masalah memindai"}},[_vm._v("\n     Masalah memindai\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"modifying-colors-in-printed-output-topic.html#d0e37536","title":"Masalah kualitas warna"}},[_vm._v("\n     Masalah kualitas warna\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-contacting-customer-support-topic.html#trb-contacting-customer-support_ba","title":"Menghubungi dukungan pelanggan"}},[_vm._v("\n     Menghubungi dukungan pelanggan\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"recycle-dispose-chapter.html#recycle-dispose-chapter_ba","title":"Membuang dan mendaur ulang"}},[_vm._v("\n    Membuang dan mendaur ulang\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e37762"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"recycling-lexmark-products-topic.html#recycling-lexmark-products_ba","title":"Mendaur ulang produk Lexmark"}},[_vm._v("\n     Mendaur ulang produk Lexmark\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_ba","title":"Mendaur ulang kemasan Lexmark"}},[_vm._v("\n     Mendaur ulang kemasan Lexmark\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#laser_ug_notices_ba","title":"Pemberitahuan"}},[_vm._v("\n    Pemberitahuan\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e37798"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e37801","title":"Informasi produk"}},[_vm._v("\n     Informasi produk\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e37818","title":"Pemberitahuan edisi"}},[_vm._v("\n     Pemberitahuan edisi\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#trademarks_ba","title":"Merek Dagang"}},[_vm._v("\n     Merek Dagang\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#licensing-notices_ba","title":"Pemberitahuan tentang lisensi"}},[_vm._v("\n     Pemberitahuan tentang lisensi\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#noise-emission-levels_ba","title":"Tingkat emisi suara"}},[_vm._v("\n     Tingkat emisi suara\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e37916","title":"Environmental labeling for packaging"}},[_vm._v("\n     Environmental labeling for packaging\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#product-disposal_ba","title":"Pembuangan produk"}},[_vm._v("\n     Pembuangan produk\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#static-sensitivity-notice_ba","title":"Pemberitahuan sensitivitas statik"}},[_vm._v("\n     Pemberitahuan sensitivitas statik\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#energy-star_ba","title":"ENERGY STAR"}},[_vm._v("\n     ENERGY STAR\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#temperature-information_ba","title":"Informasi suhu"}},[_vm._v("\n     Informasi suhu\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#laser-notice_ba","title":"Pemberitahuan Laser"}},[_vm._v("\n     Pemberitahuan Laser\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#power-consumption_ba","title":"Konsumsi daya"}},[_vm._v("\n     Konsumsi daya\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e38159","title":"Pemberitahuan tentang peraturan untuk produk nirkabel"}},[_vm._v("\n     Pemberitahuan tentang peraturan untuk produk nirkabel\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#modular-component-notice_ba","title":"Pemberitahuan komponen modular"}},[_vm._v("\n     Pemberitahuan komponen modular\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#exposure-to-radio-frequency-radiation_ba","title":"Pemaparan terhadap radiasi frekuensi radio"}},[_vm._v("\n     Pemaparan terhadap radiasi frekuensi radio\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#radio-interference-notice_ba","title":"Pemberitahuan mengenai interferensi radio"}},[_vm._v("\n     Pemberitahuan mengenai interferensi radio\n    ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js